const translations = {
  en: {
    // General
    appName: 'Veyl',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    continue: 'Continue',
    done: 'Done',
    error: 'Error',
    submit: 'Submit',
    send: 'Send',
    delete: 'Delete',
    leave: 'Leave',
    stay: 'Stay',
    yes: 'Yes',
    no: 'No',
    upgrade: 'Upgrade to Premium',

    // Auth
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    resetPasswordSent: 'Password reset email sent. Check your inbox.',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    authError: 'Authentication error. Please try again.',

    // Landing
    landingHero: 'Accountability that actually works',
    landingSubtitle: 'Get matched with an anonymous partner who shares your goal. No social pressure. Just results.',
    getStarted: 'Get Started — It\'s Free',
    howItWorks: 'How It Works',
    step1Title: 'Set your goal',
    step1Desc: 'Tell us what you\'re working toward. We\'ll match you with someone on a similar journey.',
    step2Title: 'Meet your partner',
    step2Desc: 'Get paired with an anonymous accountability partner in your timezone.',
    step3Title: 'Stay accountable',
    step3Desc: 'Check in daily, share progress, and support each other — anonymously.',
    pricingTitle: 'Simple Pricing',
    freePlan: 'Free',
    premiumPlan: 'Premium',
    perMonth: '/month',
    freeFeature1: '1 active Veyl',
    freeFeature2: '10 messages/day',
    freeFeature3: '10 voice notes/day',
    freeFeature4: 'Daily & weekly check-ins',
    freeFeature5: 'Group chat access',
    premiumFeature1: 'Up to 3 active Veyls',
    premiumFeature2: 'Unlimited messages',
    premiumFeature3: 'Unlimited voice notes',
    premiumFeature4: 'Priority matching',
    faqTitle: 'Frequently Asked Questions',

    // Onboarding
    welcomeToVeyl: 'Welcome to Veyl',
    chooseLanguage: 'Choose your language',
    chooseLanguageDesc: 'Select the language you\'d like to use Veyl in.',
    ageVerification: 'Age Verification',
    ageVerificationDesc: 'Veyl is available to users aged 13 and above.',
    areYouOldEnough: 'Are you 13 years of age or older?',
    yesIAm: '✅ Yes, I am',
    noImNot: '❌ No, I\'m not',
    mustBe13: 'You must be 13 or older',
    mustBe13Desc: 'Veyl is only available to users aged 13 and above.',
    setupProfile: 'Let\'s set up your profile',
    stepOf: 'Step {step} of 4',
    whatsYourName: 'What\'s your name?',
    namePlaceholder: 'Enter your nickname',
    whatsYourTimezone: 'What\'s your timezone?',
    selectTimezone: 'Select timezone',
    goalCategory: 'What\'s your goal category?',
    matchPreference: 'Who do you want to match with?',
    matchNearby: 'Match Nearby',
    matchNearbyDesc: 'Match with people within 4 hours of your timezone.',
    matchAnywhere: 'Match Anywhere',
    matchAnywhereDesc: 'Match with anyone worldwide regardless of timezone.',
    describeGoal: 'Describe your specific goal',
    goalPlaceholder: 'E.g., \'I want to lose 30 pounds\' or \'Learn Python\'',
    communicationStyle: 'Preferred communication style',
    textMessages: 'Text Messages',
    textMessagesDesc: 'Chat when convenient',
    scheduledCheckins: 'Scheduled Check-ins',
    scheduledCheckinsDesc: 'Weekly deep-dives',
    completingSetup: 'Finding match...',
    completeSetup: 'Complete Setup',
    agreeToTerms: 'By continuing, you agree to Veyl\'s',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',

    // Categories
    fitnessHealth: 'Fitness & Health',
    learningSkills: 'Learning & Skills',
    businessCareer: 'Business & Career',
    creativeProjects: 'Creative Projects',

    // Waiting page
    findingMatch: 'Finding your match...',
    findingNewMatch: 'Finding your new match...',
    lookingForSomeone: 'We\'re looking for someone in the',
    category: 'category',
    sharesTimezone: 'who shares your timezone and commitment.',
    autoCheck: 'We check for matches automatically every 5 seconds.',
    noMatchYet: 'No match found yet — we\'ll keep trying automatically.',
    checkNow: 'Check for Match Now',
    checking: 'Checking...',
    manualChecks: '{count} manual check{plural} done',
    joinCommunity: '🌐 Join Community While You Wait',
    goToCommunity: '🌐 Go to Community',
    previousPartnerNote: '🛡️ Your previous partner won\'t be suggested again.',
    joining: 'Joining...',

    // Dashboard tabs
    overview: 'Overview',
    chat: 'Chat',
    checkin: 'Check-In',
    group: 'Group',
    community: 'Community',
    notifications: 'Notifications',
    settings: 'Settings',

    // Overview
    yourGoal: 'Your Goal',
    yourPartner: 'Your Partner',
    you: 'You',
    unveiled: '✨ Unveiled',
    goalComplete: '✓ Goal Complete',
    adjustGoal: 'Adjust My Goal',
    unveilButton: '✨ Unveil — You Did It!',
    goalCategory2: 'Category',
    goalDescription: 'Description',
    timezone: 'Timezone',
    loadingPartner: 'Loading partner info...',
    adjustYourGoal: 'Adjust Your Goal',
    adjustGoalDesc: 'It\'s okay to change direction. Your partner will be notified.',
    newGoalDescription: 'New Goal Description',
    newGoalPlaceholder: 'What\'s your new or adjusted goal?',
    updating: 'Updating...',
    updateGoal: 'Update Goal',
    goalUpdated: 'Goal updated successfully! Your partner has been notified.',
    readyToUnveil: 'Ready to Unveil?',
    unveilDesc: 'Unveiling marks this Veyl as complete. Your partner will be notified. This cannot be undone.',
    yourNewAvatar: 'Your new avatar',
    notYet: 'Not Yet',
    unveiling: 'Unveiling...',

    // Chat
    waitingForMatch: 'Waiting for a match to start chatting.',
    noMessagesYet: 'No messages yet. Say hello to your partner!',
    typeMessage: 'Type your message...',
    dailyLimitReached: 'Daily limit reached — Upgrade to Premium',
    messagesLeft: '{count} messages · {voiceCount} voice notes left today',
    premiumUnlimited: '✨ Premium — Unlimited messages & voice notes',
    unmatch: '🔓 Unmatch',
    report: '🚩 Report',
    unmatchWarning: '⚠️ Unmatching will delete your entire chat history and return both of you to matching. This cannot be undone.',
    yesUnmatch: 'Yes, Unmatch',
    unmatching: 'Unmatching...',
    messagesLeftWarning: '{count} messages left today.',
    forUnlimited: 'for unlimited messaging.',
    sending: 'Sending...',
    deleteMessage: '🗑 Delete',
    deleting: 'Deleting...',

    // Voice notes
    recording: 'Recording...',
    deeper: 'Deeper',
    neutral: 'Neutral',
    higher: 'Higher',
    applyingModulation: '⚙️ Applying modulation...',
    preview: '▶ Preview',
    pause: '⏸ Pause',
    discard: 'Discard',
    voiceNotesLeft: '{count} voice note{plural} left today',
    dailyLimitReachedVoice: 'Daily voice note limit reached.',
    recordingTooLarge: 'Recording too large. Please try a shorter message.',
    failedToSend: 'Failed to send. Please try again.',
    micDenied: 'Microphone access denied.',

    // Check-in
    checkIn: 'Check-In',
    checkInDesc: 'Daily check-ins track progress. Weekly check-ins are deeper reflections.',
    dailyCheckin: 'Daily Check-in',
    weeklyCheckin: 'Weekly Check-in',
    dailyCheckinDesc: 'Quick update: Did you work on your goal today?',
    weeklyCheckinDesc: 'Deep reflection: How did this week go overall?',
    submitDaily: 'Submit Daily Check-in',
    submitWeekly: 'Submit Weekly Check-in',
    submitting: 'Submitting...',
    checkinSubmitted: 'Check-in Submitted!',
    checkinSubmittedDesc: 'Great job staying accountable. {name} will see your update.',
    viewHistory: 'View My History',
    newCheckin: '📝 New Check-in',
    myHistory: '📋 My History',
    partnersProgress: '👤 {name}\'s Progress',
    myCheckinHistory: 'My Check-in History',
    checkinsForVeyl: '{count} check-in{plural} for this Veyl',
    noCheckinsYet: 'No check-ins yet. Start your first one!',
    newCheckinBtn: 'New Check-in',
    partnerNoCheckins: '{name} hasn\'t checked in yet.',
    dailyNotesPrivate: 'Daily notes are private',
    goalAchievedMarked: '🎉 Goal marked as achieved',
    goalAchievedNote: '🎉 Your goal is marked as achieved! Head to Overview to unveil.',
    veylComplete: '✓ This Veyl is complete. Check-ins are read-only.',
    goalAlreadyAchieved: '🎉 You\'ve marked your goal as achieved! Head to Overview to unveil.',
    didYouWork: 'Did you work on your goal today?',
    howDidWeekGo: 'How did this week go with your goal?',
    whatGotInWay: 'What got in the way? (Optional)',
    honestNote: 'Be honest. Your partner is here to support you, not judge you.',
    whatDidYouLearn: 'What did you learn about yourself this week?',
    insightsPlaceholder: 'What insights did you gain?',
    whatPatterns: 'What pattern are you noticing?',
    patternsPlaceholder: 'Any recurring themes or obstacles?',
    whatChange: 'What needs to change for next week?',
    changePlaceholder: 'What will you do differently?',
    goalAchievedQuestion: '🏆 Have you achieved your overall goal?',
    yesDidIt: '🎉 Yes, I did it!',
    notYetBtn: 'Not yet',
    didIt: '✅ Did it',
    didSome: '😐 Did some',
    didntDoIt: "❌ Didn't do it",
    metCommitment: '✅ Met commitment',
    partialProgress: '😐 Partial progress',
    noProgress: '❌ No progress',
    rethinkingGoal: '🤔 Rethinking goal',
    yesLabel: '✅ Yes',
    aLittle: '😐 A little',
    noLabel: '❌ No',
    madeProgress: 'Made progress today',
    didSomething: 'Did something, not everything',
    didntWork: "Didn't work on it today",
    metWeekly: 'Met my weekly commitment',
    madePartial: 'Made partial progress',
    didntMake: "Didn't make progress",
    needToAdjust: 'Need to adjust my approach',
    learnedLabel: 'Learned: ',
    patternLabel: 'Pattern: ',
    nextWeekLabel: 'Next week: ',

    // Group
    joinGroup: 'Join a Group',
    joinGroupDesc: 'Groups bring together up to 5 people working on similar goals. Anonymous, supportive, no pressure.',
    whatToExpect: 'WHAT TO EXPECT',
    expectAnonymous: 'Everyone stays anonymous — same silhouette avatars',
    expectMatched: 'Matched by goal category for relevant support',
    expectMembers: 'Up to 5 members per group',
    expectChat: 'Group chat — 20 messages & 5 voice notes/day free · Unlimited on Premium',
    findOrCreate: 'Find or Create a Group',
    findingGroup: 'Finding your group...',
    oneGroupNote: 'You can only be in one group at a time. Free and Premium users both get group access.',
    groupCreated: 'Group Created!',
    groupJoined: 'Group Joined!',
    groupCreatedDesc: 'You\'ve started a new {category} group. Others will join soon.',
    groupJoinedDesc: 'You\'ve joined an existing {category} group. Say hello!',
    switchToGroup: 'Switch to the Group tab in your dashboard to start chatting.',
    groupMembers: 'Group Members',
    backToChat: '← Back to chat',
    creator: '★ Creator',
    joined: 'Joined',
    leaveGroup: 'Leave Group',
    leaveGroupTitle: 'Leave this group?',
    leaveGroupDesc: 'You\'ll lose access to the group chat and can join a new group anytime.',
    membersBtn: '👥 Members',
    noGroupMessages: 'No messages yet. Be the first to say hello!',
    messageGroup: 'Message your group...',

    // Community
    veylCommunity: 'Veyl Community',
    communityDesc: 'Join others working toward the same goal category while you wait for a match.',
    communityJoinNote: 'Join the community from the Waiting page while seeking a match.',
    leaveCommunity: 'Leave this community?',
    communityLeaveDesc: 'You can rejoin anytime from the waiting page.',
    matchRequests: 'Match Requests',
    incoming: 'Incoming',
    sent: 'Sent',
    noIncoming: 'No incoming requests.',
    noPending: 'No pending requests sent.',
    requestToAnonymous: 'Request to anonymous user',
    pending: 'Pending',
    decline: 'Decline',
    accept: '✅ Accept',
    requestWaiting: '🤝 {count} match request{plural} waiting for you',
    view: 'View',
    requestsBtn: '🤝 Requests',
    leaveBtn: 'Leave',
    openToAll: 'Open to all · Anonymous',
    msgsLeft: '{count} msgs left',
    noCommunityMessages: 'No messages yet. Say hello to the community!',
    saySomething: 'Say something to the community...',
    requestMatch: '🤝 Request Match',
    requestSending: 'Sending...',
    communityMsgsWarning: '{count} community messages left today.',
    matchRequestLimit: 'You can only have 3 pending match requests at a time.',
    matchRequestSent: 'Match request sent successfully!',
    matchRequestDuplicate: "You've already sent a request to this person.",
    matchRequestError: 'Error sending match request. Please try again.',
    matchAcceptError: 'Error accepting match request.',
    matchRequestSentAlready: "You've already sent a request to this person.",
    communityDailyLimit: 'Daily limit reached — Upgrade to Premium',
    groupVoiceLimit: 'Daily voice note limit reached.',
    groupDailyLimit: 'You have reached your daily group message limit ({limit}/day). Upgrade to Premium for unlimited messaging!',

    // Notifications
    notificationsTitle: 'Notifications',
    notificationsCount: '{total} total · {unread} unread',
    clearAll: 'Clear All',
    clearing: 'Clearing...',
    noNotifications: 'No notifications yet.',
    notifMatchFound: 'Match Found',
    notifGoalAchieved: 'Goal Achieved',
    notifSupport: 'Support Messages',
    notifUnmatched: 'Unmatch Alerts',
    notifMatchRequest: 'Match Requests',
    notificationPrefs: 'Notification Preferences',
    notificationPrefsDesc: 'Mute specific notification types individually.',
    muted: 'Muted',
    active: 'Active',
    dismiss: '✕',

    // Settings
    settingsTitle: 'Settings',
    settingsDesc: 'Personalise your anonymous identity.',
    chooseAvatar: 'Choose your avatar',
    saveAvatar: 'Save Avatar',
    saving: 'Saving...',
    saved: '✓ Saved!',
    appearance: 'Appearance',
    appearanceDesc: 'Choose how Veyl looks for you.',
    lightMode: '☀️ Light',
    lightModeDesc: 'Clean and bright',
    darkMode: '🌙 Dark',
    darkModeDesc: 'Easy on the eyes',
    active2: '✓ Active',
    changeNickname: 'Change Nickname',
    currentNickname: 'Your current nickname is',
    anonymousWarning: 'Keep it anonymous. Don\'t use your real name.',
    newNickname: 'New Nickname',
    nicknamePlaceholder: 'e.g. NightOwl, StriveMode, Kira...',
    saveNickname: 'Save Nickname',
    nicknameUpdated: '✓ Nickname Updated!',
    goalsAchieved: 'Goals Achieved',
    goalsAchievedDesc: 'Private — only visible to you.',
    goalCompleted: 'goal completed',
    goalsCompleted: 'goals completed',
    contactSupport: 'Contact Support',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'Permanently deletes your account and all associated data. This cannot be undone.',
    deleteMyAccount: 'Delete My Account',
    deleteWarning: '⚠️ This will permanently delete everything. Type DELETE below to confirm.',
    typeDelete: 'Type DELETE to confirm',
    confirmDelete: 'Confirm Delete',
    deleting2: 'Deleting...',
    unveiledLocked: '✨ Unveiled — avatar locked',
    howOthersSee: 'This is how others see you',
    unveiledNote: 'You\'ve unveiled on this Veyl. Start a new Veyl to choose a fresh avatar.',
    languageLabel: 'Language',
    languageDesc: 'Choose your preferred language.',

    // Veyl Switcher
    activeLabel: 'Active',
    seekingLabel: 'Seeking',
    completeLabel: 'Complete',
    upgradeForMore: '✨ Upgrade for more Veyls',
    newVeyl: '+ New Veyl',
    newVeylTitle: 'Start a New Veyl',
    goalCategoryLabel: 'Goal Category',
    goalDescriptionLabel: 'Goal Description',
    startVeyl: 'Start New Veyl',
    starting: 'Starting...',
    updating: 'Updating...',
    unveil: 'Unveil',
    clearing: 'Clearing...',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Teal',
    avatar_purple: 'Purple',
    avatar_navy: 'Navy Blue',
    avatar_slate: 'Slate',
    avatar_coral: 'Coral',
    avatar_gold: 'Gold',
    avatar_moss: 'Moss',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'Unveiled',
    nicknameRequired: 'Nickname is required',
    nicknameTooShort: 'Nickname must be at least 2 characters',
    nicknameTooLong: 'Nickname must be at most 20 characters',
    errorSavingNickname: 'Error saving nickname',
    errorSavingAvatar: 'Error saving avatar',
    errorDeletingAccount: 'Error deleting account',
    deleteMyAccountButton: 'Delete My Account',
    goalsAchievedTitle: 'Goals Achieved',
    goalsPrivate: 'Private — only visible to you.',
    goalsCompletedCount: '{count} goals completed',
    keepAnonymous: 'Keep it anonymous. Don\'t use your real name.',
    currentNicknameIs: 'Your current nickname is',
    justNow: 'Just now',
    minsAgo: '{count}m ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago',
    all: 'All',
    leaving: 'Leaving...',
    matchRequestSentAlready: "You've already sent a request to this person.",
    problemTitle: 'Social Media Ruined Accountability',
    problem1: "You're afraid to admit when you're struggling",
    problem2: "You hide failures instead of learning from them",
    problem3: "You ghost your accountability partners when you mess up",
    veylIsDifferent: 'Veyl is different.',
    popular: 'POPULAR',
    sixMonthDeal: 'or $20 for 6 months ($3.33/mo)',
    getStartedPremium: 'Get Started',
    buildTrust: 'Build Trust',
    unveilIdentity: 'Reveal your identity when (or if) you\'re ready',
    actuallyAchieve: 'Actually Achieve It',
    makeRealProgress: 'Make real progress without the performance',
    faq1q: 'What if my partner and I don\'t click?',
    faq1a: 'Easy rematch. No questions asked. We\'d rather you find the right person than force a partnership that isn\'t working.',
    faq2q: 'Do I have to unveil at some point?',
    faq2a: 'No. Some partnerships stay anonymous indefinitely. Some unveil after a week. It\'s entirely up to you.',
    faq3q: 'What if my partner ghosts me?',
    faq3a: 'Premium users get an instant rematch. Free users are rematched within 48 hours. We also flag chronic ghosters in our system.',
    faq4q: 'Why never profile pictures?',
    faq4a: 'Because the moment you add photos, it becomes about managing perception. We tested it. Anonymity keeps the focus on the work.',
    legalEnglishOnly: 'This document is only available in English. For questions, please contact support or use your browser\'s translation feature.',
    ctaTitle: "Ready to actually achieve your goals?",
    ctaSubtitle: "Join Veyl and get matched with an accountability partner today. It's free to start.",
    statAnonymous: "Anonymous",
    statLanguages: "Languages",
    statToStart: "To start",
    authTagline: "Anonymous accountability. Real results.",
    authPricing: "Free to start · Premium from $5/month",
    taglineHonest: "Honest",
    taglineEffective: "Effective",
    foreverLabel: "/forever",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Upgrade to Premium",
    premiumActiveDesc: "You have unlimited access to all Veyl features.",
    upgradeDesc: "Remove all limits and get the full Veyl experience.",
    billedMonthly: "Billed monthly",
    bestValue: "BEST VALUE",
    perSixMonths: "$3.33/month",
    unlimitedMessages: "Unlimited messages",
    unlimitedVoice: "Unlimited voice notes",
    unlimitedGroup: "Unlimited group chat",
    unlimitedCommunity: "Unlimited community",
    was10day: "was 10/day",
    was5day: "was 5/day",
    was20day: "was 20/day",
    was30day: "was 30/day",
    sixMonthPlan: "6-Month Plan",
    monthlyPlan: "Monthly Plan",
    modulationFailed: "Modulation failed — using original voice",
    monthly: "Monthly",
    sixMonths: "6 Months",
    savePercent: "Save {{percent}}%",
    pricePerMonth: "${{price}} / month",
    priceTotal: "${{price}} total",
    unlimitedMessages: "Unlimited messages",
    unlimitedVoiceNotes: "Unlimited voice notes",
    unlimitedGroupMessages: "Unlimited group messages",
    unlimitedCommunityMessages: "Unlimited community messages",
    upgrade: "Upgrade",
    forUnlimited: "for unlimited",
    messagesLeftWarning: "{{count}} messages left today",
    recordVoiceNote: "Record a voice note",
    uploading: "Uploading",
    maxDuration: "{{seconds}}s max",
    upgradeToPremium: "Upgrade to Premium",
    dailyMessageLimitReached: "You've reached your daily message limit.",
    dailyVoiceLimitReached: "You've reached your daily voice note limit.",
    dailyGroupMessageLimitReached: "You've reached your daily group message limit.",
    dailyGroupVoiceLimitReached: "You've reached your daily group voice note limit.",
    unlockUnlimited: "Unlock unlimited access to all features.",
    maybeLater: "Maybe later",
    premiumUnlimited: "Premium — Unlimited",
    premium: "Premium",
    msg: "msg",
    msgs: "msgs",
    newMessageNotification: "{{name}} sent you a message 💬",
    newGroupMessageNotification: "{{name}} sent a message in your group 👥",
    someone: "Someone",
    failedToLoad: "Failed to load",
    groupMessagesLeftWarning: "{{count}} messages left today",
    howOldAreYou: 'How old are you?',
    minorGroupNote: "You'll be matched and grouped with other users your age (13–17).",
    adultGroupNote: "You'll be matched and grouped with other adults (18+).",
    enterYourAge: 'Enter your age',
    // nav / hero
    getStarted:        'Get started',
    howItWorks:        'How it works',
    statAnonymous:     'Anonymous',
    statLanguages:     'Languages',
    statToStart:       'To start',
    taglineHonest:     'Honest',
    taglineEffective:  'Effective',
    landingHero:       'Accountability without the performance.',
    landingSubtitle:   'Find an anonymous partner who shares your goals. No followers. No feed. No pressure — just honest progress.',
    // problem
    problemTitle:      'Accountability is broken.',
    problem1:          'Social media turns self-improvement into performance. You post your goals for likes, not progress.',
    problem2:          'Friends and family come with judgment, expectations, or indifference. Real honesty becomes impossible.',
    problem3:          'Accountability apps feel like tracking tools — sterile dashboards that ignore the human element entirely.',
    veylIsDifferent:   'Veyl is different.',
    // how it works
    step1Title:        'Create your profile',
    step1Desc:         'Pick a pseudonym, choose your goal category, and set your communication preference. Your real identity stays completely yours.',
    step2Title:        'Get matched',
    step2Desc:         'Veyl finds you a partner who shares your goal type and age group. Matching is instant — no scrolling, no swiping.',
    step3Title:        'Start talking',
    step3Desc:         'Chat or send voice notes. Check in daily or weekly. Your partner holds you accountable — and you hold them too.',
    buildTrust:        'Build trust',
    unveilIdentity:    'Log your wins, mark goals achieved. When the trust is there, you can choose to unveil your identity — or not.',
    actuallyAchieve:   'Actually achieve',
    makeRealProgress:  'Real progress with a real human. No gamification. No streaks for streaks\' sake. Just you, your partner, and your goal.',
    // pricing
    pricingTitle:      'Start free. Go deeper when you\'re ready.',
    freePlan:          'Free',
    foreverLabel:      '/ forever',
    freeFeature1:      '1 accountability partner',
    freeFeature2:      '10 messages per day',
    freeFeature3:      '10 voice notes per day',
    freeFeature5:      'Group & community rooms',
    popular:           'Most popular',
    premiumPlan:       'Premium',
    perMonth:          '/ month',
    sixMonthDeal:      '6-month plan at $20 — save 33%',
    premiumFeature1:   'Unlimited messaging',
    premiumFeature2:   'Unlimited voice notes',
    premiumFeature3:   'Partner unveil feature',
    premiumFeature4:   'Priority matching',
    getStartedPremium: 'Get started premium',
    // faq
    faqTitle: 'Common questions.',
    faq1q: 'Is Veyl really anonymous?',
    faq1a: 'Yes. You sign up with a pseudonym — a nickname you choose. No real name, no profile photo, nothing identifying. Your partner only ever knows what you choose to share.',
    faq2q: 'How does matching work?',
    faq2a: 'Veyl matches you with someone in the same goal category and age group. If you prefer a similar timezone, that\'s an option too. Usually takes under two minutes.',
    faq3q: 'What if I don\'t get along with my partner?',
    faq3a: 'You can report or block your partner at any time with no questions asked. Rematch and find someone better — it\'s built into the flow.',
    faq4q: 'Is it safe for minors?',
    faq4a: 'Absolutely. Users aged 13–17 are only ever matched with other users in the same age group. Adults are never in the same match pool as minors — enforced at the system level.',
    // cta
    ctaTitle:    'Your partner is already waiting.',
    ctaSubtitle: 'Join Veyl for free. No social profile required. No performance necessary. Just you, your goal, and someone who gets it.',
    // footer
    privacyPolicy:  'Privacy Policy',
    termsOfService: 'Terms of Service',
    refundPolicy:   'Refund Policy',
    featuresTitle: "Everything you need. Nothing you don't.",
    feature1Title: "Full anonymity",
    feature1Desc: "You choose a pseudonym. Real name, photo, identity — never shared unless you decide to reveal them.",
    feature2Title: "Voice notes",
    feature2Desc: "Sometimes typing isn't enough. Record and send voice notes directly in-app.",
    feature3Title: "Age-safe matching",
    feature3Desc: "Minors (13–17) only match with minors. Adults with adults. No exceptions — it's in the system.",
    feature4Title: "13 languages",
    feature4Desc: "English, Swahili, French, Spanish, Portuguese, German, Italian, Hindi, Indonesian, Chinese, Japanese, Korean, Hausa.",
    feature5Title: "Daily check-ins",
    feature5Desc: "Structured check-ins keep momentum going. Log progress and celebrate wins with your partner.",
    feature6Title: "Groups & community",
    feature6Desc: "Join goal-specific group chats and language-based community rooms.",
    goalsEyebrow: "For real goals",
    goalsTitle: "Whatever you're working on.",
    goalsSub: "Veyl is for anyone with a real goal and no one to be real with about it.",
    goalFitness: "Fitness & Health",
    goalLearning: "Learning & Skills",
    goalBusiness: "Business & Career",
    goalCreative: "Creative Projects",
    moreComingSoon: "More coming soon",
    safeTitle: "Safety isn't a feature. It's the foundation.",
    safe1Title: "Age separation",
    safe1Desc: "Minors and adults are never mixed. Age verified at signup and locked in.",
    safe2Title: "Report & block",
    safe2Desc: "Any user can report or block instantly. No questions asked.",
    safe3Title: "No data selling",
    safe3Desc: "Your goals, messages, and identity are yours. Full stop.",
    safe4Title: "Pseudonyms only",
    safe4Desc: "Real names never required. You control if and when you reveal yourself.",
    refundPolicy: "Refund Policy",
    heroLine1: 'Accountability',            
    heroLine2: 'without the performance',
    mustBe18: 'You must be 18 or older to use Veyl',
    mustBe18Desc: "Veyl is an 18+ platform. We're sorry, but you don't meet the minimum age requirement to create an account.",
    ageAttestationLabel: 'I confirm that I am 18 years of age or older.',
    ageMisrepresentationNote: 'Misrepresenting your age violates our Terms of Service and may result in account termination.',
    feature3Title: 'Verified 18+ only',
    feature3Desc: 'Every member confirms they are 18 or older before joining. No minors, no exceptions.',
    faq4q: 'Is Veyl available to minors?',
    faq4a: 'No. Veyl is an 18+ only platform. Every user confirms their age during sign-up, and accounts found to misrepresent their age are subject to removal.',
    safe1Title: 'Adults only',
    safe1Desc: 'Veyl is built exclusively for people 18 and older. Anyone under 18 attempting to use Veyl is misrepresenting their age, which violates our Terms of Service.',
    ageVerificationDesc: 'Veyl is available to users aged 18 and above.',
    // Rasa
    rasaIntroTitle: 'Meet Rasa',
    rasaIntroDesc: "Rasa is a private space to reflect — just for you, separate from your accountability partner. It doesn't come in with assumptions about you or the world; it learns only from what you choose to share, and it's built to ask questions rather than hand you answers.",
    rasaIntroNotTherapist: "Rasa isn't a therapist and isn't a replacement for real human connection — including your accountability partner. If something feels heavy, it'll gently point you toward support, not try to be it.",
    rasaIntroStart: 'Begin',
    rasaMessagesLeft: 'reflections left today',
    rasaNoMessagesYet: "Whenever you're ready to reflect, start typing below.",
    rasaThinking: 'Rasa is reflecting…',
    rasaPrivateNote: 'Private to you — never visible to your accountability partner.',
    rasaPlaceholder: "Share what's on your mind…",
    rasaDailyLimitReached: "You've reached today's Rasa limit. It resets tomorrow.",
    feature7Title: 'Meet Rasa',
    feature7Desc: 'A private space to reflect — just for you, separate from your accountability partner.',
    feature8Title: 'Get support anytime',
    feature8Desc: 'Quick answers on navigation, billing, and account questions — right in the app.',
    supportChatAriaLabel: 'Veyl support chat',
    supportChatTitle: 'Veyl Support',
    supportChatEmptyState: 'Ask me anything about how Veyl works.',
    supportChatPlaceholder: 'Ask a question…',
    supportChatSend: 'Send',
    supportChatTyping: 'Typing…',
    supportChatLimitReached: "You've reached today's support chat limit. Email support@veyl.space if it's urgent.",
    supportChatGenericError: 'Something went wrong. Please try again.',
    rasaLoadError: "Couldn't load your conversation.",
    rasaLoadErrorDetail: 'check the browser console for details, or try refreshing.',
    send: 'Send',
    error: 'Error',
    premiumUnlimited: 'Unlimited',
    notifMatchFoundMessage: '🎉 You\'ve been matched with {name}! Head to your dashboard.',
    someone: 'someone',
    progressOf: 'Progress of {name}',
    installAppLabel: 'Install App',
    installMobileOnly: 'Mobile only',
    installTooltip: 'Available on mobile devices only',
    installModalTitle: 'Install Veyl on your phone',
    installStep1: 'Tap the Share icon in Safari\u2019s toolbar',
    installStep2: 'Scroll down and tap "Add to Home Screen"',
    installStep3: 'Tap "Add" in the top right corner',
    installGotIt: 'Got it',
    relationshipsConnection: 'Relationships & Connection',
    homeLifeOrganization: 'Home & Life Organization',
    moneyFinancialHabits: 'Money & Financial Habits',
    stayingConnected: 'Staying Connected',
    independentLiving: 'Independent Living',
    techConfidence: 'Tech Confidence',
    goalRelationships:     'Relationships & Connection',
    goalHomeLife:           'Home & Life Organization',
    goalMoney:              'Money & Financial Habits',
    goalStayingConnected:   'Staying Connected',
    goalIndependentLiving:  'Independent Living',
    goalTechConfidence:     'Tech Confidence',
        // Resources tab
    resources: 'Resources',
    resourcesTitle: 'Resources',
    resourcesWriteUps: 'Write-ups',
    resourcesLinks: 'Further reading',
    resourcesOpensNewTab: 'Opens in a new tab',
    resourcesEmptyTitle: 'Nothing here yet',
    resourcesEmptyBody: "We're still putting together resources for this category. Check back soon.",
    resourcesNoMatchBody: "We couldn't find resources for this goal yet.",
    resourcesDisclaimer: 'General information only, not professional advice. If something affects your health, safety or money, a qualified professional can help with your situation.',
        // Resources tab: labels (replace "Write-ups" / "Further reading" wording)
    resourcesArticles: 'Articles',
    resourcesMoreToRead: 'More to read',

    // Resources tab: Fitness & Health content
    res_intro_fitnessHealth: 'Fitness and health goals tend to be won in small, ordinary moments, not big ones. These pieces are here to take some pressure off, and the links lead to sources that are good at the detail.',

    res_fitness_showing_up_title: 'Showing up beats showing off',
    res_fitness_showing_up_p1: 'Most of us carry a picture of what “proper” exercise looks like: the gym, the running shoes, the sweat. When life doesn’t fit that picture, it’s easy to decide the whole thing isn’t for you.',
    res_fitness_showing_up_p2: 'The World Health Organization takes a much wider view. It counts movement during leisure time, getting from place to place, and the activity in your work or around the home. Walking, cycling, sport and play all count, at any level of skill. Its guidelines make a point of saying that any amount of activity is better than none.',
    res_fitness_showing_up_p3: 'That matters when you’re building a habit with a partner. A short walk you actually did is worth more than the hard session you planned and skipped. The check-in that says “I only managed ten minutes” is still a check-in that kept the thread going.',
    res_fitness_showing_up_p4: 'It also helps to separate what you did from how it felt. Some days the habit is the whole win. Intensity can come later, once showing up has stopped being a negotiation.',
    res_fitness_showing_up_p5: 'If you have a health condition, are pregnant, or haven’t been active in a long time, it’s worth a quick conversation with a doctor or another qualified health professional before changing how hard you train.',

    res_fitness_rest_title: 'Rest is part of the plan',
    res_fitness_rest_p1: 'When people talk about fitness goals, sleep and rest usually get treated like the stuff left over once the real work is done. In practice they’re a big part of whether the work holds up.',
    res_fitness_rest_p2: 'Sleep and activity feed each other. The NHS notes that regular activity can help you sleep better, and that some people find exercising close to bedtime gets in the way, in which case earlier in the day may suit them. Neither is a rule. They’re a reminder that you’re the one who gets to find out what works for your body.',
    res_fitness_rest_p3: 'Rest is also worth planning for when you’re keeping each other accountable. If every check-in becomes a report on how much you pushed, a quiet day starts to feel like a failure. A day off that you chose on purpose is different from drifting away from the goal, and it’s fine to say so out loud.',
    res_fitness_rest_p4: 'If sleep is a real struggle over a long stretch, or you’re feeling worn down for reasons you can’t pin down, that’s worth raising with a doctor or another qualified health professional. It’s not something to push through alone.',

    res_fitness_food_title: 'Food without the fuss',
    res_fitness_food_p1: 'Food advice is loud and often contradictory, so it’s worth knowing that the big public health bodies are more relaxed than most of the internet.',
    res_fitness_food_p2: 'The WHO says healthy diets come in many forms. What counts as a sensible way of eating depends on your age, lifestyle, culture, and the foods you can actually get where you live. It describes four ideas that sit underneath any of them: getting enough of what your body needs, keeping things in balance, enjoying some foods in moderation, and eating a wide variety. A mostly unprocessed, varied diet is the foundation it points to.',
    res_fitness_food_p3: 'For a goal you’re pursuing with someone else, that’s a useful frame. You don’t need to copy your partner’s way of eating, and they don’t need to copy yours. A food goal can be as simple as “cook at home more often” or “eat something other than the usual thing this week”, whatever fits your life and budget.',
    res_fitness_food_p4: 'If you’re thinking about big changes to how you eat, or you have a condition, allergy or medication that food affects, a doctor or registered dietitian can give advice that fits you. A general write-up can’t.',

    res_fitness_who_physical_activity_note: 'Global. A plain overview of what counts as activity, who benefits and why.',
    res_fitness_who_guidelines_note: 'Global. The full guidelines, with recommendations for different ages and for people living with chronic conditions or disability.',
    res_fitness_who_healthy_diet_note: 'Global. Explains the principles behind a healthy diet and why it varies by culture and local food.',
    res_fitness_nhs_sleep_note: 'UK. Practical sleep advice. Its mentions of a GP or pharmacist refer to UK services.',
    
    // Push notifications
    pushPromptTitle: 'Get notified when Veyl is closed',
    pushPromptBody: "We'll let you know when you're matched or your partner messages you. Notifications never include message content.",
    pushEnable: 'Turn on notifications',
    pushNotNow: 'Not now',
    pushError: 'Something went wrong turning notifications on. Please try again.',
    pushBlockedTitle: 'Notifications are blocked',
    pushBlockedBody: "Your browser is blocking notifications from Veyl. To turn them on, open your browser's site settings for veyl.space, allow notifications, then reload the page.",
    pushIosTitle: 'Get notifications on iPhone',
    pushIosBody: 'Add Veyl to your Home Screen first: tap Share, then Add to Home Screen, then open Veyl from there and turn on notifications.',
    pushSettingsTitle: 'Notifications on this device',
    pushSettingsDesc: "Get an alert when you're matched or your partner messages you, even when Veyl is closed. Alerts never include message content. This setting applies to this device only.",
    pushSettingsUnsupported: "Notifications aren't available in this browser. On iPhone or iPad, add Veyl to your Home Screen first (Share, then Add to Home Screen), then open it from there.",
    pushSettingsBlocked: "Notifications are blocked for Veyl in your browser. To turn them on, open your browser's site settings for veyl.space, allow notifications, then reload the page.",
    pushSettingsWorking: 'Working…',
    pushSettingsOn: 'Notifications are on for this device',
    pushSettingsTurnOff: 'Turn off notifications',
    
    // Resources tab: Learning & Skills content
    res_intro_learningSkills: 'Learning something new mostly comes down to showing up often enough for it to stick. These pieces are about the long game, and the links are free places to learn almost anything.',

    res_learning_small_repeat_title: 'Small enough to repeat',
    res_learning_small_repeat_p1: 'Most learning goals die from being too big, not too hard. “Learn to code” or “become fluent in Portuguese” is a destination, not something you can do on a Tuesday evening.',
    res_learning_small_repeat_p2: 'What you can do on a Tuesday evening is sit down for twenty minutes with one lesson. That’s a task you can repeat, and repeating it is where the learning builds up. Skills tend to arrive quietly, a little at a time, until one day you notice you can do something you couldn’t before.',
    res_learning_small_repeat_p3: 'This is where an accountability partner helps more than motivation does. Motivation comes and goes. A partner who’s expecting to hear how it went makes it harder to quietly drop the habit and easier to restart after a bad week.',
    res_learning_small_repeat_p4: 'A good check-in doesn’t have to be impressive. “I did one lesson and understood about half” is honest, and it keeps the habit alive. You can raise the size of the task later. It’s much harder to rebuild a habit that has stopped.',

    res_learning_beginner_title: 'Being a beginner is allowed',
    res_learning_beginner_p1: 'Starting something new means being bad at it, at least in front of one person. For many adults that’s the real obstacle, more than time or money.',
    res_learning_beginner_p2: 'It may help to know how open learning has become. MIT OpenCourseWare publishes materials from thousands of MIT courses for free, with no registration. The Open University’s OpenLearn offers nearly a thousand short free courses, and says there are no requirements to access them. You don’t need anyone’s permission to try a subject, or to find out it isn’t for you.',
    res_learning_beginner_p3: 'Trying something and deciding it’s not for you counts as learning too. Sampling a few things before committing to one is a perfectly good way to start.',
    res_learning_beginner_p4: 'When you feel behind, remember that your partner may well feel the same about their own goal. You’re not competing. You’re both near the start of something, in different places.',

    res_learning_choose_one_title: 'Choose one thing, then keep choosing it',
    res_learning_choose_one_p1: 'Free learning has a strange problem: there’s too much of it. OpenCourseWare alone covers more than 2,500 courses, and OpenLearn has nearly a thousand. It’s easy to spend a whole evening browsing and call it learning.',
    res_learning_choose_one_p2: 'It helps to pick one course, one book or one series of lessons, and treat everything else as “for later”. Saving the others in a note is fine. The aim is to finish one thing before starting the next. Telling your partner which one you picked is a small commitment that makes it easier to stick with.',
    res_learning_choose_one_p3: 'It’s also worth checking what a resource does and doesn’t give you. OpenLearn courses, for example, come with a statement of participation, and some with a digital badge that isn’t an accredited qualification. If you need a formal qualification for work or study, it’s worth knowing that early, and the institution you’re aiming for can tell you what they accept.',

    res_learning_mit_ocw_note: 'Global. Free lecture notes, exams and videos from thousands of MIT courses, with no registration. In English.',
    res_learning_khan_academy_note: 'Global. A nonprofit offering free lessons and practice, strongest in maths and science, in many languages.',
    res_learning_openlearn_note: 'UK-based, open to anyone. Nearly 1,000 free short courses, from about 1 to 24 hours, each with a free statement of participation.',
    
    // Resources tab: Business & Career content
    res_intro_businessCareer: 'Work goals are long, and most of the effort happens in the days between milestones. These pieces are about keeping a steady pace, and the links are free places to build skills and plan your next step.',

    res_business_progress_title: 'Progress at work is rarely a straight line',
    res_business_progress_p1: 'Career and business goals have a way of stretching out. A promotion, a career change or a first customer can take months, and the days in between rarely feel like progress.',
    res_business_progress_p2: 'It helps to separate the outcome you want from the things you can actually do this week. You can’t control whether a company hires you, or whether a customer says yes. You can control how many conversations you have, how much time you give the project, and whether you follow up on the thing you said you would.',
    res_business_progress_p3: 'That’s where an accountability partner earns their place. They don’t need to understand your industry. They just need to ask what you did, and listen to the answer without making it a performance.',
    res_business_progress_p4: 'Some weeks the honest report is “not much happened”. It’s worth saying out loud, because a goal that goes quiet for a month is much harder to pick up again than one you kept lightly alive.',

    res_business_start_from_you_title: 'Start from you, not the job',
    res_business_start_from_you_p1: 'When people feel stuck at work, the instinct is often to start with the job market: what’s hiring, what pays well, what looks impressive. It can be more useful to start somewhere else.',
    res_business_start_from_you_p2: 'OpenLearn’s free course Succeed in the workplace is built on that idea. It begins with the view that getting to know yourself and what you value is the foundation of career planning, and only then moves on to CVs, applications and interviews.',
    res_business_start_from_you_p3: 'In plain terms: what do you want your days to feel like? What are you good at that you rarely get credit for? What would you refuse to trade away, whether that’s time with family, steady income or room to be creative?',
    res_business_start_from_you_p4: 'You don’t have to answer all of that alone. Talking it through with your partner often brings up things you’d skip over by yourself, and it can turn a vague “I want something different” into a goal you can actually work on.',

    res_business_wear_out_title: 'Working hard without wearing yourself out',
    res_business_wear_out_p1: 'Ambition and exhaustion can look alike from the inside, especially when a goal matters to you.',
    res_business_wear_out_p2: 'The World Health Organization notes that work can protect mental health, and that it can also contribute to harm. Its guidelines on mental health at work point to risks such as heavy workloads and negative behaviours at work, and they say the responsibility for a healthy workplace sits with employers and governments, not only with individual workers.',
    res_business_wear_out_p3: 'If you’re checking in with a partner about a big work goal, it’s worth asking not only “did you get it done?” but “how are you holding up?” A goal pursued at the cost of your sleep, health or relationships is worth rethinking, even if it’s going well on paper.',
    res_business_wear_out_p4: 'If work is affecting your health, or you’re feeling persistently low, anxious or worn out, please talk to a doctor or another qualified health professional. If you’re unsure of your rights at work, a trusted local source, such as a labour authority or a workers’ organisation, can explain them for where you live. Rules differ a lot between countries.',

    res_business_who_mh_work_note: 'Global. Written mainly for employers and governments, so it’s technical. The executive summary is available in Arabic, Chinese, English, French, Russian and Spanish.',
    res_business_openlearn_entrepreneurship_note: 'UK-based course. 24 hours across 8 sessions, and you can start without signing up. Some of it covers UK business rules, so check what applies in your country.',
    res_business_openlearn_succeed_note: 'About 8 weeks at around 3 hours a week, covering career planning, CVs and interviews. Last updated in 2021, so some parts on job searching and social media may feel dated.',
    timezoneTitle: "Timezone",
    timezoneCurrentIs: "Your current timezone is",
    timezoneLockNote: "Your daily message and voice-note limits reset at midnight in your timezone. To keep this fair, you can only change your timezone on a day when you haven't used any messages or voice notes, and only once every 7 days.",
    timezoneNew: "Choose timezone",
    saveTimezone: "Save timezone",
    timezoneUpdated: "Timezone updated",
    timezoneInvalid: "That timezone is not valid. Please pick one from the list.",
    timezoneChangeError: "Could not change your timezone. Please try again.",
    
    // Resources tab: Creative Projects content
    res_intro_creativeProjects: 'Creative projects tend to live in the gaps between everything else. These pieces are about keeping something alive through the long middle, and the links cover learning to write and using and sharing creative work.',

    res_creative_finishing_title: 'Finishing is a skill too',
    res_creative_finishing_p1: 'Starting a creative project is the easy part. The idea is fresh and everything feels possible. The hard part comes in the middle, when the idea has turned into actual work and the work is slower and messier than the idea was.',
    res_creative_finishing_p2: 'That’s usually where projects stall, and it’s rarely because the person lacks talent. It’s more often because the middle has no finish line to look forward to and nobody is watching.',
    res_creative_finishing_p3: 'This is where a partner who simply asks “what did you make this week?” can make a real difference. You don’t need them to judge it. Knowing that you’ll be describing your week gives the work a small deadline, and a small deadline is often enough to get you back to the desk, the canvas or the instrument.',
    res_creative_finishing_p4: 'It also helps to decide what “done” means for the thing in front of you. A finished rough version counts for more than a perfect one that stays in your head. You can always make it better after it exists.',

    res_creative_rough_drafts_title: 'Nobody needs to see the first version',
    res_creative_rough_drafts_p1: 'Many creative people quietly stop because the first attempt isn’t as good as the picture in their mind. That gap between what you imagine and what you can make right now is normal. It’s often biggest when you care the most.',
    res_creative_rough_drafts_p2: 'Showing rough work to one trusted person can take some of the weight off. Telling a partner “this is a messy draft, but here’s what I’m trying to do” turns it into a conversation, not a verdict. You may find they care more about whether you kept going than whether it’s good.',
    res_creative_rough_drafts_p3: 'If you’re a beginner in a craft, there are gentle ways in. OpenLearn, the Open University’s free learning site, has an introductory course on writing fiction aimed at people just starting out. It’s one example among many, and it suits writers more than other kinds of makers.',
    res_creative_rough_drafts_p4: 'Progress in creative work rarely looks like steady improvement. Some weeks you make something you’re proud of, and some weeks you make something you’ll never show anyone. Both count, and both are part of the same habit.',

    res_creative_using_sharing_title: 'Using other people’s work, and sharing your own',
    res_creative_using_sharing_p1: 'Creative projects often involve other people’s material, such as images, sounds or text, and eventually you may want to share your own. A little background helps with both.',
    res_creative_using_sharing_p2: 'Creative Commons is a nonprofit that publishes licences letting creators keep their copyright while allowing others to use their work in ways the creator chooses. If you want to share something you’ve made, its guidance explains how those licences work.',
    res_creative_using_sharing_p3: 'Some institutions go further. The Smithsonian has released millions of images and data under what’s called CC0, which means you can use them without asking the Smithsonian’s permission, including for creative projects. But its own FAQ points out that CC0 only covers copyright. Other rights, such as privacy or trademark, may still apply, and some items in its collections aren’t included at all.',
    res_creative_using_sharing_p4: 'Copyright rules differ between countries, and this is general information, not legal advice. If a project matters commercially, or you’re unsure whether you can use something, a qualified professional can tell you where you stand.',

    res_creative_openlearn_fiction_note: 'UK-based, free to start. An introductory course on writing fiction, with a free statement of participation. It suits writers more than other kinds of makers.',
    res_creative_cc_license_note: 'Global. How to let others use your work on terms you choose while keeping your copyright. General information, not legal advice.',
    res_creative_smithsonian_open_access_note: 'US institution, free for anyone to use. Explains the images and data released as CC0, what that does and doesn’t allow, and which items are excluded.',
    
    // Resources tab: Relationships & Connection content
    res_intro_relationshipsConnection: 'Relationships are built more from small, repeated things than from big moments. These pieces are about keeping connections alive, what research says matters most, and what to do when connection is hard or a relationship is unsafe.',

    res_relationships_small_gestures_title: 'Small gestures count',
    res_relationships_small_gestures_p1: 'Many of us treat friendships and family ties as things that either exist or don’t. Robert Waldinger, who directs the Harvard Study of Adult Development, describes social life as a living system that needs maintenance, much like physical fitness.',
    res_relationships_small_gestures_p2: 'The maintenance can be tiny. Think of someone you miss and send them a message. The World Health Organization’s list of everyday steps is just as modest: reaching out to a friend, putting your phone away to be properly present in a conversation, greeting a neighbour, joining a local group, or volunteering.',
    res_relationships_small_gestures_p3: 'For a goal you share with an accountability partner, this makes a good weekly question: who did you reach out to? It’s concrete, it’s small, and you can answer it honestly even in a hard week.',
    res_relationships_small_gestures_p4: 'Not every message gets a warm reply, and that’s part of it. Waldinger says people are often surprised by how warmly small messages like these are received.',

    res_relationships_quality_title: 'Quality over quantity',
    res_relationships_quality_p1: 'It’s easy to measure a social life by headcount: how many friends, how many events, whether you’re in a relationship. The research points somewhere else.',
    res_relationships_quality_p2: 'The Harvard Study of Adult Development has followed people since 1938. When its researchers looked back at participants’ lives in middle age, satisfaction in their relationships, particularly marriages, predicted who would be happy and healthy at 80 better than things like cholesterol or blood pressure did. Its director says other research groups have since found the same thing. He also says there’s no set number of connections you need, and that shy people may need fewer than extroverts.',
    res_relationships_quality_p3: 'One caution: the study’s first participants were Harvard students and young adults from one American city, so it isn’t a picture of everyone. It’s worth holding the conclusions loosely.',
    res_relationships_quality_p4: 'What it suggests, gently, is that at least one solid relationship, someone you could call if you were sick or scared, matters more than a big circle. And it’s rarely too late. The study’s director describes people who found close friendships or love late in life when they didn’t expect to.',

    res_relationships_hard_times_title: 'When connection is hard, and when a relationship hurts',
    res_relationships_hard_times_p1: 'Feeling lonely doesn’t mean something is wrong with you. The World Health Organization estimates that about one in six people worldwide experience loneliness, at every age. It describes loneliness as the painful feeling that comes when the connections you have don’t match the ones you want.',
    res_relationships_hard_times_p2: 'The causes can include poor health, low income, living alone, or the way we use technology. The WHO notes that if the problem is more serious, finding out what support and services exist is worth doing.',
    res_relationships_hard_times_p3: 'There’s another side: relationships that hurt. Harmful behaviour in a partnership includes psychological abuse and controlling behaviour, as well as physical or sexual harm.',
    res_relationships_hard_times_p4: 'If you’re afraid of someone close to you, or you’re being hurt, please contact your local emergency number or a local helpline or support service. The right numbers depend on your country, and a Veyl partner is a peer, not a trained counsellor. If things feel too heavy to carry, a doctor or counsellor can help.',

    res_relationships_who_social_connection_note: 'Global. A short, jargon-free summary of WHO’s 2025 report on loneliness and social connection (13 pages).',
    res_relationships_harvard_gazette_note: 'US source. A Q&A with the director of the Harvard Study of Adult Development on what the research says about relationships and health, including small everyday steps. It’s an interview, and the study’s early participants came from one American city.',
    res_relationships_who_violence_note: 'Global. Explains what intimate partner violence includes and how common it is, mostly affecting women. It’s information, not a helpline, and it can be hard to read.',
  },

  sw: {
    appName: 'Veyl',
    loading: 'Inapakia...',
    save: 'Hifadhi',
    cancel: 'Ghairi',
    back: 'Rudi',
    continue: 'Endelea',
    done: 'Imekamilika',
    error: 'Hitilafu',
    submit: 'Wasilisha',
    send: 'Tuma',
    delete: 'Futa',
    leave: 'Ondoka',
    stay: 'Kaa',
    yes: 'Ndiyo',
    no: 'Hapana',
    upgrade: 'Panda hadi Premium',
    signIn: 'Ingia',
    signUp: 'Jisajili',
    signOut: 'Toka',
    email: 'Barua pepe',
    password: 'Nenosiri',
    forgotPassword: 'Umesahau nenosiri?',
    resetPassword: 'Weka upya Nenosiri',
    resetPasswordSent: 'Barua pepe ya kuweka upya nenosiri imetumwa.',
    noAccount: 'Huna akaunti?',
    hasAccount: 'Una akaunti tayari?',
    authError: 'Hitilafu ya uthibitishaji. Tafadhali jaribu tena.',
    landingHero: 'Uwajibikaji unaofanya kazi',
    landingSubtitle: 'Pata mwenzako asiyejulikana anayeshiriki lengo lako. Bila shinikizo la kijamii. Tu matokeo.',
    getStarted: 'Anza — Bila Malipo',
    howItWorks: 'Jinsi Inavyofanya Kazi',
    step1Title: 'Weka lengo lako',
    step1Desc: 'Tuambie unachofanya kazi kuelekea. Tutakuoanisha na mtu katika safari inayofanana.',
    step2Title: 'Kutana na mwenzako',
    step2Desc: 'Pata mwenzako wa uwajibikaji asiyejulikana katika eneo lako la wakati.',
    step3Title: 'Kaa na uwajibikaji',
    step3Desc: 'Angalia kila siku, shiriki maendeleo, na kusaidiana — bila kujulikana.',
    buildTrust: 'Jenga uaminifu',
    unveilIdentity: "Funua utambulisho wako wakati (au ikiwa) uko tayari",
    actuallyAchieve: 'Fanikisha kweli',
    makeRealProgress: 'Pata maendeleo ya kweli bila maonyesho',
    pricingTitle: 'Bei Rahisi',
    freePlan: 'Bila Malipo',
    premiumPlan: 'Premium',
    perMonth: '/mwezi',
    freeFeature1: 'Veyl 1 inayotumika',
    freeFeature2: 'Ujumbe 10/siku',
    freeFeature3: 'Sauti 10/siku',
    freeFeature4: 'Ukaguzi wa kila siku na wiki',
    freeFeature5: 'Ufikiaji wa mazungumzo ya kikundi',
    premiumFeature1: 'Hadi Veyls 3 zinazotumika',
    premiumFeature2: 'Ujumbe usio na kikomo',
    premiumFeature3: 'Sauti zisizo na kikomo',
    premiumFeature4: 'Kuoanishwa kwa kipaumbele',
    faqTitle: 'Maswali Yanayoulizwa Mara kwa Mara',
    faq1q: "Vipi ikiwa mimi na mwenzangu hatuelewani?",
    faq1a: "Mechi mpya rahisi. Hakuna maswali. Tunapendelea upate anayefaa kuliko kulazimisha ushirikiano usiofanya kazi.",
    faq2q: "Je, ni lazima nifunue utambulisho wangu mwishowe?",
    faq2a: "La. Baadhi ya ushirikiano hubaki bila majina kwa muda usiojulikana. Wengine hufunua baada ya wiki. Inategemea nyinyi wawili.",
    faq3q: "Vipi ikiwa mwenzangu atanipuuza?",
    faq3a: "Watumiaji wa Premium wanapata mechi mpya papo hapo. Watumiaji wa bure wanapata mechi mpya ndani ya saa 48. Pia, tunawawekea alama wale wanaopuuza mara kwa mara katika mfumo wetu.",
    faq4q: "Kwa nini hakuna picha za wasifu kabisa?",
    faq4a: "Kwa sababu punde tu unapoongeza picha, inakuwa juu ya kudhibiti mtazamo. Tumejaribu hili. Kutokujulikana kunaweka umakini kwenye kazi.",
    welcomeToVeyl: 'Karibu Veyl',
    chooseLanguage: 'Chagua lugha yako',
    chooseLanguageDesc: 'Chagua lugha unayotaka kutumia Veyl.',
    ageVerification: 'Uthibitisho wa Umri',
    ageVerificationDesc: 'Veyl inapatikana kwa watumiaji wenye umri wa miaka 13 na zaidi.',
    areYouOldEnough: 'Je, una miaka 13 au zaidi?',
    yesIAm: '✅ Ndiyo, nina',
    noImNot: '❌ Hapana, sina',
    mustBe13: 'Lazima uwe na miaka 13 au zaidi',
    mustBe13Desc: 'Veyl inapatikana tu kwa watumiaji wenye umri wa miaka 13 na zaidi.',
    setupProfile: 'Hebu tuandae wasifu wako',
    stepOf: 'Hatua {step} kati ya 4',
    whatsYourName: 'Jina lako ni nani?',
    namePlaceholder: 'Weka jina lako la utani',
    whatsYourTimezone: 'Eneo lako la wakati ni lipi?',
    selectTimezone: 'Chagua eneo la wakati',
    goalCategory: 'Kategoria ya lengo lako ni ipi?',
    matchPreference: 'Unataka kuoanishwa na nani?',
    matchNearby: 'Oanisha Karibu',
    matchNearbyDesc: 'Oanishwa na watu ndani ya masaa 4 ya eneo lako la wakati.',
    matchAnywhere: 'Oanisha Popote',
    matchAnywhereDesc: 'Oanishwa na mtu yeyote duniani bila kujali eneo la wakati.',
    describeGoal: 'Elezea lengo lako maalum',
    goalPlaceholder: 'Mfano: \'Nataka kupoteza kilo 15\' au \'Jifunze Python\'',
    communicationStyle: 'Mtindo wako unaopendelewa wa mawasiliano',
    textMessages: 'Ujumbe wa Maandishi',
    textMessagesDesc: 'Zungumza wakati unaofaa',
    scheduledCheckins: 'Ukaguzi Uliopangwa',
    scheduledCheckinsDesc: 'Mazungumzo ya kina ya kila wiki',
    completingSetup: 'Inatafuta mwenzako...',
    completeSetup: 'Kamilisha Usanidi',
    agreeToTerms: 'Kwa kuendelea, unakubali',
    termsOfService: 'Masharti ya Huduma',
    and: 'na',
    privacyPolicy: 'Sera ya Faragha',
    fitnessHealth: 'Afya na Mazoezi',
    learningSkills: 'Kujifunza na Ustadi',
    businessCareer: 'Biashara na Kazi',
    creativeProjects: 'Miradi ya Ubunifu',
    findingMatch: 'Inatafuta mwenzako...',
    findingNewMatch: 'Inatafuta mwenzako mpya...',
    lookingForSomeone: 'Tunatafuta mtu katika',
    category: 'kategoria',
    sharesTimezone: 'anayeshiriki eneo lako la wakati na kujitolea.',
    autoCheck: 'Tunakagua mechi kiotomatiki kila sekunde 5.',
    noMatchYet: 'Hakuna mechi iliyopatikana bado — tutaendelea kujaribu.',
    checkNow: 'Kagua Mechi Sasa',
    checking: 'Inakagua...',
    manualChecks: 'Ukaguzi {count} wa mkono umefanywa',
    joinCommunity: '🌐 Jiunge na Jamii Ukisubiri',
    goToCommunity: '🌐 Nenda kwa Jamii',
    previousPartnerNote: '🛡️ Mwenzako wa awali hatapendekezwa tena.',
    joining: 'Inajiunga...',
    overview: 'Muhtasari',
    chat: 'Mazungumzo',
    checkin: 'Ukaguzi',
    group: 'Kikundi',
    community: 'Jamii',
    notifications: 'Arifa',
    settings: 'Mipangilio',
    yourGoal: 'Lengo Lako',
    yourPartner: 'Mwenzako',
    you: 'Wewe',
    unveiled: '✨ Imefunuliwa',
    goalComplete: '✓ Lengo Limekamilika',
    adjustGoal: 'Rekebisha Lengo Langu',
    unveilButton: '✨ Funua — Umefanikiwa!',
    goalCategory2: 'Kategoria',
    goalDescription: 'Maelezo',
    timezone: 'Eneo la Wakati',
    loadingPartner: 'Inapakia taarifa za mwenzako...',
    adjustYourGoal: 'Rekebisha Lengo Lako',
    adjustGoalDesc: 'Ni sawa kubadilisha mwelekeo. Mwenzako ataarifiwa.',
    newGoalDescription: 'Maelezo Mapya ya Lengo',
    newGoalPlaceholder: 'Lengo lako jipya au lililorekebishwa ni lipi?',
    updating: 'Inasasisha...',
    updateGoal: 'Sasisha Lengo',
    goalUpdated: 'Lengo limesasishwa! Mwenzako amearifiwa.',
    readyToUnveil: 'Uko Tayari Kufunua?',
    unveilDesc: 'Kufunua kunakamilisha Veyl hii. Mwenzako ataarifiwa. Hii haiwezi kutenduliwa.',
    yourNewAvatar: 'Picha yako mpya',
    notYet: 'Bado',
    unveiling: 'Inafunua...',
    waitingForMatch: 'Inasubiri mechi kuanza mazungumzo.',
    noMessagesYet: 'Hakuna ujumbe bado. Salimia mwenzako!',
    typeMessage: 'Andika ujumbe wako...',
    dailyLimitReached: 'Kikomo cha siku kimefikiwa — Panda hadi Premium',
    messagesLeft: 'Ujumbe {count} · Sauti {voiceCount} zimesalia leo',
    premiumUnlimited: '✨ Premium — Ujumbe na sauti bila kikomo',
    unmatch: '🔓 Tenganisha',
    report: '🚩 Ripoti',
    unmatchWarning: '⚠️ Kutenganisha kutafuta historia yako yote ya mazungumzo na kurudisha nyote wawili kwenye mechi. Hii haiwezi kutenduliwa.',
    yesUnmatch: 'Ndiyo, Tenganisha',
    unmatching: 'Inatenganisha...',
    unmatchMessage: 'Mwenzako amemaliza kipindi hiki cha Veyl. Umerudishwa kwenye mechi.',
    messagesLeftWarning: 'Ujumbe {count} umesalia leo.',
    forUnlimited: 'kwa ujumbe usio na kikomo.',
    sending: 'Inatuma...',
    deleteMessage: '🗑 Futa',
    deleting: 'Inafuta...',
    recording: 'Inarekodi...',
    deeper: 'Kina',
    neutral: 'Kati',
    higher: 'Juu',
    applyingModulation: '⚙️ Inatumia urekebishaji...',
    preview: '▶ Onyesho',
    pause: '⏸ Sitisha',
    discard: 'Tupa',
    voiceNotesLeft: 'Sauti {count} zimesalia leo',
    dailyLimitReachedVoice: 'Kikomo cha sauti cha kila siku kimefikiwa.',
    dailyVoiceNoteLimit: 'Kikomo cha sauti cha kila siku kimefikiwa. Panda hadi Premium kwa noti zisizo na kikomo.',
    recordingTooLarge: 'Rekodi ni kubwa mno. Tafadhali jaribu ujumbe mfupi.',
    failedToSend: 'Imeshindwa kutuma. Tafadhali jaribu tena.',
    micDenied: 'Ufikiaji wa maikrofoni umekataliwa.',
    checkIn: 'Ukaguzi',
    checkInDesc: 'Ukaguzi wa kila siku unafuatilia maendeleo. Ukaguzi wa kila wiki ni tafakari za kina.',
    dailyCheckin: 'Ukaguzi wa Kila Siku',
    weeklyCheckin: 'Ukaguzi wa Kila Wiki',
    dailyCheckinDesc: 'Sasisho fupi: Je, ulifanyia kazi lengo lako leo?',
    weeklyCheckinDesc: 'Tafakari ya kina: Wiki hii iliendaje kwa ujumla?',
    submitDaily: 'Wasilisha Ukaguzi wa Kila Siku',
    submitWeekly: 'Wasilisha Ukaguzi wa Kila Wiki',
    submitting: 'Inawasilisha...',
    checkinSubmitted: 'Ukaguzi Umewasilishwa!',
    checkinSubmittedDesc: 'Kazi nzuri kuendelea kuwajibika. {name} ataona sasisho lako.',
    viewHistory: 'Angalia Historia Yangu',
    newCheckin: '📝 Ukaguzi Mpya',
    myHistory: '📋 Historia Yangu',
    partnersProgress: '👤 Maendeleo ya {name}',
    myCheckinHistory: 'Historia Yangu ya Ukaguzi',
    checkinsForVeyl: 'Ukaguzi {count} kwa Veyl hii',
    noCheckinsYet: 'Hakuna ukaguzi bado. Anza wa kwanza!',
    newCheckinBtn: 'Ukaguzi Mpya',
    partnerNoCheckins: '{name} bado hajafanya ukaguzi.',
    dailyNotesPrivate: 'Maelezo ya kila siku ni ya faragha',
    goalAchievedMarked: '🎉 Lengo limetiwa alama kuwa limefikiwa',
    goalAchievedNote: '🎉 Lengo lako limetiwa alama kuwa limefikiwa! Nenda kwenye Muhtasari ili kufunua.',
    veylComplete: '✓ Veyl hii imekamilika. Ukaguzi ni wa kusoma tu.',
    goalAlreadyAchieved: '🎉 Umeweka alama lengo lako kuwa limefikiwa! Nenda kwenye Muhtasari ili kufunua.',
    didYouWork: 'Ulifanyia kazi lengo lako leo?',
    howDidWeekGo: 'Wiki hii iliendaje na lengo lako?',
    whatGotInWay: 'Nini kilikuzuia? (Si lazima)',
    honestNote: 'Kuwa mkweli. Mwenzako yuko hapa kukusaidia, si kukuhukumu.',
    whatDidYouLearn: 'Ulijifunza nini kujihusu wiki hii?',
    insightsPlaceholder: 'Ulipata maarifa gani?',
    whatPatterns: 'Unaona mwelekeo gani?',
    patternsPlaceholder: 'Kuna mada au vikwazo vinavyojirudia?',
    whatChange: 'Nini kinahitaji kubadilika kwa wiki ijayo?',
    changePlaceholder: 'Utafanya nini tofauti?',
    goalAchievedQuestion: '🏆 Je, umefikia lengo lako la jumla?',
    yesDidIt: '🎉 Ndiyo, nimefanikiwa!',
    notYetBtn: 'Bado',
    didIt: '✅ Nimefanya',
    didSome: '😐 Nimefanya kidogo',
    didntDoIt: '❌ Sikufanya',
    metCommitment: '✅ Nimetimiza ahadi',
    partialProgress: '😐 Maendeleo kiasi',
    noProgress: '❌ Hakuna maendeleo',
    rethinkingGoal: '🤔 Nafikiria upya lengo',
    yesLabel: '✅ Ndiyo',
    aLittle: '😐 Kidogo',
    noLabel: '❌ Hapana',
    madeProgress: 'Nimepiga hatua leo',
    didSomething: 'Nimefanya kitu, si kila kitu',
    didntWork: 'Sikufanyia kazi leo',
    metWeekly: 'Nimetimiza ahadi ya wiki',
    madePartial: 'Nimepata maendeleo kiasi',
    didntMake: 'Sikupata maendeleo',
    needToAdjust: 'Nahihaji kurekebisha mbinu yangu',
    learnedLabel: 'Nimejifunza: ',
    patternLabel: 'Mwelekeo: ',
    nextWeekLabel: 'Wiki ijayo: ',
    joinGroup: 'Jiunge na Kikundi',
    joinGroupDesc: 'Vikundi huwaleta pamoja hadi watu 5 wanaofanyia kazi malengo yanayofanana. Bila majina, kusaidiana, bila shinikizo.',
    whatToExpect: 'NINI CHA KUTARAJIA',
    expectAnonymous: 'Kila mtu anabaki bila jina — picha za wasifu za silhouette sawa',
    expectMatched: 'Kulinganishwa kwa kategoria ya lengo kwa usaidizi unaofaa',
    expectMembers: 'Hadi wanachama 5 kwa kila kikundi',
    expectChat: 'Mazungumzo ya kikundi — ujumbe 20 & sauti 5/siku bure · Bila kikomo kwenye Premium',
    findOrCreate: 'Tafuta au Unda Kikundi',
    findingGroup: 'Inatafuta kikundi chako...',
    oneGroupNote: 'Unaweza kuwa katika kikundi kimoja tu kwa wakati mmoja. Watumiaji wa bure na Premium wote wanapata ufikiaji wa kikundi.',
    groupCreated: 'Kikundi Kimeundwa!',
    groupJoined: 'Umejiunga na Kikundi!',
    groupCreatedDesc: 'Umeanzisha kikundi kipya cha {category}. Wengine watajiunga hivi karibuni.',
    groupJoinedDesc: 'Umejiunga na kikundi kilichopo cha {category}. Sema hello!',
    switchToGroup: 'Badilisha hadi kichupo cha Kikundi kwenye dashibodi yako ili kuanza kuzungumza.',
    groupMembers: 'Wanachama wa Kikundi',
    backToChat: '← Rudi kwenye mazungumzo',
    creator: '★ Muundaji',
    joined: 'Amejiunga',
    leaveGroup: 'Ondoka kwenye Kikundi',
    leaveGroupTitle: 'Ondoka kwenye kikundi hiki?',
    leaveGroupDesc: 'Utapoteza ufikiaji wa mazungumzo ya kikundi na unaweza kujiunga na kikundi kipya wakati wowote.',
    membersBtn: '👥 Wanachama',
    noGroupMessages: 'Hakuna ujumbe bado. Kuwa wa kwanza kusema hello!',
    messageGroup: 'Tuma ujumbe kwa kikundi chako...',
    groupDailyLimit: 'Umefikia kikomo chako cha kila siku cha ujumbe wa kikundi ({limit}/siku). Panda hadi Premium kwa ujumbe usio na kikomo!',
    veylCommunity: 'Jamii ya Veyl',
    communityDesc: 'Jiunge na wengine wanaofanyia kazi kategoria ya lengo sawa unapongojea mechi.',
    communityJoinNote: 'Jiunge na jamii kutoka ukurasa wa Kusubiri unapongojea mechi.',
    leaveCommunity: 'Ondoka kwenye jamii hii?',
    communityLeaveDesc: 'Unaweza kujiunga tena wakati wowote kutoka ukurasa wa kusubiri.',
    matchRequests: 'Maombi ya Mechi',
    incoming: 'Yanayoingia',
    sent: 'Yaliyotumwa',
    noIncoming: 'Hakuna maombi yanayoingia.',
    noPending: 'Hakuna maombi yaliyotumwa yanayosubiri.',
    requestToAnonymous: 'Ombi kwa mtumiaji asiyejulikana',
    pending: 'Inasubiri',
    decline: 'Kataa',
    accept: '✅ Kubali',
    requestWaiting: '🤝 Maombi {count} ya mechi yanakusubiri',
    view: 'Angalia',
    requestsBtn: '🤝 Maombi',
    leaveBtn: 'Ondoka',
    openToAll: 'Wazi kwa wote · Bila majina',
    msgsLeft: 'Ujumbe {count} umesalia',
    noCommunityMessages: 'Hakuna ujumbe bado. Sema hello kwa jamii!',
    saySomething: 'Sema kitu kwa jamii...',
    requestMatch: '🤝 Omba Mechi',
    requestSending: 'Inatuma...',
    communityMsgsWarning: 'Ujumbe {count} wa jamii umesalia leo.',
    communityDailyLimit: 'Umefikia kikomo chako cha kila siku cha ujumbe wa jamii ({limit}/siku). Panda hadi Premium kwa ukomo!',
    matchRequestLimit: 'Unaweza kuwa na maombi 3 pekee yanayosubiri kwa wakati mmoja.',
    matchRequestSent: 'Ombi la mechi limetumwa kwa mafanikio!',
    matchRequestDuplicate: 'Tayari umetuma ombi kwa mtu huyu.',
    matchRequestError: 'Hitilafu katika kutuma ombi la mechi. Tafadhali jaribu tena.',
    matchAcceptError: 'Hitilafu katika kukubali ombi la mechi.',
    matchRequestSentAlready: 'Tayari umetuma ombi kwa mtu huyu.',
    groupVoiceLimit: 'Kikomo cha sauti cha kila siku kimefikiwa.',
    groupDailyLimit: 'Umefikia kikomo chako cha kila siku cha ujumbe wa kikundi ({limit}/siku). Panda hadi Premium kwa ujumbe usio na kikomo!',
    notificationsTitle: 'Arifa',
    notificationsCount: 'Jumla {total} · {unread} hazijasomwa',
    clearAll: 'Futa Zote',
    clearing: 'Inafuta...',
    noNotifications: 'Hakuna arifa bado.',
    notifMatchFound: 'Mechi Imepatikana',
    notifGoalAchieved: 'Lengo Limefikiwa',
    notifSupport: 'Ujumbe wa Usaidizi',
    notifUnmatched: 'Tahadhari za Kutenganishwa',
    notifMatchRequest: 'Maombi ya Mechi',
    notificationPrefs: 'Mapendeleo ya Arifa',
    notificationPrefsDesc: 'Zima aina maalum za arifa kibinafsi.',
    muted: 'Imenyamazishwa',
    active: 'Inatumika',
    dismiss: '✕',
    settingsTitle: 'Mipangilio',
    settingsDesc: 'Binafsisha utambulisho wako usiojulikana.',
    chooseAvatar: 'Chagua picha yako',
    saveAvatar: 'Hifadhi Picha',
    saving: 'Inahifadhi...',
    saved: '✓ Imehifadhiwa!',
    appearance: 'Mwonekano',
    appearanceDesc: 'Chagua jinsi Veyl inavyoonekana kwako.',
    lightMode: '☀️ Mwanga',
    lightModeDesc: 'Safi na angavu',
    darkMode: '🌙 Giza',
    darkModeDesc: 'Rahisi machoni',
    active2: '✓ Inatumika',
    changeNickname: 'Badilisha Jina la Utani',
    currentNickname: 'Jina lako la utani la sasa ni',
    anonymousWarning: 'Liweke liwe la siri. Usitumie jina lako halisi.',
    newNickname: 'Jina Jipya la Utani',
    nicknamePlaceholder: 'k.m. NightOwl, StriveMode, Kira...',
    saveNickname: 'Hifadhi Jina la Utani',
    nicknameUpdated: '✓ Jina la Utani Limesasishwa!',
    goalsAchieved: 'Malengo Yaliyofikiwa',
    goalsAchievedDesc: 'Faragha — inaonekana nawe tu.',
    goalCompleted: 'lengo limekamilika',
    goalsCompleted: 'malengo yamekamilika',
    contactSupport: 'Wasiliana na Usaidizi',
    deleteAccount: 'Futa Akaunti',
    deleteAccountDesc: 'Inafuta kabisa akaunti yako na data yote inayohusiana. Hii haiwezi kutenduliwa.',
    deleteMyAccount: 'Futa Akaunti Yangu',
    deleteWarning: '⚠️ Hii itafuta kila kitu kabisa. Andika FUTA hapa chini ili kuthibitisha.',
    typeDelete: 'Andika FUTA ili kuthibitisha',
    confirmDelete: 'Thibitisha Kufuta',
    deleting2: 'Inafuta...',
    unveiledLocked: '✨ Imefunuliwa — picha imefungwa',
    howOthersSee: 'Hivi ndivyo wengine wanavyokuona',
    unveiledNote: 'Umefunua kwenye Veyl hii. Anza Veyl mpya ili kuchagua picha mpya.',
    languageLabel: 'Lugha',
    languageDesc: 'Chagua lugha unayopendelea.',
    activeLabel: 'Inatumika',
    seekingLabel: 'Inatafuta',
    completeLabel: 'Imekamilika',
    upgradeForMore: '✨ Panda hadi Premium kwa Veyls zaidi',
    newVeyl: '+ Veyl Mpya',
    newVeylTitle: 'Anza Veyl Mpya',
    goalCategoryLabel: 'Kategoria ya Lengo',
    goalDescriptionLabel: 'Maelezo ya Lengo',
    startVeyl: 'Anza Veyl Mpya',
    starting: 'Inaanza...',
    updating: 'Inasasisha...',
    unveil: 'Funua',
    clearing: 'Inafuta...',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Bluu-kijani',
    avatar_purple: 'Zambarau',
    avatar_navy: 'Bluu ya giza',
    avatar_slate: 'Kijivu-bluu',
    avatar_coral: 'Matumbawe',
    avatar_gold: 'Dhahabu',
    avatar_moss: 'Rangi ya moss',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'Imefunuliwa',
    nicknameRequired: 'Jina la utani linahitajika',
    nicknameTooShort: 'Jina la utani lazima liwe na angalau herufi 2',
    nicknameTooLong: 'Jina la utani lazima lisiwe na zaidi ya herufi 20',
    errorSavingNickname: 'Hitilafu katika kuhifadhi jina la utani',
    errorSavingAvatar: 'Hitilafu katika kuhifadhi picha ya wasifu',
    errorDeletingAccount: 'Hitilafu katika kufuta akaunti',
    deleteMyAccountButton: 'Futa Akaunti Yangu',
    goalsAchievedTitle: 'Malengo Yaliyofikiwa',
    goalsPrivate: 'Faragha — inaonekana nawe tu.',
    goalsCompletedCount: 'Malengo {count} yamekamilika',
    keepAnonymous: 'Liweke liwe la siri. Usitumie jina lako halisi.',
    currentNicknameIs: 'Jina lako la utani la sasa ni',
    justNow: 'Sasa hivi',
    minsAgo: 'Dakika {count} zilizopita',
    hoursAgo: 'Masaa {count} yaliyopita',
    daysAgo: 'Siku {count} zilizopita',
    all: 'Zote',
    leaving: 'Inaondoka...',
    matchRequestSentAlready: 'Tayari umetuma ombi kwa mtu huyu.',
    group: 'Kikundi',
    community: 'Jamii',
    notifications: 'Arifa',
    settings: 'Mipangilio',
    problemTitle: 'Mitandao ya Kijamii Iliharibu Uwajibikaji',
    problem1: "Unaogopa kukubali unaposhindwa",
    problem2: "Unaficha kushindwa badala ya kujifunza",
    problem3: "Unawacha washirika wako bila maelezo unapokosea",
    veylIsDifferent: 'Veyl ni tofauti.',
    popular: 'MAARUFU',
    sixMonthDeal: 'au $20 kwa miezi 6 ($3.33/mwezi)',
    getStartedPremium: 'Anza',
    buildTrust: 'Jenga Uaminifu',
    unveilIdentity: 'Fichua utambulisho wako unapokuwa tayari',
    actuallyAchieve: 'Fikia Lengo Kweli Kweli',
    makeRealProgress: 'Fanya maendeleo ya kweli bila kujigamba',
    faq1q: 'Je, mimi na mshirika wangu hatuendani?',
    faq1a: 'Rematch rahisi. Hakuna maswali. Tunataka upate mtu sahihi badala ya kulazimisha ushirikiano usioongeza.',
    faq2q: 'Je, lazima nifunue wakati fulani?',
    faq2a: 'Hapana. Baadhi ya ushirikiano hubaki wa siri milele. Wengine hufunua baada ya wiki moja. Ni uamuzi wako.',
    faq3q: 'Je, mshirika wangu akiniache bila maelezo?',
    faq3a: 'Watumiaji wa Premium wanapata rematch mara moja. Watumiaji wa bure wanapatikana tena ndani ya saa 48.',
    faq4q: 'Kwa nini hakuna picha za wasifu?',
    faq4a: 'Kwa sababu unapoongeza picha, inakuwa kuhusu kudhibiti mtazamo. Tulijaribu hilo. Kutokujulikana kunaweka umakini kwenye kazi.',
    legalEnglishOnly: 'Hati hii inapatikana kwa Kiingereza tu. Kwa maswali, tafadhali wasiliana na msaada au tumia kipengele cha kutafsiri cha kivinjari chako.',
    ctaTitle: "Uko tayari kufikia malengo yako?",
    ctaSubtitle: "Jiunge na Veyl na uoanishwe na mshirika wa uwajibikaji leo. Ni bure kuanza.",
    statAnonymous: "Bila Jina",
    statLanguages: "Lugha",
    statToStart: "Kuanza",
    authTagline: "Uwajibikaji bila jina. Matokeo ya kweli.",
    authPricing: "Bure kuanza · Premium kuanzia $5/mwezi",
    taglineHonest: "Mwaminifu",
    taglineEffective: "Ufanisi",
    foreverLabel: "/milele",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Pata Premium",
    premiumActiveDesc: "Una ufikiaji usio na kikomo wa vipengele vyote vya Veyl.",
    upgradeDesc: "Ondoa mipaka yote na upate uzoefu kamili wa Veyl.",
    billedMonthly: "Inatozwa kila mwezi",
    bestValue: "THAMANI BORA",
    perSixMonths: "$3.33/mwezi",
    unlimitedMessages: "Ujumbe usio na kikomo",
    unlimitedVoice: "Sauti usio na kikomo",
    unlimitedGroup: "Kikundi bila kikomo",
    unlimitedCommunity: "Jamii bila kikomo",
    was10day: "ilikuwa 10/siku",
    was5day: "ilikuwa 5/siku",
    was20day: "ilikuwa 20/siku",
    was30day: "ilikuwa 30/siku",
    sixMonthPlan: "Mpango wa Miezi 6",
    monthlyPlan: "Mpango wa Kila Mwezi",
    modulationFailed: "Kurekebisha kushindikana — kutumia sauti ya asili",
    monthly: "Kila mwezi",
    sixMonths: "Miezi 6",
    savePercent: "Akiba {{percent}}%",
    pricePerMonth: "${{price}} / mwezi",
    priceTotal: "${{price}} jumla",
    unlimitedMessages: "Ujumbe usio na kikomo",
    unlimitedVoiceNotes: "Vidokezo vya sauti visivyo na kikomo",
    unlimitedGroupMessages: "Ujumbe wa kikundi usio na kikomo",
    unlimitedCommunityMessages: "Ujumbe wa jamii usio na kikomo",
    upgrade: "Boresha",
    forUnlimited: "kwa usio na kikomo",
    messagesLeftWarning: "{{count}} ujumbe umebaki leo",
    recordVoiceNote: "Rekodi ujumbe wa sauti",
    uploading: "Inapakia",
    maxDuration: "dakika {{seconds}} kwa kiwango cha juu",
    upgradeToPremium: "Boresha hadi Premium",
    dailyMessageLimitReached: "Umeifikia kikomo cha ujumbe wa kila siku.",
    dailyVoiceLimitReached: "Umeifikia kikomo cha ujumbe wa sauti wa kila siku.",
    dailyGroupMessageLimitReached: "Umeifikia kikomo cha ujumbe wa kikundi wa kila siku.",
    dailyGroupVoiceLimitReached: "Umeifikia kikomo cha ujumbe wa sauti wa kikundi wa kila siku.",
    unlockUnlimited: "Fungua ufikiaji usio na kikomo wa vipengele vyote.",
    maybeLater: "Labada baadaye",
    premiumUnlimited: "Isiyo na kikomo",
    premium: "Premium",
    msg: "uj",
    msgs: "uj",
    newMessageNotification: "{{name}} amekutumia ujumbe 💬",
    newGroupMessageNotification: "{{name}} ametuma ujumbe katika kikundi chako 👥",
    someone: "mtu",
    failedToLoad: "Imeshindwa kupakia",
    groupMessagesLeftWarning: "Ujumbe {{count}} umebaki leo",
    howOldAreYou: 'Una umri gani?',
    minorGroupNote: 'Utaoanishwa na kuwekwa pamoja na watumiaji wenzako wa umri (13–17).',
    adultGroupNote: 'Utaoanishwa na kuwekwa pamoja na watu wazima wengine (18+).',
    enterYourAge: 'Weka umri wako',
    getStarted:        'Anza sasa',
    howItWorks:        'Jinsi inavyofanya kazi',
    statAnonymous:     'Bila jina',
    statLanguages:     'Lugha',
    statToStart:       'Kuanza',
    taglineHonest:     'Mkweli',
    taglineEffective:  'Inafanya kazi',
    landingHero:       'Uwajibikaji bila maonyesho.',
    landingSubtitle:   'Pata mshirika asiyejulikana anayeshiriki malengo yako. Bila wafuasi. Bila shinikizo — maendeleo ya kweli tu.',
    problemTitle:      'Uwajibikaji umevunjika.',
    problem1:          'Mitandao ya kijamii inabadilisha kujiboresha kuwa maonyesho. Unaweka malengo yako kupata "likes", si maendeleo.',
    problem2:          'Marafiki na familia wanakuja na hukumu au kutojali. Uaminifu wa kweli unakuwa hauwezekani.',
    problem3:          'Programu za uwajibikaji zinajihisi kama zana za kufuatilia — dashibodi tupu zinazopuuza kipengele cha binadamu.',
    veylIsDifferent:   'Veyl ni tofauti.',
    step1Title:        'Unda wasifu wako',
    step1Desc:         'Chagua jina la uwongo, kategoria ya lengo, na upendeleo wako wa mawasiliano. Utambulisho wako wa kweli unabaki wako.',
    step2Title:        'Pata mechi',
    step2Desc:         'Veyl anakupata mshirika anayeshiriki aina yako ya lengo na kikundi cha umri. Kulinganisha ni haraka — hakuna kusogea, hakuna kuswipe.',
    step3Title:        'Anza kuzungumza',
    step3Desc:         'Piga gumzo au tuma noti za sauti. Angalia kila siku au kila wiki. Mshirika wako anakuhesabu — nawe unamhesabu.',
    buildTrust:        'Jenga uaminifu',
    unveilIdentity:    'Rekodi mafanikio yako, weka alama za malengo. Unaweza kuchagua kufunua utambulisho wako — au la.',
    actuallyAchieve:   'Fikia kweli kweli',
    makeRealProgress:  'Maendeleo ya kweli na binadamu wa kweli. Bila michezo. Wewe tu, mshirika wako, na lengo lako.',
    pricingTitle:      'Anza bure. Endelea zaidi ukiwa tayari.',
    freePlan:          'Bure',
    foreverLabel:      '/ milele',
    freeFeature1:      'Mshirika 1 wa uwajibikaji',
    freeFeature2:      'Ujumbe 10 kwa siku',
    freeFeature3: 'Maelezo 10 ya sauti kwa siku',
    freeFeature5:      'Vyumba vya kikundi & jamii',
    popular:           'Maarufu zaidi',
    premiumPlan:       'Premium',
    perMonth:          '/ mwezi',
    sixMonthDeal: 'Mpango wa miezi 6 kwa $20 — kuokoa 33%',
    premiumFeature1:   'Ujumbe usio na kikomo',
    premiumFeature2:   'Noti za sauti zisizo na kikomo',
    premiumFeature3:   'Kipengele cha kufunua mshirika',
    premiumFeature4:   'Kulinganishwa kwa kipaumbele',
    getStartedPremium: 'Anza premium',
    faqTitle:          'Maswali ya kawaida.',
    faq1q: 'Je, Veyl ni ya siri kweli?',
    faq1a: 'Ndiyo. Unajisajili kwa jina la uwongo. Hakuna jina halisi, hakuna picha, hakuna kinachokutambulisha. Mshirika wako anajua tu unachochagua kushiriki.',
    faq2q: 'Kulinganishwa kunafanyaje kazi?',
    faq2a: 'Veyl anakuunganisha na mtu katika kategoria sawa ya lengo na kikundi cha umri. Kawaida huchukua chini ya dakika mbili.',
    faq3q: 'Nifanye nini nisipokuja na mshirika wangu?',
    faq3a: 'Unaweza kuripoti au kuzuia mshirika wako wakati wowote bila maswali. Linganishwa tena na mtu bora — iko katika mtiririko.',
    faq4q: 'Je, ni salama kwa watoto wadogo?',
    faq4a: 'Kabisa. Watumiaji wenye umri wa miaka 13–17 wanalinganishwa tu na watumiaji wengine katika kikundi sawa cha umri. Hii inatekelezwa katika ngazi ya mfumo.',
    ctaTitle:    'Mshirika wako anakusubiri tayari.',
    ctaSubtitle: 'Jiunge na Veyl bure. Hakuna wasifu wa kijamii unaohitajika. Wewe tu, lengo lako, na mtu anayekuelewa.',
    privacyPolicy:  'Sera ya Faragha',
    termsOfService: 'Masharti ya Huduma',
    refundPolicy:   'Sera ya Kurudisha Pesa',
    featuresTitle: "Kila kitu unachohitaji. Hakuna usichohitaji.",
    feature1Title: "Usiri kamili",
    feature1Desc: "Unachagua jina la bandia. Jina lako halisi, picha, na utambulisho — havitashirikiwa kamwe isipokuwa uamue kuvifichua.",
    feature2Title: "Ujumbe wa sauti",
    feature2Desc: "Wakati mwingine kuandika haitoshi. Rekodi na tuma ujumbe wa sauti moja kwa moja kwenye programu.",
    feature3Title: "Ulinganishaji salama wa umri",
    feature3Desc: "Watoto (miaka 13–17) wanalinganishwa na watoto wenzao tu. Watu wazima na watu wazima. Hakuna ubaguzi — imo ndani ya mfumo.",
    feature4Title: "Lugha 13",
    feature4Desc: "Kiingereza, Kiswahili, Kifaransa, Kihispania, Kireno, Kijerumani, Kiitaliano, Kihindi, Kiindonesia, Kichina, Kijapani, Kikorea, Kihausa.",
    feature5Title: "Uangalizi wa kila siku",
    feature5Desc: "Uangalizi wa kimuundo huendeleza kasi. Andika maendeleo na sherehekea ushindi pamoja na mshirika wako.",
    feature6Title: "Vikundi na jamii",
    feature6Desc: "Jiunge na mazungumzo ya kikundi yenye lengo maalum na vyumba vya jamii kwa lugha.",
    goalsEyebrow: "Kwa malengo halisi",
    goalsTitle: "Lolote unalofanyia kazi.",
    goalsSub: "Veyl ni kwa mtu yeyote aliye na lengo halisi na hakuna mtu wa kuwa wazi naye kulihusu.",
    goalFitness: "Mazoezi na Afya",
    goalLearning: "Kujifunza na Ujuzi",
    goalBusiness: "Biashara na Kazi",
    goalCreative: "Miradi ya Ubunifu",
    moreComingSoon: "Zaidi vinakuja hivi karibuni",
    safeTitle: "Usalama si kipengele tu. Ni msingi.",
    safe1Title: "Mgawanyo wa umri",
    safe1Desc: "Watoto na watu wazima hawachanganywi kamwe. Umri huthibitishwa wakati wa kujisajili na kufungwa.",
    safe2Title: "Ripoti na zuia",
    safe2Desc: "Mtumiaji yeyote anaweza kuripoti au kuzuia mara moja. Hakuna maswali yanayoulizwa.",
    safe3Title: "Hatuuzi data",
    safe3Desc: "Malengo yako, ujumbe wako, na utambulisho wako ni vyako. Hivyo tu.",
    safe4Title: "Majina ya bandia tu",
    safe4Desc: "Majina halisi hayahitajiki kamwe. Unadhibiti iwapo na wakati wa kujifichua.",
    refundPolicy: "Sera ya Marejesho",
    heroLine1: 'Uwajibikaji',               
    heroLine2: 'bila maonyesho',
    mustBe18: 'Lazima uwe na umri wa miaka 18 au zaidi kutumia Veyl',
    mustBe18Desc: 'Veyl ni jukwaa la watu wenye umri wa miaka 18 na kuendelea. Tunasikitika, lakini hujafikia kigezo cha umri kinachohitajika kufungua akaunti.',
    ageAttestationLabel: 'Ninathibitisha kuwa nina umri wa miaka 18 au zaidi.',
    ageMisrepresentationNote: 'Kutoa taarifa za uongo kuhusu umri wako kunakiuka Masharti yetu ya Huduma na kunaweza kusababisha kufungiwa akaunti.',
    feature3Title: 'Imethibitishwa kwa miaka 18+',
    feature3Desc: 'Kila mwanachama anathibitisha kuwa na umri wa miaka 18 au zaidi kabla ya kujiunga. Hakuna watoto, hakuna ubaguzi.',
    faq4q: 'Je, Veyl inapatikana kwa watoto chini ya miaka 18?',
    faq4a: 'Hapana. Veyl ni jukwaa la watu wenye miaka 18 na kuendelea pekee. Kila mtumiaji anathibitisha umri wake wakati wa kujisajili, na akaunti zinazogundulika kutoa taarifa za uongo kuhusu umri zinaweza kufutwa.',
    safe1Title: 'Watu wazima pekee',
    safe1Desc: 'Veyl imeundwa kwa ajili ya watu wenye miaka 18 na zaidi pekee. Mtu yeyote chini ya miaka 18 anayejaribu kutumia Veyl anatoa taarifa za uongo kuhusu umri wake, jambo linalokiuka Masharti yetu ya Huduma.',
    ageVerificationDesc: 'Veyl inapatikana kwa watumiaji wenye umri wa miaka 18 na zaidi.',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Kutana na Rasa',
    rasaIntroDesc: 'Rasa ni nafasi ya faragha ya kutafakari — kwa ajili yako tu, tofauti na mshirika wako wa uwajibikaji. Haileti mawazo kukuhusu wewe au ulimwengu; inajifunza tu kutokana na kile unachochagua kushiriki, na imeundwa ili kuuliza maswali badala ya kukupa majibu.',
    rasaIntroNotTherapist: 'Rasa si mtaalamu wa tiba na si mbadala wa uhusiano halisi wa kibinadamu — ikiwa ni pamoja na mwenzako wa uwajibikaji. Ikiwa kitu kinahisi kizito, kitakuelekeza kwa upole kwenye usaidizi, si kujaribu kuwa hivyo.',
    rasaIntroStart: 'Anza',
    rasaMessagesLeft: 'tafakari zilizobaki leo',
    rasaNoMessagesYet: 'Wakati wowote unapokuwa tayari kutafakari, anza kuandika hapa chini.',
    rasaThinking: 'Rasa anatafakari…',
    rasaPrivateNote: 'Faragha kwako — kamwe haionekani kwa mshirika wako wa uwajibikaji.',
    rasaPlaceholder: 'Shiriki unachofikiria...',
    rasaDailyLimitReached: 'Umefikia kikomo cha Rasa cha leo. Kitaanza upya kesho.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Kutana na Rasa',
    feature7Desc: 'Nafasi ya faragha ya kutafakari — kwa ajili yako tu, tofauti na mshirika wako wa uwajibikaji.',
    feature8Title: 'Pata usaidizi wakati wowote',
    feature8Desc: 'Majibu ya haraka kuhusu urambazaji, bili, na maswali ya akaunti — moja kwa moja kwenye programu.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Gumzo la usaidizi la Veyl',
    supportChatTitle: 'Usaidizi wa Veyl',
    supportChatEmptyState: 'Niulize chochote kuhusu jinsi Veyl inavyofanya kazi.',
    supportChatPlaceholder: 'Uliza swali…',
    supportChatSend: 'Tuma',
    supportChatTyping: 'Inaandika…',
    supportChatLimitReached: 'Umefikia kikomo cha gumzo la usaidizi la leo. Tuma barua pepe kwa support@veyl.space ikiwa ni dharura.',
    supportChatGenericError: 'Kuna kitu kimeenda vibaya. Tafadhali jaribu tena.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Haikuweza kupakia mazungumzo yako.',
    rasaLoadErrorDetail: 'angalia kiweko cha kivinjari kwa maelezo zaidi, au jaribu kuburudisha.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Umelinganishwa na {name}! Nenda kwenye dashibodi yako.',
    progressOf: 'Maendeleo ya {name}',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Sakinisha Programu',
    installMobileOnly: 'Simu ya mkononi pekee',
    installTooltip: 'Inapatikana kwenye vifaa vya mkononi pekee',
    installModalTitle: 'Sakinisha Veyl kwenye simu yako',
    installStep1: 'Gusa aikoni ya Shiriki katika upau wa vidhibiti wa Safariu2019s',
    installStep2: 'Sogeza chini na ubonyeze "Ongeza kwenye Skrini ya Nyumbani"',
    installStep3: 'Gusa "Ongeza" kwenye kona ya juu kulia',
    installGotIt: 'Nimeelewa',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Mahusiano na Muunganisho',
    homeLifeOrganization: 'Shirika la Nyumbani na Maisha',
    moneyFinancialHabits: 'Pesa na Tabia za Kifedha',
    stayingConnected: 'Kuendelea Kuunganishwa',
    independentLiving: 'Maisha ya Kujitegemea',
    techConfidence: 'Kujiamini kwa Teknolojia',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Mahusiano na Muunganisho',
    goalHomeLife: 'Shirika la Nyumbani na Maisha',
    goalMoney: 'Pesa na Tabia za Kifedha',
    goalStayingConnected: 'Kuendelea Kuunganishwa',
    goalIndependentLiving: 'Maisha ya Kujitegemea',
    goalTechConfidence: 'Kujiamini kwa Teknolojia',
    // [auto-synced 2026-10-28]
    resources: 'Rasilimali',
    resourcesTitle: 'Rasilimali',
    resourcesWriteUps: 'Maandishi',
    resourcesLinks: 'Usomaji zaidi',
    resourcesOpensNewTab: 'Hufungua kwenye kichupo kipya',
    resourcesEmptyTitle: 'Hakuna kitu hapa bado',
    resourcesEmptyBody: 'Bado tunakusanya rasilimali kwa ajili ya kategoria hii. Angalia tena hivi karibuni.',
    resourcesNoMatchBody: 'Hatukuweza kupata rasilimali kwa lengo hili bado.',
    resourcesDisclaimer: 'Taarifa za jumla pekee, si ushauri wa kitaalamu. Ikiwa kitu kitaathiri afya yako, usalama au pesa zako, mtaalamu aliyehitimu anaweza kukusaidia katika hali yako.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Makala',
    resourcesMoreToRead: 'Zaidi ya kusoma',
    res_intro_fitnessHealth: 'Malengo ya siha na afya huwa yanapatikana katika nyakati ndogo, za kawaida, si kubwa. Vipande hivi viko hapa ili kupunguza shinikizo, na viungo vinaongoza kwenye vyanzo ambavyo vina maelezo mazuri.',
    res_fitness_showing_up_title: 'Kuonyesha midundo ikionyesha',
    res_fitness_showing_up_p1: 'Wengi wetu tuna picha ya jinsi mazoezi "sahihi" yanavyoonekana: ukumbi wa mazoezi, viatu vya kukimbia, jasho. Wakati maisha hayaendani na picha hiyo, ni rahisi kuamua kuwa jambo zima halikufaa.',
    res_fitness_showing_up_p2: 'Shirika la Afya Duniani lina mtazamo mpana zaidi. Linahesabu harakati wakati wa mapumziko, kutoka sehemu moja hadi nyingine, na shughuli katika kazi yako au nyumbani. Kutembea, kuendesha baiskeli, kucheza na kucheza vyote vinahesabika, katika kiwango chochote cha ujuzi. Miongozo yake inasisitiza kwamba kiasi chochote cha shughuli ni bora kuliko kutofanya hivyo.',
    res_fitness_showing_up_p3: 'Hilo ni muhimu unapojenga tabia na mwenzi. Matembezi mafupi uliyofanya yana thamani zaidi kuliko kipindi kigumu ulichopanga na kukiruka. Kuingia kwenye mkutano kunasema "Nilifanikiwa dakika kumi pekee" bado ni kuingia kwenye mkutano ulioendelea.',
    res_fitness_showing_up_p4: 'Pia husaidia kutenganisha ulichofanya na jinsi ulivyohisi. Siku zingine tabia hiyo ndiyo ushindi kamili. Nguvu inaweza kuja baadaye, mara tu kujitokeza kutakapoacha kuwa mazungumzo.',
    res_fitness_showing_up_p5: 'Ikiwa una tatizo la kiafya, una mimba, au hujafanya mazoezi kwa muda mrefu, inafaa kuzungumza na daktari au mtaalamu mwingine wa afya aliyehitimu kabla ya kubadilisha jinsi unavyofanya mazoezi kwa bidii.',
    res_fitness_rest_title: 'Pumziko ni sehemu ya mpango',
    res_fitness_rest_p1: 'Watu wanapozungumzia malengo ya siha, kulala na kupumzika kwa kawaida huchukuliwa kama vitu vilivyobaki mara tu kazi halisi inapokamilika. Kiutendaji, ni sehemu kubwa ya kama kazi itadumu.',
    res_fitness_rest_p2: 'Kulala na shughuli hulishana. NHS inabainisha kuwa shughuli za kawaida zinaweza kukusaidia kulala vizuri zaidi, na kwamba baadhi ya watu hupata kuwazuia kufanya mazoezi karibu na wakati wa kulala, ambapo mapema mchana kunaweza kuwafaa. Hakuna sheria. Ni ukumbusho kwamba wewe ndiye unayepata kujua kinachofaa kwa mwili wako.',
    res_fitness_rest_p3: 'Mapumziko pia yanafaa kupangwa wakati mnapowajibishana. Ikiwa kila kuingia kunakuwa ripoti ya kiasi gani mlichokisukuma, siku tulivu huanza kuhisi kama mshindwa. Siku ya mapumziko uliyochagua kwa makusudi ni tofauti na kupotoka kutoka kwenye lengo, na ni sawa kusema hivyo kwa sauti.',
    res_fitness_rest_p4: 'Ikiwa usingizi ni tatizo kubwa kwa muda mrefu, au unahisi umechoka kwa sababu ambazo huwezi kuzibainisha, hilo linafaa kujadiliwa na daktari au mtaalamu mwingine wa afya aliyehitimu. Sio jambo la kusukuma peke yako.',
    res_fitness_food_title: 'Chakula bila usumbufu',
    res_fitness_food_p1: 'Ushauri wa chakula ni mkubwa na mara nyingi unapingana, kwa hivyo ni muhimu kujua kwamba mashirika makubwa ya afya ya umma yana utulivu zaidi kuliko mtandao mwingi.',
    res_fitness_food_p2: 'WHO inasema lishe bora huja katika aina nyingi. Kinachohesabiwa kama njia nzuri ya kula inategemea umri wako, mtindo wa maisha, utamaduni, na vyakula unavyoweza kupata mahali unapoishi. Inaelezea mawazo manne ambayo yapo chini ya mojawapo kati ya hayo: kupata vya kutosha vya kile ambacho mwili wako unahitaji, kuweka vitu katika usawa, kufurahia baadhi ya vyakula kwa kiasi, na kula aina mbalimbali. Lishe tofauti na isiyosindikwa ndiyo msingi unaoelekeza.',
    res_fitness_food_p3: 'Kwa lengo unalofuatilia na mtu mwingine, hilo ni jambo muhimu. Huna haja ya kuiga jinsi mwenzako anavyokula, na yeye hahitaji kuiga lako. Lengo la chakula linaweza kuwa rahisi kama "kupika nyumbani mara nyingi zaidi" au "kula kitu kingine ambacho si cha kawaida wiki hii", chochote kinachofaa maisha na bajeti yako.',
    res_fitness_food_p4: 'Ikiwa unafikiria kuhusu mabadiliko makubwa katika jinsi unavyokula, au una hali, mzio au dawa zinazoathiri chakula, daktari au mtaalamu wa lishe aliyesajiliwa anaweza kutoa ushauri unaokufaa. Maandishi ya jumla hayawezi.',
    res_fitness_who_physical_activity_note: 'Ulimwenguni. Muhtasari dhahiri wa kile kinachohesabiwa kama shughuli, ni nani anayefaidika na kwa nini.',
    res_fitness_who_guidelines_note: 'Kimataifa. Miongozo kamili, yenye mapendekezo kwa rika tofauti na kwa watu wanaoishi na hali sugu au ulemavu.',
    res_fitness_who_healthy_diet_note: 'Kimataifa. Inaelezea kanuni za lishe bora na kwa nini hutofautiana kulingana na utamaduni na chakula cha ndani.',
    res_fitness_nhs_sleep_note: 'Uingereza. Ushauri wa usingizi wa vitendo. Kutajwa kwake kwa daktari wa familia au mfamasia kunarejelea huduma za Uingereza.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Pata arifa Veyl itakapofungwa',
    pushPromptBody: 'Tutakujulisha mtakapounganishwa au mshirika wako akikutumia ujumbe. Arifa hazijumuishi kamwe maudhui ya ujumbe.',
    pushEnable: 'Washa arifa',
    pushNotNow: 'Sio sasa',
    pushError: 'Hitilafu imetokea wakati wa kuwasha arifa. Tafadhali jaribu tena.',
    pushBlockedTitle: 'Arifa zimezuiwa',
    pushBlockedBody: 'Kivinjari chako kinazuia arifa kutoka Veyl. Ili kuziwasha, fungua mipangilio ya tovuti ya kivinjari chako kwa veyl.space, ruhusu arifa, kisha upakie upya ukurasa.',
    pushIosTitle: 'Pata arifa kwenye iPhone',
    pushIosBody: 'Ongeza Veyl kwenye Skrini yako ya Nyumbani kwanza: gusa Shiriki, kisha Ongeza kwenye Skrini ya Nyumbani, kisha fungua Veyl kutoka hapo na uwashe arifa.',
    pushSettingsTitle: 'Arifa kwenye kifaa hiki',
    pushSettingsDesc: 'Pata arifa mnapolingana au mshirika wako anakutumia ujumbe, hata wakati Veyl imefungwa. Arifa hazijumuishi kamwe maudhui ya ujumbe. Mpangilio huu unatumika kwa kifaa hiki pekee.',
    pushSettingsUnsupported: 'Arifa hazipatikani kwenye kivinjari hiki. Kwenye iPhone au iPad, ongeza Veyl kwenye Skrini yako ya Nyumbani kwanza (Shiriki, kisha Ongeza kwenye Skrini ya Nyumbani), kisha uifungue kutoka hapo.',
    pushSettingsBlocked: 'Arifa zimezuiwa kwa Veyl kwenye kivinjari chako. Ili kuziwasha, fungua mipangilio ya tovuti ya kivinjari chako kwa veyl.space, ruhusu arifa, kisha upakie upya ukurasa.',
    pushSettingsWorking: 'Inafanya kazi…',
    pushSettingsOn: 'Arifa zimewashwa kwa kifaa hiki',
    pushSettingsTurnOff: 'Zima arifa',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Kujifunza kitu kipya kwa kiasi kikubwa hutokana na kuonekana mara nyingi vya kutosha ili kiweze kudumu. Vipande hivi vinahusu mchezo mrefu, na viungo ni sehemu za bure za kujifunza karibu kila kitu.',
    res_learning_small_repeat_title: 'Ndogo ya kutosha kurudia',
    res_learning_small_repeat_p1: 'Malengo mengi ya kujifunza hufa kutokana na kuwa makubwa sana, si magumu sana. "Jifunze kuandika msimbo" au "kuwa fasaha katika Kireno" ni mahali pa kwenda, si kitu unachoweza kufanya Jumanne jioni.',
    res_learning_small_repeat_p2: 'Unachoweza kufanya Jumanne jioni ni kukaa chini kwa dakika ishirini na somo moja. Hiyo ni kazi unayoweza kurudia, na kuirudia ndipo kujifunza kunapoongezeka. Ujuzi huwa unafika kimya kimya, kidogo kidogo, hadi siku moja utakapogundua unaweza kufanya kitu ambacho hukuweza kufanya hapo awali.',
    res_learning_small_repeat_p3: 'Hapa ndipo mshirika anayewajibika husaidia zaidi ya motisha inavyosaidia. Motisha huja na kuondoka. Mshirika anayetarajia kusikia jinsi mambo yalivyokwenda hufanya iwe vigumu kuacha tabia hiyo kimya kimya na iwe rahisi kuanza tena baada ya wiki mbaya.',
    res_learning_small_repeat_p4: 'Kuingia vizuri si lazima kuwe kwa kuvutia. "Nilifanya somo moja na kuelewa karibu nusu" ni kweli, na huifanya tabia hiyo iendelee kuwa hai. Unaweza kuongeza ukubwa wa kazi baadaye. Ni vigumu zaidi kujenga upya tabia ambayo imeacha kufanya kazi.',
    res_learning_beginner_title: 'Kuwa mtangulizi kunaruhusiwa',
    res_learning_beginner_p1: 'Kuanzisha kitu kipya kunamaanisha kuwa mbaya katika jambo hilo, angalau mbele ya mtu mmoja. Kwa watu wazima wengi hicho ndicho kikwazo halisi, zaidi ya muda au pesa.',
    res_learning_beginner_p2: 'Inaweza kusaidia kujua jinsi ujifunzaji huria umekuwa. MIT OpenCourseWare huchapisha nyenzo kutoka kwa maelfu ya kozi za MIT bila malipo, bila usajili. OpenLearn ya Chuo Kikuu Huria inatoa karibu kozi elfu moja fupi za bure, na inasema hakuna mahitaji ya kuzifikia. Huhitaji ruhusa ya mtu yeyote kujaribu somo, au kugundua kuwa sio lako.',
    res_learning_beginner_p3: 'Kujaribu kitu na kuamua kuwa hakikufaa pia kunahesabiwa kama kujifunza. Kujaribu vitu vichache kabla ya kujitolea kufanya hivyo ni njia nzuri ya kuanza.',
    res_learning_beginner_p4: 'Unapohisi umerudi nyuma, kumbuka kwamba mwenzi wako anaweza kuhisi vivyo hivyo kuhusu lengo lake. Hamshindani. Nyote wawili mko karibu na mwanzo wa jambo fulani, katika sehemu tofauti.',
    res_learning_choose_one_title: 'Chagua kitu kimoja, kisha endelea kukichagua',
    res_learning_choose_one_p1: 'Kujifunza bila malipo kuna tatizo la ajabu: kuna mengi sana. OpenCourseWare pekee inashughulikia zaidi ya kozi 2,500, na OpenLearn ina karibu elfu moja. Ni rahisi kutumia jioni nzima kuvinjari na kuiita kujifunza.',
    res_learning_choose_one_p2: 'Inasaidia kuchagua kozi moja, kitabu kimoja au mfululizo mmoja wa masomo, na kuchukulia kila kitu kingine kama "cha baadaye". Kuweka mengine kwenye noti ni sawa. Lengo ni kumaliza jambo moja kabla ya kuanza linalofuata. Kumwambia mwenzako ni lipi ulilochagua ni ahadi ndogo ambayo hurahisisha kushikamana nalo.',
    res_learning_choose_one_p3: 'Pia inafaa kuangalia kile ambacho rasilimali inakupa na kile ambacho haipati. Kozi za OpenLearn, kwa mfano, huja na taarifa ya ushiriki, na zingine zikiwa na beji ya kidijitali ambayo si sifa iliyoidhinishwa. Ikiwa unahitaji sifa rasmi ya kazi au masomo, ni muhimu kujua hilo mapema, na taasisi unayolenga inaweza kukuambia wanachokubali.',
    res_learning_mit_ocw_note: 'Kimataifa. Maelezo ya mihadhara, mitihani na video bila malipo kutoka kwa maelfu ya kozi za MIT, bila usajili. Kwa Kiingereza.',
    res_learning_khan_academy_note: 'Kimataifa. Shirika lisilo la faida linalotoa masomo na mazoezi bila malipo, lenye nguvu zaidi katika hisabati na sayansi, katika lugha nyingi.',
    res_learning_openlearn_note: 'Imejengwa Uingereza, iko wazi kwa mtu yeyote. Karibu kozi 1,000 za bure, kuanzia saa 1 hadi 24, kila moja ikiwa na taarifa ya bure ya ushiriki.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Malengo ya kazi ni marefu, na juhudi nyingi hutokea katika siku kati ya hatua muhimu. Vipande hivi vinahusu kudumisha mwendo thabiti, na viungo ni sehemu za bure za kujenga ujuzi na kupanga hatua yako inayofuata.',
    res_business_progress_title: 'Maendeleo kazini mara chache huwa mstari ulionyooka',
    res_business_progress_p1: 'Malengo ya kazi na biashara yana njia ya kupanua. Kupandishwa cheo, mabadiliko ya kazi au mteja wa kwanza kunaweza kuchukua miezi, na siku zilizo katikati mara chache huhisi kama maendeleo.',
    res_business_progress_p2: 'Inasaidia kutenganisha matokeo unayotaka na mambo unayoweza kufanya wiki hii. Huwezi kudhibiti kama kampuni inakuajiri, au kama mteja anasema ndiyo. Unaweza kudhibiti idadi ya mazungumzo unayofanya, muda unaoupa mradi, na kama unafuatilia jambo ulilosema ungefanya.',
    res_business_progress_p3: 'Hapo ndipo mshirika anayewajibika anapopata nafasi yake. Hawahitaji kuelewa tasnia yako. Wanahitaji tu kuuliza ulichofanya, na kusikiliza jibu bila kuifanya iwe utendaji.',
    res_business_progress_p4: 'Wiki kadhaa ripoti ya kweli huwa "haijatokea mengi". Inafaa kusema kwa sauti, kwa sababu lengo ambalo halijakamilika kwa mwezi mmoja ni gumu zaidi kulifikia tena kuliko lile ambalo uliliweka hai kidogo.',
    res_business_start_from_you_title: 'Anza na wewe, si kazi',
    res_business_start_from_you_p1: 'Watu wanapohisi wamekwama kazini, silika mara nyingi huwa ni kuanza na soko la ajira: ni nini kinachofanya kazi, ni nini kinacholipa vizuri, na ni nini kinachoonekana kuvutia. Inaweza kuwa na manufaa zaidi kuanza mahali pengine.',
    res_business_start_from_you_p2: 'Kozi ya bure ya OpenLearn Succeed mahali pa kazi imejengwa juu ya wazo hilo. Inaanza na mtazamo kwamba kujijua na kile unachothamini ndio msingi wa kupanga kazi, na kisha tu huhamia kwenye CV, maombi na mahojiano.',
    res_business_start_from_you_p3: 'Kwa maneno rahisi: unataka siku zako zihisije? Una sifa gani nzuri ambayo mara chache huipati sifa? Ungekataa kuibadilisha, iwe ni wakati wa kuwa na familia, mapato thabiti au nafasi ya kuwa mbunifu?',
    res_business_start_from_you_p4: 'Huna haja ya kujibu yote hayo peke yako. Kuzungumza na mwenzi wako mara nyingi huleta mambo ambayo ungeyapuuza peke yako, na inaweza kugeuza "Nataka kitu tofauti" kuwa lengo ambalo unaweza kulifanyia kazi.',
    res_business_wear_out_title: 'Kufanya kazi kwa bidii bila kujichosha',
    res_business_wear_out_p1: 'Tamaa na uchovu vinaweza kuonekana sawa kutoka ndani, hasa wakati lengo ni muhimu kwako.',
    res_business_wear_out_p2: 'Shirika la Afya Duniani linabainisha kuwa kazi inaweza kulinda afya ya akili, na kwamba inaweza pia kuchangia madhara. Miongozo yake kuhusu afya ya akili kazini inaelekeza kwenye hatari kama vile mzigo mkubwa wa kazi na tabia mbaya kazini, na wanasema jukumu la mahali pa kazi pa afya liko mikononi mwa waajiri na serikali, si tu kwa wafanyakazi binafsi.',
    res_business_wear_out_p3: 'Ikiwa unawasiliana na mwenzako kuhusu lengo kubwa la kazi, inafaa kuuliza sio tu "umefanikiwa?" bali "unasimamaje?" Lengo linalofuatwa kwa gharama ya usingizi wako, afya au mahusiano yako linafaa kutafakari upya, hata kama linaenda vizuri kwenye karatasi.',
    res_business_wear_out_p4: 'Ikiwa kazi inaathiri afya yako, au unahisi huzuni kila mara, una wasiwasi au umechoka, tafadhali zungumza na daktari au mtaalamu mwingine wa afya aliyehitimu. Ikiwa huna uhakika kuhusu haki zako kazini, chanzo kinachoaminika cha eneo lako, kama vile mamlaka ya kazi au shirika la wafanyakazi, kinaweza kuelezea haki hizo kwa mahali unapoishi. Sheria hutofautiana sana kati ya nchi.',
    res_business_who_mh_work_note: 'Kimataifa. Imeandikwa hasa kwa ajili ya waajiri na serikali, kwa hivyo ni ya kiufundi. Muhtasari wa utendaji unapatikana katika Kiarabu, Kichina, Kiingereza, Kifaransa, Kirusi na Kihispania.',
    res_business_openlearn_entrepreneurship_note: 'Kozi inayofanyika Uingereza. Inachukua saa 24 katika vipindi 8, na unaweza kuanza bila kujisajili. Baadhi yake inashughulikia sheria za biashara za Uingereza, kwa hivyo angalia kinachofaa katika nchi yako.',
    res_business_openlearn_succeed_note: 'Takriban wiki 8 kwa takriban saa 3 kwa wiki, zikishughulikia mipango ya kazi, CV na mahojiano. Ilisasishwa mara ya mwisho mnamo 2021, kwa hivyo baadhi ya sehemu kuhusu utafutaji wa kazi na mitandao ya kijamii zinaweza kuhisi zimepitwa na wakati.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Eneo la saa',
    timezoneCurrentIs: 'Saa za eneo lako la sasa ni',
    timezoneLockNote: 'Vikomo vyako vya ujumbe wa kila siku na noti za sauti huwekwa upya saa sita usiku katika saa zako za ukanda. Ili kudumisha usawa huu, unaweza kubadilisha saa zako za ukanda siku ambayo hujatumia ujumbe wowote au noti za sauti, na mara moja tu kila baada ya siku 7.',
    timezoneNew: 'Chagua eneo la saa',
    saveTimezone: 'Hifadhi eneo la saa',
    timezoneUpdated: 'Saa za eneo zimesasishwa',
    timezoneInvalid: 'Eneo hilo la saa si sahihi. Tafadhali chagua moja kutoka kwenye orodha.',
    timezoneChangeError: 'Haikuweza kubadilisha eneo lako la saa. Tafadhali jaribu tena.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Miradi ya ubunifu huwa inaishi katika mapengo kati ya kila kitu kingine. Vipande hivi vinahusu kuweka kitu hai kupitia katikati ndefu, na viungo vinashughulikia kujifunza kuandika na kutumia na kushiriki kazi ya ubunifu.',
    res_creative_finishing_title: 'Kumaliza pia ni ujuzi',
    res_creative_finishing_p1: 'Kuanzisha mradi wa ubunifu ni sehemu rahisi. Wazo ni jipya na kila kitu kinaonekana kinawezekana. Sehemu ngumu huja katikati, wakati wazo limegeuka kuwa kazi halisi na kazi inakuwa polepole na ngumu kuliko wazo lilivyokuwa.',
    res_creative_finishing_p2: 'Hapo ndipo miradi hukwama, na mara chache sana kwa sababu mtu hana kipaji. Mara nyingi zaidi ni kwa sababu mtu wa kati hana mstari wa kumalizia wa kutarajia na hakuna anayeangalia.',
    res_creative_finishing_p3: 'Hapa ndipo mwenzi anayeuliza tu "umefanya nini wiki hii?" anaweza kuleta mabadiliko makubwa. Huna haja ya wao kuhukumu. Kujua kwamba utaelezea wiki yako huipa kazi muda mfupi wa mwisho, na muda mfupi wa mwisho mara nyingi unatosha kukurudisha kwenye dawati, turubai au kifaa cha muziki.',
    res_creative_finishing_p4: 'Pia husaidia kuamua maana ya "kufanyika" kwa kitu kilicho mbele yako. Toleo la awali lililokamilika lina thamani zaidi ya lile kamili linalobaki kichwani mwako. Unaweza kulifanya liwe bora zaidi baada ya kuwepo.',
    res_creative_rough_drafts_title: 'Hakuna mtu anayehitaji kuona toleo la kwanza',
    res_creative_rough_drafts_p1: 'Watu wengi wabunifu huacha kimya kimya kwa sababu jaribio la kwanza si zuri kama picha iliyo akilini mwao. Pengo hilo kati ya unachofikiria na unachoweza kufanya sasa hivi ni la kawaida. Mara nyingi huwa kubwa zaidi unapojali zaidi.',
    res_creative_rough_drafts_p2: 'Kumwonyesha mtu mmoja anayeaminika kazi ngumu kunaweza kupunguza uzito. Kumwambia mwenzi wako "hii ni rasimu chafu, lakini hivi ndivyo ninavyojaribu kufanya" huigeuza kuwa mazungumzo, si uamuzi. Unaweza kugundua kuwa wanajali zaidi kama uliendelea kuliko kama ni nzuri.',
    res_creative_rough_drafts_p3: 'Kama wewe ni mgeni katika ufundi, kuna njia rahisi za kuingia. OpenLearn, tovuti ya kujifunzia ya bure ya Chuo Kikuu Huria, ina kozi ya utangulizi kuhusu uandishi wa hadithi za kubuni zinazolenga watu wanaoanza tu. Ni mfano mmoja kati ya mingi, na inafaa waandishi zaidi kuliko aina nyingine za watungaji.',
    res_creative_rough_drafts_p4: 'Maendeleo katika kazi ya ubunifu mara chache huonekana kama uboreshaji thabiti. Baadhi ya wiki unafanya kitu unachojivunia, na baadhi ya wiki unafanya kitu ambacho hutawahi kumuonyesha mtu yeyote. Zote mbili zinahesabika, na zote mbili ni sehemu ya tabia moja.',
    res_creative_using_sharing_title: 'Kutumia kazi za watu wengine, na kushiriki yako mwenyewe',
    res_creative_using_sharing_p1: 'Miradi ya ubunifu mara nyingi huhusisha nyenzo za watu wengine, kama vile picha, sauti au maandishi, na hatimaye unaweza kutaka kushiriki yako mwenyewe. Usuli mdogo husaidia katika yote mawili.',
    res_creative_using_sharing_p2: 'Creative Commons ni shirika lisilo la faida linalochapisha leseni zinazowaruhusu waumbaji kuhifadhi hakimiliki zao huku likiwaruhusu wengine kutumia kazi zao kwa njia ambazo muumbaji huchagua. Ukitaka kushiriki kitu ambacho umetengeneza, mwongozo wake unaelezea jinsi leseni hizo zinavyofanya kazi.',
    res_creative_using_sharing_p3: 'Baadhi ya taasisi huenda mbali zaidi. Smithsonian imetoa mamilioni ya picha na data chini ya kile kinachoitwa CC0, kumaanisha unaweza kuzitumia bila kuomba ruhusa ya Smithsonian, ikiwa ni pamoja na miradi ya ubunifu. Lakini Maswali Yanayoulizwa Mara kwa Mara yanabainisha kuwa CC0 inashughulikia hakimiliki pekee. Haki zingine, kama vile faragha au chapa ya biashara, bado zinaweza kutumika, na baadhi ya vitu katika makusanyo yake havijajumuishwa kabisa.',
    res_creative_using_sharing_p4: 'Sheria za hakimiliki hutofautiana kati ya nchi, na hii ni taarifa ya jumla, si ushauri wa kisheria. Ikiwa mradi una umuhimu kibiashara, au huna uhakika kama unaweza kutumia kitu, mtaalamu aliyehitimu anaweza kukuambia msimamo wako.',
    res_creative_openlearn_fiction_note: 'Imejengwa Uingereza, ni bure kuanza. Kozi ya utangulizi kuhusu uandishi wa hadithi za kubuni, yenye taarifa ya ushiriki bila malipo. Inafaa waandishi zaidi kuliko aina nyingine za watungaji.',
    res_creative_cc_license_note: 'Kimataifa. Jinsi ya kuwaruhusu wengine kutumia kazi yako kwa masharti unayochagua huku ukitunza hakimiliki yako. Taarifa za jumla, si ushauri wa kisheria.',
    res_creative_smithsonian_open_access_note: 'Taasisi ya Marekani, bure kwa mtu yeyote kutumia. Inaelezea picha na data iliyotolewa kama CC0, kile kinachoruhusu na kisichoruhusu, na ni vitu gani vilivyotengwa.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Mahusiano hujengwa zaidi kutokana na mambo madogo yanayojirudia kuliko kutokana na matukio makubwa. Vipande hivi vinahusu kudumisha uhusiano hai, kile ambacho utafiti unasema ni muhimu zaidi, na cha kufanya wakati uhusiano ni mgumu au uhusiano si salama.',
    res_relationships_small_gestures_title: 'Idadi ndogo ya ishara',
    res_relationships_small_gestures_p1: 'Wengi wetu tunachukulia urafiki na mahusiano ya kifamilia kama vitu ambavyo vipo au havipo. Robert Waldinger, anayeongoza Utafiti wa Maendeleo ya Watu Wazima wa Harvard, anaelezea maisha ya kijamii kama mfumo wa maisha unaohitaji matengenezo, kama vile utimamu wa mwili.',
    res_relationships_small_gestures_p2: 'Matengenezo yanaweza kuwa madogo. Fikiria mtu unayemkosa na umtumie ujumbe. Orodha ya hatua za kila siku za Shirika la Afya Duniani ni ndogo vile vile: kuwasiliana na rafiki, kuweka simu yako pembeni ili uwepo ipasavyo kwenye mazungumzo, kumsalimia jirani, kujiunga na kikundi cha wenyeji, au kujitolea.',
    res_relationships_small_gestures_p3: 'Kwa lengo unaloshiriki na mshirika anayewajibika, hili ni swali zuri la kila wiki: uliwasiliana na nani? Ni jambo la kweli, ni dogo, na unaweza kulijibu kwa uaminifu hata katika wiki ngumu.',
    res_relationships_small_gestures_p4: 'Sio kila ujumbe unaopata jibu la joto, na hiyo ni sehemu yake. Waldinger anasema watu mara nyingi hushangazwa na jinsi ujumbe mdogo kama huu unavyopokelewa kwa joto.',
    res_relationships_quality_title: 'Ubora zaidi ya wingi',
    res_relationships_quality_p1: 'Ni rahisi kupima maisha ya kijamii kwa idadi ya watu: marafiki wangapi, matukio mangapi, kama uko kwenye uhusiano. Utafiti unaelekeza mahali pengine.',
    res_relationships_quality_p2: 'Utafiti wa Harvard wa Maendeleo ya Watu Wazima umewafuatilia watu tangu 1938. Watafiti wake walipoangalia maisha ya washiriki katika umri wa kati, kuridhika katika mahusiano yao, hasa ndoa, kulitabiri ni nani angekuwa na furaha na afya njema akiwa na umri wa miaka 80 bora kuliko mambo kama vile kolesteroli au shinikizo la damu. Mkurugenzi wake anasema vikundi vingine vya utafiti vimegundua jambo hilo hilo tangu wakati huo. Pia anasema hakuna idadi maalum ya miunganisho unayohitaji, na kwamba watu wenye haya wanaweza kuhitaji watu wachache kuliko watu wenye furaha.',
    res_relationships_quality_p3: 'Tahadhari moja: washiriki wa kwanza wa utafiti walikuwa wanafunzi wa Harvard na vijana kutoka mji mmoja wa Marekani, kwa hivyo si picha ya kila mtu. Inafaa kushikilia hitimisho kwa uhuru.',
    res_relationships_quality_p4: 'Kinachopendekeza, kwa upole, ni kwamba angalau uhusiano mmoja imara, mtu ambaye ungeweza kumpigia simu ikiwa ulikuwa mgonjwa au unaogopa, ni muhimu zaidi ya mzunguko mkubwa. Na mara chache huwa ni kuchelewa sana. Mkurugenzi wa utafiti anaelezea watu waliopata urafiki wa karibu au mapenzi marehemu maishani wakati hawakutarajia.',
    res_relationships_hard_times_title: 'Wakati uhusiano ni mgumu, na wakati uhusiano unauma',
    res_relationships_hard_times_p1: 'Kuhisi upweke haimaanishi kuna tatizo kwako. Shirika la Afya Duniani linakadiria kwamba karibu mtu mmoja kati ya sita duniani kote hupata upweke, katika kila umri. Linaelezea upweke kama hisia chungu inayokuja wakati miunganisho uliyonayo hailingani na ile unayotaka.',
    res_relationships_hard_times_p2: 'Sababu zinaweza kujumuisha afya mbaya, kipato cha chini, kuishi peke yako, au jinsi tunavyotumia teknolojia. WHO inabainisha kwamba ikiwa tatizo ni kubwa zaidi, kujua ni msaada na huduma gani zilizopo kunafaa kufanywa.',
    res_relationships_hard_times_p3: 'Kuna upande mwingine: mahusiano yanayoumiza. Tabia mbaya katika ushirikiano hujumuisha unyanyasaji wa kisaikolojia na tabia ya kudhibiti, pamoja na madhara ya kimwili au kingono.',
    res_relationships_hard_times_p4: 'Ikiwa unaogopa mtu wa karibu nawe, au unaumia, tafadhali wasiliana na nambari yako ya dharura ya karibu au simu ya usaidizi ya karibu au huduma ya usaidizi. Nambari sahihi hutegemea nchi yako, na mwenzi wa Veyl ni rika lako, si mshauri aliyefunzwa. Ikiwa mambo yanahisi kuwa mazito sana kubeba, daktari au mshauri anaweza kusaidia.',
    res_relationships_who_social_connection_note: 'Ulimwenguni. Muhtasari mfupi, usio na maneno mengi wa ripoti ya WHO ya 2025 kuhusu upweke na uhusiano wa kijamii (kurasa 13).',
    res_relationships_harvard_gazette_note: 'Chanzo cha Marekani. Maswali na Majibu na mkurugenzi wa Utafiti wa Maendeleo ya Watu Wazima wa Harvard kuhusu utafiti huo unasema nini kuhusu mahusiano na afya, ikiwa ni pamoja na hatua ndogo za kila siku. Ni mahojiano, na washiriki wa awali wa utafiti huo walitoka katika jiji moja la Marekani.',
    res_relationships_who_violence_note: 'Global. Inaelezea unyanyasaji wa wapenzi wa karibu unajumuisha nini na jinsi ulivyo wa kawaida, hasa ukiathiri wanawake. Ni taarifa, si simu ya usaidizi, na inaweza kuwa vigumu kusoma.',
  },

  fr: {
    appName: 'Veyl',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    back: 'Retour',
    continue: 'Continuer',
    done: 'Terminé',
    error: 'Erreur',
    submit: 'Soumettre',
    send: 'Envoyer',
    delete: 'Supprimer',
    leave: 'Quitter',
    stay: 'Rester',
    yes: 'Oui',
    no: 'Non',
    upgrade: 'Passer à Premium',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    signOut: 'Se déconnecter',
    email: 'E-mail',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPasswordSent: 'E-mail de réinitialisation envoyé. Vérifiez votre boîte.',
    noAccount: "Pas de compte ?",
    hasAccount: 'Déjà un compte ?',
    authError: "Erreur d'authentification. Veuillez réessayer.",
    landingHero: 'La responsabilité qui fonctionne vraiment',
    landingSubtitle: 'Trouvez un partenaire anonyme partageant votre objectif. Sans pression sociale. Juste des résultats.',
    getStarted: 'Commencer — C\'est gratuit',
    howItWorks: 'Comment ça marche',
    step1Title: 'Fixez votre objectif',
    step1Desc: 'Dites-nous ce sur quoi vous travaillez. Nous vous associerons à quelqu\'un dans un parcours similaire.',
    step2Title: 'Rencontrez votre partenaire',
    step2Desc: 'Soyez jumelé avec un partenaire de responsabilité anonyme dans votre fuseau horaire.',
    step3Title: 'Restez responsable',
    step3Desc: 'Faites le point quotidiennement, partagez vos progrès et soutenez-vous mutuellement — anonymement.',
    pricingTitle: 'Tarification simple',
    freePlan: 'Gratuit',
    premiumPlan: 'Premium',
    perMonth: '/mois',
    freeFeature1: '1 Veyl actif',
    freeFeature2: '10 messages/jour',
    freeFeature3: '10 notes vocales/jour',
    freeFeature4: 'Bilans quotidiens et hebdomadaires',
    freeFeature5: 'Accès au chat de groupe',
    premiumFeature1: "Jusqu'à 3 Veyls actifs",
    premiumFeature2: 'Messages illimités',
    premiumFeature3: 'Notes vocales illimitées',
    premiumFeature4: 'Mise en correspondance prioritaire',
    faqTitle: 'Questions fréquemment posées',
    welcomeToVeyl: 'Bienvenue sur Veyl',
    chooseLanguage: 'Choisissez votre langue',
    chooseLanguageDesc: 'Sélectionnez la langue dans laquelle vous souhaitez utiliser Veyl.',
    ageVerification: "Vérification de l'âge",
    ageVerificationDesc: 'Veyl est disponible pour les utilisateurs âgés de 13 ans et plus.',
    areYouOldEnough: 'Avez-vous 13 ans ou plus ?',
    yesIAm: "✅ Oui, j'ai",
    noImNot: "❌ Non, je n'ai pas",
    mustBe13: 'Vous devez avoir 13 ans ou plus',
    mustBe13Desc: 'Veyl est uniquement disponible pour les utilisateurs de 13 ans et plus.',
    setupProfile: 'Configurons votre profil',
    stepOf: 'Étape {step} sur 4',
    whatsYourName: 'Quel est votre prénom ?',
    namePlaceholder: 'Entrez votre pseudo',
    whatsYourTimezone: 'Quel est votre fuseau horaire ?',
    selectTimezone: 'Sélectionner le fuseau horaire',
    goalCategory: 'Quelle est la catégorie de votre objectif ?',
    matchPreference: 'Avec qui voulez-vous être mis en correspondance ?',
    matchNearby: 'Correspondance proche',
    matchNearbyDesc: 'Correspondance avec des personnes dans un rayon de 4 heures de votre fuseau horaire.',
    matchAnywhere: "Correspondance n'importe où",
    matchAnywhereDesc: 'Correspondance avec n\'importe qui dans le monde, quel que soit le fuseau horaire.',
    describeGoal: 'Décrivez votre objectif spécifique',
    goalPlaceholder: "Ex. : 'Je veux perdre 15 kg' ou 'Apprendre Python'",
    communicationStyle: 'Style de communication préféré',
    textMessages: 'Messages texte',
    textMessagesDesc: 'Chattez quand c\'est pratique',
    scheduledCheckins: 'Bilans planifiés',
    scheduledCheckinsDesc: 'Approfondissements hebdomadaires',
    completingSetup: 'Recherche d\'une correspondance...',
    completeSetup: 'Terminer la configuration',
    agreeToTerms: 'En continuant, vous acceptez les',
    termsOfService: 'Conditions d\'utilisation',
    and: 'et la',
    privacyPolicy: 'Politique de confidentialité',
    fitnessHealth: 'Forme et santé',
    learningSkills: 'Apprentissage et compétences',
    businessCareer: 'Affaires et carrière',
    creativeProjects: 'Projets créatifs',
    findingMatch: 'Recherche de correspondance...',
    findingNewMatch: 'Recherche d\'une nouvelle correspondance...',
    lookingForSomeone: 'Nous cherchons quelqu\'un dans la catégorie',
    category: '',
    sharesTimezone: 'qui partage votre fuseau horaire et votre engagement.',
    autoCheck: 'Nous vérifions les correspondances automatiquement toutes les 5 secondes.',
    noMatchYet: 'Aucune correspondance trouvée — nous continuons à chercher.',
    checkNow: 'Vérifier maintenant',
    checking: 'Vérification...',
    manualChecks: '{count} vérification{plural} manuelle{plural} effectuée{plural}',
    joinCommunity: '🌐 Rejoindre la communauté en attendant',
    goToCommunity: '🌐 Aller à la communauté',
    previousPartnerNote: '🛡️ Votre partenaire précédent ne sera plus suggéré.',
    joining: 'Connexion...',
    overview: 'Aperçu',
    chat: 'Discussion',
    checkin: 'Bilan',
    group: 'Groupe',
    community: 'Communauté',
    notifications: 'Notifications',
    settings: 'Paramètres',
    yourGoal: 'Votre objectif',
    yourPartner: 'Votre partenaire',
    you: 'Vous',
    unveiled: '✨ Dévoilé',
    goalComplete: '✓ Objectif accompli',
    adjustGoal: 'Ajuster mon objectif',
    unveilButton: '✨ Dévoiler — Vous l\'avez fait !',
    goalCategory2: 'Catégorie',
    goalDescription: 'Description',
    timezone: 'Fuseau horaire',
    loadingPartner: 'Chargement des informations du partenaire...',
    waitingForMatch: 'En attente d\'une correspondance pour commencer à discuter.',
    noMessagesYet: 'Aucun message pour l\'instant. Dites bonjour à votre partenaire !',
    typeMessage: 'Tapez votre message...',
    dailyLimitReached: 'Limite quotidienne atteinte — Passez à Premium',
    unmatch: '🔓 Dissocier',
    report: '🚩 Signaler',
    unmatchWarning: '⚠️ La dissociation supprimera tout l\'historique de vos discussions. Cette action est irréversible.',
    yesUnmatch: 'Oui, dissocier',
    unmatching: 'Dissociation...',
    unmatchMessage: 'Your partner has ended this Veyl session. You\'ve been returned to matching.',
    deleteMessage: '🗑 Supprimer',
    deleting: 'Suppression...',
    checkIn: 'Bilan',
    submitDaily: 'Soumettre le bilan quotidien',
    submitWeekly: 'Soumettre le bilan hebdomadaire',
    submitting: 'Envoi...',
    checkinSubmitted: 'Bilan soumis !',
    viewHistory: 'Voir mon historique',
    notificationsTitle: 'Notifications',
    clearAll: 'Tout effacer',
    noNotifications: 'Aucune notification pour l\'instant.',
    settingsTitle: 'Paramètres',
    settingsDesc: 'Personnalisez votre identité anonyme.',
    saveAvatar: 'Enregistrer l\'avatar',
    appearance: 'Apparence',
    lightMode: '☀️ Clair',
    darkMode: '🌙 Sombre',
    changeNickname: 'Changer de pseudo',
    saveNickname: 'Enregistrer le pseudo',
    deleteAccount: 'Supprimer le compte',
    deleteAccountDesc: 'Supprime définitivement votre compte et toutes les données associées.',
    languageLabel: 'Langue',
    languageDesc: 'Choisissez votre langue préférée.',
    signOut: 'Se déconnecter',
    updating: 'Mise à jour...',
    unveil: 'Dévoiler',
    clearing: 'Effacement...',
    buildTrust: 'Construire la confiance',
    unveilIdentity: "Révélez votre identité quand (ou si) vous êtes prêt",
    actuallyAchieve: 'Atteignez-le vraiment',
    makeRealProgress: 'Faites de vrais progrès sans la performance',
    faq1q: "Et si mon partenaire et moi n'accrochons pas ?",
    faq1a: "Rematch facile. Aucune question posée. Nous préférons que vous trouviez la bonne personne plutôt que de forcer un partenariat qui ne fonctionne pas.",
    faq2q: "Dois-je me dévoiler à un moment donné ?",
    faq2a: "Non. Certains partenariats restent anonymes indéfiniment. Certains se dévoilent après une semaine. C'est à vous de décider.",
    faq3q: "Et si mon partenaire me ghoste ?",
    faq3a: "Les utilisateurs Premium obtiennent un rematch instantané. Les utilisateurs gratuits sont rematchés dans les 48 heures. Nous signalons également les ghosters chroniques dans notre système.",
    faq4q: "Pourquoi jamais de photos de profil ?",
    faq4a: "Parce qu'au moment où vous ajoutez des photos, il s'agit de gérer la perception. Nous avons testé cela. L'anonymat maintient l'accent sur le travail.",
    unmatchMessage: 'Votre partenaire a mis fin à cette session Veyl. Vous avez été remis en correspondance.',
    communityMsgsWarning: '{count} messages communautaires restants aujourd\'hui.',
    communityDailyLimit: 'Vous avez atteint votre limite quotidienne de messages communautaires ({limit}/jour). Passez à Premium pour un nombre illimité !',
    groupDailyLimit: 'Vous avez atteint votre limite quotidienne de messages de groupe ({limit}/jour). Passez à Premium pour une messagerie illimitée !',
    dailyVoiceNoteLimit: 'Limite quotidienne de notes vocales atteinte. Passez à Premium pour des notes illimitées.',
    matchRequestLimit: 'Vous ne pouvez avoir que 3 demandes de correspondance en attente à la fois.',
    matchRequestSent: 'Demande de correspondance envoyée avec succès !',
    matchRequestDuplicate: 'Vous avez déjà envoyé une demande à cette personne.',
    matchRequestError: 'Erreur lors de l\'envoi de la demande de correspondance. Veuillez réessayer.',
    matchAcceptError: 'Erreur lors de l\'acceptation de la demande de correspondance.',
    matchRequestSentAlready: 'Vous avez déjà envoyé une demande à cette personne.',
    groupVoiceLimit: 'Limite quotidienne de notes vocales atteinte.',
    backToChat: '← Retour au chat',
    requestsBtn: '🤝 Demandes',
    leaveBtn: 'Quitter',
    openToAll: 'Ouvert à tous · Anonyme',
    msgsLeft: '{count} msgs restants',
    noCommunityMessages: 'Aucun message pour l\'instant. Dites bonjour à la communauté !',
    saySomething: 'Dites quelque chose à la communauté...',
    requestMatch: '🤝 Demander une correspondance',
    requestSending: 'Envoi...',
    incoming: 'Entrant',
    sent: 'Envoyé',
    noIncoming: 'Aucune demande entrante.',
    noPending: 'Aucune demande envoyée en attente.',
    requestToAnonymous: 'Demande à un utilisateur anonyme',
    matchRequests: 'Demandes de correspondance',
    leaveCommunity: 'Quitter cette communauté ?',
    communityLeaveDesc: 'Vous pouvez revenir à tout moment depuis la page d\'attente.',
    veylCommunity: 'Communauté Veyl',
    communityDesc: 'Rejoignez d\'autres personnes travaillant sur la même catégorie d\'objectif en attendant une correspondance. Discutez, partagez votre motivation et demandez même une correspondance directe avec quelqu\'un avec qui vous sympathisez.',
    communityJoinNote: 'Rejoignez la communauté depuis la page d\'attente pendant la recherche d\'une correspondance.',
    unveil: 'Dévoiler',
    clearing: 'Effacement...',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Sarcelle',
    avatar_purple: 'Violet',
    avatar_navy: 'Marine',
    avatar_slate: 'Ardoise',
    avatar_coral: 'Corail',
    avatar_gold: 'Or',
    avatar_moss: 'Mousse',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'Dévoilé',
    nicknameRequired: 'Le pseudo est requis',
    nicknameTooShort: 'Le pseudo doit faire au moins 2 caractères',
    nicknameTooLong: 'Le pseudo ne doit pas dépasser 20 caractères',
    errorSavingNickname: 'Erreur lors de l\'enregistrement du pseudo',
    errorSavingAvatar: 'Erreur lors de l\'enregistrement de l\'avatar',
    errorDeletingAccount: 'Erreur lors de la suppression du compte',
    deleteMyAccountButton: 'Supprimer mon compte',
    goalsAchievedTitle: 'Objectifs Atteints',
    goalsPrivate: 'Privé — visible uniquement par vous.',
    goalsCompletedCount: '{count} objectifs atteints',
    keepAnonymous: 'Restez anonyme. N\'utilisez pas votre vrai nom.',
    currentNicknameIs: 'Votre pseudo actuel est',
    justNow: 'À l\'instant',
    minsAgo: 'Il y a {count}m',
    hoursAgo: 'Il y a {count}h',
    daysAgo: 'Il y a {count}j',
    all: 'Tous',
    leaving: 'Départ...',
    matchRequestSentAlready: 'Vous avez déjà envoyé une demande à cette personne.',
    group: 'Groupe',
    community: 'Communauté',
    notifications: 'Notifications',
    settings: 'Paramètres',
    notifMatchFound: 'Correspondance trouvée',
    notifGoalAchieved: 'Objectif atteint',
    notifSupport: 'Messages de soutien',
    notifUnmatched: 'Alertes de dissociation',
    notifMatchRequest: 'Demandes de correspondance',
    notificationPrefs: 'Préférences de notification',
    notificationPrefsDesc: 'Mettez en sourdine des types de notifications spécifiques individuellement.',
    muted: 'En sourdine',
    active: 'Actif',
    all: 'Tous',
    justNow: 'À l\'instant',
    minsAgo: 'Il y a {count}m',
    hoursAgo: 'Il y a {count}h',
    daysAgo: 'Il y a {count}j',
    leaving: 'Départ...',
    myHistory: '📋 Mon historique',
    partnersProgress: '👤 Progrès de {name}',
    myCheckinHistory: 'Mon historique de bilans',
    checkinsForVeyl: '{count} bilan{plural} pour ce Veyl',
    noCheckinsYet: 'Pas encore de bilans. Commencez le premier !',
    newCheckinBtn: 'Nouveau bilan',
    partnerNoCheckins: '{name} n\'a pas encore fait de bilan.',
    dailyNotesPrivate: 'Les notes quotidiennes sont privées',
    goalAchievedMarked: '🎉 Objectif marqué comme atteint',
    goalAchievedNote: '🎉 Votre objectif est marqué comme atteint ! Allez sur Aperçu pour le dévoiler.',
    veylComplete: '✓ Ce Veyl est terminé. Les bilans sont en lecture seule.',
    goalAlreadyAchieved: '🎉 Vous avez marqué votre objectif comme atteint ! Allez sur Aperçu pour le dévoiler.',
    didYouWork: 'Avez-vous travaillé sur votre objectif aujourd\'hui ?',
    howDidWeekGo: 'Comment s\'est passée cette semaine avec votre objectif ?',
    whatGotInWay: 'Qu\'est-ce qui a fait obstacle ? (Optionnel)',
    honestNote: 'Soyez honnête. Votre partenaire est là pour vous soutenir, pas pour vous juger.',
    whatDidYouLearn: 'Qu\'avez-vous appris sur vous-même cette semaine ?',
    insightsPlaceholder: 'Quelles leçons avez-vous tirées ?',
    whatPatterns: 'Quel schéma remarquez-vous ?',
    patternsPlaceholder: 'Des thèmes ou obstacles récurrents ?',
    whatChange: 'Qu\'est-ce qui doit changer pour la semaine prochaine ?',
    changePlaceholder: 'Que ferez-vous différemment ?',
    goalAchievedQuestion: '🏆 Avez-vous atteint votre objectif global ?',
    yesDidIt: '🎉 Oui, j\'ai réussi !',
    notYetBtn: 'Pas encore',
    didIt: '✅ Fait',
    didSome: '😐 Un peu fait',
    didntDoIt: '❌ Pas fait',
    metCommitment: '✅ Engagement tenu',
    partialProgress: '😐 Progrès partiels',
    noProgress: '❌ Aucun progrès',
    rethinkingGoal: '🤔 Reconsidération de l\'objectif',
    yesLabel: '✅ Oui',
    aLittle: '😐 Un peu',
    noLabel: '❌ Non',
    madeProgress: 'J\'ai progressé aujourd\'hui',
    didSomething: 'J\'ai fait quelque chose, pas tout',
    didntWork: 'Je n\'y ai pas travaillé aujourd\'hui',
    metWeekly: 'J\'ai tenu mon engagement hebdomadaire',
    madePartial: 'J\'ai fait des progrès partiels',
    didntMake: 'Je n\'ai pas progressé',
    needToAdjust: 'Je dois ajuster mon approche',
    learnedLabel: 'Appris : ',
    patternLabel: 'Schéma : ',
    nextWeekLabel: 'Semaine prochaine : ',
    joinGroup: 'Rejoindre un groupe',
    joinGroupDesc: 'Les groupes rassemblent jusqu\'à 5 personnes travaillant sur des objectifs similaires. Anonyme, solidaire, sans pression.',
    whatToExpect: 'CE À QUOI S\'ATTENDRE',
    expectAnonymous: 'Tout le monde reste anonyme — mêmes avatars en silhouette',
    expectMatched: 'Mis en correspondance par catégorie d\'objectif pour un soutien pertinent',
    expectMembers: 'Jusqu\'à 5 membres par groupe',
    expectChat: 'Chat de groupe — 20 messages et 5 notes vocales/jour gratuits · Illimité avec Premium',
    findOrCreate: 'Trouver ou créer un groupe',
    findingGroup: 'Recherche de votre groupe...',
    oneGroupNote: 'Vous ne pouvez faire partie que d\'un groupe à la fois. Les utilisateurs gratuits et Premium ont tous deux accès aux groupes.',
    groupCreated: 'Groupe créé !',
    groupJoined: 'Groupe rejoint !',
    groupCreatedDesc: 'Vous avez créé un nouveau groupe {category}. D\'autres vont bientôt rejoindre.',
    groupJoinedDesc: 'Vous avez rejoint un groupe {category} existant. Dites bonjour !',
    switchToGroup: 'Passez à l\'onglet Groupe dans votre tableau de bord pour commencer à discuter.',
    groupMembers: 'Membres du groupe',
    backToChat: '← Retour au chat',
    creator: '★ Créateur',
    joined: 'A rejoint',
    leaveGroup: 'Quitter le groupe',
    leaveGroupTitle: 'Quitter ce groupe ?',
    leaveGroupDesc: 'Vous perdrez l\'accès au chat de groupe et pourrez rejoindre un nouveau groupe à tout moment.',
    membersBtn: '👥 Membres',
    noGroupMessages: 'Aucun message pour l\'instant. Soyez le premier à dire bonjour !',
    messageGroup: 'Envoyer un message à votre groupe...',
    groupDailyLimit: 'Vous avez atteint votre limite quotidienne de messages de groupe ({limit}/jour). Passez à Premium pour des messages illimités !',
    groupVoiceLimit: 'Limite quotidienne de notes vocales atteinte.',
    veylCommunity: 'Communauté Veyl',
    communityDesc: 'Rejoignez d\'autres personnes travaillant sur la même catégorie d\'objectif en attendant une correspondance.',
    communityJoinNote: 'Rejoignez la communauté depuis la page d\'attente pendant la recherche d\'une correspondance.',
    leaveCommunity: 'Quitter cette communauté ?',
    communityLeaveDesc: 'Vous pouvez revenir à tout moment depuis la page d\'attente.',
    matchRequests: 'Demandes de correspondance',
    incoming: 'Entrantes',
    sent: 'Envoyées',
    noIncoming: 'Aucune demande entrante.',
    noPending: 'Aucune demande envoyée en attente.',
    requestToAnonymous: 'Demande à un utilisateur anonyme',
    pending: 'En attente',
    decline: 'Refuser',
    accept: '✅ Accepter',
    requestWaiting: '🤝 {count} demande{plural} de correspondance vous attend{plural}',
    view: 'Voir',
    requestsBtn: '🤝 Demandes',
    leaveBtn: 'Quitter',
    openToAll: 'Ouvert à tous · Anonyme',
    msgsLeft: '{count} msgs restants',
    noCommunityMessages: 'Aucun message pour l\'instant. Dites bonjour à la communauté !',
    saySomething: 'Dites quelque chose à la communauté...',
    requestMatch: '🤝 Demander une correspondance',
    requestSending: 'Envoi...',
    communityMsgsWarning: '{count} messages communautaires restants aujourd\'hui.',
    communityDailyLimit: 'Vous avez atteint votre limite quotidienne de messages communautaires ({limit}/jour). Passez à Premium pour illimité !',
    matchRequestLimit: 'Vous ne pouvez avoir que 3 demandes en attente à la fois.',
    matchRequestSent: 'Demande de correspondance envoyée avec succès !',
    matchRequestDuplicate: 'Vous avez déjà envoyé une demande à cette personne.',
    matchRequestError: 'Erreur lors de l\'envoi de la demande. Veuillez réessayer.',
    matchAcceptError: 'Erreur lors de l\'acceptation de la demande.',
    matchRequestSentAlready: 'Vous avez déjà envoyé une demande à cette personne.',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Sarcelle',
    avatar_purple: 'Violet',
    avatar_navy: 'Marine',
    avatar_slate: 'Ardoise',
    avatar_coral: 'Corail',
    avatar_gold: 'Or',
    avatar_moss: 'Mousse',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'Dévoilé',
    activeLabel: 'Actif',
    seekingLabel: 'En recherche',
    completeLabel: 'Terminé',
    upgradeForMore: '✨ Passez à Premium pour plus de Veyls',
    newVeyl: '+ Nouveau Veyl',
    newVeylTitle: 'Démarrer un nouveau Veyl',
    goalCategoryLabel: 'Catégorie d\'objectif',
    goalDescriptionLabel: 'Description de l\'objectif',
    startVeyl: 'Démarrer un nouveau Veyl',
    starting: 'Démarrage...',
    unveil: 'Dévoiler',
    clearing: 'Effacement...',
    nicknameRequired: 'Le pseudo est requis',
    nicknameTooShort: 'Le pseudo doit faire au moins 2 caractères',
    nicknameTooLong: 'Le pseudo ne doit pas dépasser 20 caractères',
    errorSavingNickname: 'Erreur lors de la sauvegarde du pseudo',
    errorSavingAvatar: 'Erreur lors de la sauvegarde de l\'avatar',
    errorDeletingAccount: 'Erreur lors de la suppression du compte',
    deleteMyAccountButton: 'Supprimer mon compte',
    goalsAchievedTitle: 'Objectifs atteints',
    goalsPrivate: 'Privé — visible uniquement par vous.',
    goalsCompletedCount: '{count} objectifs atteints',
    keepAnonymous: 'Restez anonyme. N\'utilisez pas votre vrai nom.',
    currentNicknameIs: 'Votre pseudo actuel est',
    unveiledLocked: '✨ Dévoilé — avatar verrouillé',
    howOthersSee: 'C\'est ainsi que les autres vous voient',
    unveiledNote: 'Vous vous êtes dévoilé sur ce Veyl. Démarrez un nouveau Veyl pour choisir un nouvel avatar.',
    active2: '✓ Actif',
    goalsAchieved: 'Objectifs atteints',
    goalsAchievedDesc: 'Privé — visible uniquement par vous.',
    goalCompleted: 'objectif atteint',
    goalsCompleted: 'objectifs atteints',
    contactSupport: 'Contacter le support',
    deleteWarning: '⚠️ Cela supprimera tout définitivement. Tapez SUPPRIMER ci-dessous pour confirmer.',
    typeDelete: 'Tapez SUPPRIMER pour confirmer',
    confirmDelete: 'Confirmer la suppression',
    deleting2: 'Suppression...',
    messagesLeft: '{count} messages · {voiceCount} notes vocales restants aujourd\'hui',
    premiumUnlimited: '✨ Premium — Messages et notes vocales illimités',
    messagesLeftWarning: '{count} messages restants aujourd\'hui.',
    forUnlimited: 'pour des messages illimités.',
    voiceNotesLeft: '{count} note{plural} vocale{plural} restante{plural} aujourd\'hui',
    dailyLimitReachedVoice: 'Limite quotidienne de notes vocales atteinte.',
    dailyVoiceNoteLimit: 'Limite quotidienne de notes vocales atteinte. Passez à Premium pour des notes illimitées.',
    recording: 'Enregistrement...',
    deeper: 'Plus grave',
    neutral: 'Neutre',
    higher: 'Plus aigu',
    applyingModulation: '⚙️ Application de la modulation...',
    preview: '▶ Aperçu',
    pause: '⏸ Pause',
    discard: 'Supprimer',
    recordingTooLarge: 'Enregistrement trop volumineux. Essayez un message plus court.',
    failedToSend: 'Échec de l\'envoi. Veuillez réessayer.',
    micDenied: 'Accès au microphone refusé.',
    unmatchMessage: 'Votre partenaire a mis fin à cette session Veyl. Vous avez été remis en recherche.',
    appearanceDesc: 'Choisissez comment Veyl vous apparaît.',
    newNickname: 'Nouveau pseudo',
    nicknamePlaceholder: 'ex. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Choisissez votre avatar',
    notificationsTitle: 'Notifications',
    notificationsCount: '{total} au total · {unread} non lues',
    progressOf: 'Progrès de {name}',
    fitnessHealth: 'Forme & Santé',
    learningSkills: 'Apprentissage & Compétences',
    businessCareer: 'Business & Carrière',
    creativeProjects: 'Projets Créatifs',
    progressOf: 'Progrès de {name}',
    dailyCheckin: 'Bilan quotidien',
    weeklyCheckin: 'Bilan hebdomadaire',
    dailyCheckinDesc: 'Mise à jour rapide : Avez-vous travaillé sur votre objectif aujourd\'hui ?',
    weeklyCheckinDesc: 'Réflexion profonde : Comment s\'est passée cette semaine dans l\'ensemble ?',
    submitDaily: 'Soumettre le bilan quotidien',
    submitWeekly: 'Soumettre le bilan hebdomadaire',
    submitting: 'Envoi...',
    checkinSubmitted: 'Bilan soumis !',
    checkinSubmittedDesc: 'Bravo pour votre responsabilité. {name} verra votre mise à jour.',
    viewHistory: 'Voir mon historique',
    newCheckin: '📝 Nouveau bilan',
    myHistory: '📋 Mon historique',
    partnersProgress: '👤 Progrès de {name}',
    myCheckinHistory: 'Mon historique de bilans',
    checkinsForVeyl: '{count} bilan{plural} pour ce Veyl',
    noCheckinsYet: 'Pas encore de bilans. Commencez le premier !',
    newCheckinBtn: 'Nouveau bilan',
    partnerNoCheckins: '{name} n\'a pas encore fait de bilan.',
    dailyNotesPrivate: 'Les notes quotidiennes sont privées',
    goalAchievedMarked: '🎉 Objectif marqué comme atteint',
    goalAchievedNote: '🎉 Votre objectif est marqué comme atteint ! Allez sur Aperçu pour le dévoiler.',
    veylComplete: '✓ Ce Veyl est terminé. Les bilans sont en lecture seule.',
    goalAlreadyAchieved: '🎉 Vous avez marqué votre objectif comme atteint ! Allez sur Aperçu pour le dévoiler.',
    didYouWork: 'Avez-vous travaillé sur votre objectif aujourd\'hui ?',
    howDidWeekGo: 'Comment s\'est passée cette semaine avec votre objectif ?',
    whatGotInWay: 'Qu\'est-ce qui a fait obstacle ? (Optionnel)',
    honestNote: 'Soyez honnête. Votre partenaire est là pour vous soutenir, pas pour vous juger.',
    whatDidYouLearn: 'Qu\'avez-vous appris sur vous-même cette semaine ?',
    insightsPlaceholder: 'Quelles leçons avez-vous tirées ?',
    whatPatterns: 'Quel schéma remarquez-vous ?',
    patternsPlaceholder: 'Des thèmes ou obstacles récurrents ?',
    whatChange: 'Qu\'est-ce qui doit changer pour la semaine prochaine ?',
    changePlaceholder: 'Que ferez-vous différemment ?',
    goalAchievedQuestion: '🏆 Avez-vous atteint votre objectif global ?',
    yesDidIt: '🎉 Oui, j\'ai réussi !',
    notYetBtn: 'Pas encore',
    didIt: '✅ Fait',
    didSome: '😐 Un peu fait',
    didntDoIt: '❌ Pas fait',
    metCommitment: '✅ Engagement tenu',
    madePartial: '😐 Progrès partiels',
    didntMake: '❌ Aucun progrès',
    needToAdjust: '🤔 Je dois ajuster mon approche',
    yesLabel: '✅ Oui',
    aLittle: '😐 Un peu',
    noLabel: '❌ Non',
    madeProgress: 'J\'ai progressé aujourd\'hui',
    didSomething: 'J\'ai fait quelque chose, pas tout',
    didntWork: 'Je n\'y ai pas travaillé aujourd\'hui',
    metWeekly: 'J\'ai tenu mon engagement hebdomadaire',
    learnedLabel: 'Appris : ',
    patternLabel: 'Schéma : ',
    nextWeekLabel: 'Semaine prochaine : ',
    problemTitle: 'Les réseaux sociaux ont tué la responsabilité',
    problem1: "Vous avez peur d'admettre quand vous avez du mal",
    problem2: "Vous cachez vos échecs au lieu d'en tirer des leçons",
    problem3: "Vous ghostez vos partenaires quand vous échouez",
    veylIsDifferent: 'Veyl est différent.',
    popular: 'POPULAIRE',
    sixMonthDeal: 'ou 20$ pour 6 mois (3,33$/mois)',
    getStartedPremium: 'Commencer',
    buildTrust: 'Construire la confiance',
    unveilIdentity: 'Révélez votre identité quand (ou si) vous êtes prêt',
    actuallyAchieve: 'Atteignez-le vraiment',
    makeRealProgress: 'Faites de vrais progrès sans la performance',
    faq1q: 'Et si mon partenaire et moi n\'accrochons pas ?',
    faq1a: 'Rematch facile. Aucune question posée. Nous préférons que vous trouviez la bonne personne plutôt que de forcer un partenariat qui ne fonctionne pas.',
    faq2q: 'Dois-je me dévoiler à un moment donné ?',
    faq2a: 'Non. Certains partenariats restent anonymes indéfiniment. Certains se dévoilent après une semaine. C\'est entièrement à vous de décider.',
    faq3q: 'Et si mon partenaire me ghoste ?',
    faq3a: 'Les utilisateurs Premium obtiennent un rematch instantané. Les utilisateurs gratuits sont rematchés dans les 48 heures. Nous signalons également les ghosters chroniques.',
    faq4q: 'Pourquoi jamais de photos de profil ?',
    faq4a: 'Parce qu\'au moment où vous ajoutez des photos, il s\'agit de gérer la perception. Nous avons testé cela. L\'anonymat maintient l\'accent sur le travail.',
    legalEnglishOnly: 'Ce document est uniquement disponible en anglais. Pour toute question, veuillez contacter le support ou utiliser la fonction de traduction de votre navigateur.',
    ctaTitle: "Prêt à vraiment atteindre vos objectifs?",
    ctaSubtitle: "Rejoignez Veyl et trouvez un partenaire de responsabilité aujourd'hui. C'est gratuit.",
    statAnonymous: "Anonyme",
    statLanguages: "Langues",
    statToStart: "Pour commencer",
    authTagline: "Responsabilité anonyme. Vrais résultats.",
    authPricing: "Gratuit pour commencer · Premium à partir de 5$/mois",
    taglineHonest: "Honnête",
    taglineEffective: "Efficace",
    foreverLabel: "/pour toujours",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Passer à Premium",
    premiumActiveDesc: "Vous avez un accès illimité à toutes les fonctionnalités de Veyl.",
    upgradeDesc: "Supprimez toutes les limites et profitez de l'expérience Veyl complète.",
    billedMonthly: "Facturé mensuellement",
    bestValue: "MEILLEURE VALEUR",
    perSixMonths: "3,33$/mois",
    unlimitedMessages: "Messages illimités",
    unlimitedVoice: "Notes vocales illimitées",
    unlimitedGroup: "Groupe illimité",
    unlimitedCommunity: "Communauté illimitée",
    was10day: "était 10/jour",
    was5day: "était 5/jour",
    was20day: "était 20/jour",
    was30day: "était 30/jour",
    sixMonthPlan: "Plan 6 mois",
    monthlyPlan: "Plan mensuel",
    modulationFailed: "La modulation a échoué — utilisation de la voix originale",
    monthly: "Mensuel",
    sixMonths: "6 Mois",
    savePercent: "Économisez {{percent}}%",
    pricePerMonth: "${{price}} / mois",
    priceTotal: "${{price}} total",
    unlimitedMessages: "Messages illimités",
    unlimitedVoiceNotes: "Notes vocales illimitées",
    unlimitedGroupMessages: "Messages de groupe illimités",
    unlimitedCommunityMessages: "Messages communautaires illimités",
    upgrade: "Améliorer",
    forUnlimited: "pour illimité",
    messagesLeftWarning: "{{count}} messages restants aujourd'hui",
    recordVoiceNote: "Enregistrer une note vocale",
    uploading: "Téléchargement",
    maxDuration: "{{seconds}}s max",
    upgradeToPremium: "Passer à Premium",
    dailyMessageLimitReached: "Vous avez atteint votre limite de messages quotidienne.",
    dailyVoiceLimitReached: "Vous avez atteint votre limite de notes vocales quotidienne.",
    dailyGroupMessageLimitReached: "Vous avez atteint votre limite de messages de groupe quotidienne.",
    dailyGroupVoiceLimitReached: "Vous avez atteint votre limite de notes vocales de groupe quotidienne.",
    unlockUnlimited: "Débloquez l'accès illimité à toutes les fonctionnalités.",
    maybeLater: "Peut-être plus tard",
    premiumUnlimited: "Illimité",
    premium: "Premium",
    msg: "msg",
    msgs: "msgs",
    newMessageNotification: "{{name}} vous a envoyé un message 💬",
    newGroupMessageNotification: "{{name}} a envoyé un message dans votre groupe 👥",
    someone: "quelqu'un",
    failedToLoad: "Échec du chargement",
    groupMessagesLeftWarning: "{{count}} messages restants aujourd'hui",
    howOldAreYou: 'Quel âge avez-vous?',
    minorGroupNote: "Vous serez jumelé(e) avec des utilisateurs de votre âge (13–17 ans).",
    adultGroupNote: "Vous serez jumelé(e) avec d'autres adultes (18+).",
    enterYourAge: 'Entrez votre âge',
    getStarted:        'Commencer',
    howItWorks:        'Comment ça marche',
    statAnonymous:     'Anonyme',
    statLanguages:     'Langues',
    statToStart:       'Pour commencer',
    taglineHonest:     'Honnête',
    taglineEffective:  'Efficace',
    landingHero:       'La responsabilité sans la mise en scène.',
    landingSubtitle:   'Trouvez un partenaire anonyme qui partage vos objectifs. Sans abonnés. Sans pression — juste des progrès honnêtes.',
    problemTitle:      'La responsabilité est brisée.',
    problem1:          'Les réseaux sociaux transforment le développement personnel en spectacle. Vous publiez vos objectifs pour des likes, pas pour progresser.',
    problem2:          'Les amis et la famille apportent du jugement ou de l\'indifférence. L\'honnêteté réelle devient impossible.',
    problem3:          'Les applis de responsabilité ressemblent à des outils de suivi — des tableaux stériles qui ignorent complètement l\'humain.',
    veylIsDifferent:   'Veyl est différent.',
    step1Title:        'Créez votre profil',
    step1Desc:         'Choisissez un pseudonyme, une catégorie d\'objectif et vos préférences de communication. Votre identité réelle reste la vôtre.',
    step2Title:        'Soyez mis en relation',
    step2Desc:         'Veyl vous trouve un partenaire qui partage votre type d\'objectif et votre groupe d\'âge. Instantané — sans faire défiler.',
    step3Title:        'Commencez à échanger',
    step3Desc:         'Discutez ou envoyez des notes vocales. Faites le point quotidiennement ou hebdomadairement. Votre partenaire vous responsabilise — et vous l\'êtes pour lui.',
    buildTrust:        'Construire la confiance',
    unveilIdentity:    'Notez vos victoires, marquez vos objectifs atteints. Quand la confiance est là, vous pouvez choisir de vous dévoiler — ou non.',
    actuallyAchieve:   'Vraiment réussir',
    makeRealProgress:  'Des progrès réels avec un humain réel. Pas de gamification. Juste vous, votre partenaire, et votre objectif.',
    pricingTitle:      'Commencez gratuitement. Allez plus loin quand vous êtes prêt.',
    freePlan:          'Gratuit',
    foreverLabel:      '/ pour toujours',
    freeFeature1:      '1 partenaire de responsabilité',
    freeFeature2:      '10 messages par jour',
    freeFeature3: '10 messages vocaux par jour',
    freeFeature5:      'Salons de groupe et communauté',
    popular:           'Le plus populaire',
    premiumPlan:       'Premium',
    perMonth:          '/ mois',
    sixMonthDeal: 'Abonnement de 6 mois à 20 $ — économisez 33 %',
    premiumFeature1:   'Messagerie illimitée',
    premiumFeature2:   'Notes vocales illimitées',
    premiumFeature3:   'Dévoilement du partenaire',
    premiumFeature4:   'Mise en relation prioritaire',
    getStartedPremium: 'Démarrer en premium',
    faqTitle:          'Questions fréquentes.',
    faq1q: 'Veyl est-il vraiment anonyme ?',
    faq1a: 'Oui. Vous vous inscrivez avec un pseudonyme. Pas de vrai nom, pas de photo, rien d\'identifiable. Votre partenaire ne sait que ce que vous choisissez de partager.',
    faq2q: 'Comment fonctionne la mise en relation ?',
    faq2a: 'Veyl vous associe à quelqu\'un dans la même catégorie d\'objectif et le même groupe d\'âge. Cela prend généralement moins de deux minutes.',
    faq3q: 'Et si je ne m\'entends pas avec mon partenaire ?',
    faq3a: 'Vous pouvez signaler ou bloquer votre partenaire à tout moment, sans question. Trouvez quelqu\'un de mieux — c\'est intégré.',
    faq4q: 'Est-ce sûr pour les mineurs ?',
    faq4a: 'Absolument. Les utilisateurs de 13 à 17 ans ne sont jamais mis en relation qu\'avec d\'autres du même groupe d\'âge. Cela est appliqué au niveau du système.',
    ctaTitle:    'Votre partenaire vous attend déjà.',
    ctaSubtitle: 'Rejoignez Veyl gratuitement. Aucun profil social requis. Juste vous, votre objectif, et quelqu\'un qui comprend.',
    privacyPolicy:  'Politique de confidentialité',
    termsOfService: 'Conditions d\'utilisation',
    refundPolicy:   'Politique de remboursement',
    featuresTitle: "Tout ce dont vous avez besoin. Rien de plus.",
    feature1Title: "Anonymat total",
    feature1Desc: "Vous choisissez un pseudonyme. Votre vrai nom, votre photo, votre identité — jamais partagés, sauf si vous décidez de les révéler.",
    feature2Title: "Notes vocales",
    feature2Desc: "Parfois, écrire ne suffit pas. Enregistrez et envoyez des notes vocales directement dans l'application.",
    feature3Title: "Mise en relation sécurisée par âge",
    feature3Desc: "Les mineurs (13–17 ans) ne sont mis en relation qu'avec d'autres mineurs. Les adultes avec des adultes. Sans exception — c'est intégré au système.",
    feature4Title: "13 langues",
    feature4Desc: "Anglais, swahili, français, espagnol, portugais, allemand, italien, hindi, indonésien, chinois, japonais, coréen, haoussa.",
    feature5Title: "Points quotidiens",
    feature5Desc: "Des points réguliers maintiennent la dynamique. Notez vos progrès et célébrez vos réussites avec votre partenaire.",
    feature6Title: "Groupes et communauté",
    feature6Desc: "Rejoignez des discussions de groupe par objectif et des salons communautaires par langue.",
    goalsEyebrow: "Pour des objectifs réels",
    goalsTitle: "Quel que soit votre objectif.",
    goalsSub: "Veyl est fait pour toute personne ayant un objectif réel et personne à qui en parler honnêtement.",
    goalFitness: "Fitness et Santé",
    goalLearning: "Apprentissage et Compétences",
    goalBusiness: "Entreprise et Carrière",
    goalCreative: "Projets Créatifs",
    moreComingSoon: "Plus à venir prochainement",
    safeTitle: "La sécurité n'est pas une fonctionnalité. C'est le fondement.",
    safe1Title: "Séparation par âge",
    safe1Desc: "Les mineurs et les adultes ne sont jamais mélangés. L'âge est vérifié à l'inscription et verrouillé.",
    safe2Title: "Signaler et bloquer",
    safe2Desc: "Tout utilisateur peut signaler ou bloquer instantanément. Sans aucune question.",
    safe3Title: "Aucune vente de données",
    safe3Desc: "Vos objectifs, messages et identité vous appartiennent. Point final.",
    safe4Title: "Pseudonymes uniquement",
    safe4Desc: "Les vrais noms ne sont jamais requis. Vous décidez si et quand vous révéler.",
    refundPolicy: "Politique de Remboursement",
    heroLine1: 'Responsabilité',            
    heroLine2: 'sans la mise en scène',
    mustBe18: 'Vous devez avoir 18 ans ou plus pour utiliser Veyl',
    mustBe18Desc: "Veyl est une plateforme réservée aux 18 ans et plus. Nous sommes désolés, mais vous ne remplissez pas la condition d'âge minimum pour créer un compte.",
    ageAttestationLabel: "Je confirme avoir 18 ans ou plus.",
    ageMisrepresentationNote: "Toute fausse déclaration concernant votre âge constitue une violation de nos Conditions d'utilisation et peut entraîner la suppression de votre compte.",
    feature3Title: 'Vérifié 18 ans et plus uniquement',
    feature3Desc: "Chaque membre confirme avoir 18 ans ou plus avant de rejoindre la plateforme. Aucun mineur, sans exception.",
    faq4q: 'Veyl est-il accessible aux mineurs ?',
    faq4a: "Non. Veyl est une plateforme réservée aux 18 ans et plus. Chaque utilisateur confirme son âge lors de l'inscription, et les comptes ayant fourni une fausse déclaration d'âge peuvent être supprimés.",
    safe1Title: 'Réservé aux adultes',
    safe1Desc: "Veyl est conçu exclusivement pour les personnes de 18 ans et plus. Toute personne de moins de 18 ans tentant d'utiliser Veyl fait une fausse déclaration d'âge, ce qui constitue une violation de nos Conditions d'utilisation.",
    ageVerificationDesc: 'Veyl est disponible pour les utilisateurs âgés de 18 ans et plus.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Ajustez votre objectif',
    adjustGoalDesc: 'Vous pouvez changer de direction. Votre partenaire en sera informé.',
    newGoalDescription: 'Description du nouvel objectif',
    newGoalPlaceholder: 'Quel est votre nouvel objectif ou votre objectif modifié ?',
    updateGoal: 'Objectif de mise à jour',
    goalUpdated: 'Objectif atteint ! Votre partenaire a été informé.',
    readyToUnveil: 'Prêt à dévoiler ?',
    unveilDesc: 'Le dévoilement de ce Veyl marque son achèvement. Votre partenaire en sera informé. Cette action est irréversible.',
    yourNewAvatar: 'Votre nouvel avatar',
    notYet: 'Pas encore',
    unveiling: 'Dévoilement...',
    sending: 'Envoi...',
    checkInDesc: 'Les bilans quotidiens permettent de suivre les progrès. Les bilans hebdomadaires permettent une réflexion plus approfondie.',
    dismiss: '✕',
    saving: 'Économie...',
    saved: '✓ Enregistré !',
    lightModeDesc: 'Propre et lumineux',
    darkModeDesc: 'Agréable à regarder',
    currentNickname: 'Votre surnom actuel est',
    anonymousWarning: 'Restez anonyme. N\'utilisez pas votre vrai nom.',
    nicknameUpdated: '✓ Surnom mis à jour !',
    deleteMyAccount: 'Supprimer mon compte',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Voici Rasa',
    rasaIntroDesc: 'Rasa est un espace privé de réflexion, rien que pour vous, indépendamment de votre partenaire de responsabilisation. Il ne part d\'aucun préjugé sur vous ou sur le monde ; il s\'inspire uniquement de ce que vous choisissez de partager et est conçu pour susciter des questions plutôt que pour vous donner des réponses.',
    rasaIntroNotTherapist: 'Rasa n\'est pas un thérapeute et ne remplace pas les véritables relations humaines, y compris avec votre partenaire de responsabilisation. Si vous vous sentez submergé(e), Rasa vous orientera en douceur vers du soutien, sans prétendre vous en apporter.',
    rasaIntroStart: 'Commencer',
    rasaMessagesLeft: 'réflexions laissées aujourd\'hui',
    rasaNoMessagesYet: 'Lorsque vous serez prêt(e) à réfléchir, commencez à écrire ci-dessous.',
    rasaThinking: 'Rasa réfléchit…',
    rasaPrivateNote: 'Privé pour vous — jamais visible par votre partenaire de responsabilisation.',
    rasaPlaceholder: 'Partagez ce que vous avez en tête…',
    rasaDailyLimitReached: 'Vous avez atteint votre limite de Rasa pour aujourd\'hui. Elle sera réinitialisée demain.',
    feature7Title: 'Rasa, your reflection space',
    feature7Desc: 'A private AI companion, just for you. It doesn\'t come in with assumptions — it reflects on what you share and asks questions instead of answers.',
    feature8Title: 'Support, right when you need it',
    feature8Desc: 'A quick chat assistant for billing and how-to questions, built into your dashboard. Can\'t help? It points you straight to a real person.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Chat d\'assistance Veyl',
    supportChatTitle: 'Soutien Veyl',
    supportChatEmptyState: 'Posez-moi toutes vos questions sur le fonctionnement de Veyl.',
    supportChatPlaceholder: 'Posez une question…',
    supportChatSend: 'Envoyer',
    supportChatTyping: 'Dactylographie…',
    supportChatLimitReached: 'Vous avez atteint la limite de messages d\'assistance pour aujourd\'hui. Veuillez envoyer un e-mail à support@veyl.space en cas d\'urgence.',
    supportChatGenericError: 'Une erreur s\'est produite. Veuillez réessayer.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Impossible de charger votre conversation.',
    rasaLoadErrorDetail: 'Consultez la console du navigateur pour plus de détails, ou essayez d\'actualiser la page.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Vous avez été mis en relation avec {name} ! Rendez-vous sur votre tableau de bord.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Installer l\'application',
    installMobileOnly: 'Mobile uniquement',
    installTooltip: 'Disponible uniquement sur appareils mobiles',
    installModalTitle: 'Installez Veyl sur votre téléphone',
    installStep1: 'Appuyez sur l\'icône Partager dans la barre d\'outils de Safari.',
    installStep2: 'Faites défiler vers le bas et appuyez sur « Ajouter à l\'écran d\'accueil ».',
    installStep3: 'Appuyez sur « Ajouter » dans le coin supérieur droit',
    installGotIt: 'J\'ai compris',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Relations et connexions',
    homeLifeOrganization: 'Organisation Maison et Vie',
    moneyFinancialHabits: 'Argent et habitudes financières',
    stayingConnected: 'Rester connecté',
    independentLiving: 'Vie autonome',
    techConfidence: 'Confiance technologique',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Relations et connexions',
    goalHomeLife: 'Organisation Maison et Vie',
    goalMoney: 'Argent et habitudes financières',
    goalStayingConnected: 'Rester connecté',
    goalIndependentLiving: 'Vie autonome',
    goalTechConfidence: 'Confiance technologique',
    // [auto-synced 2026-10-28]
    resources: 'Ressources',
    resourcesTitle: 'Ressources',
    resourcesWriteUps: 'Rédactions',
    resourcesLinks: 'Pour en savoir plus',
    resourcesOpensNewTab: 'S\'ouvre dans un nouvel onglet',
    resourcesEmptyTitle: 'Rien ici pour l\'instant',
    resourcesEmptyBody: 'Nous sommes en train de rassembler les ressources pour cette catégorie. Revenez bientôt.',
    resourcesNoMatchBody: 'Nous n\'avons pas encore trouvé les ressources nécessaires pour atteindre cet objectif.',
    resourcesDisclaimer: 'Information générale uniquement, ne constitue pas un avis professionnel. Si votre santé, votre sécurité ou vos finances sont en jeu, veuillez consulter un professionnel qualifié.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Articles',
    resourcesMoreToRead: 'Lire la suite',
    res_intro_fitnessHealth: 'Les objectifs de forme et de santé se réalisent souvent au fil des petits moments du quotidien, et non grâce à des exploits. Ces articles sont là pour vous faciliter la tâche, et les liens vous dirigent vers des sources très détaillées.',
    res_fitness_showing_up_title: 'Se présenter vaut mieux que de se vanter.',
    res_fitness_showing_up_p1: 'La plupart d\'entre nous avons une image précise de ce à quoi ressemble un exercice physique « idéal » : la salle de sport, les chaussures de course, la transpiration. Lorsque la réalité ne correspond pas à cette image, il est facile de conclure que ce n\'est pas fait pour nous.',
    res_fitness_showing_up_p2: 'L\'Organisation mondiale de la santé adopte une vision beaucoup plus large. Elle prend en compte les mouvements effectués pendant les loisirs, les déplacements, ainsi que l\'activité physique au travail ou à domicile. La marche, le vélo, le sport et les jeux sont tous comptabilisés, quel que soit le niveau. Ses recommandations insistent sur le fait que toute activité physique est préférable à l\'inactivité.',
    res_fitness_showing_up_p3: 'C\'est important lorsqu\'on instaure une habitude avec un partenaire. Une courte promenade faite réellement vaut mieux qu\'une séance intensive prévue et annulée. Même un simple « Je n\'ai tenu que dix minutes » permet de maintenir le lien.',
    res_fitness_showing_up_p4: 'Cela permet aussi de dissocier l\'action de la sensation ressentie. Certains jours, l\'habitude suffit amplement. L\'intensité viendra plus tard, une fois que la simple présence à l\'activité ne sera plus un sacrifice.',
    res_fitness_showing_up_p5: 'Si vous avez un problème de santé, si vous êtes enceinte ou si vous n\'avez pas été actif depuis longtemps, il est conseillé de consulter rapidement un médecin ou un autre professionnel de santé qualifié avant de modifier l\'intensité de votre entraînement.',
    res_fitness_rest_title: 'Le repos fait partie du plan',
    res_fitness_rest_p1: 'Quand on parle d\'objectifs de remise en forme, le sommeil et le repos sont souvent considérés comme secondaires, une fois l\'effort principal fourni. Or, en réalité, ils jouent un rôle crucial dans la pérennité des résultats.',
    res_fitness_rest_p2: 'Le sommeil et l\'activité physique s\'alimentent mutuellement. Le NHS (service national de santé britannique) indique qu\'une activité physique régulière peut améliorer la qualité du sommeil et que certaines personnes trouvent que faire du sport juste avant le coucher perturbe le sommeil ; dans ce cas, il peut être plus approprié de s\'entraîner plus tôt dans la journée. Il ne s\'agit pas de règles absolues, mais plutôt d\'un rappel que c\'est à vous seul de trouver ce qui vous convient.',
    res_fitness_rest_p3: 'Il est également important de prévoir des moments de repos lorsque vous vous assurez mutuellement de votre réussite. Si chaque point quotidien se transforme en compte-rendu de vos efforts, une journée de détente peut vite être perçue comme un échec. Prendre un jour de congé volontairement est différent de s\'éloigner de son objectif, et il est tout à fait normal de le dire ouvertement.',
    res_fitness_rest_p4: 'Si vous souffrez de troubles du sommeil persistants ou si vous vous sentez épuisé sans raison apparente, il est important d\'en parler à un médecin ou à un autre professionnel de santé qualifié. Il est déconseillé de traverser cette épreuve seul.',
    res_fitness_food_title: 'Des repas sans tracas',
    res_fitness_food_p1: 'Les conseils alimentaires sont omniprésents et souvent contradictoires, il est donc bon de savoir que les grands organismes de santé publique sont plus tolérants que la plupart des sites internet.',
    res_fitness_food_p2: 'L\'OMS affirme que les régimes alimentaires sains peuvent prendre de nombreuses formes. Ce qui constitue une alimentation raisonnable dépend de votre âge, de votre mode de vie, de votre culture et des aliments disponibles dans votre région. L\'OMS décrit quatre principes fondamentaux : consommer suffisamment de nutriments essentiels, maintenir un équilibre alimentaire, apprécier certains aliments avec modération et manger varié. Un régime alimentaire principalement composé d\'aliments non transformés et variés en constitue la base.',
    res_fitness_food_p3: 'Pour atteindre un objectif que vous poursuivez avec quelqu\'un d\'autre, c\'est un cadre utile. Vous n\'avez pas besoin d\'imiter les habitudes alimentaires de votre partenaire, et il n\'a pas besoin d\'imiter les vôtres. Un objectif alimentaire peut être aussi simple que « cuisiner plus souvent à la maison » ou « manger autre chose que d\'habitude cette semaine », selon ce qui convient à votre vie et à votre budget.',
    res_fitness_food_p4: 'Si vous envisagez de modifier considérablement votre alimentation, ou si vous souffrez d\'une maladie, d\'une allergie ou prenez des médicaments dont l\'effet est influencé par l\'alimentation, un médecin ou un diététicien nutritionniste pourra vous donner des conseils adaptés à votre situation. Un document général ne le pourra pas.',
    res_fitness_who_physical_activity_note: 'Global. Un aperçu clair de ce qui est considéré comme une activité, de qui en bénéficie et pourquoi.',
    res_fitness_who_guidelines_note: 'À l\'échelle mondiale. Les directives complètes, avec des recommandations pour différents âges et pour les personnes atteintes de maladies chroniques ou de handicaps.',
    res_fitness_who_healthy_diet_note: 'Global. Explique les principes d\'une alimentation saine et pourquoi celle-ci varie selon les cultures et les aliments locaux.',
    res_fitness_nhs_sleep_note: 'Royaume-Uni. Conseils pratiques sur le sommeil. Les mentions de médecins généralistes ou de pharmaciens renvoient aux services britanniques.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Soyez averti(e) lorsque Veyl est fermé.',
    pushPromptBody: 'Nous vous informerons lorsque vous trouverez un partenaire compatible ou lorsque votre partenaire vous enverra un message. Les notifications ne contiennent jamais le contenu des messages.',
    pushEnable: 'Activer les notifications',
    pushNotNow: 'Pas maintenant',
    pushError: 'Une erreur s\'est produite lors de l\'activation des notifications. Veuillez réessayer.',
    pushBlockedTitle: 'Les notifications sont bloquées',
    pushBlockedBody: 'Votre navigateur bloque les notifications de Veyl. Pour les activer, ouvrez les paramètres du site veyl.space dans votre navigateur, autorisez les notifications, puis rechargez la page.',
    pushIosTitle: 'Recevez des notifications sur votre iPhone',
    pushIosBody: 'Commencez par ajouter Veyl à votre écran d\'accueil : appuyez sur Partager, puis sur Ajouter à l\'écran d\'accueil, puis ouvrez Veyl à partir de là et activez les notifications.',
    pushSettingsTitle: 'Notifications sur cet appareil',
    pushSettingsDesc: 'Recevez une alerte en cas de match ou de message de votre partenaire, même lorsque Veyl est fermé. Les alertes ne contiennent jamais le contenu des messages. Ce paramètre s\'applique uniquement à cet appareil.',
    pushSettingsUnsupported: 'Les notifications ne sont pas disponibles dans ce navigateur. Sur iPhone ou iPad, ajoutez d\'abord Veyl à votre écran d\'accueil (Partager, puis Ajouter à l\'écran d\'accueil), puis ouvrez l\'application depuis cet écran.',
    pushSettingsBlocked: 'Les notifications sont bloquées pour Veyl dans votre navigateur. Pour les activer, ouvrez les paramètres du site veyl.space dans votre navigateur, autorisez les notifications, puis rechargez la page.',
    pushSettingsWorking: 'Fonctionnement…',
    pushSettingsOn: 'Les notifications sont activées pour cet appareil.',
    pushSettingsTurnOff: 'Désactiver les notifications',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Pour apprendre quelque chose de nouveau, il faut surtout pratiquer régulièrement pour bien assimiler les connaissances. Ces articles s\'inscrivent dans une perspective de long terme, et les liens proposés sont des ressources gratuites pour apprendre presque tout.',
    res_learning_small_repeat_title: 'Assez petit pour être répété',
    res_learning_small_repeat_p1: 'La plupart des objectifs d\'apprentissage échouent parce qu\'ils sont trop ambitieux, et non trop difficiles. « Apprendre à coder » ou « parler couramment le portugais » est un but à atteindre, pas quelque chose que l\'on peut faire un mardi soir.',
    res_learning_small_repeat_p2: 'Un mardi soir, vous pouvez consacrer vingt minutes à une leçon. C\'est une activité que vous pouvez répéter, et c\'est en la répétant que l\'apprentissage se construit. Les compétences s\'acquièrent généralement progressivement, petit à petit, jusqu\'au jour où vous vous apercevez que vous êtes capable de faire quelque chose que vous ne pouviez pas faire auparavant.',
    res_learning_small_repeat_p3: 'C’est là qu’un partenaire de responsabilisation s’avère plus utile que la motivation. La motivation est fluctuante. Un partenaire qui attend un retour sur sa semaine rend plus difficile l’abandon discret d’une habitude et plus facile la reprise après une mauvaise semaine.',
    res_learning_small_repeat_p4: 'Un bon bilan n\'a pas besoin d\'être impressionnant. Dire « J\'ai fait une leçon et j\'en ai compris environ la moitié » est honnête et permet de maintenir l\'habitude. Vous pourrez augmenter la difficulté plus tard. Il est beaucoup plus difficile de reprendre une habitude perdue.',
    res_learning_beginner_title: 'Être débutant est autorisé',
    res_learning_beginner_p1: 'Commencer quelque chose de nouveau implique forcément d\'être mauvais, du moins en présence d\'une personne. Pour beaucoup d\'adultes, c\'est là le véritable obstacle, bien plus que le temps ou l\'argent.',
    res_learning_beginner_p2: 'Il peut être utile de savoir à quel point l\'apprentissage ouvert est devenu accessible. MIT OpenCourseWare publie gratuitement, sans inscription, les ressources de milliers de cours du MIT. OpenLearn, de l\'Open University, propose près d\'un millier de cours courts et gratuits, sans aucune condition d\'accès. Nul besoin d\'autorisation pour essayer un sujet, ni pour découvrir s\'il ne vous convient pas.',
    res_learning_beginner_p3: 'Essayer quelque chose et se rendre compte que ce n\'est pas pour soi, c\'est aussi apprendre. Goûter à plusieurs choses avant de s\'engager est une excellente façon de commencer.',
    res_learning_beginner_p4: 'Si vous avez l\'impression d\'être en retard, rappelez-vous que votre partenaire peut ressentir la même chose par rapport à son propre objectif. Vous n\'êtes pas en compétition. Vous êtes tous les deux au début de quelque chose, à des étapes différentes.',
    res_learning_choose_one_title: 'Choisissez une chose, puis continuez à la choisir.',
    res_learning_choose_one_p1: 'L’apprentissage gratuit souffre d’un problème étrange : il y en a trop. OpenCourseWare propose à lui seul plus de 2 500 cours, et OpenLearn près d’un millier. On peut facilement y passer une soirée entière à naviguer sur internet et croire qu’on a appris quelque chose.',
    res_learning_choose_one_p2: 'Il est utile de choisir un cours, un livre ou une série de leçons, et de considérer tout le reste comme « pour plus tard ». Noter les autres éléments dans une note est tout à fait acceptable. L\'objectif est de terminer une chose avant d\'en commencer une autre. Informer votre partenaire de votre choix est un petit engagement qui facilite le respect de votre décision.',
    res_learning_choose_one_p3: 'Il est également important de vérifier ce qu\'une ressource offre et ce qu\'elle n\'offre pas. Les cours OpenLearn, par exemple, donnent droit à une attestation de participation et certains à un badge numérique qui ne constitue pas une qualification reconnue. Si vous avez besoin d\'une qualification formelle pour travailler ou étudier, il est préférable de le savoir au plus tôt ; l\'établissement que vous visez pourra vous indiquer les qualifications qu\'il accepte.',
    res_learning_mit_ocw_note: 'Global. Accès gratuit à des notes de cours, des examens et des vidéos de milliers de cours du MIT, sans inscription. En anglais.',
    res_learning_khan_academy_note: 'Mondiale. Une organisation à but non lucratif proposant des cours et des exercices gratuits, particulièrement performante en mathématiques et en sciences, dans de nombreuses langues.',
    res_learning_openlearn_note: 'Basée au Royaume-Uni et ouverte à tous, cette plateforme propose près de 1 000 formations courtes et gratuites, d\'une durée de 1 à 24 heures environ, chacune donnant droit à une attestation de participation gratuite.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Les objectifs professionnels sont à long terme, et l\'essentiel des efforts se concentre entre les étapes clés. Ces articles visent à maintenir un rythme régulier, et les liens proposés vous permettent de développer gratuitement vos compétences et de planifier la suite.',
    res_business_progress_title: 'Les progrès au travail sont rarement linéaires.',
    res_business_progress_p1: 'Les objectifs professionnels et commerciaux ont tendance à s\'étaler dans le temps. Une promotion, une reconversion ou l\'acquisition d\'un premier client peuvent prendre des mois, et les jours qui passent donnent rarement l\'impression d\'avancer.',
    res_business_progress_p2: 'Il est utile de distinguer le résultat souhaité des actions concrètes réalisables cette semaine. Vous ne pouvez pas contrôler si une entreprise vous embauchera ou si un client acceptera votre proposition. En revanche, vous pouvez contrôler le nombre d\'échanges que vous avez, le temps que vous consacrez au projet et le suivi de vos engagements.',
    res_business_progress_p3: 'C’est là qu’un partenaire de responsabilisation prend tout son sens. Il n’a pas besoin de connaître votre secteur d’activité. Il lui suffit de vous demander ce que vous avez fait et d’écouter votre réponse sans en faire une mise en scène.',
    res_business_progress_p4: 'Certaines semaines, le constat honnête est : « Il ne s’est pas passé grand-chose. » Il est important de le dire ouvertement, car un objectif laissé de côté pendant un mois est bien plus difficile à reprendre qu’un objectif que l’on a maintenu, même modestement.',
    res_business_start_from_you_title: 'Commencez par vous-même, pas par le travail.',
    res_business_start_from_you_p1: 'Quand on se sent bloqué au travail, le premier réflexe est souvent de se tourner vers le marché de l\'emploi : les entreprises qui recrutent, celles qui offrent de bons salaires, celles qui font bonne impression. Pourtant, il peut être plus judicieux de commencer par ailleurs.',
    res_business_start_from_you_p2: 'Le cours gratuit d\'OpenLearn, « Réussir au travail », repose sur ce principe. Il part du principe que la connaissance de soi et de ses valeurs est essentielle à la planification de carrière, et n\'aborde ensuite que les CV, les candidatures et les entretiens.',
    res_business_start_from_you_p3: 'En clair : comment souhaitez-vous que vos journées soient ? Quels sont vos talents dont on ne vous reconnaît pas toujours la valeur ? À quoi seriez-vous prêt à renoncer, que ce soit du temps en famille, un revenu stable ou la possibilité d’être créatif ?',
    res_business_start_from_you_p4: 'Vous n’êtes pas obligé(e) de répondre à toutes ces questions seul(e). En discuter avec votre partenaire fait souvent émerger des points que vous auriez négligés, et cela peut transformer un vague « Je veux quelque chose de différent » en un objectif concret sur lequel vous pouvez travailler.',
    res_business_wear_out_title: 'Travailler dur sans s\'épuiser',
    res_business_wear_out_p1: 'L\'ambition et l\'épuisement peuvent se ressembler de l\'intérieur, surtout lorsqu\'un objectif vous tient à cœur.',
    res_business_wear_out_p2: 'L’Organisation mondiale de la santé souligne que le travail peut protéger la santé mentale, mais aussi la détériorer. Ses recommandations sur la santé mentale au travail mettent en évidence des risques tels que la surcharge de travail et les comportements négatifs au travail, et précisent que la responsabilité d’un environnement de travail sain incombe aux employeurs et aux gouvernements, et non uniquement aux travailleurs.',
    res_business_wear_out_p3: 'Si vous faites le point avec votre partenaire sur un objectif professionnel important, il est judicieux de lui demander non seulement « l’as-tu atteint ? » mais aussi « comment te sens-tu ? ». Un objectif poursuivi au détriment de votre sommeil, de votre santé ou de vos relations mérite d’être repensé, même s’il semble prometteur sur le papier.',
    res_business_wear_out_p4: 'Si votre travail a des répercussions sur votre santé, ou si vous vous sentez constamment déprimé, anxieux ou épuisé, veuillez consulter un médecin ou un autre professionnel de santé qualifié. Si vous avez des doutes sur vos droits au travail, un organisme local de confiance, comme une autorité compétente en matière d\'emploi ou une organisation de travailleurs, pourra vous renseigner sur ceux en vigueur dans votre pays de résidence. La réglementation varie considérablement d\'un pays à l\'autre.',
    res_business_who_mh_work_note: 'D\'envergure mondiale. Rédigé principalement à destination des employeurs et des gouvernements, il est donc technique. Le résumé est disponible en arabe, chinois, anglais, français, russe et espagnol.',
    res_business_openlearn_entrepreneurship_note: 'Formation dispensée au Royaume-Uni. 24 heures réparties sur 8 sessions, accessible sans inscription préalable. Certains aspects concernent la réglementation commerciale britannique ; vérifiez donc les règles applicables dans votre pays.',
    res_business_openlearn_succeed_note: 'Ce programme d\'environ 8 semaines, à raison de 3 heures par semaine, aborde la planification de carrière, la rédaction de CV et la préparation aux entretiens d\'embauche. Sa dernière mise à jour date de 2021 ; certaines parties concernant la recherche d\'emploi et les réseaux sociaux peuvent donc paraître obsolètes.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Fuseau horaire',
    timezoneCurrentIs: 'Votre fuseau horaire actuel est',
    timezoneLockNote: 'Vos limites quotidiennes de messages et de notes vocales sont réinitialisées à minuit, heure locale. Pour plus d\'équité, vous ne pouvez modifier votre fuseau horaire que les jours où vous n\'avez utilisé aucun message ni note vocale, et une seule fois tous les 7 jours.',
    timezoneNew: 'Choisissez le fuseau horaire',
    saveTimezone: 'Enregistrer le fuseau horaire',
    timezoneUpdated: 'Fuseau horaire mis à jour',
    timezoneInvalid: 'Ce fuseau horaire n\'est pas valide. Veuillez en choisir un dans la liste.',
    timezoneChangeError: 'Impossible de modifier votre fuseau horaire. Veuillez réessayer.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Les projets créatifs ont tendance à se développer dans les interstices du quotidien. Ces articles visent à maintenir un projet en vie pendant cette longue période intermédiaire, et les liens proposés abordent l\'apprentissage de l\'écriture, ainsi que l\'utilisation et le partage des œuvres créatives.',
    res_creative_finishing_title: 'La finition est aussi une compétence.',
    res_creative_finishing_p1: 'Démarrer un projet créatif, c\'est facile. L\'idée est fraîche et tout semble possible. La difficulté survient au milieu, lorsque l\'idée se concrétise et que le travail s\'avère plus lent et plus chaotique que l\'idée initiale.',
    res_creative_finishing_p2: 'C’est généralement à ce stade que les projets s’enlisent, et c’est rarement par manque de talent. C’est plus souvent parce qu’au milieu du projet, il n’y a pas de ligne d’arrivée en vue et que personne ne supervise.',
    res_creative_finishing_p3: 'C’est là qu’un partenaire qui vous demande simplement « Qu’as-tu fait cette semaine ? » peut faire toute la différence. Vous n’avez pas besoin de son jugement. Savoir que vous allez décrire votre semaine fixe une petite échéance à votre travail, et cette petite échéance suffit souvent à vous remettre à votre bureau, à votre toile ou à votre instrument.',
    res_creative_finishing_p4: 'Cela permet aussi de définir ce que signifie « terminé » pour ce que vous avez sous les yeux. Une version brute, même imparfaite, vaut mieux qu\'une version parfaite restée dans votre tête. Vous pourrez toujours l\'améliorer par la suite.',
    res_creative_rough_drafts_title: 'Personne n\'a besoin de voir la première version',
    res_creative_rough_drafts_p1: 'Nombreux sont les créatifs qui abandonnent discrètement car leur première tentative ne correspond pas à l\'image qu\'ils s\'en font. Cet écart entre ce que l\'on imagine et ce que l\'on parvient à réaliser est normal. Il est souvent plus important lorsque l\'on est particulièrement investi.',
    res_creative_rough_drafts_p2: 'Montrer son travail préliminaire à une personne de confiance peut alléger la pression. Dire à un partenaire : « C’est un brouillon, mais voici ce que j’essaie de faire », transforme la discussion en un échange, et non en un jugement. Vous constaterez peut-être qu’il s’intéresse davantage à votre persévérance qu’à la qualité du résultat.',
    res_creative_rough_drafts_p3: 'Si vous débutez dans un domaine artistique, il existe des approches en douceur. OpenLearn, la plateforme d\'apprentissage gratuite de l\'Open University, propose un cours d\'initiation à l\'écriture de fiction destiné aux débutants. Ce n\'est qu\'un exemple parmi d\'autres, et il convient particulièrement aux écrivains.',
    res_creative_rough_drafts_p4: 'Les progrès dans un travail créatif se manifestent rarement par une amélioration constante. Certaines semaines, on crée quelque chose dont on est fier, d\'autres, quelque chose qu\'on ne montrera jamais à personne. Les deux comptent et font partie intégrante de la même démarche.',
    res_creative_using_sharing_title: 'Utiliser le travail des autres et partager le sien',
    res_creative_using_sharing_p1: 'Les projets créatifs font souvent appel à des éléments provenant d\'autres personnes, comme des images, des sons ou du texte, et vous aurez peut-être envie, à terme, de partager les vôtres. Quelques notions de base sont utiles dans les deux cas.',
    res_creative_using_sharing_p2: 'Creative Commons est une organisation à but non lucratif qui publie des licences permettant aux créateurs de conserver leurs droits d\'auteur tout en autorisant d\'autres personnes à utiliser leurs œuvres comme ils le souhaitent. Si vous souhaitez partager une de vos créations, son guide explique le fonctionnement de ces licences.',
    res_creative_using_sharing_p3: 'Certaines institutions vont plus loin. Le Smithsonian a publié des millions d\'images et de données sous licence CC0, ce qui signifie que vous pouvez les utiliser sans son autorisation, y compris pour des projets créatifs. Cependant, sa FAQ précise que la licence CC0 ne couvre que le droit d\'auteur. D\'autres droits, comme le droit au respect de la vie privée ou le droit des marques, peuvent toujours s\'appliquer, et certains éléments de ses collections ne sont pas concernés.',
    res_creative_using_sharing_p4: 'Les règles relatives au droit d\'auteur varient d\'un pays à l\'autre. Ces informations sont d\'ordre général et ne constituent pas un avis juridique. Si un projet a une importance commerciale ou si vous avez des doutes quant à votre droit d\'utiliser un élément, un professionnel qualifié pourra vous renseigner.',
    res_creative_openlearn_fiction_note: 'Ce cours d\'initiation à l\'écriture de fiction, basé au Royaume-Uni et gratuit, ne nécessite qu\'une déclaration de participation. Il s\'adresse plus particulièrement aux écrivains qu\'à d\'autres créateurs.',
    res_creative_cc_license_note: 'À l\'échelle mondiale. Comment autoriser des tiers à utiliser votre œuvre selon les conditions de votre choix tout en conservant vos droits d\'auteur. Informations générales, ne constituent pas un avis juridique.',
    res_creative_smithsonian_open_access_note: 'Institution américaine, accès libre à tous. Ce document explique les images et les données publiées sous licence CC0, ce que cette licence autorise et n\'autorise pas, et quels éléments sont exclus.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Les relations se construisent davantage par de petites attentions répétées que par de grands moments. Ces articles traitent du maintien des liens, des principes les plus importants selon les recherches et des solutions à adopter lorsque les relations sont difficiles à maintenir ou qu\'elles deviennent dangereuses.',
    res_relationships_small_gestures_title: 'Les petits gestes comptent',
    res_relationships_small_gestures_p1: 'Nombreux sont ceux qui considèrent les amitiés et les liens familiaux comme des choses qui existent ou n\'existent pas. Robert Waldinger, directeur de l\'étude de Harvard sur le développement adulte, décrit la vie sociale comme un système vivant qui nécessite un entretien, à l\'instar de la forme physique.',
    res_relationships_small_gestures_p2: 'L’entretien peut se faire de manière très simple. Pensez à une personne qui vous manque et envoyez-lui un message. La liste des gestes quotidiens proposés par l’Organisation mondiale de la Santé est tout aussi modeste : contacter un ami, poser son téléphone pour être pleinement présent lors d’une conversation, saluer un voisin, s’engager dans une association locale ou faire du bénévolat.',
    res_relationships_small_gestures_p3: 'Pour un objectif que vous partagez avec un partenaire de responsabilisation, voici une bonne question hebdomadaire : qui avez-vous contacté ? C’est concret, c’est simple, et vous pouvez y répondre honnêtement même lors d’une semaine difficile.',
    res_relationships_small_gestures_p4: 'Tous les messages ne reçoivent pas une réponse chaleureuse, et c\'est normal. Waldinger explique que les gens sont souvent surpris de la façon dont de petits messages comme celui-ci sont accueillis.',
    res_relationships_quality_title: 'La qualité prime sur la quantité.',
    res_relationships_quality_p1: 'Il est facile de mesurer une vie sociale en fonction du nombre de personnes : le nombre d’amis, le nombre d’événements, ou si l’on est en couple. Les recherches indiquent une autre perspective.',
    res_relationships_quality_p2: 'L\'étude de Harvard sur le développement adulte suit des personnes depuis 1938. Lorsque ses chercheurs ont analysé rétrospectivement la vie des participants à l\'âge mûr, la satisfaction dans leurs relations, notamment conjugales, s\'est avérée un meilleur prédicteur du bonheur et de la santé à 80 ans que des facteurs comme le cholestérol ou la tension artérielle. Son directeur indique que d\'autres équipes de recherche ont depuis abouti aux mêmes conclusions. Il précise également qu\'il n\'existe pas de nombre précis de relations nécessaires et que les personnes timides pourraient en avoir besoin de moins que les extravertis.',
    res_relationships_quality_p3: 'Attention : les premiers participants à l’étude étaient des étudiants de Harvard et de jeunes adultes d’une seule ville américaine ; les résultats ne sont donc pas représentatifs de la population générale. Il convient d’interpréter les conclusions avec prudence.',
    res_relationships_quality_p4: 'Ce que cela suggère, en toute subtilité, c\'est qu\'au moins une relation solide, une personne que l\'on pourrait appeler en cas de maladie ou de peur, compte davantage qu\'un large cercle d\'amis. Et il est rarement trop tard. Le directeur de l\'étude décrit des personnes qui ont noué des amitiés profondes ou trouvé l\'amour sur le tard, alors qu\'elles ne s\'y attendaient pas.',
    res_relationships_hard_times_title: 'Quand la connexion est difficile, et quand une relation fait mal',
    res_relationships_hard_times_p1: 'Se sentir seul ne signifie pas qu\'il y a un problème. L\'Organisation mondiale de la santé estime qu\'environ une personne sur six dans le monde souffre de solitude, quel que soit son âge. Elle décrit la solitude comme un sentiment douloureux qui survient lorsque les relations que l\'on entretient ne correspondent pas à celles que l\'on souhaiterait.',
    res_relationships_hard_times_p2: 'Les causes peuvent être diverses : mauvaise santé, faibles revenus, solitude ou encore notre utilisation des technologies. L’OMS souligne que si le problème est plus grave, il est important de se renseigner sur les aides et services disponibles.',
    res_relationships_hard_times_p3: 'Il y a un autre aspect : les relations toxiques. Les comportements nuisibles au sein d’un couple incluent les violences psychologiques et les comportements dominateurs, ainsi que les violences physiques ou sexuelles.',
    res_relationships_hard_times_p4: 'Si vous avez peur d\'un proche ou si vous êtes victime de violence, veuillez contacter les services d\'urgence locaux ou un service d\'écoute et de soutien. Les numéros appropriés varient selon votre pays. Un partenaire Veyl est un pair, et non un conseiller formé. Si la situation vous semble insurmontable, un médecin ou un conseiller peut vous aider.',
    res_relationships_who_social_connection_note: 'Mondial. Un court résumé, sans jargon, du rapport 2025 de l’OMS sur la solitude et les liens sociaux (13 pages).',
    res_relationships_harvard_gazette_note: 'Source américaine. Entretien avec le directeur de l\'Étude de Harvard sur le développement adulte : que révèle la recherche sur les relations et la santé, notamment grâce aux petits gestes du quotidien ? Il s\'agit d\'une interview, et les premiers participants à l\'étude provenaient d\'une seule ville américaine.',
    res_relationships_who_violence_note: 'Global. Ce site explique ce que recouvre la violence conjugale et sa fréquence, touchant principalement les femmes. Il s\'agit d\'informations, et non d\'un service d\'assistance téléphonique, et le texte peut être difficile à lire.',
  },

  es: {
    appName: 'Veyl',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Atrás',
    continue: 'Continuar',
    done: 'Hecho',
    error: 'Error',
    submit: 'Enviar',
    send: 'Enviar',
    delete: 'Eliminar',
    leave: 'Salir',
    stay: 'Quedarse',
    yes: 'Sí',
    no: 'No',
    upgrade: 'Actualizar a Premium',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    resetPasswordSent: 'Correo de restablecimiento enviado. Revisa tu bandeja.',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    authError: 'Error de autenticación. Por favor intenta de nuevo.',
    landingHero: 'La responsabilidad que realmente funciona',
    landingSubtitle: 'Encuentra un compañero anónimo que comparte tu objetivo. Sin presión social. Solo resultados.',
    getStarted: 'Empezar — Es gratis',
    howItWorks: 'Cómo funciona',
    step1Title: 'Establece tu objetivo',
    step1Desc: 'Cuéntanos en qué estás trabajando. Te emparejaremos con alguien en un camino similar.',
    step2Title: 'Conoce a tu compañero',
    step2Desc: 'Emparéjate con un compañero de responsabilidad anónimo en tu zona horaria.',
    step3Title: 'Mantente responsable',
    step3Desc: 'Haz seguimiento diario, comparte tu progreso y apóyense mutuamente — de forma anónima.',
    pricingTitle: 'Precios simples',
    freePlan: 'Gratis',
    premiumPlan: 'Premium',
    perMonth: '/mes',
    freeFeature1: '1 Veyl activo',
    freeFeature2: '10 mensajes/día',
    freeFeature3: '10 notas de voz/día',
    freeFeature4: 'Seguimientos diarios y semanales',
    freeFeature5: 'Acceso al chat de grupo',
    premiumFeature1: 'Hasta 3 Veyls activos',
    premiumFeature2: 'Mensajes ilimitados',
    premiumFeature3: 'Notas de voz ilimitadas',
    premiumFeature4: 'Emparejamiento prioritario',
    faqTitle: 'Preguntas frecuentes',
    welcomeToVeyl: 'Bienvenido a Veyl',
    chooseLanguage: 'Elige tu idioma',
    chooseLanguageDesc: 'Selecciona el idioma en el que deseas usar Veyl.',
    ageVerification: 'Verificación de edad',
    ageVerificationDesc: 'Veyl está disponible para usuarios de 13 años o más.',
    areYouOldEnough: '¿Tienes 13 años o más?',
    yesIAm: '✅ Sí, tengo',
    noImNot: '❌ No, no tengo',
    mustBe13: 'Debes tener 13 años o más',
    mustBe13Desc: 'Veyl solo está disponible para usuarios de 13 años o más.',
    setupProfile: 'Configuremos tu perfil',
    stepOf: 'Paso {step} de 4',
    whatsYourName: '¿Cuál es tu nombre?',
    namePlaceholder: 'Ingresa tu apodo',
    whatsYourTimezone: '¿Cuál es tu zona horaria?',
    selectTimezone: 'Seleccionar zona horaria',
    goalCategory: '¿Cuál es la categoría de tu objetivo?',
    matchPreference: '¿Con quién quieres emparejarte?',
    matchNearby: 'Emparejar cerca',
    matchNearbyDesc: 'Emparejar con personas dentro de 4 horas de tu zona horaria.',
    matchAnywhere: 'Emparejar en cualquier lugar',
    matchAnywhereDesc: 'Emparejar con cualquier persona del mundo independientemente de la zona horaria.',
    describeGoal: 'Describe tu objetivo específico',
    goalPlaceholder: "Ej.: 'Quiero perder 15 kg' o 'Aprender Python'",
    communicationStyle: 'Estilo de comunicación preferido',
    textMessages: 'Mensajes de texto',
    textMessagesDesc: 'Chatea cuando sea conveniente',
    scheduledCheckins: 'Seguimientos programados',
    scheduledCheckinsDesc: 'Reflexiones profundas semanales',
    completingSetup: 'Buscando pareja...',
    completeSetup: 'Completar configuración',
    agreeToTerms: 'Al continuar, aceptas los',
    termsOfService: 'Términos de servicio',
    and: 'y la',
    privacyPolicy: 'Política de privacidad',
    fitnessHealth: 'Salud y bienestar',
    learningSkills: 'Aprendizaje y habilidades',
    businessCareer: 'Negocios y carrera',
    creativeProjects: 'Proyectos creativos',
    findingMatch: 'Buscando tu pareja...',
    findingNewMatch: 'Buscando tu nueva pareja...',
    lookingForSomeone: 'Buscamos a alguien en la categoría',
    category: '',
    sharesTimezone: 'que comparte tu zona horaria y compromiso.',
    autoCheck: 'Verificamos coincidencias automáticamente cada 5 segundos.',
    noMatchYet: 'No se encontró coincidencia aún — seguiremos intentando.',
    checkNow: 'Verificar ahora',
    checking: 'Verificando...',
    manualChecks: '{count} verificación{plural} manual{plural} realizada{plural}',
    joinCommunity: '🌐 Unirse a la comunidad mientras esperas',
    goToCommunity: '🌐 Ir a la comunidad',
    previousPartnerNote: '🛡️ Tu compañero anterior no será sugerido de nuevo.',
    joining: 'Uniéndose...',
    overview: 'Resumen',
    chat: 'Chat',
    checkin: 'Seguimiento',
    group: 'Grupo',
    community: 'Comunidad',
    notifications: 'Notificaciones',
    settings: 'Ajustes',
    yourGoal: 'Tu objetivo',
    yourPartner: 'Tu compañero',
    you: 'Tú',
    unveiled: '✨ Revelado',
    goalComplete: '✓ Objetivo completado',
    adjustGoal: 'Ajustar mi objetivo',
    unveilButton: '✨ Revelar — ¡Lo lograste!',
    goalCategory2: 'Categoría',
    goalDescription: 'Descripción',
    timezone: 'Zona horaria',
    loadingPartner: 'Cargando información del compañero...',
    waitingForMatch: 'Esperando una pareja para comenzar a chatear.',
    noMessagesYet: '¡Aún no hay mensajes. Saluda a tu compañero!',
    typeMessage: 'Escribe tu mensaje...',
    dailyLimitReached: 'Límite diario alcanzado — Actualiza a Premium',
    unmatch: '🔓 Desemparejar',
    report: '🚩 Reportar',
    unmatchWarning: '⚠️ Desemparejar eliminará todo el historial de chat. Esta acción es irreversible.',
    yesUnmatch: 'Sí, desemparejar',
    unmatching: 'Desemparejando...',
    deleteMessage: '🗑 Eliminar',
    deleting: 'Eliminando...',
    checkIn: 'Seguimiento',
    submitDaily: 'Enviar seguimiento diario',
    submitWeekly: 'Enviar seguimiento semanal',
    submitting: 'Enviando...',
    checkinSubmitted: '¡Seguimiento enviado!',
    viewHistory: 'Ver mi historial',
    notificationsTitle: 'Notificaciones',
    clearAll: 'Borrar todo',
    noNotifications: 'Sin notificaciones por ahora.',
    settingsTitle: 'Ajustes',
    settingsDesc: 'Personaliza tu identidad anónima.',
    saveAvatar: 'Guardar avatar',
    appearance: 'Apariencia',
    lightMode: '☀️ Claro',
    darkMode: '🌙 Oscuro',
    changeNickname: 'Cambiar apodo',
    saveNickname: 'Guardar apodo',
    deleteAccount: 'Eliminar cuenta',
    deleteAccountDesc: 'Elimina permanentemente tu cuenta y todos los datos asociados.',
    languageLabel: 'Idioma',
    languageDesc: 'Elige tu idioma preferido.',
    signOut: 'Cerrar sesión',
    updating: 'Actualizando...',
    unveil: 'Revelar',
    clearing: 'Borrando...',
    notifMatchFound: 'Coincidencia encontrada',
    notifGoalAchieved: 'Objetivo logrado',
    notifSupport: 'Mensajes de apoyo',
    notifUnmatched: 'Alertas de desemparejamiento',
    notifMatchRequest: 'Solicitudes de emparejamiento',
    notificationPrefs: 'Preferencias de notificación',
    notificationPrefsDesc: 'Silencia tipos específicos de notificaciones individualmente.',
    muted: 'Silenciado',
    active: 'Activo',
    all: 'Todos',
    justNow: 'Ahora mismo',
    minsAgo: 'Hace {count}m',
    hoursAgo: 'Hace {count}h',
    daysAgo: 'Hace {count}d',
    leaving: 'Saliendo...',
    myHistory: '📋 Mi historial',
    partnersProgress: '👤 Progreso de {name}',
    myCheckinHistory: 'Mi historial de seguimientos',
    checkinsForVeyl: '{count} seguimiento{plural} para este Veyl',
    noCheckinsYet: 'Sin seguimientos aún. ¡Empieza el primero!',
    newCheckinBtn: 'Nuevo seguimiento',
    partnerNoCheckins: '{name} aún no ha hecho un seguimiento.',
    dailyNotesPrivate: 'Las notas diarias son privadas',
    goalAchievedMarked: '🎉 Objetivo marcado como logrado',
    goalAchievedNote: '🎉 ¡Tu objetivo está marcado como logrado! Ve a Resumen para revelarlo.',
    veylComplete: '✓ Este Veyl está completo. Los seguimientos son de solo lectura.',
    goalAlreadyAchieved: '🎉 ¡Has marcado tu objetivo como logrado! Ve a Resumen para revelarlo.',
    didYouWork: '¿Trabajaste en tu objetivo hoy?',
    howDidWeekGo: '¿Cómo fue esta semana con tu objetivo?',
    whatGotInWay: '¿Qué se interpuso? (Opcional)',
    honestNote: 'Sé honesto. Tu compañero está aquí para apoyarte, no juzgarte.',
    whatDidYouLearn: '¿Qué aprendiste sobre ti mismo esta semana?',
    insightsPlaceholder: '¿Qué aprendizajes obtuviste?',
    whatPatterns: '¿Qué patrón estás notando?',
    patternsPlaceholder: '¿Temas u obstáculos recurrentes?',
    whatChange: '¿Qué necesita cambiar para la próxima semana?',
    changePlaceholder: '¿Qué harás diferente?',
    goalAchievedQuestion: '🏆 ¿Has logrado tu objetivo general?',
    yesDidIt: '🎉 ¡Sí, lo logré!',
    notYetBtn: 'Todavía no',
    didIt: '✅ Lo hice',
    didSome: '😐 Hice algo',
    didntDoIt: '❌ No lo hice',
    metCommitment: '✅ Cumplí el compromiso',
    partialProgress: '😐 Progreso parcial',
    noProgress: '❌ Sin progreso',
    rethinkingGoal: '🤔 Repensando el objetivo',
    yesLabel: '✅ Sí',
    aLittle: '😐 Un poco',
    noLabel: '❌ No',
    madeProgress: 'Avancé hoy',
    didSomething: 'Hice algo, no todo',
    didntWork: 'No trabajé en ello hoy',
    metWeekly: 'Cumplí mi compromiso semanal',
    madePartial: 'Tuve progreso parcial',
    didntMake: 'No tuve progreso',
    needToAdjust: 'Necesito ajustar mi enfoque',
    learnedLabel: 'Aprendí: ',
    patternLabel: 'Patrón: ',
    nextWeekLabel: 'Próxima semana: ',
    joinGroup: 'Unirse a un grupo',
    joinGroupDesc: 'Los grupos reúnen hasta 5 personas trabajando en objetivos similares. Anónimo, de apoyo, sin presión.',
    whatToExpect: 'QUÉ ESPERAR',
    expectAnonymous: 'Todos permanecen anónimos — los mismos avatares de silueta',
    expectMatched: 'Emparejados por categoría de objetivo para apoyo relevante',
    expectMembers: 'Hasta 5 miembros por grupo',
    expectChat: 'Chat grupal — 20 mensajes y 5 notas de voz/día gratis · Ilimitado en Premium',
    findOrCreate: 'Buscar o crear un grupo',
    findingGroup: 'Buscando tu grupo...',
    oneGroupNote: 'Solo puedes estar en un grupo a la vez. Los usuarios gratuitos y Premium tienen acceso a grupos.',
    groupCreated: '¡Grupo creado!',
    groupJoined: '¡Te uniste al grupo!',
    groupCreatedDesc: 'Has iniciado un nuevo grupo de {category}. Otros se unirán pronto.',
    groupJoinedDesc: 'Te has unido a un grupo existente de {category}. ¡Di hola!',
    switchToGroup: 'Cambia a la pestaña Grupo en tu panel para comenzar a chatear.',
    groupMembers: 'Miembros del grupo',
    backToChat: '← Volver al chat',
    creator: '★ Creador',
    joined: 'Se unió',
    leaveGroup: 'Salir del grupo',
    leaveGroupTitle: '¿Salir de este grupo?',
    leaveGroupDesc: 'Perderás acceso al chat grupal y podrás unirte a un nuevo grupo en cualquier momento.',
    membersBtn: '👥 Miembros',
    noGroupMessages: 'Sin mensajes aún. ¡Sé el primero en decir hola!',
    messageGroup: 'Envía un mensaje a tu grupo...',
    groupDailyLimit: 'Has alcanzado tu límite diario de mensajes grupales ({limit}/día). ¡Actualiza a Premium para mensajes ilimitados!',
    groupVoiceLimit: 'Límite diario de notas de voz alcanzado.',
    veylCommunity: 'Comunidad Veyl',
    communityDesc: 'Únete a otros trabajando en la misma categoría de objetivo mientras esperas una coincidencia.',
    communityJoinNote: 'Únete a la comunidad desde la página de espera mientras buscas coincidencia.',
    leaveCommunity: '¿Salir de esta comunidad?',
    communityLeaveDesc: 'Puedes volver a unirte en cualquier momento desde la página de espera.',
    matchRequests: 'Solicitudes de emparejamiento',
    incoming: 'Entrantes',
    sent: 'Enviadas',
    noIncoming: 'Sin solicitudes entrantes.',
    noPending: 'Sin solicitudes enviadas pendientes.',
    requestToAnonymous: 'Solicitud a usuario anónimo',
    pending: 'Pendiente',
    decline: 'Rechazar',
    accept: '✅ Aceptar',
    requestWaiting: '🤝 {count} solicitud{plural} de emparejamiento esperándote',
    view: 'Ver',
    requestsBtn: '🤝 Solicitudes',
    leaveBtn: 'Salir',
    openToAll: 'Abierto a todos · Anónimo',
    msgsLeft: '{count} mensajes restantes',
    noCommunityMessages: 'Sin mensajes aún. ¡Di hola a la comunidad!',
    saySomething: 'Di algo a la comunidad...',
    requestMatch: '🤝 Solicitar emparejamiento',
    requestSending: 'Enviando...',
    communityMsgsWarning: '{count} mensajes comunitarios restantes hoy.',
    communityDailyLimit: 'Has alcanzado tu límite diario de mensajes comunitarios ({limit}/día). ¡Actualiza a Premium para ilimitados!',
    matchRequestLimit: 'Solo puedes tener 3 solicitudes pendientes a la vez.',
    matchRequestSent: '¡Solicitud de emparejamiento enviada con éxito!',
    matchRequestDuplicate: 'Ya enviaste una solicitud a esta persona.',
    matchRequestError: 'Error al enviar la solicitud de emparejamiento. Por favor intenta de nuevo.',
    matchAcceptError: 'Error al aceptar la solicitud de emparejamiento.',
    matchRequestSentAlready: 'Ya enviaste una solicitud a esta persona.',
    avatar_silhouette: 'Silueta',
    avatar_teal: 'Verde azulado',
    avatar_purple: 'Morado',
    avatar_navy: 'Marino',
    avatar_slate: 'Pizarra',
    avatar_coral: 'Coral',
    avatar_gold: 'Dorado',
    avatar_moss: 'Musgo',
    avatar_indigo: 'Índigo', 
    avatar_unveiled: 'Revelado',
    activeLabel: 'Activo',
    seekingLabel: 'Buscando',
    completeLabel: 'Completo',
    upgradeForMore: '✨ Actualiza para más Veyls',
    newVeyl: '+ Nuevo Veyl',
    newVeylTitle: 'Iniciar un nuevo Veyl',
    goalCategoryLabel: 'Categoría del objetivo',
    goalDescriptionLabel: 'Descripción del objetivo',
    startVeyl: 'Iniciar nuevo Veyl',
    starting: 'Iniciando...',
    unveil: 'Revelar',
    clearing: 'Borrando...',
    nicknameRequired: 'El apodo es obligatorio',
    nicknameTooShort: 'El apodo debe tener al menos 2 caracteres',
    nicknameTooLong: 'El apodo no puede tener más de 20 caracteres',
    errorSavingNickname: 'Error al guardar el apodo',
    errorSavingAvatar: 'Error al guardar el avatar',
    errorDeletingAccount: 'Error al eliminar la cuenta',
    deleteMyAccountButton: 'Eliminar mi cuenta',
    goalsAchievedTitle: 'Objetivos logrados',
    goalsPrivate: 'Privado — solo visible para ti.',
    goalsCompletedCount: '{count} objetivos completados',
    keepAnonymous: 'Mantén el anonimato. No uses tu nombre real.',
    currentNicknameIs: 'Tu apodo actual es',
    unveiledLocked: '✨ Revelado — avatar bloqueado',
    howOthersSee: 'Así es como otros te ven',
    unveiledNote: 'Te has revelado en este Veyl. Inicia un nuevo Veyl para elegir un avatar nuevo.',
    active2: '✓ Activo',
    goalsAchieved: 'Objetivos logrados',
    goalsAchievedDesc: 'Privado — solo visible para ti.',
    goalCompleted: 'objetivo completado',
    goalsCompleted: 'objetivos completados',
    contactSupport: 'Contactar soporte',
    deleteWarning: '⚠️ Esto eliminará todo permanentemente. Escribe ELIMINAR a continuación para confirmar.',
    typeDelete: 'Escribe ELIMINAR para confirmar',
    confirmDelete: 'Confirmar eliminación',
    deleting2: 'Eliminando...',
    messagesLeft: '{count} mensajes · {voiceCount} notas de voz restantes hoy',
    premiumUnlimited: '✨ Premium — Mensajes y notas de voz ilimitados',
    messagesLeftWarning: '{count} mensajes restantes hoy.',
    forUnlimited: 'para mensajes ilimitados.',
    voiceNotesLeft: '{count} nota{plural} de voz restante{plural} hoy',
    dailyLimitReachedVoice: 'Límite diario de notas de voz alcanzado.',
    dailyVoiceNoteLimit: 'Límite diario de notas de voz alcanzado. Actualiza a Premium para notas ilimitadas.',
    recording: 'Grabando...',
    deeper: 'Más grave',
    neutral: 'Neutral',
    higher: 'Más agudo',
    applyingModulation: '⚙️ Aplicando modulación...',
    preview: '▶ Vista previa',
    pause: '⏸ Pausar',
    discard: 'Descartar',
    recordingTooLarge: 'Grabación demasiado grande. Por favor intenta un mensaje más corto.',
    failedToSend: 'Error al enviar. Por favor intenta de nuevo.',
    micDenied: 'Acceso al micrófono denegado.',
    unmatchMessage: 'Tu compañero ha terminado esta sesión de Veyl. Has vuelto a la búsqueda de coincidencias.',
    appearanceDesc: 'Elige cómo se ve Veyl para ti.',
    newNickname: 'Nuevo apodo',
    nicknamePlaceholder: 'ej. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Elige tu avatar',
    notificationsTitle: 'Notificaciones',
    notificationsCount: '{total} en total · {unread} sin leer',
    progressOf: 'Progreso de {name}',
    fitnessHealth: 'Salud & Fitness',
    learningSkills: 'Aprendizaje & Habilidades',
    businessCareer: 'Negocios & Carrera',
    creativeProjects: 'Proyectos Creativos',
    progressOf: 'Progreso de {name}',
    dailyCheckin: 'Check-in Diario',
    weeklyCheckin: 'Check-in Semanal',
    dailyCheckinDesc: 'Actualización rápida: ¿Trabajaste en tu objetivo hoy?',
    weeklyCheckinDesc: 'Reflexión profunda: ¿Cómo fue esta semana en general?',
    submitDaily: 'Enviar Check-in Diario',
    submitWeekly: 'Enviar Check-in Semanal',
    submitting: 'Enviando...',
    checkinSubmitted: '¡Check-in Enviado!',
    checkinSubmittedDesc: 'Buen trabajo manteniéndote responsable. {name} verá tu actualización.',
    viewHistory: 'Ver Mi Historial',
    newCheckin: '📝 Nuevo Check-in',
    myHistory: '📋 Mi Historial',
    partnersProgress: '👤 Progreso de {name}',
    myCheckinHistory: 'Mi Historial de Check-ins',
    checkinsForVeyl: '{count} check-in{plural} para este Veyl',
    noCheckinsYet: 'Aún no hay check-ins. ¡Empieza el primero!',
    newCheckinBtn: 'Nuevo Check-in',
    partnerNoCheckins: '{name} aún no ha hecho check-in.',
    dailyNotesPrivate: 'Las notas diarias son privadas',
    goalAchievedMarked: '🎉 Objetivo marcado como logrado',
    goalAchievedNote: '🎉 ¡Tu objetivo está marcado como logrado! Ve a Resumen para revelar.',
    veylComplete: '✓ Este Veyl está completo. Los check-ins son de solo lectura.',
    goalAlreadyAchieved: '🎉 ¡Has marcado tu objetivo como logrado! Ve a Resumen para revelar.',
    didYouWork: '¿Trabajaste en tu objetivo hoy?',
    howDidWeekGo: '¿Cómo fue esta semana con tu objetivo?',
    whatGotInWay: '¿Qué se interpuso? (Opcional)',
    honestNote: 'Sé honesto. Tu compañero está aquí para apoyarte, no para juzgarte.',
    whatDidYouLearn: '¿Qué aprendiste sobre ti mismo esta semana?',
    insightsPlaceholder: '¿Qué perspectivas obtuviste?',
    whatPatterns: '¿Qué patrón estás notando?',
    patternsPlaceholder: '¿Temas u obstáculos recurrentes?',
    whatChange: '¿Qué necesita cambiar para la próxima semana?',
    changePlaceholder: '¿Qué harás diferente?',
    goalAchievedQuestion: '🏆 ¿Has logrado tu objetivo general?',
    yesDidIt: '🎉 ¡Sí, lo logré!',
    notYetBtn: 'Todavía no',
    didIt: '✅ Lo hice',
    didSome: '😐 Hice algo',
    didntDoIt: '❌ No lo hice',
    metCommitment: '✅ Cumplí mi compromiso',
    madePartial: '😐 Progreso parcial',
    didntMake: '❌ No progresé',
    needToAdjust: '🤔 Necesito ajustar mi enfoque',
    yesLabel: '✅ Sí',
    aLittle: '😐 Un poco',
    noLabel: '❌ No',
    madeProgress: 'Progresé hoy',
    didSomething: 'Hice algo, no todo',
    didntWork: 'No trabajé en ello hoy',
    metWeekly: 'Cumplí mi compromiso semanal',
    didntMake: 'No progresé',
    needToAdjust: 'Necesito ajustar mi enfoque',
    learnedLabel: 'Aprendí: ',
    patternLabel: 'Patrón: ',
    nextWeekLabel: 'Próxima semana: ',
    problemTitle: 'Las redes sociales arruinaron la responsabilidad',
    problem1: "Tienes miedo de admitir cuando estás luchando",
    problem2: "Ocultas los fracasos en lugar de aprender de ellos",
    problem3: "Abandonas a tus compañeros cuando te equivocas",
    veylIsDifferent: 'Veyl es diferente.',
    popular: 'POPULAR',
    sixMonthDeal: 'o $20 por 6 meses ($3.33/mes)',
    getStartedPremium: 'Comenzar',
    buildTrust: 'Construir confianza',
    unveilIdentity: 'Revela tu identidad cuando (o si) estés listo',
    actuallyAchieve: 'Realmente Lograrlo',
    makeRealProgress: 'Haz progreso real sin la actuación',
    faq1q: '¿Qué pasa si mi compañero y yo no conectamos?',
    faq1a: 'Rematch fácil. Sin preguntas. Preferimos que encuentres a la persona correcta que forzar una asociación que no funciona.',
    faq2q: '¿Tengo que revelarme en algún momento?',
    faq2a: 'No. Algunas asociaciones permanecen anónimas indefinidamente. Otras se revelan después de una semana. Depende completamente de ti.',
    faq3q: '¿Qué pasa si mi compañero me hace ghosting?',
    faq3a: 'Los usuarios Premium obtienen un rematch instantáneo. Los usuarios gratuitos son rematched en 48 horas.',
    faq4q: '¿Por qué nunca fotos de perfil?',
    faq4a: 'Porque en el momento en que agregas fotos, se trata de gestionar la percepción. Lo probamos. El anonimato mantiene el enfoque en el trabajo.',
    legalEnglishOnly: 'Este documento solo está disponible en inglés. Para preguntas, comuníquese con soporte o use la función de traducción de su navegador.',
    ctaTitle: "¿Listo para alcanzar tus metas?",
    ctaSubtitle: "Únete a Veyl y encuentra un compañero de responsabilidad hoy. Es gratis empezar.",
    statAnonymous: "Anónimo",
    statLanguages: "Idiomas",
    statToStart: "Para empezar",
    authTagline: "Responsabilidad anónima. Resultados reales.",
    authPricing: "Gratis para empezar · Premium desde $5/mes",
    taglineHonest: "Honesto",
    taglineEffective: "Efectivo",
    foreverLabel: "/para siempre",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Actualizar a Premium",
    premiumActiveDesc: "Tienes acceso ilimitado a todas las funciones de Veyl.",
    upgradeDesc: "Elimina todos los límites y obtén la experiencia completa de Veyl.",
    billedMonthly: "Facturado mensualmente",
    bestValue: "MEJOR VALOR",
    perSixMonths: "$3.33/mes",
    unlimitedMessages: "Mensajes ilimitados",
    unlimitedVoice: "Notas de voz ilimitadas",
    unlimitedGroup: "Grupo ilimitado",
    unlimitedCommunity: "Comunidad ilimitada",
    was10day: "eran 10/día",
    was5day: "eran 5/día",
    was20day: "eran 20/día",
    was30day: "eran 30/día",
    sixMonthPlan: "Plan de 6 meses",
    monthlyPlan: "Plan mensual",
    modulationFailed: "La modulación falló — usando voz original",
    monthly: "Mensual",
    sixMonths: "6 Meses",
    savePercent: "Ahorra {{percent}}%",
    pricePerMonth: "${{price}} / mes",
    priceTotal: "${{price}} total",
    unlimitedMessages: "Mensajes ilimitados",
    unlimitedVoiceNotes: "Notas de voz ilimitadas",
    unlimitedGroupMessages: "Mensajes de grupo ilimitados",
    unlimitedCommunityMessages: "Mensajes de comunidad ilimitados",
    upgrade: "Actualizar",
    forUnlimited: "para ilimitado",
    messagesLeftWarning: "{{count}} mensajes restantes hoy",
    recordVoiceNote: "Grabar nota de voz",
    uploading: "Subiendo",
    maxDuration: "{{seconds}}s máx",
    upgradeToPremium: "Actualizar a Premium",
    dailyMessageLimitReached: "Has alcanzado tu límite diario de mensajes.",
    dailyVoiceLimitReached: "Has alcanzado tu límite diario de notas de voz.",
    dailyGroupMessageLimitReached: "Has alcanzado tu límite diario de mensajes de grupo.",
    dailyGroupVoiceLimitReached: "Has alcanzado tu límite diario de notas de voz de grupo.",
    unlockUnlimited: "Desbloquea acceso ilimitado a todas las funciones.",
    maybeLater: "Quizás más tarde",
    premiumUnlimited: "Ilimitado",
    premium: "Premium",
    msg: "msg",
    msgs: "msgs",
    newMessageNotification: "{{name}} te envió un mensaje 💬",
    newGroupMessageNotification: "{{name}} envió un mensaje en tu grupo 👥",
    someone: "alguien",
    failedToLoad: "Error al cargar",
    groupMessagesLeftWarning: "{{count}} mensajes restantes hoy",
    howOldAreYou: '¿Cuántos años tienes?',
    minorGroupNote: 'Serás emparejado/a con otros usuarios de tu edad (13–17).',
    adultGroupNote: 'Serás emparejado/a con otros adultos (18+).',
    enterYourAge: 'Ingresa tu edad',
    getStarted:        'Empezar',
    howItWorks:        'Cómo funciona',
    statAnonymous:     'Anónimo',
    statLanguages:     'Idiomas',
    statToStart:       'Para comenzar',
    taglineHonest:     'Honesto',
    taglineEffective:  'Efectivo',
    landingHero:       'Responsabilidad sin la actuación.',
    landingSubtitle:   'Encuentra un compañero anónimo que comparte tus metas. Sin seguidores. Sin presión — solo progreso honesto.',
    problemTitle:      'La responsabilidad está rota.',
    problem1:          'Las redes sociales convierten la superación personal en actuación. Publicas tus metas para obtener likes, no para progresar.',
    problem2:          'Los amigos y la familia traen juicios o indiferencia. La honestidad real se vuelve imposible.',
    problem3:          'Las apps de responsabilidad parecen herramientas de seguimiento — tableros estériles que ignoran el elemento humano.',
    veylIsDifferent:   'Veyl es diferente.',
    step1Title:        'Crea tu perfil',
    step1Desc:         'Elige un seudónimo, una categoría de meta y tu preferencia de comunicación. Tu identidad real sigue siendo tuya.',
    step2Title:        'Consigue una pareja',
    step2Desc:         'Veyl te encuentra un compañero que comparte tu tipo de meta y grupo de edad. Al instante, sin deslizar.',
    step3Title:        'Empieza a hablar',
    step3Desc:         'Chatea o envía notas de voz. Haz seguimiento diario o semanal. Tu compañero te responsabiliza — y tú a él.',
    buildTrust:        'Construir confianza',
    unveilIdentity:    'Registra tus logros. Cuando la confianza esté, puedes elegir revelar tu identidad — o no.',
    actuallyAchieve:   'Lograr de verdad',
    makeRealProgress:  'Progreso real con un humano real. Sin gamificación. Solo tú, tu compañero y tu meta.',
    pricingTitle:      'Empieza gratis. Profundiza cuando estés listo.',
    freePlan:          'Gratis',
    foreverLabel:      '/ para siempre',
    freeFeature1:      '1 compañero de responsabilidad',
    freeFeature2:      '10 mensajes por día',
    freeFeature3: '10 notas de voz al día',
    freeFeature5:      'Salas de grupo y comunidad',
    popular:           'Más popular',
    premiumPlan:       'Premium',
    perMonth:          '/ mes',
    sixMonthDeal: 'Plan de 6 meses por $20: ahorra un 33%.',
    premiumFeature1:   'Mensajes ilimitados',
    premiumFeature2:   'Notas de voz ilimitadas',
    premiumFeature3:   'Función de revelación de compañero',
    premiumFeature4:   'Emparejamiento prioritario',
    getStartedPremium: 'Empezar premium',
    faqTitle:          'Preguntas frecuentes.',
    faq1q: '¿Veyl es realmente anónimo?',
    faq1a: 'Sí. Te registras con un seudónimo. Sin nombre real, sin foto, nada identificable. Tu compañero solo sabe lo que tú eliges compartir.',
    faq2q: '¿Cómo funciona el emparejamiento?',
    faq2a: 'Veyl te conecta con alguien en la misma categoría de meta y grupo de edad. Suele tardar menos de dos minutos.',
    faq3q: '¿Qué pasa si no me llevo bien con mi compañero?',
    faq3a: 'Puedes reportar o bloquear a tu compañero en cualquier momento sin preguntas. Vuelve a emparejarte y encuentra a alguien mejor.',
    faq4q: '¿Es seguro para menores?',
    faq4a: 'Absolutamente. Los usuarios de 13 a 17 años solo se emparejan con otros del mismo grupo de edad. Esto se aplica a nivel del sistema.',
    ctaTitle:    'Tu compañero ya está esperando.',
    ctaSubtitle: 'Únete a Veyl gratis. No se necesita perfil social. Solo tú, tu meta y alguien que lo entiende.',
    privacyPolicy:  'Política de privacidad',
    termsOfService: 'Términos de servicio',
    refundPolicy:   'Política de reembolso',
    featuresTitle: "Todo lo que necesitas. Nada de lo que no.",
    feature1Title: "Anonimato total",
    feature1Desc: "Elige un seudónimo. Tu nombre real, foto e identidad nunca se comparten, a menos que decidas revelarlos.",
    feature2Title: "Notas de voz",
    feature2Desc: "A veces escribir no es suficiente. Graba y envía notas de voz directamente en la app.",
    feature3Title: "Emparejamiento seguro por edad",
    feature3Desc: "Los menores (13–17 años) solo se emparejan con otros menores. Adultos con adultos. Sin excepciones — está en el sistema.",
    feature4Title: "13 idiomas",
    feature4Desc: "Inglés, swahili, francés, español, portugués, alemán, italiano, hindi, indonesio, chino, japonés, coreano, hausa.",
    feature5Title: "Check-ins diarios",
    feature5Desc: "Los check-ins estructurados mantienen el impulso. Registra tu progreso y celebra logros con tu compañero.",
    feature6Title: "Grupos y comunidad",
    feature6Desc: "Únete a chats de grupo según tu objetivo y salas comunitarias por idioma.",
    goalsEyebrow: "Para metas reales",
    goalsTitle: "Sea lo que sea en lo que estés trabajando.",
    goalsSub: "Veyl es para cualquiera con una meta real y nadie con quien ser honesto al respecto.",
    goalFitness: "Fitness y Salud",
    goalLearning: "Aprendizaje y Habilidades",
    goalBusiness: "Negocios y Carrera",
    goalCreative: "Proyectos Creativos",
    moreComingSoon: "Más categorías próximamente",
    safeTitle: "La seguridad no es una función. Es la base.",
    safe1Title: "Separación por edad",
    safe1Desc: "Los menores y adultos nunca se mezclan. La edad se verifica al registrarse y queda fija.",
    safe2Title: "Reportar y bloquear",
    safe2Desc: "Cualquier usuario puede reportar o bloquear de inmediato. Sin preguntas.",
    safe3Title: "Sin venta de datos",
    safe3Desc: "Tus metas, mensajes e identidad son tuyos. Punto.",
    safe4Title: "Solo seudónimos",
    safe4Desc: "Nunca se requieren nombres reales. Tú controlas si y cuándo revelarte.",
    refundPolicy: "Política de Reembolso",
    heroLine1: 'Responsabilidad',           
    heroLine2: 'sin la actuación',
    mustBe18: 'Debes tener 18 años o más para usar Veyl',
    mustBe18Desc: 'Veyl es una plataforma para personas de 18 años o más. Lo sentimos, pero no cumples con el requisito mínimo de edad para crear una cuenta.',
    ageAttestationLabel: 'Confirmo que tengo 18 años de edad o más.',
    ageMisrepresentationNote: 'Declarar una edad falsa infringe nuestros Términos de Servicio y puede dar lugar a la cancelación de la cuenta.',
    feature3Title: 'Verificado solo para mayores de 18',
    feature3Desc: 'Cada miembro confirma tener 18 años o más antes de unirse. Sin menores, sin excepciones.',
    faq4q: '¿Veyl está disponible para menores de edad?',
    faq4a: 'No. Veyl es una plataforma exclusiva para mayores de 18 años. Cada usuario confirma su edad durante el registro, y las cuentas que declaren una edad falsa están sujetas a eliminación.',
    safe1Title: 'Solo adultos',
    safe1Desc: 'Veyl está diseñado exclusivamente para personas de 18 años o más. Cualquier menor de 18 años que intente usar Veyl está declarando una edad falsa, lo cual infringe nuestros Términos de Servicio.',
    ageVerificationDesc: 'Veyl está disponible para usuarios de 18 años en adelante.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Ajusta tu objetivo',
    adjustGoalDesc: 'No hay problema en cambiar de rumbo. Tu pareja será notificada.',
    newGoalDescription: 'Descripción del nuevo objetivo',
    newGoalPlaceholder: '¿Cuál es tu nuevo objetivo o el que has modificado?',
    updateGoal: 'Objetivo de actualización',
    goalUpdated: '¡Objetivo actualizado correctamente! Tu compañero ha sido notificado.',
    readyToUnveil: '¿Listo para el desvelamiento?',
    unveilDesc: 'La inauguración marca la finalización de este Veyl. Su pareja será notificada. Esta acción es irreversible.',
    yourNewAvatar: 'Tu nuevo avatar',
    notYet: 'Aún no',
    unveiling: 'Desvelando...',
    sending: 'Envío...',
    checkInDesc: 'Las revisiones diarias permiten hacer un seguimiento del progreso. Las revisiones semanales son para reflexiones más profundas.',
    dismiss: '✕',
    saving: 'Ahorro...',
    saved: '✓ ¡Guardado!',
    lightModeDesc: 'Limpio y luminoso',
    darkModeDesc: 'Agradable a la vista',
    currentNickname: 'Tu apodo actual es',
    anonymousWarning: 'Mantén el anonimato. No uses tu nombre real.',
    nicknameUpdated: '✓ ¡Apodo actualizado!',
    deleteMyAccount: 'Eliminar mi cuenta',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Conoce a Rasa',
    rasaIntroDesc: 'Rasa es un espacio privado para reflexionar, solo para ti, al margen de tu compañero de apoyo. No presupone nada sobre ti ni sobre el mundo; aprende únicamente de lo que decides compartir y está diseñado para plantear preguntas en lugar de ofrecerte respuestas.',
    rasaIntroNotTherapist: 'Rasa no es terapeuta ni reemplaza la conexión humana real, incluyendo a tu compañero de apoyo. Si sientes que algo te pesa, te guiará suavemente hacia el apoyo, sin intentar serlo.',
    rasaIntroStart: 'Comenzar',
    rasaMessagesLeft: 'reflexiones dejadas hoy',
    rasaNoMessagesYet: 'Cuando estés listo para reflexionar, comienza a escribir a continuación.',
    rasaThinking: 'Rasa está reflexionando…',
    rasaPrivateNote: 'Privado para ti, nunca visible para tu compañero de rendición de cuentas.',
    rasaPlaceholder: 'Comparte lo que piensas…',
    rasaDailyLimitReached: 'Has alcanzado el límite de Rasa de hoy. Se restablecerá mañana.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Conoce a Rasa',
    feature7Desc: 'Un espacio privado para reflexionar, solo para ti, separado de tu compañero de apoyo.',
    feature8Title: 'Obtén asistencia en cualquier momento.',
    feature8Desc: 'Respuestas rápidas a preguntas sobre navegación, facturación y cuenta, directamente en la aplicación.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Chat de soporte de Veyl',
    supportChatTitle: 'Soporte de Veyl',
    supportChatEmptyState: 'Pregúntame lo que quieras sobre cómo funciona Veyl.',
    supportChatPlaceholder: 'Haz una pregunta…',
    supportChatSend: 'Enviar',
    supportChatTyping: 'Mecanografía…',
    supportChatLimitReached: 'Has alcanzado el límite de chats de soporte de hoy. En caso de urgencia, envía un correo electrónico a support@veyl.space.',
    supportChatGenericError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'No se pudo cargar tu conversación.',
    rasaLoadErrorDetail: 'Consulta la consola del navegador para obtener más detalles o intenta actualizar la página.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 ¡Te han emparejado con {name}! Dirígete a tu panel de control.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Instalar aplicación',
    installMobileOnly: 'Solo para móviles',
    installTooltip: 'Disponible solo en dispositivos móviles.',
    installModalTitle: 'Instala Veyl en tu teléfono.',
    installStep1: 'Pulsa el icono de Compartir en la barra de herramientas de Safari.',
    installStep2: 'Desplázate hacia abajo y pulsa "Añadir a la pantalla de inicio".',
    installStep3: 'Pulsa "Añadir" en la esquina superior derecha.',
    installGotIt: 'Entiendo',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Relaciones y conexión',
    homeLifeOrganization: 'Organización del hogar y la vida',
    moneyFinancialHabits: 'Dinero y hábitos financieros',
    stayingConnected: 'Mantenerse conectado',
    independentLiving: 'Vida independiente',
    techConfidence: 'Confianza tecnológica',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Relaciones y conexión',
    goalHomeLife: 'Organización del hogar y la vida',
    goalMoney: 'Dinero y hábitos financieros',
    goalStayingConnected: 'Mantenerse conectado',
    goalIndependentLiving: 'Vida independiente',
    goalTechConfidence: 'Confianza tecnológica',
    // [auto-synced 2026-10-28]
    resources: 'Recursos',
    resourcesTitle: 'Recursos',
    resourcesWriteUps: 'Artículos',
    resourcesLinks: 'Lecturas adicionales',
    resourcesOpensNewTab: 'Se abre en una pestaña nueva.',
    resourcesEmptyTitle: 'Aquí todavía no hay nada',
    resourcesEmptyBody: 'Todavía estamos recopilando recursos para esta categoría. Vuelva pronto.',
    resourcesNoMatchBody: 'Todavía no hemos encontrado recursos para este objetivo.',
    resourcesDisclaimer: 'Información general únicamente, no asesoramiento profesional. Si algo afecta su salud, seguridad o economía, un profesional cualificado puede ayudarle.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Artículos',
    resourcesMoreToRead: 'Más para leer',
    res_intro_fitnessHealth: 'Los objetivos de salud y bienestar suelen alcanzarse en pequeños momentos cotidianos, no en grandes logros. Estos artículos están aquí para aliviar la presión, y los enlaces dirigen a fuentes que ofrecen información detallada.',
    res_fitness_showing_up_title: 'Presentarse es mejor que presumir.',
    res_fitness_showing_up_p1: 'La mayoría de nosotros tenemos una idea preconcebida de cómo es el ejercicio "correcto": el gimnasio, las zapatillas de correr, el sudor. Cuando la vida no se ajusta a esa imagen, es fácil decidir que eso no es para ti.',
    res_fitness_showing_up_p2: 'La Organización Mundial de la Salud adopta una perspectiva mucho más amplia. Considera el movimiento durante el tiempo libre, los desplazamientos y la actividad física en el trabajo o en el hogar. Caminar, andar en bicicleta, practicar deporte y jugar cuentan, independientemente del nivel de habilidad. Sus directrices enfatizan que cualquier cantidad de actividad es mejor que ninguna.',
    res_fitness_showing_up_p3: 'Eso importa cuando estás creando un hábito con tu pareja. Un paseo corto que realmente hiciste vale más que la sesión intensa que planeaste y luego omitiste. El simple hecho de decir "Solo logré caminar diez minutos" sigue siendo un recordatorio que mantuvo viva la chispa.',
    res_fitness_showing_up_p4: 'También ayuda a separar lo que hiciste de cómo te sentiste. Algunos días, el hábito es la clave del éxito. La intensidad puede llegar después, una vez que presentarse ya no sea una negociación.',
    res_fitness_showing_up_p5: 'Si padeces alguna afección médica, estás embarazada o llevas mucho tiempo sin hacer ejercicio, conviene que consultes brevemente con un médico u otro profesional sanitario cualificado antes de modificar la intensidad de tu entrenamiento.',
    res_fitness_rest_title: 'El descanso forma parte del plan.',
    res_fitness_rest_p1: 'Cuando se habla de objetivos de fitness, el sueño y el descanso suelen considerarse algo secundario una vez finalizado el trabajo duro. Sin embargo, en la práctica, son fundamentales para que el esfuerzo dé sus frutos.',
    res_fitness_rest_p2: 'El sueño y la actividad física se retroalimentan. El Servicio Nacional de Salud (NHS) señala que la actividad física regular puede ayudar a dormir mejor, y que algunas personas encuentran que hacer ejercicio cerca de la hora de acostarse les resulta contraproducente; en ese caso, hacerlo más temprano durante el día podría serles más adecuado. Ninguna de estas afirmaciones es una regla. Simplemente nos recuerdan que eres tú quien debe descubrir qué funciona mejor para tu cuerpo.',
    res_fitness_rest_p3: 'También es importante planificar el descanso cuando se apoyan mutuamente. Si cada reunión se convierte en un informe sobre cuánto te esforzaste, un día tranquilo empieza a sentirse como un fracaso. Un día libre elegido a propósito es diferente a alejarse del objetivo, y está bien decirlo en voz alta.',
    res_fitness_rest_p4: 'Si tienes problemas para dormir durante un periodo prolongado o te sientes agotado sin motivo aparente, conviene consultar con un médico u otro profesional sanitario cualificado. No es algo que debas afrontar solo.',
    res_fitness_food_title: 'Comida sin complicaciones',
    res_fitness_food_p1: 'Los consejos sobre alimentación son estridentes y a menudo contradictorios, por lo que conviene saber que los principales organismos de salud pública son más flexibles que la mayoría de los usuarios de internet.',
    res_fitness_food_p2: 'La OMS afirma que las dietas saludables pueden adoptar muchas formas. Lo que se considera una alimentación sensata depende de la edad, el estilo de vida, la cultura y los alimentos disponibles en el lugar donde se vive. Describe cuatro ideas fundamentales: obtener los nutrientes que el cuerpo necesita, mantener el equilibrio, disfrutar de algunos alimentos con moderación y consumir una amplia variedad. Una dieta variada, basada principalmente en alimentos no procesados, es la base que señala.',
    res_fitness_food_p3: 'Para un objetivo que persigues con otra persona, este enfoque es útil. No es necesario que copies los hábitos alimenticios de tu pareja, ni que ella copie los tuyos. Un objetivo alimenticio puede ser tan sencillo como «cocinar más a menudo en casa» o «comer algo diferente esta semana», lo que mejor se adapte a tu vida y presupuesto.',
    res_fitness_food_p4: 'Si estás pensando en hacer grandes cambios en tu alimentación, o si tienes alguna afección, alergia o tomas algún medicamento que pueda verse afectado por la comida, un médico o un dietista registrado puede ofrecerte consejos personalizados. Un informe general no puede hacerlo.',
    res_fitness_who_physical_activity_note: 'Global. Una visión general sencilla de qué se considera actividad, quién se beneficia y por qué.',
    res_fitness_who_guidelines_note: 'Global. Las directrices completas, con recomendaciones para diferentes edades y para personas con enfermedades crónicas o discapacidades.',
    res_fitness_who_healthy_diet_note: 'Global. Explica los principios que rigen una dieta saludable y por qué varía según la cultura y los alimentos locales.',
    res_fitness_nhs_sleep_note: 'Reino Unido. Consejos prácticos para dormir. Las menciones a médicos de cabecera o farmacéuticos se refieren a servicios del Reino Unido.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Reciba una notificación cuando Veyl esté cerrado.',
    pushPromptBody: 'Te avisaremos cuando haya compatibilidad o cuando tu pareja te envíe un mensaje. Las notificaciones nunca incluyen el contenido del mensaje.',
    pushEnable: 'Activar notificaciones',
    pushNotNow: 'Ahora no',
    pushError: 'Se produjo un error al activar las notificaciones. Inténtalo de nuevo.',
    pushBlockedTitle: 'Las notificaciones están bloqueadas',
    pushBlockedBody: 'Tu navegador está bloqueando las notificaciones de Veyl. Para activarlas, abre la configuración de tu navegador para veyl.space, permite las notificaciones y, a continuación, recarga la página.',
    pushIosTitle: 'Recibe notificaciones en tu iPhone',
    pushIosBody: 'Primero, agrega Veyl a tu pantalla de inicio: toca Compartir, luego Agregar a la pantalla de inicio, abre Veyl desde allí y activa las notificaciones.',
    pushSettingsTitle: 'Notificaciones en este dispositivo',
    pushSettingsDesc: 'Recibe una alerta cuando haya una coincidencia o tu pareja te envíe un mensaje, incluso con Veyl cerrado. Las alertas nunca incluyen el contenido del mensaje. Esta configuración solo se aplica a este dispositivo.',
    pushSettingsUnsupported: 'Las notificaciones no están disponibles en este navegador. En iPhone o iPad, primero agrega Veyl a tu pantalla de inicio (Compartir, luego Agregar a la pantalla de inicio) y luego ábrelo desde allí.',
    pushSettingsBlocked: 'Las notificaciones de Veyl están bloqueadas en tu navegador. Para activarlas, abre la configuración de tu navegador para veyl.space, permite las notificaciones y, a continuación, recarga la página.',
    pushSettingsWorking: 'Laboral…',
    pushSettingsOn: 'Las notificaciones están activadas para este dispositivo.',
    pushSettingsTurnOff: 'Desactivar las notificaciones',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Aprender algo nuevo, en la mayoría de los casos, se reduce a practicar con la suficiente frecuencia para que se asimile. Estos artículos tratan sobre el aprendizaje a largo plazo, y los enlaces ofrecen recursos gratuitos para aprender prácticamente cualquier cosa.',
    res_learning_small_repeat_title: 'Lo suficientemente pequeño como para repetirse',
    res_learning_small_repeat_p1: 'La mayoría de los objetivos de aprendizaje fracasan por ser demasiado ambiciosos, no demasiado difíciles. "Aprender a programar" o "dominar el portugués" es una meta, no algo que se pueda lograr un martes por la noche.',
    res_learning_small_repeat_p2: 'Un martes por la noche, puedes dedicar veinte minutos a una lección. Es una tarea que puedes repetir, y precisamente al repetirla se consolida el aprendizaje. Las habilidades suelen adquirirse poco a poco, hasta que un día te das cuenta de que puedes hacer algo que antes no podías.',
    res_learning_small_repeat_p3: 'Aquí es donde un compañero que te ayude a rendir cuentas resulta más útil que la motivación. La motivación va y viene. Un compañero que espera saber cómo te fue hace más difícil abandonar el hábito en silencio y facilita retomarlo después de una mala semana.',
    res_learning_small_repeat_p4: 'Un buen resumen no tiene por qué ser impresionante. Decir "Hice una lección y entendí la mitad" es honesto y ayuda a mantener el hábito. Más adelante, puedes aumentar la dificultad de la tarea. Es mucho más difícil recuperar un hábito que se ha perdido.',
    res_learning_beginner_title: 'Ser principiante está permitido',
    res_learning_beginner_p1: 'Empezar algo nuevo implica no ser bueno en ello, al menos delante de alguien. Para muchos adultos, ese es el verdadero obstáculo, más que el tiempo o el dinero.',
    res_learning_beginner_p2: 'Puede resultar útil saber cómo se ha convertido el aprendizaje abierto. MIT OpenCourseWare publica materiales de miles de cursos del MIT de forma gratuita, sin necesidad de registrarse. OpenLearn, de la Open University, ofrece casi mil cursos cortos gratuitos y afirma que no hay requisitos para acceder a ellos. No necesitas el permiso de nadie para probar un tema ni para descubrir que no es de tu agrado.',
    res_learning_beginner_p3: 'Probar algo y decidir que no es para ti también cuenta como aprendizaje. Probar varias cosas antes de decidirte por una es una excelente manera de empezar.',
    res_learning_beginner_p4: 'Cuando sientas que te estás quedando atrás, recuerda que tu pareja probablemente sienta lo mismo respecto a su propio objetivo. No están compitiendo. Ambos están cerca del comienzo de algo, en diferentes etapas.',
    res_learning_choose_one_title: 'Elige una cosa y sigue eligiéndola.',
    res_learning_choose_one_p1: 'El aprendizaje gratuito tiene un problema peculiar: hay demasiado. Solo OpenCourseWare ofrece más de 2500 cursos, y OpenLearn casi mil. Es fácil pasar toda una tarde navegando y considerarlo aprendizaje.',
    res_learning_choose_one_p2: 'Es útil elegir un curso, un libro o una serie de lecciones, y dejar todo lo demás para más adelante. Guardar las demás en una nota está bien. El objetivo es terminar una cosa antes de empezar la siguiente. Decirle a tu compañero/a cuál elegiste es un pequeño compromiso que facilita el cumplimiento.',
    res_learning_choose_one_p3: 'También conviene comprobar qué ofrece y qué no ofrece cada recurso. Los cursos de OpenLearn, por ejemplo, incluyen un certificado de participación, y algunos una insignia digital que no constituye una titulación acreditada. Si necesitas una titulación formal para trabajar o estudiar, es importante saberlo con antelación, y la institución a la que aspiras podrá informarte sobre los requisitos de admisión.',
    res_learning_mit_ocw_note: 'Global. Apuntes de clase, exámenes y vídeos gratuitos de miles de cursos del MIT, sin necesidad de registrarse. En inglés.',
    res_learning_khan_academy_note: 'Global. Una organización sin fines de lucro que ofrece lecciones y práctica gratuitas, especialmente en matemáticas y ciencias, en muchos idiomas.',
    res_learning_openlearn_note: 'Con sede en el Reino Unido, abierto a todo el mundo. Casi 1000 cursos cortos gratuitos, de entre 1 y 24 horas de duración, cada uno con un certificado de participación gratuito.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Los objetivos laborales suelen ser a largo plazo, y la mayor parte del esfuerzo se concentra en los días entre hitos. Estos artículos tratan sobre cómo mantener un ritmo constante, y los enlaces ofrecen recursos gratuitos para desarrollar habilidades y planificar tu próximo paso.',
    res_business_progress_title: 'El progreso en el trabajo rara vez es una línea recta.',
    res_business_progress_p1: 'Las metas profesionales y empresariales tienden a prolongarse indefinidamente. Un ascenso, un cambio de carrera o el primer cliente pueden llevar meses, y los días intermedios rara vez se sienten como un progreso.',
    res_business_progress_p2: 'Es útil separar el resultado que deseas de las cosas que realmente puedes hacer esta semana. No puedes controlar si una empresa te contrata o si un cliente acepta. Lo que sí puedes controlar es cuántas conversaciones tienes, cuánto tiempo le dedicas al proyecto y si cumples con lo que prometiste.',
    res_business_progress_p3: 'Ahí es donde un compañero de responsabilidad se gana su lugar. No necesita entender tu sector. Solo necesita preguntar qué hiciste y escuchar la respuesta sin convertirla en una demostración.',
    res_business_progress_p4: 'Algunas semanas, la verdad es que "no ha pasado gran cosa". Vale la pena decirlo en voz alta, porque un objetivo que queda en suspenso durante un mes es mucho más difícil de retomar que uno que se ha mantenido vivo de forma intermitente.',
    res_business_start_from_you_title: 'Empieza por ti, no por el trabajo.',
    res_business_start_from_you_p1: 'Cuando las personas se sienten estancadas en el trabajo, su instinto suele ser empezar por el mercado laboral: qué ofertas hay, qué paga bien, qué parece impresionante. Sin embargo, puede ser más útil empezar por otro lado.',
    res_business_start_from_you_p2: 'El curso gratuito de OpenLearn, "Triunfa en el lugar de trabajo", se basa en esa idea. Parte de la premisa de que conocerse a uno mismo y sus valores es fundamental para la planificación profesional, y solo después aborda temas como los currículums, las solicitudes de empleo y las entrevistas.',
    res_business_start_from_you_p3: 'En pocas palabras: ¿cómo te gustaría que fueran tus días? ¿En qué eres bueno pero rara vez recibes reconocimiento? ¿Qué estarías dispuesto a sacrificar, ya sea tiempo con la familia, ingresos estables o espacio para ser creativo?',
    res_business_start_from_you_p4: 'No tienes que responder a todo eso solo. Hablarlo con tu pareja suele sacar a la luz cosas que pasarías por alto por tu cuenta, y puede convertir un vago "Quiero algo diferente" en un objetivo concreto en el que puedas trabajar.',
    res_business_wear_out_title: 'Trabajar duro sin agotarse',
    res_business_wear_out_p1: 'La ambición y el agotamiento pueden parecer similares desde dentro, especialmente cuando una meta es importante para ti.',
    res_business_wear_out_p2: 'La Organización Mundial de la Salud señala que el trabajo puede proteger la salud mental, pero también puede contribuir a su deterioro. Sus directrices sobre salud mental en el trabajo apuntan a riesgos como la sobrecarga laboral y las conductas negativas en el trabajo, y afirman que la responsabilidad de un entorno laboral saludable recae en los empleadores y los gobiernos, no solo en los trabajadores individualmente.',
    res_business_wear_out_p3: 'Si le preguntas a tu pareja sobre un objetivo importante en el trabajo, vale la pena preguntar no solo "¿lo lograste?", sino también "¿cómo te encuentras?". Un objetivo que persigues a costa de tu sueño, tu salud o tus relaciones merece ser reconsiderado, incluso si en teoría va bien.',
    res_business_wear_out_p4: 'Si el trabajo está afectando tu salud o te sientes persistentemente decaído, ansioso o agotado, consulta con un médico u otro profesional de la salud cualificado. Si no estás seguro de tus derechos laborales, una fuente local de confianza, como la autoridad laboral o una organización de trabajadores, puede explicártelos en tu lugar de residencia. Las normas varían mucho entre países.',
    res_business_who_mh_work_note: 'Global. Escrito principalmente para empleadores y gobiernos, por lo que tiene un tono técnico. El resumen ejecutivo está disponible en árabe, chino, inglés, francés, ruso y español.',
    res_business_openlearn_entrepreneurship_note: 'Curso impartido en el Reino Unido. Consta de 24 horas repartidas en 8 sesiones, y puedes empezar sin necesidad de registrarte. Parte del contenido abarca la normativa empresarial británica, así que consulta la que se aplica en tu país.',
    res_business_openlearn_succeed_note: 'Aproximadamente 8 semanas, con unas 3 horas semanales, abarcando planificación profesional, currículums y entrevistas. Última actualización en 2021, por lo que algunas secciones sobre búsqueda de empleo y redes sociales pueden parecer desactualizadas.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Zona horaria',
    timezoneCurrentIs: 'Tu zona horaria actual es',
    timezoneLockNote: 'Tus límites diarios de mensajes y notas de voz se restablecen a medianoche en tu zona horaria. Para que esto sea justo, solo puedes cambiar tu zona horaria en un día en el que no hayas usado ningún mensaje ni nota de voz, y solo una vez cada 7 días.',
    timezoneNew: 'Seleccione la zona horaria',
    saveTimezone: 'Guardar zona horaria',
    timezoneUpdated: 'Zona horaria actualizada',
    timezoneInvalid: 'Esa zona horaria no es válida. Por favor, seleccione una de la lista.',
    timezoneChangeError: 'No se pudo cambiar la zona horaria. Inténtalo de nuevo.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Los proyectos creativos suelen surgir en los espacios entre todo lo demás. Estos textos tratan sobre cómo mantener algo vivo durante el largo proceso, y los enlaces abarcan el aprendizaje de la escritura, así como el uso y la difusión del trabajo creativo.',
    res_creative_finishing_title: 'Terminar también es una habilidad.',
    res_creative_finishing_p1: 'Empezar un proyecto creativo es lo fácil. La idea es fresca y todo parece posible. Lo difícil llega en el proceso, cuando la idea se ha convertido en trabajo real y este es más lento y desordenado que la idea original.',
    res_creative_finishing_p2: 'Es ahí donde suelen estancarse los proyectos, y rara vez se debe a la falta de talento. Más bien, se debe a que no hay una meta clara a la que aspirar y a que nadie está pendiente.',
    res_creative_finishing_p3: 'Aquí es donde un compañero que simplemente pregunta "¿qué hiciste esta semana?" puede marcar la diferencia. No necesitas que te juzgue. Saber que vas a describir tu semana le da un pequeño plazo al trabajo, y un plazo pequeño suele ser suficiente para que vuelvas al escritorio, al lienzo o al instrumento.',
    res_creative_finishing_p4: 'También ayuda a definir qué significa "terminado" para el proyecto que tienes delante. Una versión preliminar terminada vale más que una versión perfecta que solo existe en tu mente. Siempre puedes mejorarla una vez que esté terminada.',
    res_creative_rough_drafts_title: 'Nadie necesita ver la primera versión.',
    res_creative_rough_drafts_p1: 'Muchas personas creativas se rinden en silencio porque su primer intento no está a la altura de la imagen que tenían en mente. Esa brecha entre lo que imaginas y lo que puedes crear ahora mismo es normal. Suele ser mayor cuando más te importa.',
    res_creative_rough_drafts_p2: 'Compartir un borrador con una persona de confianza puede aliviar la presión. Decirle a un compañero: «Este es un borrador desordenado, pero esto es lo que intento hacer», lo convierte en una conversación, no en un veredicto. Quizás descubras que les importa más si seguiste adelante que si el resultado es bueno.',
    res_creative_rough_drafts_p3: 'Si eres principiante en algún oficio, hay maneras sencillas de empezar. OpenLearn, la plataforma de aprendizaje gratuita de la Open University, ofrece un curso introductorio sobre escritura de ficción dirigido a quienes se inician en este campo. Es solo un ejemplo entre muchos, y resulta más adecuado para escritores que para otros tipos de creadores.',
    res_creative_rough_drafts_p4: 'El progreso en el trabajo creativo rara vez se manifiesta como una mejora constante. Algunas semanas creas algo de lo que te sientes orgulloso, y otras semanas creas algo que jamás le mostrarás a nadie. Ambas cosas cuentan, y ambas forman parte del mismo hábito.',
    res_creative_using_sharing_title: 'Utilizar el trabajo de otras personas y compartir el tuyo propio',
    res_creative_using_sharing_p1: 'Los proyectos creativos suelen incluir material ajeno, como imágenes, sonidos o texto, y es posible que, con el tiempo, quieras compartir el tuyo propio. Un poco de información básica te será útil en ambos casos.',
    res_creative_using_sharing_p2: 'Creative Commons es una organización sin ánimo de lucro que publica licencias que permiten a los creadores conservar sus derechos de autor, a la vez que autorizan a otros a utilizar su obra como ellos decidan. Si deseas compartir alguna creación, su guía explica cómo funcionan estas licencias.',
    res_creative_using_sharing_p3: 'Algunas instituciones van más allá. El Smithsonian ha publicado millones de imágenes y datos bajo la licencia CC0, lo que significa que se pueden usar sin necesidad de pedir permiso al Smithsonian, incluso para proyectos creativos. Sin embargo, en sus preguntas frecuentes se aclara que la licencia CC0 solo cubre los derechos de autor. Otros derechos, como la privacidad o las marcas registradas, pueden seguir vigentes, y algunos elementos de sus colecciones no están incluidos en absoluto.',
    res_creative_using_sharing_p4: 'Las normas de derechos de autor varían entre países, y esta información es general, no constituye asesoramiento legal. Si un proyecto tiene implicaciones comerciales o si no está seguro de si puede utilizar algún material, un profesional cualificado puede informarle sobre su situación legal.',
    res_creative_openlearn_fiction_note: 'Con sede en el Reino Unido, inscripción gratuita. Un curso introductorio sobre escritura de ficción, con un certificado de participación gratuito. Más adecuado para escritores que para otros tipos de creadores.',
    res_creative_cc_license_note: 'Global. Cómo permitir que otros utilicen tu obra bajo tus condiciones, conservando tus derechos de autor. Información general, no asesoramiento legal.',
    res_creative_smithsonian_open_access_note: 'Institución estadounidense, de libre acceso para cualquier persona. Explica las imágenes y los datos publicados bajo la licencia CC0, qué permite y qué no, y qué elementos están excluidos.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Las relaciones se construyen más a partir de pequeños gestos repetidos que de grandes momentos. Estos artículos tratan sobre cómo mantener vivas las conexiones, qué es lo que más importa según las investigaciones y qué hacer cuando la conexión se dificulta o una relación es insegura.',
    res_relationships_small_gestures_title: 'Los pequeños gestos cuentan.',
    res_relationships_small_gestures_p1: 'Muchos de nosotros consideramos las amistades y los lazos familiares como algo que simplemente existe o no. Robert Waldinger, director del Estudio de Desarrollo Adulto de Harvard, describe la vida social como un sistema vivo que necesita mantenimiento, al igual que la condición física.',
    res_relationships_small_gestures_p2: 'El mantenimiento puede ser mínimo. Piensa en alguien a quien extrañas y envíale un mensaje. La lista de pasos cotidianos de la Organización Mundial de la Salud es igual de sencilla: contactar a un amigo, guardar el teléfono para estar presente en una conversación, saludar a un vecino, unirse a un grupo local o ser voluntario.',
    res_relationships_small_gestures_p3: 'Si tienes un objetivo que compartes con alguien que te ayude a mantenerte responsable, esta es una buena pregunta semanal: ¿a quién contactaste? Es algo concreto, sencillo y puedes responderlo con sinceridad incluso en una semana difícil.',
    res_relationships_small_gestures_p4: 'No todos los mensajes reciben una respuesta entusiasta, y eso forma parte de la experiencia. Waldinger comenta que la gente suele sorprenderse de la cálida acogida que reciben mensajes tan sencillos como estos.',
    res_relationships_quality_title: 'Calidad por encima de cantidad',
    res_relationships_quality_p1: 'Es fácil medir la vida social por la cantidad de personas: cuántos amigos, cuántos eventos, si tienes pareja. Pero la investigación apunta a otra cosa.',
    res_relationships_quality_p2: 'El Estudio de Desarrollo Adulto de Harvard ha realizado un seguimiento de las personas desde 1938. Cuando sus investigadores analizaron la vida de los participantes en la mediana edad, la satisfacción en sus relaciones, especialmente en sus matrimonios, predijo mejor quién sería feliz y saludable a los 80 años que factores como el colesterol o la presión arterial. Su director afirma que otros grupos de investigación han llegado a la misma conclusión. También señala que no existe un número fijo de conexiones necesarias y que las personas tímidas podrían necesitar menos que las extrovertidas.',
    res_relationships_quality_p3: 'Una advertencia: los primeros participantes del estudio fueron estudiantes de Harvard y adultos jóvenes de una sola ciudad estadounidense, por lo que no es representativo de toda la población. Conviene tomar las conclusiones con cautela.',
    res_relationships_quality_p4: 'Lo que sugiere, sutilmente, es que al menos una relación sólida, alguien a quien pudieras llamar si estuvieras enfermo o asustado, importa más que un gran círculo de amigos. Y rara vez es demasiado tarde. El director del estudio describe a personas que encontraron amistades cercanas o el amor en la edad adulta, cuando menos lo esperaban.',
    res_relationships_hard_times_title: 'Cuando la conexión es difícil y cuando una relación duele',
    res_relationships_hard_times_p1: 'Sentirse solo no significa que algo ande mal contigo. La Organización Mundial de la Salud estima que aproximadamente una de cada seis personas en todo el mundo experimenta soledad, independientemente de su edad. La describe como el sentimiento doloroso que surge cuando las relaciones que tienes no coinciden con las que deseas.',
    res_relationships_hard_times_p2: 'Las causas pueden incluir mala salud, bajos ingresos, vivir solo o la forma en que usamos la tecnología. La OMS señala que, si el problema es más grave, vale la pena informarse sobre el apoyo y los servicios disponibles.',
    res_relationships_hard_times_p3: 'Existe otra perspectiva: las relaciones que causan dolor. El comportamiento dañino en una relación de pareja incluye el abuso psicológico y el comportamiento controlador, así como el daño físico o sexual.',
    res_relationships_hard_times_p4: 'Si temes por alguien cercano o estás sufriendo algún daño, ponte en contacto con el número de emergencias local o con una línea de ayuda o servicio de apoyo de tu zona. Los números correctos varían según el país. Un compañero de Veyl es una persona con quien puedes compartir experiencias similares, no un terapeuta especializado. Si la situación te resulta demasiado difícil de sobrellevar, un médico o un terapeuta pueden ayudarte.',
    res_relationships_who_social_connection_note: 'Global. Un resumen breve y sin jerga del informe de la OMS de 2025 sobre la soledad y la conexión social (13 páginas).',
    res_relationships_harvard_gazette_note: 'Fuente estadounidense. Sesión de preguntas y respuestas con el director del Estudio de Desarrollo Adulto de Harvard sobre lo que revela la investigación acerca de las relaciones y la salud, incluyendo pequeños pasos cotidianos. Se trata de una entrevista, y los primeros participantes del estudio procedían de una ciudad estadounidense.',
    res_relationships_who_violence_note: 'Global. Explica qué incluye la violencia de pareja y su frecuencia, afectando principalmente a las mujeres. Es información, no una línea de ayuda, y su lectura puede resultar difícil.',
  },

  pt: {
    appName: 'Veyl',
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    back: 'Voltar',
    continue: 'Continuar',
    done: 'Concluído',
    error: 'Erro',
    submit: 'Enviar',
    send: 'Enviar',
    delete: 'Excluir',
    leave: 'Sair',
    stay: 'Ficar',
    yes: 'Sim',
    no: 'Não',
    upgrade: 'Atualizar para Premium',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    signOut: 'Sair',
    email: 'E-mail',
    password: 'Senha',
    forgotPassword: 'Esqueceu a senha?',
    resetPassword: 'Redefinir senha',
    resetPasswordSent: 'E-mail de redefinição enviado. Verifique sua caixa de entrada.',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem uma conta?',
    authError: 'Erro de autenticação. Por favor, tente novamente.',
    landingHero: 'Responsabilidade que realmente funciona',
    landingSubtitle: 'Encontre um parceiro anônimo que compartilha seu objetivo. Sem pressão social. Apenas resultados.',
    getStarted: 'Começar — É grátis',
    howItWorks: 'Como funciona',
    step1Title: 'Defina seu objetivo',
    step1Desc: 'Nos diga no que você está trabalhando. Vamos combiná-lo com alguém em uma jornada semelhante.',
    step2Title: 'Conheça seu parceiro',
    step2Desc: 'Seja pareado com um parceiro de responsabilidade anônimo no seu fuso horário.',
    step3Title: 'Mantenha-se responsável',
    step3Desc: 'Faça check-ins diários, compartilhe progresso e apoiem-se mutuamente — anonimamente.',
    pricingTitle: 'Preços simples',
    freePlan: 'Grátis',
    premiumPlan: 'Premium',
    perMonth: '/mês',
    freeFeature1: '1 Veyl ativo',
    freeFeature2: '10 mensagens/dia',
    freeFeature3: '10 notas de voz/dia',
    freeFeature4: 'Check-ins diários e semanais',
    freeFeature5: 'Acesso ao chat em grupo',
    premiumFeature1: 'Até 3 Veyls ativos',
    premiumFeature2: 'Mensagens ilimitadas',
    premiumFeature3: 'Notas de voz ilimitadas',
    premiumFeature4: 'Combinação prioritária',
    faqTitle: 'Perguntas frequentes',
    welcomeToVeyl: 'Bem-vindo ao Veyl',
    chooseLanguage: 'Escolha seu idioma',
    chooseLanguageDesc: 'Selecione o idioma em que deseja usar o Veyl.',
    ageVerification: 'Verificação de idade',
    ageVerificationDesc: 'O Veyl está disponível para usuários com 13 anos ou mais.',
    areYouOldEnough: 'Você tem 13 anos ou mais?',
    yesIAm: '✅ Sim, tenho',
    noImNot: '❌ Não, não tenho',
    mustBe13: 'Você deve ter 13 anos ou mais',
    mustBe13Desc: 'O Veyl está disponível apenas para usuários com 13 anos ou mais.',
    setupProfile: 'Vamos configurar seu perfil',
    stepOf: 'Passo {step} de 4',
    whatsYourName: 'Qual é o seu nome?',
    namePlaceholder: 'Digite seu apelido',
    whatsYourTimezone: 'Qual é o seu fuso horário?',
    selectTimezone: 'Selecionar fuso horário',
    goalCategory: 'Qual é a categoria do seu objetivo?',
    matchPreference: 'Com quem você quer ser combinado?',
    matchNearby: 'Combinar próximo',
    matchNearbyDesc: 'Combine com pessoas dentro de 4 horas do seu fuso horário.',
    matchAnywhere: 'Combinar em qualquer lugar',
    matchAnywhereDesc: 'Combine com qualquer pessoa no mundo independentemente do fuso horário.',
    describeGoal: 'Descreva seu objetivo específico',
    goalPlaceholder: "Ex.: 'Quero perder 15 kg' ou 'Aprender Python'",
    communicationStyle: 'Estilo de comunicação preferido',
    textMessages: 'Mensagens de texto',
    textMessagesDesc: 'Converse quando for conveniente',
    scheduledCheckins: 'Check-ins programados',
    scheduledCheckinsDesc: 'Reflexões semanais aprofundadas',
    completingSetup: 'Procurando parceiro...',
    completeSetup: 'Concluir configuração',
    agreeToTerms: 'Ao continuar, você concorda com os',
    termsOfService: 'Termos de serviço',
    and: 'e a',
    privacyPolicy: 'Política de privacidade',
    fitnessHealth: 'Saúde e condicionamento',
    learningSkills: 'Aprendizado e habilidades',
    businessCareer: 'Negócios e carreira',
    creativeProjects: 'Projetos criativos',
    findingMatch: 'Procurando seu parceiro...',
    findingNewMatch: 'Procurando seu novo parceiro...',
    lookingForSomeone: 'Estamos procurando alguém na categoria',
    category: '',
    sharesTimezone: 'que compartilha seu fuso horário e comprometimento.',
    autoCheck: 'Verificamos combinações automaticamente a cada 5 segundos.',
    noMatchYet: 'Nenhuma combinação encontrada ainda — continuaremos tentando.',
    checkNow: 'Verificar agora',
    checking: 'Verificando...',
    manualChecks: '{count} verificação{plural} manual{plural} realizada{plural}',
    joinCommunity: '🌐 Entrar na comunidade enquanto espera',
    goToCommunity: '🌐 Ir para a comunidade',
    previousPartnerNote: '🛡️ Seu parceiro anterior não será sugerido novamente.',
    joining: 'Entrando...',
    overview: 'Visão geral',
    chat: 'Chat',
    checkin: 'Check-in',
    group: 'Grupo',
    community: 'Comunidade',
    notifications: 'Notificações',
    settings: 'Configurações',
    yourGoal: 'Seu objetivo',
    yourPartner: 'Seu parceiro',
    you: 'Você',
    unveiled: '✨ Revelado',
    goalComplete: '✓ Objetivo concluído',
    adjustGoal: 'Ajustar meu objetivo',
    unveilButton: '✨ Revelar — Você conseguiu!',
    goalCategory2: 'Categoria',
    goalDescription: 'Descrição',
    timezone: 'Fuso horário',
    loadingPartner: 'Carregando informações do parceiro...',
    waitingForMatch: 'Aguardando uma combinação para começar a conversar.',
    noMessagesYet: 'Nenhuma mensagem ainda. Diga olá ao seu parceiro!',
    typeMessage: 'Digite sua mensagem...',
    dailyLimitReached: 'Limite diário atingido — Atualize para Premium',
    unmatch: '🔓 Desfazer combinação',
    report: '🚩 Reportar',
    unmatchWarning: '⚠️ Desfazer a combinação excluirá todo o histórico do chat. Esta ação é irreversível.',
    yesUnmatch: 'Sim, desfazer',
    unmatching: 'Desfazendo...',
    deleteMessage: '🗑 Excluir',
    deleting: 'Excluindo...',
    checkIn: 'Check-in',
    submitDaily: 'Enviar check-in diário',
    submitWeekly: 'Enviar check-in semanal',
    submitting: 'Enviando...',
    checkinSubmitted: 'Check-in enviado!',
    viewHistory: 'Ver meu histórico',
    notificationsTitle: 'Notificações',
    clearAll: 'Limpar tudo',
    noNotifications: 'Nenhuma notificação ainda.',
    settingsTitle: 'Configurações',
    settingsDesc: 'Personalize sua identidade anônima.',
    saveAvatar: 'Salvar avatar',
    appearance: 'Aparência',
    lightMode: '☀️ Claro',
    darkMode: '🌙 Escuro',
    changeNickname: 'Mudar apelido',
    saveNickname: 'Salvar apelido',
    deleteAccount: 'Excluir conta',
    deleteAccountDesc: 'Exclui permanentemente sua conta e todos os dados associados.',
    languageLabel: 'Idioma',
    languageDesc: 'Escolha seu idioma preferido.',
    signOut: 'Sair',
    updating: 'Atualizando...',
    unveil: 'Revelar',
    clearing: 'Limpando...',
    notifMatchFound: 'Combinação encontrada',
    notifGoalAchieved: 'Objetivo alcançado',
    notifSupport: 'Mensagens de apoio',
    notifUnmatched: 'Alertas de descombinação',
    notifMatchRequest: 'Solicitações de combinação',
    notificationPrefs: 'Preferências de notificação',
    notificationPrefsDesc: 'Silencie tipos específicos de notificações individualmente.',
    muted: 'Silenciado',
    active: 'Ativo',
    all: 'Todos',
    justNow: 'Agora mesmo',
    minsAgo: 'Há {count}m',
    hoursAgo: 'Há {count}h',
    daysAgo: 'Há {count}d',
    leaving: 'Saindo...',
    myHistory: '📋 Meu histórico',
    partnersProgress: '👤 Progresso de {name}',
    myCheckinHistory: 'Meu histórico de check-ins',
    checkinsForVeyl: '{count} check-in{plural} para este Veyl',
    noCheckinsYet: 'Sem check-ins ainda. Comece o primeiro!',
    newCheckinBtn: 'Novo check-in',
    partnerNoCheckins: '{name} ainda não fez check-in.',
    dailyNotesPrivate: 'Notas diárias são privadas',
    goalAchievedMarked: '🎉 Objetivo marcado como alcançado',
    goalAchievedNote: '🎉 Seu objetivo está marcado como alcançado! Vá para Visão Geral para revelar.',
    veylComplete: '✓ Este Veyl está completo. Os check-ins são somente leitura.',
    goalAlreadyAchieved: '🎉 Você marcou seu objetivo como alcançado! Vá para Visão Geral para revelar.',
    didYouWork: 'Você trabalhou no seu objetivo hoje?',
    howDidWeekGo: 'Como foi esta semana com seu objetivo?',
    whatGotInWay: 'O que atrapalhou? (Opcional)',
    honestNote: 'Seja honesto. Seu parceiro está aqui para apoiá-lo, não julgá-lo.',
    whatDidYouLearn: 'O que você aprendeu sobre si mesmo esta semana?',
    insightsPlaceholder: 'Que insights você obteve?',
    whatPatterns: 'Que padrão você está notando?',
    patternsPlaceholder: 'Temas ou obstáculos recorrentes?',
    whatChange: 'O que precisa mudar para a próxima semana?',
    changePlaceholder: 'O que você fará diferente?',
    goalAchievedQuestion: '🏆 Você alcançou seu objetivo geral?',
    yesDidIt: '🎉 Sim, consegui!',
    notYetBtn: 'Ainda não',
    didIt: '✅ Fiz',
    didSome: '😐 Fiz um pouco',
    didntDoIt: '❌ Não fiz',
    metCommitment: '✅ Cumpri o compromisso',
    partialProgress: '😐 Progresso parcial',
    noProgress: '❌ Sem progresso',
    rethinkingGoal: '🤔 Repensando o objetivo',
    yesLabel: '✅ Sim',
    aLittle: '😐 Um pouco',
    noLabel: '❌ Não',
    madeProgress: 'Avancei hoje',
    didSomething: 'Fiz algo, não tudo',
    didntWork: 'Não trabalhei nisso hoje',
    metWeekly: 'Cumpri meu compromisso semanal',
    madePartial: 'Tive progresso parcial',
    didntMake: 'Não tive progresso',
    needToAdjust: 'Preciso ajustar minha abordagem',
    learnedLabel: 'Aprendi: ',
    patternLabel: 'Padrão: ',
    nextWeekLabel: 'Próxima semana: ',
    joinGroup: 'Entrar em um grupo',
    joinGroupDesc: 'Grupos reúnem até 5 pessoas trabalhando em objetivos semelhantes. Anônimo, solidário, sem pressão.',
    whatToExpect: 'O QUE ESPERAR',
    expectAnonymous: 'Todos permanecem anônimos — os mesmos avatares de silhueta',
    expectMatched: 'Combinados por categoria de objetivo para suporte relevante',
    expectMembers: 'Até 5 membros por grupo',
    expectChat: 'Chat em grupo — 20 mensagens e 5 notas de voz/dia grátis · Ilimitado no Premium',
    findOrCreate: 'Encontrar ou criar um grupo',
    findingGroup: 'Encontrando seu grupo...',
    oneGroupNote: 'Você só pode estar em um grupo por vez. Usuários gratuitos e Premium têm acesso a grupos.',
    groupCreated: 'Grupo criado!',
    groupJoined: 'Você entrou no grupo!',
    groupCreatedDesc: 'Você iniciou um novo grupo de {category}. Outros entrarão em breve.',
    groupJoinedDesc: 'Você entrou em um grupo existente de {category}. Diga olá!',
    switchToGroup: 'Mude para a aba Grupo no seu painel para começar a conversar.',
    groupMembers: 'Membros do grupo',
    backToChat: '← Voltar ao chat',
    creator: '★ Criador',
    joined: 'Entrou',
    leaveGroup: 'Sair do grupo',
    leaveGroupTitle: 'Sair deste grupo?',
    leaveGroupDesc: 'Você perderá acesso ao chat do grupo e poderá entrar em um novo grupo a qualquer momento.',
    membersBtn: '👥 Membros',
    noGroupMessages: 'Sem mensagens ainda. Seja o primeiro a dizer olá!',
    messageGroup: 'Envie uma mensagem para seu grupo...',
    groupDailyLimit: 'Você atingiu seu limite diário de mensagens de grupo ({limit}/dia). Atualize para Premium para mensagens ilimitadas!',
    groupVoiceLimit: 'Limite diário de notas de voz atingido.',
    veylCommunity: 'Comunidade Veyl',
    communityDesc: 'Junte-se a outros trabalhando na mesma categoria de objetivo enquanto aguarda uma combinação.',
    communityJoinNote: 'Entre na comunidade pela página de espera enquanto procura uma combinação.',
    leaveCommunity: 'Sair desta comunidade?',
    communityLeaveDesc: 'Você pode retornar a qualquer momento pela página de espera.',
    matchRequests: 'Solicitações de combinação',
    incoming: 'Recebidas',
    sent: 'Enviadas',
    noIncoming: 'Sem solicitações recebidas.',
    noPending: 'Sem solicitações enviadas pendentes.',
    requestToAnonymous: 'Solicitação para usuário anônimo',
    pending: 'Pendente',
    decline: 'Recusar',
    accept: '✅ Aceitar',
    requestWaiting: '🤝 {count} solicitação{plural} de combinação aguardando você',
    view: 'Ver',
    requestsBtn: '🤝 Solicitações',
    leaveBtn: 'Sair',
    openToAll: 'Aberto a todos · Anônimo',
    msgsLeft: '{count} msgs restantes',
    noCommunityMessages: 'Sem mensagens ainda. Diga olá à comunidade!',
    saySomething: 'Diga algo à comunidade...',
    requestMatch: '🤝 Solicitar combinação',
    requestSending: 'Enviando...',
    communityMsgsWarning: '{count} mensagens da comunidade restantes hoje.',
    communityDailyLimit: 'Você atingiu seu limite diário de mensagens da comunidade ({limit}/dia). Atualize para Premium para ilimitado!',
    matchRequestLimit: 'Você só pode ter 3 solicitações pendentes por vez.',
    matchRequestSent: 'Solicitação de combinação enviada com sucesso!',
    matchRequestDuplicate: 'Você já enviou uma solicitação para esta pessoa.',
    matchRequestError: 'Erro ao enviar solicitação de combinação. Por favor tente novamente.',
    matchAcceptError: 'Erro ao aceitar solicitação de combinação.',
    matchRequestSentAlready: 'Você já enviou uma solicitação para esta pessoa.',
    avatar_silhouette: 'Silhueta',
    avatar_teal: 'Azul-petróleo',
    avatar_purple: 'Roxo',
    avatar_navy: 'Marinho',
    avatar_slate: 'Ardósia',
    avatar_coral: 'Coral',
    avatar_gold: 'Dourado',
    avatar_moss: 'Musgo',
    avatar_indigo: 'Índigo',
    avatar_unveiled: 'Revelado',
    activeLabel: 'Ativo',
    seekingLabel: 'Procurando',
    completeLabel: 'Completo',
    upgradeForMore: '✨ Atualize para mais Veyls',
    newVeyl: '+ Novo Veyl',
    newVeylTitle: 'Iniciar um novo Veyl',
    goalCategoryLabel: 'Categoria do objetivo',
    goalDescriptionLabel: 'Descrição do objetivo',
    startVeyl: 'Iniciar novo Veyl',
    starting: 'Iniciando...',
    unveil: 'Revelar',
    clearing: 'Limpando...',
    nicknameRequired: 'O apelido é obrigatório',
    nicknameTooShort: 'O apelido deve ter pelo menos 2 caracteres',
    nicknameTooLong: 'O apelido não pode ter mais de 20 caracteres',
    errorSavingNickname: 'Erro ao salvar o apelido',
    errorSavingAvatar: 'Erro ao salvar o avatar',
    errorDeletingAccount: 'Erro ao excluir a conta',
    deleteMyAccountButton: 'Excluir minha conta',
    goalsAchievedTitle: 'Objetivos alcançados',
    goalsPrivate: 'Privado — visível apenas para você.',
    goalsCompletedCount: '{count} objetivos concluídos',
    keepAnonymous: 'Mantenha o anonimato. Não use seu nome real.',
    currentNicknameIs: 'Seu apelido atual é',
    unveiledLocked: '✨ Revelado — avatar bloqueado',
    howOthersSee: 'É assim que os outros te veem',
    unveiledNote: 'Você se revelou neste Veyl. Inicie um novo Veyl para escolher um avatar novo.',
    active2: '✓ Ativo',
    goalsAchieved: 'Objetivos alcançados',
    goalsAchievedDesc: 'Privado — visível apenas para você.',
    goalCompleted: 'objetivo concluído',
    goalsCompleted: 'objetivos concluídos',
    contactSupport: 'Contatar suporte',
    deleteWarning: '⚠️ Isso excluirá tudo permanentemente. Digite EXCLUIR abaixo para confirmar.',
    typeDelete: 'Digite EXCLUIR para confirmar',
    confirmDelete: 'Confirmar exclusão',
    deleting2: 'Excluindo...',
    messagesLeft: '{count} mensagens · {voiceCount} notas de voz restantes hoje',
    premiumUnlimited: '✨ Premium — Mensagens e notas de voz ilimitadas',
    messagesLeftWarning: '{count} mensagens restantes hoje.',
    forUnlimited: 'para mensagens ilimitadas.',
    voiceNotesLeft: '{count} nota{plural} de voz restante{plural} hoje',
    dailyLimitReachedVoice: 'Limite diário de notas de voz atingido.',
    dailyVoiceNoteLimit: 'Limite diário de notas de voz atingido. Atualize para Premium para notas ilimitadas.',
    recording: 'Gravando...',
    deeper: 'Mais grave',
    neutral: 'Neutro',
    higher: 'Mais agudo',
    applyingModulation: '⚙️ Aplicando modulação...',
    preview: '▶ Pré-visualizar',
    pause: '⏸ Pausar',
    discard: 'Descartar',
    recordingTooLarge: 'Gravação muito grande. Por favor tente uma mensagem mais curta.',
    failedToSend: 'Falha ao enviar. Por favor tente novamente.',
    micDenied: 'Acesso ao microfone negado.',
    unmatchMessage: 'Seu parceiro encerrou esta sessão do Veyl. Você voltou à busca de combinações.',
    appearanceDesc: 'Escolha como o Veyl aparece para você.',
    newNickname: 'Novo apelido',
    nicknamePlaceholder: 'ex. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Escolha seu avatar',
    notificationsTitle: 'Notificações',
    notificationsCount: '{total} no total · {unread} não lidas',
    progressOf: 'Progresso de {name}',
    fitnessHealth: 'Saúde & Fitness',
    learningSkills: 'Aprendizado & Habilidades',
    businessCareer: 'Negócios & Carreira',
    creativeProjects: 'Projetos Criativos',
    progressOf: 'Progresso de {name}',
    dailyCheckin: 'Check-in Diário',
    weeklyCheckin: 'Check-in Semanal',
    dailyCheckinDesc: 'Atualização rápida: Você trabalhou no seu objetivo hoje?',
    weeklyCheckinDesc: 'Reflexão profunda: Como foi essa semana no geral?',
    submitDaily: 'Enviar Check-in Diário',
    submitWeekly: 'Enviar Check-in Semanal',
    submitting: 'Enviando...',
    checkinSubmitted: 'Check-in Enviado!',
    checkinSubmittedDesc: 'Ótimo trabalho mantendo a responsabilidade. {name} verá sua atualização.',
    viewHistory: 'Ver Meu Histórico',
    newCheckin: '📝 Novo Check-in',
    myHistory: '📋 Meu Histórico',
    partnersProgress: '👤 Progresso de {name}',
    myCheckinHistory: 'Meu Histórico de Check-ins',
    checkinsForVeyl: '{count} check-in{plural} para este Veyl',
    noCheckinsYet: 'Nenhum check-in ainda. Comece o primeiro!',
    newCheckinBtn: 'Novo Check-in',
    partnerNoCheckins: '{name} ainda não fez check-in.',
    dailyNotesPrivate: 'Notas diárias são privadas',
    goalAchievedMarked: '🎉 Objetivo marcado como alcançado',
    goalAchievedNote: '🎉 Seu objetivo está marcado como alcançado! Vá para Visão Geral para revelar.',
    veylComplete: '✓ Este Veyl está completo. Check-ins são somente leitura.',
    goalAlreadyAchieved: '🎉 Você marcou seu objetivo como alcançado! Vá para Visão Geral para revelar.',
    didYouWork: 'Você trabalhou no seu objetivo hoje?',
    howDidWeekGo: 'Como foi essa semana com seu objetivo?',
    whatGotInWay: 'O que atrapalhou? (Opcional)',
    honestNote: 'Seja honesto. Seu parceiro está aqui para apoiar, não para julgar.',
    whatDidYouLearn: 'O que você aprendeu sobre si mesmo esta semana?',
    insightsPlaceholder: 'Que insights você obteve?',
    whatPatterns: 'Que padrão você está notando?',
    patternsPlaceholder: 'Temas ou obstáculos recorrentes?',
    whatChange: 'O que precisa mudar para a próxima semana?',
    changePlaceholder: 'O que você fará diferente?',
    goalAchievedQuestion: '🏆 Você alcançou seu objetivo geral?',
    yesDidIt: '🎉 Sim, consegui!',
    notYetBtn: 'Ainda não',
    didIt: '✅ Fiz',
    didSome: '😐 Fiz um pouco',
    didntDoIt: '❌ Não fiz',
    metCommitment: '✅ Cumpri meu compromisso',
    madePartial: '😐 Progresso parcial',
    didntMake: '❌ Não progredi',
    needToAdjust: '🤔 Preciso ajustar minha abordagem',
    yesLabel: '✅ Sim',
    aLittle: '😐 Um pouco',
    noLabel: '❌ Não',
    madeProgress: 'Progredi hoje',
    didSomething: 'Fiz algo, não tudo',
    didntWork: 'Não trabalhei nisso hoje',
    metWeekly: 'Cumpri meu compromisso semanal',
    didntMake: 'Não progredi',
    needToAdjust: 'Preciso ajustar minha abordagem',
    learnedLabel: 'Aprendi: ',
    patternLabel: 'Padrão: ',
    nextWeekLabel: 'Próxima semana: ',
    problemTitle: 'As redes sociais arruinaram a responsabilidade',
    problem1: "Você tem medo de admitir quando está lutando",
    problem2: "Você esconde fracassos em vez de aprender com eles",
    problem3: "Você abandona seus parceiros quando erra",
    veylIsDifferent: 'Veyl é diferente.',
    popular: 'POPULAR',
    sixMonthDeal: 'ou $20 por 6 meses ($3,33/mês)',
    getStartedPremium: 'Começar',
    buildTrust: 'Construir Confiança',
    unveilIdentity: 'Revele sua identidade quando (ou se) estiver pronto',
    actuallyAchieve: 'Realmente Alcançar',
    makeRealProgress: 'Faça progresso real sem a performance',
    faq1q: 'E se eu e meu parceiro não nos conectarmos?',
    faq1a: 'Rematch fácil. Sem perguntas. Preferimos que você encontre a pessoa certa do que forçar uma parceria que não funciona.',
    faq2q: 'Preciso me revelar em algum momento?',
    faq2a: 'Não. Algumas parcerias permanecem anônimas indefinidamente. Outras se revelam após uma semana. É inteiramente sua decisão.',
    faq3q: 'E se meu parceiro me der ghosting?',
    faq3a: 'Usuários Premium recebem um rematch instantâneo. Usuários gratuitos são rematched em 48 horas.',
    faq4q: 'Por que nunca fotos de perfil?',
    faq4a: 'Porque no momento em que você adiciona fotos, passa a ser sobre gerenciar percepção. Testamos isso. O anonimato mantém o foco no trabalho.',
    legalEnglishOnly: 'Este documento está disponível apenas em inglês. Para dúvidas, entre em contato com o suporte ou use o recurso de tradução do seu navegador.',
    ctaTitle: "Pronto para realmente alcançar seus objetivos?",
    ctaSubtitle: "Junte-se ao Veyl e encontre um parceiro de responsabilidade hoje. É grátis começar.",
    statAnonymous: "Anônimo",
    statLanguages: "Idiomas",
    statToStart: "Para começar",
    authTagline: "Responsabilidade anônima. Resultados reais.",
    authPricing: "Grátis para começar · Premium a partir de $5/mês",
    taglineHonest: "Honesto",
    taglineEffective: "Eficaz",
    foreverLabel: "/para sempre",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Atualizar para Premium",
    premiumActiveDesc: "Você tem acesso ilimitado a todos os recursos do Veyl.",
    upgradeDesc: "Remova todos os limites e tenha a experiência completa do Veyl.",
    billedMonthly: "Cobrado mensalmente",
    bestValue: "MELHOR VALOR",
    perSixMonths: "$3,33/mês",
    unlimitedMessages: "Mensagens ilimitadas",
    unlimitedVoice: "Notas de voz ilimitadas",
    unlimitedGroup: "Grupo ilimitado",
    unlimitedCommunity: "Comunidade ilimitada",
    was10day: "eram 10/dia",
    was5day: "eram 5/dia",
    was20day: "eram 20/dia",
    was30day: "eram 30/dia",
    sixMonthPlan: "Plano de 6 meses",
    monthlyPlan: "Plano mensal",
    modulationFailed: "Modulação falhou — usando voz original",
    monthly: "Mensal",
    sixMonths: "6 Meses",
    savePercent: "Economize {{percent}}%",
    pricePerMonth: "${{price}} / mês",
    priceTotal: "${{price}} total",
    unlimitedMessages: "Mensagens ilimitadas",
    unlimitedVoiceNotes: "Notas de voz ilimitadas",
    unlimitedGroupMessages: "Mensagens de grupo ilimitadas",
    unlimitedCommunityMessages: "Mensagens da comunidade ilimitadas",
    upgrade: "Atualizar",
    forUnlimited: "para ilimitado",
    messagesLeftWarning: "{{count}} mensagens restantes hoje",
    recordVoiceNote: "Gravar nota de voz",
    uploading: "Enviando",
    maxDuration: "{{seconds}}s máx",
    upgradeToPremium: "Atualizar para Premium",
    dailyMessageLimitReached: "Você atingiu seu limite diário de mensagens.",
    dailyVoiceLimitReached: "Você atingiu seu limite diário de notas de voz.",
    dailyGroupMessageLimitReached: "Você atingiu seu limite diário de mensagens de grupo.",
    dailyGroupVoiceLimitReached: "Você atingiu seu limite diário de notas de voz de grupo.",
    unlockUnlimited: "Desbloqueie acesso ilimitado a todos os recursos.",
    maybeLater: "Talvez mais tarde",
    premiumUnlimited: "Ilimitado",
    premium: "Premium",
    msg: "msg",
    msgs: "msgs",
    newMessageNotification: "{{name}} enviou uma mensagem para você 💬",
    newGroupMessageNotification: "{{name}} enviou uma mensagem no seu grupo 👥",
    someone: "alguém",
    failedToLoad: "Falha ao carregar",
    groupMessagesLeftWarning: "{{count}} mensagens restantes hoje",
    howOldAreYou: 'Quantos anos você tem?',
    minorGroupNote: 'Você será combinado(a) com outros usuários da sua faixa etária (13–17).',
    adultGroupNote: 'Você será combinado(a) com outros adultos (18+).',
    enterYourAge: 'Digite sua idade',
    getStarted:        'Começar',
    howItWorks:        'Como funciona',
    statAnonymous:     'Anônimo',
    statLanguages:     'Idiomas',
    statToStart:       'Para começar',
    taglineHonest:     'Honesto',
    taglineEffective:  'Eficaz',
    landingHero:       'Responsabilidade sem a encenação.',
    landingSubtitle:   'Encontre um parceiro anônimo que compartilha seus objetivos. Sem seguidores. Sem pressão — só progresso honesto.',
    problemTitle:      'A responsabilidade está quebrada.',
    problem1:          'As redes sociais transformam a autoaperfeiçoamento em performance. Você publica metas para curtidas, não para progredir.',
    problem2:          'Amigos e família trazem julgamentos ou indiferença. A honestidade real torna-se impossível.',
    problem3:          'Apps de responsabilidade parecem ferramentas de rastreio — painéis estéreis que ignoram o elemento humano.',
    veylIsDifferent:   'Veyl é diferente.',
    step1Title:        'Crie seu perfil',
    step1Desc:         'Escolha um pseudônimo, uma categoria de meta e sua preferência de comunicação. Sua identidade real continua sendo sua.',
    step2Title:        'Seja combinado',
    step2Desc:         'O Veyl encontra um parceiro que compartilha seu tipo de meta e faixa etária. Instantâneo — sem rolar, sem deslizar.',
    step3Title:        'Comece a conversar',
    step3Desc:         'Converse ou envie notas de voz. Faça check-in diário ou semanal. Seu parceiro te responsabiliza — e você a ele.',
    buildTrust:        'Construir confiança',
    unveilIdentity:    'Registre suas conquistas. Quando a confiança estiver lá, você pode escolher revelar sua identidade — ou não.',
    actuallyAchieve:   'Realmente alcançar',
    makeRealProgress:  'Progresso real com um humano real. Sem gamificação. Só você, seu parceiro e seu objetivo.',
    pricingTitle:      'Comece grátis. Aprofunde quando estiver pronto.',
    freePlan:          'Grátis',
    foreverLabel:      '/ para sempre',
    freeFeature1:      '1 parceiro de responsabilidade',
    freeFeature2:      '10 mensagens por dia',
    freeFeature3: '10 mensagens de voz por dia',
    freeFeature5:      'Salas de grupo e comunidade',
    popular:           'Mais popular',
    premiumPlan:       'Premium',
    perMonth:          '/ mês',
    sixMonthDeal: 'Plano de 6 meses por US$ 20 — economize 33%',
    premiumFeature1:   'Mensagens ilimitadas',
    premiumFeature2:   'Notas de voz ilimitadas',
    premiumFeature3:   'Recurso de revelação de parceiro',
    premiumFeature4:   'Combinação prioritária',
    getStartedPremium: 'Começar premium',
    faqTitle:          'Perguntas frequentes.',
    faq1q: 'Veyl é realmente anônimo?',
    faq1a: 'Sim. Você se cadastra com um pseudônimo. Sem nome real, sem foto, nada identificável. Seu parceiro só sabe o que você escolhe compartilhar.',
    faq2q: 'Como funciona a combinação?',
    faq2a: 'O Veyl te conecta com alguém na mesma categoria de meta e faixa etária. Geralmente leva menos de dois minutos.',
    faq3q: 'E se eu não me entender com meu parceiro?',
    faq3a: 'Você pode reportar ou bloquear seu parceiro a qualquer momento, sem perguntas. Combine novamente e encontre alguém melhor.',
    faq4q: 'É seguro para menores?',
    faq4a: 'Com certeza. Usuários de 13 a 17 anos são combinados apenas com outros da mesma faixa etária. Isso é aplicado no nível do sistema.',
    ctaTitle:    'Seu parceiro já está esperando.',
    ctaSubtitle: 'Junte-se ao Veyl gratuitamente. Nenhum perfil social necessário. Só você, seu objetivo e alguém que entende.',
    privacyPolicy:  'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    refundPolicy:   'Política de Reembolso',
    featuresTitle: "Tudo o que você precisa. Nada do que não precisa.",
    feature1Title: "Anonimato total",
    feature1Desc: "Você escolhe um pseudônimo. Seu nome real, foto e identidade nunca são compartilhados, a menos que você decida revelá-los.",
    feature2Title: "Notas de voz",
    feature2Desc: "Às vezes digitar não é suficiente. Grave e envie notas de voz diretamente no app.",
    feature3Title: "Correspondência segura por idade",
    feature3Desc: "Menores (13–17 anos) só são pareados com outros menores. Adultos com adultos. Sem exceções — está no sistema.",
    feature4Title: "13 idiomas",
    feature4Desc: "Inglês, swahili, francês, espanhol, português, alemão, italiano, hindi, indonésio, chinês, japonês, coreano, hauçá.",
    feature5Title: "Check-ins diários",
    feature5Desc: "Check-ins estruturados mantêm o ritmo. Registre seu progresso e celebre conquistas com seu parceiro.",
    feature6Title: "Grupos e comunidade",
    feature6Desc: "Participe de chats em grupo por objetivo e salas de comunidade por idioma.",
    goalsEyebrow: "Para metas reais",
    goalsTitle: "Seja lá no que você estiver trabalhando.",
    goalsSub: "O Veyl é para qualquer pessoa com uma meta real e sem ninguém para ser sincero sobre isso.",
    goalFitness: "Fitness e Saúde",
    goalLearning: "Aprendizado e Habilidades",
    goalBusiness: "Negócios e Carreira",
    goalCreative: "Projetos Criativos",
    moreComingSoon: "Mais categorias em breve",
    safeTitle: "Segurança não é um recurso. É a base.",
    safe1Title: "Separação por idade",
    safe1Desc: "Menores e adultos nunca são misturados. A idade é verificada no cadastro e fica fixa.",
    safe2Title: "Denunciar e bloquear",
    safe2Desc: "Qualquer usuário pode denunciar ou bloquear instantaneamente. Sem perguntas.",
    safe3Title: "Sem venda de dados",
    safe3Desc: "Suas metas, mensagens e identidade são suas. Ponto final.",
    safe4Title: "Apenas pseudônimos",
    safe4Desc: "Nomes reais nunca são exigidos. Você controla se e quando se revelar.",
    refundPolicy: "Política de Reembolso",
    heroLine1: 'Responsabilidade',          
    heroLine2: 'sem a encenação',
    mustBe18: 'Você deve ter 18 anos ou mais para usar o Veyl',
    mustBe18Desc: 'O Veyl é uma plataforma para pessoas com 18 anos ou mais. Lamentamos, mas você não atende ao requisito mínimo de idade para criar uma conta.',
    ageAttestationLabel: 'Confirmo que tenho 18 anos de idade ou mais.',
    ageMisrepresentationNote: 'Declarar uma idade falsa viola nossos Termos de Serviço e pode resultar no encerramento da conta.',
    feature3Title: 'Verificado apenas para maiores de 18',
    feature3Desc: 'Cada membro confirma ter 18 anos ou mais antes de entrar. Sem menores, sem exceções.',
    faq4q: 'O Veyl está disponível para menores de idade?',
    faq4a: 'Não. O Veyl é uma plataforma exclusiva para maiores de 18 anos. Cada usuário confirma sua idade durante o cadastro, e contas que declararem uma idade falsa estão sujeitas a remoção.',
    safe1Title: 'Somente adultos',
    safe1Desc: 'O Veyl foi criado exclusivamente para pessoas com 18 anos ou mais. Qualquer pessoa menor de 18 anos que tente usar o Veyl está declarando uma idade falsa, o que viola nossos Termos de Serviço.',
    ageVerificationDesc: 'O Veyl está disponível para usuários com 18 anos ou mais.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Ajuste seu objetivo',
    adjustGoalDesc: 'Não há problema em mudar de direção. Seu parceiro será notificado.',
    newGoalDescription: 'Descrição da Nova Meta',
    newGoalPlaceholder: 'Qual é a sua nova meta ou a meta ajustada?',
    updateGoal: 'Meta de atualização',
    goalUpdated: 'Meta atualizada com sucesso! Seu parceiro foi notificado.',
    readyToUnveil: 'Preparados para a revelação?',
    unveilDesc: 'A revelação marca este Veyl como concluído. Seu parceiro será notificado. Esta ação não pode ser desfeita.',
    yourNewAvatar: 'Seu novo avatar',
    notYet: 'Ainda não',
    unveiling: 'Revelando...',
    sending: 'Enviando...',
    checkInDesc: 'As reuniões diárias monitoram o progresso. As reuniões semanais são reflexões mais aprofundadas.',
    dismiss: '✕',
    saving: 'Salvando...',
    saved: '✓ Salvo!',
    lightModeDesc: 'Limpo e luminoso',
    darkModeDesc: 'Agradável aos olhos',
    currentNickname: 'Seu apelido atual é',
    anonymousWarning: 'Mantenha o anonimato. Não use seu nome verdadeiro.',
    nicknameUpdated: '✓ Apelido atualizado!',
    deleteMyAccount: 'Excluir minha conta',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Conheça Rasa',
    rasaIntroDesc: 'Rasa é um espaço privado para reflexão — só para você, separado do seu parceiro de prestação de contas. Não parte de nenhuma suposição sobre você ou o mundo; aprende apenas com o que você escolhe compartilhar e foi criado para fazer perguntas em vez de lhe dar respostas prontas.',
    rasaIntroNotTherapist: 'Rasa não é um terapeuta e não substitui a conexão humana real — incluindo seu parceiro de apoio. Se algo parecer difícil, Rasa gentilmente o direcionará para o apoio necessário, sem tentar substituí-lo.',
    rasaIntroStart: 'Começar',
    rasaMessagesLeft: 'reflexões deixadas hoje',
    rasaNoMessagesYet: 'Quando estiver pronto para refletir, comece a digitar abaixo.',
    rasaThinking: 'Rasa está refletindo…',
    rasaPrivateNote: 'Privado para você — nunca visível para seu parceiro de prestação de contas.',
    rasaPlaceholder: 'Compartilhe o que está em sua mente…',
    rasaDailyLimitReached: 'Você atingiu o limite de Rasa de hoje. Ele será zerado amanhã.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Conheça Rasa',
    feature7Desc: 'Um espaço privado para reflexão — só para você, separado do seu parceiro de responsabilidade.',
    feature8Title: 'Obtenha suporte a qualquer momento.',
    feature8Desc: 'Respostas rápidas sobre navegação, faturamento e dúvidas da conta — diretamente no aplicativo.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Chat de suporte da Veyl',
    supportChatTitle: 'Suporte Veyl',
    supportChatEmptyState: 'Pergunte-me qualquer coisa sobre como o Veyl funciona.',
    supportChatPlaceholder: 'Faça uma pergunta…',
    supportChatSend: 'Enviar',
    supportChatTyping: 'Digitando…',
    supportChatLimitReached: 'Você atingiu o limite de atendimentos por chat de suporte para hoje. Se for urgente, envie um e-mail para support@veyl.space.',
    supportChatGenericError: 'Algo deu errado. Por favor, tente novamente.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Não foi possível carregar sua conversa.',
    rasaLoadErrorDetail: 'Verifique o console do navegador para obter detalhes ou tente atualizar a página.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Você foi conectado com {name}! Acesse seu painel.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Instalar aplicativo',
    installMobileOnly: 'Somente para dispositivos móveis',
    installTooltip: 'Disponível apenas em dispositivos móveis',
    installModalTitle: 'Instale o Veyl no seu celular.',
    installStep1: 'Toque no ícone Compartilhar na barra de ferramentas do Safari.',
    installStep2: 'Deslize para baixo e toque em "Adicionar à tela inicial".',
    installStep3: 'Toque em "Adicionar" no canto superior direito.',
    installGotIt: 'Entendi',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Relacionamentos e Conexão',
    homeLifeOrganization: 'Organização da Casa e da Vida',
    moneyFinancialHabits: 'Dinheiro e hábitos financeiros',
    stayingConnected: 'Mantendo-se Conectado',
    independentLiving: 'Vida independente',
    techConfidence: 'Confiança em tecnologia',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Relacionamentos e Conexão',
    goalHomeLife: 'Organização de Casa e Vida',
    goalMoney: 'Dinheiro e hábitos financeiros',
    goalStayingConnected: 'Mantendo-se Conectado',
    goalIndependentLiving: 'Vida independente',
    goalTechConfidence: 'Confiança em tecnologia',
    // [auto-synced 2026-10-28]
    resources: 'Recursos',
    resourcesTitle: 'Recursos',
    resourcesWriteUps: 'Redações',
    resourcesLinks: 'Leitura complementar',
    resourcesOpensNewTab: 'Abre em uma nova aba',
    resourcesEmptyTitle: 'Nada por aqui ainda',
    resourcesEmptyBody: 'Ainda estamos reunindo recursos para esta categoria. Volte em breve.',
    resourcesNoMatchBody: 'Ainda não conseguimos encontrar recursos para atingir esse objetivo.',
    resourcesDisclaimer: 'Informações gerais apenas, não constituem aconselhamento profissional. Se algo afetar sua saúde, segurança ou finanças, um profissional qualificado poderá ajudá-lo(a) com a situação.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Artigos',
    resourcesMoreToRead: 'Leia mais',
    res_intro_fitnessHealth: 'As metas de saúde e boa forma tendem a ser conquistadas em pequenos momentos do dia a dia, não em grandes conquistas. Estas dicas servem para aliviar um pouco a pressão, e os links levam a fontes que abordam o assunto com detalhes.',
    res_fitness_showing_up_title: 'Aparecer é melhor do que se exibir.',
    res_fitness_showing_up_p1: 'A maioria de nós tem uma imagem idealizada do que é um exercício "adequado": academia, tênis de corrida, suor. Quando a vida não se encaixa nessa imagem, é fácil concluir que tudo isso não é para você.',
    res_fitness_showing_up_p2: 'A Organização Mundial da Saúde adota uma perspectiva muito mais ampla. Ela considera o movimento durante o tempo livre, o deslocamento de um lugar para outro e a atividade no trabalho ou em casa. Caminhar, andar de bicicleta, praticar esportes e brincar contam, independentemente do nível de habilidade. Suas diretrizes enfatizam que qualquer quantidade de atividade é melhor do que nenhuma.',
    res_fitness_showing_up_p3: 'Isso é importante quando você está criando um hábito com um parceiro. Uma caminhada curta que você realmente fez vale mais do que a sessão intensa que você planejou e perdeu. O registro de que "só consegui dez minutos" ainda é um registro que manteve a prática em andamento.',
    res_fitness_showing_up_p4: 'Também ajuda separar o que você fez de como se sentiu. Em alguns dias, o hábito é a chave da vitória. A intensidade pode vir depois, quando comparecer deixar de ser uma negociação.',
    res_fitness_showing_up_p5: 'Se você tem algum problema de saúde, está grávida ou não pratica atividades físicas há muito tempo, vale a pena conversar rapidamente com um médico ou outro profissional de saúde qualificado antes de alterar a intensidade do seu treino.',
    res_fitness_rest_title: 'O descanso faz parte do plano.',
    res_fitness_rest_p1: 'Quando se fala em objetivos de condicionamento físico, o sono e o descanso geralmente são tratados como algo que sobra depois do trabalho árduo. Na prática, eles são fundamentais para que o esforço seja duradouro.',
    res_fitness_rest_p2: 'O sono e a atividade física se retroalimentam. O NHS (Serviço Nacional de Saúde do Reino Unido) observa que a atividade física regular pode ajudar a dormir melhor e que algumas pessoas acham que se exercitar perto da hora de dormir atrapalha, sendo que, nesses casos, exercitar-se mais cedo durante o dia pode ser mais adequado. Nenhuma das duas opções é uma regra. Elas servem apenas como um lembrete de que você é quem deve descobrir o que funciona melhor para o seu corpo.',
    res_fitness_rest_p3: 'O descanso também é importante quando vocês estão se responsabilizando mutuamente. Se cada conversa se torna um relatório sobre o quanto você se esforçou, um dia tranquilo começa a parecer um fracasso. Um dia de folga escolhido de propósito é diferente de se afastar do objetivo, e não há problema nenhum em dizer isso em voz alta.',
    res_fitness_rest_p4: 'Se o sono se torna uma dificuldade constante por um longo período, ou se você se sente esgotado por razões inexplicáveis, é importante conversar com um médico ou outro profissional de saúde qualificado. Não é algo que deva ser enfrentado sozinho.',
    res_fitness_food_title: 'Comida sem complicações.',
    res_fitness_food_p1: 'As recomendações alimentares são numerosas e muitas vezes contraditórias, por isso vale a pena saber que os principais órgãos de saúde pública são mais flexíveis do que a maioria das pessoas na internet.',
    res_fitness_food_p2: 'A OMS afirma que dietas saudáveis podem assumir muitas formas. O que é considerado uma alimentação equilibrada depende da idade, estilo de vida, cultura e dos alimentos disponíveis na região onde se vive. A OMS descreve quatro princípios fundamentais: obter a quantidade necessária de nutrientes, manter o equilíbrio, consumir alguns alimentos com moderação e ter uma alimentação variada. Uma dieta diversificada, composta principalmente por alimentos não processados, é a base que a organização destaca.',
    res_fitness_food_p3: 'Para um objetivo que você está buscando com outra pessoa, essa é uma estrutura útil. Você não precisa copiar o jeito do seu parceiro de se alimentar, e ele não precisa copiar o seu. Uma meta alimentar pode ser tão simples quanto "cozinhar em casa com mais frequência" ou "comer algo diferente do habitual esta semana", o que se encaixar na sua vida e no seu orçamento.',
    res_fitness_food_p4: 'Se você está pensando em fazer grandes mudanças na sua alimentação, ou se tem alguma condição de saúde, alergia ou toma algum medicamento que interaja com a comida, um médico ou nutricionista registrado pode te dar orientações personalizadas. Um texto genérico não consegue fazer isso.',
    res_fitness_who_physical_activity_note: 'Global. Uma visão geral simples do que é considerado atividade, quem se beneficia e porquê.',
    res_fitness_who_guidelines_note: 'Global. As diretrizes completas, com recomendações para diferentes faixas etárias e para pessoas com doenças crônicas ou deficiência.',
    res_fitness_who_healthy_diet_note: 'Global. Explica os princípios por trás de uma alimentação saudável e por que ela varia de acordo com a cultura e os alimentos locais.',
    res_fitness_nhs_sleep_note: 'Reino Unido. Conselhos práticos sobre sono. As menções a um médico de clínica geral ou farmacêutico referem-se a serviços do Reino Unido.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Receba uma notificação quando o Veyl estiver fechado.',
    pushPromptBody: 'Avisaremos quando houver uma combinação ou quando seu parceiro enviar uma mensagem. As notificações nunca incluem o conteúdo das mensagens.',
    pushEnable: 'Ative as notificações',
    pushNotNow: 'Agora não',
    pushError: 'Ocorreu um erro ao ativar as notificações. Tente novamente.',
    pushBlockedTitle: 'As notificações estão bloqueadas.',
    pushBlockedBody: 'Seu navegador está bloqueando as notificações do Veyl. Para ativá-las, abra as configurações do site veyl.space no seu navegador, permita as notificações e, em seguida, recarregue a página.',
    pushIosTitle: 'Receba notificações no iPhone',
    pushIosBody: 'Primeiro, adicione o Veyl à sua tela inicial: toque em Compartilhar, depois em Adicionar à tela inicial, abra o Veyl a partir daí e ative as notificações.',
    pushSettingsTitle: 'Notificações neste dispositivo',
    pushSettingsDesc: 'Receba um alerta quando houver uma combinação ou quando seu parceiro enviar uma mensagem, mesmo com o Veyl fechado. Os alertas nunca incluem o conteúdo da mensagem. Essa configuração se aplica somente a este dispositivo.',
    pushSettingsUnsupported: 'As notificações não estão disponíveis neste navegador. No iPhone ou iPad, adicione o Veyl à sua Tela Inicial primeiro (Compartilhar e, em seguida, Adicionar à Tela Inicial) e abra-o a partir daí.',
    pushSettingsBlocked: 'As notificações do Veyl estão bloqueadas no seu navegador. Para ativá-las, abra as configurações do site veyl.space no seu navegador, permita as notificações e, em seguida, recarregue a página.',
    pushSettingsWorking: 'Trabalhando…',
    pushSettingsOn: 'As notificações estão ativadas para este dispositivo.',
    pushSettingsTurnOff: 'Desativar notificações',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Aprender algo novo depende, em grande parte, de praticar com frequência suficiente para que o conhecimento seja assimilado. Estes textos são sobre o longo prazo, e os links são fontes gratuitas para aprender praticamente qualquer coisa.',
    res_learning_small_repeat_title: 'Suficientemente pequeno para repetir',
    res_learning_small_repeat_p1: 'A maioria dos objetivos de aprendizagem fracassa por serem ambiciosos demais, não por serem difíceis demais. "Aprender a programar" ou "tornar-se fluente em português" é um destino, não algo que se possa fazer numa terça-feira à noite.',
    res_learning_small_repeat_p2: 'O que você pode fazer numa terça-feira à noite é sentar-se por vinte minutos para estudar uma lição. Essa é uma tarefa que você pode repetir, e é na repetição que o aprendizado se consolida. As habilidades tendem a surgir aos poucos, gradualmente, até que um dia você perceba que consegue fazer algo que antes era impossível.',
    res_learning_small_repeat_p3: 'É aqui que um parceiro de responsabilidade ajuda mais do que a motivação. A motivação é passageira. Um parceiro que espera saber como foi torna mais difícil abandonar o hábito silenciosamente e mais fácil recomeçar depois de uma semana ruim.',
    res_learning_small_repeat_p4: 'Um bom acompanhamento não precisa ser impressionante. "Fiz uma lição e entendi mais ou menos metade" é honesto e mantém o hábito vivo. Você pode aumentar a dificuldade da tarefa mais tarde. É muito mais difícil reconstruir um hábito que foi interrompido.',
    res_learning_beginner_title: 'Ser iniciante é permitido',
    res_learning_beginner_p1: 'Começar algo novo significa ser ruim nisso, pelo menos na frente de uma pessoa. Para muitos adultos, esse é o verdadeiro obstáculo, mais do que tempo ou dinheiro.',
    res_learning_beginner_p2: 'Pode ser útil saber como o aprendizado aberto se desenvolveu. O MIT OpenCourseWare publica materiais de milhares de cursos do MIT gratuitamente, sem necessidade de cadastro. O OpenLearn da Open University oferece quase mil cursos curtos e gratuitos, e afirma que não há requisitos para acessá-los. Você não precisa da permissão de ninguém para experimentar um assunto ou para descobrir que ele não é para você.',
    res_learning_beginner_p3: 'Experimentar algo e decidir que não é para você também conta como aprendizado. Testar algumas coisas antes de se comprometer com uma é uma ótima maneira de começar.',
    res_learning_beginner_p4: 'Quando você se sentir atrasado, lembre-se de que seu parceiro pode muito bem se sentir da mesma forma em relação ao próprio objetivo. Vocês não estão competindo. Ambos estão perto do início de algo, em pontos diferentes.',
    res_learning_choose_one_title: 'Escolha uma coisa e continue escolhendo-a.',
    res_learning_choose_one_p1: 'O aprendizado gratuito tem um problema curioso: há conteúdo demais. Só o OpenCourseWare oferece mais de 2.500 cursos, e o OpenLearn tem quase mil. É fácil passar uma noite inteira navegando e achar que isso é aprendizado.',
    res_learning_choose_one_p2: 'É útil escolher um curso, um livro ou uma série de aulas, e deixar todo o resto para "depois". Não tem problema em guardar as outras tarefas em um lembrete. O objetivo é terminar uma coisa antes de começar a próxima. Contar ao seu parceiro qual você escolheu é um pequeno compromisso que facilita a sua permanência no projeto.',
    res_learning_choose_one_p3: 'Também vale a pena verificar o que um recurso oferece e o que não oferece. Os cursos do OpenLearn, por exemplo, vêm com uma declaração de participação e alguns com um certificado digital que não é uma qualificação reconhecida. Se você precisa de uma qualificação formal para trabalhar ou estudar, é importante saber disso com antecedência, e a instituição para a qual você está se candidatando pode informar quais qualificações são aceitas.',
    res_learning_mit_ocw_note: 'Global. Notas de aula, provas e vídeos gratuitos de milhares de cursos do MIT, sem necessidade de cadastro. Em inglês.',
    res_learning_khan_academy_note: 'Global. Uma organização sem fins lucrativos que oferece aulas e exercícios gratuitos, com maior ênfase em matemática e ciências, em diversos idiomas.',
    res_learning_openlearn_note: 'Sediada no Reino Unido e aberta a todos. Quase 1.000 cursos curtos e gratuitos, com duração de 1 a 24 horas, cada um com um certificado de participação gratuito.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Os objetivos de trabalho são de longo prazo, e a maior parte do esforço acontece nos dias entre as conquistas. Estas dicas visam manter um ritmo constante, e os links são plataformas gratuitas para desenvolver habilidades e planejar seu próximo passo.',
    res_business_progress_title: 'O progresso no trabalho raramente é linear.',
    res_business_progress_p1: 'As metas de carreira e de negócios tendem a se estender por um longo período. Uma promoção, uma mudança de carreira ou o primeiro cliente podem levar meses, e os dias entre esses dois pontos raramente dão a sensação de progresso.',
    res_business_progress_p2: 'É útil separar o resultado desejado das tarefas que você realmente pode realizar esta semana. Você não controla se uma empresa vai te contratar ou se um cliente vai aceitar. Mas você controla quantas conversas terá, quanto tempo dedicará ao projeto e se cumprirá o que prometeu.',
    res_business_progress_p3: 'É aí que um parceiro de responsabilização mostra seu valor. Ele não precisa entender do seu setor. Basta perguntar o que você fez e ouvir a resposta sem transformá-la em um espetáculo.',
    res_business_progress_p4: 'Em algumas semanas, o relato honesto é: "Não aconteceu muita coisa". Vale a pena dizer isso em voz alta, porque uma meta que fica em segundo plano por um mês é muito mais difícil de retomar do que uma que você manteve viva, mesmo que de forma discreta.',
    res_business_start_from_you_title: 'Comece por você, não pelo trabalho.',
    res_business_start_from_you_p1: 'Quando as pessoas se sentem estagnadas no trabalho, o instinto costuma ser começar pelo mercado de trabalho: o que está contratando, o que paga bem, o que parece impressionante. Pode ser mais útil começar por outro lugar.',
    res_business_start_from_you_p2: 'O curso gratuito da OpenLearn, "Succeed in the workplace" (Tenha sucesso no ambiente de trabalho), baseia-se nessa ideia. Ele parte do princípio de que o autoconhecimento e o conhecimento dos seus valores são a base do planejamento de carreira, e somente depois aborda currículos, candidaturas e entrevistas.',
    res_business_start_from_you_p3: 'Em termos simples: como você quer que seus dias sejam? Em que você é bom, mas raramente recebe o devido reconhecimento? O que você se recusaria a abrir mão, seja tempo com a família, renda estável ou espaço para ser criativo?',
    res_business_start_from_you_p4: 'Você não precisa responder a tudo isso sozinho(a). Conversar sobre o assunto com seu(sua) parceiro(a) muitas vezes traz à tona coisas que você ignoraria se estivesse sozinho(a), e pode transformar um vago "Eu quero algo diferente" em uma meta na qual você realmente pode trabalhar.',
    res_business_wear_out_title: 'Trabalhar arduamente sem se esgotar.',
    res_business_wear_out_p1: 'A ambição e o esgotamento podem parecer semelhantes quando vistos de dentro, especialmente quando um objetivo é importante para você.',
    res_business_wear_out_p2: 'A Organização Mundial da Saúde observa que o trabalho pode proteger a saúde mental, mas também pode contribuir para o seu agravamento. Suas diretrizes sobre saúde mental no trabalho apontam para riscos como sobrecarga de trabalho e comportamentos negativos no ambiente laboral, e afirmam que a responsabilidade por um ambiente de trabalho saudável recai sobre os empregadores e governos, e não apenas sobre os trabalhadores individualmente.',
    res_business_wear_out_p3: 'Se você estiver conversando com seu parceiro sobre uma meta importante no trabalho, vale a pena perguntar não apenas "você conseguiu?", mas também "como você está se sentindo?". Uma meta perseguida à custa do seu sono, saúde ou relacionamentos merece ser repensada, mesmo que, no papel, esteja indo bem.',
    res_business_wear_out_p4: 'Se o trabalho estiver afetando sua saúde, ou se você estiver se sentindo persistentemente deprimido, ansioso ou exausto, por favor, converse com um médico ou outro profissional de saúde qualificado. Se você não tiver certeza sobre seus direitos trabalhistas, uma fonte local confiável, como uma agência do trabalho ou uma organização de trabalhadores, pode explicá-los para o seu local de residência. As regras variam muito de país para país.',
    res_business_who_mh_work_note: 'Global. Escrito principalmente para empregadores e governos, portanto, tem um tom técnico. O resumo executivo está disponível em árabe, chinês, inglês, francês, russo e espanhol.',
    res_business_openlearn_entrepreneurship_note: 'Curso sediado no Reino Unido. 24 horas divididas em 8 sessões, e você pode começar sem se inscrever. Parte do conteúdo aborda as leis comerciais do Reino Unido, portanto, verifique o que se aplica ao seu país.',
    res_business_openlearn_succeed_note: 'Aproximadamente 8 semanas, com cerca de 3 horas semanais, abordando planejamento de carreira, currículos e entrevistas. Última atualização em 2021, portanto, algumas partes sobre busca de emprego e mídias sociais podem estar desatualizadas.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Fuso horário',
    timezoneCurrentIs: 'Seu fuso horário atual é',
    timezoneLockNote: 'Seus limites diários de mensagens e mensagens de voz são redefinidos à meia-noite no seu fuso horário. Para manter a equidade, você só pode alterar seu fuso horário em um dia em que não tenha usado nenhuma mensagem ou mensagem de voz, e apenas uma vez a cada 7 dias.',
    timezoneNew: 'Selecione o fuso horário',
    saveTimezone: 'Salvar fuso horário',
    timezoneUpdated: 'Fuso horário atualizado',
    timezoneInvalid: 'Esse fuso horário não é válido. Por favor, selecione um da lista.',
    timezoneChangeError: 'Não foi possível alterar seu fuso horário. Tente novamente.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Projetos criativos tendem a existir nos intervalos entre as demais atividades. Estas peças tratam de manter algo vivo durante o longo período intermediário, e os links abrangem o aprendizado da escrita, o uso e o compartilhamento de trabalhos criativos.',
    res_creative_finishing_title: 'Finalizar também é uma habilidade.',
    res_creative_finishing_p1: 'Começar um projeto criativo é a parte fácil. A ideia é original e tudo parece possível. A parte difícil vem no meio, quando a ideia se transforma em trabalho concreto e o trabalho se torna mais lento e caótico do que a ideia inicial.',
    res_creative_finishing_p2: 'Geralmente é aí que os projetos emperram, e raramente é por falta de talento da pessoa. É mais comum que o processo intermediário não tenha uma linha de chegada à vista e ninguém esteja acompanhando.',
    res_creative_finishing_p3: 'É aqui que um parceiro que simplesmente pergunta “o que você fez esta semana?” pode fazer toda a diferença. Você não precisa que ele julgue. Saber que você descreverá sua semana dá ao trabalho um pequeno prazo, e um pequeno prazo geralmente é suficiente para te fazer voltar à mesa, à tela ou ao instrumento.',
    res_creative_finishing_p4: 'Também ajuda a definir o que significa "concluído" para o trabalho em questão. Uma versão finalizada, mesmo que em versão preliminar, vale mais do que uma versão perfeita que fica apenas na sua cabeça. Você sempre pode aprimorá-la depois de pronta.',
    res_creative_rough_drafts_title: 'Ninguém precisa ver a primeira versão.',
    res_creative_rough_drafts_p1: 'Muitas pessoas criativas desistem silenciosamente porque a primeira tentativa não é tão boa quanto a imagem que tinham em mente. Essa diferença entre o que você imagina e o que você consegue criar agora é normal. Ela costuma ser maior quando você mais se importa.',
    res_creative_rough_drafts_p2: 'Mostrar um rascunho para uma pessoa de confiança pode aliviar um pouco a pressão. Dizer ao parceiro "este é um rascunho incompleto, mas é isso que estou tentando fazer" transforma a situação em uma conversa, e não em um veredito. Você pode descobrir que ele se importa mais com o fato de você ter persistido do que com a qualidade do resultado.',
    res_creative_rough_drafts_p3: 'Se você é iniciante em uma arte, existem maneiras suaves de começar. O OpenLearn, site de aprendizagem gratuito da Open University, oferece um curso introdutório de escrita de ficção voltado para iniciantes. É apenas um exemplo entre muitos, e se adequa mais a escritores do que a outros tipos de criadores.',
    res_creative_rough_drafts_p4: 'O progresso no trabalho criativo raramente se apresenta como uma melhora constante. Algumas semanas você cria algo de que se orgulha, e outras semanas cria algo que jamais mostrará a ninguém. Ambos contam, e ambos fazem parte do mesmo hábito.',
    res_creative_using_sharing_title: 'Utilizando o trabalho de outras pessoas e compartilhando o seu próprio.',
    res_creative_using_sharing_p1: 'Projetos criativos frequentemente envolvem material de terceiros, como imagens, sons ou textos, e eventualmente você pode querer compartilhar o seu próprio. Um pouco de contexto ajuda em ambos os casos.',
    res_creative_using_sharing_p2: 'Creative Commons é uma organização sem fins lucrativos que publica licenças que permitem aos criadores manter seus direitos autorais, ao mesmo tempo que autorizam outros a usar suas obras da maneira que o criador escolher. Se você deseja compartilhar algo que criou, as diretrizes da organização explicam como essas licenças funcionam.',
    res_creative_using_sharing_p3: 'Algumas instituições vão além. O Smithsonian disponibilizou milhões de imagens e dados sob a licença CC0, o que significa que você pode usá-los sem pedir permissão ao Smithsonian, inclusive para projetos criativos. Mas as próprias perguntas frequentes da instituição ressaltam que a CC0 cobre apenas os direitos autorais. Outros direitos, como privacidade ou marca registrada, ainda podem ser aplicáveis, e alguns itens de suas coleções não estão incluídos.',
    res_creative_using_sharing_p4: 'As regras de direitos autorais variam de país para país, e esta é uma informação geral, não constituindo aconselhamento jurídico. Se um projeto for comercialmente importante ou se você tiver dúvidas sobre a possibilidade de usar algo, um profissional qualificado poderá orientá-lo sobre seus direitos.',
    res_creative_openlearn_fiction_note: 'Sediado no Reino Unido, com inscrição gratuita. Um curso introdutório sobre escrita de ficção, com declaração de participação gratuita. É mais indicado para escritores do que para outros tipos de criadores.',
    res_creative_cc_license_note: 'Global. Como permitir que outros usem seu trabalho nos termos que você escolher, mantendo seus direitos autorais. Informações gerais, não constituem aconselhamento jurídico.',
    res_creative_smithsonian_open_access_note: 'Instituição americana, uso gratuito para qualquer pessoa. Explica as imagens e os dados liberados sob a licença CC0, o que ela permite e o que não permite, e quais itens são excluídos.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Os relacionamentos são construídos mais por meio de pequenas coisas repetidas do que por grandes momentos. Estes textos abordam a importância de manter conexões vivas, o que as pesquisas indicam ser mais relevante e o que fazer quando a conexão é difícil ou um relacionamento se torna inseguro.',
    res_relationships_small_gestures_title: 'Pequenos gestos contam',
    res_relationships_small_gestures_p1: 'Muitos de nós encaramos amizades e laços familiares como algo que ou existe ou não existe. Robert Waldinger, diretor do Estudo de Desenvolvimento Adulto de Harvard, descreve a vida social como um sistema vivo que precisa de manutenção, assim como o condicionamento físico.',
    res_relationships_small_gestures_p2: 'A manutenção pode ser mínima. Pense em alguém de quem você sente falta e envie uma mensagem. A lista de ações diárias da Organização Mundial da Saúde é igualmente modesta: entrar em contato com um amigo, guardar o celular para estar realmente presente em uma conversa, cumprimentar um vizinho, participar de um grupo local ou fazer trabalho voluntário.',
    res_relationships_small_gestures_p3: 'Para uma meta que você compartilha com um parceiro de responsabilidade, esta é uma boa pergunta semanal: com quem você entrou em contato? É algo concreto, simples e você pode responder honestamente mesmo em uma semana difícil.',
    res_relationships_small_gestures_p4: 'Nem todas as mensagens recebem uma resposta calorosa, e isso faz parte do processo. Waldinger diz que as pessoas muitas vezes se surpreendem com a receptividade calorosa de mensagens simples como essas.',
    res_relationships_quality_title: 'Qualidade acima de quantidade',
    res_relationships_quality_p1: 'É fácil medir a vida social pela quantidade de pessoas com quem se convive: quantos amigos, quantos eventos, se está em um relacionamento. A pesquisa aponta para outra direção.',
    res_relationships_quality_p2: 'O Estudo de Desenvolvimento Adulto de Harvard acompanha pessoas desde 1938. Quando seus pesquisadores analisaram a vida dos participantes na meia-idade, a satisfação em seus relacionamentos, particularmente nos casamentos, previu quem seria feliz e saudável aos 80 anos melhor do que fatores como colesterol ou pressão arterial. O diretor do estudo afirma que outros grupos de pesquisa chegaram à mesma conclusão desde então. Ele também diz que não há um número determinado de conexões necessárias e que pessoas tímidas podem precisar de menos do que extrovertidas.',
    res_relationships_quality_p3: 'Uma ressalva: os primeiros participantes do estudo foram estudantes de Harvard e jovens adultos de uma cidade americana, portanto, não representa a realidade de todos. É importante não tirar conclusões definitivas.',
    res_relationships_quality_p4: 'O que isso sugere, de forma sutil, é que pelo menos um relacionamento sólido, alguém a quem você possa ligar se estiver doente ou com medo, importa mais do que um grande círculo de amigos. E raramente é tarde demais. O diretor do estudo descreve pessoas que encontraram amizades profundas ou o amor tardiamente na vida, quando menos esperavam.',
    res_relationships_hard_times_title: 'Quando a conexão é difícil e quando um relacionamento dói',
    res_relationships_hard_times_p1: 'Sentir-se sozinho não significa que há algo de errado com você. A Organização Mundial da Saúde estima que cerca de uma em cada seis pessoas no mundo experimenta a solidão, em todas as faixas etárias. Ela descreve a solidão como o sentimento doloroso que surge quando as conexões que você tem não correspondem às que você deseja.',
    res_relationships_hard_times_p2: 'As causas podem incluir problemas de saúde, baixa renda, viver sozinho ou a forma como usamos a tecnologia. A OMS observa que, se o problema for mais sério, vale a pena descobrir quais serviços e apoios estão disponíveis.',
    res_relationships_hard_times_p3: 'Existe outro lado: relacionamentos que causam danos. Comportamentos nocivos em um relacionamento incluem abuso psicológico e comportamento controlador, bem como violência física ou sexual.',
    res_relationships_hard_times_p4: 'Se você tem medo de alguém próximo ou está sendo agredido(a), entre em contato com o número de emergência local ou com uma linha de ajuda ou serviço de apoio local. Os números corretos variam de acordo com o país, e um parceiro da Veyl é um colega, não um conselheiro treinado. Se a situação parecer difícil demais para suportar, um médico ou conselheiro pode ajudar.',
    res_relationships_who_social_connection_note: 'Global. Um resumo breve e sem jargões do relatório da OMS de 2025 sobre solidão e conexão social (13 páginas).',
    res_relationships_harvard_gazette_note: 'Fonte americana. Uma sessão de perguntas e respostas com o diretor do Estudo de Desenvolvimento Adulto de Harvard sobre o que a pesquisa revela a respeito de relacionamentos e saúde, incluindo pequenas mudanças no dia a dia. Trata-se de uma entrevista, e os primeiros participantes do estudo eram de uma cidade americana.',
    res_relationships_who_violence_note: 'Global. Explica o que é violência doméstica e quão comum ela é, afetando principalmente mulheres. É um documento informativo, não um serviço de apoio telefônico, e pode ser difícil de ler.',
  },

  de: {
    appName: 'Veyl',
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    back: 'Zurück',
    continue: 'Weiter',
    done: 'Fertig',
    error: 'Fehler',
    submit: 'Einreichen',
    send: 'Senden',
    delete: 'Löschen',
    leave: 'Verlassen',
    stay: 'Bleiben',
    yes: 'Ja',
    no: 'Nein',
    upgrade: 'Auf Premium upgraden',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signOut: 'Abmelden',
    email: 'E-Mail',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordSent: 'E-Mail zum Zurücksetzen gesendet. Prüfen Sie Ihren Posteingang.',
    noAccount: 'Kein Konto?',
    hasAccount: 'Bereits ein Konto?',
    authError: 'Authentifizierungsfehler. Bitte versuchen Sie es erneut.',
    landingHero: 'Verantwortlichkeit, die wirklich funktioniert',
    landingSubtitle: 'Finden Sie einen anonymen Partner, der Ihr Ziel teilt. Kein sozialer Druck. Nur Ergebnisse.',
    getStarted: 'Loslegen — Kostenlos',
    howItWorks: 'Wie es funktioniert',
    step1Title: 'Setzen Sie Ihr Ziel',
    step1Desc: 'Sagen Sie uns, woran Sie arbeiten. Wir verbinden Sie mit jemandem auf einem ähnlichen Weg.',
    step2Title: 'Treffen Sie Ihren Partner',
    step2Desc: 'Werden Sie mit einem anonymen Verantwortlichkeitspartner in Ihrer Zeitzone zusammengebracht.',
    step3Title: 'Bleiben Sie verantwortlich',
    step3Desc: 'Tägliche Check-ins, Fortschritt teilen und gegenseitige Unterstützung — anonym.',
    pricingTitle: 'Einfache Preise',
    freePlan: 'Kostenlos',
    premiumPlan: 'Premium',
    perMonth: '/Monat',
    freeFeature1: '1 aktives Veyl',
    freeFeature2: '10 Nachrichten/Tag',
    freeFeature3: '10 Sprachnotizen/Tag',
    freeFeature4: 'Tägliche und wöchentliche Check-ins',
    freeFeature5: 'Gruppen-Chat-Zugang',
    premiumFeature1: 'Bis zu 3 aktive Veyls',
    premiumFeature2: 'Unbegrenzte Nachrichten',
    premiumFeature3: 'Unbegrenzte Sprachnotizen',
    premiumFeature4: 'Prioritäts-Matching',
    faqTitle: 'Häufig gestellte Fragen',
    welcomeToVeyl: 'Willkommen bei Veyl',
    chooseLanguage: 'Wählen Sie Ihre Sprache',
    chooseLanguageDesc: 'Wählen Sie die Sprache, in der Sie Veyl verwenden möchten.',
    ageVerification: 'Altersverifizierung',
    ageVerificationDesc: 'Veyl ist für Benutzer ab 13 Jahren verfügbar.',
    areYouOldEnough: 'Sind Sie 13 Jahre oder älter?',
    yesIAm: '✅ Ja, ich bin',
    noImNot: '❌ Nein, ich bin nicht',
    mustBe13: 'Sie müssen mindestens 13 Jahre alt sein',
    mustBe13Desc: 'Veyl ist nur für Benutzer ab 13 Jahren verfügbar.',
    setupProfile: 'Lassen Sie uns Ihr Profil einrichten',
    stepOf: 'Schritt {step} von 4',
    whatsYourName: 'Wie heißen Sie?',
    namePlaceholder: 'Gib deinen Spitznamen ein',
    whatsYourTimezone: 'Was ist Ihre Zeitzone?',
    selectTimezone: 'Zeitzone auswählen',
    goalCategory: 'Was ist die Kategorie Ihres Ziels?',
    matchPreference: 'Mit wem möchten Sie gematcht werden?',
    matchNearby: 'In der Nähe matchen',
    matchNearbyDesc: 'Mit Personen innerhalb von 4 Stunden Ihrer Zeitzone matchen.',
    matchAnywhere: 'Überall matchen',
    matchAnywhereDesc: 'Mit jedem weltweit matchen, unabhängig von der Zeitzone.',
    describeGoal: 'Beschreiben Sie Ihr spezifisches Ziel',
    goalPlaceholder: "Z.B. 'Ich möchte 15 kg abnehmen' oder 'Python lernen'",
    communicationStyle: 'Bevorzugter Kommunikationsstil',
    textMessages: 'Textnachrichten',
    textMessagesDesc: 'Chatten Sie, wann es passt',
    scheduledCheckins: 'Geplante Check-ins',
    scheduledCheckinsDesc: 'Wöchentliche Tiefenreflexionen',
    completingSetup: 'Suche Partner...',
    completeSetup: 'Einrichtung abschließen',
    agreeToTerms: 'Durch Fortfahren stimmen Sie den',
    termsOfService: 'Nutzungsbedingungen',
    and: 'und der',
    privacyPolicy: 'Datenschutzrichtlinie',
    fitnessHealth: 'Fitness und Gesundheit',
    learningSkills: 'Lernen und Fähigkeiten',
    businessCareer: 'Business und Karriere',
    creativeProjects: 'Kreative Projekte',
    findingMatch: 'Suche nach Ihrem Partner...',
    findingNewMatch: 'Suche nach Ihrem neuen Partner...',
    lookingForSomeone: 'Wir suchen jemanden in der Kategorie',
    category: '',
    sharesTimezone: 'der Ihre Zeitzone und Ihr Engagement teilt.',
    autoCheck: 'Wir prüfen Übereinstimmungen automatisch alle 5 Sekunden.',
    noMatchYet: 'Noch keine Übereinstimmung gefunden — wir versuchen es weiter.',
    checkNow: 'Jetzt prüfen',
    checking: 'Prüfen...',
    manualChecks: '{count} manuelle Prüfung{plural} durchgeführt',
    joinCommunity: '🌐 Community beitreten während Sie warten',
    goToCommunity: '🌐 Zur Community gehen',
    previousPartnerNote: '🛡️ Ihr vorheriger Partner wird nicht mehr vorgeschlagen.',
    joining: 'Beitreten...',
    overview: 'Übersicht',
    chat: 'Chat',
    checkin: 'Check-in',
    group: 'Gruppe',
    community: 'Community',
    notifications: 'Benachrichtigungen',
    settings: 'Einstellungen',
    yourGoal: 'Ihr Ziel',
    yourPartner: 'Ihr Partner',
    you: 'Sie',
    unveiled: '✨ Enthüllt',
    goalComplete: '✓ Ziel erreicht',
    adjustGoal: 'Mein Ziel anpassen',
    unveilButton: '✨ Enthüllen — Sie haben es geschafft!',
    goalCategory2: 'Kategorie',
    goalDescription: 'Beschreibung',
    timezone: 'Zeitzone',
    loadingPartner: 'Partnerinformationen werden geladen...',
    waitingForMatch: 'Warten auf eine Übereinstimmung zum Starten des Chats.',
    noMessagesYet: 'Noch keine Nachrichten. Sagen Sie Ihrem Partner Hallo!',
    typeMessage: 'Geben Sie Ihre Nachricht ein...',
    dailyLimitReached: 'Tageslimit erreicht — Auf Premium upgraden',
    unmatch: '🔓 Trennen',
    report: '🚩 Melden',
    unmatchWarning: '⚠️ Das Trennen löscht Ihren gesamten Chat-Verlauf. Diese Aktion kann nicht rückgängig gemacht werden.',
    yesUnmatch: 'Ja, trennen',
    unmatching: 'Trennen...',
    deleteMessage: '🗑 Löschen',
    deleting: 'Löschen...',
    checkIn: 'Check-in',
    submitDaily: 'Täglichen Check-in einreichen',
    submitWeekly: 'Wöchentlichen Check-in einreichen',
    submitting: 'Einreichen...',
    checkinSubmitted: 'Check-in eingereicht!',
    viewHistory: 'Meine Historie anzeigen',
    notificationsTitle: 'Benachrichtigungen',
    clearAll: 'Alle löschen',
    noNotifications: 'Noch keine Benachrichtigungen.',
    settingsTitle: 'Einstellungen',
    settingsDesc: 'Personalisieren Sie Ihre anonyme Identität.',
    saveAvatar: 'Avatar speichern',
    appearance: 'Erscheinungsbild',
    lightMode: '☀️ Hell',
    darkMode: '🌙 Dunkel',
    changeNickname: 'Spitznamen ändern',
    saveNickname: 'Spitznamen speichern',
    deleteAccount: 'Konto löschen',
    deleteAccountDesc: 'Löscht Ihr Konto und alle zugehörigen Daten dauerhaft.',
    languageLabel: 'Sprache',
    languageDesc: 'Wählen Sie Ihre bevorzugte Sprache.',
    signOut: 'Abmelden',
    updating: 'Aktualisierung...',
    unveil: 'Enthüllen',
    clearing: 'Löschen...',
    notifMatchFound: 'Übereinstimmung gefunden',
    notifGoalAchieved: 'Ziel erreicht',
    notifSupport: 'Unterstützungsnachrichten',
    notifUnmatched: 'Trennungsbenachrichtigungen',
    notifMatchRequest: 'Übereinstimmungsanfragen',
    notificationPrefs: 'Benachrichtigungseinstellungen',
    notificationPrefsDesc: 'Bestimmte Benachrichtigungstypen individuell stummschalten.',
    muted: 'Stummgeschaltet',
    active: 'Aktiv',
    all: 'Alle',
    justNow: 'Gerade eben',
    minsAgo: 'Vor {count}m',
    hoursAgo: 'Vor {count}h',
    daysAgo: 'Vor {count}d',
    leaving: 'Verlassen...',
    myHistory: '📋 Meine Historie',
    partnersProgress: '👤 Fortschritt von {name}',
    myCheckinHistory: 'Meine Check-in-Historie',
    checkinsForVeyl: '{count} Check-in{plural} für dieses Veyl',
    noCheckinsYet: 'Noch keine Check-ins. Starten Sie den ersten!',
    newCheckinBtn: 'Neuer Check-in',
    partnerNoCheckins: '{name} hat noch keinen Check-in gemacht.',
    dailyNotesPrivate: 'Tägliche Notizen sind privat',
    goalAchievedMarked: '🎉 Ziel als erreicht markiert',
    goalAchievedNote: '🎉 Ihr Ziel ist als erreicht markiert! Gehen Sie zur Übersicht, um es zu enthüllen.',
    veylComplete: '✓ Dieses Veyl ist abgeschlossen. Check-ins sind schreibgeschützt.',
    goalAlreadyAchieved: '🎉 Sie haben Ihr Ziel als erreicht markiert! Gehen Sie zur Übersicht, um es zu enthüllen.',
    didYouWork: 'Haben Sie heute an Ihrem Ziel gearbeitet?',
    howDidWeekGo: 'Wie lief diese Woche mit Ihrem Ziel?',
    whatGotInWay: 'Was hat Sie aufgehalten? (Optional)',
    honestNote: 'Seien Sie ehrlich. Ihr Partner ist hier, um Sie zu unterstützen, nicht zu urteilen.',
    whatDidYouLearn: 'Was haben Sie diese Woche über sich selbst gelernt?',
    insightsPlaceholder: 'Welche Erkenntnisse haben Sie gewonnen?',
    whatPatterns: 'Welches Muster bemerken Sie?',
    patternsPlaceholder: 'Wiederkehrende Themen oder Hindernisse?',
    whatChange: 'Was muss sich für nächste Woche ändern?',
    changePlaceholder: 'Was werden Sie anders machen?',
    goalAchievedQuestion: '🏆 Haben Sie Ihr Gesamtziel erreicht?',
    yesDidIt: '🎉 Ja, ich habe es geschafft!',
    notYetBtn: 'Noch nicht',
    didIt: '✅ Erledigt',
    didSome: '😐 Etwas erledigt',
    didntDoIt: '❌ Nicht erledigt',
    metCommitment: '✅ Verpflichtung erfüllt',
    partialProgress: '😐 Teilweise Fortschritte',
    noProgress: '❌ Kein Fortschritt',
    rethinkingGoal: '🤔 Ziel überdenken',
    yesLabel: '✅ Ja',
    aLittle: '😐 Ein wenig',
    noLabel: '❌ Nein',
    madeProgress: 'Heute Fortschritte gemacht',
    didSomething: 'Etwas getan, nicht alles',
    didntWork: 'Heute nicht daran gearbeitet',
    metWeekly: 'Wöchentliche Verpflichtung erfüllt',
    madePartial: 'Teilweise Fortschritte gemacht',
    didntMake: 'Keine Fortschritte gemacht',
    needToAdjust: 'Meinen Ansatz anpassen',
    learnedLabel: 'Gelernt: ',
    patternLabel: 'Muster: ',
    nextWeekLabel: 'Nächste Woche: ',
    joinGroup: 'Einer Gruppe beitreten',
    joinGroupDesc: 'Gruppen bringen bis zu 5 Personen zusammen, die an ähnlichen Zielen arbeiten. Anonym, unterstützend, kein Druck.',
    whatToExpect: 'WAS SIE ERWARTEN KÖNNEN',
    expectAnonymous: 'Alle bleiben anonym — gleiche Silhouetten-Avatare',
    expectMatched: 'Nach Zielkategorie für relevante Unterstützung zusammengestellt',
    expectMembers: 'Bis zu 5 Mitglieder pro Gruppe',
    expectChat: 'Gruppen-Chat — 20 Nachrichten und 5 Sprachnotizen/Tag kostenlos · Unbegrenzt mit Premium',
    findOrCreate: 'Gruppe finden oder erstellen',
    findingGroup: 'Ihre Gruppe wird gesucht...',
    oneGroupNote: 'Sie können immer nur in einer Gruppe sein. Kostenlose und Premium-Nutzer haben beide Gruppenzugang.',
    groupCreated: 'Gruppe erstellt!',
    groupJoined: 'Gruppe beigetreten!',
    groupCreatedDesc: 'Sie haben eine neue {category}-Gruppe gestartet. Andere werden bald beitreten.',
    groupJoinedDesc: 'Sie sind einer bestehenden {category}-Gruppe beigetreten. Sagen Sie Hallo!',
    switchToGroup: 'Wechseln Sie in Ihrem Dashboard zur Gruppen-Registerkarte, um zu chatten.',
    groupMembers: 'Gruppenmitglieder',
    backToChat: '← Zurück zum Chat',
    creator: '★ Ersteller',
    joined: 'Beigetreten',
    leaveGroup: 'Gruppe verlassen',
    leaveGroupTitle: 'Diese Gruppe verlassen?',
    leaveGroupDesc: 'Sie verlieren den Zugang zum Gruppen-Chat und können jederzeit einer neuen Gruppe beitreten.',
    membersBtn: '👥 Mitglieder',
    noGroupMessages: 'Noch keine Nachrichten. Seien Sie der Erste, der Hallo sagt!',
    messageGroup: 'Nachricht an Ihre Gruppe...',
    groupDailyLimit: 'Sie haben Ihr tägliches Gruppennachrichtenlimit erreicht ({limit}/Tag). Upgraden Sie auf Premium für unbegrenzte Nachrichten!',
    groupVoiceLimit: 'Tägliches Sprachnotizlimit erreicht.',
    veylCommunity: 'Veyl Community',
    communityDesc: 'Schließen Sie sich anderen an, die an derselben Zielkategorie arbeiten, während Sie auf eine Übereinstimmung warten.',
    communityJoinNote: 'Treten Sie der Community von der Warteseite bei, während Sie eine Übereinstimmung suchen.',
    leaveCommunity: 'Diese Community verlassen?',
    communityLeaveDesc: 'Sie können jederzeit von der Warteseite wieder beitreten.',
    matchRequests: 'Übereinstimmungsanfragen',
    incoming: 'Eingehend',
    sent: 'Gesendet',
    noIncoming: 'Keine eingehenden Anfragen.',
    noPending: 'Keine gesendeten ausstehenden Anfragen.',
    requestToAnonymous: 'Anfrage an anonymen Benutzer',
    pending: 'Ausstehend',
    decline: 'Ablehnen',
    accept: '✅ Annehmen',
    requestWaiting: '🤝 {count} Übereinstimmungsanfrage{plural} wartet auf Sie',
    view: 'Ansehen',
    requestsBtn: '🤝 Anfragen',
    leaveBtn: 'Verlassen',
    openToAll: 'Offen für alle · Anonym',
    msgsLeft: '{count} Nachrichten übrig',
    noCommunityMessages: 'Noch keine Nachrichten. Sagen Sie der Community Hallo!',
    saySomething: 'Sagen Sie der Community etwas...',
    requestMatch: '🤝 Übereinstimmung anfragen',
    requestSending: 'Senden...',
    communityMsgsWarning: '{count} Community-Nachrichten heute noch übrig.',
    communityDailyLimit: 'Sie haben Ihr tägliches Community-Nachrichtenlimit erreicht ({limit}/Tag). Upgraden Sie auf Premium für unbegrenzte Nachrichten!',
    matchRequestLimit: 'Sie können nur 3 ausstehende Anfragen gleichzeitig haben.',
    matchRequestSent: 'Übereinstimmungsanfrage erfolgreich gesendet!',
    matchRequestDuplicate: 'Sie haben bereits eine Anfrage an diese Person gesendet.',
    matchRequestError: 'Fehler beim Senden der Übereinstimmungsanfrage. Bitte versuchen Sie es erneut.',
    matchAcceptError: 'Fehler beim Annehmen der Übereinstimmungsanfrage.',
    matchRequestSentAlready: 'Sie haben bereits eine Anfrage an diese Person gesendet.',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Blaugrün',
    avatar_purple: 'Lila',
    avatar_navy: 'Marine',
    avatar_slate: 'Schiefer',
    avatar_coral: 'Koralle',
    avatar_gold: 'Gold',
    avatar_moss: 'Moos',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'Enthüllt',
    activeLabel: 'Aktiv',
    seekingLabel: 'Suchend',
    completeLabel: 'Abgeschlossen',
    upgradeForMore: '✨ Upgrade für mehr Veyls',
    newVeyl: '+ Neues Veyl',
    newVeylTitle: 'Neues Veyl starten',
    goalCategoryLabel: 'Zielkategorie',
    goalDescriptionLabel: 'Zielbeschreibung',
    startVeyl: 'Neues Veyl starten',
    starting: 'Wird gestartet...',
    unveil: 'Enthüllen',
    clearing: 'Löschen...',
    nicknameRequired: 'Spitzname ist erforderlich',
    nicknameTooShort: 'Spitzname muss mindestens 2 Zeichen lang sein',
    nicknameTooLong: 'Spitzname darf maximal 20 Zeichen lang sein',
    errorSavingNickname: 'Fehler beim Speichern des Spitznamens',
    errorSavingAvatar: 'Fehler beim Speichern des Avatars',
    errorDeletingAccount: 'Fehler beim Löschen des Kontos',
    deleteMyAccountButton: 'Mein Konto löschen',
    goalsAchievedTitle: 'Erreichte Ziele',
    goalsPrivate: 'Privat — nur für Sie sichtbar.',
    goalsCompletedCount: '{count} Ziele abgeschlossen',
    keepAnonymous: 'Bleiben Sie anonym. Verwenden Sie nicht Ihren echten Namen.',
    currentNicknameIs: 'Ihr aktueller Spitzname ist',
    unveiledLocked: '✨ Enthüllt — Avatar gesperrt',
    howOthersSee: 'So sehen andere Sie',
    unveiledNote: 'Sie haben sich in diesem Veyl enthüllt. Starten Sie ein neues Veyl für einen neuen Avatar.',
    active2: '✓ Aktiv',
    goalsAchieved: 'Erreichte Ziele',
    goalsAchievedDesc: 'Privat — nur für Sie sichtbar.',
    goalCompleted: 'Ziel abgeschlossen',
    goalsCompleted: 'Ziele abgeschlossen',
    contactSupport: 'Support kontaktieren',
    deleteWarning: '⚠️ Dies löscht alles dauerhaft. Geben Sie LÖSCHEN ein, um zu bestätigen.',
    typeDelete: 'Geben Sie LÖSCHEN ein, um zu bestätigen',
    confirmDelete: 'Löschen bestätigen',
    deleting2: 'Wird gelöscht...',
    messagesLeft: '{count} Nachrichten · {voiceCount} Sprachnotizen heute noch übrig',
    premiumUnlimited: '✨ Premium — Unbegrenzte Nachrichten und Sprachnotizen',
    messagesLeftWarning: '{count} Nachrichten heute noch übrig.',
    forUnlimited: 'für unbegrenzte Nachrichten.',
    voiceNotesLeft: '{count} Sprachnotiz{plural} heute noch übrig',
    dailyLimitReachedVoice: 'Tägliches Sprachnotizlimit erreicht.',
    dailyVoiceNoteLimit: 'Tägliches Sprachnotizlimit erreicht. Upgraden Sie auf Premium für unbegrenzte Notizen.',
    recording: 'Aufnahme...',
    deeper: 'Tiefer',
    neutral: 'Neutral',
    higher: 'Höher',
    applyingModulation: '⚙️ Modulation wird angewendet...',
    preview: '▶ Vorschau',
    pause: '⏸ Pause',
    discard: 'Verwerfen',
    recordingTooLarge: 'Aufnahme zu groß. Bitte versuchen Sie eine kürzere Nachricht.',
    failedToSend: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    micDenied: 'Mikrofonzugriff verweigert.',
    unmatchMessage: 'Ihr Partner hat diese Veyl-Sitzung beendet. Sie wurden zur Übereinstimmungssuche zurückgegeben.',
    appearanceDesc: 'Wählen Sie, wie Veyl für Sie aussieht.',
    newNickname: 'Neuer Spitzname',
    nicknamePlaceholder: 'z.B. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Wählen Sie Ihren Avatar',
    notificationsTitle: 'Benachrichtigungen',
    notificationsCount: '{total} gesamt · {unread} ungelesen',
    progressOf: 'Fortschritt von {name}',
    fitnessHealth: 'Fitness & Gesundheit',
    learningSkills: 'Lernen & Fähigkeiten',
    businessCareer: 'Business & Karriere',
    creativeProjects: 'Kreative Projekte',
    progressOf: 'Fortschritt von {name}',
    dailyCheckin: 'Tägliches Check-in',
    weeklyCheckin: 'Wöchentliches Check-in',
    dailyCheckinDesc: 'Kurzes Update: Hast du heute an deinem Ziel gearbeitet?',
    weeklyCheckinDesc: 'Tiefe Reflexion: Wie lief diese Woche insgesamt?',
    submitDaily: 'Tägliches Check-in einreichen',
    submitWeekly: 'Wöchentliches Check-in einreichen',
    submitting: 'Wird gesendet...',
    checkinSubmitted: 'Check-in eingereicht!',
    checkinSubmittedDesc: 'Gut gemacht, dass du verantwortlich bleibst. {name} wird dein Update sehen.',
    viewHistory: 'Meine Historie ansehen',
    newCheckin: '📝 Neues Check-in',
    myHistory: '📋 Meine Historie',
    partnersProgress: '👤 Fortschritt von {name}',
    myCheckinHistory: 'Meine Check-in-Historie',
    checkinsForVeyl: '{count} Check-in{plural} für dieses Veyl',
    noCheckinsYet: 'Noch keine Check-ins. Starte dein erstes!',
    newCheckinBtn: 'Neues Check-in',
    partnerNoCheckins: '{name} hat noch kein Check-in gemacht.',
    dailyNotesPrivate: 'Tägliche Notizen sind privat',
    goalAchievedMarked: '🎉 Ziel als erreicht markiert',
    goalAchievedNote: '🎉 Dein Ziel ist als erreicht markiert! Gehe zu Übersicht zum Enthüllen.',
    veylComplete: '✓ Dieses Veyl ist abgeschlossen. Check-ins sind schreibgeschützt.',
    goalAlreadyAchieved: '🎉 Du hast dein Ziel als erreicht markiert! Gehe zu Übersicht zum Enthüllen.',
    didYouWork: 'Hast du heute an deinem Ziel gearbeitet?',
    howDidWeekGo: 'Wie lief diese Woche mit deinem Ziel?',
    whatGotInWay: 'Was hat dich aufgehalten? (Optional)',
    honestNote: 'Sei ehrlich. Dein Partner ist hier, um dich zu unterstützen, nicht zu urteilen.',
    whatDidYouLearn: 'Was hast du diese Woche über dich gelernt?',
    insightsPlaceholder: 'Welche Erkenntnisse hast du gewonnen?',
    whatPatterns: 'Welches Muster bemerkst du?',
    patternsPlaceholder: 'Wiederkehrende Themen oder Hindernisse?',
    whatChange: 'Was muss sich nächste Woche ändern?',
    changePlaceholder: 'Was wirst du anders machen?',
    goalAchievedQuestion: '🏆 Hast du dein Gesamtziel erreicht?',
    yesDidIt: '🎉 Ja, ich hab es geschafft!',
    notYetBtn: 'Noch nicht',
    didIt: '✅ Geschafft',
    didSome: '😐 Ein bisschen',
    didntDoIt: '❌ Nicht geschafft',
    metCommitment: '✅ Verpflichtung erfüllt',
    madePartial: '😐 Teilweise Fortschritte',
    didntMake: '❌ Keine Fortschritte',
    needToAdjust: '🤔 Muss meinen Ansatz anpassen',
    yesLabel: '✅ Ja',
    aLittle: '😐 Ein bisschen',
    noLabel: '❌ Nein',
    madeProgress: 'Heute Fortschritte gemacht',
    didSomething: 'Etwas getan, nicht alles',
    didntWork: 'Heute nicht daran gearbeitet',
    metWeekly: 'Wöchentliche Verpflichtung erfüllt',
    didntMake: 'Keine Fortschritte gemacht',
    needToAdjust: 'Muss meinen Ansatz anpassen',
    learnedLabel: 'Gelernt: ',
    patternLabel: 'Muster: ',
    nextWeekLabel: 'Nächste Woche: ',
    problemTitle: 'Social Media hat Verantwortlichkeit ruiniert',
    problem1: "Du hast Angst zuzugeben, wenn du kämpfst",
    problem2: "Du versteckst Misserfolge statt von ihnen zu lernen",
    problem3: "Du ghostest deine Partner wenn du scheiterst",
    veylIsDifferent: 'Veyl ist anders.',
    popular: 'BELIEBT',
    sixMonthDeal: 'oder $20 für 6 Monate ($3,33/Monat)',
    getStartedPremium: 'Loslegen',
    buildTrust: 'Vertrauen aufbauen',
    unveilIdentity: 'Enthülle deine Identität, wenn (oder falls) du bereit bist',
    actuallyAchieve: 'Wirklich erreichen',
    makeRealProgress: 'Mache echte Fortschritte ohne die Vorstellung',
    faq1q: 'Was, wenn mein Partner und ich nicht harmonieren?',
    faq1a: 'Einfaches Rematch. Keine Fragen gestellt. Wir möchten lieber, dass du die richtige Person findest, als eine nicht funktionierende Partnerschaft zu erzwingen.',
    faq2q: 'Muss ich mich irgendwann enthüllen?',
    faq2a: 'Nein. Manche Partnerschaften bleiben dauerhaft anonym. Manche enthüllen sich nach einer Woche. Das liegt ganz bei dir.',
    faq3q: 'Was, wenn mein Partner mich ghostet?',
    faq3a: 'Premium-Nutzer erhalten ein sofortiges Rematch. Kostenlose Nutzer werden innerhalb von 48 Stunden erneut gematcht.',
    faq4q: 'Warum nie Profilbilder?',
    faq4a: 'Weil es in dem Moment, in dem du Fotos hinzufügst, darum geht, die Wahrnehmung zu steuern. Wir haben es getestet. Anonymität hält den Fokus auf der Arbeit.',
    legalEnglishOnly: 'Dieses Dokument ist nur auf Englisch verfügbar. Bei Fragen wenden Sie sich bitte an den Support oder nutzen Sie die Übersetzungsfunktion Ihres Browsers.',
    ctaTitle: "Bereit, deine Ziele wirklich zu erreichen?",
    ctaSubtitle: "Tritt Veyl bei und finde noch heute einen Verantwortlichkeitspartner. Der Start ist kostenlos.",
    statAnonymous: "Anonym",
    statLanguages: "Sprachen",
    statToStart: "Zum Start",
    authTagline: "Anonyme Verantwortlichkeit. Echte Ergebnisse.",
    authPricing: "Kostenlos starten · Premium ab 5$/Monat",
    taglineHonest: "Ehrlich",
    taglineEffective: "Effektiv",
    foreverLabel: "/für immer",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Auf Premium upgraden",
    premiumActiveDesc: "Du hast unbegrenzten Zugang zu allen Veyl-Funktionen.",
    upgradeDesc: "Entferne alle Limits und erlebe Veyl in vollem Umfang.",
    billedMonthly: "Monatlich abgerechnet",
    bestValue: "BESTER WERT",
    perSixMonths: "3,33$/Monat",
    unlimitedMessages: "Unbegrenzte Nachrichten",
    unlimitedVoice: "Unbegrenzte Sprachnotizen",
    unlimitedGroup: "Unbegrenzte Gruppe",
    unlimitedCommunity: "Unbegrenzte Community",
    was10day: "war 10/Tag",
    was5day: "war 5/Tag",
    was20day: "war 20/Tag",
    was30day: "war 30/Tag",
    sixMonthPlan: "6-Monats-Plan",
    monthlyPlan: "Monatsplan",
    modulationFailed: "Modulation fehlgeschlagen — Originalstimme wird verwendet",
    monthly: "Monatlich",
    sixMonths: "6 Monate",
    savePercent: "Spare {{percent}}%",
    pricePerMonth: "${{price}} / Monat",
    priceTotal: "${{price}} gesamt",
    unlimitedMessages: "Unbegrenzte Nachrichten",
    unlimitedVoiceNotes: "Unbegrenzte Sprachnotizen",
    unlimitedGroupMessages: "Unbegrenzte Gruppennachrichten",
    unlimitedCommunityMessages: "Unbegrenzte Community-Nachrichten",
    upgrade: "Upgrade",
    forUnlimited: "für unbegrenzt",
    messagesLeftWarning: "{{count}} Nachrichten übrig heute",
    recordVoiceNote: "Sprachnotiz aufnehmen",
    uploading: "Hochladen",
    maxDuration: "{{seconds}}s max",
    upgradeToPremium: "Upgrade auf Premium",
    dailyMessageLimitReached: "Sie haben Ihr tägliches Nachrichtenlimit erreicht.",
    dailyVoiceLimitReached: "Sie haben Ihr tägliches Sprachnotiz-Limit erreicht.",
    dailyGroupMessageLimitReached: "Sie haben Ihr tägliches Gruppennachrichtenlimit erreicht.",
    dailyGroupVoiceLimitReached: "Sie haben Ihr tägliches Gruppen-Sprachnotiz-Limit erreicht.",
    unlockUnlimited: "Schalten Sie unbegrenzten Zugriff auf alle Funktionen frei.",
    maybeLater: "Vielleicht später",
    premiumUnlimited: "Unbegrenzt",
    premium: "Premium",
    msg: "Nch",
    msgs: "Nch",
    newMessageNotification: "{{name}} hat Ihnen eine Nachricht gesendet 💬",
    newGroupMessageNotification: "{{name}} hat eine Nachricht in Ihrer Gruppe gesendet 👥",
    someone: "jemand",
    failedToLoad: "Laden fehlgeschlagen",
    groupMessagesLeftWarning: "{{count}} Nachrichten übrig heute",
    howOldAreYou: 'Wie alt bist du?',
    minorGroupNote: 'Du wirst mit anderen Nutzern deines Alters (13–17) zusammengebracht.',
    adultGroupNote: 'Du wirst mit anderen Erwachsenen (18+) zusammengebracht.',
    enterYourAge: 'Gib dein Alter ein',
    getStarted:        'Loslegen',
    howItWorks:        'So funktioniert es',
    statAnonymous:     'Anonym',
    statLanguages:     'Sprachen',
    statToStart:       'Zum Starten',
    taglineHonest:     'Ehrlich',
    taglineEffective:  'Effektiv',
    landingHero:       'Verantwortung ohne die Schaustellung.',
    landingSubtitle:   'Finde einen anonymen Partner, der deine Ziele teilt. Keine Follower. Kein Druck — nur echten Fortschritt.',
    problemTitle:      'Verantwortlichkeit ist kaputt.',
    problem1:          'Soziale Medien machen Selbstverbesserung zur Schaustellung. Du postest Ziele für Likes, nicht für Fortschritte.',
    problem2:          'Freunde und Familie bringen Urteil oder Gleichgültigkeit. Echte Ehrlichkeit wird unmöglich.',
    problem3:          'Accountability-Apps fühlen sich wie Tracking-Tools an — sterile Dashboards, die das Menschliche völlig ignorieren.',
    veylIsDifferent:   'Veyl ist anders.',
    step1Title:        'Profil erstellen',
    step1Desc:         'Wähle ein Pseudonym, eine Zielkategorie und deine Kommunikationspräferenz. Deine echte Identität bleibt deine.',
    step2Title:        'Gematcht werden',
    step2Desc:         'Veyl findet einen Partner, der deinen Zieltyp und deine Altersgruppe teilt. Sofort — kein Scrollen, kein Swipen.',
    step3Title:        'Anfangen zu reden',
    step3Desc:         'Chatte oder sende Sprachnachrichten. Melde dich täglich oder wöchentlich. Dein Partner hält dich verantwortlich — und du ihn.',
    buildTrust:        'Vertrauen aufbauen',
    unveilIdentity:    'Notiere deine Erfolge. Wenn das Vertrauen da ist, kannst du wählen, deine Identität zu enthüllen — oder nicht.',
    actuallyAchieve:   'Wirklich erreichen',
    makeRealProgress:  'Echter Fortschritt mit einem echten Menschen. Keine Gamification. Nur du, dein Partner und dein Ziel.',
    pricingTitle:      'Kostenlos starten. Tiefer gehen, wenn du bereit bist.',
    freePlan:          'Kostenlos',
    foreverLabel:      '/ für immer',
    freeFeature1:      '1 Verantwortungspartner',
    freeFeature2:      '10 Nachrichten pro Tag',
    freeFeature3: '10 Sprachnachrichten pro Tag',
    freeFeature5:      'Gruppen- und Community-Räume',
    popular:           'Am beliebtesten',
    premiumPlan:       'Premium',
    perMonth:          '/ Monat',
    sixMonthDeal: '6-Monats-Abo für 20 $ – sparen Sie 33 %',
    premiumFeature1:   'Unbegrenzte Nachrichten',
    premiumFeature2:   'Unbegrenzte Sprachnachrichten',
    premiumFeature3:   'Partner-Enthüllungsfunktion',
    premiumFeature4:   'Priorisiertes Matching',
    getStartedPremium: 'Premium starten',
    faqTitle:          'Häufige Fragen.',
    faq1q: 'Ist Veyl wirklich anonym?',
    faq1a: 'Ja. Du meldest dich mit einem Pseudonym an. Kein echter Name, kein Foto, nichts Identifizierendes. Dein Partner weiß nur, was du wählst zu teilen.',
    faq2q: 'Wie funktioniert das Matching?',
    faq2a: 'Veyl verbindet dich mit jemandem in derselben Zielkategorie und Altersgruppe. Dauert normalerweise unter zwei Minuten.',
    faq3q: 'Was, wenn ich mich mit meinem Partner nicht verstehe?',
    faq3a: 'Du kannst deinen Partner jederzeit ohne Fragen melden oder blockieren. Neu matchen und jemand Besseres finden.',
    faq4q: 'Ist es sicher für Minderjährige?',
    faq4a: 'Absolut. Nutzer von 13–17 Jahren werden nur mit anderen derselben Altersgruppe gematcht. Dies wird auf Systemebene durchgesetzt.',
    ctaTitle:    'Dein Partner wartet bereits.',
    ctaSubtitle: 'Tritt Veyl kostenlos bei. Kein Social-Profil erforderlich. Nur du, dein Ziel und jemand, der es versteht.',
    privacyPolicy:  'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    refundPolicy:   'Rückerstattungsrichtlinie',
    featuresTitle: "Alles, was du brauchst. Nichts, was du nicht brauchst.",
    feature1Title: "Vollständige Anonymität",
    feature1Desc: "Du wählst ein Pseudonym. Dein echter Name, Foto und deine Identität werden niemals geteilt — außer du entscheidest dich dafür.",
    feature2Title: "Sprachnachrichten",
    feature2Desc: "Manchmal reicht Schreiben nicht aus. Nimm Sprachnachrichten direkt in der App auf und sende sie.",
    feature3Title: "Altersgerechtes Matching",
    feature3Desc: "Minderjährige (13–17) werden nur mit anderen Minderjährigen gematcht. Erwachsene mit Erwachsenen. Keine Ausnahmen — fest im System verankert.",
    feature4Title: "13 Sprachen",
    feature4Desc: "Englisch, Swahili, Französisch, Spanisch, Portugiesisch, Deutsch, Italienisch, Hindi, Indonesisch, Chinesisch, Japanisch, Koreanisch, Hausa.",
    feature5Title: "Tägliche Check-ins",
    feature5Desc: "Strukturierte Check-ins halten die Motivation aufrecht. Halte Fortschritte fest und feiere Erfolge mit deinem Partner.",
    feature6Title: "Gruppen & Community",
    feature6Desc: "Tritt zielspezifischen Gruppenchats und sprachbasierten Community-Räumen bei.",
    goalsEyebrow: "Für echte Ziele",
    goalsTitle: "Egal, an was du gerade arbeitest.",
    goalsSub: "Veyl ist für jeden mit einem echten Ziel und niemandem, mit dem man darüber ehrlich sein kann.",
    goalFitness: "Fitness & Gesundheit",
    goalLearning: "Lernen & Fähigkeiten",
    goalBusiness: "Beruf & Karriere",
    goalCreative: "Kreative Projekte",
    moreComingSoon: "Weitere folgen bald",
    safeTitle: "Sicherheit ist kein Feature. Sie ist das Fundament.",
    safe1Title: "Altersgetrennt",
    safe1Desc: "Minderjährige und Erwachsene werden niemals gemischt. Das Alter wird bei der Anmeldung verifiziert und festgelegt.",
    safe2Title: "Melden & Blockieren",
    safe2Desc: "Jeder Nutzer kann sofort melden oder blockieren. Ohne Rückfragen.",
    safe3Title: "Kein Datenverkauf",
    safe3Desc: "Deine Ziele, Nachrichten und Identität gehören dir. Punkt.",
    safe4Title: "Nur Pseudonyme",
    safe4Desc: "Echte Namen sind nie erforderlich. Du entscheidest, ob und wann du dich zeigst.",
    refundPolicy: "Rückerstattungsrichtlinie",
    heroLine1: 'Verantwortung',             
    heroLine2: 'ohne die Schaustellung',
    mustBe18: 'Du musst mindestens 18 Jahre alt sein, um Veyl zu nutzen',
    mustBe18Desc: 'Veyl ist eine Plattform für Personen ab 18 Jahren. Es tut uns leid, aber du erfüllst die Mindestaltersanforderung zur Erstellung eines Kontos nicht.',
    ageAttestationLabel: 'Ich bestätige, dass ich mindestens 18 Jahre alt bin.',
    ageMisrepresentationNote: 'Falsche Angaben zu deinem Alter verstoßen gegen unsere Nutzungsbedingungen und können zur Kontosperrung führen.',
    feature3Title: 'Verifiziert: nur 18+',
    feature3Desc: 'Jedes Mitglied bestätigt vor dem Beitritt, mindestens 18 Jahre alt zu sein. Keine Minderjährigen, keine Ausnahmen.',
    faq4q: 'Ist Veyl für Minderjährige zugänglich?',
    faq4a: 'Nein. Veyl ist eine Plattform ausschließlich für Personen ab 18 Jahren. Jeder Nutzer bestätigt sein Alter bei der Anmeldung, und Konten mit falschen Altersangaben können entfernt werden.',
    safe1Title: 'Nur für Erwachsene',
    safe1Desc: 'Veyl ist ausschließlich für Personen ab 18 Jahren konzipiert. Wer unter 18 ist und versucht, Veyl zu nutzen, macht falsche Altersangaben, was gegen unsere Nutzungsbedingungen verstößt.',
    ageVerificationDesc: 'Veyl steht Nutzern ab 18 Jahren zur Verfügung.', 
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Passe dein Ziel an',
    adjustGoalDesc: 'Sie können die Richtung ändern. Ihr Partner wird benachrichtigt.',
    newGoalDescription: 'Neue Zielbeschreibung',
    newGoalPlaceholder: 'Was ist Ihr neues oder angepasstes Ziel?',
    updateGoal: 'Ziel aktualisieren',
    goalUpdated: 'Ziel erfolgreich aktualisiert! Ihr Partner wurde benachrichtigt.',
    readyToUnveil: 'Bereit zur Enthüllung?',
    unveilDesc: 'Mit der Enthüllung ist dieses Veyl-Projekt abgeschlossen. Ihr Partner wird benachrichtigt. Dieser Vorgang ist unumkehrbar.',
    yourNewAvatar: 'Ihr neuer Avatar',
    notYet: 'Noch nicht',
    unveiling: 'Enthüllung...',
    sending: 'Senden...',
    checkInDesc: 'Tägliche Check-ins dienen der Fortschrittskontrolle. Wöchentliche Check-ins ermöglichen tiefergehende Reflexionen.',
    dismiss: '✕',
    saving: 'Speichern...',
    saved: '✓ Gespeichert!',
    lightModeDesc: 'Sauber und hell',
    darkModeDesc: 'Augenschonend',
    currentNickname: 'Dein aktueller Spitzname ist',
    anonymousWarning: 'Bleiben Sie anonym. Verwenden Sie nicht Ihren richtigen Namen.',
    nicknameUpdated: '✓ Spitzname aktualisiert!',
    deleteMyAccount: 'Mein Konto löschen',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Lernen Sie Rasa kennen',
    rasaIntroDesc: 'Rasa ist ein privater Raum zum Nachdenken – nur für dich, getrennt von deinem Accountability-Partner. Es geht nicht von Annahmen über dich oder die Welt aus; es lernt nur von dem, was du teilst, und ist darauf ausgelegt, Fragen zu stellen, anstatt dir Antworten zu liefern.',
    rasaIntroNotTherapist: 'Rasa ist keine Therapeutin und kann echte menschliche Beziehungen – auch nicht die zu deinem Sparringspartner – nicht ersetzen. Wenn dich etwas belastet, weist dich Rasa sanft auf Unterstützung hin, anstatt selbst diese zu bieten.',
    rasaIntroStart: 'Beginnen',
    rasaMessagesLeft: 'Reflexionen, die heute zurückgelassen wurden',
    rasaNoMessagesYet: 'Wenn Sie bereit sind, zu reflektieren, beginnen Sie unten mit dem Tippen.',
    rasaThinking: 'Rasa reflektiert…',
    rasaPrivateNote: 'Nur für Sie privat – für Ihren Accountability-Partner niemals sichtbar.',
    rasaPlaceholder: 'Teile mit, was dich bewegt…',
    rasaDailyLimitReached: 'Du hast das heutige Rasa-Limit erreicht. Es wird morgen zurückgesetzt.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Lernen Sie Rasa kennen',
    feature7Desc: 'Ein privater Raum zum Nachdenken – nur für Sie, getrennt von Ihrem Accountability-Partner.',
    feature8Title: 'Sie erhalten jederzeit Unterstützung.',
    feature8Desc: 'Schnelle Antworten auf Fragen zu Navigation, Abrechnung und Konto – direkt in der App.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Veyl-Support-Chat',
    supportChatTitle: 'Veyl Support',
    supportChatEmptyState: 'Fragen Sie mich alles, was Sie über die Funktionsweise von Veyl wissen möchten.',
    supportChatPlaceholder: 'Eine Frage stellen…',
    supportChatSend: 'Schicken',
    supportChatTyping: 'Tippt…',
    supportChatLimitReached: 'Sie haben das heutige Limit für den Support-Chat erreicht. Bei dringenden Anliegen senden Sie bitte eine E-Mail an support@veyl.space.',
    supportChatGenericError: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Ihre Konversation konnte nicht geladen werden.',
    rasaLoadErrorDetail: 'Weitere Details finden Sie in der Browserkonsole oder versuchen Sie, die Seite neu zu laden.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Du wurdest mit {name} gematcht! Gehe zu deinem Dashboard.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'App installieren',
    installMobileOnly: 'Nur für Mobilgeräte',
    installTooltip: 'Nur auf Mobilgeräten verfügbar',
    installModalTitle: 'Installieren Sie Veyl auf Ihrem Telefon',
    installStep1: 'Tippen Sie in der Safari-Symbolleiste auf das Teilen-Symbol.',
    installStep2: 'Scrollen Sie nach unten und tippen Sie auf „Zum Startbildschirm hinzufügen“.',
    installStep3: 'Tippen Sie oben rechts auf „Hinzufügen“.',
    installGotIt: 'Habe es',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Beziehungen & Verbindungen',
    homeLifeOrganization: 'Organisation von Haushalt und Leben',
    moneyFinancialHabits: 'Geld und Finanzgewohnheiten',
    stayingConnected: 'In Verbindung bleiben',
    independentLiving: 'Unabhängiges Wohnen',
    techConfidence: 'Technologievertrauen',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Beziehungen & Verbindungen',
    goalHomeLife: 'Organisation von Haushalt und Leben',
    goalMoney: 'Geld und Finanzgewohnheiten',
    goalStayingConnected: 'In Verbindung bleiben',
    goalIndependentLiving: 'Unabhängiges Wohnen',
    goalTechConfidence: 'Technologievertrauen',
    // [auto-synced 2026-10-28]
    resources: 'Ressourcen',
    resourcesTitle: 'Ressourcen',
    resourcesWriteUps: 'Berichte',
    resourcesLinks: 'Weiterführende Literatur',
    resourcesOpensNewTab: 'Öffnet sich in einem neuen Tab',
    resourcesEmptyTitle: 'Hier ist noch nichts.',
    resourcesEmptyBody: 'Wir arbeiten noch an der Zusammenstellung von Ressourcen für diese Kategorie. Schauen Sie bald wieder vorbei.',
    resourcesNoMatchBody: 'Für dieses Ziel konnten wir bisher keine Ressourcen finden.',
    resourcesDisclaimer: 'Dies sind allgemeine Informationen, keine professionelle Beratung. Wenn Ihre Gesundheit, Sicherheit oder Finanzen betroffen sind, kann Ihnen ein qualifizierter Fachmann weiterhelfen.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Artikel',
    resourcesMoreToRead: 'Mehr zum Lesen',
    res_intro_fitnessHealth: 'Fitness- und Gesundheitsziele werden meist durch kleine, alltägliche Momente erreicht, nicht durch große. Diese Texte sollen Ihnen etwas Druck nehmen, und die Links führen zu detaillierten Quellen.',
    res_fitness_showing_up_title: 'Anwesenheit ist besser als Angeberei',
    res_fitness_showing_up_p1: 'Die meisten von uns haben eine Vorstellung davon, wie „richtiges“ Training aussieht: Fitnessstudio, Laufschuhe, Schweiß. Wenn das Leben dieser Vorstellung nicht entspricht, ist es leicht zu entscheiden, dass das Ganze nichts für einen ist.',
    res_fitness_showing_up_p2: 'Die Weltgesundheitsorganisation (WHO) verfolgt einen deutlich umfassenderen Ansatz. Sie berücksichtigt Bewegung in der Freizeit, auf dem Weg von A nach B sowie Aktivitäten am Arbeitsplatz und zu Hause. Gehen, Radfahren, Sport und Spielen zählen unabhängig vom Leistungsniveau. Ihre Richtlinien betonen, dass jede Form von Bewegung besser ist als gar keine.',
    res_fitness_showing_up_p3: 'Das ist wichtig, wenn man gemeinsam mit einem Partner eine Gewohnheit aufbaut. Ein kurzer Spaziergang, den man tatsächlich unternommen hat, ist wertvoller als die geplante, aber ausgefallene Trainingseinheit. Auch die kurze Rückmeldung „Ich habe nur zehn Minuten geschafft“ ist ein Zeichen dafür, dass die Beziehung nicht abbricht.',
    res_fitness_showing_up_p4: 'Es hilft auch, das Geschehene vom Gefühl dabei zu trennen. Manchmal ist die Gewohnheit allein schon der Gewinn. Die Intensität kann später kommen, wenn die Teilnahme kein Verhandlungsspiel mehr ist.',
    res_fitness_showing_up_p5: 'Wenn Sie gesundheitliche Probleme haben, schwanger sind oder längere Zeit nicht aktiv waren, sollten Sie vor einer Änderung Ihres Trainingspensums ein kurzes Gespräch mit einem Arzt oder einer anderen qualifizierten medizinischen Fachkraft führen.',
    res_fitness_rest_title: 'Ruhe ist Teil des Plans',
    res_fitness_rest_p1: 'Wenn es um Fitnessziele geht, werden Schlaf und Erholung meist als etwas betrachtet, das übrig bleibt, nachdem die eigentliche Arbeit getan ist. In der Praxis spielen sie jedoch eine entscheidende Rolle für den Erfolg der Anstrengungen.',
    res_fitness_rest_p2: 'Schlaf und Bewegung beeinflussen sich gegenseitig. Der britische Gesundheitsdienst NHS weist darauf hin, dass regelmäßige Bewegung zu besserem Schlaf beitragen kann und dass manche Menschen Sport kurz vor dem Schlafengehen als störend empfinden. In diesem Fall kann Bewegung am frühen Tag besser passen. Beides sind keine festen Regeln. Sie sollen lediglich daran erinnern, dass Sie selbst herausfinden müssen, was Ihrem Körper guttut.',
    res_fitness_rest_p3: 'Auch Ruhepausen sind wichtig, wenn man sich gegenseitig zur Rechenschaft zieht. Wenn jedes Treffen nur ein Bericht über die geleistete Arbeit ist, fühlt sich ein ruhiger Tag schnell wie ein Misserfolg an. Ein bewusst gewählter freier Tag ist etwas anderes, als vom Ziel abzuweichen, und es ist völlig in Ordnung, das auch auszusprechen.',
    res_fitness_rest_p4: 'Wenn Sie über einen längeren Zeitraum hinweg Schwierigkeiten beim Einschlafen haben oder sich aus unerklärlichen Gründen erschöpft fühlen, sollten Sie dies mit einem Arzt oder einer anderen qualifizierten medizinischen Fachkraft besprechen. Das ist kein Problem, das man allein bewältigen muss.',
    res_fitness_food_title: 'Essen ohne viel Aufwand',
    res_fitness_food_p1: 'Ernährungsratschläge sind lautstark und oft widersprüchlich, daher ist es gut zu wissen, dass die großen öffentlichen Gesundheitsbehörden entspannter sind als der Großteil des Internets.',
    res_fitness_food_p2: 'Die WHO erklärt, dass gesunde Ernährung vielfältig sein kann. Was als vernünftige Ernährungsweise gilt, hängt von Alter, Lebensstil, Kultur und dem lokalen Lebensmittelangebot ab. Sie beschreibt vier grundlegende Prinzipien: ausreichende Zufuhr der benötigten Nährstoffe, ein ausgewogenes Verhältnis der Nährstoffe, maßvoller Genuss bestimmter Lebensmittel und eine abwechslungsreiche Ernährung. Eine überwiegend unverarbeitete, abwechslungsreiche Ernährung bildet dabei die Basis.',
    res_fitness_food_p3: 'Für ein Ziel, das man gemeinsam mit jemand anderem verfolgt, ist das ein hilfreicher Rahmen. Man muss nicht die Essgewohnheiten des Partners übernehmen, und er muss nicht die eigenen übernehmen. Ein Ernährungsziel kann so einfach sein wie „öfter zu Hause kochen“ oder „diese Woche mal etwas anderes essen“ – ganz nach den eigenen Bedürfnissen und dem Budget.',
    res_fitness_food_p4: 'Wenn Sie größere Änderungen Ihrer Ernährung planen oder an einer Erkrankung, Allergie oder Medikamenteneinnahme leiden, die durch Lebensmittel beeinflusst wird, kann Ihnen ein Arzt oder eine qualifizierte Ernährungsberaterin/ein qualifizierter Ernährungsberater individuelle Ratschläge geben. Ein allgemeiner Text kann das nicht.',
    res_fitness_who_physical_activity_note: 'Weltweit. Ein einfacher Überblick darüber, was als Aktivität gilt, wer davon profitiert und warum.',
    res_fitness_who_guidelines_note: 'Weltweit. Die vollständigen Leitlinien mit Empfehlungen für verschiedene Altersgruppen und für Menschen mit chronischen Erkrankungen oder Behinderungen.',
    res_fitness_who_healthy_diet_note: 'Global. Erklärt die Prinzipien einer gesunden Ernährung und warum diese je nach Kultur und regionaler Küche variiert.',
    res_fitness_nhs_sleep_note: 'Großbritannien. Praktische Schlaftipps. Die Erwähnungen von Hausärzten oder Apothekern beziehen sich auf entsprechende Angebote in Großbritannien.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Lassen Sie sich benachrichtigen, wenn Veyl geschlossen ist.',
    pushPromptBody: 'Wir benachrichtigen Sie, sobald Sie ein Matching erhalten oder Ihr Partner Ihnen eine Nachricht schickt. Benachrichtigungen enthalten niemals den Nachrichteninhalt.',
    pushEnable: 'Benachrichtigungen aktivieren',
    pushNotNow: 'Nicht jetzt.',
    pushError: 'Beim Aktivieren der Benachrichtigungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    pushBlockedTitle: 'Benachrichtigungen werden blockiert',
    pushBlockedBody: 'Ihr Browser blockiert Benachrichtigungen von Veyl. Um diese zu aktivieren, öffnen Sie die Website-Einstellungen Ihres Browsers für veyl.space, erlauben Sie Benachrichtigungen und laden Sie die Seite anschließend neu.',
    pushIosTitle: 'Benachrichtigungen auf dem iPhone erhalten',
    pushIosBody: 'Fügen Sie Veyl zunächst Ihrem Startbildschirm hinzu: Tippen Sie auf Teilen, dann auf Zum Startbildschirm hinzufügen, öffnen Sie Veyl von dort aus und aktivieren Sie die Benachrichtigungen.',
    pushSettingsTitle: 'Benachrichtigungen auf diesem Gerät',
    pushSettingsDesc: 'Erhalte eine Benachrichtigung, wenn du ein Match hast oder dein Partner dir eine Nachricht schreibt, auch wenn Veyl geschlossen ist. Benachrichtigungen enthalten niemals den Nachrichteninhalt. Diese Einstellung gilt nur für dieses Gerät.',
    pushSettingsUnsupported: 'Benachrichtigungen sind in diesem Browser nicht verfügbar. Auf dem iPhone oder iPad fügen Sie Veyl zuerst zu Ihrem Home-Bildschirm hinzu (Teilen, dann Zum Home-Bildschirm hinzufügen) und öffnen Sie die App anschließend von dort.',
    pushSettingsBlocked: 'Benachrichtigungen für Veyl sind in Ihrem Browser blockiert. Um sie zu aktivieren, öffnen Sie die Website-Einstellungen Ihres Browsers für veyl.space, erlauben Sie Benachrichtigungen und laden Sie die Seite anschließend neu.',
    pushSettingsWorking: 'Arbeiten…',
    pushSettingsOn: 'Benachrichtigungen sind für dieses Gerät aktiviert.',
    pushSettingsTurnOff: 'Benachrichtigungen deaktivieren',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Beim Lernen neuer Dinge kommt es vor allem darauf an, regelmäßig zu üben, damit sie sich festigen. Diese Texte setzen auf langfristiges Lernen, und die Links führen zu kostenlosen Quellen, wo man fast alles lernen kann.',
    res_learning_small_repeat_title: 'Klein genug, um wiederholt zu werden',
    res_learning_small_repeat_p1: 'Die meisten Lernziele scheitern daran, dass sie zu groß gesteckt sind, nicht daran, dass sie zu schwierig sind. „Programmieren lernen“ oder „fließend Portugiesisch sprechen“ ist ein Ziel, keine Aufgabe, die man an einem Dienstagabend erledigen kann.',
    res_learning_small_repeat_p2: 'An einem Dienstagabend könntest du dir zwanzig Minuten Zeit für eine Lektion nehmen. Das ist eine Übung, die du wiederholen kannst, und durch die Wiederholung festigt sich der Lernprozess. Fähigkeiten entwickeln sich meist unmerklich, Stück für Stück, bis du eines Tages merkst, dass du etwas kannst, was du vorher nicht konntest.',
    res_learning_small_repeat_p3: 'Hier ist ein Sparringspartner hilfreicher als Motivation allein. Motivation ist nicht statisch. Ein Partner, der wissen möchte, wie es gelaufen ist, macht es schwieriger, die Gewohnheit stillschweigend aufzugeben und leichter, nach einer schlechten Woche wieder damit anzufangen.',
    res_learning_small_repeat_p4: 'Ein gutes Feedback muss nicht beeindruckend sein. „Ich habe eine Lektion gemacht und ungefähr die Hälfte verstanden“ ist ehrlich und hält die Gewohnheit am Leben. Man kann den Umfang der Aufgabe später erhöhen. Es ist viel schwieriger, eine einmal aufgegebene Gewohnheit wieder aufzubauen.',
    res_learning_beginner_title: 'Anfängerstatus ist erlaubt',
    res_learning_beginner_p1: 'Etwas Neues zu beginnen bedeutet, darin zunächst schlecht zu sein, zumindest vor einer Person. Für viele Erwachsene ist das die eigentliche Hürde, mehr noch als Zeit oder Geld.',
    res_learning_beginner_p2: 'Es kann hilfreich sein zu wissen, wie weit das offene Lernen fortgeschritten ist. MIT OpenCourseWare stellt Materialien aus Tausenden von MIT-Kursen kostenlos und ohne Registrierung zur Verfügung. OpenLearn der Open University bietet fast tausend kurze, kostenlose Kurse an und gibt an, dass es keine Zugangsvoraussetzungen gibt. Sie benötigen keine Erlaubnis, um ein Thema auszuprobieren oder festzustellen, dass es nicht das Richtige für Sie ist.',
    res_learning_beginner_p3: 'Etwas auszuprobieren und dann festzustellen, dass es nichts für einen ist, zählt auch als Lernprozess. Ein paar Dinge erst einmal zu testen, bevor man sich für eine Sache entscheidet, ist ein völlig guter Anfang.',
    res_learning_beginner_p4: 'Wenn du das Gefühl hast, hinterherzuhinken, denk daran, dass es deinem Partner mit seinem Ziel wahrscheinlich genauso geht. Ihr steht nicht im Wettbewerb. Ihr seid beide am Anfang von etwas, nur an unterschiedlichen Punkten.',
    res_learning_choose_one_title: 'Wähle eine Sache aus und wähle sie immer wieder.',
    res_learning_choose_one_p1: 'Kostenloses Lernen hat ein seltsames Problem: Es gibt zu viel davon. Allein OpenCourseWare umfasst über 2.500 Kurse, und OpenLearn bietet fast tausend an. Man kann leicht einen ganzen Abend mit Stöbern verbringen und das dann als Lernen bezeichnen.',
    res_learning_choose_one_p2: 'Es hilft, sich einen Kurs, ein Buch oder eine Lektionsreihe auszusuchen und alles andere erst einmal aufzuheben. Die übrigen Dinge können Sie sich einfach notieren. Ziel ist es, eine Sache abzuschließen, bevor Sie mit der nächsten beginnen. Wenn Sie Ihrem Partner mitteilen, wofür Sie sich entschieden haben, ist das eine kleine Verpflichtung, die das Durchhalten erleichtert.',
    res_learning_choose_one_p3: 'Es lohnt sich auch, zu prüfen, was ein Angebot beinhaltet und was nicht. OpenLearn-Kurse beispielsweise beinhalten eine Teilnahmebestätigung und teilweise ein digitales Abzeichen, das jedoch keine anerkannte Qualifikation darstellt. Wenn Sie für Beruf oder Studium eine formale Qualifikation benötigen, sollten Sie dies frühzeitig klären. Die jeweilige Hochschule oder Universität kann Ihnen Auskunft darüber geben, welche Qualifikationen anerkannt werden.',
    res_learning_mit_ocw_note: 'Weltweit. Kostenlose Vorlesungsmitschriften, Prüfungen und Videos aus Tausenden von MIT-Kursen, ohne Anmeldung. In englischer Sprache.',
    res_learning_khan_academy_note: 'Weltweit. Eine gemeinnützige Organisation, die kostenlose Kurse und Übungen anbietet, insbesondere in Mathematik und Naturwissenschaften, und zwar in vielen Sprachen.',
    res_learning_openlearn_note: 'Mit Sitz in Großbritannien, offen für alle. Fast 1.000 kostenlose Kurzkurse von etwa 1 bis 24 Stunden Dauer, jeweils mit kostenloser Teilnahmebestätigung.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Arbeitsziele sind langfristig angelegt, und der größte Aufwand entsteht in den Tagen zwischen den einzelnen Meilensteinen. In diesen Abschnitten geht es darum, ein stetiges Tempo beizubehalten, und die Links führen zu kostenlosen Angeboten, um Fähigkeiten auszubauen und den nächsten Schritt zu planen.',
    res_business_progress_title: 'Fortschritt im Beruf verläuft selten geradlinig.',
    res_business_progress_p1: 'Karriere- und Geschäftsziele können sich in die Länge ziehen. Eine Beförderung, ein Karrierewechsel oder der erste Kunde können Monate dauern, und die Tage dazwischen fühlen sich selten wie Fortschritt an.',
    res_business_progress_p2: 'Es hilft, das gewünschte Ergebnis von den Dingen zu trennen, die Sie diese Woche tatsächlich tun können. Sie können nicht beeinflussen, ob ein Unternehmen Sie einstellt oder ein Kunde zusagt. Sie können aber steuern, wie viele Gespräche Sie führen, wie viel Zeit Sie dem Projekt widmen und ob Sie Ihre Zusagen einhalten.',
    res_business_progress_p3: 'Hier kommt ein Accountability-Partner ins Spiel. Er muss Ihre Branche nicht verstehen. Er muss lediglich fragen, was Sie getan haben, und die Antwort anhören, ohne daraus eine Selbstdarstellung zu machen.',
    res_business_progress_p4: 'Manche Wochen lautet die ehrliche Bilanz: „Es ist nicht viel passiert.“ Das sollte man aussprechen, denn ein Ziel, das einen Monat lang in Vergessenheit gerät, lässt sich viel schwerer wieder aufgreifen als eines, das man nur locker am Leben erhalten hat.',
    res_business_start_from_you_title: 'Beginne bei dir selbst, nicht bei der Arbeit.',
    res_business_start_from_you_p1: 'Wenn Menschen im Job feststecken, ist der erste Impuls oft, sich den Arbeitsmarkt anzusehen: Wo werden Stellen ausgeschrieben, welche Unternehmen sind gut bezahlt, welche Jobs machen einen guten Eindruck. Es kann jedoch sinnvoller sein, woanders anzusetzen.',
    res_business_start_from_you_p2: 'Der kostenlose OpenLearn-Kurs „Erfolgreich im Berufsleben“ basiert auf dieser Idee. Er geht von der Annahme aus, dass die Selbsterkenntnis und das Erkennen der eigenen Werte die Grundlage für die Karriereplanung bilden, und befasst sich erst anschließend mit Lebensläufen, Bewerbungen und Vorstellungsgesprächen.',
    res_business_start_from_you_p3: 'Einfach ausgedrückt: Wie sollen sich Ihre Tage anfühlen? Was können Sie gut, wofür Sie selten Anerkennung erhalten? Worauf würden Sie niemals verzichten, sei es Zeit mit der Familie, ein sicheres Einkommen oder Freiraum für Kreativität?',
    res_business_start_from_you_p4: 'Du musst das nicht alles allein beantworten. Wenn du mit deinem Partner darüber sprichst, kommen oft Dinge ans Licht, die du allein übersehen würdest, und aus einem vagen „Ich möchte etwas anderes“ kann sich ein Ziel entwickeln, an dem du tatsächlich arbeiten kannst.',
    res_business_wear_out_title: 'Hart arbeiten, ohne sich dabei zu verausgaben',
    res_business_wear_out_p1: 'Ehrgeiz und Erschöpfung können von innen betrachtet ähnlich aussehen, besonders wenn einem ein Ziel wichtig ist.',
    res_business_wear_out_p2: 'Die Weltgesundheitsorganisation (WHO) stellt fest, dass Arbeit die psychische Gesundheit schützen kann, aber auch zu Schäden beitragen kann. Ihre Leitlinien zur psychischen Gesundheit am Arbeitsplatz weisen auf Risiken wie hohe Arbeitsbelastung und negatives Verhalten am Arbeitsplatz hin und betonen, dass die Verantwortung für ein gesundes Arbeitsumfeld bei Arbeitgebern und Regierungen liegt, nicht nur bei den einzelnen Arbeitnehmern.',
    res_business_wear_out_p3: 'Wenn Sie sich bei Ihrem Partner über ein wichtiges Arbeitsziel austauschen, sollten Sie nicht nur fragen: „Hast du es geschafft?“, sondern auch: „Wie geht es dir damit?“ Ein Ziel, das auf Kosten Ihres Schlafs, Ihrer Gesundheit oder Ihrer Beziehungen verfolgt wird, sollte überdacht werden, selbst wenn es auf dem Papier gut läuft.',
    res_business_wear_out_p4: 'Wenn Ihre Arbeit Ihre Gesundheit beeinträchtigt oder Sie sich anhaltend niedergeschlagen, ängstlich oder erschöpft fühlen, sprechen Sie bitte mit einem Arzt oder einer anderen qualifizierten medizinischen Fachkraft. Wenn Sie sich über Ihre Rechte am Arbeitsplatz nicht im Klaren sind, kann Ihnen eine vertrauenswürdige Stelle vor Ort, wie beispielsweise das Arbeitsamt oder eine Arbeitnehmerorganisation, diese für Ihren Wohnort erläutern. Die Regelungen unterscheiden sich von Land zu Land erheblich.',
    res_business_who_mh_work_note: 'Global. Hauptsächlich für Arbeitgeber und Regierungen verfasst, daher technisch. Die Zusammenfassung ist auf Arabisch, Chinesisch, Englisch, Französisch, Russisch und Spanisch verfügbar.',
    res_business_openlearn_entrepreneurship_note: 'Dieser Kurs findet in Großbritannien statt. Er umfasst 24 Stunden verteilt auf 8 Sitzungen und kann ohne Anmeldung begonnen werden. Da ein Teil des Kurses britische Geschäftsregeln behandelt, informieren Sie sich bitte über die in Ihrem Land geltenden Bestimmungen.',
    res_business_openlearn_succeed_note: 'Der Kurs dauert etwa acht Wochen und umfasst ca. drei Stunden pro Woche. Themen sind Karriereplanung, Lebenslauf und Vorstellungsgespräche. Die letzte Aktualisierung erfolgte 2021, daher wirken einige Abschnitte zur Jobsuche und zu sozialen Medien möglicherweise veraltet.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Zeitzone',
    timezoneCurrentIs: 'Ihre aktuelle Zeitzone ist',
    timezoneLockNote: 'Ihre täglichen Nachrichten- und Sprachnotizlimits werden um Mitternacht Ihrer Zeitzone zurückgesetzt. Um dies fair zu gestalten, können Sie Ihre Zeitzone nur an einem Tag ändern, an dem Sie keine Nachrichten oder Sprachnotizen verwendet haben, und zwar nur einmal alle 7 Tage.',
    timezoneNew: 'Zeitzone auswählen',
    saveTimezone: 'Zeitzone speichern',
    timezoneUpdated: 'Zeitzone aktualisiert',
    timezoneInvalid: 'Diese Zeitzone ist ungültig. Bitte wählen Sie eine aus der Liste.',
    timezoneChangeError: 'Die Zeitzone konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Kreative Projekte entstehen oft in den Zwischenräumen des Alltags. Diese Beiträge helfen dabei, etwas über einen längeren Zeitraum hinweg am Leben zu erhalten, und die Links behandeln das Erlernen des Schreibens sowie die Nutzung und das Teilen kreativer Arbeiten.',
    res_creative_finishing_title: 'Auch der Torabschluss ist eine Fähigkeit.',
    res_creative_finishing_p1: 'Der Start eines kreativen Projekts ist der einfache Teil. Die Idee ist frisch und alles scheint möglich. Die Schwierigkeit kommt in der Mitte, wenn aus der Idee tatsächliche Arbeit wird und diese langsamer und chaotischer verläuft als die Idee ursprünglich war.',
    res_creative_finishing_p2: 'Hier scheitern Projekte meist, und das liegt selten an mangelndem Talent. Viel häufiger liegt es daran, dass es in der Mitte kein Ziel gibt, auf das man sich freuen kann, und niemand zuschaut.',
    res_creative_finishing_p3: 'Hier kann ein Partner, der einfach fragt: „Was hast du diese Woche gemacht?“, einen echten Unterschied machen. Du brauchst keine Bewertung. Allein die Tatsache, dass du deine Woche beschreiben wirst, gibt der Arbeit eine kleine Deadline, und eine kleine Deadline reicht oft schon aus, um dich wieder an den Schreibtisch, die Leinwand oder das Instrument zu bringen.',
    res_creative_finishing_p4: 'Es hilft auch, zu definieren, was „fertig“ für die jeweilige Sache bedeutet. Eine fertige Rohfassung ist wertvoller als eine perfekte Version, die nur im Kopf existiert. Man kann sie ja immer noch verbessern, nachdem sie existiert.',
    res_creative_rough_drafts_title: 'Die erste Version muss niemand sehen.',
    res_creative_rough_drafts_p1: 'Viele Kreative geben stillschweigend auf, weil der erste Versuch nicht ihren Vorstellungen entspricht. Diese Diskrepanz zwischen Vision und Realität ist normal. Sie ist oft am größten, wenn einem etwas besonders am Herzen liegt.',
    res_creative_rough_drafts_p2: 'Wenn man einer vertrauten Person seine ersten Entwürfe zeigt, kann das die Belastung deutlich verringern. Wenn man einem Partner sagt: „Das ist ein unfertiger Entwurf, aber so stelle ich mir das vor“, wird daraus ein Gespräch und kein Urteil. Vielleicht merkt man, dass es ihm oder ihr wichtiger ist, ob man durchgehalten hat, als ob der Entwurf gut ist.',
    res_creative_rough_drafts_p3: 'Für Anfänger in einem Handwerk gibt es sanfte Einstiegsmöglichkeiten. OpenLearn, die kostenlose Lernplattform der Open University, bietet einen Einführungskurs ins fiktionale Schreiben speziell für Einsteiger an. Dies ist nur ein Beispiel von vielen und eignet sich besonders für Schriftsteller.',
    res_creative_rough_drafts_p4: 'Fortschritte in kreativer Arbeit sehen selten wie stetige Verbesserung aus. Manchmal schafft man etwas, worauf man stolz ist, und manchmal etwas, das man nie jemandem zeigen wird. Beides zählt und gehört zur selben Gewohnheit.',
    res_creative_using_sharing_title: 'Die Arbeit anderer nutzen und die eigene teilen',
    res_creative_using_sharing_p1: 'Kreative Projekte beinhalten oft Material von anderen, wie Bilder, Töne oder Texte, und irgendwann möchten Sie vielleicht auch Ihr eigenes Material teilen. Ein wenig Hintergrundwissen ist in beiden Fällen hilfreich.',
    res_creative_using_sharing_p2: 'Creative Commons ist eine gemeinnützige Organisation, die Lizenzen veröffentlicht, die es Urhebern ermöglichen, ihr Urheberrecht zu behalten und gleichzeitig anderen die Nutzung ihrer Werke nach ihren Wünschen zu gestatten. Wenn Sie etwas, das Sie erstellt haben, teilen möchten, erklärt Ihnen die Creative-Commons-Richtlinie, wie diese Lizenzen funktionieren.',
    res_creative_using_sharing_p3: 'Manche Institutionen gehen noch weiter. Das Smithsonian hat Millionen von Bildern und Daten unter der sogenannten CC0-Lizenz veröffentlicht. Das bedeutet, dass man sie ohne vorherige Genehmigung des Smithsonian verwenden kann, auch für kreative Projekte. In den FAQ des Smithsonian wird jedoch darauf hingewiesen, dass CC0 nur das Urheberrecht abdeckt. Andere Rechte, wie beispielsweise das Recht auf Privatsphäre oder das Markenrecht, können weiterhin gelten, und einige Objekte aus den Sammlungen sind gar nicht eingeschlossen.',
    res_creative_using_sharing_p4: 'Die Urheberrechtsbestimmungen unterscheiden sich von Land zu Land. Diese Informationen sind allgemeiner Natur und stellen keine Rechtsberatung dar. Wenn ein Projekt von wirtschaftlicher Bedeutung ist oder Sie sich unsicher sind, ob Sie etwas verwenden dürfen, kann Ihnen ein qualifizierter Experte Auskunft über Ihre Rechtslage geben.',
    res_creative_openlearn_fiction_note: 'In Großbritannien ansässig, kostenloser Einstieg. Ein Einführungskurs in das Schreiben von Belletristik, inklusive kostenloser Teilnahmebestätigung. Er eignet sich besonders für Schriftsteller.',
    res_creative_cc_license_note: 'Weltweit. Wie Sie anderen die Nutzung Ihrer Werke unter Ihren Bedingungen gestatten und gleichzeitig Ihr Urheberrecht behalten. Allgemeine Informationen, keine Rechtsberatung.',
    res_creative_smithsonian_open_access_note: 'US-Institution, frei nutzbar. Erläutert die unter CC0 veröffentlichten Bilder und Daten, was diese Lizenz erlaubt und was nicht und welche Elemente ausgeschlossen sind.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Beziehungen entstehen eher durch kleine, wiederkehrende Gesten als durch große Ereignisse. In diesen Artikeln geht es darum, Verbindungen zu pflegen, was laut Forschungsergebnissen am wichtigsten ist und was zu tun ist, wenn die Kommunikation schwierig oder eine Beziehung unsicher ist.',
    res_relationships_small_gestures_title: 'Kleine Gesten zählen',
    res_relationships_small_gestures_p1: 'Viele von uns betrachten Freundschaften und familiäre Bindungen als etwas, das entweder existiert oder nicht. Robert Waldinger, Leiter der Harvard-Studie zur Erwachsenenentwicklung, beschreibt das soziale Leben als ein lebendiges System, das – ähnlich wie körperliche Fitness – Pflege benötigt.',
    res_relationships_small_gestures_p2: 'Die kleinen Gesten der Selbstfürsorge können schon viel bedeuten. Denken Sie an jemanden, den Sie vermissen, und schreiben Sie ihm eine Nachricht. Die Liste der Weltgesundheitsorganisation mit alltäglichen Schritten ist genauso bescheiden: einen Freund kontaktieren, das Handy weglegen, um sich voll und ganz auf ein Gespräch konzentrieren zu können, einen Nachbarn grüßen, einer lokalen Gruppe beitreten oder sich ehrenamtlich engagieren.',
    res_relationships_small_gestures_p3: 'Wenn Sie ein Ziel mit einem Accountability-Partner teilen, eignet sich folgende Frage gut für die Woche: Wen haben Sie kontaktiert? Sie ist konkret, klein und lässt sich auch in einer schwierigen Woche ehrlich beantworten.',
    res_relationships_small_gestures_p4: 'Nicht jede Nachricht erhält eine positive Antwort, und das gehört dazu. Waldinger sagt, die Leute seien oft überrascht, wie herzlich selbst kleine Nachrichten aufgenommen werden.',
    res_relationships_quality_title: 'Qualität vor Quantität',
    res_relationships_quality_p1: 'Das Sozialleben lässt sich leicht an der Anzahl der Kontakte messen: wie viele Freunde man hat, wie viele Veranstaltungen man besucht, ob man in einer Beziehung ist. Die Forschung deutet jedoch auf etwas anderes hin.',
    res_relationships_quality_p2: 'Die Harvard-Studie zur Erwachsenenentwicklung begleitet Menschen seit 1938. Als die Forscher die Lebensläufe der Teilnehmer im mittleren Lebensalter untersuchten, zeigte sich, dass die Zufriedenheit mit ihren Beziehungen, insbesondere in der Ehe, besser vorhersagte, wer mit 80 Jahren glücklich und gesund sein würde, als beispielsweise Cholesterin- oder Blutdruckwerte. Der Studienleiter erklärt, dass andere Forschungsgruppen seither zu demselben Ergebnis gekommen sind. Er fügt hinzu, dass es keine festgelegte Anzahl an Beziehungen gibt, die man benötigt, und dass schüchterne Menschen möglicherweise weniger Beziehungen brauchen als extrovertierte.',
    res_relationships_quality_p3: 'Ein wichtiger Hinweis: Die ersten Studienteilnehmer waren Harvard-Studenten und junge Erwachsene aus einer einzigen amerikanischen Stadt. Die Studie ist daher nicht repräsentativ für die Gesamtbevölkerung. Die Schlussfolgerungen sollten daher mit Vorsicht interpretiert werden.',
    res_relationships_quality_p4: 'Die Studie legt auf subtile Weise nahe, dass mindestens eine enge Beziehung – zu jemandem, den man im Krankheits- oder Angstfall anrufen könnte – wichtiger ist als ein großer Freundeskreis. Und es ist selten zu spät. Der Studienleiter beschreibt Menschen, die erst spät im Leben, unerwartet, enge Freundschaften oder die Liebe gefunden haben.',
    res_relationships_hard_times_title: 'Wenn die Kontaktaufnahme schwierig ist und eine Beziehung schmerzt',
    res_relationships_hard_times_p1: 'Sich einsam zu fühlen bedeutet nicht, dass etwas mit einem nicht stimmt. Die Weltgesundheitsorganisation schätzt, dass weltweit etwa jeder sechste Mensch in jedem Alter Einsamkeit erlebt. Sie beschreibt Einsamkeit als das schmerzhafte Gefühl, das entsteht, wenn die bestehenden Beziehungen nicht den eigenen Wünschen entsprechen.',
    res_relationships_hard_times_p2: 'Zu den Ursachen können ein schlechter Gesundheitszustand, ein geringes Einkommen, Alleinleben oder der Umgang mit Technologie gehören. Die WHO weist darauf hin, dass es sich bei schwerwiegenderen Problemen lohnt, sich über bestehende Unterstützungsangebote und Dienstleistungen zu informieren.',
    res_relationships_hard_times_p3: 'Es gibt aber auch die andere Seite: Beziehungen, die verletzen. Schädliches Verhalten in einer Partnerschaft umfasst psychische Misshandlung und kontrollierendes Verhalten sowie körperliche oder sexuelle Gewalt.',
    res_relationships_hard_times_p4: 'Wenn Sie Angst vor einer Ihnen nahestehenden Person haben oder verletzt werden, kontaktieren Sie bitte den Notruf oder eine örtliche Beratungsstelle. Die entsprechenden Nummern variieren je nach Land. Ein Veyl-Partner ist ein Betroffener, kein ausgebildeter Therapeut. Wenn Sie sich überfordert fühlen, kann Ihnen ein Arzt oder Therapeut helfen.',
    res_relationships_who_social_connection_note: 'Global. Eine kurze, verständliche Zusammenfassung des WHO-Berichts 2025 über Einsamkeit und soziale Kontakte (13 Seiten).',
    res_relationships_harvard_gazette_note: 'US-Quelle. Ein Interview mit dem Leiter der Harvard-Studie zur Erwachsenenentwicklung darüber, was die Forschung über Beziehungen und Gesundheit aussagt, einschließlich kleiner, alltäglicher Schritte. Die ersten Studienteilnehmer stammten aus einer einzigen amerikanischen Stadt.',
    res_relationships_who_violence_note: 'Weltweit. Erklärt, was häusliche Gewalt umfasst und wie verbreitet sie ist; sie betrifft hauptsächlich Frauen. Es handelt sich um Informationen, nicht um eine Beratungsstelle, und der Text kann schwer verständlich sein.',
  },

  it: {
    appName: 'Veyl',
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    back: 'Indietro',
    continue: 'Continua',
    done: 'Fatto',
    error: 'Errore',
    submit: 'Invia',
    send: 'Invia',
    delete: 'Elimina',
    leave: 'Lascia',
    stay: 'Rimani',
    yes: 'Sì',
    no: 'No',
    upgrade: 'Passa a Premium',
    signIn: 'Accedi',
    signUp: 'Registrati',
    signOut: 'Esci',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Password dimenticata?',
    resetPassword: 'Reimposta password',
    resetPasswordSent: 'Email di reimpostazione inviata. Controlla la tua casella.',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    authError: 'Errore di autenticazione. Riprova.',
    landingHero: 'Responsabilità che funziona davvero',
    landingSubtitle: 'Trova un partner anonimo che condivide il tuo obiettivo. Nessuna pressione sociale. Solo risultati.',
    getStarted: 'Inizia — È gratis',
    howItWorks: 'Come funziona',
    step1Title: 'Imposta il tuo obiettivo',
    step1Desc: 'Dicci su cosa stai lavorando. Ti abbineremo a qualcuno in un percorso simile.',
    step2Title: 'Incontra il tuo partner',
    step2Desc: 'Abbinati con un partner di responsabilità anonimo nel tuo fuso orario.',
    step3Title: 'Rimani responsabile',
    step3Desc: 'Fai check-in giornalieri, condividi i progressi e sostenetevi a vicenda — anonimamente.',
    pricingTitle: 'Prezzi semplici',
    freePlan: 'Gratuito',
    premiumPlan: 'Premium',
    perMonth: '/mese',
    freeFeature1: '1 Veyl attivo',
    freeFeature2: '10 messaggi/giorno',
    freeFeature3: '10 note vocali/giorno',
    freeFeature4: 'Check-in giornalieri e settimanali',
    freeFeature5: 'Accesso alla chat di gruppo',
    premiumFeature1: 'Fino a 3 Veyl attivi',
    premiumFeature2: 'Messaggi illimitati',
    premiumFeature3: 'Note vocali illimitate',
    premiumFeature4: 'Abbinamento prioritario',
    faqTitle: 'Domande frequenti',
    welcomeToVeyl: 'Benvenuto su Veyl',
    chooseLanguage: 'Scegli la tua lingua',
    chooseLanguageDesc: 'Seleziona la lingua in cui desideri utilizzare Veyl.',
    ageVerification: "Verifica dell'età",
    ageVerificationDesc: 'Veyl è disponibile per utenti di 13 anni e oltre.',
    areYouOldEnough: 'Hai 13 anni o più?',
    yesIAm: '✅ Sì, ho',
    noImNot: '❌ No, non ho',
    mustBe13: 'Devi avere almeno 13 anni',
    mustBe13Desc: 'Veyl è disponibile solo per utenti di 13 anni e oltre.',
    setupProfile: 'Configuriamo il tuo profilo',
    stepOf: 'Passo {step} di 4',
    whatsYourName: 'Come ti chiami?',
    namePlaceholder: 'Inserisci il tuo soprannome',
    whatsYourTimezone: 'Qual è il tuo fuso orario?',
    selectTimezone: 'Seleziona fuso orario',
    goalCategory: "Qual è la categoria del tuo obiettivo?",
    matchPreference: 'Con chi vuoi essere abbinato?',
    matchNearby: 'Abbina vicino',
    matchNearbyDesc: 'Abbinati con persone entro 4 ore dal tuo fuso orario.',
    matchAnywhere: 'Abbina ovunque',
    matchAnywhereDesc: 'Abbinati con chiunque nel mondo indipendentemente dal fuso orario.',
    describeGoal: 'Descrivi il tuo obiettivo specifico',
    goalPlaceholder: "Es.: 'Voglio perdere 15 kg' o 'Imparare Python'",
    communicationStyle: 'Stile di comunicazione preferito',
    textMessages: 'Messaggi di testo',
    textMessagesDesc: 'Chatta quando è conveniente',
    scheduledCheckins: 'Check-in programmati',
    scheduledCheckinsDesc: 'Riflessioni approfondite settimanali',
    completingSetup: 'Ricerca partner...',
    completeSetup: 'Completa configurazione',
    agreeToTerms: 'Continuando, accetti i',
    termsOfService: 'Termini di servizio',
    and: 'e la',
    privacyPolicy: 'Informativa sulla privacy',
    fitnessHealth: 'Fitness e salute',
    learningSkills: 'Apprendimento e competenze',
    businessCareer: 'Business e carriera',
    creativeProjects: 'Progetti creativi',
    findingMatch: 'Ricerca del tuo partner...',
    findingNewMatch: 'Ricerca del tuo nuovo partner...',
    lookingForSomeone: 'Stiamo cercando qualcuno nella categoria',
    category: '',
    sharesTimezone: 'che condivide il tuo fuso orario e impegno.',
    autoCheck: 'Controlliamo le corrispondenze automaticamente ogni 5 secondi.',
    noMatchYet: 'Nessuna corrispondenza trovata ancora — continueremo a cercare.',
    checkNow: 'Controlla ora',
    checking: 'Controllo...',
    manualChecks: '{count} controllo{plural} manuale{plural} effettuato{plural}',
    joinCommunity: '🌐 Unisciti alla community mentre aspetti',
    goToCommunity: '🌐 Vai alla community',
    previousPartnerNote: '🛡️ Il tuo partner precedente non sarà più suggerito.',
    joining: 'Unendosi...',
    overview: 'Panoramica',
    chat: 'Chat',
    checkin: 'Check-in',
    group: 'Gruppo',
    community: 'Community',
    notifications: 'Notifiche',
    settings: 'Impostazioni',
    yourGoal: 'Il tuo obiettivo',
    yourPartner: 'Il tuo partner',
    you: 'Tu',
    unveiled: '✨ Svelato',
    goalComplete: '✓ Obiettivo completato',
    adjustGoal: 'Modifica il mio obiettivo',
    unveilButton: '✨ Svela — Ce l\'hai fatta!',
    goalCategory2: 'Categoria',
    goalDescription: 'Descrizione',
    timezone: 'Fuso orario',
    loadingPartner: 'Caricamento informazioni partner...',
    waitingForMatch: 'In attesa di una corrispondenza per iniziare a chattare.',
    noMessagesYet: 'Nessun messaggio ancora. Di\' ciao al tuo partner!',
    typeMessage: 'Scrivi il tuo messaggio...',
    dailyLimitReached: 'Limite giornaliero raggiunto — Passa a Premium',
    unmatch: '🔓 Separa',
    report: '🚩 Segnala',
    unmatchWarning: '⚠️ La separazione eliminerà tutta la cronologia della chat. Questa azione è irreversibile.',
    yesUnmatch: 'Sì, separa',
    unmatching: 'Separazione...',
    deleteMessage: '🗑 Elimina',
    deleting: 'Eliminazione...',
    checkIn: 'Check-in',
    submitDaily: 'Invia check-in giornaliero',
    submitWeekly: 'Invia check-in settimanale',
    submitting: 'Invio...',
    checkinSubmitted: 'Check-in inviato!',
    viewHistory: 'Visualizza la mia cronologia',
    notificationsTitle: 'Notifiche',
    clearAll: 'Cancella tutto',
    noNotifications: 'Nessuna notifica ancora.',
    settingsTitle: 'Impostazioni',
    settingsDesc: 'Personalizza la tua identità anonima.',
    saveAvatar: 'Salva avatar',
    appearance: 'Aspetto',
    lightMode: '☀️ Chiaro',
    darkMode: '🌙 Scuro',
    changeNickname: 'Cambia soprannome',
    saveNickname: 'Salva soprannome',
    deleteAccount: 'Elimina account',
    deleteAccountDesc: 'Elimina definitivamente il tuo account e tutti i dati associati.',
    languageLabel: 'Lingua',
    languageDesc: 'Scegli la tua lingua preferita.',
    signOut: 'Esci',
    updating: 'Aggiornamento...',
    unveil: 'Svelare',
    clearing: 'Cancellazione...',
    notifMatchFound: 'Corrispondenza trovata',
    notifGoalAchieved: 'Obiettivo raggiunto',
    notifSupport: 'Messaggi di supporto',
    notifUnmatched: 'Avvisi di separazione',
    notifMatchRequest: 'Richieste di corrispondenza',
    notificationPrefs: 'Preferenze notifiche',
    notificationPrefsDesc: 'Silenzia tipi specifici di notifiche individualmente.',
    muted: 'Silenziato',
    active: 'Attivo',
    all: 'Tutti',
    justNow: 'Proprio ora',
    minsAgo: '{count}m fa',
    hoursAgo: '{count}h fa',
    daysAgo: '{count}g fa',
    leaving: 'Uscita...',
    myHistory: '📋 La mia cronologia',
    partnersProgress: '👤 Progressi di {name}',
    myCheckinHistory: 'La mia cronologia check-in',
    checkinsForVeyl: '{count} check-in per questo Veyl',
    noCheckinsYet: 'Nessun check-in ancora. Inizia il primo!',
    newCheckinBtn: 'Nuovo check-in',
    partnerNoCheckins: '{name} non ha ancora fatto check-in.',
    dailyNotesPrivate: 'Le note giornaliere sono private',
    goalAchievedMarked: '🎉 Obiettivo segnato come raggiunto',
    goalAchievedNote: '🎉 Il tuo obiettivo è segnato come raggiunto! Vai su Panoramica per svelarlo.',
    veylComplete: '✓ Questo Veyl è completo. I check-in sono in sola lettura.',
    goalAlreadyAchieved: '🎉 Hai segnato il tuo obiettivo come raggiunto! Vai su Panoramica per svelarlo.',
    didYouWork: 'Hai lavorato sul tuo obiettivo oggi?',
    howDidWeekGo: 'Com\'è andata questa settimana con il tuo obiettivo?',
    whatGotInWay: 'Cosa ti ha ostacolato? (Opzionale)',
    honestNote: 'Sii onesto. Il tuo partner è qui per supportarti, non per giudicarti.',
    whatDidYouLearn: 'Cosa hai imparato su te stesso questa settimana?',
    insightsPlaceholder: 'Quali intuizioni hai ottenuto?',
    whatPatterns: 'Che schema stai notando?',
    patternsPlaceholder: 'Temi o ostacoli ricorrenti?',
    whatChange: 'Cosa deve cambiare per la prossima settimana?',
    changePlaceholder: 'Cosa farai diversamente?',
    goalAchievedQuestion: '🏆 Hai raggiunto il tuo obiettivo generale?',
    yesDidIt: '🎉 Sì, ce l\'ho fatta!',
    notYetBtn: 'Non ancora',
    didIt: '✅ Fatto',
    didSome: '😐 Fatto qualcosa',
    didntDoIt: '❌ Non l\'ho fatto',
    metCommitment: '✅ Impegno rispettato',
    partialProgress: '😐 Progressi parziali',
    noProgress: '❌ Nessun progresso',
    rethinkingGoal: '🤔 Ripensando l\'obiettivo',
    yesLabel: '✅ Sì',
    aLittle: '😐 Un po\'',
    noLabel: '❌ No',
    madeProgress: 'Fatto progressi oggi',
    didSomething: 'Fatto qualcosa, non tutto',
    didntWork: 'Non ci ho lavorato oggi',
    metWeekly: 'Rispettato l\'impegno settimanale',
    madePartial: 'Progressi parziali',
    didntMake: 'Nessun progresso fatto',
    needToAdjust: 'Devo aggiustare il mio approccio',
    learnedLabel: 'Imparato: ',
    patternLabel: 'Schema: ',
    nextWeekLabel: 'Settimana prossima: ',
    joinGroup: 'Unisciti a un gruppo',
    joinGroupDesc: 'I gruppi riuniscono fino a 5 persone che lavorano su obiettivi simili. Anonimo, solidale, senza pressione.',
    whatToExpect: 'COSA ASPETTARSI',
    expectAnonymous: 'Tutti rimangono anonimi — stessi avatar silhouette',
    expectMatched: 'Abbinati per categoria di obiettivo per supporto pertinente',
    expectMembers: 'Fino a 5 membri per gruppo',
    expectChat: 'Chat di gruppo — 20 messaggi e 5 note vocali/giorno gratis · Illimitato con Premium',
    findOrCreate: 'Trova o crea un gruppo',
    findingGroup: 'Ricerca del tuo gruppo...',
    oneGroupNote: 'Puoi essere in un solo gruppo alla volta. Utenti gratuiti e Premium hanno entrambi accesso ai gruppi.',
    groupCreated: 'Gruppo creato!',
    groupJoined: 'Ti sei unito al gruppo!',
    groupCreatedDesc: 'Hai avviato un nuovo gruppo {category}. Altri si uniranno presto.',
    groupJoinedDesc: 'Ti sei unito a un gruppo {category} esistente. Di\' ciao!',
    switchToGroup: 'Passa alla scheda Gruppo nel tuo dashboard per iniziare a chattare.',
    groupMembers: 'Membri del gruppo',
    backToChat: '← Torna alla chat',
    creator: '★ Creatore',
    joined: 'Unito',
    leaveGroup: 'Lascia il gruppo',
    leaveGroupTitle: 'Lasciare questo gruppo?',
    leaveGroupDesc: 'Perderai l\'accesso alla chat di gruppo e potrai unirti a un nuovo gruppo in qualsiasi momento.',
    membersBtn: '👥 Membri',
    noGroupMessages: 'Nessun messaggio ancora. Sii il primo a dire ciao!',
    messageGroup: 'Scrivi al tuo gruppo...',
    groupDailyLimit: 'Hai raggiunto il limite giornaliero di messaggi di gruppo ({limit}/giorno). Passa a Premium per messaggi illimitati!',
    groupVoiceLimit: 'Limite giornaliero di note vocali raggiunto.',
    veylCommunity: 'Community Veyl',
    communityDesc: 'Unisciti ad altri che lavorano sulla stessa categoria di obiettivo mentre aspetti una corrispondenza.',
    communityJoinNote: 'Unisciti alla community dalla pagina di attesa mentre cerchi una corrispondenza.',
    leaveCommunity: 'Lasciare questa community?',
    communityLeaveDesc: 'Puoi tornare in qualsiasi momento dalla pagina di attesa.',
    matchRequests: 'Richieste di corrispondenza',
    incoming: 'In entrata',
    sent: 'Inviato',
    noIncoming: 'Nessuna richiesta in entrata.',
    noPending: 'Nessuna richiesta inviata in sospeso.',
    requestToAnonymous: 'Richiesta a utente anonimo',
    pending: 'In sospeso',
    decline: 'Rifiuta',
    accept: '✅ Accetta',
    requestWaiting: '🤝 {count} richiesta{plural} di corrispondenza in attesa',
    view: 'Vedi',
    requestsBtn: '🤝 Richieste',
    leaveBtn: 'Lascia',
    openToAll: 'Aperto a tutti · Anonimo',
    msgsLeft: '{count} messaggi rimasti',
    noCommunityMessages: 'Nessun messaggio ancora. Di\' ciao alla community!',
    saySomething: 'Di\' qualcosa alla community...',
    requestMatch: '🤝 Richiedi corrispondenza',
    requestSending: 'Invio...',
    communityMsgsWarning: '{count} messaggi community rimasti oggi.',
    communityDailyLimit: 'Hai raggiunto il limite giornaliero di messaggi community ({limit}/giorno). Passa a Premium per messaggi illimitati!',
    matchRequestLimit: 'Puoi avere solo 3 richieste in sospeso alla volta.',
    matchRequestSent: 'Richiesta di corrispondenza inviata con successo!',
    matchRequestDuplicate: 'Hai già inviato una richiesta a questa persona.',
    matchRequestError: 'Errore nell\'invio della richiesta di corrispondenza. Riprova.',
    matchAcceptError: 'Errore nell\'accettare la richiesta di corrispondenza.',
    matchRequestSentAlready: 'Hai già inviato una richiesta a questa persona.',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Verde acqua',
    avatar_purple: 'Viola',
    avatar_navy: 'Blu navy',
    avatar_slate: 'Ardesia',
    avatar_coral: 'Corallo',
    avatar_gold: 'Oro',
    avatar_moss: 'Muschio',
    avatar_indigo: 'Indaco',
    avatar_unveiled: 'Svelato',
    activeLabel: 'Attivo',
    seekingLabel: 'In cerca',
    completeLabel: 'Completo',
    upgradeForMore: '✨ Fai upgrade per altri Veyls',
    newVeyl: '+ Nuovo Veyl',
    newVeylTitle: 'Avvia un nuovo Veyl',
    goalCategoryLabel: 'Categoria obiettivo',
    goalDescriptionLabel: 'Descrizione obiettivo',
    startVeyl: 'Avvia nuovo Veyl',
    starting: 'Avvio...',
    unveil: 'Svela',
    clearing: 'Cancellazione...',
    nicknameRequired: 'Il soprannome è obbligatorio',
    nicknameTooShort: 'Il soprannome deve avere almeno 2 caratteri',
    nicknameTooLong: 'Il soprannome non può superare 20 caratteri',
    errorSavingNickname: 'Errore nel salvataggio del soprannome',
    errorSavingAvatar: 'Errore nel salvataggio dell\'avatar',
    errorDeletingAccount: 'Errore nell\'eliminazione dell\'account',
    deleteMyAccountButton: 'Elimina il mio account',
    goalsAchievedTitle: 'Obiettivi raggiunti',
    goalsPrivate: 'Privato — visibile solo a te.',
    goalsCompletedCount: '{count} obiettivi completati',
    keepAnonymous: 'Rimani anonimo. Non usare il tuo vero nome.',
    currentNicknameIs: 'Il tuo soprannome attuale è',
    unveiledLocked: '✨ Svelato — avatar bloccato',
    howOthersSee: 'Così ti vedono gli altri',
    unveiledNote: 'Hai svelato su questo Veyl. Avvia un nuovo Veyl per scegliere un nuovo avatar.',
    active2: '✓ Attivo',
    goalsAchieved: 'Obiettivi raggiunti',
    goalsAchievedDesc: 'Privato — visibile solo a te.',
    goalCompleted: 'obiettivo completato',
    goalsCompleted: 'obiettivi completati',
    contactSupport: 'Contatta il supporto',
    deleteWarning: '⚠️ Questo eliminerà tutto definitivamente. Scrivi ELIMINA qui sotto per confermare.',
    typeDelete: 'Scrivi ELIMINA per confermare',
    confirmDelete: 'Conferma eliminazione',
    deleting2: 'Eliminazione...',
    messagesLeft: '{count} messaggi · {voiceCount} note vocali rimaste oggi',
    premiumUnlimited: '✨ Premium — Messaggi e note vocali illimitati',
    messagesLeftWarning: '{count} messaggi rimasti oggi.',
    forUnlimited: 'per messaggi illimitati.',
    voiceNotesLeft: '{count} nota{plural} vocale{plural} rimasta{plural} oggi',
    dailyLimitReachedVoice: 'Limite giornaliero di note vocali raggiunto.',
    dailyVoiceNoteLimit: 'Limite giornaliero di note vocali raggiunto. Passa a Premium per note illimitate.',
    recording: 'Registrazione...',
    deeper: 'Più basso',
    neutral: 'Neutro',
    higher: 'Più alto',
    applyingModulation: '⚙️ Applicazione modulazione...',
    preview: '▶ Anteprima',
    pause: '⏸ Pausa',
    discard: 'Scarta',
    recordingTooLarge: 'Registrazione troppo grande. Prova un messaggio più breve.',
    failedToSend: 'Invio fallito. Riprova.',
    micDenied: 'Accesso al microfono negato.',
    unmatchMessage: 'Il tuo partner ha terminato questa sessione Veyl. Sei stato rimesso in abbinamento.',
    appearanceDesc: 'Scegli come appare Veyl per te.',
    newNickname: 'Nuovo soprannome',
    nicknamePlaceholder: 'es. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Scegli il tuo avatar',
    notificationsTitle: 'Notifiche',
    notificationsCount: '{total} totali · {unread} non lette',
    progressOf: 'Progressi di {name}',
    fitnessHealth: 'Fitness & Salute',
    learningSkills: 'Apprendimento & Competenze',
    businessCareer: 'Business & Carriera',
    creativeProjects: 'Progetti Creativi',
    progressOf: 'Progressi di {name}',
    dailyCheckin: 'Check-in Giornaliero',
    weeklyCheckin: 'Check-in Settimanale',
    dailyCheckinDesc: 'Aggiornamento rapido: Hai lavorato sul tuo obiettivo oggi?',
    weeklyCheckinDesc: 'Riflessione profonda: Com\'è andata questa settimana in generale?',
    submitDaily: 'Invia Check-in Giornaliero',
    submitWeekly: 'Invia Check-in Settimanale',
    submitting: 'Invio in corso...',
    checkinSubmitted: 'Check-in Inviato!',
    checkinSubmittedDesc: 'Ottimo lavoro nel mantenere la responsabilità. {name} vedrà il tuo aggiornamento.',
    viewHistory: 'Vedi la Mia Cronologia',
    newCheckin: '📝 Nuovo Check-in',
    myHistory: '📋 La Mia Cronologia',
    partnersProgress: '👤 Progressi di {name}',
    myCheckinHistory: 'La Mia Cronologia Check-in',
    checkinsForVeyl: '{count} check-in{plural} per questo Veyl',
    noCheckinsYet: 'Nessun check-in ancora. Inizia il primo!',
    newCheckinBtn: 'Nuovo Check-in',
    partnerNoCheckins: '{name} non ha ancora fatto il check-in.',
    dailyNotesPrivate: 'Le note giornaliere sono private',
    goalAchievedMarked: '🎉 Obiettivo segnato come raggiunto',
    goalAchievedNote: '🎉 Il tuo obiettivo è segnato come raggiunto! Vai su Panoramica per rivelare.',
    veylComplete: '✓ Questo Veyl è completo. I check-in sono in sola lettura.',
    goalAlreadyAchieved: '🎉 Hai segnato il tuo obiettivo come raggiunto! Vai su Panoramica per rivelare.',
    didYouWork: 'Hai lavorato sul tuo obiettivo oggi?',
    howDidWeekGo: 'Com\'è andata questa settimana con il tuo obiettivo?',
    whatGotInWay: 'Cosa ti ha ostacolato? (Opzionale)',
    honestNote: 'Sii onesto. Il tuo partner è qui per supportarti, non per giudicarti.',
    whatDidYouLearn: 'Cosa hai imparato su te stesso questa settimana?',
    insightsPlaceholder: 'Quali intuizioni hai acquisito?',
    whatPatterns: 'Che schema stai notando?',
    patternsPlaceholder: 'Temi o ostacoli ricorrenti?',
    whatChange: 'Cosa deve cambiare per la prossima settimana?',
    changePlaceholder: 'Cosa farai diversamente?',
    goalAchievedQuestion: '🏆 Hai raggiunto il tuo obiettivo generale?',
    yesDidIt: '🎉 Sì, ce l\'ho fatta!',
    notYetBtn: 'Non ancora',
    didIt: '✅ Fatto',
    didSome: '😐 Ho fatto qualcosa',
    didntDoIt: '❌ Non l\'ho fatto',
    metCommitment: '✅ Ho mantenuto l\'impegno',
    madePartial: '😐 Progresso parziale',
    didntMake: '❌ Nessun progresso',
    needToAdjust: '🤔 Devo rivedere il mio approccio',
    yesLabel: '✅ Sì',
    aLittle: '😐 Un po\'',
    noLabel: '❌ No',
    madeProgress: 'Ho fatto progressi oggi',
    didSomething: 'Ho fatto qualcosa, non tutto',
    didntWork: 'Non ci ho lavorato oggi',
    metWeekly: 'Ho mantenuto l\'impegno settimanale',
    didntMake: 'Non ho fatto progressi',
    needToAdjust: 'Devo rivedere il mio approccio',
    learnedLabel: 'Imparato: ',
    patternLabel: 'Schema: ',
    nextWeekLabel: 'Prossima settimana: ',
    problemTitle: 'I social media hanno rovinato la responsabilità',
    problem1: "Hai paura di ammettere quando sei in difficoltà",
    problem2: "Nascondi i fallimenti invece di imparare da essi",
    problem3: "Sparisci dai tuoi partner quando sbagli",
    veylIsDifferent: 'Veyl è diverso.',
    popular: 'POPOLARE',
    sixMonthDeal: 'o $20 per 6 mesi ($3,33/mese)',
    getStartedPremium: 'Inizia',
    buildTrust: 'Costruire Fiducia',
    unveilIdentity: 'Rivela la tua identità quando (o se) sei pronto',
    actuallyAchieve: 'Raggiungilo Davvero',
    makeRealProgress: 'Fai progressi reali senza la performance',
    faq1q: 'E se io e il mio partner non andiamo d\'accordo?',
    faq1a: 'Rematch facile. Nessuna domanda. Preferiamo che tu trovi la persona giusta piuttosto che forzare una partnership che non funziona.',
    faq2q: 'Devo rivelare la mia identità ad un certo punto?',
    faq2a: 'No. Alcune partnership rimangono anonime indefinitamente. Alcune si rivelano dopo una settimana. Dipende completamente da te.',
    faq3q: 'E se il mio partner mi fa ghosting?',
    faq3a: 'Gli utenti Premium ottengono un rematch istantaneo. Gli utenti gratuiti vengono rematched entro 48 ore.',
    faq4q: 'Perché mai le foto del profilo?',
    faq4a: 'Perché nel momento in cui aggiungi le foto, si tratta di gestire la percezione. L\'abbiamo testato. L\'anonimato mantiene il focus sul lavoro.',
    legalEnglishOnly: 'Questo documento è disponibile solo in inglese. Per domande, contatta il supporto o usa la funzione di traduzione del tuo browser.',
    ctaTitle: "Pronto a raggiungere davvero i tuoi obiettivi?",
    ctaSubtitle: "Unisciti a Veyl e trova un partner di responsabilità oggi. È gratis iniziare.",
    statAnonymous: "Anonimo",
    statLanguages: "Lingue",
    statToStart: "Per iniziare",
    authTagline: "Responsabilità anonima. Risultati reali.",
    authPricing: "Gratis per iniziare · Premium da $5/mese",
    taglineHonest: "Onesto",
    taglineEffective: "Efficace",
    foreverLabel: "/per sempre",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Passa a Premium",
    premiumActiveDesc: "Hai accesso illimitato a tutte le funzionalità di Veyl.",
    upgradeDesc: "Rimuovi tutti i limiti e ottieni l'esperienza completa di Veyl.",
    billedMonthly: "Fatturato mensilmente",
    bestValue: "MIGLIOR VALORE",
    perSixMonths: "$3,33/mese",
    unlimitedMessages: "Messaggi illimitati",
    unlimitedVoice: "Note vocali illimitate",
    unlimitedGroup: "Gruppo illimitato",
    unlimitedCommunity: "Comunità illimitata",
    was10day: "erano 10/giorno",
    was5day: "erano 5/giorno",
    was20day: "erano 20/giorno",
    was30day: "erano 30/giorno",
    sixMonthPlan: "Piano 6 mesi",
    monthlyPlan: "Piano mensile",
    modulationFailed: "Modulazione fallita — uso della voce originale",
    monthly: "Mensile",
    sixMonths: "6 Mesi",
    savePercent: "Risparmia {{percent}}%",
    pricePerMonth: "${{price}} / mese",
    priceTotal: "${{price}} totale",
    unlimitedMessages: "Messaggi illimitati",
    unlimitedVoiceNotes: "Note vocali illimitate",
    unlimitedGroupMessages: "Messaggi di gruppo illimitati",
    unlimitedCommunityMessages: "Messaggi della community illimitati",
    upgrade: "Aggiorna",
    forUnlimited: "per illimitato",
    messagesLeftWarning: "{{count}} messaggi rimasti oggi",
    recordVoiceNote: "Registra nota vocale",
    uploading: "Caricamento",
    maxDuration: "{{seconds}}s max",
    upgradeToPremium: "Passa a Premium",
    dailyMessageLimitReached: "Hai raggiunto il tuo limite di messaggi giornaliero.",
    dailyVoiceLimitReached: "Hai raggiunto il tuo limite di note vocali giornaliero.",
    dailyGroupMessageLimitReached: "Hai raggiunto il tuo limite di messaggi di gruppo giornaliero.",
    dailyGroupVoiceLimitReached: "Hai raggiunto il tuo limite di note vocali di gruppo giornaliero.",
    unlockUnlimited: "Sblocca l'accesso illimitato a tutte le funzionalità.",
    maybeLater: "Forse più tardi",
    premiumUnlimited: "Illimitato",
    premium: "Premium",
    msg: "msg",
    msgs: "msg",
    newMessageNotification: "{{name}} ti ha inviato un messaggio 💬",
    newGroupMessageNotification: "{{name}} ha inviato un messaggio nel tuo gruppo 👥",
    someone: "qualcuno",
    failedToLoad: "Caricamento fallito",
    groupMessagesLeftWarning: "{{count}} messaggi rimasti oggi",
    howOldAreYou: 'Quanti anni hai?',
    minorGroupNote: 'Sarai abbinato/a con altri utenti della tua età (13–17).',
    adultGroupNote: 'Sarai abbinato/a con altri adulti (18+).',
    enterYourAge: 'Inserisci la tua età',
    getStarted:        'Inizia',
    howItWorks:        'Come funziona',
    statAnonymous:     'Anonimo',
    statLanguages:     'Lingue',
    statToStart:       'Per iniziare',
    taglineHonest:     'Onesto',
    taglineEffective:  'Efficace',
    landingHero:       'Responsabilità senza la messa in scena.',
    landingSubtitle:   'Trova un partner anonimo che condivide i tuoi obiettivi. Senza follower. Senza pressione — solo progresso onesto.',
    problemTitle:      'La responsabilità è rotta.',
    problem1:          'I social media trasformano il miglioramento personale in performance. Pubblichi obiettivi per i like, non per progredire.',
    problem2:          'Amici e famiglia portano giudizi o indifferenza. L\'onestà vera diventa impossibile.',
    problem3:          'Le app di responsabilità sembrano strumenti di monitoraggio — dashboard sterili che ignorano completamente l\'elemento umano.',
    veylIsDifferent:   'Veyl è diverso.',
    step1Title:        'Crea il tuo profilo',
    step1Desc:         'Scegli uno pseudonimo, una categoria di obiettivo e la tua preferenza di comunicazione. La tua vera identità rimane tua.',
    step2Title:        'Trova un abbinamento',
    step2Desc:         'Veyl trova un partner che condivide il tuo tipo di obiettivo e la tua fascia d\'età. Istantaneo — nessuno scroll, nessuno swipe.',
    step3Title:        'Inizia a parlare',
    step3Desc:         'Chatta o invia note vocali. Fai il punto ogni giorno o ogni settimana. Il tuo partner ti responsabilizza — e tu fai lo stesso.',
    buildTrust:        'Costruire fiducia',
    unveilIdentity:    'Registra le tue vittorie. Quando c\'è fiducia, puoi scegliere di rivelare la tua identità — o no.',
    actuallyAchieve:   'Raggiungere davvero',
    makeRealProgress:  'Progresso reale con un essere umano reale. Niente gamification. Solo tu, il tuo partner e il tuo obiettivo.',
    pricingTitle:      'Inizia gratis. Vai più in profondità quando sei pronto.',
    freePlan:          'Gratuito',
    foreverLabel:      '/ per sempre',
    freeFeature1:      '1 partner di responsabilità',
    freeFeature2:      '10 messaggi al giorno',
    freeFeature3: '10 messaggi vocali al giorno',
    freeFeature5:      'Stanze di gruppo e community',
    popular:           'Più popolare',
    premiumPlan:       'Premium',
    perMonth:          '/ mese',
    sixMonthDeal: 'Abbonamento semestrale a 20 dollari: risparmia il 33%',
    premiumFeature1:   'Messaggi illimitati',
    premiumFeature2:   'Note vocali illimitate',
    premiumFeature3:   'Funzione di rivelazione partner',
    premiumFeature4:   'Abbinamento prioritario',
    getStartedPremium: 'Inizia premium',
    faqTitle:          'Domande frequenti.',
    faq1q: 'Veyl è davvero anonimo?',
    faq1a: 'Sì. Ti registri con uno pseudonimo. Nessun nome reale, nessuna foto, niente che ti identifichi. Il tuo partner sa solo ciò che scegli di condividere.',
    faq2q: 'Come funziona l\'abbinamento?',
    faq2a: 'Veyl ti abbina a qualcuno nella stessa categoria di obiettivo e fascia d\'età. Di solito richiede meno di due minuti.',
    faq3q: 'E se non vado d\'accordo con il mio partner?',
    faq3a: 'Puoi segnalare o bloccare il tuo partner in qualsiasi momento senza domande. Trova un abbinamento migliore.',
    faq4q: 'È sicuro per i minori?',
    faq4a: 'Assolutamente. Gli utenti dai 13 ai 17 anni vengono abbinati solo con altri dello stesso gruppo d\'età. Applicato a livello di sistema.',
    ctaTitle:    'Il tuo partner ti sta già aspettando.',
    ctaSubtitle: 'Unisciti a Veyl gratuitamente. Nessun profilo social richiesto. Solo tu, il tuo obiettivo e qualcuno che capisce.',
    privacyPolicy:  'Informativa sulla privacy',
    termsOfService: 'Termini di servizio',
    refundPolicy:   'Politica di rimborso',
    featuresTitle: "Tutto ciò di cui hai bisogno. Niente di superfluo.",
    feature1Title: "Anonimato totale",
    feature1Desc: "Scegli uno pseudonimo. Il tuo vero nome, foto e identità non vengono mai condivisi, a meno che tu non decida di rivelarli.",
    feature2Title: "Note vocali",
    feature2Desc: "A volte scrivere non basta. Registra e invia note vocali direttamente nell'app.",
    feature3Title: "Abbinamento sicuro per età",
    feature3Desc: "I minori (13–17 anni) vengono abbinati solo ad altri minori. Adulti con adulti. Nessuna eccezione — è integrato nel sistema.",
    feature4Title: "13 lingue",
    feature4Desc: "Inglese, swahili, francese, spagnolo, portoghese, tedesco, italiano, hindi, indonesiano, cinese, giapponese, coreano, hausa.",
    feature5Title: "Check-in quotidiani",
    feature5Desc: "I check-in strutturati mantengono lo slancio. Registra i progressi e festeggia i traguardi con il tuo partner.",
    feature6Title: "Gruppi e community",
    feature6Desc: "Partecipa a chat di gruppo per obiettivo e stanze di community per lingua.",
    goalsEyebrow: "Per obiettivi reali",
    goalsTitle: "Qualunque cosa tu stia facendo.",
    goalsSub: "Veyl è per chiunque abbia un obiettivo reale e nessuno con cui essere davvero sincero al riguardo.",
    goalFitness: "Fitness e Salute",
    goalLearning: "Apprendimento e Competenze",
    goalBusiness: "Business e Carriera",
    goalCreative: "Progetti Creativi",
    moreComingSoon: "Altre presto disponibili",
    safeTitle: "La sicurezza non è una funzione. È la base.",
    safe1Title: "Separazione per età",
    safe1Desc: "Minori e adulti non vengono mai mescolati. L'età viene verificata alla registrazione e bloccata.",
    safe2Title: "Segnala e blocca",
    safe2Desc: "Qualsiasi utente può segnalare o bloccare istantaneamente. Senza domande.",
    safe3Title: "Nessuna vendita di dati",
    safe3Desc: "I tuoi obiettivi, messaggi e identità sono tuoi. Punto.",
    safe4Title: "Solo pseudonimi",
    safe4Desc: "I nomi reali non sono mai richiesti. Decidi tu se e quando rivelarti.",
    refundPolicy: "Politica di Rimborso",
    heroLine1: 'Responsabilità',            
    heroLine2: 'senza la messa in scena',
    mustBe18: 'Devi avere almeno 18 anni per usare Veyl',
    mustBe18Desc: "Veyl è una piattaforma riservata ai maggiori di 18 anni. Siamo spiacenti, ma non soddisfi il requisito di età minima per creare un account.",
    ageAttestationLabel: 'Confermo di avere almeno 18 anni.',
    ageMisrepresentationNote: "Dichiarare un'età falsa viola i nostri Termini di Servizio e può comportare la chiusura dell'account.",
    feature3Title: 'Verificato solo 18+',
    feature3Desc: 'Ogni membro conferma di avere almeno 18 anni prima di iscriversi. Nessun minore, senza eccezioni.',
    faq4q: 'Veyl è disponibile per i minorenni?',
    faq4a: 'No. Veyl è una piattaforma riservata esclusivamente ai maggiori di 18 anni. Ogni utente conferma la propria età durante la registrazione e gli account che dichiarano un\u2019età falsa possono essere rimossi.',
    safe1Title: 'Solo adulti',
    safe1Desc: 'Veyl è progettato esclusivamente per persone di almeno 18 anni. Chiunque sia minorenne e tenti di usare Veyl sta dichiarando un\u2019età falsa, violando i nostri Termini di Servizio.',
    ageVerificationDesc: 'Veyl è disponibile per utenti di età pari o superiore a 18 anni.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Modifica il tuo obiettivo',
    adjustGoalDesc: 'Va bene cambiare direzione. Il tuo partner verrà avvisato.',
    newGoalDescription: 'Descrizione del nuovo obiettivo',
    newGoalPlaceholder: 'Qual è il tuo nuovo obiettivo o quello modificato?',
    updateGoal: 'Obiettivo di aggiornamento',
    goalUpdated: 'Obiettivo aggiornato con successo! Il tuo partner è stato avvisato.',
    readyToUnveil: 'Pronti a svelare?',
    unveilDesc: 'La disvelatura sancisce il completamento di questo Velo. Il tuo partner verrà avvisato. Questa operazione è irreversibile.',
    yourNewAvatar: 'Il tuo nuovo avatar',
    notYet: 'Non ancora',
    unveiling: 'Svelare...',
    sending: 'Invio in corso...',
    checkInDesc: 'I controlli giornalieri tengono traccia dei progressi. I controlli settimanali offrono spunti di riflessione più approfonditi.',
    dismiss: '✕',
    saving: 'Risparmio...',
    saved: '✓ Salvato!',
    lightModeDesc: 'Pulito e luminoso',
    darkModeDesc: 'Piacevole alla vista',
    currentNickname: 'Il tuo nickname attuale è',
    anonymousWarning: 'Mantieni l\'anonimato. Non usare il tuo vero nome.',
    nicknameUpdated: '✓ Soprannome aggiornato!',
    deleteMyAccount: 'Elimina il mio account',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Vi presentiamo Rasa',
    rasaIntroDesc: 'Rasa è uno spazio privato per la riflessione, pensato solo per te, separato dal tuo partner di responsabilità. Non parte da preconcetti su di te o sul mondo; impara solo da ciò che scegli di condividere ed è progettato per porre domande piuttosto che fornire risposte.',
    rasaIntroNotTherapist: 'Rasa non è una terapeuta e non sostituisce una vera connessione umana, incluso il tuo partner di supporto. Se qualcosa ti pesa, ti indirizzerà delicatamente verso il supporto, senza cercare di sostituirsi a te.',
    rasaIntroStart: 'Inizio',
    rasaMessagesLeft: 'riflessi lasciati oggi',
    rasaNoMessagesYet: 'Quando ti sentirai pronto a riflettere, inizia a scrivere qui sotto.',
    rasaThinking: 'Rasa sta riflettendo…',
    rasaPrivateNote: 'Riservato solo a te, mai visibile al tuo partner di responsabilità.',
    rasaPlaceholder: 'Condividi i tuoi pensieri…',
    rasaDailyLimitReached: 'Hai raggiunto il limite Rasa di oggi. Si azzera domani.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Vi presentiamo Rasa',
    feature7Desc: 'Uno spazio privato per riflettere, solo per te, separato dal tuo partner di responsabilità.',
    feature8Title: 'Ricevi assistenza in qualsiasi momento',
    feature8Desc: 'Risposte rapide a domande su navigazione, fatturazione e account, direttamente nell\'app.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Assistenza clienti Veyl',
    supportChatTitle: 'Supporto Veyl',
    supportChatEmptyState: 'Chiedetemi qualsiasi cosa sul funzionamento di Veyl.',
    supportChatPlaceholder: 'Poni una domanda…',
    supportChatSend: 'Inviare',
    supportChatTyping: 'Sto scrivendo…',
    supportChatLimitReached: 'Hai raggiunto il limite di chat di supporto per oggi. Se la tua richiesta è urgente, invia un\'e-mail a support@veyl.space.',
    supportChatGenericError: 'Si è verificato un errore. Riprova.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Impossibile caricare la conversazione.',
    rasaLoadErrorDetail: 'Controlla la console del browser per i dettagli oppure prova ad aggiornare la pagina.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Ti è stato assegnato un match con {name}! Vai alla tua dashboard.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Installa l\'app',
    installMobileOnly: 'Solo per dispositivi mobili',
    installTooltip: 'Disponibile solo su dispositivi mobili',
    installModalTitle: 'Installa Veyl sul tuo telefono',
    installStep1: 'Tocca l\'icona Condividi nella barra degli strumenti di Safari',
    installStep2: 'Scorri verso il basso e tocca "Aggiungi alla schermata iniziale"',
    installStep3: 'Tocca "Aggiungi" nell\'angolo in alto a destra',
    installGotIt: 'Fatto',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Relazioni e connessioni',
    homeLifeOrganization: 'Organizzazione della casa e della vita quotidiana',
    moneyFinancialHabits: 'Denaro e abitudini finanziarie',
    stayingConnected: 'Rimanere connessi',
    independentLiving: 'Vita indipendente',
    techConfidence: 'Fiducia tecnologica',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Relazioni e connessioni',
    goalHomeLife: 'Organizzazione della casa e della vita quotidiana',
    goalMoney: 'Denaro e abitudini finanziarie',
    goalStayingConnected: 'Rimanere connessi',
    goalIndependentLiving: 'Vita indipendente',
    goalTechConfidence: 'Fiducia tecnologica',
    // [auto-synced 2026-10-28]
    resources: 'Risorse',
    resourcesTitle: 'Risorse',
    resourcesWriteUps: 'Articoli',
    resourcesLinks: 'Per approfondire',
    resourcesOpensNewTab: 'Si apre in una nuova scheda',
    resourcesEmptyTitle: 'Ancora niente.',
    resourcesEmptyBody: 'Stiamo ancora raccogliendo risorse per questa categoria. Tornate a trovarci presto.',
    resourcesNoMatchBody: 'Non siamo ancora riusciti a trovare le risorse necessarie per raggiungere questo obiettivo.',
    resourcesDisclaimer: 'Queste informazioni sono di carattere generale e non costituiscono consulenza professionale. Se la situazione riguarda la tua salute, la tua sicurezza o le tue finanze, rivolgiti a un professionista qualificato.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Articoli',
    resourcesMoreToRead: 'Altro da leggere',
    res_intro_fitnessHealth: 'Gli obiettivi di fitness e salute si raggiungono solitamente con piccoli momenti quotidiani, non con grandi imprese. Questi articoli sono pensati per alleviare la pressione e i link rimandano a fonti che approfondiscono l\'argomento.',
    res_fitness_showing_up_title: 'Presentarsi è meglio che mettersi in mostra',
    res_fitness_showing_up_p1: 'La maggior parte di noi ha in mente un\'immagine precisa di come dovrebbe essere l\'esercizio fisico "per bene": la palestra, le scarpe da corsa, il sudore. Quando la vita non corrisponde a quest\'immagine, è facile pensare che l\'attività fisica non faccia per noi.',
    res_fitness_showing_up_p2: 'L\'Organizzazione Mondiale della Sanità adotta un punto di vista molto più ampio. Considera il movimento durante il tempo libero, gli spostamenti da un luogo all\'altro e l\'attività svolta sul lavoro o a casa. Camminare, andare in bicicletta, praticare sport e giocare sono tutti attività che contano, a qualsiasi livello di abilità. Le sue linee guida sottolineano che qualsiasi quantità di attività fisica è meglio di nessuna.',
    res_fitness_showing_up_p3: 'Questo è importante quando si cerca di costruire un\'abitudine con un partner. Una breve passeggiata fatta davvero vale più di una sessione impegnativa pianificata e poi saltata. Anche un semplice "Sono riuscito a fare solo dieci minuti" è un promemoria che ha mantenuto vivo l\'impegno.',
    res_fitness_showing_up_p4: 'Aiuta anche a separare ciò che hai fatto da come ti sei sentito. Certi giorni, l\'abitudine è già di per sé vincente. L\'intensità può arrivare dopo, una volta che presentarsi non è più oggetto di negoziazione.',
    res_fitness_showing_up_p5: 'Se soffrite di qualche patologia, siete in gravidanza o non fate attività fisica da molto tempo, è consigliabile consultare un medico o un altro professionista sanitario qualificato prima di modificare l\'intensità del vostro allenamento.',
    res_fitness_rest_title: 'Il riposo fa parte del piano',
    res_fitness_rest_p1: 'Quando si parla di obiettivi di fitness, il sonno e il riposo vengono solitamente considerati come qualcosa che rimane dopo aver fatto il vero lavoro. In realtà, sono fondamentali per la tenuta dei risultati ottenuti.',
    res_fitness_rest_p2: 'Sonno e attività fisica si influenzano a vicenda. Il Servizio Sanitario Nazionale (NHS) britannico sottolinea che l\'attività fisica regolare può favorire un sonno migliore e che per alcune persone l\'esercizio fisico prima di andare a letto può essere controproducente; in questi casi, potrebbe essere più indicato allenarsi prima durante la giornata. Nessuna di queste affermazioni è una regola fissa, ma serve a ricordare che solo tu puoi scoprire cosa funziona meglio per il tuo corpo.',
    res_fitness_rest_p3: 'Anche il riposo è importante quando ci si responsabilizza a vicenda. Se ogni confronto si trasforma in un resoconto di quanto ci si è impegnati, una giornata tranquilla inizia a sembrare un fallimento. Un giorno libero scelto di proposito è diverso dal divagare dall\'obiettivo, ed è giusto dirlo apertamente.',
    res_fitness_rest_p4: 'Se hai difficoltà a dormire per un periodo prolungato, o se ti senti esausto per motivi che non riesci a definire con precisione, è opportuno parlarne con un medico o un altro professionista sanitario qualificato. Non è una situazione da affrontare da soli.',
    res_fitness_food_title: 'Cibo senza complicazioni',
    res_fitness_food_p1: 'I consigli sull\'alimentazione sono spesso contraddittori e spesso discordanti, quindi è bene sapere che i principali enti di sanità pubblica sono più permissivi rispetto alla maggior parte di ciò che si trova su internet.',
    res_fitness_food_p2: 'L\'OMS afferma che le diete sane si presentano in molte forme. Ciò che si considera un modo sensato di mangiare dipende dall\'età, dallo stile di vita, dalla cultura e dagli alimenti effettivamente reperibili nel luogo in cui si vive. Descrive quattro principi fondamentali che stanno alla base di ogni regime alimentare sano: assumere la quantità di nutrienti di cui il corpo ha bisogno, mantenere un equilibrio, gustare alcuni alimenti con moderazione e seguire una dieta varia. Il fondamento su cui si basa è una dieta varia e prevalentemente a base di alimenti non trasformati.',
    res_fitness_food_p3: 'Per un obiettivo che perseguite insieme a qualcun altro, questo è un utile punto di partenza. Non è necessario che tu copi le abitudini alimentari del tuo partner, né che lui/lei copi le tue. Un obiettivo alimentare può essere semplice come "cucinare più spesso a casa" o "mangiare qualcosa di diverso dal solito questa settimana", a seconda di ciò che si adatta alla tua vita e al tuo budget.',
    res_fitness_food_p4: 'Se stai pensando di apportare grandi cambiamenti al tuo regime alimentare, o se soffri di una patologia, hai un\'allergia o assumi farmaci che possono influire sul tuo apporto di cibo, un medico o un dietologo qualificato possono fornirti consigli personalizzati. Un testo generico non può farlo.',
    res_fitness_who_physical_activity_note: 'A livello globale. Una semplice panoramica di cosa si intende per attività, chi ne beneficia e perché.',
    res_fitness_who_guidelines_note: 'Globale. Le linee guida complete, con raccomandazioni per diverse fasce d\'età e per persone affette da patologie croniche o disabilità.',
    res_fitness_who_healthy_diet_note: 'Globale. Spiega i principi alla base di una dieta sana e perché questa varia a seconda della cultura e degli alimenti locali.',
    res_fitness_nhs_sleep_note: 'Regno Unito. Consigli pratici sul sonno. I riferimenti a un medico di base o a un farmacista si riferiscono a servizi sanitari del Regno Unito.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Ricevi una notifica quando Veyl è chiuso.',
    pushPromptBody: 'Ti avviseremo quando troverai un partner compatibile o quando ti invierà un messaggio. Le notifiche non includono mai il contenuto dei messaggi.',
    pushEnable: 'Attiva le notifiche',
    pushNotNow: 'Non adesso',
    pushError: 'Si è verificato un errore durante l\'attivazione delle notifiche. Riprova.',
    pushBlockedTitle: 'Le notifiche sono bloccate',
    pushBlockedBody: 'Il tuo browser sta bloccando le notifiche di Veyl. Per attivarle, apri le impostazioni del sito veyl.space nel tuo browser, abilita le notifiche e poi ricarica la pagina.',
    pushIosTitle: 'Ricevi notifiche su iPhone',
    pushIosBody: 'Innanzitutto, aggiungi Veyl alla schermata iniziale: tocca Condividi, poi Aggiungi alla schermata iniziale, quindi apri Veyl da lì e attiva le notifiche.',
    pushSettingsTitle: 'Notifiche su questo dispositivo',
    pushSettingsDesc: 'Ricevi una notifica quando trovi un partner compatibile o quando ti invia un messaggio, anche quando Veyl è chiuso. Le notifiche non includono mai il contenuto dei messaggi. Questa impostazione si applica solo a questo dispositivo.',
    pushSettingsUnsupported: 'Le notifiche non sono disponibili in questo browser. Su iPhone o iPad, aggiungi prima Veyl alla schermata Home (Condividi, poi Aggiungi alla schermata Home), quindi aprilo da lì.',
    pushSettingsBlocked: 'Le notifiche per Veyl sono bloccate nel tuo browser. Per attivarle, apri le impostazioni del sito veyl.space nel tuo browser, abilita le notifiche e poi ricarica la pagina.',
    pushSettingsWorking: 'Lavorando…',
    pushSettingsOn: 'Le notifiche sono attive per questo dispositivo.',
    pushSettingsTurnOff: 'Disattiva le notifiche',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Imparare qualcosa di nuovo dipende soprattutto dalla costanza e dalla frequenza con cui si assimila. Questi articoli parlano di un percorso a lungo termine, e i link rimandano a risorse gratuite dove imparare praticamente qualsiasi cosa.',
    res_learning_small_repeat_title: 'Abbastanza piccolo da poter ripetere',
    res_learning_small_repeat_p1: 'La maggior parte degli obiettivi di apprendimento fallisce perché troppo ambiziosi, non troppo difficili. "Imparare a programmare" o "diventare fluente in portoghese" sono traguardi da raggiungere, non qualcosa che si può fare un martedì sera.',
    res_learning_small_repeat_p2: 'Quello che puoi fare un martedì sera è sederti per venti minuti e dedicarti a una lezione. È un\'attività che puoi ripetere, ed è proprio ripetendola che l\'apprendimento si consolida. Le competenze tendono ad arrivare gradualmente, un po\' alla volta, finché un giorno ti accorgi di poter fare qualcosa che prima non eri in grado di fare.',
    res_learning_small_repeat_p3: 'È qui che un partner che ti responsabilizza si rivela più utile della semplice motivazione. La motivazione va e viene. Un partner che si aspetta di sapere come è andata rende più difficile abbandonare l\'abitudine in silenzio e più facile ricominciare dopo una settimana negativa.',
    res_learning_small_repeat_p4: 'Un buon check-in non deve essere per forza impressionante. "Ho fatto una lezione e ne ho capito circa la metà" è onesto e aiuta a mantenere viva l\'abitudine. Potrai aumentare la difficoltà del compito in seguito. È molto più difficile ricostruire un\'abitudine che si è interrotta.',
    res_learning_beginner_title: 'Essere un principiante è consentito',
    res_learning_beginner_p1: 'Iniziare qualcosa di nuovo significa non essere bravi, almeno di fronte a una persona. Per molti adulti, questo è il vero ostacolo, più del tempo o del denaro.',
    res_learning_beginner_p2: 'Può essere utile sapere quanto sia diventato aperto l\'apprendimento. MIT OpenCourseWare pubblica gratuitamente materiali provenienti da migliaia di corsi del MIT, senza bisogno di registrazione. OpenLearn della Open University offre quasi mille brevi corsi gratuiti e afferma che non ci sono requisiti per accedervi. Non serve il permesso di nessuno per provare una materia o per scoprire che non fa per voi.',
    res_learning_beginner_p3: 'Anche provare qualcosa e decidere che non fa per te conta come apprendimento. Sperimentare diverse cose prima di impegnarsi in una in particolare è un ottimo modo per iniziare.',
    res_learning_beginner_p4: 'Quando ti senti indietro, ricorda che anche il tuo partner potrebbe provare la stessa sensazione riguardo al proprio obiettivo. Non siete in competizione. Siete entrambi all\'inizio di qualcosa, in punti diversi.',
    res_learning_choose_one_title: 'Scegli una cosa, poi continua a sceglierla',
    res_learning_choose_one_p1: 'L\'apprendimento gratuito ha uno strano problema: ce n\'è troppo. Solo OpenCourseWare offre più di 2.500 corsi, e OpenLearn ne ha quasi un migliaio. È facile passare un\'intera serata a navigare e considerarla un\'esperienza di apprendimento.',
    res_learning_choose_one_p2: 'È utile scegliere un corso, un libro o una serie di lezioni e rimandare tutto il resto a un secondo momento. Annotare gli altri compiti va benissimo. L\'obiettivo è finire un\'attività prima di iniziarne un\'altra. Comunicare al partner quale si è scelta è un piccolo impegno che rende più facile portarla a termine.',
    res_learning_choose_one_p3: 'È inoltre importante verificare cosa una risorsa offre e cosa non offre. I corsi di OpenLearn, ad esempio, prevedono un attestato di partecipazione e, in alcuni casi, un badge digitale che non costituisce una qualifica accreditata. Se per motivi di lavoro o di studio è necessaria una qualifica formale, è bene saperlo fin da subito, e l\'istituto a cui si intende iscriversi può fornire informazioni sui titoli che accetta.',
    res_learning_mit_ocw_note: 'Globale. Appunti delle lezioni, esami e video gratuiti da migliaia di corsi del MIT, senza registrazione. In inglese.',
    res_learning_khan_academy_note: 'Globale. Un\'organizzazione no-profit che offre lezioni ed esercizi gratuiti, specializzati in matematica e scienze, in numerose lingue.',
    res_learning_openlearn_note: 'Con sede nel Regno Unito, aperto a tutti. Quasi 1.000 corsi brevi gratuiti, da circa 1 a 24 ore, ognuno con un attestato di partecipazione gratuito.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Gli obiettivi lavorativi sono a lungo termine e la maggior parte dello sforzo si concentra nei giorni che intercorrono tra una tappa e l\'altra. Questi articoli hanno lo scopo di aiutarti a mantenere un ritmo costante, e i link che trovi sono risorse gratuite per sviluppare competenze e pianificare i tuoi prossimi passi.',
    res_business_progress_title: 'La progressione sul lavoro raramente segue un percorso lineare.',
    res_business_progress_p1: 'Gli obiettivi di carriera e professionali tendono a dilatarsi nel tempo. Una promozione, un cambio di carriera o il primo cliente possono richiedere mesi, e i giorni che intercorrono tra un obiettivo e l\'altro raramente danno la sensazione di un vero progresso.',
    res_business_progress_p2: 'È utile distinguere il risultato desiderato dalle cose che si possono effettivamente fare questa settimana. Non si può controllare se un\'azienda ti assume o se un cliente accetta. Si può però controllare quante conversazioni si hanno, quanto tempo si dedica al progetto e se si dà seguito alle promesse fatte.',
    res_business_progress_p3: 'È qui che entra in gioco un partner per la responsabilizzazione. Non ha bisogno di conoscere il tuo settore. Deve solo chiederti cosa hai fatto e ascoltare la risposta senza farla sembrare una performance.',
    res_business_progress_p4: 'A volte, la verità è che "non è successo granché". Vale la pena dirlo apertamente, perché è molto più difficile riprendere in mano un obiettivo che rimane in sospeso per un mese rispetto a uno che si è tenuto vivo solo superficialmente.',
    res_business_start_from_you_title: 'Parti da te stesso, non dal lavoro.',
    res_business_start_from_you_p1: 'Quando ci si sente bloccati sul lavoro, l\'istinto è spesso quello di iniziare a esaminare il mercato del lavoro: cosa assume, cosa offre una buona retribuzione, cosa sembra interessante. Può essere più utile iniziare da un\'altra prospettiva.',
    res_business_start_from_you_p2: 'Il corso gratuito di OpenLearn "Succeed in the workplace" si basa proprio su questa idea. Parte dal presupposto che conoscere se stessi e i propri valori sia il fondamento della pianificazione della carriera, per poi passare a curriculum vitae, candidature e colloqui.',
    res_business_start_from_you_p3: 'In parole semplici: come vorresti che fossero le tue giornate? In cosa sei bravo ma raramente ricevi il giusto riconoscimento? A cosa rinunceresti, che si tratti di tempo da trascorrere con la famiglia, di un reddito stabile o della possibilità di esprimere la tua creatività?',
    res_business_start_from_you_p4: 'Non devi rispondere a tutte queste domande da solo. Parlarne con il tuo partner spesso fa emergere aspetti che altrimenti tralasceresti, e può trasformare un vago "Vorrei qualcosa di diverso" in un obiettivo concreto su cui lavorare.',
    res_business_wear_out_title: 'Lavorare sodo senza però esaurirsi',
    res_business_wear_out_p1: 'Ambizione e spossatezza possono apparire simili dall\'interno, soprattutto quando un obiettivo è importante per te.',
    res_business_wear_out_p2: 'L\'Organizzazione Mondiale della Sanità osserva che il lavoro può proteggere la salute mentale, ma può anche contribuire a danneggiarla. Le sue linee guida sulla salute mentale sul lavoro evidenziano rischi come carichi di lavoro eccessivi e comportamenti negativi sul posto di lavoro, e affermano che la responsabilità di un ambiente di lavoro sano ricade sui datori di lavoro e sui governi, non solo sui singoli lavoratori.',
    res_business_wear_out_p3: 'Se vi confrontate con il vostro partner su un importante obiettivo lavorativo, vale la pena chiedere non solo "Ce l\'hai fatta?" ma anche "Come stai?". Un obiettivo perseguito a scapito del sonno, della salute o delle relazioni merita di essere riconsiderato, anche se sulla carta sembra andare tutto per il meglio.',
    res_business_wear_out_p4: 'Se il lavoro sta influenzando la tua salute o se ti senti persistentemente giù di morale, ansioso o esausto, ti preghiamo di parlarne con un medico o un altro professionista sanitario qualificato. Se non sei sicuro dei tuoi diritti sul lavoro, una fonte locale affidabile, come un\'autorità del lavoro o un\'organizzazione dei lavoratori, può fornirti spiegazioni in merito alla normativa vigente nel tuo Paese. Le regole variano notevolmente da Paese a Paese.',
    res_business_who_mh_work_note: 'Globale. Scritto principalmente per datori di lavoro e governi, quindi di carattere tecnico. Il riassunto esecutivo è disponibile in arabo, cinese, inglese, francese, russo e spagnolo.',
    res_business_openlearn_entrepreneurship_note: 'Corso con sede nel Regno Unito. 24 ore suddivise in 8 sessioni, e puoi iniziare anche senza iscriverti. Parte del corso tratta le normative commerciali del Regno Unito, quindi verifica quali si applicano nel tuo paese.',
    res_business_openlearn_succeed_note: 'Circa 8 settimane, con circa 3 ore di lezione a settimana, dedicate alla pianificazione della carriera, alla redazione del curriculum vitae e ai colloqui di lavoro. Ultimo aggiornamento nel 2021, quindi alcune parti sulla ricerca di lavoro e sui social media potrebbero risultare datate.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Fuso orario',
    timezoneCurrentIs: 'Il tuo fuso orario attuale è',
    timezoneLockNote: 'Il limite giornaliero di messaggi e note vocali si azzera a mezzanotte, nel tuo fuso orario. Per garantire l\'equità, puoi cambiare il tuo fuso orario solo in un giorno in cui non hai utilizzato messaggi o note vocali e solo una volta ogni 7 giorni.',
    timezoneNew: 'Seleziona il fuso orario',
    saveTimezone: 'Salva il fuso orario',
    timezoneUpdated: 'Fuso orario aggiornato',
    timezoneInvalid: 'Quel fuso orario non è valido. Selezionane uno dall\'elenco.',
    timezoneChangeError: 'Impossibile modificare il fuso orario. Riprova.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'I progetti creativi tendono a vivere negli spazi vuoti tra ogni altra cosa. Questi articoli trattano di come mantenere vivo qualcosa durante i lunghi periodi di transizione, e i link includono argomenti come imparare a scrivere, utilizzare e condividere il proprio lavoro creativo.',
    res_creative_finishing_title: 'Anche la finalizzazione è un\'abilità',
    res_creative_finishing_p1: 'Avviare un progetto creativo è la parte facile. L\'idea è fresca e tutto sembra possibile. La parte difficile arriva nel mezzo, quando l\'idea si è trasformata in un lavoro concreto e il lavoro è più lento e caotico di quanto non lo fosse all\'inizio.',
    res_creative_finishing_p2: 'È solitamente in questa fase che i progetti si bloccano, e raramente per mancanza di talento. Più spesso accade perché a metà percorso non c\'è un traguardo da raggiungere e nessuno sta a controllare.',
    res_creative_finishing_p3: 'È qui che un partner che si limita a chiedere "cosa hai creato questa settimana?" può fare davvero la differenza. Non c\'è bisogno che ti giudichi. Sapere che descriverai la tua settimana dà al lavoro una piccola scadenza, e una piccola scadenza è spesso sufficiente per farti tornare alla scrivania, alla tela o allo strumento.',
    res_creative_finishing_p4: 'Aiuta anche a decidere cosa significa "finito" per ciò che hai di fronte. Una versione preliminare, anche se completa, conta più di una versione perfetta che rimane solo nella tua testa. Puoi sempre migliorarla in seguito.',
    res_creative_rough_drafts_title: 'Nessuno ha bisogno di vedere la prima versione',
    res_creative_rough_drafts_p1: 'Molte persone creative si fermano in silenzio perché il primo tentativo non è all\'altezza dell\'immagine che hanno in mente. Quel divario tra ciò che immagini e ciò che puoi realizzare in quel momento è normale. Spesso è maggiore quando ci tieni di più.',
    res_creative_rough_drafts_p2: 'Mostrare una bozza a una persona fidata può alleggerire il peso. Dire a un partner "questa è una bozza disordinata, ma ecco cosa sto cercando di fare" trasforma la situazione in una conversazione, non in un giudizio. Potresti scoprire che a lui interessa di più se hai perseverato piuttosto che se il risultato è buono o meno.',
    res_creative_rough_drafts_p3: 'Se sei alle prime armi con un\'attività creativa, esistono dei modi semplici per iniziare. OpenLearn, il sito di apprendimento gratuito della Open University, offre un corso introduttivo sulla scrittura di narrativa pensato per chi è alle prime armi. È solo un esempio tra i tanti, ed è più adatto agli scrittori che ad altri tipi di creatori.',
    res_creative_rough_drafts_p4: 'Nel lavoro creativo, i progressi raramente si traducono in un miglioramento costante. Ci sono settimane in cui si crea qualcosa di cui si è orgogliosi, e altre in cui si crea qualcosa che non si mostrerà mai a nessuno. Entrambe le esperienze contano, ed entrambe fanno parte della stessa abitudine.',
    res_creative_using_sharing_title: 'Utilizzare il lavoro di altri e condividere il proprio',
    res_creative_using_sharing_p1: 'I progetti creativi spesso includono materiale altrui, come immagini, suoni o testi, e prima o poi potresti voler condividere anche il tuo. Un po\' di contesto è utile in entrambi i casi.',
    res_creative_using_sharing_p2: 'Creative Commons è un\'organizzazione no-profit che pubblica licenze che permettono ai creatori di conservare il proprio diritto d\'autore, consentendo al contempo ad altri di utilizzare le loro opere secondo le modalità scelte dal creatore stesso. Se desideri condividere qualcosa che hai creato, le sue linee guida spiegano come funzionano queste licenze.',
    res_creative_using_sharing_p3: 'Alcune istituzioni si spingono oltre. Lo Smithsonian ha rilasciato milioni di immagini e dati con la cosiddetta licenza CC0, il che significa che è possibile utilizzarli senza chiedere l\'autorizzazione allo Smithsonian, anche per progetti creativi. Tuttavia, le sue FAQ specificano che la licenza CC0 copre solo il diritto d\'autore. Altri diritti, come la privacy o il marchio registrato, potrebbero comunque essere applicabili, e alcuni elementi delle sue collezioni non sono affatto inclusi.',
    res_creative_using_sharing_p4: 'Le norme sul diritto d\'autore variano da paese a paese e queste sono informazioni di carattere generale, non consulenza legale. Se un progetto ha rilevanza commerciale o se non si è certi di poter utilizzare del materiale, è consigliabile rivolgersi a un professionista qualificato per ottenere chiarimenti.',
    res_creative_openlearn_fiction_note: 'Con sede nel Regno Unito, gratuito all\'inizio. Un corso introduttivo sulla scrittura di narrativa, con attestato di partecipazione gratuito. È più adatto agli scrittori che ad altri tipi di creatori.',
    res_creative_cc_license_note: 'A livello globale. Come consentire ad altri di utilizzare la tua opera alle condizioni da te stabilite, mantenendo il diritto d\'autore. Informazioni generali, non consulenza legale.',
    res_creative_smithsonian_open_access_note: 'Istituzione statunitense, utilizzo gratuito per chiunque. Spiega le immagini e i dati rilasciati con licenza CC0, cosa consentono e non consentono e quali elementi sono esclusi.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Le relazioni si costruiscono più con piccoli gesti ripetuti che con grandi eventi. Questi articoli trattano di come mantenere vivi i legami, di ciò che la ricerca dice essere più importante e di cosa fare quando la connessione è difficile o una relazione non è sicura.',
    res_relationships_small_gestures_title: 'I piccoli gesti contano',
    res_relationships_small_gestures_p1: 'Molti di noi considerano le amicizie e i legami familiari come qualcosa che o esiste o non esiste. Robert Waldinger, direttore dell\'Harvard Study of Adult Development, descrive la vita sociale come un sistema vivente che necessita di manutenzione, proprio come l\'attività fisica.',
    res_relationships_small_gestures_p2: 'Anche piccoli gesti possono essere di routine. Pensate a qualcuno che vi manca e mandategli un messaggio. L\'elenco di azioni quotidiane suggerito dall\'Organizzazione Mondiale della Sanità è altrettanto semplice: contattare un amico, mettere via il telefono per essere veramente presenti in una conversazione, salutare un vicino, unirsi a un gruppo locale o fare volontariato.',
    res_relationships_small_gestures_p3: 'Per un obiettivo condiviso con un partner di responsabilità, questa è un\'ottima domanda settimanale: chi hai contattato? È concreta, semplice e puoi rispondere onestamente anche in una settimana difficile.',
    res_relationships_small_gestures_p4: 'Non tutti i messaggi ricevono una risposta calorosa, e questo fa parte del gioco. Waldinger afferma che le persone sono spesso sorprese da quanto calorosamente vengano accolti piccoli messaggi come questi.',
    res_relationships_quality_title: 'la qualità prima della quantità',
    res_relationships_quality_p1: 'È facile misurare la vita sociale in base al numero di persone: quanti amici si hanno, quanti eventi si frequentano, se si ha una relazione. La ricerca, però, indica un\'altra direzione.',
    res_relationships_quality_p2: 'Lo studio di Harvard sullo sviluppo degli adulti segue le persone dal 1938. Quando i ricercatori hanno esaminato le vite dei partecipanti in età adulta, la soddisfazione nelle loro relazioni, in particolare nel matrimonio, si è rivelata un indicatore più affidabile di fattori come il colesterolo o la pressione sanguigna per prevedere chi sarebbe stato felice e in salute a 80 anni. Il direttore dello studio afferma che altri gruppi di ricerca hanno successivamente riscontrato la stessa cosa. Aggiunge inoltre che non esiste un numero fisso di relazioni necessarie e che le persone timide potrebbero averne bisogno di meno rispetto agli estroversi.',
    res_relationships_quality_p3: 'Un avvertimento: i primi partecipanti allo studio erano studenti di Harvard e giovani adulti provenienti da una sola città americana, quindi non si tratta di un quadro rappresentativo dell\'intera popolazione. È opportuno interpretare le conclusioni con cautela.',
    res_relationships_quality_p4: 'Ciò che suggerisce, con delicatezza, è che almeno una relazione solida, una persona che potresti chiamare se stessi male o avessi paura, conta più di una grande cerchia di amici. E raramente è troppo tardi. Il direttore dello studio descrive persone che hanno trovato amicizie profonde o l\'amore in età avanzata, quando meno se lo aspettavano.',
    res_relationships_hard_times_title: 'Quando la connessione è difficile e quando una relazione fa male',
    res_relationships_hard_times_p1: 'Sentirsi soli non significa che ci sia qualcosa che non va. L\'Organizzazione Mondiale della Sanità stima che circa una persona su sei nel mondo, a qualsiasi età, sperimenti la solitudine. La definisce come la dolorosa sensazione che si prova quando i legami che si hanno non corrispondono a quelli che si desiderano.',
    res_relationships_hard_times_p2: 'Tra le cause si possono annoverare problemi di salute, basso reddito, vivere da soli o il modo in cui utilizziamo la tecnologia. L\'OMS sottolinea che, se il problema è più grave, vale la pena informarsi sui servizi di supporto disponibili.',
    res_relationships_hard_times_p3: 'C\'è anche un altro aspetto: le relazioni che fanno soffrire. I comportamenti dannosi in una relazione includono abusi psicologici e comportamenti di controllo, oltre a violenze fisiche o sessuali.',
    res_relationships_hard_times_p4: 'Se hai paura di qualcuno a te vicino o se ti senti vittima di violenza, contatta il numero di emergenza locale o un servizio di assistenza o supporto locale. I numeri corretti variano a seconda del Paese e un partner di Veyl è una persona con cui hai un\'esperienza simile, non uno psicologo. Se la situazione ti sembra troppo difficile da gestire, un medico o uno psicologo possono aiutarti.',
    res_relationships_who_social_connection_note: 'Globale. Un breve riassunto, senza tecnicismi, del rapporto dell\'OMS del 2025 sulla solitudine e la connessione sociale (13 pagine).',
    res_relationships_harvard_gazette_note: 'Fonte statunitense. Un\'intervista con il direttore dell\'Harvard Study of Adult Development su ciò che la ricerca rivela in merito a relazioni e salute, compresi i piccoli passi quotidiani. Si tratta di un\'intervista e i primi partecipanti allo studio provenivano da un\'unica città americana.',
    res_relationships_who_violence_note: 'Globale. Spiega cosa comprende la violenza del partner intimo e quanto sia diffusa, colpendo soprattutto le donne. Si tratta di informazioni, non di un servizio di assistenza telefonica, e la lettura può risultare difficile.',
  },

  hi: {
    appName: 'Veyl',
    loading: 'लोड हो रहा है...',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    back: 'वापस',
    continue: 'जारी रखें',
    done: 'हो गया',
    error: 'त्रुटि',
    submit: 'जमा करें',
    send: 'भेजें',
    delete: 'हटाएं',
    leave: 'छोड़ें',
    stay: 'रहें',
    yes: 'हाँ',
    no: 'नहीं',
    upgrade: 'Premium पर अपग्रेड करें',
    signIn: 'साइन इन करें',
    signUp: 'साइन अप करें',
    signOut: 'साइन आउट करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    forgotPassword: 'पासवर्ड भूल गए?',
    resetPassword: 'पासवर्ड रीसेट करें',
    resetPasswordSent: 'पासवर्ड रीसेट ईमेल भेजा गया। अपना इनबॉक्स जांचें।',
    noAccount: 'खाता नहीं है?',
    hasAccount: 'पहले से खाता है?',
    authError: 'प्रमाणीकरण त्रुटि। कृपया पुनः प्रयास करें।',
    landingHero: 'जवाबदेही जो वास्तव में काम करती है',
    landingSubtitle: 'अपना लक्ष्य साझा करने वाले एक गुमनाम साथी से मिलें। कोई सामाजिक दबाव नहीं। बस परिणाम।',
    getStarted: 'शुरू करें — मुफ़्त है',
    howItWorks: 'यह कैसे काम करता है',
    step1Title: 'अपना लक्ष्य निर्धारित करें',
    step1Desc: 'हमें बताएं आप किस पर काम कर रहे हैं। हम आपको समान यात्रा पर किसी से मिलाएंगे।',
    step2Title: 'अपने साथी से मिलें',
    step2Desc: 'अपने समय क्षेत्र में एक गुमनाम जवाबदेही साथी से जुड़ें।',
    step3Title: 'जवाबदेह रहें',
    step3Desc: 'रोजाना जांच करें, प्रगति साझा करें और एक-दूसरे का समर्थन करें — गुमनाम तरीके से।',
    pricingTitle: 'सरल मूल्य निर्धारण',
    freePlan: 'मुफ़्त',
    premiumPlan: 'Premium',
    perMonth: '/माह',
    freeFeature1: '1 सक्रिय Veyl',
    freeFeature2: '10 संदेश/दिन',
    freeFeature3: '10 वॉइस नोट/दिन',
    freeFeature4: 'दैनिक और साप्ताहिक जांच',
    freeFeature5: 'समूह चैट पहुंच',
    premiumFeature1: 'तक 3 सक्रिय Veyls',
    premiumFeature2: 'असीमित संदेश',
    premiumFeature3: 'असीमित वॉइस नोट',
    premiumFeature4: 'प्राथमिकता मिलान',
    faqTitle: 'अक्सर पूछे जाने वाले प्रश्न',
    welcomeToVeyl: 'Veyl में आपका स्वागत है',
    chooseLanguage: 'अपनी भाषा चुनें',
    chooseLanguageDesc: 'वह भाषा चुनें जिसमें आप Veyl उपयोग करना चाहते हैं।',
    ageVerification: 'आयु सत्यापन',
    ageVerificationDesc: 'Veyl 13 वर्ष और उससे अधिक आयु के उपयोगकर्ताओं के लिए उपलब्ध है।',
    areYouOldEnough: 'क्या आपकी आयु 13 वर्ष या अधिक है?',
    yesIAm: '✅ हाँ, मैं हूँ',
    noImNot: '❌ नहीं, मैं नहीं हूँ',
    mustBe13: 'आपकी आयु 13 वर्ष या अधिक होनी चाहिए',
    mustBe13Desc: 'Veyl केवल 13 वर्ष और उससे अधिक आयु के उपयोगकर्ताओं के लिए उपलब्ध है।',
    setupProfile: 'अपना प्रोफ़ाइल सेट करते हैं',
    stepOf: 'चरण {step} में से 4',
    whatsYourName: 'आपका नाम क्या है?',
    namePlaceholder: 'अपना उपनाम दर्ज करें',
    whatsYourTimezone: 'आपका समय क्षेत्र क्या है?',
    selectTimezone: 'समय क्षेत्र चुनें',
    goalCategory: 'आपके लक्ष्य की श्रेणी क्या है?',
    matchPreference: 'आप किससे मिलान करना चाहते हैं?',
    matchNearby: 'नजदीकी मिलान',
    matchNearbyDesc: 'अपने समय क्षेत्र के 4 घंटे के भीतर लोगों से मिलान करें।',
    matchAnywhere: 'कहीं भी मिलान',
    matchAnywhereDesc: 'समय क्षेत्र की परवाह किए बिना दुनिया में किसी से भी मिलान करें।',
    describeGoal: 'अपने विशिष्ट लक्ष्य का वर्णन करें',
    goalPlaceholder: "उदा.: 'मैं 15 किलो वजन कम करना चाहता हूँ' या 'Python सीखना'",
    communicationStyle: 'पसंदीदा संचार शैली',
    textMessages: 'टेक्स्ट संदेश',
    textMessagesDesc: 'जब सुविधाजनक हो तब चैट करें',
    scheduledCheckins: 'निर्धारित जांच',
    scheduledCheckinsDesc: 'साप्ताहिक गहन चर्चाएं',
    completingSetup: 'साथी खोजा जा रहा है...',
    completeSetup: 'सेटअप पूरा करें',
    agreeToTerms: 'जारी रखकर, आप Veyl की',
    termsOfService: 'सेवा की शर्तें',
    and: 'और',
    privacyPolicy: 'गोपनीयता नीति',
    fitnessHealth: 'फिटनेस और स्वास्थ्य',
    learningSkills: 'सीखना और कौशल',
    businessCareer: 'व्यवसाय और करियर',
    creativeProjects: 'रचनात्मक परियोजनाएं',
    findingMatch: 'आपका साथी खोजा जा रहा है...',
    findingNewMatch: 'आपका नया साथी खोजा जा रहा है...',
    lookingForSomeone: 'हम श्रेणी में किसी को खोज रहे हैं',
    category: '',
    sharesTimezone: 'जो आपके समय क्षेत्र और प्रतिबद्धता को साझा करता है।',
    autoCheck: 'हम हर 5 सेकंड में स्वचालित रूप से मिलान जांचते हैं।',
    noMatchYet: 'अभी तक कोई मिलान नहीं मिला — हम प्रयास जारी रखेंगे।',
    checkNow: 'अभी जांचें',
    checking: 'जांच हो रही है...',
    manualChecks: '{count} मैनुअल जांच की गई',
    joinCommunity: '🌐 प्रतीक्षा करते हुए समुदाय से जुड़ें',
    goToCommunity: '🌐 समुदाय पर जाएं',
    previousPartnerNote: '🛡️ आपके पिछले साथी का सुझाव नहीं दिया जाएगा।',
    joining: 'जुड़ा जा रहा है...',
    overview: 'अवलोकन',
    chat: 'चैट',
    checkin: 'जांच',
    group: 'समूह',
    community: 'समुदाय',
    notifications: 'सूचनाएं',
    settings: 'सेटिंग्स',
    yourGoal: 'आपका लक्ष्य',
    yourPartner: 'आपका साथी',
    you: 'आप',
    unveiled: '✨ अनावरण किया',
    goalComplete: '✓ लक्ष्य पूरा हुआ',
    adjustGoal: 'मेरा लक्ष्य समायोजित करें',
    unveilButton: '✨ अनावरण करें — आपने कर दिखाया!',
    goalCategory2: 'श्रेणी',
    goalDescription: 'विवरण',
    timezone: 'समय क्षेत्र',
    loadingPartner: 'साथी की जानकारी लोड हो रही है...',
    waitingForMatch: 'चैट शुरू करने के लिए मिलान की प्रतीक्षा।',
    noMessagesYet: 'अभी तक कोई संदेश नहीं। अपने साथी को नमस्ते कहें!',
    typeMessage: 'अपना संदेश टाइप करें...',
    dailyLimitReached: 'दैनिक सीमा पहुंच गई — Premium पर अपग्रेड करें',
    unmatch: '🔓 अलग करें',
    report: '🚩 रिपोर्ट करें',
    unmatchWarning: '⚠️ अलग करने से आपकी पूरी चैट हिस्ट्री हट जाएगी। यह पूर्ववत नहीं हो सकता।',
    yesUnmatch: 'हाँ, अलग करें',
    unmatching: 'अलग किया जा रहा है...',
    deleteMessage: '🗑 हटाएं',
    deleting: 'हटाया जा रहा है...',
    checkIn: 'जांच',
    submitDaily: 'दैनिक जांच जमा करें',
    submitWeekly: 'साप्ताहिक जांच जमा करें',
    submitting: 'जमा हो रहा है...',
    checkinSubmitted: 'जांच जमा की गई!',
    viewHistory: 'मेरा इतिहास देखें',
    notificationsTitle: 'सूचनाएं',
    clearAll: 'सब साफ करें',
    noNotifications: 'अभी तक कोई सूचना नहीं।',
    settingsTitle: 'सेटिंग्स',
    settingsDesc: 'अपनी गुमनाम पहचान को वैयक्तिकृत करें।',
    saveAvatar: 'अवतार सहेजें',
    appearance: 'दिखावट',
    lightMode: '☀️ हल्का',
    darkMode: '🌙 डार्क',
    changeNickname: 'उपनाम बदलें',
    saveNickname: 'उपनाम सहेजें',
    deleteAccount: 'खाता हटाएं',
    deleteAccountDesc: 'आपका खाता और सभी संबंधित डेटा स्थायी रूप से हटा देता है।',
    languageLabel: 'भाषा',
    languageDesc: 'अपनी पसंदीदा भाषा चुनें।',
    signOut: 'साइन आउट करें',
    updating: 'अपडेट हो रहा है...',
    unveil: 'अनावरण करें',
    clearing: 'साफ हो रहा है...',
    notifMatchFound: 'मिलान मिला',
    notifGoalAchieved: 'लक्ष्य प्राप्त हुआ',
    notifSupport: 'सहायता संदेश',
    notifUnmatched: 'अलगाव अलर्ट',
    notifMatchRequest: 'मिलान अनुरोध',
    notificationPrefs: 'सूचना प्राथमिकताएं',
    notificationPrefsDesc: 'विशिष्ट सूचना प्रकारों को व्यक्तिगत रूप से म्यूट करें।',
    muted: 'म्यूट किया गया',
    active: 'सक्रिय',
    all: 'सभी',
    justNow: 'अभी-अभी',
    minsAgo: '{count} मिनट पहले',
    hoursAgo: '{count} घंटे पहले',
    daysAgo: '{count} दिन पहले',
    leaving: 'छोड़ा जा रहा है...',
    myHistory: '📋 मेरा इतिहास',
    partnersProgress: '👤 {name} की प्रगति',
    myCheckinHistory: 'मेरा जांच इतिहास',
    checkinsForVeyl: 'इस Veyl के लिए {count} जांच',
    noCheckinsYet: 'अभी तक कोई जांच नहीं। पहली शुरू करें!',
    newCheckinBtn: 'नई जांच',
    partnerNoCheckins: '{name} ने अभी तक जांच नहीं की।',
    dailyNotesPrivate: 'दैनिक नोट्स निजी हैं',
    goalAchievedMarked: '🎉 लक्ष्य प्राप्त के रूप में चिह्नित',
    goalAchievedNote: '🎉 आपका लक्ष्य प्राप्त के रूप में चिह्नित है! अनावरण करने के लिए अवलोकन पर जाएं।',
    veylComplete: '✓ यह Veyl पूर्ण है। जांचें केवल पढ़ने योग्य हैं।',
    goalAlreadyAchieved: '🎉 आपने अपना लक्ष्य प्राप्त के रूप में चिह्नित किया! अनावरण करने के लिए अवलोकन पर जाएं।',
    didYouWork: 'क्या आपने आज अपने लक्ष्य पर काम किया?',
    howDidWeekGo: 'इस सप्ताह आपके लक्ष्य के साथ कैसा रहा?',
    whatGotInWay: 'क्या रास्ते में आया? (वैकल्पिक)',
    honestNote: 'ईमानदार रहें। आपका साथी आपको सहारा देने के लिए है, आंकने के लिए नहीं।',
    whatDidYouLearn: 'इस सप्ताह आपने अपने बारे में क्या सीखा?',
    insightsPlaceholder: 'आपको कौन सी अंतर्दृष्टि मिली?',
    whatPatterns: 'आप कौन सा पैटर्न देख रहे हैं?',
    patternsPlaceholder: 'कोई आवर्ती विषय या बाधाएं?',
    whatChange: 'अगले सप्ताह के लिए क्या बदलना चाहिए?',
    changePlaceholder: 'आप क्या अलग करेंगे?',
    goalAchievedQuestion: '🏆 क्या आपने अपना समग्र लक्ष्य प्राप्त किया?',
    yesDidIt: '🎉 हाँ, मैंने कर दिखाया!',
    notYetBtn: 'अभी नहीं',
    didIt: '✅ कर दिया',
    didSome: '😐 कुछ किया',
    didntDoIt: '❌ नहीं किया',
    metCommitment: '✅ प्रतिबद्धता पूरी की',
    partialProgress: '😐 आंशिक प्रगति',
    noProgress: '❌ कोई प्रगति नहीं',
    rethinkingGoal: '🤔 लक्ष्य पर पुनर्विचार',
    yesLabel: '✅ हाँ',
    aLittle: '😐 थोड़ा',
    noLabel: '❌ नहीं',
    madeProgress: 'आज प्रगति की',
    didSomething: 'कुछ किया, सब नहीं',
    didntWork: 'आज इस पर काम नहीं किया',
    metWeekly: 'साप्ताहिक प्रतिबद्धता पूरी की',
    madePartial: 'आंशिक प्रगति हुई',
    didntMake: 'कोई प्रगति नहीं हुई',
    needToAdjust: 'अपना दृष्टिकोण बदलना होगा',
    learnedLabel: 'सीखा: ',
    patternLabel: 'पैटर्न: ',
    nextWeekLabel: 'अगले सप्ताह: ',
    joinGroup: 'समूह में शामिल हों',
    joinGroupDesc: 'समूह समान लक्ष्यों पर काम करने वाले 5 लोगों को एक साथ लाते हैं। गुमनाम, सहायक, बिना दबाव।',
    whatToExpect: 'क्या उम्मीद करें',
    expectAnonymous: 'सभी गुमनाम रहते हैं — एक जैसे सिल्हूट अवतार',
    expectMatched: 'प्रासंगिक समर्थन के लिए लक्ष्य श्रेणी के अनुसार मिलान',
    expectMembers: 'प्रति समूह 5 सदस्य तक',
    expectChat: 'समूह चैट — 20 संदेश और 5 वॉइस नोट/दिन मुफ़्त · Premium पर असीमित',
    findOrCreate: 'समूह खोजें या बनाएं',
    findingGroup: 'आपका समूह खोजा जा रहा है...',
    oneGroupNote: 'आप एक समय में केवल एक समूह में हो सकते हैं। मुफ़्त और Premium दोनों उपयोगकर्ताओं को समूह पहुंच मिलती है।',
    groupCreated: 'समूह बनाया गया!',
    groupJoined: 'समूह में शामिल हो गए!',
    groupCreatedDesc: 'आपने एक नया {category} समूह शुरू किया। जल्द ही अन्य शामिल होंगे।',
    groupJoinedDesc: 'आप एक मौजूदा {category} समूह में शामिल हो गए। नमस्ते कहें!',
    switchToGroup: 'चैट शुरू करने के लिए अपने डैशबोर्ड में समूह टैब पर जाएं।',
    groupMembers: 'समूह सदस्य',
    backToChat: '← चैट पर वापस जाएं',
    creator: '★ निर्माता',
    joined: 'शामिल हुए',
    leaveGroup: 'समूह छोड़ें',
    leaveGroupTitle: 'इस समूह को छोड़ें?',
    leaveGroupDesc: 'आप समूह चैट तक पहुंच खो देंगे और किसी भी समय नए समूह में शामिल हो सकते हैं।',
    membersBtn: '👥 सदस्य',
    noGroupMessages: 'अभी तक कोई संदेश नहीं। पहले नमस्ते कहें!',
    messageGroup: 'अपने समूह को संदेश भेजें...',
    groupDailyLimit: 'आपने अपनी दैनिक समूह संदेश सीमा पहुंच ली ({limit}/दिन)। असीमित संदेश के लिए Premium पर अपग्रेड करें!',
    groupVoiceLimit: 'दैनिक वॉइस नोट सीमा पहुंच गई।',
    veylCommunity: 'Veyl समुदाय',
    communityDesc: 'मिलान की प्रतीक्षा करते समय समान लक्ष्य श्रेणी पर काम करने वाले अन्य लोगों से जुड़ें।',
    communityJoinNote: 'मिलान खोजते समय प्रतीक्षा पृष्ठ से समुदाय में शामिल हों।',
    leaveCommunity: 'इस समुदाय को छोड़ें?',
    communityLeaveDesc: 'आप प्रतीक्षा पृष्ठ से किसी भी समय वापस जुड़ सकते हैं।',
    matchRequests: 'मिलान अनुरोध',
    incoming: 'आने वाले',
    sent: 'भेजे गए',
    noIncoming: 'कोई आने वाले अनुरोध नहीं।',
    noPending: 'कोई लंबित भेजे गए अनुरोध नहीं।',
    requestToAnonymous: 'गुमनाम उपयोगकर्ता को अनुरोध',
    pending: 'लंबित',
    decline: 'अस्वीकार',
    accept: '✅ स्वीकार',
    requestWaiting: '🤝 {count} मिलान अनुरोध आपका इंतजार कर रहे हैं',
    view: 'देखें',
    requestsBtn: '🤝 अनुरोध',
    leaveBtn: 'छोड़ें',
    openToAll: 'सभी के लिए खुला · गुमनाम',
    msgsLeft: '{count} संदेश बचे हैं',
    noCommunityMessages: 'अभी तक कोई संदेश नहीं। समुदाय को नमस्ते कहें!',
    saySomething: 'समुदाय को कुछ कहें...',
    requestMatch: '🤝 मिलान का अनुरोध करें',
    requestSending: 'भेजा जा रहा है...',
    communityMsgsWarning: 'आज {count} सामुदायिक संदेश बचे हैं।',
    communityDailyLimit: 'आपने अपनी दैनिक सामुदायिक संदेश सीमा पहुंच ली ({limit}/दिन)। असीमित के लिए Premium पर अपग्रेड करें!',
    matchRequestLimit: 'आप एक समय में केवल 3 लंबित अनुरोध रख सकते हैं।',
    matchRequestSent: 'मिलान अनुरोध सफलतापूर्वक भेजा गया!',
    matchRequestDuplicate: 'आपने पहले से इस व्यक्ति को अनुरोध भेज दिया है।',
    matchRequestError: 'मिलान अनुरोध भेजने में त्रुटि। कृपया पुनः प्रयास करें।',
    matchAcceptError: 'मिलान अनुरोध स्वीकार करने में त्रुटि।',
    matchRequestSentAlready: 'आपने पहले से इस व्यक्ति को अनुरोध भेज दिया है।',
    avatar_silhouette: 'सिल्हूट',
    avatar_teal: 'टील',
    avatar_purple: 'बैंगनी',
    avatar_navy: 'नेवी',
    avatar_slate: 'स्लेट',
    avatar_coral: 'कोरल',
    avatar_gold: 'सुनहरा',
    avatar_moss: 'मॉस',
    avatar_indigo: 'इंडिगो',
    avatar_unveiled: 'अनावरण किया',
    activeLabel: 'सक्रिय',
    seekingLabel: 'खोज रहे हैं',
    completeLabel: 'पूर्ण',
    upgradeForMore: '✨ अधिक Veyls के लिए अपग्रेड करें',
    newVeyl: '+ नया Veyl',
    newVeylTitle: 'नया Veyl शुरू करें',
    goalCategoryLabel: 'लक्ष्य श्रेणी',
    goalDescriptionLabel: 'लक्ष्य विवरण',
    startVeyl: 'नया Veyl शुरू करें',
    starting: 'शुरू हो रहा है...',
    unveil: 'अनावरण करें',
    clearing: 'साफ हो रहा है...',
    nicknameRequired: 'उपनाम आवश्यक है',
    nicknameTooShort: 'उपनाम कम से कम 2 अक्षर का होना चाहिए',
    nicknameTooLong: 'उपनाम अधिकतम 20 अक्षर का होना चाहिए',
    errorSavingNickname: 'उपनाम सहेजने में त्रुटि',
    errorSavingAvatar: 'अवतार सहेजने में त्रुटि',
    errorDeletingAccount: 'खाता हटाने में त्रुटि',
    deleteMyAccountButton: 'मेरा खाता हटाएं',
    goalsAchievedTitle: 'प्राप्त लक्ष्य',
    goalsPrivate: 'निजी — केवल आपको दिखाई देता है।',
    goalsCompletedCount: '{count} लक्ष्य पूर्ण हुए',
    keepAnonymous: 'गुमनाम रहें। अपना असली नाम न दें।',
    currentNicknameIs: 'आपका वर्तमान उपनाम है',
    unveiledLocked: '✨ अनावरण किया — अवतार लॉक है',
    howOthersSee: 'दूसरे आपको इस तरह देखते हैं',
    unveiledNote: 'आपने इस Veyl पर अनावरण किया। नया अवतार चुनने के लिए नया Veyl शुरू करें।',
    active2: '✓ सक्रिय',
    goalsAchieved: 'प्राप्त लक्ष्य',
    goalsAchievedDesc: 'निजी — केवल आपको दिखाई देता है।',
    goalCompleted: 'लक्ष्य पूर्ण',
    goalsCompleted: 'लक्ष्य पूर्ण हुए',
    contactSupport: 'सहायता से संपर्क करें',
    deleteWarning: '⚠️ इससे सब कुछ स्थायी रूप से हट जाएगा। पुष्टि के लिए नीचे DELETE टाइप करें।',
    typeDelete: 'पुष्टि के लिए DELETE टाइप करें',
    confirmDelete: 'हटाने की पुष्टि करें',
    deleting2: 'हटाया जा रहा है...',
    messagesLeft: '{count} संदेश · {voiceCount} वॉइस नोट आज बचे हैं',
    premiumUnlimited: '✨ Premium — असीमित संदेश और वॉइस नोट',
    messagesLeftWarning: 'आज {count} संदेश बचे हैं।',
    forUnlimited: 'असीमित संदेश के लिए।',
    voiceNotesLeft: 'आज {count} वॉइस नोट बचे हैं',
    dailyLimitReachedVoice: 'दैनिक वॉइस नोट सीमा पहुंच गई।',
    dailyVoiceNoteLimit: 'दैनिक वॉइस नोट सीमा पहुंच गई। असीमित नोट के लिए Premium पर अपग्रेड करें।',
    recording: 'रिकॉर्डिंग हो रही है...',
    deeper: 'गहरा',
    neutral: 'तटस्थ',
    higher: 'ऊंचा',
    applyingModulation: '⚙️ मॉड्युलेशन लागू हो रहा है...',
    preview: '▶ पूर्वावलोकन',
    pause: '⏸ रोकें',
    discard: 'हटाएं',
    recordingTooLarge: 'रिकॉर्डिंग बहुत बड़ी है। कृपया छोटा संदेश आज़माएं।',
    failedToSend: 'भेजने में विफल। कृपया पुनः प्रयास करें।',
    micDenied: 'माइक्रोफ़ोन पहुंच अस्वीकृत।',
    unmatchMessage: 'आपके साथी ने इस Veyl सत्र को समाप्त कर दिया। आप वापस मिलान खोज में आ गए हैं।',
    appearanceDesc: 'चुनें कि Veyl आपको कैसा दिखे।',
    newNickname: 'नया उपनाम',
    nicknamePlaceholder: 'जैसे NightOwl, StriveMode, Kira...',
    chooseAvatar: 'अपना अवतार चुनें',
    notificationsTitle: 'सूचनाएं',
    notificationsCount: 'कुल {total} · {unread} अपठित',
    progressOf: '{name} की प्रगति',
    fitnessHealth: 'फिटनेस & स्वास्थ्य',
    learningSkills: 'सीखना & कौशल',
    businessCareer: 'व्यवसाय & करियर',
    creativeProjects: 'रचनात्मक परियोजनाएं',
    progressOf: '{name} की प्रगति',
    dailyCheckin: 'दैनिक चेक-इन',
    weeklyCheckin: 'साप्ताहिक चेक-इन',
    dailyCheckinDesc: 'त्वरित अपडेट: क्या आपने आज अपने लक्ष्य पर काम किया?',
    weeklyCheckinDesc: 'गहरी समीक्षा: इस सप्ताह कुल मिलाकर कैसा रहा?',
    submitDaily: 'दैनिक चेक-इन सबमिट करें',
    submitWeekly: 'साप्ताहिक चेक-इन सबमिट करें',
    submitting: 'सबमिट हो रहा है...',
    checkinSubmitted: 'चेक-इन सबमिट हो गया!',
    checkinSubmittedDesc: 'जवाबदेह रहने के लिए शाबाश। {name} आपका अपडेट देखेंगे।',
    viewHistory: 'मेरा इतिहास देखें',
    newCheckin: '📝 नया चेक-इन',
    myHistory: '📋 मेरा इतिहास',
    partnersProgress: '👤 {name} की प्रगति',
    myCheckinHistory: 'मेरा चेक-इन इतिहास',
    checkinsForVeyl: 'इस Veyl के लिए {count} चेक-इन',
    noCheckinsYet: 'अभी तक कोई चेक-इन नहीं। पहला शुरू करें!',
    newCheckinBtn: 'नया चेक-इन',
    partnerNoCheckins: '{name} ने अभी तक चेक-इन नहीं किया।',
    dailyNotesPrivate: 'दैनिक नोट्स निजी हैं',
    goalAchievedMarked: '🎉 लक्ष्य प्राप्त के रूप में चिह्नित',
    goalAchievedNote: '🎉 आपका लक्ष्य प्राप्त के रूप में चिह्नित है! प्रकट करने के लिए अवलोकन पर जाएं।',
    veylComplete: '✓ यह Veyl पूर्ण है। चेक-इन केवल पढ़ने योग्य हैं।',
    goalAlreadyAchieved: '🎉 आपने अपना लक्ष्य प्राप्त के रूप में चिह्नित किया! प्रकट करने के लिए अवलोकन पर जाएं।',
    didYouWork: 'क्या आपने आज अपने लक्ष्य पर काम किया?',
    howDidWeekGo: 'इस सप्ताह आपके लक्ष्य के साथ कैसा रहा?',
    whatGotInWay: 'क्या बाधा आई? (वैकल्पिक)',
    honestNote: 'ईमानदार रहें। आपका साथी यहाँ आपका समर्थन करने के लिए है, न कि आंकने के लिए।',
    whatDidYouLearn: 'इस सप्ताह आपने अपने बारे में क्या सीखा?',
    insightsPlaceholder: 'आपने क्या अंतर्दृष्टि प्राप्त की?',
    whatPatterns: 'आप कौन सा पैटर्न देख रहे हैं?',
    patternsPlaceholder: 'कोई बार-बार आने वाली बाधाएं?',
    whatChange: 'अगले सप्ताह के लिए क्या बदलना होगा?',
    changePlaceholder: 'आप क्या अलग करेंगे?',
    goalAchievedQuestion: '🏆 क्या आपने अपना समग्र लक्ष्य प्राप्त कर लिया?',
    yesDidIt: '🎉 हाँ, मैंने कर दिखाया!',
    notYetBtn: 'अभी नहीं',
    didIt: '✅ किया',
    didSome: '😐 कुछ किया',
    didntDoIt: '❌ नहीं किया',
    metCommitment: '✅ प्रतिबद्धता पूरी की',
    madePartial: '😐 आंशिक प्रगति',
    didntMake: '❌ कोई प्रगति नहीं',
    needToAdjust: '🤔 अपना तरीका बदलना होगा',
    yesLabel: '✅ हाँ',
    aLittle: '😐 थोड़ा',
    noLabel: '❌ नहीं',
    madeProgress: 'आज प्रगति की',
    didSomething: 'कुछ किया, सब कुछ नहीं',
    didntWork: 'आज इस पर काम नहीं किया',
    metWeekly: 'साप्ताहिक प्रतिबद्धता पूरी की',
    didntMake: 'कोई प्रगति नहीं हुई',
    needToAdjust: 'अपना तरीका बदलना होगा',
    learnedLabel: 'सीखा: ',
    patternLabel: 'पैटर्न: ',
    nextWeekLabel: 'अगला सप्ताह: ',
    problemTitle: 'सोशल मीडिया ने जवाबदेही बर्बाद की',
    problem1: "आप संघर्ष करते समय स्वीकार करने से डरते हैं",
    problem2: "आप असफलताओं से सीखने की बजाय छुपाते हैं",
    problem3: "गलती होने पर आप अपने साथियों को छोड़ देते हैं",
    veylIsDifferent: 'Veyl अलग है।',
    popular: 'लोकप्रिय',
    sixMonthDeal: 'या 6 महीने के लिए $20 ($3.33/महीना)',
    getStartedPremium: 'शुरू करें',
    buildTrust: 'विश्वास बनाएं',
    unveilIdentity: 'तैयार होने पर अपनी पहचान उजागर करें',
    actuallyAchieve: 'वास्तव में हासिल करें',
    makeRealProgress: 'प्रदर्शन के बिना वास्तविक प्रगति करें',
    faq1q: 'क्या होगा अगर मैं और मेरा साथी नहीं जमते?',
    faq1a: 'आसान रीमैच। कोई सवाल नहीं। हम चाहते हैं कि आप सही व्यक्ति खोजें न कि काम न करने वाली साझेदारी को मजबूर करें।',
    faq2q: 'क्या मुझे किसी बिंदु पर खुद को उजागर करना होगा?',
    faq2a: 'नहीं। कुछ साझेदारियां हमेशा के लिए गुमनाम रहती हैं। कुछ एक हफ्ते बाद उजागर होती हैं। यह पूरी तरह आप पर निर्भर है।',
    faq3q: 'क्या होगा अगर मेरा साथी मुझे घोस्ट करे?',
    faq3a: 'प्रीमियम उपयोगकर्ताओं को तत्काल रीमैच मिलता है। मुफ्त उपयोगकर्ताओं को 48 घंटों के भीतर रीमैच किया जाता है।',
    faq4q: 'प्रोफाइल चित्र क्यों नहीं?',
    faq4a: 'क्योंकि जैसे ही आप फ़ोटो जोड़ते हैं, यह धारणा प्रबंधित करने के बारे में हो जाता है। हमने इसे परखा। गुमनामी काम पर ध्यान केंद्रित रखती है।',
    legalEnglishOnly: 'यह दस्तावेज़ केवल अंग्रेज़ी में उपलब्ध है। प्रश्नों के लिए, कृपया सहायता से संपर्क करें या अपने ब्राउज़र की अनुवाद सुविधा का उपयोग करें।',
    ctaTitle: "क्या आप अपने लक्ष्य पाने के लिए तैयार हैं?",
    ctaSubtitle: "Veyl से जुड़ें और आज ही एक जवाबदेही साथी से मिलें। शुरुआत मुफ़्त है।",
    statAnonymous: "गुमनाम",
    statLanguages: "भाषाएँ",
    statToStart: "शुरू करने के लिए",
    authTagline: "गुमनाम जवाबदेही। असली परिणाम।",
    authPricing: "शुरुआत मुफ़्त · प्रीमियम $5/माह से",
    taglineHonest: "ईमानदार",
    taglineEffective: "प्रभावी",
    foreverLabel: "/हमेशा के लिए",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Premium में अपग्रेड करें",
    premiumActiveDesc: "आपके पास Veyl की सभी सुविधाओं तक असीमित पहुंच है।",
    upgradeDesc: "सभी सीमाएं हटाएं और पूरा Veyl अनुभव पाएं।",
    billedMonthly: "मासिक बिल किया गया",
    bestValue: "सर्वोत्तम मूल्य",
    perSixMonths: "$3.33/माह",
    unlimitedMessages: "असीमित संदेश",
    unlimitedVoice: "असीमित वॉयस नोट्स",
    unlimitedGroup: "असीमित ग्रुप चैट",
    unlimitedCommunity: "असीमित समुदाय",
    was10day: "10/दिन था",
    was5day: "5/दिन था",
    was20day: "20/दिन था",
    was30day: "30/दिन था",
    sixMonthPlan: "6 महीने की योजना",
    monthlyPlan: "मासिक योजना",
    modulationFailed: "मॉड्यूलेशन विफल — मूल आवाज़ का उपयोग",
    monthly: "मासिक",
    sixMonths: "6 महीने",
    savePercent: "{{percent}}% बचाएं",
    pricePerMonth: "${{price}} / महीना",
    priceTotal: "कुल ${{price}}",
    unlimitedMessages: "असीमित संदेश",
    unlimitedVoiceNotes: "असीमित वॉयस नोट्स",
    unlimitedGroupMessages: "असीमित समूह संदेश",
    unlimitedCommunityMessages: "असीमित सामुदायिक संदेश",
    upgrade: "अपग्रेड",
    forUnlimited: "असीमित के लिए",
    messagesLeftWarning: "आज {{count}} संदेश बचे हैं",
    recordVoiceNote: "वॉयस नोट रिकॉर्ड करें",
    uploading: "अपलोड हो रहा है",
    maxDuration: "{{seconds}} सेकंड अधिकतम",
    upgradeToPremium: "प्रीमियम में अपग्रेड करें",
    dailyMessageLimitReached: "आपने अपनी दैनिक संदेश सीमा पार कर ली है।",
    dailyVoiceLimitReached: "आपने अपनी दैनिक वॉयस नोट सीमा पार कर ली है।",
    dailyGroupMessageLimitReached: "आपने अपनी दैनिक समूह संदेश सीमा पार कर ली है।",
    dailyGroupVoiceLimitReached: "आपने अपनी दैनिक समूह वॉयस नोट सीमा पार कर ली है।",
    unlockUnlimited: "सभी सुविधाओं तक असीमित पहुंच अनलॉक करें।",
    maybeLater: "शायद बाद में",
    premiumUnlimited: "असीमित",
    premium: "प्रीमियम",
    msg: "सं",
    msgs: "सं",
    newMessageNotification: "{{name}} ने आपको एक संदेश भेजा है 💬",
    newGroupMessageNotification: "{{name}} ने आपके समूह में एक संदेश भेजा है 👥",
    someone: "कोई",
    failedToLoad: "लोड करने में विफल",
    groupMessagesLeftWarning: "आज {{count}} संदेश बचे हैं",
    howOldAreYou: 'आपकी उम्र क्या है?',
    minorGroupNote: 'आपको आपकी उम्र के अन्य उपयोगकर्ताओं (13–17) के साथ जोड़ा जाएगा।',
    adultGroupNote: 'आपको अन्य वयस्कों (18+) के साथ जोड़ा जाएगा।',
    enterYourAge: 'अपनी उम्र दर्ज करें',
    getStarted:        'शुरू करें',
    howItWorks:        'यह कैसे काम करता है',
    statAnonymous:     'गुमनाम',
    statLanguages:     'भाषाएं',
    statToStart:       'शुरू करने के लिए',
    taglineHonest:     'ईमानदार',
    taglineEffective:  'प्रभावी',
    landingHero:       'प्रदर्शन के बिना जवाबदेही।',
    landingSubtitle:   'एक गुमनाम साथी खोजें जो आपके लक्ष्य साझा करता हो। कोई फॉलोअर नहीं। कोई दबाव नहीं — सिर्फ ईमानदार प्रगति।',
    problemTitle:      'जवाबदेही टूटी हुई है।',
    problem1:          'सोशल मीडिया आत्म-सुधार को प्रदर्शन में बदल देता है। आप लाइक के लिए लक्ष्य पोस्ट करते हैं, प्रगति के लिए नहीं।',
    problem2:          'दोस्त और परिवार निर्णय या उदासीनता लाते हैं। असली ईमानदारी असंभव हो जाती है।',
    problem3:          'जवाबदेही ऐप्स ट्रैकिंग टूल जैसे लगते हैं — बेजान डैशबोर्ड जो इंसानी पहलू को पूरी तरह नज़रअंदाज़ करते हैं।',
    veylIsDifferent:   'Veyl अलग है।',
    step1Title:        'अपना प्रोफ़ाइल बनाएं',
    step1Desc:         'एक उपनाम चुनें, लक्ष्य श्रेणी और संचार प्राथमिकता सेट करें। आपकी असली पहचान पूरी तरह आपकी रहती है।',
    step2Title:        'मिलान पाएं',
    step2Desc:         'Veyl आपको एक साथी ढूंढता है जो आपके लक्ष्य प्रकार और आयु वर्ग से मेल खाता हो। तुरंत — कोई स्क्रॉलिंग नहीं।',
    step3Title:        'बात करना शुरू करें',
    step3Desc:         'चैट करें या वॉइस नोट्स भेजें। रोज़ाना या साप्ताहिक चेक इन करें। आपका साथी आपको जवाबदेह रखता है — और आप उन्हें।',
    buildTrust:        'विश्वास बनाएं',
    unveilIdentity:    'अपनी जीत दर्ज करें। जब विश्वास हो, तो आप अपनी पहचान उजागर करना चुन सकते हैं — या नहीं।',
    actuallyAchieve:   'वास्तव में हासिल करें',
    makeRealProgress:  'एक असली इंसान के साथ असली प्रगति। कोई गेमीफिकेशन नहीं। बस आप, आपका साथी और आपका लक्ष्य।',
    pricingTitle:      'मुफ़्त शुरू करें। तैयार होने पर आगे बढ़ें।',
    freePlan:          'मुफ़्त',
    foreverLabel:      '/ हमेशा के लिए',
    freeFeature1:      '1 जवाबदेही साथी',
    freeFeature2:      'प्रतिदिन 10 संदेश',
    freeFeature3: 'प्रतिदिन 10 वॉइस नोट्स',
    freeFeature5:      'ग्रुप और कम्युनिटी रूम',
    popular:           'सबसे लोकप्रिय',
    premiumPlan:       'प्रीमियम',
    perMonth:          '/ माह',
    sixMonthDeal: '6 महीने की योजना मात्र $20 में — 33% की बचत करें',
    premiumFeature1:   'असीमित मैसेजिंग',
    premiumFeature2:   'असीमित वॉइस नोट्स',
    premiumFeature3:   'साथी उजागर करने की सुविधा',
    premiumFeature4:   'प्राथमिकता मिलान',
    getStartedPremium: 'प्रीमियम शुरू करें',
    faqTitle:          'सामान्य प्रश्न।',
    faq1q: 'क्या Veyl वाकई गुमनाम है?',
    faq1a: 'हां। आप एक उपनाम से साइन अप करते हैं। कोई असली नाम नहीं, कोई फ़ोटो नहीं। आपका साथी केवल वही जानता है जो आप साझा करना चुनते हैं।',
    faq2q: 'मिलान कैसे काम करता है?',
    faq2a: 'Veyl आपको समान लक्ष्य श्रेणी और आयु वर्ग के किसी व्यक्ति से जोड़ता है। आमतौर पर दो मिनट से कम लगते हैं।',
    faq3q: 'अगर मैं अपने साथी से नहीं बनती/बनता तो?',
    faq3a: 'आप किसी भी समय बिना सवाल के रिपोर्ट या ब्लॉक कर सकते हैं। दोबारा मिलान करें और बेहतर कोई खोजें।',
    faq4q: 'क्या यह नाबालिगों के लिए सुरक्षित है?',
    faq4a: 'बिल्कुल। 13–17 वर्ष के उपयोगकर्ताओं का मिलान केवल उसी आयु वर्ग के साथ होता है। यह सिस्टम स्तर पर लागू होता है।',
    ctaTitle:    'आपका साथी पहले से इंतज़ार कर रहा है।',
    ctaSubtitle: 'Veyl से मुफ़्त जुड़ें। कोई सोशल प्रोफ़ाइल आवश्यक नहीं। बस आप, आपका लक्ष्य और कोई जो समझता हो।',
    privacyPolicy:  'गोपनीयता नीति',
    termsOfService: 'सेवा की शर्तें',
    refundPolicy:   'वापसी नीति',
    featuresTitle: "जो चाहिए वो सब। जो नहीं चाहिए वो कुछ नहीं।",
    feature1Title: "पूर्ण गुमनामी",
    feature1Desc: "आप एक उपनाम चुनते हैं। आपका असली नाम, फोटो और पहचान कभी साझा नहीं की जाएगी, जब तक आप स्वयं इन्हें प्रकट करने का फैसला न करें।",
    feature2Title: "वॉइस नोट्स",
    feature2Desc: "कभी-कभी टाइप करना काफी नहीं होता। ऐप के अंदर ही वॉइस नोट्स रिकॉर्ड करें और भेजें।",
    feature3Title: "उम्र के अनुसार सुरक्षित मैचिंग",
    feature3Desc: "नाबालिग (13–17) केवल नाबालिगों से ही मैच होते हैं। बालिग बालिगों से। कोई अपवाद नहीं — यह सिस्टम में बना हुआ है।",
    feature4Title: "13 भाषाएँ",
    feature4Desc: "अंग्रेज़ी, स्वाहिली, फ्रेंच, स्पेनिश, पुर्तगाली, जर्मन, इटालियन, हिंदी, इंडोनेशियाई, चीनी, जापानी, कोरियाई, हौसा।",
    feature5Title: "दैनिक चेक-इन",
    feature5Desc: "संरचित चेक-इन गति बनाए रखते हैं। अपनी प्रगति दर्ज करें और अपने पार्टनर के साथ जीत का जश्न मनाएं।",
    feature6Title: "ग्रुप्स और कम्युनिटी",
    feature6Desc: "लक्ष्य-विशिष्ट ग्रुप चैट और भाषा-आधारित कम्युनिटी रूम्स में शामिल हों।",
    goalsEyebrow: "वास्तविक लक्ष्यों के लिए",
    goalsTitle: "आप जिस पर भी काम कर रहे हों।",
    goalsSub: "Veyl उन सभी के लिए है जिनका कोई वास्तविक लक्ष्य है और जिनके पास इस बारे में खुलकर बात करने वाला कोई नहीं है।",
    goalFitness: "फिटनेस और स्वास्थ्य",
    goalLearning: "शिक्षा और कौशल",
    goalBusiness: "व्यवसाय और करियर",
    goalCreative: "रचनात्मक प्रोजेक्ट्स",
    moreComingSoon: "और जल्द आ रहे हैं",
    safeTitle: "सुरक्षा कोई फीचर नहीं है। यह आधार है।",
    safe1Title: "उम्र के अनुसार विभाजन",
    safe1Desc: "नाबालिग और बालिग कभी एक साथ नहीं मिलाए जाते। साइनअप पर उम्र सत्यापित और लॉक की जाती है।",
    safe2Title: "रिपोर्ट और ब्लॉक",
    safe2Desc: "कोई भी उपयोगकर्ता तुरंत रिपोर्ट या ब्लॉक कर सकता है। कोई सवाल नहीं पूछा जाता।",
    safe3Title: "कोई डेटा बिक्री नहीं",
    safe3Desc: "आपके लक्ष्य, संदेश और पहचान आपकी हैं। बस यही सच है।",
    safe4Title: "केवल उपनाम",
    safe4Desc: "असली नाम कभी आवश्यक नहीं। आप तय करते हैं कि कब और क्या प्रकट करना है।",
    refundPolicy: "धन वापसी नीति",
    heroLine1: 'जवाबदेही',                  
    heroLine2: 'प्रदर्शन के बिना।',
    mustBe18: 'Veyl उपयोग करने के लिए आपकी उम्र 18 वर्ष या अधिक होनी चाहिए',
    mustBe18Desc: 'Veyl केवल 18 वर्ष या उससे अधिक उम्र के लोगों के लिए है। हमें खेद है, लेकिन खाता बनाने के लिए आप न्यूनतम आयु आवश्यकता को पूरा नहीं करते हैं।',
    ageAttestationLabel: 'मैं पुष्टि करता/करती हूं कि मेरी उम्र 18 वर्ष या उससे अधिक है।',
    ageMisrepresentationNote: 'अपनी उम्र के बारे में गलत जानकारी देना हमारी सेवा की शर्तों का उल्लंघन है और इसके कारण खाता बंद किया जा सकता है।',
    feature3Title: 'केवल 18+ सत्यापित',
    feature3Desc: 'हर सदस्य शामिल होने से पहले पुष्टि करता है कि उसकी उम्र 18 वर्ष या उससे अधिक है। कोई नाबालिग नहीं, कोई अपवाद नहीं।',
    faq4q: 'क्या Veyl नाबालिगों के लिए उपलब्ध है?',
    faq4a: 'नहीं। Veyl केवल 18 वर्ष या उससे अधिक उम्र के लोगों के लिए एक मंच है। हर उपयोगकर्ता साइन-अप के दौरान अपनी उम्र की पुष्टि करता है, और गलत उम्र बताने वाले खाते हटाए जा सकते हैं।',
    safe1Title: 'केवल वयस्कों के लिए',
    safe1Desc: 'Veyl विशेष रूप से 18 वर्ष या उससे अधिक उम्र के लोगों के लिए बनाया गया है। 18 वर्ष से कम उम्र का कोई भी व्यक्ति जो Veyl का उपयोग करने का प्रयास करता है, वह अपनी उम्र के बारे में गलत जानकारी दे रहा है, जो हमारी सेवा की शर्तों का उल्लंघन है।',
    ageVerificationDesc: 'Veyl 18 वर्ष या उससे अधिक उम्र के उपयोगकर्ताओं के लिए उपलब्ध है।',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'अपने लक्ष्य को समायोजित करें',
    adjustGoalDesc: 'दिशा बदलना ठीक है। आपके साथी को सूचित कर दिया जाएगा।',
    newGoalDescription: 'नए लक्ष्य का विवरण',
    newGoalPlaceholder: 'आपका नया या संशोधित लक्ष्य क्या है?',
    updateGoal: 'लक्ष्य अद्यतन करें',
    goalUpdated: 'लक्ष्य सफलतापूर्वक अपडेट हो गया! आपके पार्टनर को सूचित कर दिया गया है।',
    readyToUnveil: 'अनावरण के लिए तैयार हैं?',
    unveilDesc: 'अनावरण के साथ ही वेयल का निर्माण पूरा हो गया है। आपके साथी को सूचित कर दिया जाएगा। इसे बदला नहीं जा सकता।',
    yourNewAvatar: 'आपका नया अवतार',
    notYet: 'अभी तक नहीं',
    unveiling: 'अनावरण...',
    sending: 'भेजा जा रहा है...',
    checkInDesc: 'दैनिक चेक-इन से प्रगति पर नज़र रखी जा सकती है। साप्ताहिक चेक-इन गहन चिंतन का अवसर प्रदान करते हैं।',
    dismiss: '✕',
    saving: 'सहेजा जा रहा है...',
    saved: '✓ सहेजा गया!',
    lightModeDesc: 'साफ़ और चमकदार',
    darkModeDesc: 'आँखों को सुकून देने वाला',
    currentNickname: 'आपका वर्तमान उपनाम है',
    anonymousWarning: 'अपनी पहचान गुप्त रखें। अपना असली नाम इस्तेमाल न करें।',
    nicknameUpdated: '✓ उपनाम अपडेट किया गया!',
    deleteMyAccount: 'मेरा एकाउंट हटा दो',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'मिलिए रासा से',
    rasaIntroDesc: 'रसा आपके लिए एक निजी चिंतन स्थल है — यह सिर्फ आपके लिए है, आपके जवाबदेही साथी से अलग। यह आपके या दुनिया के बारे में कोई पूर्वधारणा नहीं रखता; यह केवल आपसे साझा की गई बातों से सीखता है, और इसका उद्देश्य आपको उत्तर देने के बजाय प्रश्न पूछना है।',
    rasaIntroNotTherapist: 'रासा एक थेरेपिस्ट नहीं है और न ही यह वास्तविक मानवीय संबंधों का विकल्प है—जिसमें आपका जवाबदेही साथी भी शामिल है। अगर आपको कोई बोझ महसूस हो रहा है, तो यह आपको धीरे से सहायता की ओर ले जाएगा, न कि स्वयं सहायता प्रदान करने का प्रयास करेगा।',
    rasaIntroStart: 'शुरू',
    rasaMessagesLeft: 'आज छोड़े गए विचार',
    rasaNoMessagesYet: 'जब भी आप चिंतन करने के लिए तैयार हों, नीचे लिखना शुरू करें।',
    rasaThinking: 'रस प्रतिबिंबित कर रहा है…',
    rasaPrivateNote: 'यह सिर्फ आपके लिए निजी है — आपके जवाबदेही पार्टनर को कभी दिखाई नहीं देगा।',
    rasaPlaceholder: 'अपने मन की बात साझा करें…',
    rasaDailyLimitReached: 'आपने आज की रस सीमा पूरी कर ली है। यह कल रीसेट हो जाएगी।',
    // [auto-synced 2026-08-06]
    feature7Title: 'मिलिए रासा से',
    feature7Desc: 'चिंतन के लिए एक निजी स्थान — केवल आपके लिए, आपके जवाबदेही साथी से अलग।',
    feature8Title: 'किसी भी समय सहायता प्राप्त करें',
    feature8Desc: 'नेविगेशन, बिलिंग और खाता संबंधी प्रश्नों के त्वरित उत्तर सीधे ऐप में ही प्राप्त करें।',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'वेयल सपोर्ट चैट',
    supportChatTitle: 'वेयल समर्थन',
    supportChatEmptyState: 'Veyl कैसे काम करता है, इसके बारे में आप मुझसे कुछ भी पूछ सकते हैं।',
    supportChatPlaceholder: 'प्रश्न पूछें…',
    supportChatSend: 'भेजना',
    supportChatTyping: 'टाइपिंग…',
    supportChatLimitReached: 'आज की सपोर्ट चैट सीमा पूरी हो चुकी है। यदि कोई अत्यावश्यक मामला हो तो support@veyl.space पर ईमेल करें।',
    supportChatGenericError: 'कुछ गड़बड़ हुई है। कृपया दोबारा प्रयास करें।',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'आपकी बातचीत लोड नहीं हो सकी।',
    rasaLoadErrorDetail: 'अधिक जानकारी के लिए ब्राउज़र कंसोल देखें, या ब्राउज़र को रीफ़्रेश करने का प्रयास करें।',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 आपका मिलान {name} से हो गया है! अपने डैशबोर्ड पर जाएं।',
    // [auto-synced 2026-09-08]
    installAppLabel: 'एप्लिकेशन इंस्टॉल करो',
    installMobileOnly: 'केवल मोबाइल के लिए',
    installTooltip: 'केवल मोबाइल उपकरणों पर उपलब्ध है',
    installModalTitle: 'अपने फोन पर Veyl इंस्टॉल करें',
    installStep1: 'Safari के टूलबार में शेयर आइकन पर टैप करें',
    installStep2: 'नीचे स्क्रॉल करें और "होम स्क्रीन पर जोड़ें" पर टैप करें।',
    installStep3: 'ऊपर दाएं कोने में "जोड़ें" पर टैप करें',
    installGotIt: 'समझ गया',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'रिश्ते और जुड़ाव',
    homeLifeOrganization: 'घर और जीवन संगठन',
    moneyFinancialHabits: 'पैसा और वित्तीय आदतें',
    stayingConnected: 'जुड़े रहना',
    independentLiving: 'स्वतंत्र जीवन यापन',
    techConfidence: 'तकनीकी आत्मविश्वास',
    // [auto-synced 2026-09-15]
    goalRelationships: 'रिश्ते और जुड़ाव',
    goalHomeLife: 'घर और जीवन संगठन',
    goalMoney: 'पैसा और वित्तीय आदतें',
    goalStayingConnected: 'जुड़े रहना',
    goalIndependentLiving: 'स्वतंत्र जीवन यापन',
    goalTechConfidence: 'तकनीकी आत्मविश्वास',
    // [auto-synced 2026-10-28]
    resources: 'संसाधन',
    resourcesTitle: 'संसाधन',
    resourcesWriteUps: 'लिखने-अप',
    resourcesLinks: 'अग्रिम पठन',
    resourcesOpensNewTab: 'नए टैब में खुलता है',
    resourcesEmptyTitle: 'अभी तक यहाँ कुछ नहीं है',
    resourcesEmptyBody: 'हम अभी भी इस श्रेणी के लिए संसाधन जुटा रहे हैं। कृपया जल्द ही दोबारा देखें।',
    resourcesNoMatchBody: 'हमें अभी तक इस लक्ष्य के लिए संसाधन नहीं मिल पाए हैं।',
    resourcesDisclaimer: 'यह केवल सामान्य जानकारी है, पेशेवर सलाह नहीं। यदि कोई बात आपके स्वास्थ्य, सुरक्षा या आर्थिक स्थिति को प्रभावित करती है, तो एक योग्य पेशेवर आपकी मदद कर सकता है।',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'सामग्री',
    resourcesMoreToRead: 'और पढ़ें',
    res_intro_fitnessHealth: 'फिटनेस और स्वास्थ्य के लक्ष्य अक्सर बड़े पलों में नहीं, बल्कि छोटे-छोटे, साधारण पलों में हासिल होते हैं। ये लेख आपको थोड़ा तनाव से मुक्ति दिलाने के लिए हैं, और दिए गए लिंक आपको विस्तृत जानकारी देने वाले स्रोतों तक ले जाएंगे।',
    res_fitness_showing_up_title: 'उपस्थिति दर्ज कराना दिखावा करने से बेहतर है',
    res_fitness_showing_up_p1: 'हममें से ज्यादातर लोगों के मन में "सही" व्यायाम की एक छवि होती है: जिम, दौड़ने वाले जूते, पसीना। जब जीवन उस छवि से मेल नहीं खाता, तो यह तय करना आसान हो जाता है कि यह सब आपके लिए नहीं है।',
    res_fitness_showing_up_p2: 'विश्व स्वास्थ्य संगठन का दृष्टिकोण कहीं अधिक व्यापक है। यह अवकाश के दौरान की जाने वाली गतिविधियों, एक स्थान से दूसरे स्थान तक जाने और कार्यस्थल या घर के आसपास की गतिविधियों को भी शामिल करता है। चलना, साइकिल चलाना, खेलकूद और मनोरंजन, सभी गतिविधियाँ, चाहे आप किसी भी स्तर पर हों, इसमें शामिल हैं। इसके दिशानिर्देशों में विशेष रूप से कहा गया है कि किसी भी प्रकार की गतिविधि, बिल्कुल भी गतिविधि न करने से बेहतर है।',
    res_fitness_showing_up_p3: 'जब आप अपने पार्टनर के साथ कोई आदत बना रहे हों तो यह बात मायने रखती है। एक छोटी सी सैर जो आपने सच में की, वह उस कठिन अभ्यास सत्र से कहीं ज़्यादा मायने रखती है जिसे आपने प्लान किया और छोड़ दिया। "मैं सिर्फ़ दस मिनट ही चल पाया" जैसी बात भी बातचीत को जारी रखने का एक ज़रिया है।',
    res_fitness_showing_up_p4: 'इससे यह समझने में भी मदद मिलती है कि आपने क्या किया और आपको कैसा महसूस हुआ। कभी-कभी आदत ही पूरी जीत होती है। तीव्रता बाद में आ सकती है, जब उपस्थित होना कोई मोलभाव न रह जाए।',
    res_fitness_showing_up_p5: 'यदि आपको कोई स्वास्थ्य समस्या है, आप गर्भवती हैं, या आपने लंबे समय से कोई गतिविधि नहीं की है, तो अपने प्रशिक्षण के स्तर में बदलाव करने से पहले किसी डॉक्टर या अन्य योग्य स्वास्थ्य पेशेवर से संक्षिप्त बातचीत करना उचित होगा।',
    res_fitness_rest_title: 'आराम करना योजना का हिस्सा है।',
    res_fitness_rest_p1: 'जब लोग फिटनेस लक्ष्यों के बारे में बात करते हैं, तो नींद और आराम को अक्सर असली काम खत्म होने के बाद बची हुई चीज़ों की तरह माना जाता है। लेकिन असल में, ये इस बात में बहुत अहम भूमिका निभाते हैं कि किया गया काम कितना कारगर साबित होता है।',
    res_fitness_rest_p2: 'नींद और शारीरिक गतिविधि एक दूसरे के पूरक हैं। एनएचएस का कहना है कि नियमित गतिविधि से नींद बेहतर आती है, और कुछ लोगों को सोने के समय के आसपास व्यायाम करने से परेशानी होती है, ऐसे में दिन में जल्दी व्यायाम करना उनके लिए बेहतर हो सकता है। ये दोनों ही बातें नियम नहीं हैं। ये सिर्फ इस बात की याद दिलाती हैं कि आपके शरीर के लिए क्या सही है, यह आपको खुद पता लगाना है।',
    res_fitness_rest_p3: 'जब आप एक-दूसरे को जवाबदेह बनाए रख रहे हों, तो आराम के लिए भी योजना बनाना ज़रूरी है। अगर हर बातचीत इस बात की रिपोर्ट बन जाए कि आपने कितना ज़ोर लगाया, तो एक शांत दिन भी असफलता जैसा लगने लगता है। जानबूझकर चुना गया आराम का दिन लक्ष्य से भटकने से अलग होता है, और इस बात को खुलकर कहने में कोई बुराई नहीं है।',
    res_fitness_rest_p4: 'अगर लंबे समय तक नींद न आने की समस्या बनी रहती है, या आप बिना किसी स्पष्ट कारण के थका हुआ महसूस करते हैं, तो डॉक्टर या किसी योग्य स्वास्थ्य पेशेवर से इस बारे में बात करना उचित होगा। इसे अकेले झेलने की जरूरत नहीं है।',
    res_fitness_food_title: 'बिना किसी झंझट के खाना',
    res_fitness_food_p1: 'खान-पान संबंधी सलाहें बहुत मुखर और अक्सर विरोधाभासी होती हैं, इसलिए यह जानना महत्वपूर्ण है कि बड़े सार्वजनिक स्वास्थ्य निकाय इंटरनेट पर मौजूद अधिकांश लोगों की तुलना में अधिक लचीले होते हैं।',
    res_fitness_food_p2: 'विश्व स्वास्थ्य संगठन (डब्ल्यूएचओ) का कहना है कि स्वस्थ आहार कई प्रकार के होते हैं। सही खान-पान आपकी उम्र, जीवनशैली, संस्कृति और आपके आस-पास उपलब्ध खाद्य पदार्थों पर निर्भर करता है। विश्व स्वास्थ्य संगठन इन सभी सिद्धांतों के मूल में चार मुख्य बातें बताता है: शरीर की ज़रूरतों के अनुसार पर्याप्त मात्रा में पोषण प्राप्त करना, संतुलन बनाए रखना, कुछ खाद्य पदार्थों का सीमित मात्रा में सेवन करना और विभिन्न प्रकार के खाद्य पदार्थ खाना। विश्व स्वास्थ्य संगठन का मानना है कि मुख्य रूप से बिना प्रसंस्कृत खाद्य पदार्थों से बना, विविध आहार ही इसका आधार है।',
    res_fitness_food_p3: 'किसी दूसरे व्यक्ति के साथ मिलकर कोई लक्ष्य तय करने के लिए, यह एक उपयोगी ढांचा है। आपको अपने साथी के खाने के तरीके को अपनाने की ज़रूरत नहीं है, और न ही उन्हें आपके। खाने से जुड़ा लक्ष्य इतना सरल हो सकता है जैसे "घर पर ज़्यादा खाना बनाना" या "इस हफ्ते रोज़ाना के खाने के अलावा कुछ और खाना", जो भी आपकी जीवनशैली और बजट के अनुकूल हो।',
    res_fitness_food_p4: 'अगर आप अपने खान-पान में बड़े बदलाव करने की सोच रहे हैं, या आपको कोई ऐसी बीमारी, एलर्जी या दवा है जिसका असर खाने पर पड़ता है, तो एक डॉक्टर या पंजीकृत आहार विशेषज्ञ ही आपको सही सलाह दे सकते हैं। सामान्य जानकारी से यह सलाह नहीं मिल सकती।',
    res_fitness_who_physical_activity_note: 'वैश्विक। गतिविधि किसे माना जाता है, इससे किसे लाभ होता है और क्यों, इसका एक सरल अवलोकन।',
    res_fitness_who_guidelines_note: 'वैश्विक। विभिन्न आयु वर्ग के लोगों और दीर्घकालिक बीमारियों या विकलांगता से ग्रस्त लोगों के लिए सिफारिशों सहित संपूर्ण दिशानिर्देश।',
    res_fitness_who_healthy_diet_note: 'वैश्विक स्तर पर। यह स्वस्थ आहार के सिद्धांतों और संस्कृति तथा स्थानीय भोजन के अनुसार इसमें होने वाले अंतर को समझाता है।',
    res_fitness_nhs_sleep_note: 'यूके। नींद से जुड़ी व्यावहारिक सलाह। इसमें जहां भी किसी जनरल प्रैक्टिशनर या फार्मासिस्ट का जिक्र है, वह यूके में उपलब्ध सेवाओं को संदर्भित करता है।',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Veyl के बंद होने पर सूचना प्राप्त करें',
    pushPromptBody: 'जब आपका मैच हो जाएगा या आपका पार्टनर आपको मैसेज करेगा, तो हम आपको सूचित कर देंगे। नोटिफिकेशन में मैसेज का कंटेंट शामिल नहीं होता है।',
    pushEnable: 'सूचनाओं पर मुड़ें',
    pushNotNow: 'अभी नहीं',
    pushError: 'नोटिफिकेशन चालू करने में कुछ गड़बड़ी हो गई है। कृपया दोबारा कोशिश करें।',
    pushBlockedTitle: 'सूचनाएं अवरुद्ध हैं',
    pushBlockedBody: 'आपका ब्राउज़र Veyl से आने वाली सूचनाओं को ब्लॉक कर रहा है। उन्हें चालू करने के लिए, अपने ब्राउज़र की साइट सेटिंग में veyl.space खोलें, सूचनाओं को अनुमति दें और फिर पेज को रीलोड करें।',
    pushIosTitle: 'iPhone पर सूचनाएं प्राप्त करें',
    pushIosBody: 'सबसे पहले Veyl को अपनी होम स्क्रीन पर जोड़ें: शेयर पर टैप करें, फिर होम स्क्रीन पर जोड़ें पर टैप करें, फिर वहां से Veyl खोलें और नोटिफिकेशन चालू करें।',
    pushSettingsTitle: 'इस डिवाइस पर सूचनाएं',
    pushSettingsDesc: 'जब आपका मैच हो या आपका पार्टनर आपको मैसेज करे, तो आपको अलर्ट मिलेगा, भले ही Veyl बंद हो। अलर्ट में मैसेज का कंटेंट शामिल नहीं होता है। यह सेटिंग केवल इसी डिवाइस पर लागू होती है।',
    pushSettingsUnsupported: 'इस ब्राउज़र में नोटिफिकेशन उपलब्ध नहीं हैं। iPhone या iPad पर, पहले Veyl को अपनी होम स्क्रीन पर जोड़ें (शेयर करें, फिर होम स्क्रीन पर जोड़ें), और फिर इसे वहां से खोलें।',
    pushSettingsBlocked: 'आपके ब्राउज़र में Veyl के लिए नोटिफिकेशन ब्लॉक हैं। इन्हें चालू करने के लिए, अपने ब्राउज़र की साइट सेटिंग में veyl.space खोलें, नोटिफिकेशन चालू करें और फिर पेज को रीलोड करें।',
    pushSettingsWorking: 'कार्यरत…',
    pushSettingsOn: 'इस डिवाइस के लिए नोटिफिकेशन चालू हैं।',
    pushSettingsTurnOff: 'सूचनाएं बंद करो',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'कुछ नया सीखना अक्सर इस बात पर निर्भर करता है कि आप उसे याद रखने के लिए कितनी बार अभ्यास करते हैं। ये लेख दीर्घकालिक प्रक्रिया के बारे में हैं, और लिंक लगभग हर चीज सीखने के लिए मुफ्त स्रोत हैं।',
    res_learning_small_repeat_title: 'दोहराने के लिए काफी छोटा',
    res_learning_small_repeat_p1: 'अधिकांश सीखने के लक्ष्य बहुत बड़े होने के कारण अधूरे रह जाते हैं, न कि बहुत कठिन होने के कारण। "कोडिंग सीखें" या "पुर्तगाली भाषा में धाराप्रवाह बनें" एक लक्ष्य है, न कि ऐसा कुछ जो आप मंगलवार शाम को कर सकें।',
    res_learning_small_repeat_p2: 'आप मंगलवार की शाम को बीस मिनट बैठकर एक पाठ पढ़ सकते हैं। यह एक ऐसा कार्य है जिसे आप दोहरा सकते हैं, और इसे दोहराने से ही आपका ज्ञान बढ़ता है। कौशल धीरे-धीरे, थोड़ा-थोड़ा करके आते हैं, जब तक कि एक दिन आपको एहसास नहीं होता कि आप कुछ ऐसा कर सकते हैं जो आप पहले नहीं कर पाते थे।',
    res_learning_small_repeat_p3: 'यहीं पर जवाबदेही साथी प्रेरणा से कहीं अधिक मददगार साबित होता है। प्रेरणा आती-जाती रहती है। एक ऐसा साथी जो यह सुनने की उम्मीद रखता है कि कैसा रहा, उसके कारण चुपचाप आदत छोड़ना मुश्किल हो जाता है और एक खराब सप्ताह के बाद फिर से शुरू करना आसान हो जाता है।',
    res_learning_small_repeat_p4: 'अच्छा चेक-इन बहुत प्रभावशाली होना ज़रूरी नहीं है। "मैंने एक पाठ किया और लगभग आधा समझ गया" कहना ईमानदारी है और इससे आदत बनी रहती है। आप बाद में कार्य का स्तर बढ़ा सकते हैं। एक बार आदत छूट जाने पर उसे फिर से शुरू करना बहुत मुश्किल होता है।',
    res_learning_beginner_title: 'शुरुआती होना स्वीकार्य है',
    res_learning_beginner_p1: 'किसी नई चीज की शुरुआत करने का मतलब है उसमें कम से कम एक व्यक्ति के सामने तो असफल होना ही। कई वयस्कों के लिए यही असली बाधा है, समय या पैसे से भी ज्यादा।',
    res_learning_beginner_p2: 'यह जानना उपयोगी हो सकता है कि अब शिक्षा कितनी खुली हो गई है। एमआईटी ओपनकोर्सवेयर हजारों एमआईटी पाठ्यक्रमों की सामग्री मुफ्त में प्रकाशित करता है, जिसके लिए पंजीकरण की आवश्यकता नहीं है। ओपन यूनिवर्सिटी का ओपनलर्न लगभग एक हजार छोटे मुफ्त पाठ्यक्रम प्रदान करता है और कहता है कि इन्हें पढ़ने के लिए कोई शर्त नहीं है। किसी विषय को आज़माने या यह जानने के लिए कि वह आपके लिए उपयुक्त नहीं है, आपको किसी की अनुमति की आवश्यकता नहीं है।',
    res_learning_beginner_p3: 'किसी चीज को आजमाना और यह तय करना कि वह आपके लिए नहीं है, भी सीखने का एक हिस्सा है। किसी एक चीज को चुनने से पहले कुछ चीजों को आजमाना शुरुआत करने का एक बेहतरीन तरीका है।',
    res_learning_beginner_p4: 'जब आपको लगे कि आप पीछे रह गए हैं, तो याद रखें कि आपके साथी को भी अपने लक्ष्य के बारे में शायद ऐसा ही महसूस हो रहा होगा। आप प्रतिस्पर्धा नहीं कर रहे हैं। आप दोनों किसी न किसी लक्ष्य की शुरुआत के करीब हैं, बस अलग-अलग जगहों पर हैं।',
    res_learning_choose_one_title: 'एक चीज चुनें, फिर उसे ही चुनते रहें।',
    res_learning_choose_one_p1: 'मुफ्त शिक्षा की एक अजीब समस्या है: यह बहुत अधिक मात्रा में उपलब्ध है। अकेले ओपनकोर्सवेयर पर ही 2,500 से अधिक पाठ्यक्रम हैं, और ओपनलर्न पर लगभग एक हजार पाठ्यक्रम हैं। पूरी शाम ब्राउज़ करने में बिताना और इसे सीखना कहना बहुत आसान है।',
    res_learning_choose_one_p2: 'एक कोर्स, एक किताब या पाठों की एक श्रृंखला चुनना मददगार होता है, और बाकी सब कुछ बाद के लिए छोड़ देना चाहिए। बाकी को नोट में सहेज कर रखना ठीक है। लक्ष्य यह है कि एक काम खत्म करने के बाद ही दूसरा शुरू करें। अपने साथी को यह बताना कि आपने कौन सा कोर्स चुना है, एक छोटी सी प्रतिबद्धता है जिससे उस पर टिके रहना आसान हो जाता है।',
    res_learning_choose_one_p3: 'यह भी जांचना जरूरी है कि कोई संसाधन आपको क्या देता है और क्या नहीं। उदाहरण के लिए, ओपनलर्न कोर्स के साथ भागीदारी का प्रमाण पत्र मिलता है, और कुछ के साथ डिजिटल बैज मिलता है जो मान्यता प्राप्त योग्यता नहीं है। यदि आपको काम या पढ़ाई के लिए औपचारिक योग्यता की आवश्यकता है, तो यह बात पहले से जान लेना बेहतर है, और जिस संस्थान में आप प्रवेश लेना चाहते हैं, वह आपको बता सकता है कि वे क्या स्वीकार करते हैं।',
    res_learning_mit_ocw_note: 'वैश्विक स्तर पर। बिना पंजीकरण के, एमआईटी के हजारों पाठ्यक्रमों के निःशुल्क व्याख्यान नोट्स, परीक्षाएँ और वीडियो उपलब्ध हैं। अंग्रेजी में।',
    res_learning_khan_academy_note: 'वैश्विक स्तर पर संचालित। एक गैर-लाभकारी संस्था जो कई भाषाओं में मुफ्त पाठ और अभ्यास प्रदान करती है, गणित और विज्ञान में सर्वश्रेष्ठ है।',
    res_learning_openlearn_note: 'ब्रिटेन स्थित, सभी के लिए खुला। लगभग 1,000 निःशुल्क लघु पाठ्यक्रम, लगभग 1 से 24 घंटे तक, प्रत्येक के साथ भागीदारी का निःशुल्क प्रमाण पत्र दिया जाता है।',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'कार्य लक्ष्य दीर्घकालिक होते हैं, और अधिकांश प्रयास लक्ष्यों के बीच के दिनों में ही किए जाते हैं। ये लेख निरंतर गति बनाए रखने के बारे में हैं, और दिए गए लिंक कौशल विकसित करने और अपने अगले कदम की योजना बनाने के लिए निःशुल्क स्थान हैं।',
    res_business_progress_title: 'काम में प्रगति शायद ही कभी सीधी रेखा में होती है।',
    res_business_progress_p1: 'करियर और व्यावसायिक लक्ष्यों को पूरा होने में अक्सर समय लगता है। पदोन्नति, करियर में बदलाव या पहला ग्राहक मिलने में महीनों लग सकते हैं, और बीच के दिनों में शायद ही कभी प्रगति का एहसास होता है।',
    res_business_progress_p2: 'इससे आपको अपने मनचाहे परिणाम और इस सप्ताह आप वास्तव में क्या कर सकते हैं, इन दोनों में अंतर करने में मदद मिलती है। आप यह नियंत्रित नहीं कर सकते कि कोई कंपनी आपको काम पर रखेगी या नहीं, या कोई ग्राहक हाँ कहेगा या नहीं। आप केवल यह नियंत्रित कर सकते हैं कि आप कितनी बातचीत करेंगे, परियोजना को कितना समय देंगे, और आपने जो वादा किया था उसे पूरा करेंगे या नहीं।',
    res_business_progress_p3: 'यहीं पर एक जवाबदेही साझेदार की भूमिका महत्वपूर्ण हो जाती है। उन्हें आपके उद्योग को समझने की आवश्यकता नहीं है। उन्हें बस यह पूछना है कि आपने क्या किया, और आपके उत्तर को बिना किसी दिखावे के ध्यान से सुनना है।',
    res_business_progress_p4: 'कुछ हफ़्तों में सच बात यही होती है कि "कुछ खास नहीं हुआ"। इसे ज़ोर से कहना ज़रूरी है, क्योंकि एक महीने तक ठंडे बस्ते में पड़े लक्ष्य को दोबारा शुरू करना उस लक्ष्य से कहीं ज़्यादा मुश्किल होता है जिसे आपने बस हल्के-फुल्के ढंग से ज़िंदा रखा हो।',
    res_business_start_from_you_title: 'शुरुआत खुद से करें, नौकरी से नहीं।',
    res_business_start_from_you_p1: 'जब लोग अपने काम में फंसा हुआ महसूस करते हैं, तो अक्सर उनकी स्वाभाविक प्रवृत्ति नौकरी बाजार से शुरुआत करने की होती है: कौन सी कंपनियां भर्तियां कर रही हैं, कौन सी अच्छी तनख्वाह देती हैं, और कौन सी देखने में आकर्षक लगती हैं। लेकिन कहीं और से शुरुआत करना अधिक उपयोगी हो सकता है।',
    res_business_start_from_you_p2: 'ओपनलर्न का निःशुल्क पाठ्यक्रम "कार्यस्थल में सफलता" इसी विचार पर आधारित है। इसकी शुरुआत इस दृष्टिकोण से होती है कि स्वयं को जानना और अपने मूल्यों को समझना करियर नियोजन की नींव है, और उसके बाद ही यह सीवी, आवेदन और साक्षात्कार की ओर बढ़ता है।',
    res_business_start_from_you_p3: 'सीधे शब्दों में कहें तो: आप अपने दिन कैसे बिताना चाहते हैं? आपमें ऐसी कौन सी खूबी है जिसके लिए आपको शायद ही कभी श्रेय मिलता है? आप किस चीज को छोड़ने से इनकार करेंगे, चाहे वह परिवार के साथ बिताया गया समय हो, स्थिर आय हो या रचनात्मक होने का अवसर हो?',
    res_business_start_from_you_p4: 'आपको इन सभी सवालों के जवाब अकेले देने की ज़रूरत नहीं है। अपने साथी के साथ बातचीत करने से अक्सर ऐसी बातें सामने आती हैं जिन्हें आप अकेले में नज़रअंदाज़ कर देते, और इससे "मैं कुछ अलग चाहता/चाहती हूँ" जैसी अस्पष्ट बात एक ऐसे लक्ष्य में बदल सकती है जिस पर आप वास्तव में काम कर सकते हैं।',
    res_business_wear_out_title: 'बिना थके कड़ी मेहनत करना',
    res_business_wear_out_p1: 'महत्वाकांक्षा और थकावट अंदर से एक जैसी दिख सकती हैं, खासकर जब कोई लक्ष्य आपके लिए मायने रखता हो।',
    res_business_wear_out_p2: 'विश्व स्वास्थ्य संगठन का कहना है कि कार्यस्थल मानसिक स्वास्थ्य की रक्षा कर सकता है, और साथ ही इसे नुकसान भी पहुंचा सकता है। कार्यस्थल पर मानसिक स्वास्थ्य संबंधी इसके दिशानिर्देश भारी कार्यभार और कार्यस्थल पर नकारात्मक व्यवहार जैसे जोखिमों की ओर इशारा करते हैं, और कहते हैं कि स्वस्थ कार्यस्थल की जिम्मेदारी नियोक्ताओं और सरकारों की है, न कि केवल व्यक्तिगत कर्मचारियों की।',
    res_business_wear_out_p3: 'अगर आप अपने पार्टनर से किसी बड़े कार्य लक्ष्य के बारे में बात कर रहे हैं, तो न केवल यह पूछना ज़रूरी है कि "क्या आपने इसे पूरा कर लिया?" बल्कि यह भी पूछें कि "आप कैसे हैं?" अगर कोई लक्ष्य आपकी नींद, स्वास्थ्य या रिश्तों की कीमत पर हासिल किया जा रहा है, तो उस पर दोबारा विचार करना चाहिए, भले ही कागज़ पर सब कुछ ठीक चल रहा हो।',
    res_business_wear_out_p4: 'अगर काम से आपकी सेहत पर असर पड़ रहा है, या आप लगातार उदास, चिंतित या थका हुआ महसूस कर रहे हैं, तो कृपया किसी डॉक्टर या योग्य स्वास्थ्य पेशेवर से बात करें। अगर आपको काम पर अपने अधिकारों के बारे में जानकारी नहीं है, तो श्रम प्राधिकरण या श्रमिक संगठन जैसी कोई विश्वसनीय स्थानीय संस्था आपके क्षेत्र के अनुसार आपके अधिकारों की व्याख्या कर सकती है। नियम अलग-अलग देशों में काफी भिन्न होते हैं।',
    res_business_who_mh_work_note: 'वैश्विक स्तर पर प्रकाशित। यह मुख्य रूप से नियोक्ताओं और सरकारों के लिए लिखा गया है, इसलिए इसमें तकनीकी भाषा का प्रयोग किया गया है। इसका संक्षिप्त सारांश अरबी, चीनी, अंग्रेजी, फ्रेंच, रूसी और स्पेनिश भाषाओं में उपलब्ध है।',
    res_business_openlearn_entrepreneurship_note: 'यूके आधारित कोर्स। 8 सत्रों में 24 घंटे का कोर्स, और आप बिना पंजीकरण के भी शुरू कर सकते हैं। इसमें यूके के व्यावसायिक नियमों का भी उल्लेख है, इसलिए अपने देश में लागू नियमों की जाँच अवश्य कर लें।',
    res_business_openlearn_succeed_note: 'लगभग 8 सप्ताह का यह कोर्स, जिसमें प्रति सप्ताह लगभग 3 घंटे का समय दिया जाएगा, करियर योजना, सीवी और साक्षात्कार को कवर करेगा। इसे आखिरी बार 2021 में अपडेट किया गया था, इसलिए नौकरी खोजने और सोशल मीडिया से संबंधित कुछ भाग पुराने लग सकते हैं।',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'समय क्षेत्र',
    timezoneCurrentIs: 'आपका वर्तमान समय क्षेत्र है',
    timezoneLockNote: 'आपके दैनिक संदेश और वॉइस नोट की सीमा आपके टाइमज़ोन के अनुसार आधी रात को रीसेट हो जाती है। निष्पक्षता बनाए रखने के लिए, आप अपना टाइमज़ोन केवल उसी दिन बदल सकते हैं जब आपने कोई संदेश या वॉइस नोट इस्तेमाल न किया हो, और वह भी हर 7 दिनों में केवल एक बार।',
    timezoneNew: 'समय क्षेत्र चुनें',
    saveTimezone: 'समय क्षेत्र सहेजें',
    timezoneUpdated: 'समय क्षेत्र अपडेट किया गया',
    timezoneInvalid: 'यह टाइमज़ोन मान्य नहीं है। कृपया सूची में से एक चुनें।',
    timezoneChangeError: 'आपका टाइमज़ोन बदला नहीं जा सका। कृपया पुनः प्रयास करें।',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'रचनात्मक परियोजनाएँ अक्सर अन्य सभी चीजों के बीच के अंतराल में पनपती हैं। ये लेख लंबे अंतराल के दौरान किसी चीज को जीवित रखने के बारे में हैं, और इनमें लेखन सीखने, रचनात्मक कार्यों का उपयोग करने और उन्हें साझा करने से संबंधित विषय शामिल हैं।',
    res_creative_finishing_title: 'किसी काम को पूरा करना भी एक कौशल है।',
    res_creative_finishing_p1: 'किसी रचनात्मक परियोजना को शुरू करना आसान होता है। विचार ताजा होता है और सब कुछ संभव लगता है। मुश्किल तब आती है जब विचार असल काम में बदल जाता है और काम विचार की तुलना में धीमा और अधिक अव्यवस्थित हो जाता है।',
    res_creative_finishing_p2: 'आमतौर पर यहीं पर परियोजनाएं रुक जाती हैं, और ऐसा शायद ही कभी व्यक्ति की प्रतिभा की कमी के कारण होता है। बल्कि, ऐसा अक्सर इसलिए होता है क्योंकि बीच में कोई निश्चित लक्ष्य नहीं होता और कोई देखने वाला भी नहीं होता।',
    res_creative_finishing_p3: 'यहीं पर एक ऐसा साथी जो बस इतना पूछता है, "आपने इस सप्ताह क्या बनाया?", वाकई फर्क ला सकता है। आपको उनसे आलोचना की उम्मीद नहीं है। यह जानकर कि आप अपने सप्ताह का विवरण देंगे, काम के लिए एक छोटी समय सीमा तय हो जाती है, और एक छोटी समय सीमा अक्सर आपको वापस डेस्क, कैनवास या वाद्य यंत्र पर लौटने के लिए पर्याप्त होती है।',
    res_creative_finishing_p4: 'इससे यह तय करने में भी मदद मिलती है कि आपके सामने मौजूद चीज़ के लिए "पूर्ण" का क्या अर्थ है। एक तैयार, कच्चा संस्करण आपके दिमाग में मौजूद एक परिपूर्ण संस्करण से कहीं अधिक महत्वपूर्ण होता है। बनने के बाद आप इसे हमेशा बेहतर बना सकते हैं।',
    res_creative_rough_drafts_title: 'किसी को भी पहला संस्करण देखने की जरूरत नहीं है।',
    res_creative_rough_drafts_p1: 'कई रचनात्मक लोग चुपचाप काम करना बंद कर देते हैं क्योंकि पहला प्रयास उनके मन में मौजूद छवि जितना अच्छा नहीं होता। आपकी कल्पना और आप वर्तमान में जो बना सकते हैं, उसके बीच का यह अंतर सामान्य है। यह अंतर अक्सर तब सबसे अधिक होता है जब आप किसी काम को सबसे ज़्यादा महत्व देते हैं।',
    res_creative_rough_drafts_p2: 'किसी भरोसेमंद व्यक्ति को अपना कच्चा काम दिखाना कुछ हद तक तनाव कम कर सकता है। अपने साथी से यह कहना कि "यह एक अव्यवस्थित ड्राफ्ट है, लेकिन मैं यही करने की कोशिश कर रहा हूँ" बातचीत का विषय बन जाता है, न कि कोई फैसला। आप पाएंगे कि वे इस बात की परवाह ज़्यादा करते हैं कि आपने काम जारी रखा या नहीं, बजाय इसके कि यह अच्छा है या नहीं।',
    res_creative_rough_drafts_p3: 'यदि आप किसी कला में नए हैं, तो शुरुआत करने के आसान तरीके मौजूद हैं। ओपन यूनिवर्सिटी की निःशुल्क शिक्षण साइट ओपनलर्न पर कथा लेखन का एक परिचयात्मक पाठ्यक्रम उपलब्ध है, जो नए लोगों के लिए बनाया गया है। यह कई उदाहरणों में से एक है, और यह अन्य प्रकार के रचनाकारों की तुलना में लेखकों के लिए अधिक उपयुक्त है।',
    res_creative_rough_drafts_p4: 'रचनात्मक कार्यों में प्रगति का मतलब अक्सर निरंतर सुधार ही नहीं होता। कुछ सप्ताह आप ऐसी रचना करते हैं जिस पर आपको गर्व होता है, और कुछ सप्ताह आप ऐसी रचना करते हैं जिसे आप कभी किसी को नहीं दिखाएंगे। दोनों ही महत्वपूर्ण हैं, और दोनों एक ही आदत का हिस्सा हैं।',
    res_creative_using_sharing_title: 'दूसरों के काम का उपयोग करना और अपना काम साझा करना',
    res_creative_using_sharing_p1: 'रचनात्मक परियोजनाओं में अक्सर दूसरों की सामग्री, जैसे चित्र, ध्वनि या पाठ शामिल होते हैं, और अंततः आप अपनी सामग्री भी साझा करना चाह सकते हैं। थोड़ी पृष्ठभूमि जानकारी दोनों के लिए सहायक होती है।',
    res_creative_using_sharing_p2: 'क्रिएटिव कॉमन्स एक गैर-लाभकारी संस्था है जो ऐसे लाइसेंस प्रकाशित करती है जिससे रचनाकार अपने कॉपीराइट को बरकरार रख सकते हैं और दूसरों को उनकी रचना का उपयोग उनकी इच्छानुसार करने की अनुमति मिल सकती है। यदि आप अपनी बनाई हुई कोई चीज़ साझा करना चाहते हैं, तो इसके दिशानिर्देश बताते हैं कि ये लाइसेंस कैसे काम करते हैं।',
    res_creative_using_sharing_p3: 'कुछ संस्थान इससे भी आगे जाते हैं। स्मिथसोनियन ने CC0 लाइसेंस के तहत लाखों तस्वीरें और डेटा जारी किए हैं, जिसका मतलब है कि आप रचनात्मक परियोजनाओं सहित किसी भी काम के लिए स्मिथसोनियन की अनुमति के बिना उनका उपयोग कर सकते हैं। लेकिन इसके अपने FAQ में यह बताया गया है कि CC0 केवल कॉपीराइट को कवर करता है। गोपनीयता या ट्रेडमार्क जैसे अन्य अधिकार अभी भी लागू हो सकते हैं, और इसके संग्रह की कुछ वस्तुएं इसमें शामिल नहीं हैं।',
    res_creative_using_sharing_p4: 'कॉपीराइट नियम अलग-अलग देशों में भिन्न होते हैं, और यह सामान्य जानकारी है, कानूनी सलाह नहीं। यदि कोई परियोजना व्यावसायिक रूप से महत्वपूर्ण है, या आप सुनिश्चित नहीं हैं कि आप किसी सामग्री का उपयोग कर सकते हैं या नहीं, तो एक योग्य पेशेवर आपको स्थिति के बारे में बता सकता है।',
    res_creative_openlearn_fiction_note: 'ब्रिटेन में आयोजित, निःशुल्क शुरुआत। कथा लेखन का एक परिचयात्मक पाठ्यक्रम, जिसमें भागीदारी का निःशुल्क प्रमाण पत्र शामिल है। यह अन्य प्रकार के रचनाकारों की तुलना में लेखकों के लिए अधिक उपयुक्त है।',
    res_creative_cc_license_note: 'वैश्विक स्तर पर। अपने कॉपीराइट को सुरक्षित रखते हुए, अपनी पसंद की शर्तों पर दूसरों को अपना काम इस्तेमाल करने की अनुमति कैसे दें। यह सामान्य जानकारी है, कानूनी सलाह नहीं।',
    res_creative_smithsonian_open_access_note: 'अमेरिकी संस्था द्वारा प्रकाशित, सभी के लिए उपयोग करने के लिए निःशुल्क। इसमें CC0 लाइसेंस के तहत जारी की गई छवियों और डेटा के बारे में बताया गया है, कि यह लाइसेंस क्या अनुमति देता है और क्या नहीं, और किन वस्तुओं को इसमें शामिल नहीं किया गया है।',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'रिश्ते बड़े-बड़े पलों से ज़्यादा छोटी-छोटी, बार-बार की जाने वाली चीज़ों से बनते हैं। ये लेख रिश्तों को मज़बूत बनाए रखने, शोध के अनुसार सबसे ज़्यादा मायने रखने वाली बातों और जब रिश्ते में जुड़ाव मुश्किल हो या रिश्ता असुरक्षित लगे तो क्या करना चाहिए, इन सब के बारे में हैं।',
    res_relationships_small_gestures_title: 'छोटे-छोटे इशारे भी मायने रखते हैं',
    res_relationships_small_gestures_p1: 'हममें से कई लोग दोस्ती और पारिवारिक संबंधों को ऐसी चीज़ों के रूप में देखते हैं जो या तो मौजूद होती हैं या नहीं। हार्वर्ड स्टडी ऑफ एडल्ट डेवलपमेंट के निदेशक रॉबर्ट वाल्डिंगर सामाजिक जीवन को एक जीवित प्रणाली के रूप में वर्णित करते हैं जिसे शारीरिक फिटनेस की तरह ही रखरखाव की आवश्यकता होती है।',
    res_relationships_small_gestures_p2: 'आप छोटी-छोटी बातों से भी अपना समय और ऊर्जा बचा सकते हैं। किसी ऐसे व्यक्ति के बारे में सोचें जिसे आप याद करते हैं और उसे एक संदेश भेजें। विश्व स्वास्थ्य संगठन द्वारा सुझाए गए रोज़मर्रा के काम भी उतने ही सरल हैं: किसी मित्र से संपर्क करना, बातचीत में पूरी तरह से शामिल होने के लिए अपना फ़ोन दूर रखना, पड़ोसी को नमस्कार करना, किसी स्थानीय समूह में शामिल होना या स्वयंसेवा करना।',
    res_relationships_small_gestures_p3: 'यदि आप किसी ऐसे लक्ष्य को लेकर प्रतिबद्ध हैं जिसे आप अपने जवाबदेही साथी के साथ साझा करते हैं, तो यह एक अच्छा साप्ताहिक प्रश्न हो सकता है: आपने किससे संपर्क किया? यह ठोस है, छोटा है, और आप एक कठिन सप्ताह में भी इसका ईमानदारी से उत्तर दे सकते हैं।',
    res_relationships_small_gestures_p4: 'हर संदेश का गर्मजोशी से जवाब नहीं मिलता, और यही इसका एक हिस्सा है। वाल्डिंगर का कहना है कि लोग अक्सर इस बात से हैरान होते हैं कि ऐसे छोटे संदेशों को कितनी गर्मजोशी से स्वीकार किया जाता है।',
    res_relationships_quality_title: 'मात्रा से अधिक गुणवत्ता।',
    res_relationships_quality_p1: 'सामाजिक जीवन को लोगों की संख्या से मापना आसान है: कितने दोस्त हैं, कितने कार्यक्रमों में भाग लेते हैं, और क्या आप किसी रिश्ते में हैं। लेकिन शोध कुछ और ही इशारा करता है।',
    res_relationships_quality_p2: 'हार्वर्ड स्टडी ऑफ एडल्ट डेवलपमेंट 1938 से लोगों पर नज़र रख रही है। जब इसके शोधकर्ताओं ने प्रतिभागियों के मध्य आयु के जीवन का विश्लेषण किया, तो उनके रिश्तों, विशेष रूप से वैवाहिक जीवन में संतुष्टि, इस बात का बेहतर अनुमान लगा पाई कि 80 वर्ष की आयु में कौन खुश और स्वस्थ रहेगा, बजाय कोलेस्ट्रॉल या रक्तचाप जैसी चीज़ों के। इसके निदेशक का कहना है कि अन्य शोध समूहों ने भी यही पाया है। उनका यह भी कहना है कि ज़रूरी रिश्तों की कोई निश्चित संख्या नहीं है, और शर्मीले लोगों को बहिर्मुखी लोगों की तुलना में कम रिश्तों की आवश्यकता हो सकती है।',
    res_relationships_quality_p3: 'एक बात का ध्यान रखें: इस अध्ययन में शामिल पहले प्रतिभागी हार्वर्ड के छात्र और एक अमेरिकी शहर के युवा थे, इसलिए यह सभी का प्रतिनिधित्व नहीं करता है। निष्कर्षों को पूरी तरह से सच न मानें।',
    res_relationships_quality_p4: 'यह अध्ययन अप्रत्यक्ष रूप से यह संकेत देता है कि कम से कम एक मजबूत रिश्ता, कोई ऐसा व्यक्ति जिसे आप बीमार या भयभीत होने पर फोन कर सकें, एक बड़े सामाजिक दायरे से कहीं अधिक महत्वपूर्ण है। और इसके लिए शायद ही कभी देर होती है। अध्ययन के निदेशक ऐसे लोगों का वर्णन करते हैं जिन्होंने जीवन के उत्तरार्ध में, जब उन्हें इसकी उम्मीद नहीं थी, घनिष्ठ मित्रता या प्रेम पाया।',
    res_relationships_hard_times_title: 'जब संबंध स्थापित करना कठिन हो, और जब कोई रिश्ता दुखदायी हो',
    res_relationships_hard_times_p1: 'अकेलापन महसूस करना यह नहीं दर्शाता कि आपमें कुछ कमी है। विश्व स्वास्थ्य संगठन का अनुमान है कि दुनिया भर में लगभग हर छह में से एक व्यक्ति, हर उम्र में, अकेलेपन का अनुभव करता है। यह अकेलेपन को उस पीड़ादायक अनुभूति के रूप में परिभाषित करता है जो तब उत्पन्न होती है जब आपके मौजूदा संबंध आपकी इच्छित संबंधों से मेल नहीं खाते।',
    res_relationships_hard_times_p2: 'इसके कारणों में खराब स्वास्थ्य, कम आय, अकेले रहना या प्रौद्योगिकी के उपयोग का तरीका शामिल हो सकता है। विश्व स्वास्थ्य संगठन (डब्ल्यूएचओ) का कहना है कि यदि समस्या अधिक गंभीर है, तो उपलब्ध सहायता और सेवाओं के बारे में जानकारी प्राप्त करना महत्वपूर्ण है।',
    res_relationships_hard_times_p3: 'इसका एक दूसरा पहलू भी है: ऐसे रिश्ते जो दुख पहुंचाते हैं। साझेदारी में हानिकारक व्यवहार में मनोवैज्ञानिक दुर्व्यवहार और नियंत्रणकारी व्यवहार के साथ-साथ शारीरिक या यौन उत्पीड़न भी शामिल है।',
    res_relationships_hard_times_p4: 'अगर आपको अपने किसी करीबी से डर लग रहा है, या आपको चोट पहुँच रही है, तो कृपया अपने स्थानीय आपातकालीन नंबर या स्थानीय हेल्पलाइन या सहायता सेवा से संपर्क करें। सही नंबर आपके देश के अनुसार अलग-अलग हो सकते हैं, और वेयल पार्टनर एक साथी होता है, प्रशिक्षित काउंसलर नहीं। अगर आपको लग रहा है कि आप इस बोझ को संभाल नहीं पा रहे हैं, तो डॉक्टर या काउंसलर आपकी मदद कर सकते हैं।',
    res_relationships_who_social_connection_note: 'वैश्विक। अकेलेपन और सामाजिक जुड़ाव पर डब्ल्यूएचओ की 2025 की रिपोर्ट का एक संक्षिप्त, सरल भाषा में सारांश (13 पृष्ठ)।',
    res_relationships_harvard_gazette_note: 'अमेरिकी स्रोत। हार्वर्ड स्टडी ऑफ एडल्ट डेवलपमेंट के निदेशक के साथ एक प्रश्नोत्तर सत्र, जिसमें रिश्तों और स्वास्थ्य पर शोध के प्रभावों, जिनमें रोजमर्रा के छोटे-छोटे कदम भी शामिल हैं, पर चर्चा की गई है। यह एक साक्षात्कार है, और अध्ययन के शुरुआती प्रतिभागी एक अमेरिकी शहर से थे।',
    res_relationships_who_violence_note: 'वैश्विक स्तर पर प्रकाशित यह रिपोर्ट बताती है कि घरेलू हिंसा में क्या-क्या शामिल है और यह कितनी आम है, जो मुख्य रूप से महिलाओं को प्रभावित करती है। यह जानकारी देने वाली पत्रिका है, हेल्पलाइन नहीं, और इसे पढ़ना थोड़ा कठिन हो सकता है।',
  },

  id: {
    appName: 'Veyl',
    loading: 'Memuat...',
    save: 'Simpan',
    cancel: 'Batal',
    back: 'Kembali',
    continue: 'Lanjutkan',
    done: 'Selesai',
    error: 'Kesalahan',
    submit: 'Kirim',
    send: 'Kirim',
    delete: 'Hapus',
    leave: 'Keluar',
    stay: 'Tetap',
    yes: 'Ya',
    no: 'Tidak',
    upgrade: 'Upgrade ke Premium',
    signIn: 'Masuk',
    signUp: 'Daftar',
    signOut: 'Keluar',
    email: 'Email',
    password: 'Kata sandi',
    forgotPassword: 'Lupa kata sandi?',
    resetPassword: 'Reset kata sandi',
    resetPasswordSent: 'Email reset kata sandi terkirim. Periksa kotak masuk Anda.',
    noAccount: 'Belum punya akun?',
    hasAccount: 'Sudah punya akun?',
    authError: 'Kesalahan autentikasi. Silakan coba lagi.',
    landingHero: 'Akuntabilitas yang benar-benar bekerja',
    landingSubtitle: 'Temukan mitra anonim yang berbagi tujuan Anda. Tanpa tekanan sosial. Hanya hasil.',
    getStarted: 'Mulai — Gratis',
    howItWorks: 'Cara kerjanya',
    step1Title: 'Tetapkan tujuan Anda',
    step1Desc: 'Ceritakan apa yang sedang Anda kerjakan. Kami akan mencocokkan Anda dengan seseorang dalam perjalanan serupa.',
    step2Title: 'Temui mitra Anda',
    step2Desc: 'Dipasangkan dengan mitra akuntabilitas anonim di zona waktu Anda.',
    step3Title: 'Tetap akuntabel',
    step3Desc: 'Check-in harian, bagikan kemajuan, dan saling mendukung — secara anonim.',
    pricingTitle: 'Harga sederhana',
    freePlan: 'Gratis',
    premiumPlan: 'Premium',
    perMonth: '/bulan',
    freeFeature1: '1 Veyl aktif',
    freeFeature2: '10 pesan/hari',
    freeFeature3: '10 pesan suara/hari',
    freeFeature4: 'Check-in harian dan mingguan',
    freeFeature5: 'Akses obrolan grup',
    premiumFeature1: 'Hingga 3 Veyl aktif',
    premiumFeature2: 'Pesan tak terbatas',
    premiumFeature3: 'Pesan suara tak terbatas',
    premiumFeature4: 'Pencocokan prioritas',
    faqTitle: 'Pertanyaan yang sering diajukan',
    welcomeToVeyl: 'Selamat datang di Veyl',
    chooseLanguage: 'Pilih bahasa Anda',
    chooseLanguageDesc: 'Pilih bahasa yang ingin Anda gunakan di Veyl.',
    ageVerification: 'Verifikasi usia',
    ageVerificationDesc: 'Veyl tersedia untuk pengguna berusia 13 tahun ke atas.',
    areYouOldEnough: 'Apakah Anda berusia 13 tahun atau lebih?',
    yesIAm: '✅ Ya, saya',
    noImNot: '❌ Tidak, saya tidak',
    mustBe13: 'Anda harus berusia 13 tahun atau lebih',
    mustBe13Desc: 'Veyl hanya tersedia untuk pengguna berusia 13 tahun ke atas.',
    setupProfile: 'Mari siapkan profil Anda',
    stepOf: 'Langkah {step} dari 4',
    whatsYourName: 'Siapa nama Anda?',
    namePlaceholder: 'Masukkan nama panggilan Anda',
    whatsYourTimezone: 'Apa zona waktu Anda?',
    selectTimezone: 'Pilih zona waktu',
    goalCategory: 'Apa kategori tujuan Anda?',
    matchPreference: 'Dengan siapa Anda ingin dicocokkan?',
    matchNearby: 'Cocokkan terdekat',
    matchNearbyDesc: 'Cocokkan dengan orang dalam 4 jam zona waktu Anda.',
    matchAnywhere: 'Cocokkan di mana saja',
    matchAnywhereDesc: 'Cocokkan dengan siapa saja di seluruh dunia tanpa memandang zona waktu.',
    describeGoal: 'Jelaskan tujuan spesifik Anda',
    goalPlaceholder: "Cth.: 'Saya ingin menurunkan 15 kg' atau 'Belajar Python'",
    communicationStyle: 'Gaya komunikasi yang disukai',
    textMessages: 'Pesan teks',
    textMessagesDesc: 'Mengobrol saat nyaman',
    scheduledCheckins: 'Check-in terjadwal',
    scheduledCheckinsDesc: 'Refleksi mendalam mingguan',
    completingSetup: 'Mencari pasangan...',
    completeSetup: 'Selesaikan pengaturan',
    agreeToTerms: 'Dengan melanjutkan, Anda menyetujui',
    termsOfService: 'Syarat Layanan',
    and: 'dan',
    privacyPolicy: 'Kebijakan Privasi',
    fitnessHealth: 'Kebugaran & Kesehatan',
    learningSkills: 'Pembelajaran & Keterampilan',
    businessCareer: 'Bisnis & Karier',
    creativeProjects: 'Proyek Kreatif',
    findingMatch: 'Mencari pasangan Anda...',
    findingNewMatch: 'Mencari pasangan baru Anda...',
    lookingForSomeone: 'Kami mencari seseorang di kategori',
    category: '',
    sharesTimezone: 'yang berbagi zona waktu dan komitmen Anda.',
    autoCheck: 'Kami memeriksa kecocokan secara otomatis setiap 5 detik.',
    noMatchYet: 'Belum ada kecocokan — kami akan terus mencoba.',
    checkNow: 'Periksa sekarang',
    checking: 'Memeriksa...',
    manualChecks: '{count} pemeriksaan manual dilakukan',
    joinCommunity: '🌐 Bergabung dengan komunitas sambil menunggu',
    goToCommunity: '🌐 Pergi ke komunitas',
    previousPartnerNote: '🛡️ Mitra sebelumnya tidak akan disarankan lagi.',
    joining: 'Bergabung...',
    overview: 'Ikhtisar',
    chat: 'Obrolan',
    checkin: 'Check-in',
    group: 'Grup',
    community: 'Komunitas',
    notifications: 'Notifikasi',
    settings: 'Pengaturan',
    yourGoal: 'Tujuan Anda',
    yourPartner: 'Mitra Anda',
    you: 'Anda',
    unveiled: '✨ Terungkap',
    goalComplete: '✓ Tujuan Tercapai',
    adjustGoal: 'Sesuaikan Tujuan Saya',
    unveilButton: '✨ Ungkap — Anda Berhasil!',
    goalCategory2: 'Kategori',
    goalDescription: 'Deskripsi',
    timezone: 'Zona Waktu',
    loadingPartner: 'Memuat informasi mitra...',
    waitingForMatch: 'Menunggu kecocokan untuk mulai mengobrol.',
    noMessagesYet: 'Belum ada pesan. Sapa mitra Anda!',
    typeMessage: 'Ketik pesan Anda...',
    dailyLimitReached: 'Batas harian tercapai — Upgrade ke Premium',
    unmatch: '🔓 Batalkan pencocokan',
    report: '🚩 Laporkan',
    unmatchWarning: '⚠️ Membatalkan pencocokan akan menghapus seluruh riwayat obrolan. Tindakan ini tidak dapat dibatalkan.',
    yesUnmatch: 'Ya, batalkan',
    unmatching: 'Membatalkan...',
    deleteMessage: '🗑 Hapus',
    deleting: 'Menghapus...',
    checkIn: 'Check-in',
    submitDaily: 'Kirim check-in harian',
    submitWeekly: 'Kirim check-in mingguan',
    submitting: 'Mengirim...',
    checkinSubmitted: 'Check-in terkirim!',
    viewHistory: 'Lihat riwayat saya',
    notificationsTitle: 'Notifikasi',
    clearAll: 'Hapus semua',
    noNotifications: 'Belum ada notifikasi.',
    settingsTitle: 'Pengaturan',
    settingsDesc: 'Personalisasi identitas anonim Anda.',
    saveAvatar: 'Simpan avatar',
    appearance: 'Tampilan',
    lightMode: '☀️ Terang',
    darkMode: '🌙 Gelap',
    changeNickname: 'Ubah nama panggilan',
    saveNickname: 'Simpan nama panggilan',
    deleteAccount: 'Hapus akun',
    deleteAccountDesc: 'Menghapus akun Anda dan semua data terkait secara permanen.',
    languageLabel: 'Bahasa',
    languageDesc: 'Pilih bahasa yang Anda sukai.',
    signOut: 'Keluar',
    updating: 'Memperbarui...',
    unveil: 'Ungkap',
    clearing: 'Menghapus...',
    notifMatchFound: 'Kecocokan ditemukan',
    notifGoalAchieved: 'Tujuan tercapai',
    notifSupport: 'Pesan dukungan',
    notifUnmatched: 'Peringatan pembatalan',
    notifMatchRequest: 'Permintaan kecocokan',
    notificationPrefs: 'Preferensi notifikasi',
    notificationPrefsDesc: 'Bisukan jenis notifikasi tertentu secara individual.',
    muted: 'Dibisukan',
    active: 'Aktif',
    all: 'Semua',
    justNow: 'Baru saja',
    minsAgo: '{count}m lalu',
    hoursAgo: '{count}j lalu',
    daysAgo: '{count}h lalu',
    leaving: 'Keluar...',
    myHistory: '📋 Riwayat saya',
    partnersProgress: '👤 Kemajuan {name}',
    myCheckinHistory: 'Riwayat check-in saya',
    checkinsForVeyl: '{count} check-in untuk Veyl ini',
    noCheckinsYet: 'Belum ada check-in. Mulai yang pertama!',
    newCheckinBtn: 'Check-in baru',
    partnerNoCheckins: '{name} belum melakukan check-in.',
    dailyNotesPrivate: 'Catatan harian bersifat pribadi',
    goalAchievedMarked: '🎉 Tujuan ditandai sebagai tercapai',
    goalAchievedNote: '🎉 Tujuan Anda ditandai sebagai tercapai! Pergi ke Ikhtisar untuk mengungkapnya.',
    veylComplete: '✓ Veyl ini selesai. Check-in hanya bisa dibaca.',
    goalAlreadyAchieved: '🎉 Anda telah menandai tujuan Anda sebagai tercapai! Pergi ke Ikhtisar untuk mengungkapnya.',
    didYouWork: 'Apakah Anda mengerjakan tujuan Anda hari ini?',
    howDidWeekGo: 'Bagaimana minggu ini dengan tujuan Anda?',
    whatGotInWay: 'Apa yang menghalangi? (Opsional)',
    honestNote: 'Jujurlah. Mitra Anda di sini untuk mendukung, bukan menghakimi.',
    whatDidYouLearn: 'Apa yang Anda pelajari tentang diri sendiri minggu ini?',
    insightsPlaceholder: 'Wawasan apa yang Anda dapatkan?',
    whatPatterns: 'Pola apa yang Anda perhatikan?',
    patternsPlaceholder: 'Ada tema atau hambatan berulang?',
    whatChange: 'Apa yang perlu berubah untuk minggu depan?',
    changePlaceholder: 'Apa yang akan Anda lakukan berbeda?',
    goalAchievedQuestion: '🏆 Apakah Anda telah mencapai tujuan keseluruhan Anda?',
    yesDidIt: '🎉 Ya, saya berhasil!',
    notYetBtn: 'Belum',
    didIt: '✅ Sudah',
    didSome: '😐 Sedikit',
    didntDoIt: '❌ Belum',
    metCommitment: '✅ Memenuhi komitmen',
    partialProgress: '😐 Kemajuan sebagian',
    noProgress: '❌ Tidak ada kemajuan',
    rethinkingGoal: '🤔 Memikirkan ulang tujuan',
    yesLabel: '✅ Ya',
    aLittle: '😐 Sedikit',
    noLabel: '❌ Tidak',
    madeProgress: 'Membuat kemajuan hari ini',
    didSomething: 'Melakukan sesuatu, tidak semuanya',
    didntWork: 'Tidak mengerjakan hari ini',
    metWeekly: 'Memenuhi komitmen mingguan',
    madePartial: 'Membuat kemajuan sebagian',
    didntMake: 'Tidak membuat kemajuan',
    needToAdjust: 'Perlu menyesuaikan pendekatan',
    learnedLabel: 'Dipelajari: ',
    patternLabel: 'Pola: ',
    nextWeekLabel: 'Minggu depan: ',
    joinGroup: 'Bergabung dengan grup',
    joinGroupDesc: 'Grup menyatukan hingga 5 orang yang mengerjakan tujuan serupa. Anonim, suportif, tanpa tekanan.',
    whatToExpect: 'APA YANG DIHARAPKAN',
    expectAnonymous: 'Semua tetap anonim — avatar siluet yang sama',
    expectMatched: 'Dicocokkan berdasarkan kategori tujuan untuk dukungan relevan',
    expectMembers: 'Hingga 5 anggota per grup',
    expectChat: 'Obrolan grup — 20 pesan & 5 pesan suara/hari gratis · Tak terbatas di Premium',
    findOrCreate: 'Temukan atau buat grup',
    findingGroup: 'Mencari grup Anda...',
    oneGroupNote: 'Anda hanya bisa berada dalam satu grup sekaligus. Pengguna gratis dan Premium keduanya mendapat akses grup.',
    groupCreated: 'Grup dibuat!',
    groupJoined: 'Bergabung dengan grup!',
    groupCreatedDesc: 'Anda telah memulai grup {category} baru. Orang lain akan segera bergabung.',
    groupJoinedDesc: 'Anda telah bergabung dengan grup {category} yang ada. Ucapkan halo!',
    switchToGroup: 'Beralih ke tab Grup di dasbor Anda untuk mulai mengobrol.',
    groupMembers: 'Anggota grup',
    backToChat: '← Kembali ke obrolan',
    creator: '★ Pembuat',
    joined: 'Bergabung',
    leaveGroup: 'Tinggalkan grup',
    leaveGroupTitle: 'Tinggalkan grup ini?',
    leaveGroupDesc: 'Anda akan kehilangan akses ke obrolan grup dan bisa bergabung dengan grup baru kapan saja.',
    membersBtn: '👥 Anggota',
    noGroupMessages: 'Belum ada pesan. Jadilah yang pertama menyapa!',
    messageGroup: 'Pesan ke grup Anda...',
    groupDailyLimit: 'Anda telah mencapai batas pesan grup harian ({limit}/hari). Upgrade ke Premium untuk pesan tak terbatas!',
    groupVoiceLimit: 'Batas pesan suara harian tercapai.',
    veylCommunity: 'Komunitas Veyl',
    communityDesc: 'Bergabunglah dengan orang lain yang mengerjakan kategori tujuan yang sama saat menunggu kecocokan.',
    communityJoinNote: 'Bergabunglah dengan komunitas dari halaman tunggu saat mencari kecocokan.',
    leaveCommunity: 'Tinggalkan komunitas ini?',
    communityLeaveDesc: 'Anda bisa kembali kapan saja dari halaman tunggu.',
    matchRequests: 'Permintaan kecocokan',
    incoming: 'Masuk',
    sent: 'Terkirim',
    noIncoming: 'Tidak ada permintaan masuk.',
    noPending: 'Tidak ada permintaan terkirim yang tertunda.',
    requestToAnonymous: 'Permintaan ke pengguna anonim',
    pending: 'Tertunda',
    decline: 'Tolak',
    accept: '✅ Terima',
    requestWaiting: '🤝 {count} permintaan kecocokan menunggu Anda',
    view: 'Lihat',
    requestsBtn: '🤝 Permintaan',
    leaveBtn: 'Keluar',
    openToAll: 'Terbuka untuk semua · Anonim',
    msgsLeft: '{count} pesan tersisa',
    noCommunityMessages: 'Belum ada pesan. Ucapkan halo ke komunitas!',
    saySomething: 'Katakan sesuatu ke komunitas...',
    requestMatch: '🤝 Minta kecocokan',
    requestSending: 'Mengirim...',
    communityMsgsWarning: '{count} pesan komunitas tersisa hari ini.',
    communityDailyLimit: 'Anda telah mencapai batas pesan komunitas harian ({limit}/hari). Upgrade ke Premium untuk tak terbatas!',
    matchRequestLimit: 'Anda hanya bisa memiliki 3 permintaan tertunda sekaligus.',
    matchRequestSent: 'Permintaan kecocokan berhasil dikirim!',
    matchRequestDuplicate: 'Anda sudah mengirim permintaan ke orang ini.',
    matchRequestError: 'Kesalahan saat mengirim permintaan kecocokan. Silakan coba lagi.',
    matchAcceptError: 'Kesalahan saat menerima permintaan kecocokan.',
    matchRequestSentAlready: 'Anda sudah mengirim permintaan ke orang ini.',
    avatar_silhouette: 'Siluet',
    avatar_teal: 'Hijau kebiruan',
    avatar_purple: 'Ungu',
    avatar_navy: 'Biru tua',
    avatar_slate: 'Abu-abu batu',
    avatar_coral: 'Koral',
    avatar_gold: 'Emas',
    avatar_moss: 'Lumut',
    avatar_indigo: 'Nila',
    avatar_unveiled: 'Terungkap',
    activeLabel: 'Aktif',
    seekingLabel: 'Mencari',
    completeLabel: 'Selesai',
    upgradeForMore: '✨ Upgrade untuk lebih banyak Veyls',
    newVeyl: '+ Veyl baru',
    newVeylTitle: 'Mulai Veyl baru',
    goalCategoryLabel: 'Kategori tujuan',
    goalDescriptionLabel: 'Deskripsi tujuan',
    startVeyl: 'Mulai Veyl baru',
    starting: 'Memulai...',
    unveil: 'Ungkap',
    clearing: 'Menghapus...',
    nicknameRequired: 'Nama panggilan diperlukan',
    nicknameTooShort: 'Nama panggilan harus minimal 2 karakter',
    nicknameTooLong: 'Nama panggilan maksimal 20 karakter',
    errorSavingNickname: 'Kesalahan menyimpan nama panggilan',
    errorSavingAvatar: 'Kesalahan menyimpan avatar',
    errorDeletingAccount: 'Kesalahan menghapus akun',
    deleteMyAccountButton: 'Hapus akun saya',
    goalsAchievedTitle: 'Tujuan tercapai',
    goalsPrivate: 'Pribadi — hanya terlihat oleh Anda.',
    goalsCompletedCount: '{count} tujuan selesai',
    keepAnonymous: 'Tetap anonim. Jangan gunakan nama asli Anda.',
    currentNicknameIs: 'Nama panggilan Anda saat ini adalah',
    unveiledLocked: '✨ Terungkap — avatar dikunci',
    howOthersSee: 'Begini orang lain melihat Anda',
    unveiledNote: 'Anda telah terungkap di Veyl ini. Mulai Veyl baru untuk memilih avatar baru.',
    active2: '✓ Aktif',
    goalsAchieved: 'Tujuan tercapai',
    goalsAchievedDesc: 'Pribadi — hanya terlihat oleh Anda.',
    goalCompleted: 'tujuan selesai',
    goalsCompleted: 'tujuan selesai',
    contactSupport: 'Hubungi dukungan',
    deleteWarning: '⚠️ Ini akan menghapus segalanya secara permanen. Ketik HAPUS di bawah untuk mengonfirmasi.',
    typeDelete: 'Ketik HAPUS untuk mengonfirmasi',
    confirmDelete: 'Konfirmasi hapus',
    deleting2: 'Menghapus...',
    messagesLeft: '{count} pesan · {voiceCount} pesan suara tersisa hari ini',
    premiumUnlimited: '✨ Premium — Pesan & pesan suara tak terbatas',
    messagesLeftWarning: '{count} pesan tersisa hari ini.',
    forUnlimited: 'untuk pesan tak terbatas.',
    voiceNotesLeft: '{count} pesan suara tersisa hari ini',
    dailyLimitReachedVoice: 'Batas pesan suara harian tercapai.',
    dailyVoiceNoteLimit: 'Batas pesan suara harian tercapai. Upgrade ke Premium untuk pesan tak terbatas.',
    recording: 'Merekam...',
    deeper: 'Lebih dalam',
    neutral: 'Netral',
    higher: 'Lebih tinggi',
    applyingModulation: '⚙️ Menerapkan modulasi...',
    preview: '▶ Pratinjau',
    pause: '⏸ Jeda',
    discard: 'Buang',
    recordingTooLarge: 'Rekaman terlalu besar. Coba pesan yang lebih pendek.',
    failedToSend: 'Gagal mengirim. Silakan coba lagi.',
    micDenied: 'Akses mikrofon ditolak.',
    unmatchMessage: 'Mitra Anda telah mengakhiri sesi Veyl ini. Anda dikembalikan ke pencarian kecocokan.',
    appearanceDesc: 'Pilih tampilan Veyl untuk Anda.',
    newNickname: 'Nama panggilan baru',
    nicknamePlaceholder: 'mis. NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Pilih avatar Anda',
    notificationsTitle: 'Notifikasi',
    notificationsCount: '{total} total · {unread} belum dibaca',
    progressOf: 'Kemajuan {name}',
    fitnessHealth: 'Kebugaran & Kesehatan',
    learningSkills: 'Belajar & Keterampilan',
    businessCareer: 'Bisnis & Karier',
    creativeProjects: 'Proyek Kreatif',
    progressOf: 'Kemajuan {name}',
    dailyCheckin: 'Check-in Harian',
    weeklyCheckin: 'Check-in Mingguan',
    dailyCheckinDesc: 'Pembaruan cepat: Apakah kamu mengerjakan tujuanmu hari ini?',
    weeklyCheckinDesc: 'Refleksi mendalam: Bagaimana minggu ini secara keseluruhan?',
    submitDaily: 'Kirim Check-in Harian',
    submitWeekly: 'Kirim Check-in Mingguan',
    submitting: 'Mengirim...',
    checkinSubmitted: 'Check-in Terkirim!',
    checkinSubmittedDesc: 'Kerja bagus tetap bertanggung jawab. {name} akan melihat pembaruanmu.',
    viewHistory: 'Lihat Riwayat Saya',
    newCheckin: '📝 Check-in Baru',
    myHistory: '📋 Riwayat Saya',
    partnersProgress: '👤 Kemajuan {name}',
    myCheckinHistory: 'Riwayat Check-in Saya',
    checkinsForVeyl: '{count} check-in untuk Veyl ini',
    noCheckinsYet: 'Belum ada check-in. Mulai yang pertama!',
    newCheckinBtn: 'Check-in Baru',
    partnerNoCheckins: '{name} belum melakukan check-in.',
    dailyNotesPrivate: 'Catatan harian bersifat pribadi',
    goalAchievedMarked: '🎉 Tujuan ditandai sebagai tercapai',
    goalAchievedNote: '🎉 Tujuanmu ditandai sebagai tercapai! Pergi ke Ikhtisar untuk mengungkap.',
    veylComplete: '✓ Veyl ini selesai. Check-in hanya bisa dibaca.',
    goalAlreadyAchieved: '🎉 Kamu telah menandai tujuanmu sebagai tercapai! Pergi ke Ikhtisar untuk mengungkap.',
    didYouWork: 'Apakah kamu mengerjakan tujuanmu hari ini?',
    howDidWeekGo: 'Bagaimana minggu ini dengan tujuanmu?',
    whatGotInWay: 'Apa yang menghalangi? (Opsional)',
    honestNote: 'Jujurlah. Mitramu di sini untuk mendukung, bukan menghakimi.',
    whatDidYouLearn: 'Apa yang kamu pelajari tentang dirimu minggu ini?',
    insightsPlaceholder: 'Wawasan apa yang kamu peroleh?',
    whatPatterns: 'Pola apa yang kamu perhatikan?',
    patternsPlaceholder: 'Tema atau hambatan yang berulang?',
    whatChange: 'Apa yang perlu berubah untuk minggu depan?',
    changePlaceholder: 'Apa yang akan kamu lakukan berbeda?',
    goalAchievedQuestion: '🏆 Apakah kamu telah mencapai tujuan keseluruhanmu?',
    yesDidIt: '🎉 Ya, aku berhasil!',
    notYetBtn: 'Belum',
    didIt: '✅ Selesai',
    didSome: '😐 Sebagian',
    didntDoIt: '❌ Tidak selesai',
    metCommitment: '✅ Memenuhi komitmen',
    madePartial: '😐 Kemajuan sebagian',
    didntMake: '❌ Tidak ada kemajuan',
    needToAdjust: '🤔 Perlu menyesuaikan pendekatan',
    yesLabel: '✅ Ya',
    aLittle: '😐 Sedikit',
    noLabel: '❌ Tidak',
    madeProgress: 'Membuat kemajuan hari ini',
    didSomething: 'Melakukan sesuatu, tidak semuanya',
    didntWork: 'Tidak mengerjakannya hari ini',
    metWeekly: 'Memenuhi komitmen mingguan',
    didntMake: 'Tidak ada kemajuan',
    needToAdjust: 'Perlu menyesuaikan pendekatan saya',
    learnedLabel: 'Dipelajari: ',
    patternLabel: 'Pola: ',
    nextWeekLabel: 'Minggu depan: ',
    problemTitle: 'Media Sosial Merusak Akuntabilitas',
    problem1: "Kamu takut mengakui ketika sedang berjuang",
    problem2: "Kamu menyembunyikan kegagalan daripada belajar dari situ",
    problem3: "Kamu menghilang dari mitra saat melakukan kesalahan",
    veylIsDifferent: 'Veyl berbeda.',
    popular: 'POPULER',
    sixMonthDeal: 'atau $20 untuk 6 bulan ($3,33/bulan)',
    getStartedPremium: 'Mulai',
    buildTrust: 'Membangun Kepercayaan',
    unveilIdentity: 'Ungkap identitasmu saat (atau jika) kamu siap',
    actuallyAchieve: 'Benar-benar Mencapainya',
    makeRealProgress: 'Buat kemajuan nyata tanpa pertunjukan',
    faq1q: 'Bagaimana jika saya dan mitra tidak cocok?',
    faq1a: 'Rematch mudah. Tidak ada pertanyaan. Kami lebih suka kamu menemukan orang yang tepat daripada memaksakan kemitraan yang tidak berhasil.',
    faq2q: 'Apakah saya harus mengungkap diri pada suatu saat?',
    faq2a: 'Tidak. Beberapa kemitraan tetap anonim selamanya. Beberapa mengungkap setelah seminggu. Sepenuhnya terserah kamu.',
    faq3q: 'Bagaimana jika mitra saya menghilang begitu saja?',
    faq3a: 'Pengguna Premium mendapatkan rematch instan. Pengguna gratis dirematched dalam 48 jam.',
    faq4q: 'Mengapa tidak pernah ada foto profil?',
    faq4a: 'Karena begitu kamu menambahkan foto, semuanya menjadi tentang mengelola persepsi. Kami telah mengujinya. Anonimitas menjaga fokus pada pekerjaan.',
    legalEnglishOnly: 'Dokumen ini hanya tersedia dalam bahasa Inggris. Untuk pertanyaan, hubungi dukungan atau gunakan fitur terjemahan browser Anda.',
    ctaTitle: "Siap benar-benar mencapai tujuanmu?",
    ctaSubtitle: "Bergabunglah dengan Veyl dan temukan mitra akuntabilitas hari ini. Gratis untuk memulai.",
    statAnonymous: "Anonim",
    statLanguages: "Bahasa",
    statToStart: "Untuk mulai",
    authTagline: "Akuntabilitas anonim. Hasil nyata.",
    authPricing: "Gratis untuk memulai · Premium mulai $5/bulan",
    taglineHonest: "Jujur",
    taglineEffective: "Efektif",
    foreverLabel: "/selamanya",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Upgrade ke Premium",
    premiumActiveDesc: "Kamu memiliki akses tak terbatas ke semua fitur Veyl.",
    upgradeDesc: "Hapus semua batasan dan dapatkan pengalaman Veyl penuh.",
    billedMonthly: "Ditagih bulanan",
    bestValue: "NILAI TERBAIK",
    perSixMonths: "$3,33/bulan",
    unlimitedMessages: "Pesan tak terbatas",
    unlimitedVoice: "Catatan suara tak terbatas",
    unlimitedGroup: "Grup tak terbatas",
    unlimitedCommunity: "Komunitas tak terbatas",
    was10day: "dulu 10/hari",
    was5day: "dulu 5/hari",
    was20day: "dulu 20/hari",
    was30day: "dulu 30/hari",
    sixMonthPlan: "Paket 6 Bulan",
    monthlyPlan: "Paket Bulanan",
    modulationFailed: "Modulasi gagal — menggunakan suara asli",
    monthly: "Bulanan",
    sixMonths: "6 Bulan",
    savePercent: "Hemat {{percent}}%",
    pricePerMonth: "${{price}} / bulan",
    priceTotal: "${{price}} total",
    unlimitedMessages: "Pesan tak terbatas",
    unlimitedVoiceNotes: "Catatan suara tak terbatas",
    unlimitedGroupMessages: "Pesan grup tak terbatas",
    unlimitedCommunityMessages: "Pesan komunitas tak terbatas",
    upgrade: "Tingkatkan",
    forUnlimited: "untuk tak terbatas",
    messagesLeftWarning: "{{count}} pesan tersisa hari ini",
    recordVoiceNote: "Rekam catatan suara",
    uploading: "Mengunggah",
    maxDuration: "{{seconds}}d maks",
    upgradeToPremium: "Tingkatkan ke Premium",
    dailyMessageLimitReached: "Anda telah mencapai batas pesan harian Anda.",
    dailyVoiceLimitReached: "Anda telah mencapai batas catatan suara harian Anda.",
    dailyGroupMessageLimitReached: "Anda telah mencapai batas pesan grup harian Anda.",
    dailyGroupVoiceLimitReached: "Anda telah mencapai batas catatan suara grup harian Anda.",
    unlockUnlimited: "Buka akses tak terbatas ke semua fitur.",
    maybeLater: "Mungkin nanti",
    premiumUnlimited: "Tak terbatas",
    premium: "Premium",
    msg: "psn",
    msgs: "psn",
    newMessageNotification: "{{name}} mengirim pesan kepada Anda 💬",
    newGroupMessageNotification: "{{name}} mengirim pesan di grup Anda 👥",
    someone: "seseorang",
    failedToLoad: "Gagal memuat",
    groupMessagesLeftWarning: "{{count}} pesan tersisa hari ini",
    howOldAreYou: 'Berapa umur Anda?',
    minorGroupNote: 'Anda akan dicocokkan dengan pengguna seusia Anda (13–17 tahun).',
    adultGroupNote: 'Anda akan dicocokkan dengan pengguna dewasa lainnya (18+).',
    enterYourAge: 'Masukkan usia Anda',
    getStarted:        'Mulai',
    howItWorks:        'Cara kerjanya',
    statAnonymous:     'Anonim',
    statLanguages:     'Bahasa',
    statToStart:       'Untuk memulai',
    taglineHonest:     'Jujur',
    taglineEffective:  'Efektif',
    landingHero:       'Akuntabilitas tanpa pertunjukan.',
    landingSubtitle:   'Temukan mitra anonim yang berbagi tujuanmu. Tanpa pengikut. Tanpa tekanan — hanya kemajuan yang jujur.',
    problemTitle:      'Akuntabilitas sudah rusak.',
    problem1:          'Media sosial mengubah pengembangan diri menjadi pertunjukan. Kamu memposting tujuan demi likes, bukan kemajuan.',
    problem2:          'Teman dan keluarga membawa penilaian atau ketidakpedulian. Kejujuran sejati menjadi mustahil.',
    problem3:          'Aplikasi akuntabilitas terasa seperti alat pelacak — dasbor steril yang sepenuhnya mengabaikan elemen manusia.',
    veylIsDifferent:   'Veyl berbeda.',
    step1Title:        'Buat profilmu',
    step1Desc:         'Pilih nama samaran, kategori tujuan, dan preferensi komunikasimu. Identitas aslimu tetap milikmu.',
    step2Title:        'Dapatkan kecocokan',
    step2Desc:         'Veyl menemukan mitra yang berbagi jenis tujuan dan kelompok usiamu. Instan — tanpa scroll, tanpa swipe.',
    step3Title:        'Mulai berbicara',
    step3Desc:         'Mengobrol atau kirim catatan suara. Check in harian atau mingguan. Mitramu membuatmu bertanggung jawab — dan kamu juga.',
    buildTrust:        'Membangun kepercayaan',
    unveilIdentity:    'Catat kemenanganmu. Saat kepercayaan ada, kamu bisa memilih untuk mengungkapkan identitasmu — atau tidak.',
    actuallyAchieve:   'Benar-benar mencapai',
    makeRealProgress:  'Kemajuan nyata dengan manusia nyata. Tanpa gamifikasi. Hanya kamu, mitramu, dan tujuanmu.',
    pricingTitle:      'Mulai gratis. Lebih dalam saat kamu siap.',
    freePlan:          'Gratis',
    foreverLabel:      '/ selamanya',
    freeFeature1:      '1 mitra akuntabilitas',
    freeFeature2:      '10 pesan per hari',
    freeFeature3: '10 catatan suara per hari',
    freeFeature5:      'Ruang grup & komunitas',
    popular:           'Paling populer',
    premiumPlan:       'Premium',
    perMonth:          '/ bulan',
    sixMonthDeal: 'Paket 6 bulan seharga $20 — hemat 33%',
    premiumFeature1:   'Pesan tak terbatas',
    premiumFeature2:   'Catatan suara tak terbatas',
    premiumFeature3:   'Fitur pengungkapan mitra',
    premiumFeature4:   'Pencocokan prioritas',
    getStartedPremium: 'Mulai premium',
    faqTitle:          'Pertanyaan umum.',
    faq1q: 'Apakah Veyl benar-benar anonim?',
    faq1a: 'Ya. Kamu mendaftar dengan nama samaran. Tanpa nama asli, tanpa foto, tanpa identifikasi. Mitramu hanya tahu apa yang kamu pilih untuk dibagikan.',
    faq2q: 'Bagaimana cara pencocokan bekerja?',
    faq2a: 'Veyl mencocokkanmu dengan seseorang di kategori tujuan dan kelompok usia yang sama. Biasanya kurang dari dua menit.',
    faq3q: 'Bagaimana jika saya tidak cocok dengan mitra saya?',
    faq3a: 'Kamu bisa melaporkan atau memblokir mitramu kapan saja tanpa pertanyaan. Cocokkan ulang dan temukan seseorang yang lebih baik.',
    faq4q: 'Apakah aman untuk remaja?',
    faq4a: 'Tentu. Pengguna usia 13–17 tahun hanya dicocokkan dengan pengguna lain di kelompok usia yang sama. Ini diterapkan di tingkat sistem.',
    ctaTitle:    'Mitramu sudah menunggu.',
    ctaSubtitle: 'Bergabunglah dengan Veyl secara gratis. Tidak perlu profil sosial. Hanya kamu, tujuanmu, dan seseorang yang mengerti.',
    privacyPolicy:  'Kebijakan Privasi',
    termsOfService: 'Syarat Layanan',
    refundPolicy:   'Kebijakan Pengembalian Dana',
    featuresTitle: "Semua yang kamu butuhkan. Tanpa yang tidak perlu.",
    feature1Title: "Anonimitas penuh",
    feature1Desc: "Kamu memilih nama samaran. Nama asli, foto, dan identitasmu tidak akan pernah dibagikan kecuali kamu memutuskan untuk mengungkapkannya.",
    feature2Title: "Catatan suara",
    feature2Desc: "Terkadang mengetik saja tidak cukup. Rekam dan kirim catatan suara langsung di dalam aplikasi.",
    feature3Title: "Pencocokan aman berdasarkan usia",
    feature3Desc: "Remaja (13–17 tahun) hanya dicocokkan dengan remaja lainnya. Dewasa dengan dewasa. Tanpa pengecualian — sudah ada di sistem.",
    feature4Title: "13 bahasa",
    feature4Desc: "Inggris, Swahili, Prancis, Spanyol, Portugis, Jerman, Italia, Hindi, Indonesia, Mandarin, Jepang, Korea, Hausa.",
    feature5Title: "Check-in harian",
    feature5Desc: "Check-in terstruktur menjaga momentum. Catat progres dan rayakan pencapaian bersama partnermu.",
    feature6Title: "Grup & komunitas",
    feature6Desc: "Bergabunglah dengan obrolan grup berdasarkan tujuan dan ruang komunitas berdasarkan bahasa.",
    goalsEyebrow: "Untuk tujuan nyata",
    goalsTitle: "Apa pun yang sedang kamu kerjakan.",
    goalsSub: "Veyl untuk siapa pun yang punya tujuan nyata dan tidak punya seorang pun untuk bersikap jujur soal itu.",
    goalFitness: "Kebugaran & Kesehatan",
    goalLearning: "Belajar & Keterampilan",
    goalBusiness: "Bisnis & Karier",
    goalCreative: "Proyek Kreatif",
    moreComingSoon: "Kategori lainnya segera hadir",
    safeTitle: "Keamanan bukan sekadar fitur. Itu adalah fondasinya.",
    safe1Title: "Pemisahan usia",
    safe1Desc: "Remaja dan orang dewasa tidak pernah dicampur. Usia diverifikasi saat mendaftar dan dikunci.",
    safe2Title: "Lapor & blokir",
    safe2Desc: "Pengguna mana pun dapat melapor atau memblokir secara instan. Tanpa pertanyaan.",
    safe3Title: "Tidak menjual data",
    safe3Desc: "Tujuan, pesan, dan identitasmu adalah milikmu. Titik.",
    safe4Title: "Hanya nama samaran",
    safe4Desc: "Nama asli tidak pernah diperlukan. Kamu yang mengontrol apakah dan kapan akan mengungkapkan dirimu.",
    refundPolicy: "Kebijakan Pengembalian Dana",
    heroLine1: 'Akuntabilitas',             
    heroLine2: 'tanpa pertunjukan',
    mustBe18: 'Anda harus berusia 18 tahun atau lebih untuk menggunakan Veyl',
    mustBe18Desc: 'Veyl adalah platform untuk pengguna berusia 18 tahun ke atas. Mohon maaf, Anda belum memenuhi syarat usia minimum untuk membuat akun.',
    ageAttestationLabel: 'Saya menegaskan bahwa usia saya 18 tahun atau lebih.',
    ageMisrepresentationNote: 'Memberikan informasi usia yang salah melanggar Ketentuan Layanan kami dan dapat mengakibatkan penghentian akun.',
    feature3Title: 'Terverifikasi khusus 18+',
    feature3Desc: 'Setiap anggota mengonfirmasi usianya 18 tahun atau lebih sebelum bergabung. Tidak ada anak di bawah umur, tanpa pengecualian.',
    faq4q: 'Apakah Veyl tersedia untuk anak di bawah umur?',
    faq4a: 'Tidak. Veyl adalah platform khusus untuk usia 18 tahun ke atas. Setiap pengguna mengonfirmasi usianya saat mendaftar, dan akun yang terbukti memberikan informasi usia palsu dapat dihapus.',
    safe1Title: 'Khusus dewasa',
    safe1Desc: 'Veyl dirancang khusus untuk orang berusia 18 tahun ke atas. Siapa pun di bawah 18 tahun yang mencoba menggunakan Veyl berarti memberikan informasi usia palsu, yang melanggar Ketentuan Layanan kami.',
    ageVerificationDesc: 'Veyl tersedia untuk pengguna berusia 18 tahun ke atas.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Sesuaikan Tujuan Anda',
    adjustGoalDesc: 'Tidak apa-apa untuk mengubah arah. Mitra Anda akan diberitahu.',
    newGoalDescription: 'Deskripsi Tujuan Baru',
    newGoalPlaceholder: 'Apa tujuan baru atau tujuan yang telah disesuaikan?',
    updateGoal: 'Perbarui Tujuan',
    goalUpdated: 'Tujuan berhasil diperbarui! Mitra Anda telah diberi tahu.',
    readyToUnveil: 'Siap untuk Diungkap?',
    unveilDesc: 'Pengungkapan ini menandai selesainya Veyl ini. Pasangan Anda akan diberi tahu. Ini tidak dapat dibatalkan.',
    yourNewAvatar: 'Avatar baru Anda',
    notYet: 'Belum',
    unveiling: 'Pembukaan...',
    sending: 'Mengirim...',
    checkInDesc: 'Pengecekan harian melacak kemajuan. Pengecekan mingguan merupakan refleksi yang lebih mendalam.',
    dismiss: '✕',
    saving: 'Penghematan...',
    saved: '✓ Tersimpan!',
    lightModeDesc: 'Bersih dan terang',
    darkModeDesc: 'Enak dipandang',
    currentNickname: 'Nama panggilan Anda saat ini adalah',
    anonymousWarning: 'Jaga kerahasiaan identitas Anda. Jangan gunakan nama asli Anda.',
    nicknameUpdated: '✓ Nama panggilan telah diperbarui!',
    deleteMyAccount: 'Hapus Akun Saya',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Bertemu Rasa',
    rasaIntroDesc: 'Rasa adalah ruang pribadi untuk merenung — hanya untuk Anda, terpisah dari mitra akuntabilitas Anda. Rasa tidak datang dengan asumsi tentang Anda atau dunia; ia hanya belajar dari apa yang Anda pilih untuk bagikan, dan dirancang untuk mengajukan pertanyaan daripada memberikan jawaban.',
    rasaIntroNotTherapist: 'Rasa bukanlah terapis dan bukan pengganti koneksi manusia yang sebenarnya — termasuk mitra akuntabilitas Anda. Jika sesuatu terasa berat, Rasa akan dengan lembut mengarahkan Anda ke dukungan, bukan mencoba menjadi sumber dukungan itu sendiri.',
    rasaIntroStart: 'Mulai',
    rasaMessagesLeft: 'refleksi yang ditinggalkan hari ini',
    rasaNoMessagesYet: 'Kapan pun Anda siap untuk merenung, mulailah mengetik di bawah ini.',
    rasaThinking: 'Rasa sedang merefleksikan…',
    rasaPrivateNote: 'Hanya untuk Anda — tidak akan pernah terlihat oleh mitra akuntabilitas Anda.',
    rasaPlaceholder: 'Bagikan apa yang ada di pikiranmu…',
    rasaDailyLimitReached: 'Anda telah mencapai batas Rasa hari ini. Batas akan direset besok.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Bertemu Rasa',
    feature7Desc: 'Ruang pribadi untuk merenung — hanya untuk Anda, terpisah dari rekan pendamping Anda.',
    feature8Title: 'Dapatkan dukungan kapan saja.',
    feature8Desc: 'Jawaban cepat untuk pertanyaan navigasi, penagihan, dan akun — langsung di dalam aplikasi.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Obrolan dukungan Veyl',
    supportChatTitle: 'Dukungan Veyl',
    supportChatEmptyState: 'Tanyakan apa pun kepada saya tentang cara kerja Veyl.',
    supportChatPlaceholder: 'Ajukan pertanyaan…',
    supportChatSend: 'Mengirim',
    supportChatTyping: 'Mengetik…',
    supportChatLimitReached: 'Anda telah mencapai batas obrolan dukungan hari ini. Kirim email ke support@veyl.space jika mendesak.',
    supportChatGenericError: 'Terjadi kesalahan. Silakan coba lagi.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Percakapan Anda tidak dapat dimuat.',
    rasaLoadErrorDetail: 'Periksa konsol browser untuk detailnya, atau coba segarkan halaman.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 Anda telah dipasangkan dengan {name}! Silakan kembali ke dasbor Anda.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Instal Aplikasi',
    installMobileOnly: 'Hanya untuk ponsel',
    installTooltip: 'Hanya tersedia di perangkat seluler.',
    installModalTitle: 'Instal Veyl di ponsel Anda',
    installStep1: 'Ketuk ikon Bagikan di bilah alat Safari.',
    installStep2: 'Gulir ke bawah dan ketuk "Tambahkan ke Layar Utama"',
    installStep3: 'Ketuk "Tambah" di pojok kanan atas',
    installGotIt: 'Mengerti',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Hubungan & Koneksi',
    homeLifeOrganization: 'Organisasi Rumah & Kehidupan',
    moneyFinancialHabits: 'Uang & Kebiasaan Keuangan',
    stayingConnected: 'Tetap Terhubung',
    independentLiving: 'Hidup Mandiri',
    techConfidence: 'Kepercayaan Diri Teknologi',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Hubungan & Koneksi',
    goalHomeLife: 'Organisasi Rumah & Kehidupan',
    goalMoney: 'Uang & Kebiasaan Keuangan',
    goalStayingConnected: 'Tetap Terhubung',
    goalIndependentLiving: 'Hidup Mandiri',
    goalTechConfidence: 'Kepercayaan Diri Teknologi',
    // [auto-synced 2026-10-28]
    resources: 'Sumber daya',
    resourcesTitle: 'Sumber daya',
    resourcesWriteUps: 'Tulisan',
    resourcesLinks: 'Bacaan lebih lanjut',
    resourcesOpensNewTab: 'Terbuka di tab baru',
    resourcesEmptyTitle: 'Belum ada apa-apa di sini',
    resourcesEmptyBody: 'Kami masih mengumpulkan sumber daya untuk kategori ini. Silakan periksa kembali dalam waktu singkat.',
    resourcesNoMatchBody: 'Kami belum menemukan sumber daya untuk tujuan ini.',
    resourcesDisclaimer: 'Informasi umum saja, bukan nasihat profesional. Jika sesuatu memengaruhi kesehatan, keselamatan, atau keuangan Anda, seorang profesional yang berkualifikasi dapat membantu mengatasi situasi Anda.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Artikel',
    resourcesMoreToRead: 'Baca selengkapnya',
    res_intro_fitnessHealth: 'Tujuan kebugaran dan kesehatan cenderung dicapai dalam momen-momen kecil dan biasa, bukan momen-momen besar. Artikel-artikel ini hadir untuk mengurangi tekanan, dan tautan-tautan yang diberikan mengarah ke sumber-sumber yang ahli dalam detailnya.',
    res_fitness_showing_up_title: 'Menunjukkan diri lebih baik daripada pamer.',
    res_fitness_showing_up_p1: 'Sebagian besar dari kita memiliki gambaran tentang seperti apa olahraga yang "benar": pusat kebugaran, sepatu lari, dan keringat. Ketika kehidupan tidak sesuai dengan gambaran itu, mudah untuk memutuskan bahwa semua itu bukanlah untuk kita.',
    res_fitness_showing_up_p2: 'Organisasi Kesehatan Dunia (WHO) memiliki pandangan yang jauh lebih luas. Mereka menghitung pergerakan selama waktu luang, berpindah dari satu tempat ke tempat lain, dan aktivitas di tempat kerja atau di sekitar rumah. Berjalan kaki, bersepeda, olahraga, dan bermain semuanya dihitung, pada tingkat keterampilan apa pun. Pedoman mereka menekankan bahwa aktivitas apa pun lebih baik daripada tidak melakukan aktivitas sama sekali.',
    res_fitness_showing_up_p3: 'Hal itu penting ketika Anda membangun kebiasaan bersama pasangan. Jalan kaki singkat yang benar-benar Anda lakukan lebih berharga daripada sesi berat yang Anda rencanakan dan kemudian Anda lewatkan. Pengecekan yang mengatakan "Saya hanya berhasil sepuluh menit" tetaplah sebuah pengecekan yang menjaga momentum tetap berjalan.',
    res_fitness_showing_up_p4: 'Memisahkan apa yang Anda lakukan dari bagaimana perasaan Anda juga sangat membantu. Terkadang, kebiasaan adalah kunci keberhasilan. Intensitas bisa datang kemudian, setelah kehadiran tidak lagi menjadi sebuah negosiasi.',
    res_fitness_showing_up_p5: 'Jika Anda memiliki kondisi kesehatan tertentu, sedang hamil, atau sudah lama tidak aktif berolahraga, ada baiknya berkonsultasi singkat dengan dokter atau tenaga kesehatan profesional lainnya sebelum mengubah intensitas latihan Anda.',
    res_fitness_rest_title: 'Istirahat adalah bagian dari rencana.',
    res_fitness_rest_p1: 'Ketika orang berbicara tentang tujuan kebugaran, tidur dan istirahat biasanya dianggap sebagai hal yang tersisa setelah pekerjaan utama selesai. Padahal, dalam praktiknya, keduanya merupakan bagian penting yang menentukan keberhasilan atau kegagalan hasil latihan tersebut.',
    res_fitness_rest_p2: 'Tidur dan aktivitas saling berkaitan. NHS mencatat bahwa aktivitas teratur dapat membantu Anda tidur lebih nyenyak, dan beberapa orang merasa berolahraga menjelang waktu tidur justru mengganggu, sehingga berolahraga di pagi hari mungkin lebih cocok untuk mereka. Ini bukan aturan baku. Ini hanyalah pengingat bahwa Anda sendirilah yang berhak menemukan apa yang cocok untuk tubuh Anda.',
    res_fitness_rest_p3: 'Istirahat juga perlu direncanakan ketika Anda saling bertanggung jawab. Jika setiap pertemuan menjadi laporan tentang seberapa keras Anda bekerja, hari yang tenang mulai terasa seperti kegagalan. Hari libur yang Anda pilih dengan sengaja berbeda dengan menjauh dari tujuan, dan tidak apa-apa untuk mengatakannya dengan lantang.',
    res_fitness_rest_p4: 'Jika tidur menjadi masalah serius dalam jangka waktu lama, atau Anda merasa lelah tanpa alasan yang jelas, sebaiknya bicarakan hal itu dengan dokter atau tenaga kesehatan profesional lainnya. Ini bukan sesuatu yang bisa Anda hadapi sendirian.',
    res_fitness_food_title: 'Makanan tanpa ribet',
    res_fitness_food_p1: 'Saran tentang makanan seringkali ramai diperbincangkan dan saling bertentangan, jadi ada baiknya mengetahui bahwa lembaga kesehatan masyarakat besar lebih longgar dalam hal ini dibandingkan sebagian besar informasi di internet.',
    res_fitness_food_p2: 'WHO menyatakan bahwa pola makan sehat hadir dalam berbagai bentuk. Apa yang dianggap sebagai cara makan yang masuk akal bergantung pada usia, gaya hidup, budaya, dan makanan yang benar-benar dapat Anda peroleh di tempat Anda tinggal. WHO menjelaskan empat gagasan yang mendasari setiap pola makan sehat: mendapatkan cukup nutrisi yang dibutuhkan tubuh, menjaga keseimbangan, menikmati beberapa makanan dalam jumlah sedang, dan mengonsumsi berbagai macam makanan. Pola makan yang sebagian besar tidak diolah dan bervariasi adalah dasar yang ditekankan oleh WHO.',
    res_fitness_food_p3: 'Untuk tujuan yang Anda kejar bersama orang lain, itu adalah kerangka kerja yang berguna. Anda tidak perlu meniru cara makan pasangan Anda, dan mereka juga tidak perlu meniru cara makan Anda. Tujuan terkait makanan bisa sesederhana "lebih sering memasak di rumah" atau "makan sesuatu yang berbeda dari biasanya minggu ini", apa pun yang sesuai dengan kehidupan dan anggaran Anda.',
    res_fitness_food_p4: 'Jika Anda sedang mempertimbangkan perubahan besar pada pola makan Anda, atau Anda memiliki kondisi kesehatan, alergi, atau pengobatan yang dipengaruhi oleh makanan, dokter atau ahli gizi terdaftar dapat memberikan saran yang sesuai untuk Anda. Tulisan umum saja tidak bisa.',
    res_fitness_who_physical_activity_note: 'Global. Gambaran umum yang sederhana tentang apa yang dianggap sebagai aktivitas, siapa yang mendapat manfaat, dan mengapa.',
    res_fitness_who_guidelines_note: 'Global. Pedoman lengkap, dengan rekomendasi untuk berbagai usia dan untuk orang yang hidup dengan kondisi kronis atau disabilitas.',
    res_fitness_who_healthy_diet_note: 'Global. Menjelaskan prinsip-prinsip di balik diet sehat dan mengapa hal itu berbeda-beda menurut budaya dan makanan lokal.',
    res_fitness_nhs_sleep_note: 'Inggris. Saran praktis tentang tidur. Penyebutan dokter umum atau apoteker merujuk pada layanan di Inggris.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Dapatkan pemberitahuan saat Veyl tutup',
    pushPromptBody: 'Kami akan memberi tahu Anda saat Anda mendapatkan pasangan atau pasangan Anda mengirim pesan kepada Anda. Notifikasi tidak pernah menyertakan isi pesan.',
    pushEnable: 'Aktifkan notifikasi',
    pushNotNow: 'Tidak sekarang',
    pushError: 'Terjadi kesalahan saat mengaktifkan notifikasi. Silakan coba lagi.',
    pushBlockedTitle: 'Notifikasi diblokir',
    pushBlockedBody: 'Browser Anda memblokir notifikasi dari Veyl. Untuk mengaktifkannya, buka pengaturan situs browser Anda untuk veyl.space, izinkan notifikasi, lalu muat ulang halaman.',
    pushIosTitle: 'Dapatkan notifikasi di iPhone',
    pushIosBody: 'Tambahkan Veyl ke Layar Utama Anda terlebih dahulu: ketuk Bagikan, lalu Tambahkan ke Layar Utama, kemudian buka Veyl dari sana dan aktifkan notifikasi.',
    pushSettingsTitle: 'Notifikasi pada perangkat ini',
    pushSettingsDesc: 'Dapatkan notifikasi saat Anda mendapatkan kecocokan atau pasangan Anda mengirim pesan, bahkan saat Veyl sedang ditutup. Notifikasi tidak pernah menyertakan isi pesan. Pengaturan ini hanya berlaku untuk perangkat ini.',
    pushSettingsUnsupported: 'Notifikasi tidak tersedia di browser ini. Di iPhone atau iPad, tambahkan Veyl ke Layar Utama Anda terlebih dahulu (Bagikan, lalu Tambahkan ke Layar Utama), kemudian buka dari sana.',
    pushSettingsBlocked: 'Notifikasi untuk Veyl diblokir di peramban Anda. Untuk mengaktifkannya, buka pengaturan situs peramban Anda untuk veyl.space, izinkan notifikasi, lalu muat ulang halaman.',
    pushSettingsWorking: 'Bekerja…',
    pushSettingsOn: 'Notifikasi diaktifkan untuk perangkat ini.',
    pushSettingsTurnOff: 'Matikan notifikasi',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Mempelajari sesuatu yang baru sebagian besar bergantung pada seberapa sering Anda hadir agar pengetahuan itu melekat. Tulisan-tulisan ini membahas tentang strategi jangka panjang, dan tautan-tautan tersebut adalah tempat gratis untuk mempelajari hampir apa pun.',
    res_learning_small_repeat_title: 'Cukup kecil untuk diulang',
    res_learning_small_repeat_p1: 'Sebagian besar tujuan pembelajaran gagal karena terlalu besar, bukan karena terlalu sulit. "Belajar coding" atau "menjadi fasih berbahasa Portugis" adalah sebuah tujuan akhir, bukan sesuatu yang bisa Anda lakukan pada Selasa malam.',
    res_learning_small_repeat_p2: 'Yang bisa Anda lakukan pada Selasa malam adalah duduk selama dua puluh menit untuk mempelajari satu pelajaran. Itu adalah tugas yang bisa Anda ulangi, dan pengulangan itulah yang membangun pembelajaran. Keterampilan cenderung datang secara perlahan, sedikit demi sedikit, sampai suatu hari Anda menyadari bahwa Anda dapat melakukan sesuatu yang sebelumnya tidak bisa Anda lakukan.',
    res_learning_small_repeat_p3: 'Di sinilah peran seorang rekan akuntabilitas lebih membantu daripada sekadar motivasi. Motivasi datang dan pergi. Rekan yang mengharapkan kabar tentang bagaimana hasilnya membuat lebih sulit untuk diam-diam meninggalkan kebiasaan tersebut dan lebih mudah untuk memulai kembali setelah minggu yang buruk.',
    res_learning_small_repeat_p4: 'Pengecekan yang baik tidak harus mengesankan. "Saya mengerjakan satu pelajaran dan memahami sekitar setengahnya" adalah pernyataan yang jujur, dan itu menjaga kebiasaan tetap hidup. Anda dapat meningkatkan ukuran tugas nanti. Jauh lebih sulit untuk membangun kembali kebiasaan yang telah terhenti.',
    res_learning_beginner_title: 'Menjadi pemula diperbolehkan.',
    res_learning_beginner_p1: 'Memulai sesuatu yang baru berarti harus mahir, setidaknya di depan satu orang. Bagi banyak orang dewasa, itulah hambatan sebenarnya, lebih besar daripada waktu atau uang.',
    res_learning_beginner_p2: 'Mungkin bermanfaat untuk mengetahui bagaimana pembelajaran terbuka telah berkembang. MIT OpenCourseWare menerbitkan materi dari ribuan kursus MIT secara gratis, tanpa registrasi. OpenLearn dari Open University menawarkan hampir seribu kursus singkat gratis, dan menyatakan tidak ada persyaratan untuk mengaksesnya. Anda tidak memerlukan izin siapa pun untuk mencoba suatu subjek, atau untuk mengetahui bahwa subjek tersebut tidak cocok untuk Anda.',
    res_learning_beginner_p3: 'Mencoba sesuatu dan kemudian memutuskan bahwa itu bukan untuk Anda juga termasuk dalam proses belajar. Mencoba beberapa hal sebelum berkomitmen pada satu hal adalah cara yang sangat baik untuk memulai.',
    res_learning_beginner_p4: 'Saat Anda merasa tertinggal, ingatlah bahwa pasangan Anda mungkin merasakan hal yang sama tentang tujuan mereka sendiri. Anda tidak sedang bersaing. Kalian berdua berada di awal sesuatu, di tempat yang berbeda.',
    res_learning_choose_one_title: 'Pilih satu hal, lalu teruslah memilih hal itu.',
    res_learning_choose_one_p1: 'Pembelajaran gratis memiliki masalah yang aneh: jumlahnya terlalu banyak. OpenCourseWare saja mencakup lebih dari 2.500 kursus, dan OpenLearn memiliki hampir seribu. Sangat mudah untuk menghabiskan sepanjang malam menjelajahinya dan menyebutnya sebagai pembelajaran.',
    res_learning_choose_one_p2: 'Akan lebih mudah jika Anda memilih satu kursus, satu buku, atau satu rangkaian pelajaran, dan menganggap yang lainnya sebagai "untuk nanti". Menyimpan yang lain dalam catatan juga tidak masalah. Tujuannya adalah menyelesaikan satu hal sebelum memulai yang berikutnya. Memberitahu pasangan Anda mana yang telah Anda pilih adalah komitmen kecil yang akan memudahkan Anda untuk tetap berpegang pada rencana.',
    res_learning_choose_one_p3: 'Ada baiknya juga memeriksa apa yang diberikan dan tidak diberikan oleh suatu sumber daya. Kursus OpenLearn, misalnya, dilengkapi dengan pernyataan partisipasi, dan beberapa dengan lencana digital yang bukan merupakan kualifikasi terakreditasi. Jika Anda membutuhkan kualifikasi formal untuk pekerjaan atau studi, ada baiknya mengetahuinya sejak awal, dan institusi yang Anda tuju dapat memberi tahu Anda apa yang mereka terima.',
    res_learning_mit_ocw_note: 'Global. Catatan kuliah, ujian, dan video gratis dari ribuan kursus MIT, tanpa registrasi. Dalam bahasa Inggris.',
    res_learning_khan_academy_note: 'Global. Sebuah organisasi nirlaba yang menawarkan pelajaran dan latihan gratis, terkuat di bidang matematika dan sains, dalam berbagai bahasa.',
    res_learning_openlearn_note: 'Berbasis di Inggris, terbuka untuk siapa saja. Hampir 1.000 kursus singkat gratis, mulai dari sekitar 1 hingga 24 jam, masing-masing dengan pernyataan partisipasi gratis.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Tujuan kerja itu jangka panjang, dan sebagian besar upaya dilakukan pada hari-hari di antara setiap pencapaian. Artikel-artikel ini membahas tentang menjaga kecepatan yang stabil, dan tautan-tautan tersebut adalah tempat gratis untuk membangun keterampilan dan merencanakan langkah Anda selanjutnya.',
    res_business_progress_title: 'Kemajuan di tempat kerja jarang sekali berupa garis lurus.',
    res_business_progress_p1: 'Tujuan karier dan bisnis seringkali membutuhkan waktu yang lama. Promosi, perubahan karier, atau pelanggan pertama bisa memakan waktu berbulan-bulan, dan hari-hari di antaranya jarang terasa seperti kemajuan.',
    res_business_progress_p2: 'Akan sangat membantu jika Anda memisahkan hasil yang Anda inginkan dari hal-hal yang sebenarnya dapat Anda lakukan minggu ini. Anda tidak dapat mengontrol apakah sebuah perusahaan akan mempekerjakan Anda, atau apakah pelanggan akan mengatakan ya. Anda dapat mengontrol berapa banyak percakapan yang Anda lakukan, berapa banyak waktu yang Anda berikan untuk proyek tersebut, dan apakah Anda menindaklanjuti hal yang telah Anda janjikan.',
    res_business_progress_p3: 'Di situlah peran seorang mitra akuntabilitas menjadi penting. Mereka tidak perlu memahami industri Anda. Mereka hanya perlu bertanya apa yang Anda lakukan, dan mendengarkan jawabannya tanpa menjadikannya sebuah pertunjukan.',
    res_business_progress_p4: 'Terkadang, laporan jujur yang disampaikan adalah "tidak banyak yang terjadi". Penting untuk mengatakannya dengan lantang, karena tujuan yang terbengkalai selama sebulan jauh lebih sulit untuk dihidupkan kembali daripada tujuan yang terus dipertahankan secara perlahan.',
    res_business_start_from_you_title: 'Mulailah dari diri Anda, bukan dari pekerjaan.',
    res_business_start_from_you_p1: 'Ketika orang merasa terjebak di tempat kerja, naluri mereka seringkali adalah memulai dengan pasar kerja: lowongan apa yang tersedia, pekerjaan apa yang bergaji tinggi, dan pekerjaan apa yang terlihat mengesankan. Padahal, akan lebih bermanfaat jika memulai dari tempat lain.',
    res_business_start_from_you_p2: 'Kursus gratis OpenLearn, Sukses di Tempat Kerja, dibangun di atas gagasan tersebut. Kursus ini dimulai dengan pandangan bahwa mengenal diri sendiri dan nilai-nilai yang Anda junjung adalah fondasi perencanaan karier, dan baru kemudian membahas CV, lamaran, dan wawancara.',
    res_business_start_from_you_p3: 'Sederhananya: seperti apa yang Anda inginkan agar hari-hari Anda terasa? Apa keahlian Anda yang jarang dihargai? Apa yang tidak akan Anda tukar dengan apa pun, baik itu waktu bersama keluarga, penghasilan tetap, atau ruang untuk berkreasi?',
    res_business_start_from_you_p4: 'Anda tidak perlu menjawab semua itu sendirian. Berdiskusi dengan pasangan sering kali memunculkan hal-hal yang mungkin Anda abaikan jika sendirian, dan itu dapat mengubah ungkapan samar "Saya ingin sesuatu yang berbeda" menjadi tujuan yang benar-benar dapat Anda kerjakan.',
    res_business_wear_out_title: 'Bekerja keras tanpa membuat diri Anda kelelahan.',
    res_business_wear_out_p1: 'Ambisi dan kelelahan bisa tampak serupa dari dalam, terutama ketika suatu tujuan sangat berarti bagi Anda.',
    res_business_wear_out_p2: 'Organisasi Kesehatan Dunia (WHO) mencatat bahwa pekerjaan dapat melindungi kesehatan mental, dan juga dapat berkontribusi pada bahaya. Pedoman WHO tentang kesehatan mental di tempat kerja menunjukkan risiko seperti beban kerja yang berat dan perilaku negatif di tempat kerja, dan mereka mengatakan bahwa tanggung jawab untuk tempat kerja yang sehat berada di pundak pengusaha dan pemerintah, bukan hanya pekerja individu.',
    res_business_wear_out_p3: 'Jika Anda berdiskusi dengan pasangan tentang pencapaian besar di tempat kerja, ada baiknya bertanya tidak hanya "apakah Anda berhasil menyelesaikannya?" tetapi juga "bagaimana keadaan Anda?" Sebuah tujuan yang dikejar dengan mengorbankan tidur, kesehatan, atau hubungan Anda perlu dipertimbangkan kembali, meskipun secara teoritis berjalan lancar.',
    res_business_wear_out_p4: 'Jika pekerjaan memengaruhi kesehatan Anda, atau Anda merasa terus-menerus murung, cemas, atau kelelahan, silakan berkonsultasi dengan dokter atau tenaga kesehatan profesional lainnya yang berkualifikasi. Jika Anda tidak yakin tentang hak-hak Anda di tempat kerja, sumber lokal yang terpercaya, seperti otoritas ketenagakerjaan atau organisasi pekerja, dapat menjelaskannya di tempat Anda tinggal. Aturan sangat berbeda antar negara.',
    res_business_who_mh_work_note: 'Bersifat global. Ditulis terutama untuk pemberi kerja dan pemerintah, sehingga bersifat teknis. Ringkasan eksekutif tersedia dalam bahasa Arab, Mandarin, Inggris, Prancis, Rusia, dan Spanyol.',
    res_business_openlearn_entrepreneurship_note: 'Kursus berbasis di Inggris. 24 jam dalam 8 sesi, dan Anda dapat mulai tanpa mendaftar. Sebagian materi membahas peraturan bisnis Inggris, jadi periksa apa yang berlaku di negara Anda.',
    res_business_openlearn_succeed_note: 'Sekitar 8 minggu dengan durasi sekitar 3 jam per minggu, mencakup perencanaan karier, CV, dan wawancara. Terakhir diperbarui pada tahun 2021, jadi beberapa bagian tentang pencarian kerja dan media sosial mungkin terasa ketinggalan zaman.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Zona waktu',
    timezoneCurrentIs: 'Zona waktu Anda saat ini adalah',
    timezoneLockNote: 'Batas pesan dan catatan suara harian Anda akan direset pada tengah malam di zona waktu Anda. Agar adil, Anda hanya dapat mengubah zona waktu pada hari ketika Anda belum menggunakan pesan atau catatan suara apa pun, dan hanya sekali setiap 7 hari.',
    timezoneNew: 'Pilih zona waktu',
    saveTimezone: 'Simpan zona waktu',
    timezoneUpdated: 'Zona waktu diperbarui',
    timezoneInvalid: 'Zona waktu tersebut tidak valid. Silakan pilih salah satu dari daftar.',
    timezoneChangeError: 'Zona waktu Anda tidak dapat diubah. Silakan coba lagi.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Proyek-proyek kreatif cenderung muncul di sela-sela kesibukan lainnya. Tulisan-tulisan ini membahas tentang menjaga agar sesuatu tetap hidup di tengah perjalanan yang panjang, dan tautannya mencakup pembelajaran menulis serta penggunaan dan berbagi karya kreatif.',
    res_creative_finishing_title: 'Penyelesaian akhir juga merupakan sebuah keterampilan.',
    res_creative_finishing_p1: 'Memulai proyek kreatif adalah bagian yang mudah. Idenya masih segar dan segalanya terasa mungkin. Bagian tersulit datang di tengah jalan, ketika ide tersebut telah berubah menjadi pekerjaan nyata dan prosesnya lebih lambat dan berantakan daripada saat membayangkannya.',
    res_creative_finishing_p2: 'Biasanya di situlah proyek terhenti, dan jarang sekali karena orang tersebut kurang berbakat. Lebih sering karena di tengah proses tidak ada garis finish yang bisa dinantikan dan tidak ada yang memperhatikan.',
    res_creative_finishing_p3: 'Di sinilah peran pasangan yang sekadar bertanya "apa yang kamu buat minggu ini?" dapat membuat perbedaan nyata. Anda tidak perlu mereka untuk menilainya. Mengetahui bahwa Anda akan mendeskripsikan minggu Anda memberi karya tersebut tenggat waktu kecil, dan tenggat waktu kecil seringkali cukup untuk membuat Anda kembali ke meja, kanvas, atau instrumen musik.',
    res_creative_finishing_p4: 'Hal ini juga membantu untuk menentukan apa arti "selesai" untuk hal yang ada di hadapan Anda. Versi kasar yang sudah selesai lebih berarti daripada versi sempurna yang hanya ada di kepala Anda. Anda selalu dapat memperbaikinya setelah selesai dibuat.',
    res_creative_rough_drafts_title: 'Tidak ada yang perlu melihat versi pertama.',
    res_creative_rough_drafts_p1: 'Banyak orang kreatif diam-diam berhenti karena percobaan pertama tidak sebagus gambaran dalam pikiran mereka. Kesenjangan antara apa yang Anda bayangkan dan apa yang dapat Anda buat saat ini adalah hal yang normal. Seringkali kesenjangan itu paling besar ketika Anda paling peduli.',
    res_creative_rough_drafts_p2: 'Menunjukkan draf kasar kepada satu orang yang dipercaya dapat mengurangi beban. Memberitahu pasangan, "Ini draf yang berantakan, tapi inilah yang coba saya lakukan," mengubahnya menjadi percakapan, bukan penilaian. Anda mungkin mendapati mereka lebih peduli apakah Anda terus melanjutkan daripada apakah hasilnya bagus.',
    res_creative_rough_drafts_p3: 'Jika Anda seorang pemula dalam suatu bidang keahlian, ada cara-cara mudah untuk memulainya. OpenLearn, situs pembelajaran gratis dari Open University, memiliki kursus pengantar tentang menulis fiksi yang ditujukan untuk orang-orang yang baru memulai. Ini hanyalah salah satu contoh di antara banyak contoh lainnya, dan lebih cocok untuk penulis daripada jenis pembuat karya lainnya.',
    res_creative_rough_drafts_p4: 'Kemajuan dalam karya kreatif jarang terlihat seperti peningkatan yang stabil. Beberapa minggu Anda membuat sesuatu yang Anda banggakan, dan beberapa minggu Anda membuat sesuatu yang tidak akan pernah Anda tunjukkan kepada siapa pun. Keduanya penting, dan keduanya merupakan bagian dari kebiasaan yang sama.',
    res_creative_using_sharing_title: 'Menggunakan karya orang lain, dan membagikan karya Anda sendiri',
    res_creative_using_sharing_p1: 'Proyek kreatif sering kali melibatkan materi orang lain, seperti gambar, suara, atau teks, dan pada akhirnya Anda mungkin ingin berbagi materi Anda sendiri. Sedikit latar belakang akan membantu dalam kedua hal tersebut.',
    res_creative_using_sharing_p2: 'Creative Commons adalah organisasi nirlaba yang menerbitkan lisensi yang memungkinkan pencipta untuk mempertahankan hak cipta mereka sambil mengizinkan orang lain untuk menggunakan karya mereka dengan cara yang dipilih oleh pencipta. Jika Anda ingin membagikan sesuatu yang telah Anda buat, panduannya menjelaskan cara kerja lisensi tersebut.',
    res_creative_using_sharing_p3: 'Beberapa institusi melangkah lebih jauh. Smithsonian telah merilis jutaan gambar dan data di bawah lisensi yang disebut CC0, yang berarti Anda dapat menggunakannya tanpa meminta izin dari Smithsonian, termasuk untuk proyek kreatif. Namun, FAQ mereka sendiri menunjukkan bahwa CC0 hanya mencakup hak cipta. Hak-hak lain, seperti privasi atau merek dagang, mungkin masih berlaku, dan beberapa item dalam koleksi mereka sama sekali tidak termasuk.',
    res_creative_using_sharing_p4: 'Aturan hak cipta berbeda antar negara, dan ini adalah informasi umum, bukan nasihat hukum. Jika suatu proyek penting secara komersial, atau Anda tidak yakin apakah Anda dapat menggunakan sesuatu, seorang profesional yang berkualifikasi dapat memberi tahu Anda posisi Anda.',
    res_creative_openlearn_fiction_note: 'Berbasis di Inggris, gratis untuk memulai. Kursus pengantar tentang menulis fiksi, dengan pernyataan partisipasi gratis. Lebih cocok untuk penulis daripada jenis pembuat konten lainnya.',
    res_creative_cc_license_note: 'Global. Cara mengizinkan orang lain menggunakan karya Anda dengan ketentuan yang Anda pilih sambil tetap mempertahankan hak cipta Anda. Informasi umum, bukan nasihat hukum.',
    res_creative_smithsonian_open_access_note: 'Lembaga AS, bebas digunakan oleh siapa saja. Menjelaskan gambar dan data yang dirilis sebagai CC0, apa yang diperbolehkan dan tidak diperbolehkan, serta item mana yang dikecualikan.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Hubungan lebih banyak dibangun dari hal-hal kecil yang berulang daripada dari momen-momen besar. Tulisan-tulisan ini membahas tentang menjaga agar hubungan tetap hidup, apa yang menurut penelitian paling penting, dan apa yang harus dilakukan ketika hubungan sulit terjalin atau tidak aman.',
    res_relationships_small_gestures_title: 'Sikap kecil pun berarti.',
    res_relationships_small_gestures_p1: 'Banyak dari kita memperlakukan persahabatan dan ikatan keluarga sebagai sesuatu yang ada atau tidak ada. Robert Waldinger, yang memimpin Studi Perkembangan Dewasa Harvard, menggambarkan kehidupan sosial sebagai sistem hidup yang membutuhkan pemeliharaan, seperti halnya kebugaran fisik.',
    res_relationships_small_gestures_p2: 'Perawatan yang dibutuhkan bisa sangat sederhana. Pikirkan seseorang yang Anda rindukan dan kirimkan pesan kepada mereka. Daftar langkah-langkah sehari-hari dari Organisasi Kesehatan Dunia juga sama sederhananya: menghubungi teman, menyimpan ponsel agar benar-benar hadir dalam percakapan, menyapa tetangga, bergabung dengan kelompok lokal, atau menjadi sukarelawan.',
    res_relationships_small_gestures_p3: 'Untuk tujuan yang Anda bagi bersama mitra akuntabilitas, ini bisa menjadi pertanyaan mingguan yang bagus: kepada siapa Anda menghubungi? Pertanyaan ini konkret, kecil, dan Anda dapat menjawabnya dengan jujur bahkan di minggu yang sulit.',
    res_relationships_small_gestures_p4: 'Tidak setiap pesan mendapat balasan hangat, dan itu adalah bagian dari prosesnya. Waldinger mengatakan orang sering terkejut dengan betapa hangatnya pesan-pesan kecil seperti ini diterima.',
    res_relationships_quality_title: 'Kualitas lebih penting daripada kuantitas.',
    res_relationships_quality_p1: 'Sangat mudah mengukur kehidupan sosial dengan menghitung jumlah orang yang terlibat: berapa banyak teman, berapa banyak acara yang diikuti, apakah Anda sedang menjalin hubungan. Namun, penelitian menunjukkan hal lain.',
    res_relationships_quality_p2: 'Studi Harvard tentang Perkembangan Dewasa telah mengikuti orang-orang sejak tahun 1938. Ketika para peneliti meninjau kembali kehidupan peserta di usia paruh baya, kepuasan dalam hubungan mereka, khususnya pernikahan, memprediksi siapa yang akan bahagia dan sehat di usia 80 tahun lebih baik daripada hal-hal seperti kolesterol atau tekanan darah. Direkturnya mengatakan bahwa kelompok penelitian lain sejak itu menemukan hal yang sama. Dia juga mengatakan bahwa tidak ada jumlah koneksi yang pasti yang Anda butuhkan, dan bahwa orang yang pemalu mungkin membutuhkan lebih sedikit koneksi daripada orang ekstrovert.',
    res_relationships_quality_p3: 'Satu hal yang perlu diperhatikan: peserta pertama studi ini adalah mahasiswa Harvard dan orang dewasa muda dari satu kota di Amerika, jadi ini bukanlah gambaran dari semua orang. Kesimpulan yang dihasilkan sebaiknya diterima dengan tidak sepenuhnya mutlak.',
    res_relationships_quality_p4: 'Yang tersirat, secara halus, adalah bahwa setidaknya satu hubungan yang solid, seseorang yang dapat Anda hubungi jika Anda sakit atau takut, lebih penting daripada lingkaran pertemanan yang besar. Dan jarang sekali sudah terlambat. Direktur penelitian ini menggambarkan orang-orang yang menemukan persahabatan dekat atau cinta di usia senja ketika mereka tidak mengharapkannya.',
    res_relationships_hard_times_title: 'Saat koneksi sulit terjalin, dan saat sebuah hubungan menyakitkan.',
    res_relationships_hard_times_p1: 'Merasa kesepian bukan berarti ada yang salah dengan Anda. Organisasi Kesehatan Dunia memperkirakan bahwa sekitar satu dari enam orang di seluruh dunia mengalami kesepian, di setiap usia. Organisasi tersebut mendefinisikan kesepian sebagai perasaan menyakitkan yang muncul ketika hubungan yang Anda miliki tidak sesuai dengan hubungan yang Anda inginkan.',
    res_relationships_hard_times_p2: 'Penyebabnya bisa meliputi kesehatan yang buruk, pendapatan rendah, hidup sendirian, atau cara kita menggunakan teknologi. WHO mencatat bahwa jika masalahnya lebih serius, mencari tahu dukungan dan layanan apa yang tersedia sangatlah penting.',
    res_relationships_hard_times_p3: 'Ada sisi lain: hubungan yang menyakitkan. Perilaku berbahaya dalam suatu kemitraan meliputi pelecehan psikologis dan perilaku mengontrol, serta kekerasan fisik atau seksual.',
    res_relationships_hard_times_p4: 'Jika Anda takut pada seseorang yang dekat dengan Anda, atau Anda sedang disakiti, silakan hubungi nomor darurat setempat atau layanan bantuan atau dukungan setempat. Nomor yang tepat bergantung pada negara Anda, dan mitra Veyl adalah rekan sebaya, bukan konselor terlatih. Jika Anda merasa masalah terlalu berat untuk ditanggung, dokter atau konselor dapat membantu.',
    res_relationships_who_social_connection_note: 'Global. Ringkasan singkat dan bebas jargon dari laporan WHO tahun 2025 tentang kesepian dan koneksi sosial (13 halaman).',
    res_relationships_harvard_gazette_note: 'Sumber dari AS. Tanya Jawab dengan direktur Studi Perkembangan Dewasa Harvard tentang apa yang dikatakan penelitian tentang hubungan dan kesehatan, termasuk langkah-langkah kecil sehari-hari. Ini adalah wawancara, dan peserta awal studi ini berasal dari satu kota di Amerika.',
    res_relationships_who_violence_note: 'Global. Menjelaskan apa saja yang termasuk dalam kekerasan dalam rumah tangga dan seberapa umum hal itu terjadi, sebagian besar menimpa perempuan. Ini adalah informasi, bukan layanan bantuan, dan mungkin sulit dibaca.',
  },

  zh: {
    appName: 'Veyl',
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    back: '返回',
    continue: '继续',
    done: '完成',
    error: '错误',
    submit: '提交',
    send: '发送',
    delete: '删除',
    leave: '离开',
    stay: '留下',
    yes: '是',
    no: '否',
    upgrade: '升级到高级版',
    signIn: '登录',
    signUp: '注册',
    signOut: '退出登录',
    email: '电子邮件',
    password: '密码',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    resetPasswordSent: '密码重置邮件已发送。请检查您的收件箱。',
    noAccount: '没有账户？',
    hasAccount: '已有账户？',
    authError: '认证错误。请重试。',
    landingHero: '真正有效的责任感',
    landingSubtitle: '找到一个分享您目标的匿名伙伴。没有社交压力。只有结果。',
    getStarted: '开始 — 免费',
    howItWorks: '如何运作',
    step1Title: '设定您的目标',
    step1Desc: '告诉我们您在努力实现什么。我们将把您与相似旅程中的人配对。',
    step2Title: '认识您的伙伴',
    step2Desc: '与您所在时区的匿名问责伙伴配对。',
    step3Title: '保持负责任',
    step3Desc: '每日打卡，分享进展，互相支持 — 匿名进行。',
    pricingTitle: '简单定价',
    freePlan: '免费',
    premiumPlan: '高级版',
    perMonth: '/月',
    freeFeature1: '1个活跃Veyl',
    freeFeature2: '每天10条消息',
    freeFeature3: '每天10条语音留言',
    freeFeature4: '每日和每周打卡',
    freeFeature5: '群聊访问',
    premiumFeature1: '最多3个活跃Veyl',
    premiumFeature2: '无限消息',
    premiumFeature3: '无限语音留言',
    premiumFeature4: '优先配对',
    faqTitle: '常见问题',
    welcomeToVeyl: '欢迎来到Veyl',
    chooseLanguage: '选择您的语言',
    chooseLanguageDesc: '选择您希望使用Veyl的语言。',
    ageVerification: '年龄验证',
    ageVerificationDesc: 'Veyl适用于13岁及以上的用户。',
    areYouOldEnough: '您是否年满13岁？',
    yesIAm: '✅ 是的，我是',
    noImNot: '❌ 不，我不是',
    mustBe13: '您必须年满13岁',
    mustBe13Desc: 'Veyl仅适用于13岁及以上的用户。',
    setupProfile: '让我们设置您的个人资料',
    stepOf: '第{step}步，共4步',
    whatsYourName: '您的名字是什么？',
    namePlaceholder: '请输入您的昵称',
    whatsYourTimezone: '您的时区是什么？',
    selectTimezone: '选择时区',
    goalCategory: '您的目标类别是什么？',
    matchPreference: '您想与谁配对？',
    matchNearby: '就近配对',
    matchNearbyDesc: '与您时区4小时内的人配对。',
    matchAnywhere: '随处配对',
    matchAnywhereDesc: '与全球任何人配对，不限时区。',
    describeGoal: '描述您的具体目标',
    goalPlaceholder: "例如：'我想减重15公斤' 或 '学习Python'",
    communicationStyle: '首选沟通方式',
    textMessages: '文字消息',
    textMessagesDesc: '方便时聊天',
    scheduledCheckins: '定期打卡',
    scheduledCheckinsDesc: '每周深度反思',
    completingSetup: '正在寻找匹配...',
    completeSetup: '完成设置',
    agreeToTerms: '继续即表示您同意Veyl的',
    termsOfService: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    fitnessHealth: '健身与健康',
    learningSkills: '学习与技能',
    businessCareer: '商业与职业',
    creativeProjects: '创意项目',
    findingMatch: '正在寻找您的伙伴...',
    findingNewMatch: '正在寻找您的新伙伴...',
    lookingForSomeone: '我们正在寻找同一类别的人',
    category: '',
    sharesTimezone: '与您共享时区和承诺的人。',
    autoCheck: '我们每5秒自动检查一次匹配。',
    noMatchYet: '尚未找到匹配 — 我们将继续尝试。',
    checkNow: '立即检查',
    checking: '检查中...',
    manualChecks: '已完成{count}次手动检查',
    joinCommunity: '🌐 等待期间加入社区',
    goToCommunity: '🌐 前往社区',
    previousPartnerNote: '🛡️ 您之前的伙伴不会再被推荐。',
    joining: '加入中...',
    overview: '概览',
    chat: '聊天',
    checkin: '打卡',
    group: '群组',
    community: '社区',
    notifications: '通知',
    settings: '设置',
    yourGoal: '您的目标',
    yourPartner: '您的伙伴',
    you: '您',
    unveiled: '✨ 已揭晓',
    goalComplete: '✓ 目标完成',
    adjustGoal: '调整我的目标',
    unveilButton: '✨ 揭晓 — 您做到了！',
    goalCategory2: '类别',
    goalDescription: '描述',
    timezone: '时区',
    loadingPartner: '正在加载伙伴信息...',
    waitingForMatch: '等待匹配开始聊天。',
    noMessagesYet: '还没有消息。向您的伙伴打个招呼吧！',
    typeMessage: '输入您的消息...',
    dailyLimitReached: '已达每日限制 — 升级到高级版',
    unmatch: '🔓 取消匹配',
    report: '🚩 举报',
    unmatchWarning: '⚠️ 取消匹配将删除您的全部聊天记录。此操作无法撤销。',
    yesUnmatch: '是的，取消匹配',
    unmatching: '取消中...',
    deleteMessage: '🗑 删除',
    deleting: '删除中...',
    checkIn: '打卡',
    submitDaily: '提交每日打卡',
    submitWeekly: '提交每周打卡',
    submitting: '提交中...',
    checkinSubmitted: '打卡已提交！',
    viewHistory: '查看我的历史',
    notificationsTitle: '通知',
    clearAll: '清除全部',
    noNotifications: '暂无通知。',
    settingsTitle: '设置',
    settingsDesc: '个性化您的匿名身份。',
    saveAvatar: '保存头像',
    appearance: '外观',
    lightMode: '☀️ 浅色',
    darkMode: '🌙 深色',
    changeNickname: '更改昵称',
    saveNickname: '保存昵称',
    deleteAccount: '删除账户',
    deleteAccountDesc: '永久删除您的账户和所有相关数据。',
    languageLabel: '语言',
    languageDesc: '选择您的首选语言。',
    signOut: '退出登录',
    updating: '更新中...',
    unveil: '揭晓',
    clearing: '清除中...',
    notifMatchFound: '找到匹配',
    notifGoalAchieved: '目标已达成',
    notifSupport: '支持消息',
    notifUnmatched: '取消匹配提醒',
    notifMatchRequest: '匹配请求',
    notificationPrefs: '通知偏好',
    notificationPrefsDesc: '单独静音特定类型的通知。',
    muted: '已静音',
    active: '活跃',
    all: '全部',
    justNow: '刚刚',
    minsAgo: '{count}分钟前',
    hoursAgo: '{count}小时前',
    daysAgo: '{count}天前',
    leaving: '离开中...',
    myHistory: '📋 我的历史',
    partnersProgress: '👤 {name}的进展',
    myCheckinHistory: '我的打卡历史',
    checkinsForVeyl: '此Veyl共{count}次打卡',
    noCheckinsYet: '还没有打卡。开始第一次吧！',
    newCheckinBtn: '新打卡',
    partnerNoCheckins: '{name}还没有打卡。',
    dailyNotesPrivate: '每日备注是私密的',
    goalAchievedMarked: '🎉 目标已标记为完成',
    goalAchievedNote: '🎉 您的目标已标记为完成！前往概览揭晓。',
    veylComplete: '✓ 此Veyl已完成。打卡记录为只读。',
    goalAlreadyAchieved: '🎉 您已将目标标记为完成！前往概览揭晓。',
    didYouWork: '您今天为目标努力了吗？',
    howDidWeekGo: '这周您的目标进展如何？',
    whatGotInWay: '有什么阻碍？（可选）',
    honestNote: '请诚实作答。您的伙伴是来支持您的，不是评判您的。',
    whatDidYouLearn: '这周您对自己有什么新认识？',
    insightsPlaceholder: '您获得了哪些感悟？',
    whatPatterns: '您注意到什么规律？',
    patternsPlaceholder: '有重复出现的主题或障碍吗？',
    whatChange: '下周需要做什么改变？',
    changePlaceholder: '您会有什么不同的做法？',
    goalAchievedQuestion: '🏆 您实现了总体目标了吗？',
    yesDidIt: '🎉 是的，我做到了！',
    notYetBtn: '还没有',
    didIt: '✅ 完成了',
    didSome: '😐 做了一些',
    didntDoIt: '❌ 没做',
    metCommitment: '✅ 完成了承诺',
    partialProgress: '😐 部分进展',
    noProgress: '❌ 没有进展',
    rethinkingGoal: '🤔 重新考虑目标',
    yesLabel: '✅ 是',
    aLittle: '😐 一点点',
    noLabel: '❌ 否',
    madeProgress: '今天有进展',
    didSomething: '做了一些，不是全部',
    didntWork: '今天没有为此努力',
    metWeekly: '完成了本周承诺',
    madePartial: '取得了部分进展',
    didntMake: '没有取得进展',
    needToAdjust: '需要调整我的方法',
    learnedLabel: '学到：',
    patternLabel: '规律：',
    nextWeekLabel: '下周：',
    joinGroup: '加入群组',
    joinGroupDesc: '群组将最多5人聚集在一起，共同为相似目标努力。匿名、互助、无压力。',
    whatToExpect: '会怎样',
    expectAnonymous: '所有人保持匿名——相同的剪影头像',
    expectMatched: '按目标类别匹配，获得相关支持',
    expectMembers: '每个群组最多5名成员',
    expectChat: '群组聊天——每天20条消息和5条语音备注免费·Premium无限制',
    findOrCreate: '查找或创建群组',
    findingGroup: '正在寻找您的群组...',
    oneGroupNote: '您一次只能加入一个群组。免费用户和Premium用户都可以访问群组。',
    groupCreated: '群组已创建！',
    groupJoined: '已加入群组！',
    groupCreatedDesc: '您已创建了一个新的{category}群组。其他人很快会加入。',
    groupJoinedDesc: '您已加入现有的{category}群组。打个招呼吧！',
    switchToGroup: '切换到控制台中的群组标签开始聊天。',
    groupMembers: '群组成员',
    backToChat: '← 返回聊天',
    creator: '★ 创建者',
    joined: '已加入',
    leaveGroup: '退出群组',
    leaveGroupTitle: '退出这个群组？',
    leaveGroupDesc: '您将失去群组聊天的访问权限，可以随时加入新群组。',
    membersBtn: '👥 成员',
    noGroupMessages: '还没有消息。第一个打招呼吧！',
    messageGroup: '给您的群组发消息...',
    groupDailyLimit: '您已达到每日群组消息限制（{limit}/天）。升级到Premium享受无限消息！',
    groupVoiceLimit: '已达每日语音备注限制。',
    veylCommunity: 'Veyl社区',
    communityDesc: '在等待匹配时，加入其他在同一目标类别上努力的人。',
    communityJoinNote: '在等待匹配时，从等待页面加入社区。',
    leaveCommunity: '退出此社区？',
    communityLeaveDesc: '您可以随时从等待页面重新加入。',
    matchRequests: '匹配请求',
    incoming: '收到的',
    sent: '已发送',
    noIncoming: '没有收到的请求。',
    noPending: '没有待处理的已发送请求。',
    requestToAnonymous: '向匿名用户发送请求',
    pending: '待处理',
    decline: '拒绝',
    accept: '✅ 接受',
    requestWaiting: '🤝 {count}个匹配请求等待您',
    view: '查看',
    requestsBtn: '🤝 请求',
    leaveBtn: '离开',
    openToAll: '对所有人开放·匿名',
    msgsLeft: '剩余{count}条消息',
    noCommunityMessages: '还没有消息。向社区打个招呼！',
    saySomething: '向社区说点什么...',
    requestMatch: '🤝 请求匹配',
    requestSending: '发送中...',
    communityMsgsWarning: '今天还剩{count}条社区消息。',
    communityDailyLimit: '您已达到每日社区消息限制（{limit}/天）。升级到Premium享受无限制！',
    matchRequestLimit: '您一次最多只能有3个待处理请求。',
    matchRequestSent: '匹配请求发送成功！',
    matchRequestDuplicate: '您已向此人发送过请求。',
    matchRequestError: '发送匹配请求时出错。请重试。',
    matchAcceptError: '接受匹配请求时出错。',
    matchRequestSentAlready: '您已向此人发送过请求。',
    avatar_silhouette: '剪影',
    avatar_teal: '蓝绿色',
    avatar_purple: '紫色',
    avatar_navy: '深蓝色',
    avatar_slate: '石板色',
    avatar_coral: '珊瑚色',
    avatar_gold: '金色',
    avatar_moss: '苔绿色',
    avatar_indigo: '靛蓝色',
    avatar_unveiled: '已揭晓',
    activeLabel: '活跃',
    seekingLabel: '寻找中',
    completeLabel: '已完成',
    upgradeForMore: '✨ 升级获得更多Veyls',
    newVeyl: '+ 新Veyl',
    newVeylTitle: '开始新Veyl',
    goalCategoryLabel: '目标类别',
    goalDescriptionLabel: '目标描述',
    startVeyl: '开始新Veyl',
    starting: '启动中...',
    unveil: '揭晓',
    clearing: '清除中...',
    nicknameRequired: '昵称为必填项',
    nicknameTooShort: '昵称至少需要2个字符',
    nicknameTooLong: '昵称最多20个字符',
    errorSavingNickname: '保存昵称时出错',
    errorSavingAvatar: '保存头像时出错',
    errorDeletingAccount: '删除账户时出错',
    deleteMyAccountButton: '删除我的账户',
    goalsAchievedTitle: '已达成目标',
    goalsPrivate: '私密——仅您可见。',
    goalsCompletedCount: '已完成{count}个目标',
    keepAnonymous: '保持匿名。不要使用您的真实姓名。',
    currentNicknameIs: '您当前的昵称是',
    unveiledLocked: '✨ 已揭晓——头像已锁定',
    howOthersSee: '这是其他人看到您的样子',
    unveiledNote: '您已在此Veyl上揭晓。开始新Veyl以选择新头像。',
    active2: '✓ 活跃',
    goalsAchieved: '已达成目标',
    goalsAchievedDesc: '私密——仅您可见。',
    goalCompleted: '个目标已完成',
    goalsCompleted: '个目标已完成',
    contactSupport: '联系支持',
    deleteWarning: '⚠️ 这将永久删除所有内容。在下方输入DELETE以确认。',
    typeDelete: '输入DELETE以确认',
    confirmDelete: '确认删除',
    deleting2: '删除中...',
    messagesLeft: '{count}条消息·{voiceCount}条语音备注今日剩余',
    premiumUnlimited: '✨ Premium——无限消息和语音备注',
    messagesLeftWarning: '今天还剩{count}条消息。',
    forUnlimited: '以享受无限消息。',
    voiceNotesLeft: '今日剩余{count}条语音备注',
    dailyLimitReachedVoice: '已达每日语音备注限制。',
    dailyVoiceNoteLimit: '已达每日语音备注限制。升级到Premium享受无限备注。',
    recording: '录音中...',
    deeper: '更低沉',
    neutral: '中性',
    higher: '更高',
    applyingModulation: '⚙️ 正在应用调制...',
    preview: '▶ 预览',
    pause: '⏸ 暂停',
    discard: '丢弃',
    recordingTooLarge: '录音太大。请尝试更短的消息。',
    failedToSend: '发送失败。请重试。',
    micDenied: '麦克风访问被拒绝。',
    unmatchMessage: '您的伙伴已结束此Veyl会话。您已返回匹配搜索。',
    appearanceDesc: '选择Veyl对您显示的外观。',
    newNickname: '新昵称',
    nicknamePlaceholder: '例如 NightOwl、StriveMode、Kira...',
    chooseAvatar: '选择您的头像',
    notificationsTitle: '通知',
    notificationsCount: '共{total}条 · {unread}条未读',
    progressOf: '{name}的进展',
    fitnessHealth: '健身与健康',
    learningSkills: '学习与技能',
    businessCareer: '商业与职业',
    creativeProjects: '创意项目',
    progressOf: '{name}的进展',
    dailyCheckin: '每日打卡',
    weeklyCheckin: '每周打卡',
    dailyCheckinDesc: '快速更新：你今天有为目标努力吗？',
    weeklyCheckinDesc: '深度反思：这周整体情况如何？',
    submitDaily: '提交每日打卡',
    submitWeekly: '提交每周打卡',
    submitting: '提交中...',
    checkinSubmitted: '打卡已提交！',
    checkinSubmittedDesc: '坚持负责任，做得好。{name}将看到你的更新。',
    viewHistory: '查看我的历史',
    newCheckin: '📝 新打卡',
    myHistory: '📋 我的历史',
    partnersProgress: '👤 {name}的进展',
    myCheckinHistory: '我的打卡历史',
    checkinsForVeyl: '此Veyl共{count}次打卡',
    noCheckinsYet: '还没有打卡记录。开始第一次吧！',
    newCheckinBtn: '新打卡',
    partnerNoCheckins: '{name}还没有打卡。',
    dailyNotesPrivate: '每日笔记是私密的',
    goalAchievedMarked: '🎉 目标已标记为已完成',
    goalAchievedNote: '🎉 你的目标已标记为完成！前往概览页面揭晓。',
    veylComplete: '✓ 此Veyl已完成。打卡记录为只读。',
    goalAlreadyAchieved: '🎉 你已将目标标记为完成！前往概览页面揭晓。',
    didYouWork: '你今天有为目标努力吗？',
    howDidWeekGo: '这周你在目标上进展如何？',
    whatGotInWay: '是什么阻碍了你？（可选）',
    honestNote: '诚实面对自己。你的伙伴在这里支持你，而不是评判你。',
    whatDidYouLearn: '这周你对自己有什么了解？',
    insightsPlaceholder: '你获得了哪些洞察？',
    whatPatterns: '你注意到了什么规律？',
    patternsPlaceholder: '有什么反复出现的主题或障碍吗？',
    whatChange: '下周需要做出什么改变？',
    changePlaceholder: '你会有什么不同的做法？',
    goalAchievedQuestion: '🏆 你已经实现了整体目标吗？',
    yesDidIt: '🎉 是的，我做到了！',
    notYetBtn: '还没有',
    didIt: '✅ 完成了',
    didSome: '😐 完成了一些',
    didntDoIt: '❌ 没完成',
    metCommitment: '✅ 履行了承诺',
    madePartial: '😐 部分进展',
    didntMake: '❌ 没有进展',
    needToAdjust: '🤔 需要调整方法',
    yesLabel: '✅ 是',
    aLittle: '😐 一点点',
    noLabel: '❌ 没有',
    madeProgress: '今天取得了进展',
    didSomething: '做了一些，但不是全部',
    didntWork: '今天没有为此努力',
    metWeekly: '完成了每周承诺',
    didntMake: '没有取得进展',
    needToAdjust: '需要调整我的方法',
    learnedLabel: '学到了：',
    patternLabel: '规律：',
    nextWeekLabel: '下周：',
    problemTitle: '社交媒体毁了责任感',
    problem1: "你害怕承认自己在挣扎",
    problem2: "你隐藏失败而不是从中学习",
    problem3: "你在失误时消失，不联系伙伴",
    veylIsDifferent: 'Veyl 不一样。',
    popular: '热门',
    sixMonthDeal: '或 $20 购买6个月（$3.33/月）',
    getStartedPremium: '开始',
    buildTrust: '建立信任',
    unveilIdentity: '在准备好时（或如果准备好了）揭示你的身份',
    actuallyAchieve: '真正实现它',
    makeRealProgress: '不表演，取得真正的进步',
    faq1q: '如果我和我的伙伴不合适怎么办？',
    faq1a: '轻松重新匹配。无需解释。我们宁愿让你找到合适的人，也不愿强迫一段不起作用的合作关系。',
    faq2q: '我必须在某个时候揭示身份吗？',
    faq2a: '不必。有些伙伴关系永远保持匿名。有些在一周后揭示。完全由你决定。',
    faq3q: '如果我的伙伴把我晾在一边怎么办？',
    faq3a: '高级用户可以立即重新匹配。免费用户在48小时内重新匹配。',
    faq4q: '为什么从不使用个人资料图片？',
    faq4a: '因为一旦你添加照片，就变成了管理印象的事情。我们测试过。匿名性让焦点保持在工作上。',
    legalEnglishOnly: '本文件仅提供英文版本。如有疑问，请联系客服或使用浏览器的翻译功能。',
    ctaTitle: "准备好真正实现你的目标了吗？",
    ctaSubtitle: "加入Veyl，今天就找到一个问责伙伴。免费开始。",
    statAnonymous: "匿名",
    statLanguages: "语言",
    statToStart: "开始",
    authTagline: "匿名问责。真实结果。",
    authPricing: "免费开始 · 高级版每月$5起",
    taglineHonest: "诚实",
    taglineEffective: "有效",
    foreverLabel: "/永远",
    premiumTitle: "Veyl 高级版",
    upgradeTitle: "升级到高级版",
    premiumActiveDesc: "您可以无限制访问Veyl的所有功能。",
    upgradeDesc: "解除所有限制，享受完整的Veyl体验。",
    billedMonthly: "按月计费",
    bestValue: "最优惠",
    perSixMonths: "$3.33/月",
    unlimitedMessages: "无限消息",
    unlimitedVoice: "无限语音备忘",
    unlimitedGroup: "无限群聊",
    unlimitedCommunity: "无限社区",
    was10day: "原10条/天",
    was5day: "原5条/天",
    was20day: "原20条/天",
    was30day: "原30条/天",
    sixMonthPlan: "6个月计划",
    monthlyPlan: "月度计划",
    modulationFailed: "调制失败 — 使用原始声音",
    monthly: "月度",
    sixMonths: "6个月",
    savePercent: "节省 {{percent}}%",
    pricePerMonth: "${{price}} / 月",
    priceTotal: "总计 ${{price}}",
    unlimitedMessages: "无限消息",
    unlimitedVoiceNotes: "无限语音笔记",
    unlimitedGroupMessages: "无限群组消息",
    unlimitedCommunityMessages: "无限社区消息",
    upgrade: "升级",
    forUnlimited: "获取无限",
    messagesLeftWarning: "今日剩余 {{count}} 条消息",
    recordVoiceNote: "录制语音笔记",
    uploading: "上传中",
    maxDuration: "最多{{seconds}}秒",
    upgradeToPremium: "升级到高级版",
    dailyMessageLimitReached: "您已达到每日消息限制。",
    dailyVoiceLimitReached: "您已达到每日语音笔记限制。",
    dailyGroupMessageLimitReached: "您已达到每日群组消息限制。",
    dailyGroupVoiceLimitReached: "您已达到每日群组语音笔记限制。",
    unlockUnlimited: "解锁所有功能的无限访问权限。",
    maybeLater: "稍后也许",
    premiumUnlimited: "无限",
    premium: "高级版",
    msg: "条",
    msgs: "条",
    newMessageNotification: "{{name}} 给您发送了一条消息 💬",
    newGroupMessageNotification: "{{name}} 在您的群组中发送了一条消息 👥",
    someone: "某人",
    failedToLoad: "加载失败",
    groupMessagesLeftWarning: "今日剩余 {{count}} 条消息",
    howOldAreYou: '你多大了？',
    minorGroupNote: '您将与同龄用户（13–17岁）配对分组。',
    adultGroupNote: '您将与其他成年用户（18岁以上）配对分组。',
    enterYourAge: '请输入您的年龄',
    getStarted:        '立即开始',
    howItWorks:        '使用方式',
    statAnonymous:     '匿名',
    statLanguages:     '语言',
    statToStart:       '免费开始',
    taglineHonest:     '诚实',
    taglineEffective:  '有效',
    landingHero:       '不需要表演的责任感。',
    landingSubtitle:   '找到一个共享你目标的匿名伙伴。没有关注者，没有压力——只有真实的进步。',
    problemTitle:      '问责制已经失灵。',
    problem1:          '社交媒体把自我提升变成了表演。你为了点赞而发布目标，而不是为了进步。',
    problem2:          '朋友和家人带来评判或漠视。真正的诚实变得不可能。',
    problem3:          '问责应用感觉像追踪工具——完全忽视人性元素的冷漠仪表板。',
    veylIsDifferent:   'Veyl 与众不同。',
    step1Title:        '创建你的档案',
    step1Desc:         '选择一个化名，选择目标类别，设置你的沟通偏好。你的真实身份完全由你掌控。',
    step2Title:        '获得匹配',
    step2Desc:         'Veyl 为你找到一个与你目标类型和年龄组匹配的伙伴。即时完成——无需滑动。',
    step3Title:        '开始交流',
    step3Desc:         '聊天或发送语音消息。每天或每周打卡。你的伙伴让你负责——你也让他们负责。',
    buildTrust:        '建立信任',
    unveilIdentity:    '记录你的成就。当信任建立后，你可以选择揭示你的身份——或者不。',
    actuallyAchieve:   '真正实现',
    makeRealProgress:  '与真实的人取得真实的进步。没有游戏化。只有你、你的伙伴和你的目标。',
    pricingTitle:      '免费开始。准备好后深入使用。',
    freePlan:          '免费',
    foreverLabel:      '/ 永久',
    freeFeature1:      '1 名问责伙伴',
    freeFeature2:      '每天 10 条消息',
    freeFeature3: '每天 10 条语音留言',
    freeFeature5:      '群组和社区房间',
    popular:           '最受欢迎',
    premiumPlan:       '高级版',
    perMonth:          '/ 月',
    sixMonthDeal: '6个月套餐，仅需20美元——节省33%',
    premiumFeature1:   '无限消息',
    premiumFeature2:   '无限语音消息',
    premiumFeature3:   '伙伴揭示功能',
    premiumFeature4:   '优先匹配',
    getStartedPremium: '开始高级版',
    faqTitle:          '常见问题。',
    faq1q: 'Veyl 真的匿名吗？',
    faq1a: '是的。你用化名注册，没有真实姓名，没有照片，没有任何身份信息。你的伙伴只知道你选择分享的内容。',
    faq2q: '匹配是如何运作的？',
    faq2a: 'Veyl 将你与同一目标类别和年龄组的人配对，通常不到两分钟。',
    faq3q: '如果我与我的伙伴合不来怎么办？',
    faq3a: '你可以随时无需说明原因地举报或屏蔽你的伙伴，然后重新匹配。',
    faq4q: '对未成年人安全吗？',
    faq4a: '绝对安全。13–17 岁的用户只与同年龄组的用户匹配，这在系统层面强制执行。',
    ctaTitle:    '你的伙伴已经在等待了。',
    ctaSubtitle: '免费加入 Veyl。无需社交资料。只有你、你的目标和一个理解你的人。',
    privacyPolicy:  '隐私政策',
    termsOfService: '服务条款',
    refundPolicy:   '退款政策',
    featuresTitle: "你需要的一切。不需要的一概没有。",
    feature1Title: "完全匿名",
    feature1Desc: "你可以选择一个昵称。你的真实姓名、照片和身份永远不会被分享,除非你自己决定公开。",
    feature2Title: "语音留言",
    feature2Desc: "有时打字不够直接。直接在应用内录制并发送语音留言。",
    feature3Title: "年龄安全匹配",
    feature3Desc: "未成年人(13-17岁)只会与其他未成年人匹配。成年人与成年人匹配。没有例外——这是系统内置的规则。",
    feature4Title: "13种语言",
    feature4Desc: "英语、斯瓦希里语、法语、西班牙语、葡萄牙语、德语、意大利语、印地语、印尼语、中文、日语、韩语、豪萨语。",
    feature5Title: "每日打卡",
    feature5Desc: "结构化的打卡能保持动力。记录进度,与伙伴一起庆祝每一次胜利。",
    feature6Title: "群组与社区",
    feature6Desc: "加入特定目标的群聊和按语言划分的社区房间。",
    goalsEyebrow: "为真实目标而设",
    goalsTitle: "无论你在努力做什么。",
    goalsSub: "Veyl 适合任何有真实目标、却找不到人可以坦诚交流的人。",
    goalFitness: "健身与健康",
    goalLearning: "学习与技能",
    goalBusiness: "事业与职场",
    goalCreative: "创意项目",
    moreComingSoon: "更多分类即将推出",
    safeTitle: "安全不是一项功能,而是基础。",
    safe1Title: "年龄分隔",
    safe1Desc: "未成年人与成年人永不混合。年龄在注册时验证并锁定。",
    safe2Title: "举报与屏蔽",
    safe2Desc: "任何用户都可以立即举报或屏蔽对方,无需任何理由。",
    safe3Title: "绝不出售数据",
    safe3Desc: "你的目标、消息和身份都属于你自己,没有任何例外。",
    safe4Title: "仅使用昵称",
    safe4Desc: "永远不需要真实姓名。是否以及何时公开自己,完全由你决定。",
    refundPolicy: "退款政策",
    heroLine1: '责任感',                     
    heroLine2: '不需要表演。',
    mustBe18: '您必须年满18周岁才能使用 Veyl',
    mustBe18Desc: 'Veyl 是面向18岁及以上用户的平台。很抱歉，您未满足创建账户所需的最低年龄要求。',
    ageAttestationLabel: '我确认本人年满18周岁。',
    ageMisrepresentationNote: '谎报年龄将违反我们的服务条款，并可能导致账户被终止。',
    feature3Title: '仅限18岁以上，已验证',
    feature3Desc: '每位会员在加入前都需确认年满18周岁。不接受未成年人，没有例外。',
    faq4q: 'Veyl 是否对未成年人开放？',
    faq4a: '不开放。Veyl 是仅限18岁及以上人群使用的平台。每位用户在注册时都需确认自己的年龄，谎报年龄的账户可能会被移除。',
    safe1Title: '仅限成年人',
    safe1Desc: 'Veyl 专为18岁及以上人群打造。任何未满18岁却试图使用 Veyl 的人都属于谎报年龄，这违反了我们的服务条款。',
    ageVerificationDesc: 'Veyl 仅供18岁及以上用户使用。',
    // [auto-synced 2026-08-03]
    adjustYourGoal: '调整你的目标',
    adjustGoalDesc: '改变方向没关系。我们会通知你的搭档。',
    newGoalDescription: '新目标描述',
    newGoalPlaceholder: '你新的或调整后的目标是什么？',
    updateGoal: '更新目标',
    goalUpdated: '目标更新成功！您的合作伙伴已收到通知。',
    readyToUnveil: '准备好揭晓了吗？',
    unveilDesc: '揭开面纱标志着此维尔仪式完成。您的伙伴将会收到通知。此操作无法撤销。',
    yourNewAvatar: '你的新头像',
    notYet: '还没有',
    unveiling: '揭晓……',
    sending: '正在发送...',
    checkInDesc: '每日打卡记录进度，每周打卡进行更深入的反思。',
    dismiss: '✕',
    saving: '保存...',
    saved: '✓ 已保存！',
    lightModeDesc: '干净明亮',
    darkModeDesc: '赏心悦目',
    currentNickname: '你目前的昵称是',
    anonymousWarning: '保持匿名。不要使用你的真实姓名。',
    nicknameUpdated: '✓ 昵称已更新！',
    deleteMyAccount: '删除我的帐户',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: '认识拉萨',
    rasaIntroDesc: 'Rasa是一个私密的反思空间——只属于你，与你的督导伙伴无关。它不会对你或世界抱有任何预设；它只从你选择分享的内容中学习，并且它的设计理念是提出问题，而不是直接给你答案。',
    rasaIntroNotTherapist: 'Rasa 不是心理治疗师，也不能取代真实的人际关系——包括你的责任伙伴。如果有什么事情让你感到沉重，它会温和地引导你寻求支持，而不是试图成为支持本身。',
    rasaIntroStart: '开始',
    rasaMessagesLeft: '今天留下的思考',
    rasaNoMessagesYet: '当你准备好反思时，请在下方开始输入。',
    rasaThinking: 'Rasa正在沉思……',
    rasaPrivateNote: '只有你才能看到——你的监督伙伴永远不会看到。',
    rasaPlaceholder: '分享你的想法……',
    rasaDailyLimitReached: '您已达到今天的 Rasa 上限，明天重置。',
    // [auto-synced 2026-08-06]
    feature7Title: '认识拉萨',
    feature7Desc: '一个供你反思的私人空间——只属于你，与你的责任伙伴分开。',
    feature8Title: '随时获取支持',
    feature8Desc: '在应用内即可快速获得有关导航、账单和帐户问题的解答。',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Veyl 客服聊天',
    supportChatTitle: 'Veyl 支持',
    supportChatEmptyState: '关于Veyl的工作原理，你可以问任何问题。',
    supportChatPlaceholder: '提问……',
    supportChatSend: '发送',
    supportChatTyping: '正在输入……',
    supportChatLimitReached: '您今天的客服聊天次数已达上限。如有紧急情况，请发送电子邮件至 support@veyl.space。',
    supportChatGenericError: '出错了，请重试。',
    // [auto-synced 2026-08-06]
    rasaLoadError: '无法加载您的对话。',
    rasaLoadErrorDetail: '查看浏览器控制台了解详情，或尝试刷新页面。',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 你已与{name}匹配成功！前往你的仪表盘。',
    // [auto-synced 2026-09-08]
    installAppLabel: '安装应用',
    installMobileOnly: '仅限移动设备',
    installTooltip: '仅限移动设备使用',
    installModalTitle: '在手机上安装 Veyl',
    installStep1: '点击 Safari 工具栏中的“分享”图标',
    installStep2: '向下滚动并点击“添加到主屏幕”',
    installStep3: '点击右上角的“添加”',
    installGotIt: '知道了',
    // [auto-synced 2026-09-15]
    relationshipsConnection: '人际关系与联系',
    homeLifeOrganization: '家居生活收纳',
    moneyFinancialHabits: '金钱与理财习惯',
    stayingConnected: '保持联系',
    independentLiving: '独立生活',
    techConfidence: '技术信心',
    // [auto-synced 2026-09-15]
    goalRelationships: '人际关系与联系',
    goalHomeLife: '家居生活收纳',
    goalMoney: '金钱与理财习惯',
    goalStayingConnected: '保持联系',
    goalIndependentLiving: '独立生活',
    goalTechConfidence: '技术信心',
    // [auto-synced 2026-10-28]
    resources: '资源',
    resourcesTitle: '资源',
    resourcesWriteUps: '撰写',
    resourcesLinks: '延伸阅读',
    resourcesOpensNewTab: '在新标签页中打开',
    resourcesEmptyTitle: '这里目前还没有任何东西',
    resourcesEmptyBody: '我们仍在整理此类别的相关资源，请稍后查看。',
    resourcesNoMatchBody: '我们目前还没有找到实现这一目标所需的资源。',
    resourcesDisclaimer: '仅供参考，不构成专业建议。如果问题涉及您的健康、安全或财务，请咨询合格的专业人士寻求帮助。',
    // [auto-synced 2026-10-28]
    resourcesArticles: '文章',
    resourcesMoreToRead: '更多阅读',
    res_intro_fitnessHealth: '健身和健康目标往往是在平凡的小事中实现的，而不是在惊天动地的大事中。这些文章旨在减轻你的压力，文中的链接指向更详细的资料来源。',
    res_fitness_showing_up_title: '炫耀式的表演',
    res_fitness_showing_up_p1: '我们大多数人心中都有一幅“正确”锻炼的画面：健身房、跑鞋、汗水。当生活与这幅画面不符时，很容易就认定锻炼不适合自己。',
    res_fitness_showing_up_p2: '世界卫生组织则采取了更为宽泛的观点。它将休闲时间的活动、出行活动以及工作或居家活动都纳入统计。步行、骑自行车、运动和玩耍，无论技能水平如何，都算在内。世卫组织的指南特别强调，任何程度的活动都胜过不活动。',
    res_fitness_showing_up_p3: '当你和伙伴一起培养习惯时，这一点至关重要。一次真正完成的短途散步比你计划好却最终放弃的高强度训练更有价值。即使只是简单地记录“我只坚持了十分钟”，也是一次有效的记录，它让你们的习惯得以延续。',
    res_fitness_showing_up_p4: '区分你的行为和感受也很有帮助。有时候，养成习惯本身就是最大的胜利。强度可以稍后再来，等到你不再觉得坚持下去是一种妥协之后。',
    res_fitness_showing_up_p5: '如果您有健康问题、怀孕或很久没有运动，那么在改变训练强度之前，最好先与医生或其他合格的健康专业人员进行简短的沟通。',
    res_fitness_rest_title: '休息是计划的一部分',
    res_fitness_rest_p1: '人们谈论健身目标时，通常把睡眠和休息当作真正训练结束后剩下的“剩余部分”。但实际上，它们对训练效果能否持久起见至关重要。',
    res_fitness_rest_p2: '睡眠和运动相辅相成。英国国民医疗服务体系（NHS）指出，规律的运动有助于改善睡眠质量，但有些人发现睡前运动会影响睡眠，在这种情况下，白天早些时候运动可能更适合他们。当然，这并非硬性规定，而是提醒我们，只有你自己才能找到适合自己身体的运动方式。',
    res_fitness_rest_p3: '当你们互相监督时，休息也值得安排。如果每次进度汇报都变成了你付出了多少努力，那么休息日就会感觉像是失败。主动选择的休息日与偏离目标截然不同，坦诚地表达出来也无妨。',
    res_fitness_rest_p4: '如果长时间睡眠严重不足，或者感到疲惫不堪却又找不到原因，那就应该咨询医生或其他合格的医疗专业人员。这种情况不应该独自承受。',
    res_fitness_food_title: '轻松享用美食',
    res_fitness_food_p1: '关于食物的建议五花八门，而且常常自相矛盾，所以值得注意的是，大型公共卫生机构比大多数互联网信息要宽松得多。',
    res_fitness_food_p2: '世界卫生组织指出，健康饮食的形式多种多样。何为合理的饮食方式取决于您的年龄、生活方式、文化背景以及您所在地区实际可获得的食物。世界卫生组织阐述了所有健康饮食方式的基础四个要素：摄入足够的身体所需营养、保持营养均衡、适量享用某些食物以及饮食多样化。其中，以未经加工且种类丰富的食物为主的饮食是其核心。',
    res_fitness_food_p3: '如果你要和别人一起实现某个目标，这个框架就很有用。你不需要完全照搬伴侣的饮食习惯，他们也不需要完全照搬你的。饮食目标可以很简单，比如“多在家做饭”或者“这周吃点不一样的食物”，只要符合你的生活方式和预算即可。',
    res_fitness_food_p4: '如果您正考虑大幅改变饮食习惯，或者您患有某种疾病、过敏症或正在服用会影响食物的药物，那么医生或注册营养师可以为您提供量身定制的建议。而泛泛而谈的文章则无法做到这一点。',
    res_fitness_who_physical_activity_note: '全球范围。简要概述哪些活动算作活动、谁受益以及为什么受益。',
    res_fitness_who_guidelines_note: '全球性指南。包含针对不同年龄段人群以及患有慢性疾病或残疾人群的完整建议。',
    res_fitness_who_healthy_diet_note: '全球视角。阐述健康饮食背后的原则，以及为何健康饮食会因文化和当地食物而异。',
    res_fitness_nhs_sleep_note: '英国。实用睡眠建议。文中提及的全科医生或药剂师均指英国境内的医疗服务机构。',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Veyl 关闭时收到通知',
    pushPromptBody: '当您配对成功或您的伴侣给您发消息时，我们会通知您。通知中不会包含消息内容。',
    pushEnable: '开启通知',
    pushNotNow: '现在不要',
    pushError: '开启通知功能时出现错误，请重试。',
    pushBlockedTitle: '通知已被阻止',
    pushBlockedBody: '您的浏览器已阻止来自 Veyl 的通知。要启用通知，请打开浏览器中 veyl.space 的网站设置，允许通知，然后重新加载页面。',
    pushIosTitle: '在 iPhone 上接收通知',
    pushIosBody: '首先将 Veyl 添加到您的主屏幕：点击“分享”，然后点击“添加到主屏幕”，然后从那里打开 Veyl 并打开通知。',
    pushSettingsTitle: '此设备上的通知',
    pushSettingsDesc: '即使 Veyl 处于关闭状态，当您匹配成功或您的伴侣给您发消息时，您也会收到提醒。提醒内容不包含任何消息内容。此设置仅适用于此设备。',
    pushSettingsUnsupported: '此浏览器不支持通知功能。在 iPhone 或 iPad 上，请先将 Veyl 添加到主屏幕（共享，然后添加到主屏幕），再从主屏幕打开它。',
    pushSettingsBlocked: '您的浏览器已阻止 Veyl 的通知。要启用通知，请打开浏览器中 veyl.space 的网站设置，允许通知，然后重新加载页面。',
    pushSettingsWorking: '在职的…',
    pushSettingsOn: '此设备的通知功能已开启。',
    pushSettingsTurnOff: '关闭通知',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: '学习新知识的关键在于坚持不懈，经常练习才能真正记住。这些文章着眼于长远发展，而文中提供的链接则提供了几乎任何知识的免费学习资源。',
    res_learning_small_repeat_title: '足够小，可以重复',
    res_learning_small_repeat_p1: '大多数学习目标之所以失败，是因为目标太大，而不是太难。“学习编程”或“精通葡萄牙语”是一个目标，而不是你可以在周二晚上完成的事情。',
    res_learning_small_repeat_p2: '周二晚上，你可以抽出二十分钟时间，学习一节课。这是一项可以重复的任务，而学习正是通过重复积累起来的。技能往往会悄然积累，一点一点地进步，直到有一天，你会发现自己能做到以前做不到的事情了。',
    res_learning_small_repeat_p3: '这时，一个督促伙伴比单纯的激励更有帮助。动力时有时无。如果有个伙伴期待听到你的反馈，就能让你更难悄悄戒掉坏习惯，也更容易在糟糕的一周后重新开始。',
    res_learning_small_repeat_p4: '一次有效的进度检查不必惊艳。“我上了一节课，大概理解了一半”这样诚实的回答，就能帮助保持学习习惯。之后你可以逐步增加任务难度。而重新建立已经中断的习惯则要困难得多。',
    res_learning_beginner_title: '初学者是被允许的。',
    res_learning_beginner_p1: '开始做一件新事意味着一开始会做得不好，至少在一个人面前是这样。对许多成年人来说，这才是真正的障碍，比时间和金钱更重要。',
    res_learning_beginner_p2: '了解开放式学习的发展现状或许有所帮助。麻省理工学院开放课件（MIT OpenCourseWare）免费发布数千门麻省理工学院课程的资料，无需注册。英国开放大学的OpenLearn平台提供近千门免费短课程，并表示访问这些课程没有任何要求。你无需获得任何人的许可即可尝试学习某个科目，或者发现它并不适合自己。',
    res_learning_beginner_p3: '尝试某件事，即使发现它不适合自己，也算是一种学习。在真正投入之前先尝试几种不同的事物，是一个非常好的开始方式。',
    res_learning_beginner_p4: '当你感觉落后时，请记住，你的伴侣可能对他们的目标也有同样的感受。你们不是在竞争。你们都处于某个目标的起点附近，只是身处不同的阶段。',
    res_learning_choose_one_title: '选择一件事，然后一直选择它。',
    res_learning_choose_one_p1: '免费学习面临一个奇怪的问题：资源太多了。仅 OpenCourseWare 就涵盖了 2500 多门课程，OpenLearn 也有近千门。很容易花一整个晚上浏览，然后就称之为学习。',
    res_learning_choose_one_p2: '最好选择一门课程、一本书或一系列课程，把其他的都先放在一边，留到以后再说。把其他的记在笔记里也可以。目标是在开始下一件事之前完成一件事。告诉你的伴侣你选择了哪一项，这本身就是一个小小的承诺，能让你更容易坚持下去。',
    res_learning_choose_one_p3: '此外，了解学习资源的功能和局限性也很重要。例如，OpenLearn课程会提供参与证明，有些课程还会颁发数字徽章，但这并非正式的资格证书。如果您需要正式的资格证书用于工作或学习，最好尽早了解这一点，并且您目标院校可以告知您他们认可哪些证书。',
    res_learning_mit_ocw_note: '全球通用。无需注册，即可免费获取麻省理工学院数千门课程的讲义、试题和视频。英文版。',
    res_learning_khan_academy_note: '全球性的非营利组织，提供免费课程和练习，尤其擅长数学和科学，并提供多种语言版本。',
    res_learning_openlearn_note: '总部位于英国，面向所有人开放。提供近千门免费短期课程，时长从约1小时到24小时不等，每门课程都提供免费的参与证明。',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: '工作目标周期很长，大部分精力都集中在各个里程碑之间的过渡阶段。这些内容旨在帮助你保持稳定的节奏，而提供的链接则提供了免费资源，帮助你提升技能并规划下一步。',
    res_business_progress_title: '工作中的进步很少是一帆风顺的。',
    res_business_progress_p1: '职业和商业目标往往会被无限期地延长。升职、换工作或获得第一个客户可能需要数月时间，而中间的这段时间却很少让人感觉有所进展。',
    res_business_progress_p2: '区分你想要的结果和本周实际能做的事情很有帮助。你无法控制公司是否会录用你，也无法控制客户是否会同意。但你可以控制你进行了多少次对话，投入了多少时间在项目上，以及你是否履行了你承诺的事情。',
    res_business_progress_p3: '这就是责任伙伴发挥作用的地方。他们不需要了解你的行业，只需要询问你做了什么，并认真倾听你的回答，而不是把它当成一场表演。',
    res_business_progress_p4: '有些时候，诚实的报告会是“没什么大事发生”。值得把这话说出来，因为一个搁置一个月的目标，比起一个你一直保持警惕的目标，再想重新启动要难得多。',
    res_business_start_from_you_title: '从你自身开始，而不是从工作开始。',
    res_business_start_from_you_p1: '当人们感到工作停滞不前时，往往会首先关注就业市场：哪些公司在招聘，哪些公司薪水高，哪些公司看起来很不错。但或许从其他方面入手会更有帮助。',
    res_business_start_from_you_p2: 'OpenLearn 的免费课程《职场成功之道》正是基于这一理念。它首先强调，了解自己和自己的价值观是职业规划的基础，然后才会涉及简历撰写、求职申请和面试等内容。',
    res_business_start_from_you_p3: '简单来说：你希望自己每天都过得怎样？你擅长什么却很少得到认可？你最不愿放弃的是什么，无论是陪伴家人的时间、稳定的收入还是发挥创造力的空间？',
    res_business_start_from_you_p4: '你不必独自面对所有这些问题。与伴侣沟通往往能让你注意到自己独自思考时会忽略的一些事情，也能将模糊的“我想要一些不同的东西”转化为你可以真正努力实现的目标。',
    res_business_wear_out_title: '努力工作而不让自己筋疲力尽',
    res_business_wear_out_p1: '从内心深处来看，雄心壮志和疲惫不堪可能看起来很相似，尤其当一个目标对你来说至关重要时。',
    res_business_wear_out_p2: '世界卫生组织指出，工作既可以保护心理健康，也可能造成损害。其关于工作场所心理健康的指导方针指出，工作量过大和工作中的消极行为等都是心理健康的风险因素，并强调营造健康的工作场所不仅是员工个人的责任，也是雇主和政府的责任。',
    res_business_wear_out_p3: '如果你要和伴侣讨论一个重要的工作目标，不仅应该问“你完成了吗？”，还应该问“你感觉怎么样？”。即使表面上看起来进展顺利，但如果为了实现目标而牺牲睡眠、健康或人际关系，那就值得重新考虑了。',
    res_business_wear_out_p4: '如果工作影响了您的健康，或者您持续感到情绪低落、焦虑或疲惫不堪，请咨询医生或其他合格的医疗专业人员。如果您不确定自己在工作中享有的权利，可以向您所在地区的可靠机构（例如劳动部门或工人组织）咨询。各国的相关规定差异很大。',
    res_business_who_mh_work_note: '全球通用。主要面向雇主和政府机构，因此内容较为专业。执行摘要提供阿拉伯语、中文、英语、法语、俄语和西班牙语版本。',
    res_business_openlearn_entrepreneurship_note: '这是一门英国课程，共8节课，总计24小时，无需注册即可开始学习。课程内容部分涵盖英国商业法规，请自行查阅您所在国家/地区的适用法规。',
    res_business_openlearn_succeed_note: '课程时长约8周，每周约3小时，内容涵盖职业规划、简历撰写和面试技巧。课程最后更新于2021年，因此部分关于求职和社交媒体的内容可能略显过时。',
    // [auto-synced 2026-11-03]
    timezoneTitle: '时区',
    timezoneCurrentIs: '您当前的时区是',
    timezoneLockNote: '您的每日消息和语音留言限额会在您所在时区的午夜重置。为了公平起见，您只能在当天未使用任何消息或语音留言的情况下更改时区，并且每 7 天只能更改一次。',
    timezoneNew: '选择时区',
    saveTimezone: '保存时区',
    timezoneUpdated: '时区已更新',
    timezoneInvalid: '该时区无效，请从列表中选择一个。',
    timezoneChangeError: '无法更改您的时区。请重试。',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: '创意项目往往存在于其他一切事物的间隙之中。这些文章旨在探讨如何在漫长的过程中保持创意的活力，而链接则涵盖了学习写作、运用和分享创意作品等方面。',
    res_creative_finishing_title: '完成动作也是一项技能。',
    res_creative_finishing_p1: '启动一个创意项目很容易。想法新鲜，一切皆有可能。难点在于过程中，当想法变成实际工作时，工作本身会比最初的想法更慢、更混乱。',
    res_creative_finishing_p2: '项目通常就是在这里停滞不前，而这很少是因为负责人缺乏才能。更多时候是因为项目进行到一半看不到尽头，而且没有人关注。',
    res_creative_finishing_p3: '这时，一个伴侣简单地问一句“你这周做了什么？”就能起到很大的作用。你不需要他们评判你的作品。知道自己要描述这周的成果，就相当于给作品设定了一个小小的截止日期，而一个小小的截止日期往往足以让你回到书桌前，面对画布或乐器。',
    res_creative_finishing_p4: '明确“完成”对你眼前这项工作的意义也很有帮助。一个完成的粗略版本比一个只存在于你脑海中的完美版本更有价值。即使它已经存在，你仍然可以对其进行改进。',
    res_creative_rough_drafts_title: '没人需要看第一版',
    res_creative_rough_drafts_p1: '许多创意人士会悄悄放弃，因为第一次尝试的效果不如他们脑海中的设想。想象与现实之间的差距很正常，而且往往在你最在意的时候，这种差距会更大。',
    res_creative_rough_drafts_p2: '把草稿给一个信任的人看看，可以减轻一些压力。告诉伴侣“这只是个草稿，但我想表达的是这个意思”，这样就变成了一次对话，而不是评判。你可能会发现，他们更关心你是否坚持下去，而不是作品好不好。',
    res_creative_rough_drafts_p3: '如果你是某个领域的初学者，有很多循序渐进的方法。开放大学的免费学习网站OpenLearn就开设了一门面向初学者的小说写作入门课程。这只是众多选择之一，而且它更适合作家而非其他类型的创作者。',
    res_creative_rough_drafts_p4: '创作过程中的进步很少呈现稳步提升的态势。有些时候，你会创作出令自己引以为傲的作品；有些时候，你创作出的作品可能永远不会给任何人看。两者都算数，而且都源于同一种习惯。',
    res_creative_using_sharing_title: '使用他人的作品，并分享自己的作品',
    res_creative_using_sharing_p1: '创意项目通常会用到他人的素材，例如图片、声音或文字，最终你可能也想分享自己的作品。了解一些背景知识对这两方面都有帮助。',
    res_creative_using_sharing_p2: 'Creative Commons 是一个非营利组织，它发布各种许可协议，让创作者保留版权，同时允许他人以创作者选择的方式使用他们的作品。如果您想分享自己创作的内容，Creative Commons 的指南会解释这些许可协议是如何运作的。',
    res_creative_using_sharing_p3: '有些机构做得更进一步。史密森学会已根据 CC0 协议发布了数百万张图片和数据，这意味着您可以无需征得史密森学会的许可即可使用它们，包括用于创意项目。但其常见问题解答指出，CC0 仅涵盖版权。其他权利，例如隐私权或商标权，可能仍然有效，而且其馆藏中的某些项目根本不包含在 CC0 协议中。',
    res_creative_using_sharing_p4: '各国版权规则不尽相同，本文仅提供一般信息，并非法律建议。如果某个项目具有商业价值，或者您不确定是否可以使用该内容，请咨询专业人士以获取法律意见。',
    res_creative_openlearn_fiction_note: '英国本土开设，免费入门。这是一门小说写作入门课程，完成课程后可获得免费参与证明。该课程更适合作家而非其他类型的创作者。',
    res_creative_cc_license_note: '全球指南。如何在保留版权的同时，允许他人按照您选择的条款使用您的作品。本指南仅提供一般信息，不构成法律建议。',
    res_creative_smithsonian_open_access_note: '美国机构出品，任何人均可免费使用。本文解释了以 CC0 协议发布的图像和数据，说明了该协议的适用范围和限制，以及哪些内容被排除在外。',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: '人际关系更多地是由细微而重复的举动而非重大事件构建而成。本文将探讨如何维系人际关系，研究指出哪些因素最为重要，以及当人际关系出现问题或关系不安全时应该如何应对。',
    res_relationships_small_gestures_title: '小举动也很重要',
    res_relationships_small_gestures_p1: '我们很多人都把友谊和家庭关系看作是非此即彼的东西。哈佛大学成人发展研究主任罗伯特·瓦尔丁格则将社会生活描述为一个需要维护的生命系统，就像身体健康一样。',
    res_relationships_small_gestures_p2: '维护健康的方式可以很简单。想想你想念的人，给他们发条信息。世界卫生组织列出的日常措施也同样简单：联系朋友、放下手机以便全身心投入到谈话中、和邻居打个招呼、加入当地的社群或做志愿者。',
    res_relationships_small_gestures_p3: '如果你和督促伙伴共同设定一个目标，那么每周可以问自己这样一个问题：你联系了谁？这个问题具体、简单，即使在艰难的一周里，你也能诚实地回答。',
    res_relationships_small_gestures_p4: '并非每条信息都能得到热情回应，这本身就是一件好事。沃尔丁格说，人们常常会惊讶于这些简短信息竟然会受到如此热烈的欢迎。',
    res_relationships_quality_title: '质量重于数量',
    res_relationships_quality_p1: '用人数来衡量社交生活很容易：有多少朋友，参加了多少活动，你是否恋爱。但研究结果却指向了其他方面。',
    res_relationships_quality_p2: '哈佛成人发展研究自1938年起就开始追踪人们的生活。当研究人员回顾参与者中年时期的生活时发现，人际关系（尤其是婚姻）的满意度，比胆固醇或血压等指标更能预测他们80岁时的幸福和健康状况。该研究的负责人表示，其他研究团队也发现了同样的结论。他还指出，人际关系的数量并没有固定的标准，性格内向的人可能比性格外向的人需要的更少。',
    res_relationships_quality_p3: '需要注意的是：这项研究的首批参与者是哈佛大学的学生和来自美国某城市的年轻人，因此它并不能代表所有人的情况。因此，应谨慎看待其结论。',
    res_relationships_quality_p4: '这项研究委婉地表明，至少拥有一段稳固的关系——一个在你生病或害怕时可以倾诉的人——比拥有庞大的社交圈更为重要。而且，亡羊补牢，为时未晚。该研究的负责人描述了一些人在人生后期，出乎意料地找到了亲密的友谊或爱情。',
    res_relationships_hard_times_title: '当沟通变得困难，当一段关系带来伤害',
    res_relationships_hard_times_p1: '感到孤独并不意味着你有什么问题。世界卫生组织估计，全球约有六分之一的人在各个年龄段都会经历孤独。它将孤独定义为一种痛苦的感觉，这种感觉源于你现有的人际关系与你渴望的人际关系不符。',
    res_relationships_hard_times_p2: '造成这种情况的原因可能包括健康状况不佳、收入低、独居或我们使用科技的方式。世界卫生组织指出，如果问题比较严重，那么了解有哪些支持和服务是值得的。',
    res_relationships_hard_times_p3: '还有另一面：会造成伤害的关系。伴侣关系中的有害行为包括心理虐待和控制行为，以及身体或性伤害。',
    res_relationships_hard_times_p4: '如果你害怕身边的人，或者你正在受到伤害，请拨打当地的紧急求助电话、求助热线或支持服务机构电话。正确的电话号码因国家/地区而异。Veyl 的伙伴是同伴，而非专业咨询师。如果感到压力过大，可以寻求医生或咨询师的帮助。',
    res_relationships_who_social_connection_note: '全球。世界卫生组织 2025 年关于孤独和社会联系的报告的简短、通俗易懂的摘要（13 页）。',
    res_relationships_harvard_gazette_note: '美国消息来源。哈佛成人发展研究项目主任接受采访，谈及该研究对人际关系与健康（包括日常生活中一些小步骤）的启示。这是一篇访谈，该研究的早期参与者来自美国的一个城市。',
    res_relationships_who_violence_note: '全球范围。解释了亲密伴侣暴力包括哪些内容以及其普遍程度，主要受害者是女性。这是信息分享，并非求助热线，而且内容可能令人难以卒读。',
  },

  ja: {
    appName: 'Veyl',
    loading: '読み込み中...',
    save: '保存',
    cancel: 'キャンセル',
    back: '戻る',
    continue: '続ける',
    done: '完了',
    error: 'エラー',
    submit: '送信',
    send: '送信',
    delete: '削除',
    leave: '退出',
    stay: '留まる',
    yes: 'はい',
    no: 'いいえ',
    upgrade: 'プレミアムにアップグレード',
    signIn: 'サインイン',
    signUp: 'サインアップ',
    signOut: 'サインアウト',
    email: 'メール',
    password: 'パスワード',
    forgotPassword: 'パスワードをお忘れですか？',
    resetPassword: 'パスワードをリセット',
    resetPasswordSent: 'パスワードリセットメールを送信しました。受信箱をご確認ください。',
    noAccount: 'アカウントをお持ちでない方',
    hasAccount: 'すでにアカウントをお持ちの方',
    authError: '認証エラーです。もう一度お試しください。',
    landingHero: '本当に機能するアカウンタビリティ',
    landingSubtitle: '目標を共有する匿名のパートナーを見つけましょう。社会的プレッシャーなし。結果だけ。',
    getStarted: '始める — 無料',
    howItWorks: '使い方',
    step1Title: '目標を設定する',
    step1Desc: '取り組んでいることを教えてください。同じような旅路の人とマッチングします。',
    step2Title: 'パートナーと出会う',
    step2Desc: 'あなたのタイムゾーンで匿名のアカウンタビリティパートナーとペアになります。',
    step3Title: '責任を持ち続ける',
    step3Desc: '毎日チェックイン、進捗を共有し、お互いをサポート — 匿名で。',
    pricingTitle: 'シンプルな料金',
    freePlan: '無料',
    premiumPlan: 'プレミアム',
    perMonth: '/月',
    freeFeature1: '1つのアクティブなVeyl',
    freeFeature2: '1日10件のメッセージ',
    freeFeature3: '1日10件の音声メモ',
    freeFeature4: '毎日・毎週のチェックイン',
    freeFeature5: 'グループチャットへのアクセス',
    premiumFeature1: '最大3つのアクティブVeyl',
    premiumFeature2: '無制限のメッセージ',
    premiumFeature3: '無制限の音声メモ',
    premiumFeature4: '優先マッチング',
    faqTitle: 'よくある質問',
    welcomeToVeyl: 'Veylへようこそ',
    chooseLanguage: '言語を選択',
    chooseLanguageDesc: 'Veylで使用したい言語を選択してください。',
    ageVerification: '年齢確認',
    ageVerificationDesc: 'Veylは13歳以上のユーザーが利用できます。',
    areYouOldEnough: '13歳以上ですか？',
    yesIAm: '✅ はい、そうです',
    noImNot: '❌ いいえ、違います',
    mustBe13: '13歳以上である必要があります',
    mustBe13Desc: 'Veylは13歳以上のユーザーのみご利用いただけます。',
    setupProfile: 'プロフィールを設定しましょう',
    stepOf: 'ステップ{step}/4',
    whatsYourName: 'お名前は何ですか？',
    namePlaceholder: 'ニックネームを入力してください',
    whatsYourTimezone: 'タイムゾーンは何ですか？',
    selectTimezone: 'タイムゾーンを選択',
    goalCategory: '目標のカテゴリは何ですか？',
    matchPreference: '誰とマッチングしたいですか？',
    matchNearby: '近くでマッチング',
    matchNearbyDesc: 'タイムゾーンの4時間以内の人とマッチング。',
    matchAnywhere: 'どこでもマッチング',
    matchAnywhereDesc: 'タイムゾーンに関係なく世界中の誰とでもマッチング。',
    describeGoal: '具体的な目標を説明してください',
    goalPlaceholder: "例：'15キロ痩せたい' または 'Pythonを学ぶ'",
    communicationStyle: '好みのコミュニケーションスタイル',
    textMessages: 'テキストメッセージ',
    textMessagesDesc: '便利な時にチャット',
    scheduledCheckins: '定期チェックイン',
    scheduledCheckinsDesc: '毎週の深い振り返り',
    completingSetup: 'マッチングを探しています...',
    completeSetup: 'セットアップを完了',
    agreeToTerms: '続けることで、Veylの',
    termsOfService: '利用規約',
    and: 'と',
    privacyPolicy: 'プライバシーポリシー',
    fitnessHealth: 'フィットネスと健康',
    learningSkills: '学習とスキル',
    businessCareer: 'ビジネスとキャリア',
    creativeProjects: 'クリエイティブプロジェクト',
    findingMatch: 'パートナーを探しています...',
    findingNewMatch: '新しいパートナーを探しています...',
    lookingForSomeone: 'カテゴリで誰かを探しています',
    category: '',
    sharesTimezone: 'あなたのタイムゾーンとコミットメントを共有する人。',
    autoCheck: '5秒ごとに自動的にマッチングを確認します。',
    noMatchYet: 'まだマッチングが見つかりません — 引き続き検索します。',
    checkNow: '今すぐ確認',
    checking: '確認中...',
    manualChecks: '{count}回の手動確認が完了',
    joinCommunity: '🌐 待ちながらコミュニティに参加',
    goToCommunity: '🌐 コミュニティへ',
    previousPartnerNote: '🛡️ 以前のパートナーは再度提案されません。',
    joining: '参加中...',
    overview: '概要',
    chat: 'チャット',
    checkin: 'チェックイン',
    group: 'グループ',
    community: 'コミュニティ',
    notifications: '通知',
    settings: '設定',
    yourGoal: 'あなたの目標',
    yourPartner: 'あなたのパートナー',
    you: 'あなた',
    unveiled: '✨ 公開済み',
    goalComplete: '✓ 目標達成',
    adjustGoal: '目標を調整する',
    unveilButton: '✨ 公開する — やり遂げました！',
    goalCategory2: 'カテゴリ',
    goalDescription: '説明',
    timezone: 'タイムゾーン',
    loadingPartner: 'パートナー情報を読み込み中...',
    waitingForMatch: 'チャットを開始するためのマッチングを待っています。',
    noMessagesYet: 'まだメッセージがありません。パートナーに挨拶しましょう！',
    typeMessage: 'メッセージを入力...',
    dailyLimitReached: '1日の上限に達しました — プレミアムにアップグレード',
    unmatch: '🔓 マッチング解除',
    report: '🚩 報告',
    unmatchWarning: '⚠️ マッチング解除により、チャット履歴全体が削除されます。この操作は元に戻せません。',
    yesUnmatch: 'はい、解除します',
    unmatching: '解除中...',
    deleteMessage: '🗑 削除',
    deleting: '削除中...',
    checkIn: 'チェックイン',
    submitDaily: '毎日のチェックインを送信',
    submitWeekly: '毎週のチェックインを送信',
    submitting: '送信中...',
    checkinSubmitted: 'チェックインを送信しました！',
    viewHistory: '履歴を見る',
    notificationsTitle: '通知',
    clearAll: 'すべて削除',
    noNotifications: 'まだ通知はありません。',
    settingsTitle: '設定',
    settingsDesc: '匿名のアイデンティティをパーソナライズ。',
    saveAvatar: 'アバターを保存',
    appearance: '外観',
    lightMode: '☀️ ライト',
    darkMode: '🌙 ダーク',
    changeNickname: 'ニックネームを変更',
    saveNickname: 'ニックネームを保存',
    deleteAccount: 'アカウントを削除',
    deleteAccountDesc: 'アカウントと関連するすべてのデータを永久に削除します。',
    languageLabel: '言語',
    languageDesc: '使用する言語を選択してください。',
    signOut: 'サインアウト',
    updating: '更新中...',
    unveil: '公開する',
    clearing: 'クリア中...',
    notifMatchFound: 'マッチング成立',
    notifGoalAchieved: '目標達成',
    notifSupport: 'サポートメッセージ',
    notifUnmatched: 'マッチング解除通知',
    notifMatchRequest: 'マッチングリクエスト',
    notificationPrefs: '通知設定',
    notificationPrefsDesc: '特定の通知タイプを個別にミュートします。',
    muted: 'ミュート中',
    active: 'アクティブ',
    all: 'すべて',
    justNow: 'たった今',
    minsAgo: '{count}分前',
    hoursAgo: '{count}時間前',
    daysAgo: '{count}日前',
    leaving: '退出中...',
    myHistory: '📋 マイ履歴',
    partnersProgress: '👤 {name}の進捗',
    myCheckinHistory: 'チェックイン履歴',
    checkinsForVeyl: 'このVeylの{count}回チェックイン',
    noCheckinsYet: 'まだチェックインがありません。最初の1回を始めましょう！',
    newCheckinBtn: '新しいチェックイン',
    partnerNoCheckins: '{name}はまだチェックインしていません。',
    dailyNotesPrivate: '毎日のメモはプライベートです',
    goalAchievedMarked: '🎉 目標を達成済みとしてマーク',
    goalAchievedNote: '🎉 目標が達成済みとしてマークされました！概要に戻って公開しましょう。',
    veylComplete: '✓ このVeylは完了しました。チェックインは読み取り専用です。',
    goalAlreadyAchieved: '🎉 目標を達成済みとしてマークしました！概要に戻って公開しましょう。',
    didYouWork: '今日、目標に取り組みましたか？',
    howDidWeekGo: '今週、目標の進捗はどうでしたか？',
    whatGotInWay: '何が妨げになりましたか？（任意）',
    honestNote: '正直に答えてください。パートナーはサポートするためにいます。判断しません。',
    whatDidYouLearn: '今週、自分自身についてどんなことを学びましたか？',
    insightsPlaceholder: 'どんな洞察を得ましたか？',
    whatPatterns: 'どんなパターンに気づいていますか？',
    patternsPlaceholder: '繰り返し現れるテーマや障害はありますか？',
    whatChange: '来週に向けて何を変える必要がありますか？',
    changePlaceholder: 'どんなことを違うやり方でしますか？',
    goalAchievedQuestion: '🏆 全体的な目標を達成しましたか？',
    yesDidIt: '🎉 はい、やり遂げました！',
    notYetBtn: 'まだです',
    didIt: '✅ できた',
    didSome: '😐 少しできた',
    didntDoIt: '❌ できなかった',
    metCommitment: '✅ コミットメント達成',
    partialProgress: '😐 部分的な進歩',
    noProgress: '❌ 進歩なし',
    rethinkingGoal: '🤔 目標を再考中',
    yesLabel: '✅ はい',
    aLittle: '😐 少し',
    noLabel: '❌ いいえ',
    madeProgress: '今日進歩できた',
    didSomething: '何かできた、全部ではない',
    didntWork: '今日は取り組めなかった',
    metWeekly: '週次のコミットメント達成',
    madePartial: '部分的な進歩あり',
    didntMake: '進歩できなかった',
    needToAdjust: 'アプローチを調整する必要あり',
    learnedLabel: '学んだこと：',
    patternLabel: 'パターン：',
    nextWeekLabel: '来週：',
    joinGroup: 'グループに参加',
    joinGroupDesc: 'グループは同じような目標に取り組む5人を集めます。匿名、サポーティブ、プレッシャーなし。',
    whatToExpect: '期待できること',
    expectAnonymous: '全員が匿名のまま — 同じシルエットアバター',
    expectMatched: '関連したサポートのために目標カテゴリでマッチング',
    expectMembers: '1グループ最大5人',
    expectChat: 'グループチャット — 1日20件のメッセージと5件の音声メモが無料·Premiumなら無制限',
    findOrCreate: 'グループを探す・作る',
    findingGroup: 'グループを検索中...',
    oneGroupNote: '一度に参加できるグループは1つだけです。無料ユーザーもPremiumユーザーもグループにアクセスできます。',
    groupCreated: 'グループ作成！',
    groupJoined: 'グループに参加しました！',
    groupCreatedDesc: '{category}の新しいグループを作成しました。他の人もまもなく参加します。',
    groupJoinedDesc: '既存の{category}グループに参加しました。挨拶しましょう！',
    switchToGroup: 'ダッシュボードのグループタブに切り替えてチャットを始めましょう。',
    groupMembers: 'グループメンバー',
    backToChat: '← チャットに戻る',
    creator: '★ 作成者',
    joined: '参加済み',
    leaveGroup: 'グループを退出',
    leaveGroupTitle: 'このグループを退出しますか？',
    leaveGroupDesc: 'グループチャットへのアクセスを失いますが、いつでも新しいグループに参加できます。',
    membersBtn: '👥 メンバー',
    noGroupMessages: 'まだメッセージがありません。最初に挨拶しましょう！',
    messageGroup: 'グループにメッセージを送る...',
    groupDailyLimit: '1日のグループメッセージ上限に達しました（{limit}/日）。Premiumにアップグレードして無制限に。',
    groupVoiceLimit: '1日の音声メモ上限に達しました。',
    veylCommunity: 'Veylコミュニティ',
    communityDesc: 'マッチングを待ちながら、同じ目標カテゴリに取り組む仲間と交流しましょう。',
    communityJoinNote: 'マッチングを探しながら、待機ページからコミュニティに参加できます。',
    leaveCommunity: 'このコミュニティを退出しますか？',
    communityLeaveDesc: '待機ページからいつでも再参加できます。',
    matchRequests: 'マッチングリクエスト',
    incoming: '受信済み',
    sent: '送信済み',
    noIncoming: '受信したリクエストはありません。',
    noPending: '保留中の送信リクエストはありません。',
    requestToAnonymous: '匿名ユーザーへのリクエスト',
    pending: '保留中',
    decline: '断る',
    accept: '✅ 承認',
    requestWaiting: '🤝 {count}件のマッチングリクエストが届いています',
    view: '見る',
    requestsBtn: '🤝 リクエスト',
    leaveBtn: '退出',
    openToAll: '全員に公開·匿名',
    msgsLeft: '残り{count}件',
    noCommunityMessages: 'まだメッセージがありません。コミュニティに挨拶しましょう！',
    saySomething: 'コミュニティに何か送りましょう...',
    requestMatch: '🤝 マッチングをリクエスト',
    requestSending: '送信中...',
    communityMsgsWarning: '今日のコミュニティメッセージ残り{count}件。',
    communityDailyLimit: '1日のコミュニティメッセージ上限に達しました（{limit}/日）。Premiumで無制限に。',
    matchRequestLimit: '一度に保留できるリクエストは3件までです。',
    matchRequestSent: 'マッチングリクエストを送信しました！',
    matchRequestDuplicate: 'この人にはすでにリクエストを送っています。',
    matchRequestError: 'マッチングリクエストの送信中にエラーが発生しました。もう一度お試しください。',
    matchAcceptError: 'マッチングリクエストの承認中にエラーが発生しました。',
    matchRequestSentAlready: 'この人にはすでにリクエストを送っています。',
    avatar_silhouette: 'シルエット',
    avatar_teal: 'ティール',
    avatar_purple: 'パープル',
    avatar_navy: 'ネイビー',
    avatar_slate: 'スレート',
    avatar_coral: 'コーラル',
    avatar_gold: 'ゴールド',
    avatar_moss: 'モス',
    avatar_indigo: 'インディゴ',
    avatar_unveiled: '公開済み',
    activeLabel: 'アクティブ',
    seekingLabel: '検索中',
    completeLabel: '完了',
    upgradeForMore: '✨ もっとVeylのためにアップグレード',
    newVeyl: '+ 新しいVeyl',
    newVeylTitle: '新しいVeylを始める',
    goalCategoryLabel: '目標カテゴリ',
    goalDescriptionLabel: '目標の説明',
    startVeyl: '新しいVeylを開始',
    starting: '開始中...',
    unveil: '公開する',
    clearing: 'クリア中...',
    nicknameRequired: 'ニックネームは必須です',
    nicknameTooShort: 'ニックネームは最低2文字必要です',
    nicknameTooLong: 'ニックネームは最大20文字です',
    errorSavingNickname: 'ニックネームの保存中にエラーが発生しました',
    errorSavingAvatar: 'アバターの保存中にエラーが発生しました',
    errorDeletingAccount: 'アカウントの削除中にエラーが発生しました',
    deleteMyAccountButton: 'アカウントを削除する',
    goalsAchievedTitle: '達成した目標',
    goalsPrivate: 'プライベート — あなたにのみ表示されます。',
    goalsCompletedCount: '{count}個の目標を達成',
    keepAnonymous: '匿名を保ちましょう。本名は使わないでください。',
    currentNicknameIs: '現在のニックネームは',
    unveiledLocked: '✨ 公開済み — アバターがロックされています',
    howOthersSee: '他の人にはこう見えています',
    unveiledNote: 'このVeylで公開しました。新しいアバターを選ぶには新しいVeylを始めてください。',
    active2: '✓ アクティブ',
    goalsAchieved: '達成した目標',
    goalsAchievedDesc: 'プライベート — あなたにのみ表示されます。',
    goalCompleted: '個の目標完了',
    goalsCompleted: '個の目標完了',
    contactSupport: 'サポートに連絡',
    deleteWarning: '⚠️ これにより全てが完全に削除されます。確認するには下にDELETEと入力してください。',
    typeDelete: '確認するにはDELETEと入力',
    confirmDelete: '削除を確認',
    deleting2: '削除中...',
    messagesLeft: '{count}件のメッセージ · {voiceCount}件の音声メモが今日残っています',
    premiumUnlimited: '✨ Premium — メッセージと音声メモが無制限',
    messagesLeftWarning: '今日{count}件のメッセージが残っています。',
    forUnlimited: '無制限のメッセージのために。',
    voiceNotesLeft: '今日{count}件の音声メモが残っています',
    dailyLimitReachedVoice: '1日の音声メモ上限に達しました。',
    dailyVoiceNoteLimit: '1日の音声メモ上限に達しました。Premiumにアップグレードして無制限に。',
    recording: '録音中...',
    deeper: '低く',
    neutral: 'ニュートラル',
    higher: '高く',
    applyingModulation: '⚙️ モジュレーション適用中...',
    preview: '▶ プレビュー',
    pause: '⏸ 一時停止',
    discard: '破棄',
    recordingTooLarge: '録音が大きすぎます。もっと短いメッセージをお試しください。',
    failedToSend: '送信に失敗しました。もう一度お試しください。',
    micDenied: 'マイクへのアクセスが拒否されました。',
    unmatchMessage: 'パートナーがこのVeylセッションを終了しました。マッチング検索に戻りました。',
    appearanceDesc: 'Veylの表示方法を選択してください。',
    newNickname: '新しいニックネーム',
    nicknamePlaceholder: '例：NightOwl、StriveMode、Kira...',
    chooseAvatar: 'アバターを選択',
    notificationsTitle: '通知',
    notificationsCount: '合計{total}件 · {unread}件未読',
    progressOf: '{name}の進捗',
    fitnessHealth: 'フィットネス＆健康',
    learningSkills: '学習＆スキル',
    businessCareer: 'ビジネス＆キャリア',
    creativeProjects: 'クリエイティブプロジェクト',
    progressOf: '{name}の進捗',
    dailyCheckin: '毎日のチェックイン',
    weeklyCheckin: '毎週のチェックイン',
    dailyCheckinDesc: '簡単な報告：今日は目標に取り組みましたか？',
    weeklyCheckinDesc: '深い振り返り：今週全体はどうでしたか？',
    submitDaily: '毎日のチェックインを送信',
    submitWeekly: '毎週のチェックインを送信',
    submitting: '送信中...',
    checkinSubmitted: 'チェックイン送信完了！',
    checkinSubmittedDesc: '責任を持ち続けて素晴らしいです。{name}があなたの更新を確認します。',
    viewHistory: '履歴を見る',
    newCheckin: '📝 新しいチェックイン',
    myHistory: '📋 私の履歴',
    partnersProgress: '👤 {name}の進捗',
    myCheckinHistory: '私のチェックイン履歴',
    checkinsForVeyl: 'このVeylのチェックイン{count}件',
    noCheckinsYet: 'まだチェックインがありません。最初のものを始めましょう！',
    newCheckinBtn: '新しいチェックイン',
    partnerNoCheckins: '{name}はまだチェックインしていません。',
    dailyNotesPrivate: '毎日のメモはプライベートです',
    goalAchievedMarked: '🎉 目標が達成済みとしてマークされました',
    goalAchievedNote: '🎉 目標が達成済みとしてマークされました！概要ページで公開しましょう。',
    veylComplete: '✓ このVeylは完了しています。チェックインは読み取り専用です。',
    goalAlreadyAchieved: '🎉 目標を達成済みとしてマークしました！概要ページで公開しましょう。',
    didYouWork: '今日は目標に取り組みましたか？',
    howDidWeekGo: '今週の目標はどうでしたか？',
    whatGotInWay: '何が妨げになりましたか？（任意）',
    honestNote: '正直に。パートナーは判断するためではなく、支援するためにいます。',
    whatDidYouLearn: '今週、自分自身について何を学びましたか？',
    insightsPlaceholder: 'どんな気づきがありましたか？',
    whatPatterns: 'どんなパターンに気づいていますか？',
    patternsPlaceholder: '繰り返すテーマや障害はありますか？',
    whatChange: '来週は何を変える必要がありますか？',
    changePlaceholder: '何を違う形でしますか？',
    goalAchievedQuestion: '🏆 全体的な目標を達成しましたか？',
    yesDidIt: '🎉 はい、やり遂げました！',
    notYetBtn: 'まだです',
    didIt: '✅ できた',
    didSome: '😐 少しできた',
    didntDoIt: '❌ できなかった',
    metCommitment: '✅ コミットメントを達成',
    madePartial: '😐 部分的な進捗',
    didntMake: '❌ 進捗なし',
    needToAdjust: '🤔 アプローチを調整する必要があります',
    yesLabel: '✅ はい',
    aLittle: '😐 少し',
    noLabel: '❌ いいえ',
    madeProgress: '今日進捗しました',
    didSomething: '何かしましたが、全部ではありません',
    didntWork: '今日は取り組みませんでした',
    metWeekly: '週次コミットメントを達成しました',
    didntMake: '進捗がありませんでした',
    needToAdjust: 'アプローチを調整する必要があります',
    learnedLabel: '学んだこと：',
    patternLabel: 'パターン：',
    nextWeekLabel: '来週：',
    problemTitle: 'SNSが責任感を壊した',
    problem1: "苦しんでいることを認めるのが怖い",
    problem2: "失敗を隠して学ぼうとしない",
    problem3: "失敗したときパートナーをゴーストする",
    veylIsDifferent: 'Veylは違います。',
    popular: '人気',
    sixMonthDeal: 'または6ヶ月で$20（$3.33/月）',
    getStartedPremium: '始める',
    buildTrust: '信頼を築く',
    unveilIdentity: '準備ができたとき（もしくは準備ができれば）自分の素性を明かす',
    actuallyAchieve: '本当に達成する',
    makeRealProgress: 'パフォーマンスなしで本当の進歩をする',
    faq1q: 'パートナーと合わなかったら？',
    faq1a: '簡単に再マッチできます。質問なし。うまくいかないパートナーシップを強制するより、あなたに合った人を見つけてほしいです。',
    faq2q: 'いつか素性を明かさなければなりませんか？',
    faq2a: 'いいえ。一部のパートナーシップは永遠に匿名のままです。一週間後に明かすものもあります。完全にあなた次第です。',
    faq3q: 'パートナーにゴーストされたら？',
    faq3a: 'プレミアムユーザーは即座に再マッチされます。無料ユーザーは48時間以内に再マッチされます。',
    faq4q: 'なぜプロフィール写真がないのですか？',
    faq4a: '写真を追加した瞬間、印象管理の問題になるからです。テストしました。匿名性が仕事への集中を維持します。',
    legalEnglishOnly: 'この文書は英語のみでご利用いただけます。ご質問はサポートにお問い合わせいただくか、ブラウザの翻訳機能をご利用ください。',
    ctaTitle: "目標を本当に達成する準備はできていますか？",
    ctaSubtitle: "Veylに参加して、今日アカウンタビリティパートナーを見つけましょう。無料で始められます。",
    statAnonymous: "匿名",
    statLanguages: "言語",
    statToStart: "始めるため",
    authTagline: "匿名のアカウンタビリティ。本物の結果。",
    authPricing: "無料で始める · プレミアム月額$5から",
    taglineHonest: "誠実",
    taglineEffective: "効果的",
    foreverLabel: "/永久に",
    premiumTitle: "Veyl プレミアム",
    upgradeTitle: "プレミアムにアップグレード",
    premiumActiveDesc: "Veylのすべての機能に無制限でアクセスできます。",
    upgradeDesc: "すべての制限を解除して、Veylの完全な体験を得ましょう。",
    billedMonthly: "毎月請求",
    bestValue: "最高コスパ",
    perSixMonths: "$3.33/月",
    unlimitedMessages: "メッセージ無制限",
    unlimitedVoice: "ボイスメモ無制限",
    unlimitedGroup: "グループ無制限",
    unlimitedCommunity: "コミュニティ無制限",
    was10day: "以前は10件/日",
    was5day: "以前は5件/日",
    was20day: "以前は20件/日",
    was30day: "以前は30件/日",
    sixMonthPlan: "6ヶ月プラン",
    monthlyPlan: "月額プラン",
    modulationFailed: "変調に失敗しました — 元の音声を使用",
    monthly: "月額",
    sixMonths: "6ヶ月",
    savePercent: "{{percent}}%お得",
    pricePerMonth: "${{price}} / 月",
    priceTotal: "合計 ${{price}}",
    unlimitedMessages: "無制限のメッセージ",
    unlimitedVoiceNotes: "無制限のボイスノート",
    unlimitedGroupMessages: "無制限のグループメッセージ",
    unlimitedCommunityMessages: "無制限のコミュニティメッセージ",
    upgrade: "アップグレード",
    forUnlimited: "無制限で",
    messagesLeftWarning: "本日残り {{count}} 件のメッセージ",
    recordVoiceNote: "ボイスノートを録音",
    uploading: "アップロード中",
    maxDuration: "最大{{seconds}}秒",
    upgradeToPremium: "プレミアムにアップグレード",
    dailyMessageLimitReached: "1日のメッセージ上限に達しました。",
    dailyVoiceLimitReached: "1日のボイスノート上限に達しました。",
    dailyGroupMessageLimitReached: "1日のグループメッセージ上限に達しました。",
    dailyGroupVoiceLimitReached: "1日のグループボイスノート上限に達しました。",
    unlockUnlimited: "すべての機能への無制限アクセスを解除します。",
    maybeLater: "後で",
    premiumUnlimited: "無制限",
    premium: "プレミアム",
    msg: "件",
    msgs: "件",
    newMessageNotification: "{{name}} がメッセージを送信しました 💬",
    newGroupMessageNotification: "{{name}} がグループにメッセージを送信しました 👥",
    someone: "誰か",
    failedToLoad: "読み込みに失敗しました",
    groupMessagesLeftWarning: "本日残り {{count}} 件のメッセージ",
    howOldAreYou: '何歳ですか？',
    minorGroupNote: '同年代のユーザー（13〜17歳）とマッチングされます。',
    adultGroupNote: '他の大人（18歳以上）とマッチングされます。',
    enterYourAge: '年齢を入力してください',
    getStarted:        '始める',
    howItWorks:        '使い方',
    statAnonymous:     '匿名',
    statLanguages:     '言語',
    statToStart:       '無料で始める',
    taglineHonest:     '誠実',
    taglineEffective:  '効果的',
    landingHero:       'パフォーマンスなしのアカウンタビリティ。',
    landingSubtitle:   '目標を共有する匿名のパートナーを見つけましょう。フォロワーなし、プレッシャーなし — 正直な進歩だけ。',
    problemTitle:      'アカウンタビリティは壊れている。',
    problem1:          'ソーシャルメディアは自己改善をパフォーマンスに変えます。いいねのために目標を投稿する、進歩のためではなく。',
    problem2:          '友人や家族は判断や無関心を持ち込みます。本当の誠実さは不可能になります。',
    problem3:          'アカウンタビリティアプリはトラッキングツールのように感じられます — 人間的要素を完全に無視した無味乾燥なダッシュボード。',
    veylIsDifferent:   'Veyl は違います。',
    step1Title:        'プロフィールを作成する',
    step1Desc:         'ペンネームを選び、目標カテゴリを選択し、コミュニケーション設定をします。本当の身元は完全にあなたのものです。',
    step2Title:        'マッチングを受ける',
    step2Desc:         'Veylが同じ目標タイプと年齢グループのパートナーを見つけます。即時 — スクロールもスワイプも不要。',
    step3Title:        '話し始める',
    step3Desc:         'チャットまたはボイスメモを送信。毎日または毎週チェックイン。パートナーがあなたを責任ある状態に保ち、あなたも同様に。',
    buildTrust:        '信頼を築く',
    unveilIdentity:    '成果を記録しましょう。信頼が生まれたら、素性を明かすかどうか選べます。',
    actuallyAchieve:   '実際に達成する',
    makeRealProgress:  '本物の人間との本物の進歩。ゲーミフィケーションなし。あなた、パートナー、そして目標だけ。',
    pricingTitle:      '無料で始め、準備ができたら深く使いましょう。',
    freePlan:          '無料',
    foreverLabel:      '/ 永久',
    freeFeature1:      'アカウンタビリティパートナー1人',
    freeFeature2:      '1日10件のメッセージ',
    freeFeature3: '1日10件の音声メッセージ',
    freeFeature5:      'グループ＆コミュニティルーム',
    popular:           '最も人気',
    premiumPlan:       'プレミアム',
    perMonth:          '/ 月',
    sixMonthDeal: '6ヶ月プランが20ドル — 33%割引',
    premiumFeature1:   '無制限のメッセージ',
    premiumFeature2:   '無制限のボイスメモ',
    premiumFeature3:   'パートナー素性開示機能',
    premiumFeature4:   '優先マッチング',
    getStartedPremium: 'プレミアムを始める',
    faqTitle:          'よくある質問。',
    faq1q: 'Veylは本当に匿名ですか？',
    faq1a: 'はい。ペンネームで登録します。本名、写真、識別情報は一切不要です。パートナーはあなたが共有することを選んだことだけを知ります。',
    faq2q: 'マッチングはどのように機能しますか？',
    faq2a: 'Veylは同じ目標カテゴリと年齢グループの人とあなたをマッチングします。通常2分以内です。',
    faq3q: 'パートナーとうまくいかない場合は？',
    faq3a: 'いつでも質問なしにパートナーを報告またはブロックできます。再マッチングして良い人を見つけましょう。',
    faq4q: '未成年者に安全ですか？',
    faq4a: 'もちろんです。13〜17歳のユーザーは同じ年齢グループのユーザーとのみマッチングされます。これはシステムレベルで強制されています。',
    ctaTitle:    'パートナーはすでに待っています。',
    ctaSubtitle: '無料でVeylに参加しましょう。SNSプロフィール不要。あなた、目標、そして理解してくれる誰かだけ。',
    privacyPolicy:  'プライバシーポリシー',
    termsOfService: '利用規約',
    refundPolicy:   '返金ポリシー',
    featuresTitle: "必要なものすべて。不要なものは一切なし。",
    feature1Title: "完全な匿名性",
    feature1Desc: "ニックネームを選択できます。本名、写真、本人情報は、自分で公開を決めない限り、決して共有されません。",
    feature2Title: "ボイスメモ",
    feature2Desc: "テキストだけでは伝わらないこともあります。アプリ内で直接ボイスメモを録音・送信できます。",
    feature3Title: "年齢に配慮したマッチング",
    feature3Desc: "未成年(13〜17歳)は未成年同士でのみマッチングされます。成人は成人と。例外はありません — システムに組み込まれています。",
    feature4Title: "13言語対応",
    feature4Desc: "英語、スワヒリ語、フランス語、スペイン語、ポルトガル語、ドイツ語、イタリア語、ヒンディー語、インドネシア語、中国語、日本語、韓国語、ハウサ語。",
    feature5Title: "毎日のチェックイン",
    feature5Desc: "構造化されたチェックインでモチベーションを維持。進捗を記録し、パートナーと一緒に成果を祝いましょう。",
    feature6Title: "グループとコミュニティ",
    feature6Desc: "目標別のグループチャットや言語別のコミュニティルームに参加できます。",
    goalsEyebrow: "本当の目標のために",
    goalsTitle: "どんな目標に取り組んでいても。",
    goalsSub: "Veylは、本当の目標を持っているのに、それについて本音で話せる相手がいない、すべての人のためのものです。",
    goalFitness: "フィットネス・健康",
    goalLearning: "学習・スキル",
    goalBusiness: "ビジネス・キャリア",
    goalCreative: "創作プロジェクト",
    moreComingSoon: "他のカテゴリーも近日公開",
    safeTitle: "安全性は機能のひとつではなく、その土台です。",
    safe1Title: "年齢別の分離",
    safe1Desc: "未成年と成人は決して混在しません。年齢は登録時に確認され、固定されます。",
    safe2Title: "報告・ブロック",
    safe2Desc: "どのユーザーも即座に報告・ブロックできます。理由を聞かれることはありません。",
    safe3Title: "データ販売なし",
    safe3Desc: "あなたの目標、メッセージ、身元はすべてあなただけのものです。それだけです。",
    safe4Title: "ニックネームのみ",
    safe4Desc: "本名は一切必要ありません。自分を公開するかどうか、いつ公開するかはあなたが決めます。",
    refundPolicy: "返金ポリシー",
    heroLine1: 'アカウンタビリティ',           
    heroLine2: 'パフォーマンスなしで。',
    mustBe18: 'Veyl をご利用いただくには18歳以上である必要があります',
    mustBe18Desc: 'Veyl は18歳以上の方向けのプラットフォームです。申し訳ございませんが、アカウント作成の最低年齢要件を満たしていません。',
    ageAttestationLabel: '私は18歳以上であることを確認します。',
    ageMisrepresentationNote: '年齢を偽って申告することは利用規約に違反し、アカウントの停止につながる可能性があります。',
    feature3Title: '18歳以上限定・確認済み',
    feature3Desc: '参加前にすべてのメンバーが18歳以上であることを確認します。未成年者は例外なくご利用いただけません。',
    faq4q: 'Veyl は未成年者でも利用できますか？',
    faq4a: 'いいえ。Veyl は18歳以上限定のプラットフォームです。すべてのユーザーは登録時に年齢を確認しており、年齢を偽った場合はアカウントが削除されることがあります。',
    safe1Title: '成人限定',
    safe1Desc: 'Veyl は18歳以上の方専用に設計されています。18歳未満の方が Veyl を利用しようとすることは年齢の虚偽申告にあたり、利用規約違反となります。',
    ageVerificationDesc: 'Veylは18歳以上のユーザーがご利用いただけます。',
    // [auto-synced 2026-08-03]
    adjustYourGoal: '目標を調整する',
    adjustGoalDesc: '方向転換しても構いません。パートナーには通知されます。',
    newGoalDescription: '新しい目標の説明',
    newGoalPlaceholder: '新しい目標、あるいは修正後の目標は何ですか？',
    updateGoal: '目標を更新する',
    goalUpdated: '目標が正常に更新されました！パートナーに通知済みです。',
    readyToUnveil: '発表の準備はできましたか？',
    unveilDesc: '公開をもって、このヴェイルは完了となります。パートナーに通知されます。この操作は取り消せません。',
    yourNewAvatar: 'あなたの新しいアバター',
    notYet: 'まだ',
    unveiling: '公開中…',
    sending: '送信中...',
    checkInDesc: '日々のチェックインは進捗状況を把握するためのものであり、週ごとのチェックインはより深い振り返りのためのものである。',
    dismiss: '✕',
    saving: '保存中...',
    saved: '✓ 保存しました！',
    lightModeDesc: '清潔で明るい',
    darkModeDesc: '目に優しい',
    currentNickname: 'あなたの現在のニックネームは',
    anonymousWarning: '匿名でお願いします。本名は使わないでください。',
    nicknameUpdated: '✓ニックネームが更新されました！',
    deleteMyAccount: 'アカウントを削除する',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'ラサをご紹介します',
    rasaIntroDesc: 'Rasaは、あなただけのプライベートな内省空間です。責任を共有するパートナーとは切り離された、あなただけの空間です。あなたや世界について先入観を持つことはなく、あなたが共有することを選んだ情報からのみ学び、答えを与えるのではなく、問いを投げかけるように設計されています。',
    rasaIntroNotTherapist: 'Rasaはセラピストではありませんし、責任を共有できるパートナーを含めた、本当の人間関係の代わりになるものでもありません。何か重荷に感じることがあれば、Rasaはあなたを優しくサポートへと導いてくれるだけで、Rasa自身がサポート役になろうとはしません。',
    rasaIntroStart: '始める',
    rasaMessagesLeft: '今日残された考察',
    rasaNoMessagesYet: '振り返りたいと思ったら、下の欄に書き込んでください。',
    rasaThinking: 'ラサは反省している…',
    rasaPrivateNote: 'あなただけのプライベートな情報であり、あなたの責任を共有するパートナーには決して公開されません。',
    rasaPlaceholder: '心に浮かんだことをシェアしてください…',
    rasaDailyLimitReached: '本日のRasa使用制限に達しました。明日リセットされます。',
    // [auto-synced 2026-08-06]
    feature7Title: 'ラサをご紹介します',
    feature7Desc: 'あなただけの、じっくりと考えるためのプライベートな空間。責任を共有するパートナーとは別に、あなただけのために用意された空間です。',
    feature8Title: 'いつでもサポートを受けられます',
    feature8Desc: 'ナビゲーション、請求、アカウントに関する質問への回答は、アプリ内ですぐに確認できます。',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Veylサポートチャット',
    supportChatTitle: 'Veylサポート',
    supportChatEmptyState: 'Veylの仕組みについて、何でも質問してください。',
    supportChatPlaceholder: '質問する…',
    supportChatSend: '送信',
    supportChatTyping: 'タイピング…',
    supportChatLimitReached: '本日のサポートチャットの上限に達しました。お急ぎの場合は、support@veyl.spaceまでメールでお問い合わせください。',
    supportChatGenericError: 'エラーが発生しました。もう一度お試しください。',
    // [auto-synced 2026-08-06]
    rasaLoadError: '会話を読み込めませんでした。',
    rasaLoadErrorDetail: '詳細はブラウザのコンソールを確認するか、ページを更新してみてください。',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 {name} さんとマッチングしました！ダッシュボードにアクセスしてください。',
    // [auto-synced 2026-09-08]
    installAppLabel: 'アプリをインストール',
    installMobileOnly: 'モバイル専用',
    installTooltip: 'モバイル端末でのみ利用可能',
    installModalTitle: 'Veylをスマートフォンにインストールしてください。',
    installStep1: 'Safariのツールバーにある共有アイコンをタップします。',
    installStep2: '下にスクロールして「ホーム画面に追加」をタップします。',
    installStep3: '右上隅の「追加」をタップ',
    installGotIt: 'わかった',
    // [auto-synced 2026-09-15]
    relationshipsConnection: '人間関係とつながり',
    homeLifeOrganization: 'ホーム＆ライフオーガナイザー',
    moneyFinancialHabits: 'お金と金銭習慣',
    stayingConnected: 'つながりを保つ',
    independentLiving: '自立生活',
    techConfidence: 'テクノロジーへの信頼',
    // [auto-synced 2026-09-15]
    goalRelationships: '人間関係とつながり',
    goalHomeLife: 'ホーム＆ライフオーガナイザー',
    goalMoney: 'お金と金銭習慣',
    goalStayingConnected: 'つながりを保つ',
    goalIndependentLiving: '自立生活',
    goalTechConfidence: 'テクノロジーへの信頼',
    // [auto-synced 2026-10-28]
    resources: 'リソース',
    resourcesTitle: 'リソース',
    resourcesWriteUps: '記事',
    resourcesLinks: 'さらに読む',
    resourcesOpensNewTab: '新しいタブで開きます',
    resourcesEmptyTitle: 'まだここには何もありません',
    resourcesEmptyBody: 'このカテゴリーに関する資料は現在作成中です。しばらくしてから再度ご確認ください。',
    resourcesNoMatchBody: 'この目標に必要なリソースはまだ見つかっていません。',
    resourcesDisclaimer: '一般的な情報提供のみを目的としており、専門的なアドバイスではありません。健康、安全、または金銭面に影響がある場合は、資格のある専門家にご相談ください。',
    // [auto-synced 2026-10-28]
    resourcesArticles: '記事',
    resourcesMoreToRead: 'もっと読む',
    res_intro_fitnessHealth: 'フィットネスや健康に関する目標は、大きな出来事ではなく、ささやかな日常の積み重ねによって達成されることが多いものです。この記事は、そうしたプレッシャーを少しでも軽減するために書かれたものであり、リンク先は詳細な情報を提供する優れた情報源へと繋がっています。',
    res_fitness_showing_up_title: '見せびらかすより、実際に姿を見せる方がずっと良い',
    res_fitness_showing_up_p1: '私たちのほとんどは、「正しい」運動とはどういうものかというイメージを持っています。ジム、ランニングシューズ、汗をかくこと。生活がそのイメージと合わないとき、運動は自分には向いていないと簡単に決めつけてしまうのです。',
    res_fitness_showing_up_p2: '世界保健機関（WHO）は、より広い視点から運動を評価しています。余暇時間の移動、移動手段、仕事や家庭での活動など、あらゆる運動をカウントします。ウォーキング、サイクリング、スポーツ、遊びなど、スキルレベルを問わず、すべて運動としてカウントされます。WHOのガイドラインでは、どんなに少量でも運動する方が、全く運動しないよりは良いと強調しています。',
    res_fitness_showing_up_p3: 'パートナーと一緒に習慣を身につける場合、それは重要なポイントになります。実際に歩いた短い散歩は、計画していたものの結局サボってしまったハードなトレーニングよりも価値があります。「たった10分しかできなかった」という報告も、継続の糸口となる報告なのです。',
    res_fitness_showing_up_p4: 'また、自分が何をしたかと、それに対してどう感じたかを切り離して考えることも大切です。習慣そのものが大きな成果となる日もあります。集中力や熱意は、参加すること自体がもはや交渉の必要がなくなった後に自然と湧いてくるものです。',
    res_fitness_showing_up_p5: '持病がある場合、妊娠中の場合、または長期間運動をしていない場合は、トレーニングの強度を変更する前に、医師またはその他の資格のある医療専門家と簡単に相談することをお勧めします。',
    res_fitness_rest_title: '休息は計画の一部です',
    res_fitness_rest_p1: 'フィットネスの目標について語る時、睡眠や休息は、本来の努力が終わった後に残るもののように扱われがちです。しかし実際には、睡眠や休息は、努力が持続するかどうかに大きく影響する重要な要素なのです。',
    res_fitness_rest_p2: '睡眠と運動は互いに良い影響を与え合います。英国国民保健サービス（NHS）によると、定期的な運動は睡眠の質を高めるのに役立ち、就寝直前の運動が睡眠を妨げると感じる人もいるため、その場合は日中の早い時間帯に運動するのが適しているかもしれません。どちらも絶対的なルールではありません。重要なのは、自分の体に何が合うのかを自分で見つけることだということを覚えておいてください。',
    res_fitness_rest_p3: 'お互いに責任感を持ち合っている場合、休息も計画的に取るべきです。毎回のチェックインがどれだけ頑張ったかの報告になってしまうと、静かな一日がまるで失敗のように感じられてしまいます。意図的に選んだ休日と、目標から逸れてしまうことは全く別物なので、それを声に出して言うのは全く問題ありません。',
    res_fitness_rest_p4: '長期間にわたって睡眠に本当に苦労している場合や、原因がはっきりしないのに疲労感を感じている場合は、医師やその他の資格のある医療専門家に相談する価値があります。一人で抱え込むべきではありません。',
    res_fitness_food_title: '手間のかからない食事',
    res_fitness_food_p1: '食に関するアドバイスは多岐にわたり、しばしば矛盾しているため、主要な公衆衛生機関はインターネット上の情報よりも寛容であることを知っておくと良いでしょう。',
    res_fitness_food_p2: '世界保健機関（WHO）は、健康的な食生活には様々な形があると述べています。何が賢明な食生活と言えるかは、年齢、ライフスタイル、文化、そして住んでいる地域で実際に手に入る食品によって異なります。WHOは、それらの食生活の根底にある4つの考え方を挙げています。それは、体に必要な栄養素を十分に摂取すること、バランスを保つこと、適度に様々な食品を楽しむこと、そして多種多様な食品を食べることです。WHOが推奨する基本は、加工食品をほとんど含まない、多様な食生活です。',
    res_fitness_food_p3: '誰かと一緒に目標を追求する場合、それは有効な枠組みとなります。パートナーの食生活を真似する必要はありませんし、パートナーもあなたの食生活を真似する必要はありません。食に関する目標は、「もっと頻繁に家で料理をする」とか「今週はいつもとは違うものを食べる」など、あなたの生活スタイルや予算に合ったシンプルなもので構いません。',
    res_fitness_food_p4: '食生活を大きく変えようと考えている場合、あるいは食事によって影響を受ける疾患、アレルギー、または服用中の薬がある場合は、医師または登録栄養士があなたに合ったアドバイスを提供できます。一般的な記事では対応できません。',
    res_fitness_who_physical_activity_note: 'グローバルな視点。活動とみなされるもの、その恩恵を受ける人、そしてその理由について、分かりやすく概説します。',
    res_fitness_who_guidelines_note: '世界規模。年齢別、慢性疾患や障害を持つ人向けの推奨事項を含む、完全なガイドライン。',
    res_fitness_who_healthy_diet_note: 'グローバルな視点から、健康的な食生活の基本原則と、文化や地域の食文化によって食生活が異なる理由を解説します。',
    res_fitness_nhs_sleep_note: '英国。睡眠に関する実践的なアドバイス。本書で言及されている一般開業医（GP）または薬剤師は、英国の医療サービスを指します。',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Veylが閉鎖されたときに通知を受け取る',
    pushPromptBody: 'マッチングが成立した場合、またはパートナーからメッセージが届いた場合は、お知らせします。通知にはメッセージの内容は含まれません。',
    pushEnable: '通知をオンにする',
    pushNotNow: '今じゃない',
    pushError: '通知をオンにする際に問題が発生しました。もう一度お試しください。',
    pushBlockedTitle: '通知がブロックされています',
    pushBlockedBody: 'お使いのブラウザがVeylからの通知をブロックしています。通知を有効にするには、ブラウザのサイト設定でveyl.spaceを開き、通知を許可してからページを再読み込みしてください。',
    pushIosTitle: 'iPhoneで通知を受け取る',
    pushIosBody: 'まず、Veylをホーム画面に追加してください。「共有」をタップし、「ホーム画面に追加」をタップします。その後、ホーム画面からVeylを開き、通知をオンにしてください。',
    pushSettingsTitle: 'このデバイスでの通知',
    pushSettingsDesc: 'Veylが閉じている場合でも、マッチングが成立したときやパートナーからメッセージが届いたときに通知を受け取ることができます。通知にはメッセージの内容は含まれません。この設定はこのデバイスのみに適用されます。',
    pushSettingsUnsupported: 'このブラウザでは通知機能は利用できません。iPhoneまたはiPadでは、まずVeylをホーム画面に追加してから（共有メニューから「ホーム画面に追加」を選択）、そこからVeylを開いてください。',
    pushSettingsBlocked: 'お使いのブラウザでは、Veylの通知がブロックされています。通知を有効にするには、ブラウザのサイト設定でveyl.spaceを開き、通知を許可してからページを再読み込みしてください。',
    pushSettingsWorking: '働く…',
    pushSettingsOn: 'このデバイスでは通知がオンになっています',
    pushSettingsTurnOff: '通知をオフにする',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: '何か新しいことを学ぶには、それを定着させるために十分な頻度で取り組むことが何よりも重要です。これらの記事は長期的な視点に基づいたものであり、リンク先はほぼあらゆることを無料で学べるサイトです。',
    res_learning_small_repeat_title: '繰り返し使えるほど小さい',
    res_learning_small_repeat_p1: '学習目標の多くは、難しすぎるのではなく、大きすぎるために挫折してしまう。「プログラミングを学ぶ」とか「ポルトガル語を流暢に話せるようになる」というのは、目的地であって、火曜日の夜にできるようなことではない。',
    res_learning_small_repeat_p2: '火曜日の夜にできることは、20分間、1つのレッスンに取り組むことです。これは繰り返しできる作業であり、繰り返すことで学習が積み重なっていきます。スキルは少しずつ、静かに身についていくもので、ある日、以前はできなかったことができるようになっていることに気づくでしょう。',
    res_learning_small_repeat_p3: 'こういう時こそ、モチベーションよりも責任を共有できるパートナーの存在が役立ちます。モチベーションは上がったり下がったりするものです。結果を報告してくれるパートナーがいれば、習慣をひっそりとやめるのは難しくなり、うまくいかなかった週の後でも再開しやすくなります。',
    res_learning_small_repeat_p4: '良い進捗報告は、必ずしも素晴らしい内容である必要はありません。「レッスンを1つ受けて、半分くらい理解できました」という正直な報告は、習慣を維持するのに役立ちます。課題の規模は後から大きくすれば良いのです。一度途絶えてしまった習慣を再構築するのは、はるかに困難です。',
    res_learning_beginner_title: '初心者でも構いません',
    res_learning_beginner_p1: '何か新しいことを始めるということは、少なくとも誰か一人の前ではうまくできないということだ。多くの大人にとって、時間やお金よりも、それが本当の障害となる。',
    res_learning_beginner_p2: 'オープンラーニングがどのように普及しているかを知っておくと役立つかもしれません。MIT OpenCourseWareは、数千ものMITのコース教材を登録不要で無料で公開しています。オープン大学のOpenLearnは、約1000もの無料の短期コースを提供しており、受講に条件は一切ありません。科目を試したり、自分に合わないと分かったりするのに、誰かの許可は必要ありません。',
    res_learning_beginner_p3: '何かを試してみて、自分には合わないと判断することも、学びの一つと言えるでしょう。何か一つに決める前に、いくつか試してみるのは、始めるにあたって非常に良い方法です。',
    res_learning_beginner_p4: '自分が遅れをとっていると感じたときは、パートナーも自分の目標について同じように感じているかもしれないことを思い出してください。あなたたちは競争しているわけではありません。どちらも何かのスタート地点に立っていて、ただ場所が違うだけなのです。',
    res_learning_choose_one_title: '一つを選び、それを選び続ける',
    res_learning_choose_one_p1: '無料学習には奇妙な問題がある。それは、量が多すぎるということだ。OpenCourseWareだけでも2,500以上のコースがあり、OpenLearnには1,000近くのコースがある。一晩中閲覧して、それを学習と呼ぶのは簡単だ。',
    res_learning_choose_one_p2: '一つのコース、一冊の本、あるいは一連のレッスンを選び、それ以外は「後で」としておくのが良いでしょう。メモに書き留めておくだけでも構いません。大切なのは、一つを終えてから次のことに取り掛かることです。パートナーに自分が何を選んだかを伝えるのは、小さな約束ですが、継続しやすくなります。',
    res_learning_choose_one_p3: 'リソースの内容と提供されない内容を事前に確認しておくことも重要です。例えば、OpenLearnのコースには参加証明書が発行されますが、中には認定資格ではないデジタルバッジが付与されるものもあります。仕事や学習のために正式な資格が必要な場合は、その点を早めに把握しておくことが大切です。また、志望する教育機関に、どのような資格が認められるかを確認することもできます。',
    res_learning_mit_ocw_note: '世界中で利用可能。MITの数千ものコースの講義ノート、試験問題、ビデオが登録不要で無料で利用できます。英語のみ。',
    res_learning_khan_academy_note: 'グローバルな非営利団体。数学と科学を専門とし、多言語で無料のレッスンと練習問題を提供しています。',
    res_learning_openlearn_note: '英国を拠点とし、誰でも参加可能。約1,000種類の無料短期講座があり、所要時間は約1時間から24時間。各講座には無料の参加証明書が発行されます。',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: '仕事の目標は長期的なものであり、努力の大部分は節目となる目標と目標の間の日々に注ぎ込まれます。この記事では、着実なペースを維持する方法について解説し、リンク先ではスキルアップや次のステップの計画に役立つ無料のリソースをご紹介しています。',
    res_business_progress_title: '仕事における進歩は、めったに一直線ではない。',
    res_business_progress_p1: 'キャリアやビジネスにおける目標は、往々にして長期化するものだ。昇進、転職、あるいは初めての顧客獲得には数ヶ月かかることもあり、その間の日々はなかなか前進している実感を持てない。',
    res_business_progress_p2: '望む結果と、今週実際にできることを切り離して考えることが大切です。企業があなたを採用するかどうか、顧客が承諾するかどうかは、あなたにはコントロールできません。しかし、どれだけの会話をするか、プロジェクトにどれだけの時間を費やすか、そして約束したことをきちんと実行するかどうかは、あなた自身がコントロールできます。',
    res_business_progress_p3: 'そこにこそ、アカウンタビリティ・パートナーの存在意義があるのです。彼らはあなたの業界を理解する必要はありません。ただ、あなたが何をしたのかを尋ね、それをパフォーマンスとして捉えることなく、その答えに耳を傾けるだけで良いのです。',
    res_business_progress_p4: '正直に言うと、「特に何も起こらなかった」週もある。そう口に出して言うことは大切だ。なぜなら、1ヶ月間沈黙してしまった目標は、少しでも意識していた目標よりも、再び取り組むのがはるかに難しいからだ。',
    res_business_start_from_you_title: '仕事から始めるのではなく、あなた自身から始めましょう。',
    res_business_start_from_you_p1: '仕事に行き詰まりを感じたとき、人はつい求人市場を調べようとしがちです。どんな仕事が募集されているのか、給料は良いのか、どんな仕事が魅力的に見えるのか、といった具合です。しかし、別のところから始める方が効果的な場合もあります。',
    res_business_start_from_you_p2: 'OpenLearnの無料コース「職場で成功する」は、まさにこの考えに基づいています。まず、自分自身と自分の価値観を知ることがキャリアプランニングの基礎であるという考え方から始まり、それから履歴書、応募書類、面接へと進んでいきます。',
    res_business_start_from_you_p3: '簡単に言うと、あなたはどんな毎日を送りたいですか？ あまり評価されないけれど、あなたが得意なことは何ですか？ 家族と過ごす時間、安定した収入、創造性を発揮できる空間など、絶対に手放したくないものは何ですか？',
    res_business_start_from_you_p4: 'それらの問題をすべて一人で解決する必要はありません。パートナーと話し合うことで、一人では見過ごしてしまうような事柄が明らかになり、「何か違うものが欲しい」という漠然とした気持ちが、実際に取り組める目標へと変わることもあります。',
    res_business_wear_out_title: '自分を疲れ果てさせることなく、一生懸命働く',
    res_business_wear_out_p1: '野心と疲労は、内面から見ると似ているように見えることがある。特に、その目標が自分にとって重要なものである場合はなおさらだ。',
    res_business_wear_out_p2: '世界保健機関（WHO）は、仕事はメンタルヘルスを守る側面もあれば、害を及ぼす側面もあると指摘している。WHOの職場におけるメンタルヘルスに関するガイドラインでは、過重な業務量や職場での否定的な行動といったリスクを挙げ、健全な職場環境の責任は、個々の労働者だけでなく、雇用主や政府にもあると述べている。',
    res_business_wear_out_p3: 'パートナーと大きな仕事上の目標について話し合う際は、「目標は達成できたか？」だけでなく、「調子はどう？」と尋ねることも大切です。睡眠時間、健康、人間関係を犠牲にしてまで追求している目標は、たとえ計画上は順調に進んでいるように見えても、再考する価値があります。',
    res_business_wear_out_p4: '仕事が健康に影響を与えている場合、あるいは気分が落ち込んだり、不安を感じたり、疲労困憊している状態が続く場合は、医師またはその他の資格のある医療専門家にご相談ください。職場での権利について不明な点がある場合は、労働局や労働者団体など、信頼できる地域の機関に問い合わせて、お住まいの地域の権利について説明を受けることができます。規則は国によって大きく異なります。',
    res_business_who_mh_work_note: 'グローバル向け。主に雇用主や政府機関向けに書かれているため、専門的な内容となっています。要約版はアラビア語、中国語、英語、フランス語、ロシア語、スペイン語で提供されています。',
    res_business_openlearn_entrepreneurship_note: '英国を拠点とするコースです。全8回のセッションで合計24時間。登録不要で受講を開始できます。コース内容には英国のビジネスルールも含まれていますので、ご自身の国に適用されるルールをご確認ください。',
    res_business_openlearn_succeed_note: '約8週間、週3時間程度で、キャリアプランニング、履歴書作成、面接対策を網羅しています。最終更新は2021年なので、求職活動やソーシャルメディアに関する部分はやや古く感じられるかもしれません。',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'タイムゾーン',
    timezoneCurrentIs: '現在のタイムゾーンは',
    timezoneLockNote: '1日のメッセージと音声メモの制限は、お住まいのタイムゾーンの午前0時にリセットされます。公平性を保つため、タイムゾーンを変更できるのは、メッセージや音声メモを一切使用していない日に限り、7日に1回までです。',
    timezoneNew: 'タイムゾーンを選択してください',
    saveTimezone: 'タイムゾーンを保存',
    timezoneUpdated: 'タイムゾーンが更新されました',
    timezoneInvalid: 'そのタイムゾーンは無効です。リストから選択してください。',
    timezoneChangeError: 'タイムゾーンを変更できませんでした。もう一度お試しください。',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'クリエイティブなプロジェクトは、他のあらゆることの合間の隙間に生まれる傾向があります。これらの記事は、長い道のりの中で何かを生き続けさせる方法について述べており、リンク先では、文章の書き方を学ぶこと、クリエイティブな作品を活用すること、そして共有することについて取り上げています。',
    res_creative_finishing_title: 'フィニッシュもスキルの一つです',
    res_creative_finishing_p1: 'クリエイティブなプロジェクトを始めるのは簡単なことだ。アイデアは新鮮で、何でも可能に思える。難しいのは途中、アイデアが実際の作業へと変わり、作業がアイデアの頃よりも遅く、複雑になる時だ。',
    res_creative_finishing_p2: 'プロジェクトが停滞するのはたいていこの段階であり、それは担当者の才能不足が原因であることは稀だ。むしろ、途中の段階にゴールが見えず、誰も見ていないことが原因であることが多い。',
    res_creative_finishing_p3: 'こういう時、「今週は何を作ったの？」と尋ねてくれるパートナーの存在が、大きな違いを生むのです。評価してもらう必要はありません。自分が作ったものを説明する必要があると分かっているだけで、作品に小さな締め切りが生まれ、その小さな締め切りこそが、机やキャンバス、楽器へと再び向き合う原動力となることが多いのです。',
    res_creative_finishing_p4: 'また、目の前の作業において「完了」とは何を意味するのかを明確にすることも重要です。頭の中に完璧なイメージを留めておくよりも、完成度の高いラフバージョンの方が価値があります。完成後でも、いつでも改善できるからです。',
    res_creative_rough_drafts_title: '最初のバージョンを見る必要は誰にもない',
    res_creative_rough_drafts_p1: '多くのクリエイターは、最初の試みが頭の中で思い描いたイメージほど良くないため、ひっそりと創作活動を諦めてしまう。想像したものと、実際に今作れるものとの間にギャップが生じるのはごく普通のことだ。そして、そのギャップは、情熱を最も強く持っている時ほど大きくなることが多い。',
    res_creative_rough_drafts_p2: '信頼できる人に下書きを見せることで、プレッシャーが少し軽減されることがあります。「これは雑な下書きだけど、こういうことをしようとしているんだ」とパートナーに伝えることで、評価ではなく対話になります。相手は、出来栄えよりも、あなたが最後までやり遂げたかどうかの方を気にしているかもしれません。',
    res_creative_rough_drafts_p3: '何かの分野に初めて挑戦する人でも、無理なく始められる方法があります。オープン大学の無料学習サイトであるOpenLearnには、小説執筆の入門コースがあり、まさに初心者向けです。これは数ある例の一つに過ぎず、他の分野のクリエイターよりも作家に適しています。',
    res_creative_rough_drafts_p4: '創作活動における進歩は、必ずしも着実な向上という形をとるとは限りません。ある週は自分が誇りに思える作品を作り、またある週は誰にも見せないような作品を作る。どちらも価値があり、どちらも同じ習慣の一部なのです。',
    res_creative_using_sharing_title: '他人の作品を利用したり、自分の作品を共有したりすること',
    res_creative_using_sharing_p1: 'クリエイティブなプロジェクトでは、画像、音声、テキストなど、他人の素材を使うことがよくあります。そして、いずれは自分の作品を共有したくなることもあるでしょう。どちらの場合も、少し背景知識があると役立ちます。',
    res_creative_using_sharing_p2: 'クリエイティブ・コモンズは、クリエイターが著作権を保持しつつ、他者がクリエイターの作品を自由に利用できるライセンスを公開する非営利団体です。あなたが作った作品を共有したい場合は、クリエイティブ・コモンズのガイドラインでこれらのライセンスの仕組みが説明されています。',
    res_creative_using_sharing_p3: '中にはさらに踏み込んだ取り組みをしている機関もあります。スミソニアン博物館は、CC0と呼ばれるライセンスの下で数百万点の画像とデータを公開しています。これは、クリエイティブなプロジェクトを含め、スミソニアン博物館の許可を得ることなく利用できることを意味します。しかし、同博物館のFAQには、CC0は著作権のみを対象としていると明記されています。プライバシー権や商標権などの他の権利は依然として適用される場合があり、所蔵品の中にはCC0に含まれていないものもあります。',
    res_creative_using_sharing_p4: '著作権に関する規則は国によって異なり、これは一般的な情報であり、法的助言ではありません。プロジェクトが商業的に重要な場合、または使用の可否が不明な場合は、資格のある専門家に相談してください。',
    res_creative_openlearn_fiction_note: '英国を拠点とし、受講開始は無料。小説執筆の入門コースで、参加証明書も無料で発行されます。他のクリエイターよりも作家に適しています。',
    res_creative_cc_license_note: 'グローバルな視点から、著作権を保持したまま、自分の作品を自分が選んだ条件で他者に利用してもらう方法をご紹介します。これは一般的な情報であり、法的助言ではありません。',
    res_creative_smithsonian_open_access_note: '米国の機関が運営しており、誰でも無料で利用できます。CC0ライセンスで公開されている画像とデータについて、そのライセンスで許可される内容と許可されない内容、および除外される項目について説明しています。',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: '人間関係は、大きな出来事よりも、小さな出来事を繰り返し積み重ねることで築かれるものです。この記事では、人との繋がりを維持する方法、研究で最も重要なこととして挙げられていること、そして繋がりを維持するのが難しい場合や、関係が不安定な場合にどう対処すべきかについて解説します。',
    res_relationships_small_gestures_title: '小さな行動が大切です',
    res_relationships_small_gestures_p1: '私たちの多くは、友情や家族の絆を、存在するか存在しないかの二択として捉えがちです。ハーバード大学成人発達研究の責任者であるロバート・ウォールディンガーは、社会生活を、身体の健康状態と同様に、維持管理が必要な生きたシステムだと説明しています。',
    res_relationships_small_gestures_p2: '維持するための行動は、ほんの些細なことで構いません。会いたい人を思い浮かべて、メッセージを送ってみましょう。世界保健機関（WHO）が推奨する日々の行動リストも、同様に控えめなものです。友人に連絡を取る、会話に集中するために携帯電話をしまう、近所の人に挨拶をする、地域のグループに参加する、ボランティア活動をするなどです。',
    res_relationships_small_gestures_p3: '目標達成のために協力してくれるパートナーがいる場合、毎週の質問として「誰に連絡を取ったか？」という問いかけをしてみるのも良いでしょう。具体的で、小さな目標なので、たとえ大変な週でも正直に答えることができます。',
    res_relationships_small_gestures_p4: 'すべてのメッセージに温かい返信が返ってくるわけではない。それもこの仕事の一部だ。ウォールディンガー氏によれば、人々はこうしたささやかなメッセージがいかに温かく受け止められるかに驚くことが多いという。',
    res_relationships_quality_title: '量より質',
    res_relationships_quality_p1: '友人の数、参加するイベントの数、交際相手の有無など、人数で社会生活を測るのは簡単だ。しかし、研究結果は別のところを示している。',
    res_relationships_quality_p2: 'ハーバード大学の成人発達研究は、1938年から人々を追跡調査してきました。研究者たちが参加者の中年期の人生を振り返ったところ、人間関係、特に結婚生活における満足度が、コレステロール値や血圧といった指標よりも、80歳になった時に幸福で健康であるかどうかをより正確に予測できることが分かりました。研究責任者によると、その後、他の研究グループも同様の結果を得ているとのことです。また、必要な人間関係の数に決まった基準はなく、内気な人は外向的な人よりも少ない人間関係で済む場合もあると述べています。',
    res_relationships_quality_p3: '一つ注意点があります。この研究の最初の参加者はハーバード大学の学生と、あるアメリカの都市の若者だったため、すべての人を代表するものではありません。結論は鵜呑みにしない方が良いでしょう。',
    res_relationships_quality_p4: 'この研究が穏やかに示唆しているのは、少なくとも一つ、しっかりとした人間関係、つまり病気や不安な時に頼れる人がいることの方が、大きな交友関係よりも大切だということ。そして、それは決して遅すぎることはない。研究責任者は、予想もしなかった晩年に、親密な友情や愛を見つけた人々の例を挙げている。',
    res_relationships_hard_times_title: '繋がりが難しく、関係が傷つくとき',
    res_relationships_hard_times_p1: '孤独を感じることは、あなたに何か問題があるという意味ではありません。世界保健機関（WHO）の推計によると、世界中の約6人に1人が、あらゆる年齢層で孤独を感じています。WHOは孤独を、自分が望むような人間関係を築けていないときに感じる、苦痛な感情と定義しています。',
    res_relationships_hard_times_p2: '原因としては、健康状態の悪さ、低所得、一人暮らし、あるいはテクノロジーの使い方などが挙げられます。WHOは、問題がより深刻な場合は、どのような支援やサービスが利用できるかを調べる価値があると指摘しています。',
    res_relationships_hard_times_p3: 'もう一つの側面として、傷つける関係性がある。パートナーシップにおける有害な行為には、精神的虐待や支配的な行動に加え、身体的または性的危害も含まれる。',
    res_relationships_hard_times_p4: '身近な人に恐怖を感じている場合、または危害を加えられている場合は、お住まいの地域の緊急電話番号、ヘルプライン、または支援サービスにご連絡ください。適切な番号は国によって異なります。Veylのパートナーは、訓練を受けたカウンセラーではなく、同じ経験を持つ仲間です。もし抱えきれないほど辛い状況であれば、医師やカウンセラーに相談してください。',
    res_relationships_who_social_connection_note: '世界規模。WHOが発表した孤独と社会的つながりに関する2025年報告書の簡潔で専門用語を使わない要約（13ページ）。',
    res_relationships_harvard_gazette_note: '米国発の情報源。ハーバード大学成人発達研究の責任者への質疑応答。研究が人間関係と健康、そして日々の小さなステップについて何を語っているのかを解説。インタビュー形式で、研究の初期参加者はアメリカのある都市出身者だった。',
    res_relationships_who_violence_note: 'グローバルな情報提供。親密なパートナー間暴力の内容と、それがどれほど一般的で、主に女性に影響を与えているかを解説しています。これは情報提供を目的としたものであり、相談窓口ではありません。また、読むのが辛い部分もあるかもしれません。',
  },

  ko: {
    appName: 'Veyl',
    loading: '로딩 중...',
    save: '저장',
    cancel: '취소',
    back: '뒤로',
    continue: '계속',
    done: '완료',
    error: '오류',
    submit: '제출',
    send: '전송',
    delete: '삭제',
    leave: '나가기',
    stay: '남기',
    yes: '예',
    no: '아니요',
    upgrade: '프리미엄으로 업그레이드',
    signIn: '로그인',
    signUp: '회원가입',
    signOut: '로그아웃',
    email: '이메일',
    password: '비밀번호',
    forgotPassword: '비밀번호를 잊으셨나요?',
    resetPassword: '비밀번호 재설정',
    resetPasswordSent: '비밀번호 재설정 이메일이 전송되었습니다. 받은 편지함을 확인하세요.',
    noAccount: '계정이 없으신가요?',
    hasAccount: '이미 계정이 있으신가요?',
    authError: '인증 오류입니다. 다시 시도해 주세요.',
    landingHero: '실제로 작동하는 책임감',
    landingSubtitle: '목표를 공유하는 익명 파트너를 찾으세요. 사회적 압박 없이. 결과만.',
    getStarted: '시작하기 — 무료',
    howItWorks: '작동 방식',
    step1Title: '목표 설정',
    step1Desc: '무엇을 향해 노력하는지 알려주세요. 비슷한 여정의 사람과 매칭해 드립니다.',
    step2Title: '파트너 만나기',
    step2Desc: '같은 시간대의 익명 책임감 파트너와 매칭됩니다.',
    step3Title: '책임감 유지',
    step3Desc: '매일 체크인하고, 진행 상황을 공유하고, 서로 지원하세요 — 익명으로.',
    pricingTitle: '간단한 가격',
    freePlan: '무료',
    premiumPlan: '프리미엄',
    perMonth: '/월',
    freeFeature1: '활성 Veyl 1개',
    freeFeature2: '하루 10개 메시지',
    freeFeature3: '하루 10개 음성 메모',
    freeFeature4: '일일 및 주간 체크인',
    freeFeature5: '그룹 채팅 접근',
    premiumFeature1: '최대 3개의 활성 Veyl',
    premiumFeature2: '무제한 메시지',
    premiumFeature3: '무제한 음성 메모',
    premiumFeature4: '우선 매칭',
    faqTitle: '자주 묻는 질문',
    welcomeToVeyl: 'Veyl에 오신 것을 환영합니다',
    chooseLanguage: '언어 선택',
    chooseLanguageDesc: 'Veyl을 사용할 언어를 선택하세요.',
    ageVerification: '나이 확인',
    ageVerificationDesc: 'Veyl은 13세 이상 사용자를 위한 서비스입니다.',
    areYouOldEnough: '13세 이상이신가요?',
    yesIAm: '✅ 네, 그렇습니다',
    noImNot: '❌ 아니요, 아닙니다',
    mustBe13: '13세 이상이어야 합니다',
    mustBe13Desc: 'Veyl은 13세 이상 사용자만 이용 가능합니다.',
    setupProfile: '프로필을 설정해 봅시다',
    stepOf: '{step}단계 / 4단계',
    whatsYourName: '이름이 무엇인가요?',
    namePlaceholder: '닉네임을 입력하세요',
    whatsYourTimezone: '시간대가 무엇인가요?',
    selectTimezone: '시간대 선택',
    goalCategory: '목표 카테고리가 무엇인가요?',
    matchPreference: '누구와 매칭하고 싶으신가요?',
    matchNearby: '근처에서 매칭',
    matchNearbyDesc: '시간대 4시간 이내의 사람들과 매칭합니다.',
    matchAnywhere: '어디서든 매칭',
    matchAnywhereDesc: '시간대에 관계없이 전 세계 누구와도 매칭합니다.',
    describeGoal: '구체적인 목표를 설명해 주세요',
    goalPlaceholder: "예: '15kg 감량하고 싶다' 또는 'Python 배우기'",
    communicationStyle: '선호하는 소통 방식',
    textMessages: '문자 메시지',
    textMessagesDesc: '편할 때 채팅',
    scheduledCheckins: '예정된 체크인',
    scheduledCheckinsDesc: '주간 심층 성찰',
    completingSetup: '매칭 찾는 중...',
    completeSetup: '설정 완료',
    agreeToTerms: '계속함으로써 Veyl의',
    termsOfService: '서비스 약관',
    and: '및',
    privacyPolicy: '개인정보 처리방침',
    fitnessHealth: '피트니스 & 건강',
    learningSkills: '학습 & 기술',
    businessCareer: '비즈니스 & 커리어',
    creativeProjects: '창의적 프로젝트',
    findingMatch: '파트너를 찾고 있습니다...',
    findingNewMatch: '새로운 파트너를 찾고 있습니다...',
    lookingForSomeone: '카테고리에서 누군가를 찾고 있습니다',
    category: '',
    sharesTimezone: '시간대와 헌신을 공유하는 사람.',
    autoCheck: '5초마다 자동으로 매칭을 확인합니다.',
    noMatchYet: '아직 매칭을 찾지 못했습니다 — 계속 시도합니다.',
    checkNow: '지금 확인',
    checking: '확인 중...',
    manualChecks: '{count}번 수동 확인 완료',
    joinCommunity: '🌐 기다리는 동안 커뮤니티 참여',
    goToCommunity: '🌐 커뮤니티로 이동',
    previousPartnerNote: '🛡️ 이전 파트너는 다시 추천되지 않습니다.',
    joining: '참여 중...',
    overview: '개요',
    chat: '채팅',
    checkin: '체크인',
    group: '그룹',
    community: '커뮤니티',
    notifications: '알림',
    settings: '설정',
    yourGoal: '나의 목표',
    yourPartner: '나의 파트너',
    you: '나',
    unveiled: '✨ 공개됨',
    goalComplete: '✓ 목표 달성',
    adjustGoal: '목표 조정',
    unveilButton: '✨ 공개하기 — 해냈습니다!',
    goalCategory2: '카테고리',
    goalDescription: '설명',
    timezone: '시간대',
    loadingPartner: '파트너 정보를 불러오는 중...',
    waitingForMatch: '채팅을 시작할 매칭을 기다리고 있습니다.',
    noMessagesYet: '아직 메시지가 없습니다. 파트너에게 인사해 보세요!',
    typeMessage: '메시지를 입력하세요...',
    dailyLimitReached: '일일 한도 도달 — 프리미엄으로 업그레이드',
    unmatch: '🔓 매칭 해제',
    report: '🚩 신고',
    unmatchWarning: '⚠️ 매칭 해제 시 채팅 기록 전체가 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
    yesUnmatch: '네, 해제합니다',
    unmatching: '해제 중...',
    deleteMessage: '🗑 삭제',
    deleting: '삭제 중...',
    checkIn: '체크인',
    submitDaily: '일일 체크인 제출',
    submitWeekly: '주간 체크인 제출',
    submitting: '제출 중...',
    checkinSubmitted: '체크인이 제출되었습니다!',
    viewHistory: '내 기록 보기',
    notificationsTitle: '알림',
    clearAll: '모두 지우기',
    noNotifications: '아직 알림이 없습니다.',
    settingsTitle: '설정',
    settingsDesc: '익명 정체성을 개인화하세요.',
    saveAvatar: '아바타 저장',
    appearance: '외관',
    lightMode: '☀️ 라이트',
    darkMode: '🌙 다크',
    changeNickname: '닉네임 변경',
    saveNickname: '닉네임 저장',
    deleteAccount: '계정 삭제',
    deleteAccountDesc: '계정과 모든 관련 데이터를 영구적으로 삭제합니다.',
    languageLabel: '언어',
    languageDesc: '선호하는 언어를 선택하세요.',
    signOut: '로그아웃',
    updating: '업데이트 중...',
    unveil: '공개하기',
    clearing: '지우는 중...',
    notifMatchFound: '매칭 성사',
    notifGoalAchieved: '목표 달성',
    notifSupport: '지원 메시지',
    notifUnmatched: '매칭 해제 알림',
    notifMatchRequest: '매칭 요청',
    notificationPrefs: '알림 설정',
    notificationPrefsDesc: '특정 알림 유형을 개별적으로 음소거합니다.',
    muted: '음소거됨',
    active: '활성',
    all: '전체',
    justNow: '방금 전',
    minsAgo: '{count}분 전',
    hoursAgo: '{count}시간 전',
    daysAgo: '{count}일 전',
    leaving: '나가는 중...',
    myHistory: '📋 내 기록',
    partnersProgress: '👤 {name}의 진행 상황',
    myCheckinHistory: '내 체크인 기록',
    checkinsForVeyl: '이 Veyl의 {count}번 체크인',
    noCheckinsYet: '아직 체크인이 없습니다. 첫 번째를 시작하세요!',
    newCheckinBtn: '새 체크인',
    partnerNoCheckins: '{name}은(는) 아직 체크인하지 않았습니다.',
    dailyNotesPrivate: '일일 메모는 비공개입니다',
    goalAchievedMarked: '🎉 목표가 달성됨으로 표시되었습니다',
    goalAchievedNote: '🎉 목표가 달성됨으로 표시되었습니다! 개요 탭에서 공개하세요.',
    veylComplete: '✓ 이 Veyl은 완료되었습니다. 체크인은 읽기 전용입니다.',
    goalAlreadyAchieved: '🎉 목표를 달성됨으로 표시했습니다! 개요 탭에서 공개하세요.',
    didYouWork: '오늘 목표를 위해 노력하셨나요?',
    howDidWeekGo: '이번 주 목표 진행은 어땠나요?',
    whatGotInWay: '무엇이 방해가 되었나요? (선택 사항)',
    honestNote: '솔직하게 답해주세요. 파트너는 판단하는 게 아니라 응원하기 위해 있습니다.',
    whatDidYouLearn: '이번 주 자신에 대해 무엇을 배웠나요?',
    insightsPlaceholder: '어떤 통찰을 얻었나요?',
    whatPatterns: '어떤 패턴을 발견하고 있나요?',
    patternsPlaceholder: '반복되는 주제나 장애물이 있나요?',
    whatChange: '다음 주를 위해 무엇을 바꿔야 하나요?',
    changePlaceholder: '무엇을 다르게 할 건가요?',
    goalAchievedQuestion: '🏆 전체 목표를 달성하셨나요?',
    yesDidIt: '🎉 네, 해냈습니다!',
    notYetBtn: '아직이요',
    didIt: '✅ 했어요',
    didSome: '😐 조금 했어요',
    didntDoIt: '❌ 못 했어요',
    metCommitment: '✅ 다짐을 지켰어요',
    partialProgress: '😐 부분적으로 진전',
    noProgress: '❌ 진전 없음',
    rethinkingGoal: '🤔 목표 재고 중',
    yesLabel: '✅ 예',
    aLittle: '😐 조금',
    noLabel: '❌ 아니요',
    madeProgress: '오늘 진전이 있었어요',
    didSomething: '무언가 했지만, 전부는 아니에요',
    didntWork: '오늘 이것에 노력하지 않았어요',
    metWeekly: '주간 다짐을 지켰어요',
    madePartial: '부분적인 진전이 있었어요',
    didntMake: '진전이 없었어요',
    needToAdjust: '접근 방식을 조정해야 해요',
    learnedLabel: '배운 점: ',
    patternLabel: '패턴: ',
    nextWeekLabel: '다음 주: ',
    joinGroup: '그룹 참여',
    joinGroupDesc: '그룹은 비슷한 목표를 가진 최대 5명이 모입니다. 익명, 서로 지지, 부담 없음.',
    whatToExpect: '기대할 수 있는 것',
    expectAnonymous: '모든 사람이 익명으로 유지됩니다 — 동일한 실루엣 아바타',
    expectMatched: '관련 지원을 위한 목표 카테고리별 매칭',
    expectMembers: '그룹당 최대 5명',
    expectChat: '그룹 채팅 — 하루 20개 메시지와 5개 음성 메모 무료·Premium은 무제한',
    findOrCreate: '그룹 찾기 또는 만들기',
    findingGroup: '그룹을 찾고 있습니다...',
    oneGroupNote: '한 번에 한 그룹에만 참여할 수 있습니다. 무료 및 Premium 사용자 모두 그룹에 접근할 수 있습니다.',
    groupCreated: '그룹 생성됨!',
    groupJoined: '그룹에 참여했습니다!',
    groupCreatedDesc: '새로운 {category} 그룹을 시작했습니다. 다른 사람들이 곧 합류할 거예요.',
    groupJoinedDesc: '기존 {category} 그룹에 참여했습니다. 인사해 보세요!',
    switchToGroup: '채팅을 시작하려면 대시보드의 그룹 탭으로 전환하세요.',
    groupMembers: '그룹 멤버',
    backToChat: '← 채팅으로 돌아가기',
    creator: '★ 개설자',
    joined: '참여함',
    leaveGroup: '그룹 나가기',
    leaveGroupTitle: '이 그룹을 나가시겠어요?',
    leaveGroupDesc: '그룹 채팅에 대한 접근을 잃게 되며, 언제든지 새 그룹에 참여할 수 있습니다.',
    membersBtn: '👥 멤버',
    noGroupMessages: '아직 메시지가 없습니다. 첫 인사를 해보세요!',
    messageGroup: '그룹에 메시지 보내기...',
    groupDailyLimit: '일일 그룹 메시지 한도에 도달했습니다 ({limit}/일). 무제한 메시지를 위해 Premium으로 업그레이드하세요!',
    groupVoiceLimit: '일일 음성 메모 한도에 도달했습니다.',
    veylCommunity: 'Veyl 커뮤니티',
    communityDesc: '매칭을 기다리는 동안 같은 목표 카테고리에서 노력하는 다른 사람들과 함께하세요.',
    communityJoinNote: '매칭을 찾는 동안 대기 페이지에서 커뮤니티에 참여하세요.',
    leaveCommunity: '이 커뮤니티를 떠나시겠어요?',
    communityLeaveDesc: '대기 페이지에서 언제든지 다시 참여할 수 있습니다.',
    matchRequests: '매칭 요청',
    incoming: '받은 요청',
    sent: '보낸 요청',
    noIncoming: '받은 요청이 없습니다.',
    noPending: '보류 중인 보낸 요청이 없습니다.',
    requestToAnonymous: '익명 사용자에게 요청',
    pending: '대기 중',
    decline: '거절',
    accept: '✅ 수락',
    requestWaiting: '🤝 {count}개의 매칭 요청이 기다리고 있습니다',
    view: '보기',
    requestsBtn: '🤝 요청',
    leaveBtn: '나가기',
    openToAll: '모두에게 공개 · 익명',
    msgsLeft: '메시지 {count}개 남음',
    noCommunityMessages: '아직 메시지가 없습니다. 커뮤니티에 인사해 보세요!',
    saySomething: '커뮤니티에 말을 건네보세요...',
    requestMatch: '🤝 매칭 요청',
    requestSending: '전송 중...',
    communityMsgsWarning: '오늘 커뮤니티 메시지 {count}개 남았습니다.',
    communityDailyLimit: '일일 커뮤니티 메시지 한도에 도달했습니다 ({limit}/일). 무제한을 위해 Premium으로 업그레이드하세요!',
    matchRequestLimit: '한 번에 최대 3개의 대기 중인 요청만 가질 수 있습니다.',
    matchRequestSent: '매칭 요청이 성공적으로 전송되었습니다!',
    matchRequestDuplicate: '이미 이 사람에게 요청을 보냈습니다.',
    matchRequestError: '매칭 요청 전송 중 오류가 발생했습니다. 다시 시도해 주세요.',
    matchAcceptError: '매칭 요청 수락 중 오류가 발생했습니다.',
    matchRequestSentAlready: '이미 이 사람에게 요청을 보냈습니다.',
    avatar_silhouette: '실루엣',
    avatar_teal: '청록색',
    avatar_purple: '보라색',
    avatar_navy: '남색',
    avatar_slate: '슬레이트',
    avatar_coral: '산호색',
    avatar_gold: '금색',
    avatar_moss: '이끼색',
    avatar_indigo: '인디고',
    avatar_unveiled: '공개됨',
    activeLabel: '활성',
    seekingLabel: '찾는 중',
    completeLabel: '완료',
    upgradeForMore: '✨ 더 많은 Veyls를 위해 업그레이드',
    newVeyl: '+ 새 Veyl',
    newVeylTitle: '새 Veyl 시작',
    goalCategoryLabel: '목표 카테고리',
    goalDescriptionLabel: '목표 설명',
    startVeyl: '새 Veyl 시작',
    starting: '시작 중...',
    unveil: '공개하기',
    clearing: '지우는 중...',
    nicknameRequired: '닉네임은 필수입니다',
    nicknameTooShort: '닉네임은 최소 2자 이상이어야 합니다',
    nicknameTooLong: '닉네임은 최대 20자까지 가능합니다',
    errorSavingNickname: '닉네임 저장 중 오류 발생',
    errorSavingAvatar: '아바타 저장 중 오류 발생',
    errorDeletingAccount: '계정 삭제 중 오류 발생',
    deleteMyAccountButton: '내 계정 삭제',
    goalsAchievedTitle: '달성한 목표',
    goalsPrivate: '비공개 — 나만 볼 수 있습니다.',
    goalsCompletedCount: '{count}개의 목표 완료',
    keepAnonymous: '익명을 유지하세요. 실명을 사용하지 마세요.',
    currentNicknameIs: '현재 닉네임은',
    unveiledLocked: '✨ 공개됨 — 아바타가 잠겼습니다',
    howOthersSee: '다른 사람들에게는 이렇게 보입니다',
    unveiledNote: '이 Veyl에서 공개했습니다. 새 아바타를 선택하려면 새 Veyl을 시작하세요.',
    active2: '✓ 활성',
    goalsAchieved: '달성한 목표',
    goalsAchievedDesc: '비공개 — 나만 볼 수 있습니다.',
    goalCompleted: '개의 목표 완료',
    goalsCompleted: '개의 목표 완료',
    contactSupport: '지원 문의',
    deleteWarning: '⚠️ 모든 것이 영구적으로 삭제됩니다. 확인하려면 아래에 DELETE를 입력하세요.',
    typeDelete: '확인을 위해 DELETE 입력',
    confirmDelete: '삭제 확인',
    deleting2: '삭제 중...',
    messagesLeft: '메시지 {count}개 · 음성 메모 {voiceCount}개 오늘 남음',
    premiumUnlimited: '✨ Premium — 무제한 메시지 및 음성 메모',
    messagesLeftWarning: '오늘 메시지 {count}개 남았습니다.',
    forUnlimited: '무제한 메시지를 위해.',
    voiceNotesLeft: '오늘 음성 메모 {count}개 남았습니다',
    dailyLimitReachedVoice: '일일 음성 메모 한도에 도달했습니다.',
    dailyVoiceNoteLimit: '일일 음성 메모 한도에 도달했습니다. 무제한을 위해 Premium으로 업그레이드하세요.',
    recording: '녹음 중...',
    deeper: '더 낮게',
    neutral: '중립',
    higher: '더 높게',
    applyingModulation: '⚙️ 변조 적용 중...',
    preview: '▶ 미리듣기',
    pause: '⏸ 일시정지',
    discard: '버리기',
    recordingTooLarge: '녹음이 너무 큽니다. 더 짧은 메시지를 시도해 보세요.',
    failedToSend: '전송 실패. 다시 시도해 주세요.',
    micDenied: '마이크 접근이 거부되었습니다.',
    unmatchMessage: '파트너가 이 Veyl 세션을 종료했습니다. 매칭 검색으로 돌아왔습니다.',
    appearanceDesc: 'Veyl이 어떻게 보일지 선택하세요.',
    newNickname: '새 닉네임',
    nicknamePlaceholder: '예: NightOwl, StriveMode, Kira...',
    chooseAvatar: '아바타 선택',
    notificationsTitle: '알림',
    notificationsCount: '전체 {total}개 · {unread}개 안 읽음',
    progressOf: '{name}의 진행 상황',
    fitnessHealth: '피트니스 & 건강',
    learningSkills: '학습 & 기술',
    businessCareer: '비즈니스 & 커리어',
    creativeProjects: '창의적 프로젝트',
    progressOf: '{name}의 진행 상황',
    dailyCheckin: '매일 체크인',
    weeklyCheckin: '매주 체크인',
    dailyCheckinDesc: '빠른 업데이트: 오늘 목표를 위해 노력했나요?',
    weeklyCheckinDesc: '깊은 성찰: 이번 주는 전반적으로 어땠나요?',
    submitDaily: '매일 체크인 제출',
    ubmitWeekly: '매주 체크인 제출',
    submitting: '제출 중...',
    checkinSubmitted: '체크인 제출 완료!',
    checkinSubmittedDesc: '책임감을 유지하고 있어요. {name}이 업데이트를 확인할 거예요.',
    viewHistory: '내 기록 보기',
    newCheckin: '📝 새 체크인',
    myHistory: '📋 내 기록',
    partnersProgress: '👤 {name}의 진행 상황',
    myCheckinHistory: '내 체크인 기록',
    checkinsForVeyl: '이 Veyl의 체크인 {count}개',
    noCheckinsYet: '아직 체크인이 없어요. 첫 번째를 시작하세요!',
    newCheckinBtn: '새 체크인',
    partnerNoCheckins: '{name}은 아직 체크인하지 않았어요.',
    dailyNotesPrivate: '일일 메모는 비공개입니다',
    goalAchievedMarked: '🎉 목표가 달성됨으로 표시됨',
    goalAchievedNote: '🎉 목표가 달성됨으로 표시되었어요! 개요로 가서 공개하세요.',
    veylComplete: '✓ 이 Veyl은 완료되었습니다. 체크인은 읽기 전용입니다.',
    goalAlreadyAchieved: '🎉 목표를 달성됨으로 표시했어요! 개요로 가서 공개하세요.',
    didYouWork: '오늘 목표를 위해 노력했나요?',
    howDidWeekGo: '이번 주 목표는 어떻게 진행됐나요?',
    whatGotInWay: '무엇이 방해가 됐나요? (선택 사항)',
    honestNote: '솔직하게 말해요. 파트너는 판단이 아닌 지원을 위해 있어요.',
    whatDidYouLearn: '이번 주 자신에 대해 무엇을 배웠나요?',
    insightsPlaceholder: '어떤 통찰을 얻었나요?',
    whatPatterns: '어떤 패턴을 발견하고 있나요?',
    patternsPlaceholder: '반복되는 주제나 장애물이 있나요?',
    whatChange: '다음 주를 위해 무엇을 바꿔야 하나요?',
    changePlaceholder: '무엇을 다르게 할 건가요?',
    goalAchievedQuestion: '🏆 전체 목표를 달성했나요?',
    yesDidIt: '🎉 네, 해냈어요!',
    notYetBtn: '아직 아니에요',
    didIt: '✅ 했어요',
    didSome: '😐 조금 했어요',
    didntDoIt: '❌ 못했어요',
    metCommitment: '✅ 약속을 지켰어요',
    madePartial: '😐 부분적 진전',
    didntMake: '❌ 진전 없음',
    needToAdjust: '🤔 접근 방식을 조정해야 해요',
    yesLabel: '✅ 네',
    aLittle: '😐 조금',
    noLabel: '❌ 아니요',
    madeProgress: '오늘 진전했어요',
    didSomething: '뭔가 했지만 전부는 아니에요',
    didntWork: '오늘은 작업하지 않았어요',
    metWeekly: '주간 약속을 지켰어요',
    didntMake: '진전이 없었어요',
    needToAdjust: '접근 방식을 조정해야 해요',
    learnedLabel: '배운 것: ',
    patternLabel: '패턴: ',
    nextWeekLabel: '다음 주: ',
    problemTitle: 'SNS가 책임감을 망쳤어요',
    problem1: "힘들 때 인정하는 게 두렵습니다",
    problem2: "실패를 숨기고 배우려 하지 않습니다",
    problem3: "실수하면 파트너를 그냥 떠납니다",
    veylIsDifferent: 'Veyl은 다릅니다.',
    popular: '인기',
    sixMonthDeal: '또는 6개월에 $20 ($3.33/월)',
    getStartedPremium: '시작하기',
    buildTrust: '신뢰 쌓기',
    unveilIdentity: '준비됐을 때 (또는 준비되면) 정체를 공개하세요',
    actuallyAchieve: '진짜로 달성하기',
    makeRealProgress: '보여주기 없이 진짜 진전을 이루세요',
    faq1q: '파트너와 맞지 않으면 어떻게 되나요?',
    faq1a: '쉽게 리매치할 수 있어요. 아무 질문 없이요. 작동하지 않는 파트너십을 강요하기보다 올바른 사람을 찾는 것을 선호해요.',
    faq2q: '언젠가 정체를 공개해야 하나요?',
    faq2a: '아니요. 일부 파트너십은 영원히 익명으로 유지됩니다. 일부는 일주일 후에 공개합니다. 완전히 당신에게 달려 있어요.',
    faq3q: '파트너가 저를 잠수 타면 어떻게 되나요?',
    faq3a: '프리미엄 사용자는 즉시 리매치됩니다. 무료 사용자는 48시간 이내에 리매치됩니다.',
    faq4q: '왜 프로필 사진이 없나요?',
    faq4a: '사진을 추가하는 순간 인식 관리가 되기 때문이에요. 테스트했습니다. 익명성이 일에 집중하게 해줍니다.',
    legalEnglishOnly: '이 문서는 영어로만 제공됩니다. 문의사항은 지원팀에 연락하거나 브라우저의 번역 기능을 사용하세요.',
    ctaTitle: "목표를 실제로 달성할 준비가 되셨나요?",
    ctaSubtitle: "Veyl에 가입하고 오늘 책임 파트너를 만나보세요. 무료로 시작할 수 있습니다.",
    statAnonymous: "익명",
    statLanguages: "언어",
    statToStart: "시작 비용",
    authTagline: "익명 책임감. 진짜 결과.",
    authPricing: "무료로 시작 · 프리미엄 월 $5부터",
    taglineHonest: "정직한",
    taglineEffective: "효과적인",
    foreverLabel: "/영원히",
    premiumTitle: "Veyl 프리미엄",
    upgradeTitle: "프리미엄으로 업그레이드",
    premiumActiveDesc: "Veyl의 모든 기능에 무제한으로 액세스할 수 있습니다.",
    upgradeDesc: "모든 제한을 없애고 Veyl의 전체 경험을 즐기세요.",
    billedMonthly: "매월 청구",
    bestValue: "최고 가성비",
    perSixMonths: "$3.33/월",
    unlimitedMessages: "무제한 메시지",
    unlimitedVoice: "무제한 음성 메모",
    unlimitedGroup: "무제한 그룹 채팅",
    unlimitedCommunity: "무제한 커뮤니티",
    was10day: "기존 10개/일",
    was5day: "기존 5개/일",
    was20day: "기존 20개/일",
    was30day: "기존 30개/일",
    sixMonthPlan: "6개월 플랜",
    monthlyPlan: "월간 플랜",
    modulationFailed: "변조 실패 — 원본 음성 사용",
    monthly: "월간",
    sixMonths: "6개월",
    savePercent: "{{percent}}% 절약",
    pricePerMonth: "${{price}} / 월",
    priceTotal: "총 ${{price}}",
    unlimitedMessages: "무제한 메시지",
    unlimitedVoiceNotes: "무제한 음성 노트",
    unlimitedGroupMessages: "무제한 그룹 메시지",
    unlimitedCommunityMessages: "무제한 커뮤니티 메시지",
    upgrade: "업그레이드",
    forUnlimited: "무제한을 위해",
    messagesLeftWarning: "오늘 {{count}}개의 메시지 남음",
    recordVoiceNote: "음성 노트 녹음",
    uploading: "업로드 중",
    maxDuration: "최대 {{seconds}}초",
    upgradeToPremium: "프리미엄으로 업그레이드",
    dailyMessageLimitReached: "일일 메시지 한도에 도달했습니다.",
    dailyVoiceLimitReached: "일일 음성 노트 한도에 도달했습니다.",
    dailyGroupMessageLimitReached: "일일 그룹 메시지 한도에 도달했습니다.",
    dailyGroupVoiceLimitReached: "일일 그룹 음성 노트 한도에 도달했습니다.",
    unlockUnlimited: "모든 기능에 대한 무제한 액세스를 잠금 해제하세요.",
    maybeLater: "나중에",
    premiumUnlimited: "제한 없는",
    premium: "프리미엄",
    msg: "개",
    msgs: "개",
    newMessageNotification: "{{name}} 님이 메시지를 보냈습니다 💬",
    newGroupMessageNotification: "{{name}} 님이 그룹에 메시지를 보냈습니다 👥",
    someone: "누구",
    failedToLoad: "로드 실패",
    groupMessagesLeftWarning: "오늘 {{count}}개의 메시지 남음",
    howOldAreYou: '나이가 어떻게 되세요?',
    minorGroupNote: '같은 연령대의 사용자(13–17세)와 매칭됩니다.',
    adultGroupNote: '다른 성인(18세 이상)과 매칭됩니다.',
    enterYourAge: '나이를 입력하세요',
    getStarted:        '시작하기',
    howItWorks:        '사용 방법',
    statAnonymous:     '익명',
    statLanguages:     '언어',
    statToStart:       '시작하기 위해',
    taglineHonest:     '솔직한',
    taglineEffective:  '효과적인',
    landingHero:       '퍼포먼스 없는 책임감.',
    landingSubtitle:   '목표를 공유하는 익명의 파트너를 찾으세요. 팔로워 없음. 압박 없음 — 오직 진실한 성장만.',
    problemTitle:      '책임감은 무너져 있습니다.',
    problem1:          '소셜 미디어는 자기계발을 퍼포먼스로 만듭니다. 성장이 아닌 좋아요를 위해 목표를 올립니다.',
    problem2:          '친구와 가족은 판단이나 무관심을 가져옵니다. 진정한 솔직함은 불가능해집니다.',
    problem3:          '책임감 앱은 추적 도구처럼 느껴집니다 — 인간적 요소를 완전히 무시한 무미건조한 대시보드.',
    veylIsDifferent:   'Veyl은 다릅니다.',
    step1Title:        '프로필 만들기',
    step1Desc:         '가명을 선택하고 목표 카테고리와 소통 방식을 설정하세요. 실제 정체성은 완전히 내 것으로 유지됩니다.',
    step2Title:        '매칭 받기',
    step2Desc:         'Veyl이 같은 목표 유형과 연령대의 파트너를 찾아줍니다. 즉시 — 스크롤도 스와이프도 없이.',
    step3Title:        '대화 시작하기',
    step3Desc:         '채팅하거나 음성 메모를 보내세요. 매일 또는 매주 체크인하세요. 파트너가 당신에게 책임을 묻고, 당신도 마찬가지입니다.',
    buildTrust:        '신뢰 쌓기',
    unveilIdentity:    '성과를 기록하세요. 신뢰가 쌓이면 정체성을 공개할지 선택할 수 있습니다.',
    actuallyAchieve:   '진짜로 달성하기',
    makeRealProgress:  '진짜 사람과의 진짜 성장. 게임화 없음. 오직 당신, 파트너, 그리고 목표.',
    pricingTitle:      '무료로 시작하고 준비되면 더 깊이 사용하세요.',
    freePlan:          '무료',
    foreverLabel:      '/ 영구',
    freeFeature1:      '책임 파트너 1명',
    freeFeature2:      '하루 10개 메시지',
    freeFeature3: '하루에 음성 메모 10개',
    freeFeature5:      '그룹 및 커뮤니티 방',
    popular:           '가장 인기 있는',
    premiumPlan:       '프리미엄',
    perMonth:          '/ 월',
    sixMonthDeal: '6개월 플랜 20달러 - 33% 할인',
    premiumFeature1:   '무제한 메시지',
    premiumFeature2:   '무제한 음성 메모',
    premiumFeature3:   '파트너 공개 기능',
    premiumFeature4:   '우선 매칭',
    getStartedPremium: '프리미엄 시작',
    faqTitle:          '자주 묻는 질문.',
    faq1q: 'Veyl은 정말 익명인가요?',
    faq1a: '네. 가명으로 가입합니다. 실명, 사진, 식별 정보 없음. 파트너는 당신이 공유하기로 선택한 것만 알게 됩니다.',
    faq2q: '매칭은 어떻게 작동하나요?',
    faq2a: 'Veyl이 같은 목표 카테고리와 연령대의 사람과 매칭해 줍니다. 보통 2분 이내입니다.',
    faq3q: '파트너와 맞지 않으면 어떻게 하나요?',
    faq3a: '언제든지 묻지 않고 신고하거나 차단할 수 있습니다. 다시 매칭하여 더 나은 사람을 찾으세요.',
    faq4q: '미성년자에게 안전한가요?',
    faq4a: '물론입니다. 13–17세 사용자는 같은 연령대의 사용자와만 매칭됩니다. 이는 시스템 수준에서 적용됩니다.',
    ctaTitle:    '파트너가 이미 기다리고 있습니다.',
    ctaSubtitle: 'Veyl에 무료로 가입하세요. 소셜 프로필 불필요. 당신, 당신의 목표, 그리고 이해해 주는 누군가.',
    privacyPolicy:  '개인정보 처리방침',
    termsOfService: '이용약관',
    refundPolicy:   '환불 정책',
    featuresTitle: "필요한 모든 것. 필요 없는 건 하나도 없이.",
    feature1Title: "완전한 익명성",
    feature1Desc: "닉네임을 선택하세요. 실명, 사진, 신원은 본인이 직접 공개하기로 결정하지 않는 한 절대 공유되지 않습니다.",
    feature2Title: "음성 메모",
    feature2Desc: "때로는 타이핑만으로는 부족합니다. 앱 안에서 바로 음성 메모를 녹음하고 보낼 수 있습니다.",
    feature3Title: "연령 안전 매칭",
    feature3Desc: "미성년자(13~17세)는 다른 미성년자와만 매칭됩니다. 성인은 성인과. 예외 없이 — 시스템에 내장되어 있습니다.",
    feature4Title: "13개 언어 지원",
    feature4Desc: "영어, 스와힐리어, 프랑스어, 스페인어, 포르투갈어, 독일어, 이탈리아어, 힌디어, 인도네시아어, 중국어, 일본어, 한국어, 하우사어.",
    feature5Title: "매일 체크인",
    feature5Desc: "체계적인 체크인으로 동력을 유지하세요. 진행 상황을 기록하고 파트너와 함께 성과를 축하하세요.",
    feature6Title: "그룹 & 커뮤니티",
    feature6Desc: "목표별 그룹 채팅과 언어별 커뮤니티 방에 참여하세요.",
    goalsEyebrow: "진짜 목표를 위해",
    goalsTitle: "어떤 목표를 향해 나아가고 있든.",
    goalsSub: "Veyl은 진짜 목표가 있지만 그것에 대해 솔직하게 이야기할 사람이 없는 모든 사람을 위한 곳입니다.",
    goalFitness: "운동 & 건강",
    goalLearning: "학습 & 스킬",
    goalBusiness: "비즈니스 & 커리어",
    goalCreative: "창작 프로젝트",
    moreComingSoon: "더 많은 카테고리가 곧 추가됩니다",
    safeTitle: "안전은 기능이 아닙니다. 그것이 바로 기반입니다.",
    safe1Title: "연령 분리",
    safe1Desc: "미성년자와 성인은 절대 섞이지 않습니다. 가입 시 연령이 확인되고 고정됩니다.",
    safe2Title: "신고 & 차단",
    safe2Desc: "모든 사용자는 즉시 신고하거나 차단할 수 있습니다. 어떤 질문도 받지 않습니다.",
    safe3Title: "데이터 판매 없음",
    safe3Desc: "당신의 목표, 메시지, 신원은 모두 당신의 것입니다. 그게 전부입니다.",
    safe4Title: "닉네임만 사용",
    safe4Desc: "실명은 절대 필요하지 않습니다. 자신을 공개할지, 언제 공개할지는 당신이 결정합니다.",
    refundPolicy: "환불 정책",
    heroLine1: '책임감',                     
    heroLine2: '퍼포먼스 없이.',
    mustBe18: 'Veyl을 이용하려면 18세 이상이어야 합니다',
    mustBe18Desc: 'Veyl은 18세 이상을 위한 플랫폼입니다. 죄송하지만 계정을 생성하기 위한 최소 연령 요건을 충족하지 않습니다.',
    ageAttestationLabel: '본인은 18세 이상임을 확인합니다.',
    ageMisrepresentationNote: '연령을 허위로 기재하는 것은 서비스 약관을 위반하며 계정 정지로 이어질 수 있습니다.',
    feature3Title: '18세 이상만 인증 가능',
    feature3Desc: '모든 회원은 가입 전 18세 이상임을 확인합니다. 미성년자는 예외 없이 이용할 수 없습니다.',
    faq4q: 'Veyl은 미성년자도 이용할 수 있나요?',
    faq4a: '아니요. Veyl은 18세 이상만 이용 가능한 플랫폼입니다. 모든 사용자는 가입 시 연령을 확인하며, 연령을 허위로 기재한 계정은 삭제될 수 있습니다.',
    safe1Title: '성인 전용',
    safe1Desc: 'Veyl은 18세 이상을 위해 만들어졌습니다. 18세 미만의 사용자가 Veyl을 이용하려는 시도는 연령 허위 기재에 해당하며, 이는 서비스 약관 위반입니다.',
    ageVerificationDesc: 'Veyl은 18세 이상 사용자만 이용할 수 있습니다.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: '목표를 조정하세요',
    adjustGoalDesc: '방향을 바꿔도 괜찮습니다. 파트너에게 알려드리겠습니다.',
    newGoalDescription: '새로운 목표 설명',
    newGoalPlaceholder: '새로운 목표 또는 수정된 목표는 무엇인가요?',
    updateGoal: '목표 업데이트',
    goalUpdated: '목표가 성공적으로 업데이트되었습니다! 파트너에게 알림이 전송되었습니다.',
    readyToUnveil: '공개할 준비 되셨나요?',
    unveilDesc: '공개를 하면 이 베일이 완료됩니다. 파트너에게 알림이 전송됩니다. 이 작업은 되돌릴 수 없습니다.',
    yourNewAvatar: '당신의 새로운 아바타',
    notYet: '아직 아님',
    unveiling: '공개합니다...',
    sending: '배상...',
    checkInDesc: '일일 점검은 진행 상황을 확인하는 것이고, 주간 점검은 더 심층적인 성찰을 위한 것입니다.',
    dismiss: '✕',
    saving: '절약...',
    saved: '✓ 저장되었습니다!',
    lightModeDesc: '깨끗하고 밝다',
    darkModeDesc: '눈에 편안한',
    currentNickname: '현재 당신의 별명은',
    anonymousWarning: '익명성을 유지하세요. 실명을 사용하지 마세요.',
    nicknameUpdated: '✓ 닉네임이 업데이트되었습니다!',
    deleteMyAccount: '내 계정을 삭제해 주세요',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: '라사를 만나보세요',
    rasaIntroDesc: '라사는 오롯이 당신만을 위한, 책임감을 공유하는 파트너와도 분리된 사적인 성찰 공간입니다. 당신이나 세상에 대한 어떤 선입견도 없이, 당신이 공유하기로 선택한 것에서만 배우고, 정답을 제시하기보다는 질문을 던지도록 설계되었습니다.',
    rasaIntroNotTherapist: 'Rasa는 치료사가 아니며 진정한 인간관계, 특히 당신의 책임감을 함께 나눌 수 있는 파트너를 대체할 수 없습니다. 힘든 일이 생기면 Rasa는 당신이 도움을 받을 수 있는 곳을 부드럽게 안내해 줄 뿐, 직접 나서서 도와주려 하지 않습니다.',
    rasaIntroStart: '시작하다',
    rasaMessagesLeft: '오늘 남긴 생각들',
    rasaNoMessagesYet: '언제든 생각을 정리할 준비가 되면 아래에 입력을 시작하세요.',
    rasaThinking: '라사는 생각에 잠겨 있다…',
    rasaPrivateNote: '본인만 볼 수 있는 비공개 정보이며, 책임 파트너에게는 절대 공개되지 않습니다.',
    rasaPlaceholder: '마음속에 있는 생각을 나눠보세요…',
    rasaDailyLimitReached: '오늘의 Rasa 사용량 한도에 도달했습니다. 내일 초기화됩니다.',
    // [auto-synced 2026-08-06]
    feature7Title: '라사를 만나보세요',
    feature7Desc: '책임감을 공유하는 파트너와 떨어져 오롯이 나 자신만을 위한 사적인 공간에서 생각을 정리해 보세요.',
    feature8Title: '언제든지 지원을 받으세요',
    feature8Desc: '내비게이션, 결제 및 계정 관련 질문에 대한 빠른 답변을 앱에서 바로 확인하세요.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Veyl 지원 채팅',
    supportChatTitle: 'Veyl 지원',
    supportChatEmptyState: 'Veyl의 작동 방식에 대해 무엇이든 물어보세요.',
    supportChatPlaceholder: '질문해 보세요…',
    supportChatSend: '보내다',
    supportChatTyping: '타자…',
    supportChatLimitReached: '오늘 고객 지원 채팅 이용 한도에 도달했습니다. 긴급한 문의 사항은 support@veyl.space로 이메일을 보내주세요.',
    supportChatGenericError: '오류가 발생했습니다. 다시 시도해 주세요.',
    // [auto-synced 2026-08-06]
    rasaLoadError: '대화를 불러올 수 없습니다.',
    rasaLoadErrorDetail: '자세한 내용은 브라우저 콘솔을 확인하거나 새로 고침해 보세요.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 {name}님과 매칭되셨습니다! 대시보드로 이동하세요.',
    // [auto-synced 2026-09-08]
    installAppLabel: '앱 설치',
    installMobileOnly: '모바일 전용',
    installTooltip: '모바일 기기에서만 이용 가능합니다.',
    installModalTitle: 'Veyl을 휴대폰에 설치하세요',
    installStep1: 'Safari 도구 모음에서 공유 아이콘을 탭하세요.',
    installStep2: '아래로 스크롤하여 "홈 화면에 추가"를 탭하세요.',
    installStep3: '오른쪽 상단의 "추가"를 탭하세요.',
    installGotIt: '알았어요',
    // [auto-synced 2026-09-15]
    relationshipsConnection: '관계 및 연결',
    homeLifeOrganization: '가정 및 생활 정리',
    moneyFinancialHabits: '돈과 재정 습관',
    stayingConnected: '연결 상태 유지',
    independentLiving: '독립 생활',
    techConfidence: '기술 자신감',
    // [auto-synced 2026-09-15]
    goalRelationships: '관계 및 연결',
    goalHomeLife: '가정 및 생활 정리',
    goalMoney: '돈과 재정 습관',
    goalStayingConnected: '연결 상태 유지',
    goalIndependentLiving: '독립 생활',
    goalTechConfidence: '기술 자신감',
    // [auto-synced 2026-10-28]
    resources: '자원',
    resourcesTitle: '자원',
    resourcesWriteUps: '글',
    resourcesLinks: '추가 자료',
    resourcesOpensNewTab: '새 탭에서 열립니다',
    resourcesEmptyTitle: '아직 아무것도 없습니다',
    resourcesEmptyBody: '해당 카테고리에 대한 자료를 계속 준비 중입니다. 잠시 후 다시 확인해 주세요.',
    resourcesNoMatchBody: '아직 이 목표를 달성하기 위한 자료를 찾지 못했습니다.',
    resourcesDisclaimer: '본 정보는 일반적인 정보이며 전문적인 조언이 아닙니다. 건강, 안전 또는 금전적인 문제가 발생할 경우, 자격을 갖춘 전문가의 도움을 받으시기 바랍니다.',
    // [auto-synced 2026-10-28]
    resourcesArticles: '조항',
    resourcesMoreToRead: '더 읽어보기',
    res_intro_fitnessHealth: '건강 및 피트니스 목표는 거창한 순간이 아닌 작고 평범한 순간들에서 달성되는 경우가 많습니다. 이 글은 그러한 부담감을 덜어드리고자 작성되었으며, 링크는 자세한 정보를 제공하는 유용한 자료들로 연결됩니다.',
    res_fitness_showing_up_title: '과시하는 것보다는 실제로 나타나는 것이 낫다.',
    res_fitness_showing_up_p1: '대부분의 사람들은 \'제대로 된\' 운동이란 헬스장, 운동화, 땀 흘리는 모습이라고 생각합니다. 하지만 현실이 그 모습과 다를 때, 운동은 자신에게 맞지 않는다고 쉽게 단정짓곤 합니다.',
    res_fitness_showing_up_p2: '세계보건기구(WHO)는 훨씬 더 폭넓은 관점을 취합니다. 여가 시간 동안의 움직임, 장소 이동, 직장이나 집에서의 활동까지 모두 포함합니다. 걷기, 자전거 타기, 스포츠 및 놀이 등 모든 활동은 숙련도와 관계없이 모두 해당됩니다. WHO의 지침은 어떤 활동이든 전혀 활동하지 않는 것보다 낫다는 점을 강조합니다.',
    res_fitness_showing_up_p3: '파트너와 함께 습관을 만들 때는 이런 점이 중요합니다. 실제로 한 짧은 산책은 계획만 세우고 건너뛴 힘든 산책보다 훨씬 더 가치 있습니다. "겨우 10분밖에 못 했어요"라고 말하는 것도 습관 형성을 위한 중요한 과정입니다.',
    res_fitness_showing_up_p4: '또한, 자신이 한 행동과 그 행동이 어떤 느낌이었는지를 분리하는 데 도움이 됩니다. 어떤 날은 습관 자체가 큰 성공일 수도 있습니다. 열정은 나중에, 참여하는 것이 더 이상 협상이 아닌 상태가 되었을 때 생겨날 수 있습니다.',
    res_fitness_showing_up_p5: '건강 문제가 있거나 임신 중이거나 오랫동안 운동을 하지 않았다면, 운동 강도를 바꾸기 전에 의사 또는 다른 자격을 갖춘 의료 전문가와 상담하는 것이 좋습니다.',
    res_fitness_rest_title: '휴식도 계획의 일부입니다',
    res_fitness_rest_p1: '사람들이 운동 목표에 대해 이야기할 때, 수면과 휴식은 보통 본격적인 운동이 끝난 후에 남는 부수적인 것으로 여겨집니다. 하지만 실제로는 운동의 효과를 좌우하는 중요한 요소입니다.',
    res_fitness_rest_p2: '수면과 활동은 서로 영향을 미칩니다. 영국 국민보건서비스(NHS)에 따르면 규칙적인 활동은 수면의 질을 개선하는 데 도움이 되며, 어떤 사람들은 취침 시간에 가까운 운동이 오히려 방해가 된다고 느끼기 때문에 낮 시간에 운동하는 것이 더 적합할 수 있습니다. 하지만 이는 절대적인 규칙은 아닙니다. 결국 자신에게 맞는 방법을 찾는 것은 본인이라는 점을 상기시켜 주는 것입니다.',
    res_fitness_rest_p3: '서로 목표 달성을 독려하는 과정에서 휴식 또한 계획에 포함시키는 것이 중요합니다. 매번 진행 상황을 보고할 때마다 얼마나 무리했는지 따지기만 한다면, 조용히 쉬는 날조차 실패처럼 느껴질 수 있습니다. 의도적으로 선택한 휴식은 목표에서 벗어난 것과는 다르며, 이를 솔직하게 말하는 것도 괜찮습니다.',
    res_fitness_rest_p4: '장기간 수면 장애가 지속되거나, 특별한 이유 없이 피로감을 느낀다면 의사나 다른 자격을 갖춘 의료 전문가와 상담하는 것이 좋습니다. 혼자서 꾹 참고 넘길 문제가 아닙니다.',
    res_fitness_food_title: '번거로움 없이 즐기는 음식',
    res_fitness_food_p1: '식품 관련 조언은 많고 서로 모순되는 경우가 흔하기 때문에, 주요 공공 보건 기관들은 인터넷상의 대부분의 정보보다 더 관대한 입장을 취한다는 것을 알아두는 것이 좋습니다.',
    res_fitness_food_p2: '세계보건기구(WHO)는 건강한 식단에는 여러 가지 형태가 있다고 말합니다. 어떤 식단이 적절한지는 나이, 생활 방식, 문화, 그리고 거주 지역에서 구할 수 있는 식품에 따라 달라집니다. WHO는 모든 건강한 식단의 기본 원칙으로 네 가지를 제시합니다. 즉, 신체에 필요한 영양소를 충분히 섭취하고, 균형을 유지하며, 일부 음식은 적당히 즐기고, 다양한 음식을 섭취하는 것입니다. 가공되지 않은 식품을 중심으로 다양한 음식을 섭취하는 것이 WHO가 강조하는 핵심입니다.',
    res_fitness_food_p3: '다른 사람과 함께 추구하는 목표라면, 그런 관점이 유용합니다. 파트너의 식습관을 따라 할 필요도 없고, 파트너도 당신의 식습관을 따라 할 필요가 없습니다. 음식 관련 목표는 "집에서 더 자주 요리하기" 또는 "이번 주에는 평소 먹던 것 말고 다른 것을 먹어보기"처럼 간단하게 설정할 수 있으며, 각자의 생활 방식과 예산에 맞춰 조정하면 됩니다.',
    res_fitness_food_p4: '식습관에 큰 변화를 줄 생각이거나, 음식이 영향을 미치는 질환, 알레르기 또는 복용 중인 약물이 있는 경우, 의사나 공인 영양사가 개인에게 맞는 조언을 해줄 수 있습니다. 일반적인 정보 제공으로는 충분하지 않습니다.',
    res_fitness_who_physical_activity_note: '글로벌. 활동으로 간주되는 항목, 수혜자 및 그 이유에 대한 간략한 개요.',
    res_fitness_who_guidelines_note: '전 세계적으로 통용되는 지침입니다. 연령대별, 만성 질환자 또는 장애인을 위한 권장 사항을 포함한 전체 가이드라인을 제공합니다.',
    res_fitness_who_healthy_diet_note: '글로벌. 건강한 식단의 원칙과 문화 및 지역 음식에 따라 식단이 달라지는 이유를 설명합니다.',
    res_fitness_nhs_sleep_note: '영국. 실용적인 수면 조언. 본문에서 언급되는 일반의나 약사는 영국 내 의료 서비스를 의미합니다.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'Veyl이 문을 닫으면 알림을 받으세요',
    pushPromptBody: '매칭이 되거나 상대방이 메시지를 보내면 알려드리겠습니다. 알림에는 메시지 내용이 포함되지 않습니다.',
    pushEnable: '알림 켜기',
    pushNotNow: '지금은 안 돼',
    pushError: '알림 기능을 켜는 데 문제가 발생했습니다. 다시 시도해 주세요.',
    pushBlockedTitle: '알림이 차단되었습니다',
    pushBlockedBody: '사용 중인 브라우저에서 Veyl의 알림을 차단하고 있습니다. 알림을 활성화하려면 브라우저의 veyl.space 사이트 설정에서 알림을 허용한 다음 페이지를 새로고침하세요.',
    pushIosTitle: '아이폰에서 알림 받기',
    pushIosBody: '먼저 Veyl을 홈 화면에 추가하세요. \'공유\'를 탭한 다음 \'홈 화면에 추가\'를 탭하고, 홈 화면에서 Veyl을 열어 알림을 켜세요.',
    pushSettingsTitle: '이 기기의 알림',
    pushSettingsDesc: 'Veyl 앱이 꺼져 있어도 매칭이 되거나 파트너가 메시지를 보내면 알림을 받으세요. 알림에는 메시지 내용이 포함되지 않습니다. 이 설정은 해당 기기에만 적용됩니다.',
    pushSettingsUnsupported: '이 브라우저에서는 알림을 사용할 수 없습니다. iPhone 또는 iPad에서는 먼저 Veyl을 홈 화면에 추가한 다음(공유 > 홈 화면에 추가) 홈 화면에서 Veyl을 실행하세요.',
    pushSettingsBlocked: '브라우저에서 Veyl 알림이 차단되어 있습니다. 알림을 활성화하려면 브라우저의 veyl.space 사이트 설정에서 알림을 허용한 다음 페이지를 새로고침하세요.',
    pushSettingsWorking: '일하고 있는…',
    pushSettingsOn: '이 기기에서 알림이 켜져 있습니다.',
    pushSettingsTurnOff: '알림 끄기',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: '새로운 것을 배우는 것은 결국 꾸준히 실천해서 기억에 남는 것이 핵심입니다. 이 글은 장기적인 관점을 제시하며, 링크된 자료들은 거의 모든 것을 무료로 배울 수 있는 곳들입니다.',
    res_learning_small_repeat_title: '반복하기에 충분히 작다',
    res_learning_small_repeat_p1: '학습 목표는 대부분 너무 어려워서가 아니라 너무 커서 실패하는 경우가 많습니다. "코딩을 배우다" 또는 "포르투갈어에 능통해지다"는 최종 목표이지, 화요일 저녁에 달성할 수 있는 일이 아닙니다.',
    res_learning_small_repeat_p2: '화요일 저녁에 할 수 있는 일은 20분 동안 한 가지 레슨을 공부하는 것입니다. 이렇게 반복하는 과정을 통해 학습 효과가 쌓입니다. 기술은 조용히, 조금씩 습득되다가 어느 날 갑자기 전에는 할 수 없었던 것을 해낼 수 있게 된 자신을 발견하게 될 것입니다.',
    res_learning_small_repeat_p3: '이럴 때 동기 부여보다는 책임감을 공유할 수 있는 파트너가 훨씬 더 도움이 됩니다. 동기 부여는 왔다가 사라지곤 하죠. 하지만 결과를 기대하는 파트너가 있다면 조용히 습관을 버리기는 더 어려워지고, 부진한 한 주를 보낸 후에도 다시 시작하기가 더 쉬워집니다.',
    res_learning_small_repeat_p4: '효과적인 점검은 거창할 필요가 없습니다. "한 수업을 들었는데 절반 정도 이해했어요."처럼 솔직한 평가면 충분합니다. 이렇게 하면 학습 습관을 유지하는 데 도움이 됩니다. 나중에 과제의 난이도를 높여갈 수 있습니다. 한 번 중단된 습관을 다시 시작하는 것은 훨씬 더 어렵습니다.',
    res_learning_beginner_title: '초보자여도 괜찮습니다',
    res_learning_beginner_p1: '새로운 일을 시작한다는 것은 적어도 한 사람 앞에서는 서툴다는 것을 의미합니다. 많은 어른들에게 있어 시간이나 돈보다 이것이 진정한 장애물입니다.',
    res_learning_beginner_p2: '개방형 학습이 얼마나 발전했는지 아는 것이 도움이 될 수 있습니다. MIT OpenCourseWare는 수천 개의 MIT 강좌 자료를 무료로 제공하며, 별도의 등록 절차도 필요 없습니다. 오픈 유니버시티의 OpenLearn은 거의 천 개의 무료 단기 강좌를 제공하며, 이용 자격 요건도 없다고 명시하고 있습니다. 어떤 주제든 시도해 보거나, 자신에게 맞지 않는지 알아보는 데 누구의 허락도 필요하지 않습니다.',
    res_learning_beginner_p3: '무언가를 시도해보고 자신에게 맞지 않다고 판단하는 것도 배움의 과정입니다. 하나에 전념하기 전에 여러 가지를 경험해 보는 것은 아주 좋은 시작 방법입니다.',
    res_learning_beginner_p4: '뒤처진다고 느껴질 때는, 파트너도 자신의 목표에 대해 똑같은 감정을 느끼고 있을 수 있다는 것을 기억하세요. 경쟁하는 게 아닙니다. 두 사람 모두 무언가의 시작점에 서 있지만, 서로 다른 위치에 있는 것뿐입니다.',
    res_learning_choose_one_title: '한 가지를 선택하고, 계속해서 그것을 선택하세요.',
    res_learning_choose_one_p1: '무료 학습에는 이상한 문제가 있습니다. 바로 너무 많은 무료 학습 콘텐츠가 있다는 것입니다. OpenCourseWare만 해도 2,500개가 넘는 강좌가 있고, OpenLearn에는 거의 1,000개에 달하는 강좌가 있습니다. 저녁 내내 검색하며 학습이라고 부를 수도 있을 정도입니다.',
    res_learning_choose_one_p2: '한 가지 강좌, 책, 또는 강의 시리즈를 선택하고 나머지는 "나중에"로 미루는 것이 도움이 됩니다. 나머지는 메모해 두는 것도 괜찮습니다. 목표는 하나를 끝내고 나서 다음 단계로 넘어가는 것입니다. 배우자에게 어떤 것을 선택했는지 알려주는 것은 작은 약속이 되어 꾸준히 실천하는 데 도움이 됩니다.',
    res_learning_choose_one_p3: '학습 자료가 무엇을 제공하고 무엇을 제공하지 않는지 확인하는 것도 중요합니다. 예를 들어, OpenLearn 강좌는 수료증과 디지털 배지를 제공하지만, 이는 공인된 자격증은 아닙니다. 직장이나 학업을 위해 공식적인 자격증이 필요하다면, 미리 알아두는 것이 좋으며, 목표 기관에 어떤 자격증을 인정하는지 문의해야 합니다.',
    res_learning_mit_ocw_note: '전 세계 어디에서나 이용 가능합니다. 수천 개의 MIT 강좌의 강의 노트, 시험 문제, 동영상을 회원가입 없이 무료로 이용할 수 있습니다. 모든 콘텐츠는 영어로 제공됩니다.',
    res_learning_khan_academy_note: '글로벌. 다양한 언어로 무료 수업과 연습 문제를 제공하는 비영리 단체로, 특히 수학과 과학 분야에서 강점을 보입니다.',
    res_learning_openlearn_note: '영국에 기반을 두고 있으며 누구나 참여할 수 있습니다. 약 1시간에서 24시간까지 다양한 길이의 무료 단기 강좌 약 1,000개를 제공하며, 각 강좌 수료증도 무료로 발급됩니다.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: '업무 목표는 장기적인 것이며, 대부분의 노력은 주요 단계 사이의 기간 동안 이루어집니다. 이 글은 꾸준한 속도를 유지하는 데 도움이 되며, 링크된 자료들은 기술을 향상시키고 다음 단계를 계획하는 데 무료로 활용할 수 있는 곳들입니다.',
    res_business_progress_title: '직장에서의 발전은 드물게 직선적인 경로를 따르지 않습니다.',
    res_business_progress_p1: '직업 및 사업 목표는 늘 길어지는 경향이 있습니다. 승진, 이직 또는 첫 고객 확보는 몇 달이 걸릴 수 있으며, 그 사이의 날들은 진전이 느껴지지 않는 경우가 많습니다.',
    res_business_progress_p2: '원하는 결과와 이번 주에 실제로 할 수 있는 일을 구분하는 것이 도움이 됩니다. 회사가 당신을 고용할지, 고객이 승낙할지 여부는 당신이 통제할 수 없습니다. 하지만 당신은 얼마나 많은 대화를 나눌지, 프로젝트에 얼마나 많은 시간을 투자할지, 그리고 하겠다고 말한 일을 제대로 처리할지 여부는 통제할 수 있습니다.',
    res_business_progress_p3: '바로 이런 점에서 책임 파트너의 역할이 중요해집니다. 그들은 당신의 업계를 이해할 필요가 없습니다. 그저 당신이 무엇을 했는지 묻고, 마치 연극처럼 꾸며내지 않고 답변을 경청하면 됩니다.',
    res_business_progress_p4: '어떤 주에는 솔직하게 "별일 없었다"라고 보고할 때가 있습니다. 이렇게 말하는 것이 중요한데, 한 달 동안 잠잠해진 목표는 꾸준히 되살려둔 목표보다 다시 시작하기가 훨씬 어렵기 때문입니다.',
    res_business_start_from_you_title: '직업이 아니라 자신부터 시작하세요.',
    res_business_start_from_you_p1: '사람들이 직장에서 정체감을 느낄 때, 흔히 구직 시장부터 살펴보는 경향이 있습니다. 어떤 회사가 채용 중인지, 연봉은 높은지, 어떤 경력이 인상적으로 보이는지 등을 알아보는 것이죠. 하지만 다른 곳에서부터 시작하는 것이 더 유용할 수 있습니다.',
    res_business_start_from_you_p2: 'OpenLearn의 무료 강좌인 \'직장에서 성공하기\'는 바로 그러한 아이디어를 바탕으로 만들어졌습니다. 이 강좌는 자신을 이해하고 자신이 무엇을 중요하게 생각하는지 아는 것이 진로 계획의 기초라는 관점에서 시작하여, 그 후에야 이력서 작성, 지원서 제출, 면접으로 넘어갑니다.',
    res_business_start_from_you_p3: '쉽게 말해, 당신은 하루하루를 어떻게 보내고 싶나요? 당신이 잘하지만 제대로 인정받지 못하는 것은 무엇인가요? 가족과 보내는 시간, 안정적인 수입, 창의적인 활동을 할 수 있는 여유 등, 무엇을 절대 포기하지 않겠나요?',
    res_business_start_from_you_p4: '혼자서 모든 질문에 답할 필요는 없습니다. 파트너와 함께 이야기를 나누다 보면 혼자서는 놓칠 수 있는 부분들을 발견할 수 있고, 막연하게 "뭔가 다른 걸 원해"라고 생각했던 것을 실제로 실천 가능한 목표로 바꿀 수 있습니다.',
    res_business_wear_out_title: '무리하지 않고 열심히 일하기',
    res_business_wear_out_p1: '야망과 피로감은 내면에서 보면 비슷하게 느껴질 수 있는데, 특히 목표가 중요할 때는 더욱 그렇습니다.',
    res_business_wear_out_p2: '세계보건기구(WHO)는 직장 생활이 정신 건강을 보호하는 역할을 할 수도 있지만, 해를 끼칠 수도 있다고 지적합니다. 직장 내 정신 건강 가이드라인은 과도한 업무량과 직장 내 부정적인 행동과 같은 위험 요소를 언급하며, 건강한 직장 환경을 조성할 책임은 개별 근로자뿐 아니라 고용주와 정부에게도 있다고 강조합니다.',
    res_business_wear_out_p3: '파트너와 중요한 업무 목표에 대해 이야기를 나눌 때는 "목표 달성했어?"뿐만 아니라 "어떻게 지내고 있어?"도 물어보는 것이 좋습니다. 수면, 건강 또는 인간관계를 희생하면서까지 추구하는 목표는, 설령 계획대로 잘 진행되고 있더라도 다시 생각해 볼 필요가 있습니다.',
    res_business_wear_out_p4: '만약 직장 생활이 건강에 영향을 미치거나, 지속적으로 우울감, 불안감, 피로감을 느낀다면 의사 또는 자격을 갖춘 의료 전문가와 상담하십시오. 직장에서의 권리에 대해 잘 모르겠다면, 거주 지역의 노동 당국이나 노동자 단체와 같은 신뢰할 수 있는 기관에 문의하여 설명을 들으십시오. 국가마다 관련 규정이 크게 다를 수 있습니다.',
    res_business_who_mh_work_note: '글로벌 시장용이며, 주로 고용주와 정부 기관을 대상으로 작성되었기 때문에 전문적인 내용이 포함되어 있습니다. 요약본은 아랍어, 중국어, 영어, 프랑스어, 러시아어, 스페인어로 제공됩니다.',
    res_business_openlearn_entrepreneurship_note: '영국에서 진행되는 과정입니다. 총 8회에 걸쳐 24시간 동안 진행되며, 등록 없이도 시작할 수 있습니다. 과정 중 일부는 영국 비즈니스 규정을 다루므로, 본인의 국가에 적용되는 규정을 확인하십시오.',
    res_business_openlearn_succeed_note: '약 8주 과정으로, 주당 약 3시간씩 투자하여 진로 계획, 이력서 작성 및 면접 준비에 대해 다룹니다. 2021년에 최종 업데이트되었으므로, 구직 활동 및 소셜 미디어 활용 관련 내용은 다소 오래되었을 수 있습니다.',
    // [auto-synced 2026-11-03]
    timezoneTitle: '시간대',
    timezoneCurrentIs: '현재 시간대는 다음과 같습니다.',
    timezoneLockNote: '일일 메시지 및 음성 메모 사용량 제한은 사용자의 시간대 자정(밤 12시)에 초기화됩니다. 공정성을 위해, 메시지나 음성 메모를 전혀 사용하지 않은 날에만, 그리고 7일에 한 번만 시간대를 변경할 수 있습니다.',
    timezoneNew: '시간대를 선택하세요',
    saveTimezone: '시간대 저장',
    timezoneUpdated: '시간대 업데이트됨',
    timezoneInvalid: '해당 시간대는 유효하지 않습니다. 목록에서 시간대를 선택해 주세요.',
    timezoneChangeError: '시간대를 변경할 수 없습니다. 다시 시도해 주세요.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: '창의적인 프로젝트는 다른 모든 것들 사이의 틈새에서 생겨나는 경향이 있습니다. 이 글은 긴 중간 과정 속에서 무언가를 계속해서 이어가는 것에 관한 것이며, 관련 링크들은 글쓰기 학습과 창작물 활용 및 공유에 대한 내용을 다룹니다.',
    res_creative_finishing_title: '마무리도 기술이다',
    res_creative_finishing_p1: '창작 프로젝트를 시작하는 건 쉬운 일입니다. 아이디어가 신선하고 모든 게 가능해 보이죠. 하지만 아이디어가 실제 작업으로 바뀌면서, 처음 생각했던 것보다 작업 속도가 느리고 복잡해지는 중간 단계에서 어려움이 시작됩니다.',
    res_creative_finishing_p2: '프로젝트가 정체되는 지점은 대개 그런 곳인데, 그 이유는 담당자의 재능 부족 때문이 아닌 경우가 많습니다. 오히려 중간 단계에 끝이 보이지 않고, 아무도 지켜보지 않기 때문입니다.',
    res_creative_finishing_p3: '이럴 때 "이번 주에 뭐 만들었어?"라고 간단히 물어봐 주는 파트너가 큰 도움이 될 수 있습니다. 굳이 평가해 줄 필요는 없어요. 한 주 동안 만든 작품을 설명해야 한다는 사실만으로도 작업에 대한 작은 마감일이 생기고, 그 작은 마감일만으로도 책상이나 캔버스, 악기 앞으로 다시 돌아가 작업에 몰두하게 되는 경우가 많습니다.',
    res_creative_finishing_p4: '또한 눈앞에 있는 것에 대해 "완료"의 의미를 정하는 데에도 도움이 됩니다. 머릿속에만 간직한 완벽한 버전보다 완성된 초안이 더 가치 있을 수 있습니다. 완성된 것은 언제든 더 좋게 만들 수 있으니까요.',
    res_creative_rough_drafts_title: '누구도 첫 번째 버전을 볼 필요가 없습니다.',
    res_creative_rough_drafts_p1: '많은 창작자들이 처음 시도한 결과물이 머릿속에 있는 그림만큼 좋지 않다는 이유로 조용히 작업을 멈춥니다. 상상하는 것과 지금 당장 만들어낼 수 있는 것 사이의 차이는 지극히 정상적인 것입니다. 특히 가장 애정을 쏟을수록 그 차이는 더욱 커지는 경향이 있습니다.',
    res_creative_rough_drafts_p2: '믿을 만한 사람에게 초안을 보여주는 것만으로도 부담을 덜 수 있습니다. 파트너에게 "이건 좀 지저분한 초안이지만, 제가 하려는 건 이런 거예요"라고 말하면, 판단을 내리는 것이 아니라 대화를 이어갈 수 있습니다. 어쩌면 파트너는 결과물의 완성도보다 당신이 계속 노력했는지에 더 관심을 가질지도 모릅니다.',
    res_creative_rough_drafts_p3: '어떤 분야에 처음 입문하는 초보자라면, 차근차근 시작할 수 있는 방법들이 있습니다. 오픈 유니버시티의 무료 학습 사이트인 오픈런(OpenLearn)에는 이제 막 시작하는 사람들을 위한 소설 창작 입문 강좌가 있습니다. 이는 수많은 예시 중 하나일 뿐이며, 다른 분야의 창작자들보다 작가들에게 더 적합한 방법입니다.',
    res_creative_rough_drafts_p4: '창작 활동의 발전은 꾸준한 향상처럼 보이지 않는 경우가 많습니다. 어떤 주에는 자랑스러운 작품을 만들고, 어떤 주에는 누구에게도 보여주고 싶지 않은 작품을 만들기도 합니다. 하지만 둘 다 중요하며, 모두 같은 습관의 일부입니다.',
    res_creative_using_sharing_title: '다른 사람의 작품을 활용하고, 자신의 작품을 공유하는 것',
    res_creative_using_sharing_p1: '창작 프로젝트에는 이미지, 소리, 텍스트 등 다른 사람의 자료가 포함되는 경우가 많으며, 나중에는 자신의 자료를 공유하고 싶어질 수도 있습니다. 관련 분야에 대한 기본적인 지식은 이러한 과정 모두에 도움이 됩니다.',
    res_creative_using_sharing_p2: '크리에이티브 커먼즈는 창작자가 저작권을 유지하면서 다른 사람들이 창작물을 창작자가 선택한 방식으로 사용할 수 있도록 허용하는 라이선스를 발행하는 비영리 단체입니다. 자신이 만든 것을 공유하고 싶다면, 크리에이티브 커먼즈의 가이드라인을 통해 해당 라이선스가 어떻게 작동하는지 알아볼 수 있습니다.',
    res_creative_using_sharing_p3: '일부 기관은 한발 더 나아갑니다. 스미소니언 박물관은 수백만 장의 이미지와 데이터를 CC0 라이선스로 공개했는데, 이는 창작 프로젝트를 포함하여 스미소니언의 허가 없이 자유롭게 사용할 수 있다는 의미입니다. 하지만 스미소니언 박물관의 FAQ에 따르면 CC0는 저작권에만 해당됩니다. 개인정보 보호나 상표권과 같은 다른 권리는 여전히 적용될 수 있으며, 소장품 중 일부는 CC0 라이선스 적용 대상에서 완전히 제외됩니다.',
    res_creative_using_sharing_p4: '저작권 관련 규정은 국가마다 다르며, 이는 일반적인 정보일 뿐 법률 자문이 아닙니다. 프로젝트가 상업적으로 중요하거나 특정 저작물을 사용할 수 있는지 여부가 불확실한 경우, 자격을 갖춘 전문가에게 문의하여 정확한 상황을 확인하시기 바랍니다.',
    res_creative_openlearn_fiction_note: '영국에 기반을 둔, 무료로 시작할 수 있는 소설 쓰기 입문 강좌입니다. 참가비는 무료이며, 다른 분야의 창작자보다는 작가에게 더 적합합니다.',
    res_creative_cc_license_note: '글로벌. 저작권을 유지하면서 다른 사람들이 원하는 조건으로 내 작품을 사용할 수 있도록 하는 방법. 일반적인 정보이며 법률 자문이 아닙니다.',
    res_creative_smithsonian_open_access_note: '미국 기관에서 제공하며 누구나 자유롭게 사용할 수 있습니다. CC0 라이선스로 공개된 이미지와 데이터에 대한 설명, 해당 라이선스가 허용하는 범위와 허용하지 않는 범위, 그리고 제외되는 항목들을 안내합니다.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: '관계는 거창한 순간들보다 작고 반복적인 행동들을 통해 더욱 돈독해집니다. 이 글에서는 관계를 유지하는 방법, 연구 결과에 따르면 가장 중요한 요소는 무엇인지, 그리고 관계가 어렵거나 안전하지 않을 때 어떻게 해야 하는지에 대해 다룹니다.',
    res_relationships_small_gestures_title: '작은 행동 하나하나가 중요합니다',
    res_relationships_small_gestures_p1: '많은 사람들은 친구 관계나 가족 관계를 단순히 존재하거나 존재하지 않는 것으로 여깁니다. 하지만 하버드 성인 발달 연구소 소장인 로버트 월딩거는 사회생활을 신체 건강처럼 관리가 필요한 살아있는 시스템으로 설명합니다.',
    res_relationships_small_gestures_p2: '일상적인 노력은 아주 사소한 것부터 시작할 수 있습니다. 보고 싶은 사람을 떠올리고 메시지를 보내 보세요. 세계보건기구(WHO)가 제시하는 일상생활 속 실천 방법들도 마찬가지로 간단합니다. 친구에게 연락하기, 대화에 집중하기 위해 잠시 휴대폰을 내려놓기, 이웃에게 인사하기, 지역 모임에 참여하기, 또는 자원봉사하기 등이 있습니다.',
    res_relationships_small_gestures_p3: '목표 달성을 위해 서로 책임감을 공유하는 경우, 매주 다음과 같은 질문을 해보세요. "누구에게 연락했나요?" 구체적이고 간단하며, 힘든 한 주에도 솔직하게 답할 수 있는 질문입니다.',
    res_relationships_small_gestures_p4: '모든 메시지에 따뜻한 답장이 오는 것은 아니며, 그것 또한 하나의 과정입니다. 월딩거는 사람들이 이처럼 짧은 메시지들이 얼마나 따뜻하게 받아들여지는지에 종종 놀라워한다고 말합니다.',
    res_relationships_quality_title: '양보다 질',
    res_relationships_quality_p1: '사회생활은 친구 수, 참석한 행사 수, 연애 여부 등으로 쉽게 측정할 수 있습니다. 하지만 연구 결과는 다른 점을 시사합니다.',
    res_relationships_quality_p2: '하버드 성인 발달 연구는 1938년부터 사람들을 추적 조사해 왔습니다. 연구진이 참가자들의 중년 시절 삶을 되돌아본 결과, 특히 결혼 생활을 포함한 인간관계에 대한 만족도가 콜레스테롤이나 혈압 같은 요인보다 80세까지 행복하고 건강하게 살 가능성을 더 잘 예측하는 것으로 나타났습니다. 연구 책임자는 이후 다른 연구 그룹에서도 같은 결과를 발견했다고 밝혔습니다. 또한, 필요한 인간관계의 수는 정해져 있지 않으며, 내성적인 사람은 외향적인 사람보다 더 적은 수의 인간관계로도 충분할 수 있다고 덧붙였습니다.',
    res_relationships_quality_p3: '한 가지 주의할 점은 이 연구의 초기 참가자가 하버드 학생들과 미국 한 도시의 젊은 성인들이었기 때문에 모든 사람을 대표하는 것은 아니라는 것입니다. 따라서 연구 결과를 너무 맹신하지 않는 것이 좋습니다.',
    res_relationships_quality_p4: '이 연구는 적어도 하나 이상의 든든한 관계, 즉 아프거나 두려울 때 전화할 수 있는 사람이 있는 것이 많은 친구 관계보다 더 중요하다는 점을 부드럽게 시사합니다. 그리고 그런 관계를 맺기에 너무 늦은 경우는 거의 없습니다. 연구 책임자는 예상치 못했던 시기에 인생 후반에 진정한 우정이나 사랑을 찾은 사람들의 사례를 소개합니다.',
    res_relationships_hard_times_title: '소통이 어려울 때, 그리고 관계가 아플 때',
    res_relationships_hard_times_p1: '외로움을 느낀다고 해서 당신에게 문제가 있는 것은 아닙니다. 세계보건기구(WHO)는 전 세계 인구의 약 6분의 1이 모든 연령대에서 외로움을 경험한다고 추정합니다. WHO는 외로움을 자신이 맺고 있는 관계가 자신이 원하는 관계와 일치하지 않을 때 느끼는 고통스러운 감정으로 정의합니다.',
    res_relationships_hard_times_p2: '원인으로는 건강 악화, 저소득, 독거, 기술 사용 방식 등이 있을 수 있습니다. 세계보건기구(WHO)는 문제가 심각한 경우, 이용 가능한 지원 및 서비스가 무엇인지 알아보는 것이 중요하다고 지적합니다.',
    res_relationships_hard_times_p3: '하지만 또 다른 측면도 있습니다. 바로 상처를 주는 관계입니다. 연인 관계에서 해로운 행동에는 심리적 학대와 통제적인 행동뿐만 아니라 신체적 또는 성적 학대도 포함됩니다.',
    res_relationships_hard_times_p4: '가까운 사람이 두렵거나 상처를 입었다면, 지역 긴급 전화번호나 지역 상담 전화 또는 지원 서비스에 연락하세요. 연락처는 국가마다 다르며, Veyl 파트너는 전문 상담사가 아닌 동료입니다. 감당하기 힘든 상황이라면 의사나 상담사의 도움을 받으세요.',
    res_relationships_who_social_connection_note: '세계보건기구(WHO)의 2025년 외로움과 사회적 연결에 관한 보고서를 전문 용어 없이 간략하게 요약한 자료입니다(13페이지).',
    res_relationships_harvard_gazette_note: '미국 자료입니다. 하버드 성인 발달 연구 책임자와의 질의응답으로, 연구 결과가 관계와 건강에 미치는 영향, 그리고 일상 속 작은 실천들에 대해 이야기합니다. 인터뷰 형식이며, 연구 초기 참여자는 미국 한 도시 거주자였습니다.',
    res_relationships_who_violence_note: '글로벌(Global)은 친밀한 파트너 폭력의 내용과 그 발생 빈도(주로 여성에게 영향을 미침)에 대해 설명합니다. 상담 전화가 아닌 정보 제공 목적이며, 읽기 불편할 수 있습니다.',
  },

  ha: {
    appName: 'Veyl',
    loading: 'Ana lodawa...',
    save: 'Ajiye',
    cancel: 'Soke',
    back: 'Koma',
    continue: 'Ci gaba',
    done: 'An gama',
    error: 'Kuskure',
    submit: 'Aika',
    send: 'Aika',
    delete: 'Goge',
    leave: 'Fita',
    stay: 'Zauna',
    yes: 'Eh',
    no: 'A\'a',
    upgrade: 'Haura zuwa Premium',
    signIn: 'Shiga',
    signUp: 'Yi rajista',
    signOut: 'Fita',
    email: 'Imel',
    password: 'Kalmar sirri',
    forgotPassword: 'Ka manta kalmar sirri?',
    resetPassword: 'Sake saita kalmar sirri',
    resetPasswordSent: 'An aika imel don sake saita kalmar sirri. Duba akwatin shigowa.',
    noAccount: 'Babu asusu?',
    hasAccount: 'Kana da asusu?',
    authError: 'Kuskuren tabbatarwa. Don Allah sake gwadawa.',
    landingHero: 'Alhakin da ke aiki da gaske',
    landingSubtitle: 'Sami abokin harka na asiri wanda yake da manufar da kai. Ba matsin lamba na zamantakewa ba. Kawai sakamakon.',
    getStarted: 'Fara — Kyauta ne',
    howItWorks: 'Yadda yake aiki',
    step1Title: 'Saita manufarka',
    step1Desc: 'Gaya mana abin da kake aiki akansa. Za mu haɗa ka da wanda yake tafiya iri ɗaya.',
    step2Title: 'Haɗu da abokin hulɗa',
    step2Desc: 'An haɗa ka da abokin alhakin asiri a yankin lokacinka.',
    step3Title: 'Kasance da alhakin',
    step3Desc: 'Duba kowace rana, raba ci gaban, kuma ku goyi bayan juna — a asirce.',
    pricingTitle: 'Farashin sauƙi',
    freePlan: 'Kyauta',
    premiumPlan: 'Premium',
    perMonth: '/wata',
    freeFeature1: 'Veyl 1 mai aiki',
    freeFeature2: 'Saƙonni 10/rana',
    freeFeature3: 'Saƙonnin murya 10/rana',
    freeFeature4: 'Dubawa kowace rana da mako',
    freeFeature5: 'Shiga tattaunawar ƙungiya',
    premiumFeature1: 'Har zuwa Veyls 3 masu aiki',
    premiumFeature2: 'Saƙonni ba iyaka',
    premiumFeature3: 'Saƙonnin murya ba iyaka',
    premiumFeature4: 'Haɗawa da fifiko',
    faqTitle: 'Tambayoyin da ake yawan yi',
    welcomeToVeyl: 'Maraba da zuwa Veyl',
    chooseLanguage: 'Zaɓi yarenka',
    chooseLanguageDesc: 'Zaɓi yaren da kake son amfani da shi a Veyl.',
    ageVerification: 'Tabbatar da shekaru',
    ageVerificationDesc: 'Veyl yana samuwa ga masu amfani masu shekara 13 ko sama.',
    areYouOldEnough: 'Kana da shekara 13 ko sama?',
    yesIAm: '✅ Eh, ina da',
    noImNot: '❌ A\'a, ba ni da',
    mustBe13: 'Dole ne ka kasance da shekara 13 ko sama',
    mustBe13Desc: 'Veyl yana samuwa ne kawai ga masu amfani masu shekara 13 ko sama.',
    setupProfile: 'Bari mu saita bayananka',
    stepOf: 'Mataki {step} na 4',
    whatsYourName: 'Menene sunanka?',
    namePlaceholder: 'Shigar da laƙabinka',
    whatsYourTimezone: 'Menene yankin lokacinka?',
    selectTimezone: 'Zaɓi yankin lokaci',
    goalCategory: 'Menene nau\'in manufarka?',
    matchPreference: 'Da wanda kake son a haɗa ka?',
    matchNearby: 'Haɗa kusa',
    matchNearbyDesc: 'An haɗa ka da mutanen da ke cikin awanni 4 na yankin lokacinka.',
    matchAnywhere: 'Haɗa ko ina',
    matchAnywhereDesc: 'An haɗa ka da kowa a duniya ba tare da la\'akari da yankin lokaci ba.',
    describeGoal: 'Bayyana manufarka ta musamman',
    goalPlaceholder: "Misali: 'Ina son rasa kilo 15' ko 'Koyi Python'",
    communicationStyle: 'Siffar sadarwa da kake so',
    textMessages: 'Saƙonnin rubutu',
    textMessagesDesc: 'Yi hira lokacin da ya dace',
    scheduledCheckins: 'Dubawa da aka tsara',
    scheduledCheckinsDesc: 'Tattaunawa mai zurfi na mako-mako',
    completingSetup: 'Ana neman haɗawa...',
    completeSetup: 'Kammala saiti',
    agreeToTerms: 'Ta hanyar ci gaba, kana yarda da',
    termsOfService: 'Sharuɗɗan Amfani',
    and: 'da',
    privacyPolicy: 'Manufofin Sirri',
    fitnessHealth: 'Lafiya da Motsa Jiki',
    learningSkills: 'Koyo da Ƙwarewa',
    businessCareer: 'Kasuwanci da Aiki',
    creativeProjects: 'Ayyukan Kirkire-kirkire',
    findingMatch: 'Ana neman abokin hulɗarka...',
    findingNewMatch: 'Ana neman sabon abokin hulɗarka...',
    lookingForSomeone: 'Muna neman wani a cikin',
    category: 'nau\'i',
    sharesTimezone: 'wanda yake da yankin lokacinka da kudurin kai.',
    autoCheck: 'Muna duba haɗawar ta atomatik kowane dakika 5.',
    noMatchYet: 'Ba a sami haɗawa ba tukuna — za mu ci gaba da ƙoƙari.',
    checkNow: 'Duba yanzu',
    checking: 'Ana dubawa...',
    manualChecks: 'An yi dubawa {count} da hannu',
    joinCommunity: '🌐 Shiga Al\'umma Yayin Jira',
    goToCommunity: '🌐 Tafi Al\'umma',
    previousPartnerNote: '🛡️ Ba za a sake ba da shawarar abokin hulɗarka na baya ba.',
    joining: 'Ana shigowa...',
    overview: 'Taƙaitawa',
    chat: 'Hira',
    checkin: 'Dubawa',
    group: 'Ƙungiya',
    community: "Al'umma",
    notifications: 'Sanarwa',
    settings: 'Saiti',
    yourGoal: 'Manufarka',
    yourPartner: 'Abokin hulɗarka',
    you: 'Kai',
    unveiled: '✨ An Bayyana',
    goalComplete: '✓ Manufa Ta Cika',
    adjustGoal: 'Daidaita Manufata',
    unveilButton: '✨ Bayyana — Ka Yi Shi!',
    goalCategory2: "Nau'i",
    goalDescription: 'Bayani',
    timezone: 'Yankin Lokaci',
    loadingPartner: 'Ana loda bayanan abokin hulɗa...',
    waitingForMatch: 'Ana jiran haɗawa don fara hira.',
    noMessagesYet: 'Babu saƙonni tukuna. Gaishe abokin hulɗarka!',
    typeMessage: 'Rubuta saƙonka...',
    dailyLimitReached: 'An kai iyakar yau — Haura zuwa Premium',
    unmatch: '🔓 Rabu',
    report: '🚩 Rahoto',
    unmatchWarning: '⚠️ Rabuwa za ta share dukkan tarihin hirar. Ba za a iya mayar da wannan ba.',
    yesUnmatch: 'Eh, Rabu',
    unmatching: 'Ana rabuwa...',
    deleteMessage: '🗑 Goge',
    deleting: 'Ana gogewa...',
    checkIn: 'Dubawa',
    submitDaily: 'Aika Dubawa ta Yau',
    submitWeekly: 'Aika Dubawa ta Mako',
    submitting: 'Ana aikawa...',
    checkinSubmitted: 'An Aika Dubawa!',
    viewHistory: 'Duba Tarihin Na',
    notificationsTitle: 'Sanarwa',
    clearAll: 'Share Duka',
    noNotifications: 'Babu sanarwa tukuna.',
    settingsTitle: 'Saiti',
    settingsDesc: 'Keɓance asalin sirrika.',
    saveAvatar: 'Ajiye Hoton Kai',
    appearance: 'Bayyanar',
    lightMode: '☀️ Haske',
    darkMode: '🌙 Duhu',
    changeNickname: 'Canza Laƙabi',
    saveNickname: 'Ajiye Laƙabi',
    deleteAccount: 'Share Asusu',
    deleteAccountDesc: 'Share asusunka da dukkan bayanan da ke da alaƙa har abada.',
    languageLabel: 'Yare',
    languageDesc: 'Zaɓi yarena da kake so.',
    signOut: 'Fita',
    updating: 'Ana sabunta...',
    unveil: 'Bayyana',
    clearing: 'Ana share...',
    notifMatchFound: 'An Sami Haɗawa',
    notifGoalAchieved: 'Manufa Ta Cika',
    notifSupport: 'Saƙonnin Tallafi',
    notifUnmatched: 'Gargaɗin Rabuwa',
    notifMatchRequest: 'Buƙatun Haɗawa',
    notificationPrefs: 'Zaɓuɓɓukan Sanarwa',
    notificationPrefsDesc: 'Kashe nau\'ukan sanarwa na musamman daban-daban.',
    muted: 'An Kashe',
    active: 'Mai Aiki',
    all: 'Duka',
    justNow: 'Yanzu haka',
    minsAgo: 'Minti {count} da suka wuce',
    hoursAgo: 'Sa\'o\'i {count} da suka wuce',
    daysAgo: 'Kwanaki {count} da suka wuce',
    leaving: 'Ana fita...',
    myHistory: '📋 Tarihin Na',
    partnersProgress: '👤 Ci gaban {name}',
    myCheckinHistory: 'Tarihin Dubawa na',
    checkinsForVeyl: 'Dubawa {count} don Veyl ɗin nan',
    noCheckinsYet: 'Babu dubawa tukuna. Fara ta farko!',
    newCheckinBtn: 'Dubawa Sabuwa',
    partnerNoCheckins: '{name} bai/ta yi dubawa ba tukuna.',
    dailyNotesPrivate: 'Bayanan yau-da-kullum na sirri ne',
    goalAchievedMarked: '🎉 An yiwa manufa alama cewa ta cika',
    goalAchievedNote: '🎉 An yiwa manufarka alama cewa ta cika! Tafi Taƙaitawa don bayyana.',
    veylComplete: '✓ Veyl ɗin nan ya cika. Dubawa na karanta kawai.',
    goalAlreadyAchieved: '🎉 Ka/ki yiwa manufarka alama cewa ta cika! Tafi Taƙaitawa don bayyana.',
    didYouWork: 'Shin ka/ki yi aiki kan manufarka yau?',
    howDidWeekGo: 'Yaya mako ya wuce da manufarka?',
    whatGotInWay: 'Menene ya hana? (Ba tilas ba)',
    honestNote: 'Ka/ki kasance da gaskiya. Abokin hulɗarka yana/tana nan don tallafawa, ba yin hukunci ba.',
    whatDidYouLearn: 'Menene ka/ki koya game da kanka/kiyanka mako ɗin nan?',
    insightsPlaceholder: 'Wane fahimta ka/ki samu?',
    whatPatterns: 'Wane salon ka/ki lura da shi?',
    patternsPlaceholder: 'Akwai jigogi ko shinge da ke maimaita?',
    whatChange: 'Menene ya kamata ya canza don mako mai zuwa?',
    changePlaceholder: 'Menene za ka/ki yi daban?',
    goalAchievedQuestion: '🏆 Shin ka/ki cimma manufarka baki ɗaya?',
    yesDidIt: '🎉 Eh, na yi shi!',
    notYetBtn: 'Ba tukuna',
    didIt: '✅ Na yi',
    didSome: '😐 Na yi kaɗan',
    didntDoIt: '❌ Ban yi ba',
    metCommitment: '✅ Na cika alkawali',
    partialProgress: '😐 Ci gaba ɗan kaɗan',
    noProgress: '❌ Babu ci gaba',
    rethinkingGoal: '🤔 Ina sake tunanin manufa',
    yesLabel: '✅ Eh',
    aLittle: '😐 Kaɗan',
    noLabel: '❌ A\'a',
    madeProgress: 'Na samu ci gaba yau',
    didSomething: 'Na yi wani abu, ba komai ba',
    didntWork: 'Ban yi aiki kan wannan yau ba',
    metWeekly: 'Na cika alkawali na mako',
    madePartial: 'Na samu ci gaba ɗan kaɗan',
    didntMake: 'Ban samu ci gaba ba',
    needToAdjust: 'Ina bukatar daidaita hanyata',
    learnedLabel: 'Na koya: ',
    patternLabel: 'Salon: ',
    nextWeekLabel: 'Mako mai zuwa: ',
    joinGroup: 'Shiga Ƙungiya',
    joinGroupDesc: 'Ƙungiyoyi suna tattara mutane har 5 masu aiki kan manufofi iri ɗaya. Asirce, tallafawa, babu matsi.',
    whatToExpect: 'ABIN DA AKE TSAMMANI',
    expectAnonymous: 'Kowa yana kasancewa a asirce — daidai avatoci na silhouette',
    expectMatched: 'An haɗa ta nau\'in manufa don tallafin da ya dace',
    expectMembers: 'Har zuwa mamba 5 a kowace ƙungiya',
    expectChat: 'Tattaunawar ƙungiya — saƙonni 20 & sauti 5/rana kyauta · Ba iyaka akan Premium',
    findOrCreate: 'Nemi ko Ƙirƙiri Ƙungiya',
    findingGroup: 'Ana neman ƙungiyarka...',
    oneGroupNote: 'Kana/kina iya kasancewa a ƙungiya ɗaya a lokaci ɗaya. Masu amfani kyauta da Premium duk suna samun damar ƙungiya.',
    groupCreated: 'An Ƙirƙiri Ƙungiya!',
    groupJoined: 'Ka/ki Shiga Ƙungiya!',
    groupCreatedDesc: 'Ka/ki fara sabuwar ƙungiyar {category}. Sauran za su shigo nan ba da daɗewa ba.',
    groupJoinedDesc: 'Ka/ki shiga ƙungiyar {category} da ke akwai. Ka/ki ce salam!',
    switchToGroup: 'Canza zuwa shafin Ƙungiya a dashibodinka don fara hira.',
    groupMembers: 'Mambobin Ƙungiya',
    backToChat: '← Koma hirar',
    creator: '★ Mai Ƙirƙira',
    joined: 'Ya/ta shiga',
    leaveGroup: 'Bar Ƙungiya',
    leaveGroupTitle: 'Bar wannan ƙungiyar?',
    leaveGroupDesc: 'Za ka/ki rasa damar tattaunawar ƙungiya kuma za ka/ki iya shiga sabuwar ƙungiya a kowane lokaci.',
    membersBtn: '👥 Mambobi',
    noGroupMessages: 'Babu saƙonni tukuna. Ka/ki kasance na farko da ya/ta ce salam!',
    messageGroup: 'Aika saƙo ga ƙungiyarka...',
    groupDailyLimit: 'Ka/ki kai iyakar saƙonnin ƙungiya na yau ({limit}/rana). Haura zuwa Premium don saƙonni ba iyaka!',
    groupVoiceLimit: 'An kai iyakar sauti na yau.',
    veylCommunity: "Al'ummar Veyl",
    communityDesc: "Shiga wasu masu aiki kan nau'in manufa iri ɗaya yayin da kake/kike jiran haɗawa.",
    communityJoinNote: "Shiga al'umma daga shafin jira yayin neman haɗawa.",
    leaveCommunity: "Bar wannan al'ummar?",
    communityLeaveDesc: 'Za ka/ki iya koma daga shafin jira a kowane lokaci.',
    matchRequests: 'Buƙatun Haɗawa',
    incoming: 'Masu Shigowa',
    sent: 'Aika',
    noIncoming: 'Babu buƙatun masu shigowa.',
    noPending: 'Babu buƙatun da aka aika masu jira.',
    requestToAnonymous: 'Buƙata ga mai amfani na asirce',
    pending: 'Tana jira',
    decline: 'Ƙi',
    accept: '✅ Karɓa',
    requestWaiting: '🤝 Buƙatun haɗawa {count} suna jiran ka/ki',
    view: 'Duba',
    requestsBtn: '🤝 Buƙatu',
    leaveBtn: 'Fita',
    openToAll: 'Buɗe ga duka · Asirce',
    msgsLeft: 'Saƙonni {count} sun rage',
    noCommunityMessages: "Babu saƙonni tukuna. Ka/ki ce salam ga al'ummar!",
    saySomething: "Ka/ki ce wani abu ga al'ummar...",
    requestMatch: '🤝 Buƙaci Haɗawa',
    requestSending: 'Ana aikawa...',
    communityMsgsWarning: "Saƙonnin al'umma {count} sun rage yau.",
    communityDailyLimit: "Ka/ki kai iyakar saƙonnin al'umma na yau ({limit}/rana). Haura zuwa Premium don ba iyaka!",
    matchRequestLimit: 'Kana/kina iya samun buƙatu 3 masu jira a lokaci ɗaya kawai.',
    matchRequestSent: 'An aika buƙatar haɗawa cikin nasara!',
    matchRequestDuplicate: 'Kun riga kun aika buƙata ga wannan mutumin.',
    matchRequestError: 'Kuskure wajen aika buƙatar haɗawa. Don Allah sake gwadawa.',
    matchAcceptError: 'Kuskure wajen karɓar buƙatar haɗawa.',
    matchRequestSentAlready: 'Kun riga kun aika buƙata ga wannan mutumin.',
    avatar_silhouette: 'Silhouette',
    avatar_teal: 'Teal',
    avatar_purple: 'Purple',
    avatar_navy: 'Navy',
    avatar_slate: 'Slate',
    avatar_coral: 'Coral',
    avatar_gold: 'Zinare',
    avatar_moss: 'Moss',
    avatar_indigo: 'Indigo',
    avatar_unveiled: 'An Bayyana',
    activeLabel: 'Mai Aiki',
    seekingLabel: 'Ana Nema',
    completeLabel: 'An Gama',
    upgradeForMore: '✨ Haura don ƙarin Veyls',
    newVeyl: '+ Sabon Veyl',
    newVeylTitle: 'Fara Sabon Veyl',
    goalCategoryLabel: "Nau'in Manufa",
    goalDescriptionLabel: 'Bayani na Manufa',
    startVeyl: 'Fara Sabon Veyl',
    starting: 'Ana farawa...',
    unveil: 'Bayyana',
    clearing: 'Ana share...',
    nicknameRequired: 'Ana buƙatar laƙabi',
    nicknameTooShort: 'Laƙabi dole ne ya kasance da haruffa 2 aƙalla',
    nicknameTooLong: 'Laƙabi dole ne ya kasance da haruffa 20 aƙalla',
    errorSavingNickname: 'Kuskure wajen ajiye laƙabi',
    errorSavingAvatar: 'Kuskure wajen ajiye hoton kai',
    errorDeletingAccount: 'Kuskure wajen share asusu',
    deleteMyAccountButton: 'Share Asusuna',
    goalsAchievedTitle: 'Manufofi Da Aka Cika',
    goalsPrivate: 'Sirri — ana ganin sa kai kaɗai.',
    goalsCompletedCount: 'Manufofi {count} sun cika',
    keepAnonymous: 'Ka/ki kasance a asirce. Kada ka/ki yi amfani da sunanka na gaske.',
    currentNicknameIs: 'Laƙabinka na yanzu shine',
    unveiledLocked: '✨ An Bayyana — hoton kai ya kulle',
    howOthersSee: 'Haka ne wasu suke ganinka',
    unveiledNote: 'Ka/ki bayyana akan Veyl ɗin nan. Fara sabon Veyl don zaɓar sabon hoton kai.',
    active2: '✓ Mai Aiki',
    goalsAchieved: 'Manufofi Da Aka Cika',
    goalsAchievedDesc: 'Sirri — ana ganin sa kai kaɗai.',
    goalCompleted: 'manufa ta cika',
    goalsCompleted: 'manufofi sun cika',
    contactSupport: 'Tuntuɓi Tallafi',
    deleteWarning: '⚠️ Wannan zai share komai har abada. Rubuta SHARE a ƙasa don tabbatarwa.',
    typeDelete: 'Rubuta SHARE don tabbatarwa',
    confirmDelete: 'Tabbatar Share',
    deleting2: 'Ana share...',
    messagesLeft: 'Saƙonni {count} · Sauti {voiceCount} sun rage yau',
    premiumUnlimited: '✨ Premium — Saƙonni da sauti ba iyaka',
    messagesLeftWarning: 'Saƙonni {count} sun rage yau.',
    forUnlimited: 'don saƙonni ba iyaka.',
    voiceNotesLeft: 'Sauti {count} sun rage yau',
    dailyLimitReachedVoice: 'An kai iyakar sauti na yau.',
    dailyVoiceNoteLimit: 'An kai iyakar sauti na yau. Haura zuwa Premium don sauti ba iyaka.',
    recording: 'Ana rikodin...',
    deeper: 'Zurfi',
    neutral: 'Tsakiya',
    higher: 'Sama',
    applyingModulation: '⚙️ Ana amfani da urekebishaji...',
    preview: '▶ Ƙilla',
    pause: '⏸ Tsayar',
    discard: 'Jefa',
    recordingTooLarge: 'Rikodi yana da girma sosai. Don Allah gwada saƙo gajere.',
    failedToSend: 'Aika ya kasa. Don Allah sake gwadawa.',
    micDenied: 'An ƙi damar maikrofoni.',
    unmatchMessage: 'Abokin hulɗarka ya/ta ƙare wannan zaman Veyl. An mayar da kai/ki zuwa neman haɗawa.',
    appearanceDesc: 'Zaɓi yadda Veyl yake gare ka/ki.',
    newNickname: 'Sabon Laƙabi',
    nicknamePlaceholder: 'misali NightOwl, StriveMode, Kira...',
    chooseAvatar: 'Zaɓi hoton kanka',
    notificationsTitle: 'Sanarwa',
    notificationsCount: 'Jimla {total} · {unread} da ba a karanta ba',
    progressOf: 'Ci gaban {name}',
    fitnessHealth: 'Kiwon Lafiya & Fitness',
    learningSkills: 'Koyo & Ƙwarewa',
    businessCareer: 'Kasuwanci & Aiki',
    creativeProjects: 'Ayyukan Kirkira',
    progressOf: 'Ci gaban {name}',
    dailyCheckin: 'Dubawa ta Yau',
    weeklyCheckin: 'Dubawa ta Mako',
    dailyCheckinDesc: 'Sabuntawa mai sauri: Shin kun yi aiki kan manufarku yau?',
    weeklyCheckinDesc: 'Tunani mai zurfi: Mako ya kasance yaya gaba ɗaya?',
    submitDaily: 'Aika Dubawa ta Yau',
    submitWeekly: 'Aika Dubawa ta Mako',
    submitting: 'Ana aika...',
    checkinSubmitted: 'An Aika Dubawa!',
    checkinSubmittedDesc: 'Kyakkyawan aiki wajen kasancewa da alhakin. {name} zai ga sabuntawarka.',
    viewHistory: 'Duba Tarihin Na',
    newCheckin: '📝 Sabuwar Dubawa',
    myHistory: '📋 Tarihin Na',
    partnersProgress: '👤 Ci gaban {name}',
    myCheckinHistory: 'Tarihin Dubawar Na',
    checkinsForVeyl: 'Dubawa {count} don wannan Veyl',
    noCheckinsYet: 'Babu dubawa tukuna. Fara na farko!',
    newCheckinBtn: 'Sabuwar Dubawa',
    partnerNoCheckins: '{name} bai/ta yi dubawa tukuna ba.',
    dailyNotesPrivate: 'Bayanan yau na sirri ne',
    goalAchievedMarked: '🎉 An nuna manufa a matsayin cimma',
    goalAchievedNote: '🎉 Manufarka an nuna a matsayin cimma! Je zuwa Bayanai don bayyana.',
    veylComplete: '✓ Wannan Veyl ya ƙare. Dubawa don karanta kawai.',
    goalAlreadyAchieved: '🎉 Kun nuna manufarku a matsayin cimma! Je zuwa Bayanai don bayyana.',
    didYouWork: 'Shin kun yi aiki kan manufarku yau?',
    howDidWeekGo: 'Mako ya kasance yaya tare da manufarku?',
    whatGotInWay: 'Mene ne ya hana ku? (Na zaɓi)',
    honestNote: 'Kasance mai gaskiya. Abokin tarayya yana nan don tallafawa, ba don shari\'a ba.',
    whatDidYouLearn: 'Mene ne kuka koya game da kanku wannan mako?',
    insightsPlaceholder: 'Wane fahimta kuka samu?',
    whatPatterns: 'Wane tsari kuke lura da shi?',
    patternsPlaceholder: 'Batutuwa ko cikas da ke maimaituwa?',
    whatChange: 'Mene ne ya kamata ya canza don mako mai zuwa?',
    changePlaceholder: 'Mene ne za ku yi daban?',
    goalAchievedQuestion: '🏆 Shin kun cimma manufarku gaba ɗaya?',
    yesDidIt: '🎉 Eh, na yi shi!',
    notYetBtn: 'Ba tukuna',
    didIt: '✅ Na yi',
    didSome: '😐 Na yi wani ɓangare',
    didntDoIt: '❌ Ban yi ba',
    metCommitment: '✅ Na cika alkawari',
    madePartial: '😐 Ci gaba na ɓangare',
    didntMake: '❌ Babu ci gaba',
    needToAdjust: '🤔 Ina bukatan daidaita hanyata',
    yesLabel: '✅ Eh',
    aLittle: '😐 Kaɗan',
    noLabel: '❌ A\'a',
    madeProgress: 'Na ci gaba yau',
    didSomething: 'Na yi wani abu, ba duka ba',
    didntWork: 'Ban yi aiki a kai yau ba',
    metWeekly: 'Na cika alkawarin mako',
    didntMake: 'Babu ci gaba',
    needToAdjust: 'Ina bukatan daidaita hanyata',
    learnedLabel: 'Na koya: ',
    patternLabel: 'Tsari: ',
    nextWeekLabel: 'Mako mai zuwa: ',
    problemTitle: 'Kafofin Sada Zumunta Sun Lalata Alhakin',
    problem1: "Kuna tsoron yarda lokacin da kuke gwagwarmaya",
    problem2: "Kuna ɓoye gazawa maimakon koyo daga gare ta",
    problem3: "Kuna barin abokan tarayya lokacin da kuka yi kuskure",
    veylIsDifferent: 'Veyl ya bambanta.',
    popular: 'MASHAHURI',
    sixMonthDeal: 'ko $20 don watanni 6 ($3.33/wata)',
    getStartedPremium: 'Fara',
    buildTrust: 'Gina Amana',
    unveilIdentity: 'Bayyana asalinku lokacin da kuke shirye',
    actuallyAchieve: 'Cimma Gaske',
    makeRealProgress: 'Sami ci gaba na gaske ba tare da wasan kwaikwayo ba',
    faq1q: 'Idan ni da abokin tarayya ba mu jitu ba?',
    faq1a: 'Rematch mai sauƙi. Babu tambayoyi. Muna son ku sami mutumin da ya dace maimakon tilasta haɗin gwiwa da bai yi aiki ba.',
    faq2q: 'Shin dole ne in bayyana asalina a wani lokaci?',
    faq2a: 'A\'a. Wasu haɗin gwiwa suna kasancewa a ɓoye har abada. Wasu sun bayyana bayan mako ɗaya. Yanke shawara naku ne gaba ɗaya.',
    faq3q: 'Idan abokin tarayya ya ɓace ba tare da bayani ba?',
    faq3a: 'Masu amfani da Premium suna samun rematch nan take. Masu amfani kyauta ana sake musu daidaitawa a cikin awanni 48.',
    faq4q: 'Me yasa babu hotunan bayanin martaba?',
    faq4a: 'Saboda a lokacin da kuka ƙara hotuna, ya zama game da sarrafa ra\'ayi. Mun gwada hakan. Rashin bayyana suna yana kiyaye hankali a kan aiki.',
    legalEnglishOnly: 'Wannan takarda tana samuwa cikin Turanci kawai. Don tambayoyi, a tuntuɓi tallafi ko amfani da fasalin fassara na burauzar ku.',
    ctaTitle: "Kun shirya don cimma burinku?",
    ctaSubtitle: "Shiga Veyl kuma sami abokin lissafi yau. Farawa kyauta ne.",
    statAnonymous: "Ba a san su ba",
    statLanguages: "Harsunan",
    statToStart: "Don farawa",
    authTagline: "Lissafi ba tare da suna ba. Sakamako na gaske.",
    authPricing: "Farawa kyauta · Premium daga $5/wata",
    taglineHonest: "Aminci",
    taglineEffective: "Inganci",
    foreverLabel: "/har abada",
    premiumTitle: "Veyl Premium",
    upgradeTitle: "Haɓaka zuwa Premium",
    premiumActiveDesc: "Kuna da damar shiga duk abubuwan Veyl ba tare da iyaka ba.",
    upgradeDesc: "Cire duk iyakoki kuma sami cikakken ƙwarewar Veyl.",
    billedMonthly: "Ana biya kowace wata",
    bestValue: "MAFI KYAUN FARASHI",
    perSixMonths: "$3.33/wata",
    unlimitedMessages: "Saƙonni mara iyaka",
    unlimitedVoice: "Bayanin murya mara iyaka",
    unlimitedGroup: "Ƙungiya mara iyaka",
    unlimitedCommunity: "Al'umma mara iyaka",
    was10day: "ya kasance 10/rana",
    was5day: "ya kasance 5/rana",
    was20day: "ya kasance 20/rana",
    was30day: "ya kasance 30/rana",
    sixMonthPlan: "Shirin Watanni 6",
    monthlyPlan: "Shirin Wata-wata",
    modulationFailed: "Modulation ya gaza — amfani da muryar asali",
    monthly: "Kowane wata",
    sixMonths: "Watanni 6",
    savePercent: "Ajiye {{percent}}%",
    pricePerMonth: "${{price}} / wata",
    priceTotal: "${{price}} Jimilla",
    unlimitedMessages: "Sako mara iyaka",
    unlimitedVoiceNotes: "Saƙo na murya mara iyaka",
    unlimitedGroupMessages: "Sako na rukuni mara iyaka",
    unlimitedCommunityMessages: "Sako na al'umma mara iyaka",
    upgrade: "Haɓaka",
    forUnlimited: "don mara iyaka",
    messagesLeftWarning: "{{count}} saƙo ya rage yau",
    recordVoiceNote: "Yi rikodin saƙon murya",
    uploading: "Ana ɗora",
    maxDuration: "ƙarar {{seconds}}s",
    upgradeToPremium: "Haɓaka zuwa Premium",
    dailyMessageLimitReached: "Kun kai iyakar saƙonku na yau da kullum.",
    dailyVoiceLimitReached: "Kun kai iyakar saƙon muryarku na yau da kullum.",
    dailyGroupMessageLimitReached: "Kun kai iyakar saƙon rukuninku na yau da kullum.",
    dailyGroupVoiceLimitReached: "Kun kai iyakar saƙon muryar rukuninku na yau da kullum.",
    unlockUnlimited: "Kunna damar shiga mara iyaka zuwa duk fasalulluka.",
    maybeLater: "Watakila daga baya",
    premiumUnlimited: "Unlimited",
    premium: "Premium",
    msg: "sƙ",
    msgs: "sƙ",
    newMessageNotification: "{{name}} ya aiko maka da saƙo 💬",
    newGroupMessageNotification: "{{name}} ya aiko da saƙo a rukuninka 👥",
    someone: "wani",
    failedToLoad: "Ya gaza loda",
    groupMessagesLeftWarning: "{{count}} saƙo ya rage yau",
    howOldAreYou: 'Shekaru nawa kuke da su?',
    minorGroupNote: 'Za a daidaita ku tare da masu amfani na shekarun ku (13–17).',
    adultGroupNote: 'Za a daidaita ku tare da sauran manya (18+).',
    enterYourAge: 'Shigar da shekarun ku',
    getStarted:'Fara',
    howItWorks:'Yadda yake aiki',
    statAnonymous:'Asiri',
    statLanguages:'Harsunan',
    statToStart:'Don farawa',
    taglineHonest:'Aminci',
    taglineEffective:'Tasiri',
    landingHero:'Alhaki ba tare da wasan kwaikwayo ba.',
    landingSubtitle:'Sami abokin sirri wanda yake da manufofin kamar naka. Babu mabiya. Babu matsin lamba — ci gaba na gaske kawai.',
    problemTitle:'Alhaki ya karye.',
    problem1:'Kafofin sada zumunta na canza haɓaka kai zuwa wasan kwaikwayo. Kana ɗora manufofinka don likes, ba ci gaba ba.',
    problem2:'Abokai da iyali suna kawo hukunci ko rashin kulawa. Gaskiya ta gaske ta zama ba zai yiwu ba.',
    problem3:'Aikace-aikacen alhaki suna ji kamar kayan aikin bin diddigin — allon gudanarwa mara rai waɗanda suka yi watsi da ɗan adam gaba ɗaya.',
    veylIsDifferent:'Veyl ya bambanta.',
    step1Title:'Ƙirƙiri bayanan ka',
    step1Desc:'Zaɓi sunan karya, rukunin manufa, da son sadarwar ka. Ainihin asalin ka ya kasance naka gaba ɗaya.',
    step2Title:'Sami daidaituwa',
    step2Desc:'Veyl yana neman abokin tarayya wanda ya raba nau\'in manufa da rukunin shekarun ka. Nan da nan — babu zazzagewa.',
    step3Title:'Fara magana',
    step3Desc:'Yi hira ko aika bayanan murya. Duba kowace rana ko mako. Abokinka yana sa ka da alhakin — kai kuma ka sa shi.',
    buildTrust:'Gina amana',
    unveilIdentity:'Yi rikodin nasarorin ka. Sa\'ad da amana ta kasance, za ka iya zaɓar bayyana asalin ka — ko a\'a.',
    actuallyAchieve:'Cimma gaskiya',
    makeRealProgress:'Ci gaba na gaske tare da ɗan adam na gaske. Babu wasa. Kai kawai, abokinka, da manufarka.',
    pricingTitle:'Fara kyauta. Ci gaba fiye da haka sa\'ad da ka shirya.',
    freePlan:'Kyauta',
    foreverLabel:'/ har abada',
    freeFeature1:'Abokin alhaki 1',
    freeFeature2:'Saƙonni 10 a rana',
    freeFeature3: 'Bayanan murya 10 a kowace rana',
    freeFeature5:'Ɗakunan ƙungiya da al\'umma',
    popular:'Shahararren mafi yawa',
    premiumPlan:'Premium',
    perMonth:'/ wata',
    sixMonthDeal: 'Tsarin watanni 6 akan $20 — adana 33%',
    premiumFeature1:'Saƙonni mara iyaka',
    premiumFeature2:'Bayanan murya mara iyaka',
    premiumFeature3:'Fasalin bayyana abokin tarayya',
    premiumFeature4:'Daidaitawa ta farko',
    getStartedPremium:'Fara premium',
    faqTitle:'Tambayoyi gama gari.',
    faq1q:'Shin Veyl yana asiri ne da gaske?',
    faq1a:'Eh. Kana rajista da sunan karya. Babu ainihin sunan, babu hoto, babu abin da ya gane ka. Abokinka kawai ya san abin da ka zaɓa raba.',
    faq2q:'Yadda daidaitawa ke aiki?',
    faq2a:'Veyl yana haɗa ka da wani a cikin irin rukunin manufa da shekarun ka. Yawanci yana ɗaukar ƙasa da mintuna biyu.',
    faq3q:'Idan ban yi daidai da abokina ba?',
    faq3a:'Kana iya rahoto ko toshe abokinka a kowane lokaci ba tare da tambayoyi ba. Sake daidaitawa kuma sami mafi kyau.',
    faq4q:'Shin lafiya ne ga yara?',
    faq4a:'Lalle ne. Masu amfani masu shekara 13–17 ana daidaita su kawai tare da sauran masu amfani a cikin irin rukunin shekarun. An tilasta wannan a matakin tsarin.',
    ctaTitle:'Abokinka yana jiranka tuni.',
    ctaSubtitle:'Shiga Veyl kyauta. Babu buƙatar bayanin zamantakewa. Kai kawai, manufarka, da wani da ya fahimta.',
    privacyPolicy:'Manufofin Sirri',
    termsOfService:'Sharuɗɗan Sabis',
    refundPolicy:'Manufofin Dawowar Kuɗi',
    featuresTitle: "Duk abin da kake bukata. Babu abin da ba ka bukata.",
    feature1Title: "Cikakkar sirri",
    feature1Desc: "Kana zaɓar wani suna na ɓoye. Ainihin sunanka, hoto, da asalin kai ba za a taɓa raba su ba sai idan ka yanke shawarar bayyana su.",
    feature2Title: "Saƙonnin murya",
    feature2Desc: "Wani lokaci rubutu kawai bai isa ba. Yi rikoda kuma aika saƙonnin murya kai tsaye a cikin app.",
    feature3Title: "Daidaitawa mai aminci ta shekaru",
    feature3Desc: "Yara ƙanana (shekaru 13-17) za su dace ne kawai da wasu yara ƙanana. Manya da manya. Babu togaciya — an gina shi cikin tsarin.",
    feature4Title: "Harsuna 13",
    feature4Desc: "Turanci, Swahili, Faransanci, Sifaniyanci, Fotigal, Jamusanci, Italiyanci, Hindi, Indonesiyanci, Sinanci, Jafananci, Koriyanci, Hausa.",
    feature5Title: "Bincike na yau da kullum",
    feature5Desc: "Bincike mai tsari yana ƴaƴaƴa kuzari. Rubuta ci gabanka kuma yi murnar nasara tare da abokin tafiyarka.",
    feature6Title: "Ƴungiyoyi da al'umma",
    feature6Desc: "Shiga cikin tattaunawar ƴungiya na musamman ga buri da ɗakunan al'umma na harshe.",
    goalsEyebrow: "Don manufofi na gaskiya",
    goalsTitle: "Komai abin da kake aiki a kai.",
    goalsSub: "Veyl yana don kowane mutum mai manufa ta gaskiya kuma babu wani da zai yi gaskiya da shi game da ita.",
    goalFitness: "Motsa Jiki da Lafiya",
    goalLearning: "Koyo da Ƴaƴinya",
    goalBusiness: "Kasuwanci da Sana'a",
    goalCreative: "Ƴayyukan Ƴaƴi",
    moreComingSoon: "Wasu suna zuwa nan ba da jimawa ba",
    safeTitle: "Tsaro ba fasali kawai ba ne. Shi ne tushen.",
    safe1Title: "Rabuwar shekaru",
    safe1Desc: "Ba a taɓa haɗa yara ƙanana da manya ba. Ana tabbatar da shekaru a lokacin rajista kuma ana kullewa.",
    safe2Title: "Kai rahoto da toshe",
    safe2Desc: "Duk wani mai amfani zai iya kai rahoto ko toshe nan take. Babu tambayoyi.",
    safe3Title: "Babu sayar da bayanai",
    safe3Desc: "Manufofinka, saƙonninka, da asalin kai naka ne. Babu kara magana.",
    safe4Title: "Sunaye na ɓoye kawai",
    safe4Desc: "Ba a buƙatar ainihin sunaye ba. Kai ne ke iko da ko da yaushe za ka bayyana kanka.",
    refundPolicy: "Manufar Mayar da Kuɗi",
    heroLine1: 'Alhaki',                    
    heroLine2: 'ba tare da wasan kwaikwayo ba',
    mustBe18: 'Dole ne ka kai shekara 18 ko fiye don amfani da Veyl',
    mustBe18Desc: 'Veyl dandali ne na mutanen da suka kai shekara 18 zuwa sama. Yi hakuri, amma ba ka cika ƙa\u2019idar shekarun da ake bukata don ƙirƙirar asusu.',
    ageAttestationLabel: 'Ina tabbatar da cewa ina da shekara 18 ko fiye.',
    ageMisrepresentationNote: 'Bayar da bayanan shekaru na ƙarya ya saba wa Sharuɗɗanmu na Sabis kuma yana iya haifar da rufe asusu.',
    feature3Title: 'An tabbatar, shekara 18+ kawai',
    feature3Desc: 'Kowane memba yana tabbatar da cewa yana da shekara 18 ko fiye kafin shiga. Babu yara ƙanana, babu togaciya.',
    faq4q: 'Shin yara ƙanana za su iya amfani da Veyl?',
    faq4a: "A'a. Veyl dandali ne na musamman ga mutanen da suka kai shekara 18 zuwa sama. Kowane mai amfani yana tabbatar da shekarunsa lokacin yin rajista, kuma asusun da aka gano sun bayar da bayanan shekaru na ƙarya na iya cirewa.",
    safe1Title: 'Manya kawai',
    safe1Desc: 'An ƙera Veyl musamman ga mutanen da suka kai shekara 18 zuwa sama. Duk wanda bai kai shekara 18 ba kuma yake ƙoƙarin amfani da Veyl yana bayar da bayanan shekaru na ƙarya, wanda ya saba wa Sharuɗɗanmu na Sabis.',
    ageVerificationDesc: 'Veyl yana samuwa ga masu amfani da shekaru 18 zuwa sama.',
    // [auto-synced 2026-08-03]
    adjustYourGoal: 'Daidaita Manufarka',
    adjustGoalDesc: 'Babu matsala a canza alkibla. Za a sanar da abokin tarayyar ku.',
    newGoalDescription: 'Bayanin Sabon Buri',
    newGoalPlaceholder: 'Menene sabon burinka ko kuma wanda aka gyara?',
    updateGoal: 'Sabunta Manufar',
    goalUpdated: 'An sabunta burin cikin nasara! An sanar da abokin tarayyar ku.',
    readyToUnveil: 'A Shirye Don Bayyana?',
    unveilDesc: 'Buɗewar wannan Veyl ta nuna cewa ta cika. Za a sanar da abokin tarayyar ku. Ba za a iya warware wannan ba.',
    yourNewAvatar: 'Sabon hotonka',
    notYet: 'Tukuna',
    unveiling: 'Budewa...',
    sending: 'Ana aikawa...',
    checkInDesc: 'Ci gaban rajistar yau da kullun. Shiga cikin rajistar mako-mako zurfafa tunani ne.',
    dismiss: '✕',
    saving: 'Ana adanawa...',
    saved: '✓ An adana!',
    lightModeDesc: 'Tsabta kuma mai haske',
    darkModeDesc: 'Mai sauƙi a idanu',
    currentNickname: 'Lakabinka na yanzu shine',
    anonymousWarning: 'A ajiye shi a ɓoye. Kada a yi amfani da sunanka na ainihi.',
    nicknameUpdated: '✓ An sabunta sunan barkwanci!',
    deleteMyAccount: 'Share Asusu Na',
    // [auto-synced 2026-08-06]
    rasaIntroTitle: 'Haɗu da Rasa',
    rasaIntroDesc: 'Rasa wuri ne na sirri da za a yi tunani — kawai a gare ku, daban da abokin hulɗar ku da ke da alhakin alhaki. Ba ya zuwa da zato game da ku ko duniya; yana koya ne kawai daga abin da kuka zaɓi rabawa, kuma an gina shi ne don yin tambayoyi maimakon ba ku amsoshi.',
    rasaIntroNotTherapist: 'Rasa ba mai ilimin hanyoyin kwantar da hankali ba ce kuma ba ta maye gurbin ainihin haɗin kai na ɗan adam ba — har da abokin hulɗar ku da ke da alhakin ɗaukar nauyin wani. Idan wani abu ya ji nauyi, zai nuna muku a hankali ga goyon baya, ba ƙoƙarin zama haka ba.',
    rasaIntroStart: 'Fara',
    rasaMessagesLeft: 'tunani da aka bari a yau',
    rasaNoMessagesYet: 'Duk lokacin da ka shirya yin tunani, fara rubutawa a ƙasa.',
    rasaThinking: 'Rasha ta yi nazari…',
    rasaPrivateNote: 'Keɓance maka — ba za a taɓa ganin abokin hulɗarka da ke da alhakin komai ba.',
    rasaPlaceholder: 'Raba abin da ke zuciyarka…',
    rasaDailyLimitReached: 'Kun kai iyakar Rasa ta yau. Zai sake farawa gobe.',
    // [auto-synced 2026-08-06]
    feature7Title: 'Haɗu da Rasa',
    feature7Desc: 'Wuri na sirri don yin tunani — kawai don ku, daban da abokin hulɗar ku.',
    feature8Title: 'Nemi tallafi a kowane lokaci',
    feature8Desc: 'Amsoshi masu sauri kan kewayawa, lissafin kuɗi, da tambayoyin asusu — kai tsaye a cikin manhajar.',
    // [auto-synced 2026-08-06]
    supportChatAriaLabel: 'Tattaunawar tallafi ta Veyl',
    supportChatTitle: 'Tallafin Veyl',
    supportChatEmptyState: 'Tambaye ni wani abu game da yadda Veyl ke aiki.',
    supportChatPlaceholder: 'Yi tambaya…',
    supportChatSend: 'Aika',
    supportChatTyping: 'Ana bugawa…',
    supportChatLimitReached: 'Kun kai ga iyakar tattaunawar tallafi ta yau. Aika imel zuwa support@veyl.space idan gaggawa ce.',
    supportChatGenericError: 'Akwai matsala. Da fatan za a sake gwadawa.',
    // [auto-synced 2026-08-06]
    rasaLoadError: 'Ba a iya loda tattaunawar ku ba.',
    rasaLoadErrorDetail: 'duba na\'urar binciken burauzar don ƙarin bayani, ko gwada sabuntawa.',
    // [auto-synced 2026-08-06]
    notifMatchFoundMessage: '🎉 An haɗa ka da {name}! Je zuwa dashboard ɗinka.',
    // [auto-synced 2026-09-08]
    installAppLabel: 'Shigar da Manhaja',
    installMobileOnly: 'Wayar hannu kawai',
    installTooltip: 'Ana samuwa ne kawai akan na\'urorin hannu',
    installModalTitle: 'Shigar da Veyl a wayarka',
    installStep1: 'Danna alamar Raba a cikin kayan aikin Safariu2019s',
    installStep2: 'Gungura ƙasa ka matsa "Ƙara zuwa Allon Gida"',
    installStep3: 'Danna "Ƙara" a kusurwar dama ta sama',
    installGotIt: 'Na fahimta',
    // [auto-synced 2026-09-15]
    relationshipsConnection: 'Dangantaka & Haɗi',
    homeLifeOrganization: 'Tsarin Gida & Rayuwa',
    moneyFinancialHabits: 'Kuɗi & Ɗabi\'un Kuɗi',
    stayingConnected: 'Kasancewa da Haɗi',
    independentLiving: 'Rayuwa Mai Zaman Kanta',
    techConfidence: 'Amincewar Fasaha',
    // [auto-synced 2026-09-15]
    goalRelationships: 'Dangantaka & Haɗi',
    goalHomeLife: 'Tsarin Gida & Rayuwa',
    goalMoney: 'Kuɗi & Ɗabi\'un Kuɗi',
    goalStayingConnected: 'Kasancewa da Haɗi',
    goalIndependentLiving: 'Rayuwa Mai Zaman Kanta',
    goalTechConfidence: 'Amincewar Fasaha',
    // [auto-synced 2026-10-28]
    resources: 'Albarkatu',
    resourcesTitle: 'Albarkatu',
    resourcesWriteUps: 'Rubuce-rubuce',
    resourcesLinks: 'Ƙarin karatu',
    resourcesOpensNewTab: 'Yana buɗewa a cikin sabon shafin',
    resourcesEmptyTitle: 'Babu wani abu a nan tukuna',
    resourcesEmptyBody: 'Har yanzu muna tattara albarkatu don wannan rukunin. Duba nan ba da jimawa ba.',
    resourcesNoMatchBody: 'Ba mu sami albarkatun wannan burin ba tukuna.',
    resourcesDisclaimer: 'Bayani na gaba ɗaya kawai, ba shawara ta ƙwararru ba. Idan wani abu ya shafi lafiyarka, lafiyarka ko kuɗinka, ƙwararren ƙwararre zai iya taimaka maka da yanayinka.',
    // [auto-synced 2026-10-28]
    resourcesArticles: 'Labarai',
    resourcesMoreToRead: 'Ƙarin karatu',
    res_intro_fitnessHealth: 'Ana samun nasarori a cikin ƙananan lokatai na yau da kullun, ba manyan lokatai ba. Waɗannan abubuwan suna nan don rage matsin lamba, kuma hanyoyin haɗin yanar gizon suna kaiwa ga majiyoyin da suka ƙware a cikakkun bayanai.',
    res_fitness_showing_up_title: 'Ana nuna waƙoƙin da ke ...',
    res_fitness_showing_up_p1: 'Yawancinmu muna ɗauke da hoton yadda motsa jiki "mai kyau" yake: wurin motsa jiki, takalman gudu, da gumi. Idan rayuwa ba ta dace da wannan hoton ba, yana da sauƙi a yanke shawara cewa komai ba ya dace da kai ba.',
    res_fitness_showing_up_p2: 'Hukumar Lafiya ta Duniya tana ɗaukar ra\'ayi mai faɗi. Tana ƙididdige motsi a lokacin hutu, tafiya daga wuri zuwa wuri, da kuma ayyukan da ake yi a wurin aikinka ko a kusa da gida. Tafiya, hawa keke, wasanni da wasa duk suna da mahimmanci, a kowane matakin ƙwarewa. Jagororin ta sun nuna cewa kowane aiki ya fi babu.',
    res_fitness_showing_up_p3: 'Wannan yana da mahimmanci idan kana gina dabi\'a tare da abokin tarayya. Tafiya mai tsawo da ka yi a zahiri ya fi tsada fiye da zaman wahala da ka shirya kuma ka tsallake. Shiga da ke cewa "Na yi mintuna goma kacal" har yanzu rajista ce da ke ci gaba da gudana.',
    res_fitness_showing_up_p4: 'Haka kuma yana taimakawa wajen raba abin da ka yi da yadda kake ji. A wasu kwanaki, al\'ada ita ce nasara gaba ɗaya. Ƙarfin zai iya zuwa daga baya, da zarar ka bayyana, ya daina zama tattaunawa.',
    res_fitness_showing_up_p5: 'Idan kina da wata matsala ta lafiya, ko kina da juna biyu, ko kuma ba ki daɗe da yin motsa jiki ba, ya kamata ki yi magana da likita ko wani ƙwararren likita kafin ki canza yadda kike yin atisaye.',
    res_fitness_rest_title: 'Hutu wani ɓangare ne na shirin',
    res_fitness_rest_p1: 'Idan mutane suna magana game da burin motsa jiki, barci da hutawa galibi ana ɗaukar su kamar abubuwan da suka rage bayan an gama ainihin aikin. A zahiri suna da matuƙar muhimmanci a fahimci ko aikin zai ci gaba da aiki.',
    res_fitness_rest_p2: 'Barci da motsa jiki suna ciyar da juna. Hukumar NHS ta lura cewa motsa jiki akai-akai na iya taimaka maka ka yi barci mai kyau, kuma wasu mutane suna ganin motsa jiki kusa da lokacin kwanciya barci yana hana su, wanda hakan ke sa su dace da shi a farkon rana. Haka kuma doka ba ta aiki. Suna tunatar da kai cewa kai ne za ka iya gano abin da ke aiki ga jikinka.',
    res_fitness_rest_p3: 'Hutu ma yana da kyau a yi shiri a kai lokacin da kuke ɗaukar alhakin junanku. Idan kowace rajista ta zama rahoto game da yawan abin da kuka tura, ranar shiru ta fara jin kamar gazawa. Ranar hutu da kuka zaɓa da gangan ta bambanta da nisantar da kai daga burin, kuma yana da kyau a faɗi haka da babbar murya.',
    res_fitness_rest_p4: 'Idan barci yana da matuƙar wahala a tsawon lokaci, ko kuma kana jin gajiya saboda dalilan da ba za ka iya tantancewa ba, ya kamata ka yi magana da likita ko wani ƙwararren likita. Ba abu ne da za a iya yi shi kaɗai ba.',
    res_fitness_food_title: 'Abinci ba tare da wahala ba',
    res_fitness_food_p1: 'Shawarwari kan abinci suna da ƙarfi kuma galibi suna da sabani, don haka ya kamata a san cewa manyan hukumomin kiwon lafiyar jama\'a sun fi sassauta fiye da yawancin intanet.',
    res_fitness_food_p2: 'WHO ta ce abinci mai kyau yana zuwa ta hanyoyi daban-daban. Abin da ake ɗauka a matsayin hanyar cin abinci mai kyau ya dogara da shekarunka, salon rayuwarka, al\'adarka, da kuma abincin da za ka iya samu a inda kake zama. Ta bayyana ra\'ayoyi guda huɗu da ke ƙarƙashin kowanne daga cikinsu: samun isasshen abin da jikinka ke buƙata, daidaita abubuwa, jin daɗin wasu abinci a matsakaici, da kuma cin abinci iri-iri. Abincin da ba a sarrafa shi ba, wanda ba a sarrafa shi ba, shine tushen da take nunawa.',
    res_fitness_food_p3: 'Ga wani buri da kake bi da wani, wannan tsari ne mai amfani. Ba kwa buƙatar yin koyi da yadda abokin tarayyarka ke cin abinci, kuma ba sa buƙatar yin koyi da naka. Manufar abinci na iya zama mai sauƙi kamar "dafa abinci a gida akai-akai" ko "cin wani abu daban da na yau da kullun a wannan makon", duk abin da ya dace da rayuwarka da kasafin kuɗinka.',
    res_fitness_food_p4: 'Idan kana tunanin manyan canje-canje ga yadda kake cin abinci, ko kuma kana da wata matsala, rashin lafiyar jiki ko magani da abinci ke shafarka, likita ko likitan abinci mai rijista zai iya ba ka shawara da ta dace da kai. Rubutu na gaba ɗaya ba zai iya ba.',
    res_fitness_who_physical_activity_note: 'Na duniya. Bayani dalla-dalla game da abin da ake ɗauka a matsayin aiki, wanda ke amfana da kuma dalilin hakan.',
    res_fitness_who_guidelines_note: 'Na duniya. Cikakken jagororin, tare da shawarwari ga shekaru daban-daban da kuma mutanen da ke fama da cututtuka ko nakasa.',
    res_fitness_who_healthy_diet_note: 'Na Duniya. Yana bayani game da ƙa\'idodin da ke tattare da abinci mai kyau da kuma dalilin da ya sa ya bambanta dangane da al\'ada da abincin gida.',
    res_fitness_nhs_sleep_note: 'Birtaniya. Shawarwari masu amfani game da barci. Ambata likitan dabbobi ko mai harhada magunguna yana nufin ayyukan Burtaniya.',
    // [auto-synced 2026-10-29]
    pushPromptTitle: 'A sanar da ku lokacin da aka rufe Veyl',
    pushPromptBody: 'Za mu sanar da ku lokacin da kuka haɗu ko kuma abokin tarayyar ku ya aiko muku da saƙo. Sanarwa ba ta taɓa haɗa saƙonnin da ke ciki ba.',
    pushEnable: 'Kunna sanarwar',
    pushNotNow: 'Ba yanzu',
    pushError: 'Akwai matsala wajen kunna sanarwar. Da fatan za a sake gwadawa.',
    pushBlockedTitle: 'An toshe sanarwar',
    pushBlockedBody: 'Mai bincikenka yana toshe sanarwa daga Veyl. Don kunna su, buɗe saitunan shafin burauzarka don veyl.space, ba da izinin sanarwa, sannan sake kunna shafin.',
    pushIosTitle: 'Sami sanarwa akan iPhone',
    pushIosBody: 'Da farko ƙara Veyl zuwa Allon Gida: danna Raba, sannan Ƙara zuwa Allon Gida, sannan buɗe Veyl daga can sannan ka kunna sanarwar.',
    pushSettingsTitle: 'Sanarwa akan wannan na\'urar',
    pushSettingsDesc: 'Sami faɗakarwa lokacin da aka haɗa ku ko kuma abokin tarayyar ku ya aiko muku da saƙo, koda lokacin da aka rufe Veyl. Gargaɗi ba ya haɗa da abubuwan da ke cikin saƙo. Wannan saitin ya shafi wannan na\'urar kawai.',
    pushSettingsUnsupported: 'Sanarwa ba ta samuwa a cikin wannan burauzar. A kan iPhone ko iPad, fara ƙara Veyl zuwa Allon Gida (Raba, sannan Ƙara zuwa Allon Gida), sannan buɗe shi daga can.',
    pushSettingsBlocked: 'An toshe sanarwar Veyl a cikin burauzarka. Don kunna su, buɗe saitunan shafin burauzarka don veyl.space, ba da izinin sanarwa, sannan sake kunna shafin.',
    pushSettingsWorking: 'Aiki…',
    pushSettingsOn: 'Ana kunna sanarwa don wannan na\'urar',
    pushSettingsTurnOff: 'Kashe sanarwa',
    // [auto-synced 2026-10-29]
    res_intro_learningSkills: 'Koyan wani sabon abu galibi yana faruwa ne saboda bayyanawa akai-akai har ya daɗe. Waɗannan abubuwan suna da alaƙa da dogon wasan, kuma hanyoyin haɗin yanar gizo wurare ne na kyauta don koyo kusan komai.',
    res_learning_small_repeat_title: 'Ƙarami ne isa ya maimaita',
    res_learning_small_repeat_p1: 'Yawancin manufofin koyo suna mutuwa ne saboda girmansu, ba su da wahala sosai. "Koyi yadda ake rubuta lambobi" ko "ya ƙware a cikin harshen Portugal" wuri ne da za a je, ba abin da za ku iya yi a daren Talata ba.',
    res_learning_small_repeat_p2: 'Abin da za ku iya yi a daren Talata shi ne ku zauna na minti ashirin da darasi ɗaya. Wannan aiki ne da za ku iya maimaitawa, kuma maimaitawa shine inda koyo ke ƙaruwa. Ƙwarewa kan zo a hankali, kaɗan-kaɗan, har sai wata rana kun lura za ku iya yin abin da ba za ku iya yi ba a da.',
    res_learning_small_repeat_p3: 'Nan ne abokin hulɗa mai ɗaukar nauyi ke taimakawa fiye da kwarin gwiwa. Kwarin gwiwa yana zuwa yana tafiya. Abokin hulɗa wanda ke tsammanin jin yadda lamarin ya kasance yana sa ya yi wuya a daina wannan dabi\'ar a hankali kuma a sake farawa bayan mako mara kyau.',
    res_learning_small_repeat_p4: 'Ba dole ba ne a yi rajista mai kyau. "Na yi darasi ɗaya kuma na fahimci kusan rabi" gaskiya ne, kuma yana sa ɗabi\'ar ta ci gaba da wanzuwa. Za ka iya ƙara girman aikin daga baya. Yana da wahala a sake gina ɗabi\'ar da ta daina.',
    res_learning_beginner_title: 'An yarda da zama mafari',
    res_learning_beginner_p1: 'Fara wani sabon abu yana nufin yin abin da bai dace ba, aƙalla a gaban mutum ɗaya. Ga manya da yawa, wannan shine babban cikas, fiye da lokaci ko kuɗi.',
    res_learning_beginner_p2: 'Yana iya taimakawa a san yadda ilmantarwa ta bude take. MIT OpenCourseWare tana buga littattafai daga dubban darussa na MIT kyauta, ba tare da yin rijista ba. OpenLearn na Jami\'ar Open tana ba da kusan darussa dubu kyauta, kuma tana cewa babu buƙatar samun damar shiga su. Ba kwa buƙatar izinin kowa don gwada wani darasi, ko kuma don gano cewa ba naku ba ne.',
    res_learning_beginner_p3: 'Gwada wani abu da kuma yanke shawara cewa ba don kanka ba ne yana da mahimmanci a matsayin koyo. Yin samfurin wasu abubuwa kafin ɗaukar ɗaya hanya ce mai kyau ta farawa.',
    res_learning_beginner_p4: 'Idan ka ji kamar ba ka da tabbas, ka tuna cewa abokin tarayyarka zai iya jin haka game da burinsa. Ba ku gasa ba ne. Ku duka kuna gab da fara wani abu, a wurare daban-daban.',
    res_learning_choose_one_title: 'Zaɓi abu ɗaya, sannan ka ci gaba da zaɓensa',
    res_learning_choose_one_p1: 'Koyo kyauta yana da matsala mai ban mamaki: akwai abubuwa da yawa. OpenCourseWare kaɗai ya ƙunshi fiye da darussa 2,500, kuma OpenLearn yana da kusan dubu ɗaya. Yana da sauƙi a yi amfani da dare duka a bincika a kira shi koyo.',
    res_learning_choose_one_p2: 'Yana da kyau a zaɓi kwas ɗaya, littafi ɗaya ko jerin darussa ɗaya, sannan a ɗauki sauran abubuwa a matsayin "don daga baya". Ajiye sauran a cikin bayanin kula yana da kyau. Manufar ita ce a kammala abu ɗaya kafin a fara na gaba. Faɗa wa abokin tarayya wanne ka zaɓa ƙaramin alkawari ne wanda ke sauƙaƙa masa ci gaba.',
    res_learning_choose_one_p3: 'Haka kuma ya kamata a duba abin da wani abu ke bayarwa da abin da ba ya ba ku. Misali, kwasa-kwasan OpenLearn suna zuwa da bayanin shiga, wasu kuma suna da lambar dijital wadda ba takardar shaidar cancanta ba ce. Idan kuna buƙatar takardar shaidar aiki ko karatu, ya kamata ku san hakan da wuri, kuma cibiyar da kuke son zuwa za ta iya gaya muku abin da suka karɓa.',
    res_learning_mit_ocw_note: 'Na duniya. Bayanan lacca kyauta, jarrabawa da bidiyo daga dubban darussa na MIT, ba tare da yin rijista ba. A Turanci.',
    res_learning_khan_academy_note: 'Na Duniya. Ƙungiyar agaji ce da ke ba da darussa da aiki kyauta, mafi ƙarfi a fannin lissafi da kimiyya, a cikin harsuna da yawa.',
    res_learning_openlearn_note: 'Da ke Burtaniya, a buɗe ga kowa. Kusan darussa 1,000 na gajerun darussa kyauta, daga kimanin awanni 1 zuwa 24, kowannensu yana da sanarwar shiga kyauta.',
    // [auto-synced 2026-10-29]
    res_intro_businessCareer: 'Manufofin aiki suna da tsawo, kuma mafi yawan ƙoƙarin yana faruwa ne a cikin kwanaki tsakanin manyan matakai. Waɗannan ayyukan suna game da kiyaye daidaiton gudu, kuma hanyoyin haɗin yanar gizo wurare ne na kyauta don gina ƙwarewa da tsara matakin da za ku ɗauka na gaba.',
    res_business_progress_title: 'Ci gaba a wurin aiki ba kasafai ake samun layi madaidaiciya ba',
    res_business_progress_p1: 'Manufofin aiki da kasuwanci suna da hanyar da za su iya ƙara himma. Karin girma, canjin aiki ko abokin ciniki na farko na iya ɗaukar watanni, kuma kwanakin da ke tsakanin ba sa jin kamar an samu ci gaba.',
    res_business_progress_p2: 'Yana taimakawa wajen raba sakamakon da kake so da abubuwan da za ka iya yi a wannan makon. Ba za ka iya sarrafa ko kamfani zai ɗauke ka aiki ba, ko kuma ko abokin ciniki ya ce eh. Za ka iya sarrafa yawan tattaunawa da kake yi, tsawon lokacin da za ka ba aikin, da kuma ko za ka ci gaba da bin diddigin abin da ka ce za ka yi.',
    res_business_progress_p3: 'A nan ne abokin hulɗa mai riƙon amana zai sami matsayinsa. Ba sa buƙatar fahimtar masana\'antar ku. Kawai suna buƙatar tambayar abin da kuka yi, kuma su saurari amsar ba tare da sun mayar da ita abin wasa ba.',
    res_business_progress_p4: 'A wasu makonni, rahoton gaskiya ba ya faruwa sosai. Ya kamata a faɗi da babbar murya, domin burin da aka yi shiru na tsawon wata ɗaya yana da wuyar sake cimmawa fiye da wanda aka ci gaba da rayuwa ba tare da ɓata lokaci ba.',
    res_business_start_from_you_title: 'Fara daga gare ku, ba daga aikin ba',
    res_business_start_from_you_p1: 'Idan mutane suka ji kamar sun makale a wurin aiki, sau da yawa abin da ake so shi ne su fara da kasuwar aiki: abin da ake ɗauka aiki, abin da ake biyan albashi mai kyau, abin da yake da ban sha\'awa. Zai iya zama mafi amfani a fara wani wuri.',
    res_business_start_from_you_p2: 'Kwas ɗin kyauta na OpenLearn Succeed a wurin aiki an gina shi ne bisa wannan ra\'ayin. Ya fara da ra\'ayin cewa sanin kanka da abin da kake daraja shi ne tushen tsara aiki, sannan sai kawai ya koma ga CV, aikace-aikace da tambayoyi.',
    res_business_start_from_you_p3: 'A takaice dai: me kake son kwanakinka su kasance? Me kake da ƙwarewa a kai wanda ba kasafai ake samun yabo a kansa ba? Me za ka ƙi musanyawa, ko lokacin da kake tare da iyali ne, samun kuɗi mai ɗorewa ko kuma lokacin da za ka yi kirkire-kirkire?',
    res_business_start_from_you_p4: 'Ba sai ka amsa duk waɗannan ba kai kaɗai. Tattaunawa da abokin tarayya sau da yawa yakan kawo abubuwan da za ka yi watsi da su kai kaɗai, kuma yana iya mayar da "Ina son wani abu daban" mara tabbas zuwa wani buri da za ka iya cimmawa a kai.',
    res_business_wear_out_title: 'Yin aiki tukuru ba tare da gajiyar da kanka ba',
    res_business_wear_out_p1: 'Buri da gajiya na iya kama da juna daga ciki, musamman idan manufa ta dace da kai.',
    res_business_wear_out_p2: 'Hukumar Lafiya ta Duniya ta lura cewa aiki na iya kare lafiyar kwakwalwa, kuma yana iya haifar da illa. Jagororin da ta bayar kan lafiyar kwakwalwa a wurin aiki sun nuna haɗari kamar manyan ayyuka da munanan halaye a wurin aiki, kuma sun ce alhakin wurin aiki mai kyau yana kan ma\'aikata da gwamnatoci, ba wai kawai ga ma\'aikata ba.',
    res_business_wear_out_p3: 'Idan kana tattaunawa da abokin tarayya game da babban burin aiki, ya kamata ka tambaya ba wai kawai "ka gama shi ba?" amma "yaya kake jurewa?" Manufar da aka bi wacce ta shafi barcinka, lafiyarka ko dangantakarka ya cancanci a sake tunani a kai, ko da kuwa tana tafiya daidai a kan takarda.',
    res_business_wear_out_p4: 'Idan aiki yana shafar lafiyarka, ko kuma kana jin kasala akai-akai, damuwa ko gajiya, don Allah ka yi magana da likita ko wani ƙwararren ma\'aikacin lafiya. Idan ba ka da tabbas game da haƙƙinka a wurin aiki, wata majiya mai aminci ta gida, kamar hukumar kwadago ko ƙungiyar ma\'aikata, za ta iya bayyana musu inda kake zama. Dokoki sun bambanta sosai tsakanin ƙasashe.',
    res_business_who_mh_work_note: 'Na Duniya. An rubuta shi ne musamman ga ma\'aikata da gwamnatoci, don haka fasaha ce. Takaitaccen bayani yana samuwa a cikin Larabci, Sinanci, Ingilishi, Faransanci, Rashanci da Sifaniyanci.',
    res_business_openlearn_entrepreneurship_note: 'Darasin da ke Burtaniya. Awa 24 a cikin zaman guda 8, kuma za ku iya farawa ba tare da yin rijista ba. Wasu daga cikinsu sun shafi ƙa\'idodin kasuwanci na Burtaniya, don haka duba abin da ya dace a ƙasarku.',
    res_business_openlearn_succeed_note: 'Kimanin makonni 8 a kusan awanni 3 a mako, suna ba da labarin tsara aiki, CV da tambayoyi. An sabunta shi a ƙarshe a cikin 2021, don haka wasu sassan neman aiki da kafofin sada zumunta na iya jin kamar sun tsufa.',
    // [auto-synced 2026-11-03]
    timezoneTitle: 'Yankin Lokaci',
    timezoneCurrentIs: 'Yankin lokacinka na yanzu shine',
    timezoneLockNote: 'Iyakokin saƙonku na yau da kullun da na sautin murya suna sake saitawa da tsakar dare a yankin lokacinku. Don kiyaye wannan adalci, zaku iya canza yankin lokacinku ne kawai a ranar da ba ku yi amfani da saƙonni ko bayanan murya ba, kuma sau ɗaya kawai a cikin kwanaki 7.',
    timezoneNew: 'Zaɓi yankin lokaci',
    saveTimezone: 'Ajiye yankin lokaci',
    timezoneUpdated: 'An sabunta yankin lokaci',
    timezoneInvalid: 'Wannan yankin lokaci bai dace ba. Da fatan za a zaɓi ɗaya daga cikin jerin.',
    timezoneChangeError: 'Ba za a iya canza yankin lokacinka ba. Da fatan za a sake gwadawa.',
    // [auto-synced 2026-11-03]
    res_intro_creativeProjects: 'Ayyukan ƙirƙira galibi suna rayuwa ne a cikin gibin da ke tsakanin komai. Waɗannan ayyukan suna magana ne game da kiyaye wani abu a cikin dogon tsakiya, kuma hanyoyin haɗin yanar gizon sun haɗa da koyon rubutu da amfani da raba ayyukan ƙirƙira.',
    res_creative_finishing_title: 'Kammalawa ƙwarewa ce kuma',
    res_creative_finishing_p1: 'Fara aikin ƙirƙira shine abu mafi sauƙi. Manufar sabo ce kuma komai yana da sauƙi. Abu mai wahala yana zuwa a tsakiya, lokacin da ra\'ayin ya koma aiki na gaske kuma aikin ya fi jinkiri da rikitarwa fiye da yadda ra\'ayin yake.',
    res_creative_finishing_p2: 'A nan ne ayyukan ke tsayawa, kuma ba kasafai ake samun matsala ba saboda mutumin ba shi da baiwa. Sau da yawa hakan kan faru ne saboda babu layin ƙarshe da zai jira kuma babu wanda ke kallo.',
    res_creative_finishing_p3: 'A nan ne abokin tarayya wanda kawai ya tambaya "me ka cim ma a wannan makon?" zai iya kawo babban canji. Ba kwa buƙatar su yi hukunci a kai. Sanin cewa za ku bayyana makonku yana ba aikin ƙaramin wa\'adi, kuma ƙaramin wa\'adi sau da yawa ya isa ya sa ku koma teburin, zane ko kayan aiki.',
    res_creative_finishing_p4: 'Haka kuma yana taimakawa wajen yanke shawara kan ma\'anar "an yi" ga abin da ke gabanka. Sigar da aka gama ta fi ta cikakken da ta tsaya a cikin zuciyarka daraja. Kullum za ka iya inganta ta bayan ta wanzu.',
    res_creative_rough_drafts_title: 'Babu wanda ke buƙatar ganin sigar farko',
    res_creative_rough_drafts_p1: 'Mutane da yawa masu kirkire-kirkire suna tsayawa a hankali saboda ƙoƙarin farko bai yi kyau kamar hoton da ke cikin zuciyarsu ba. Wannan gibin da ke tsakanin abin da kuke tsammani da abin da za ku iya yi a yanzu abu ne na al\'ada. Sau da yawa yakan fi girma lokacin da kuka fi damuwa.',
    res_creative_rough_drafts_p2: 'Nuna wa wani amintaccen mutum aiki mai wahala zai iya rage masa nauyi. Faɗa wa abokin tarayya "wannan daftarin aiki ne mai rikitarwa, amma ga abin da nake ƙoƙarin yi" yana mai da shi tattaunawa, ba hukunci ba. Za ka iya ganin sun fi damuwa da ko ka ci gaba da tafiya maimakon ko yana da kyau.',
    res_creative_rough_drafts_p3: 'Idan kai sabon shiga ne a fannin sana\'a, akwai hanyoyi masu sauƙi a ciki. OpenLearn, shafin ilmantarwa kyauta na Jami\'ar Open, yana da kwas na gabatarwa kan rubuce-rubucen almara da aka yi niyya ga mutanen da suka fara. Misali ɗaya ne daga cikin mutane da yawa, kuma ya fi dacewa da marubuta fiye da sauran nau\'ikan masu ƙirƙira.',
    res_creative_rough_drafts_p4: 'Ci gaba a aikin ƙirƙira ba kasafai yake kama da ci gaba mai ɗorewa ba. Wasu makonni kana yin abin da kake alfahari da shi, wasu makonni kuma kana yin abin da ba za ka taɓa nuna wa kowa ba. Dukansu suna da mahimmanci, kuma duka suna cikin ɗabi\'a ɗaya.',
    res_creative_using_sharing_title: 'Amfani da aikin wasu mutane, da kuma raba naka',
    res_creative_using_sharing_p1: 'Ayyukan ƙirƙira galibi suna ƙunshe da kayan wasu mutane, kamar hotuna, sautuka ko rubutu, kuma daga ƙarshe za ku iya son raba naku. Ƙaramin bayani yana taimakawa ga duka biyun.',
    res_creative_using_sharing_p2: 'Creative Commons ƙungiya ce mai zaman kanta wadda ke buga lasisi wanda ke ba wa masu ƙirƙira damar riƙe haƙƙin mallaka yayin da suke ba wa wasu damar amfani da ayyukansu ta hanyoyin da mai ƙirƙira ya zaɓa. Idan kana son raba wani abu da ka ƙirƙira, jagorarta tana bayyana yadda waɗannan lasisin ke aiki.',
    res_creative_using_sharing_p3: 'Wasu cibiyoyi sun ci gaba da tafiya. Smithsonian ta fitar da miliyoyin hotuna da bayanai a ƙarƙashin abin da ake kira CC0, wanda ke nufin za ku iya amfani da su ba tare da neman izinin Smithsonian ba, har ma da ayyukan ƙirƙira. Amma tambayoyin da ake yawan yi akai-akai sun nuna cewa CC0 ya shafi haƙƙin mallaka ne kawai. Sauran haƙƙoƙi, kamar sirri ko alamar kasuwanci, har yanzu suna iya aiki, kuma wasu abubuwa a cikin tarinsa ba a haɗa su kwata-kwata ba.',
    res_creative_using_sharing_p4: 'Dokokin haƙƙin mallaka sun bambanta tsakanin ƙasashe, kuma wannan bayani ne na gabaɗaya, ba shawara ta shari\'a ba. Idan wani aiki yana da mahimmanci a kasuwanci, ko kuma ba ka da tabbas ko za ka iya amfani da wani abu, ƙwararren ƙwararre zai iya gaya maka inda kake.',
    res_creative_openlearn_fiction_note: 'Daular Burtaniya, kyauta don farawa. Darasi na gabatarwa kan rubuce-rubucen almara, tare da sanarwar shiga kyauta. Ya fi dacewa da marubuta fiye da sauran nau\'ikan masu ƙirƙira.',
    res_creative_cc_license_note: 'Na Duniya. Yadda za a bar wasu su yi amfani da aikinka bisa sharuɗɗan da ka zaɓa yayin da kake riƙe haƙƙin mallaka. Bayani na gaba ɗaya, ba shawara ta shari\'a ba.',
    res_creative_smithsonian_open_access_note: 'Cibiyar Amurka, kyauta ga kowa ya yi amfani da ita. Yana bayyana hotunan da bayanan da aka fitar a matsayin CC0, abin da hakan ke ba da izini da abin da ba ya ba da izini, da kuma waɗanne abubuwa aka cire.',
    // [auto-synced 2026-11-03]
    res_intro_relationshipsConnection: 'Ana gina dangantaka ne daga ƙananan abubuwa masu maimaitawa fiye da manyan lokatai. Waɗannan bayanai suna magana ne game da kiyaye alaƙar da ke raye, abin da bincike ya ce ya fi muhimmanci, da abin da za a yi idan dangantaka ta yi wahala ko kuma dangantaka ba ta da aminci.',
    res_relationships_small_gestures_title: 'Ƙananan motsin hannu suna ƙidaya',
    res_relationships_small_gestures_p1: 'Da yawa daga cikinmu muna ɗaukar abota da alaƙar iyali a matsayin abubuwan da ko dai suna wanzuwa ko ba sa wanzuwa. Robert Waldinger, wanda ke jagorantar Nazarin Ci gaban Manyan Mutane a Harvard, ya bayyana rayuwar zamantakewa a matsayin tsarin rayuwa wanda ke buƙatar kulawa, kamar lafiyar jiki.',
    res_relationships_small_gestures_p2: 'Kulawa na iya zama ƙarami. Ka yi tunanin wanda ka ke kewa ka aika masa saƙo. Jerin matakan da Hukumar Lafiya ta Duniya ke ɗauka a kullum suna da sauƙi kamar haka: tuntuɓar aboki, ajiye wayar ka don ta kasance a wurin tattaunawa, gaishe da maƙwabci, shiga ƙungiyar gida, ko yin aikin sa kai.',
    res_relationships_small_gestures_p3: 'Ga wani buri da kuka raba wa abokin hulɗar ku da alhakin alhaki, wannan tambaya ce mai kyau ta mako-mako: wa kuka yi wa magana? Gaskiya ne, ƙarami ne, kuma za ku iya amsa ta da gaskiya ko da a cikin mako mai wahala.',
    res_relationships_small_gestures_p4: 'Ba kowanne saƙo ne ke samun amsa mai daɗi ba, kuma wannan wani ɓangare ne na saƙon. Waldinger ya ce mutane sau da yawa suna mamakin yadda ake karɓar ƙananan saƙonni kamar waɗannan cikin ɗumi.',
    res_relationships_quality_title: 'Inganci akan adadi',
    res_relationships_quality_p1: 'Yana da sauƙi a auna rayuwar zamantakewa ta hanyar ƙidayar kai: adadin abokai, adadin abubuwan da suka faru, ko kuna cikin dangantaka. Binciken ya nuna wani wuri.',
    res_relationships_quality_p2: 'Nazarin Harvard na Ci gaban Manya ya bi diddigin mutane tun daga shekarar 1938. Lokacin da masu binciken suka yi waiwaye kan rayuwar mahalarta a tsakiyar shekaru, gamsuwa a dangantakarsu, musamman aure, sun yi hasashen wanda zai fi farin ciki da lafiya a shekaru 80 fiye da abubuwa kamar cholesterol ko hawan jini. Daraktan ya ce sauran ƙungiyoyin bincike sun gano abu ɗaya tun daga lokacin. Ya kuma ce babu takamaiman adadin alaƙa da kuke buƙata, kuma cewa mutane masu jin kunya na iya buƙatar ƙasa da masu son fita waje.',
    res_relationships_quality_p3: 'Gargaɗi ɗaya: waɗanda suka fara halartar binciken ɗaliban Harvard ne da kuma matasa daga wani birni a Amurka, don haka ba hoton kowa ba ne. Ya kamata a yi watsi da sakamakon binciken.',
    res_relationships_quality_p4: 'Abin da yake nufi, a hankali, shi ne cewa aƙalla dangantaka mai ƙarfi ɗaya, wanda za ka iya kira idan kana rashin lafiya ko tsoro, ya fi muhimmanci fiye da babban da\'ira. Kuma ba kasafai ake makara ba. Daraktan binciken ya bayyana mutanen da suka sami abota ta kud da kud ko soyayya a ƙarshen rayuwarsu lokacin da ba su yi tsammani ba.',
    res_relationships_hard_times_title: 'Lokacin da dangantaka take da wahala, da kuma lokacin da dangantaka ke da zafi',
    res_relationships_hard_times_p1: 'Jin kaɗaici ba yana nufin akwai matsala a tare da kai ba. Hukumar Lafiya ta Duniya ta kiyasta cewa kusan mutum ɗaya cikin shida a duniya yana fuskantar kaɗaici, a kowane zamani. Ta bayyana kaɗaici a matsayin jin zafi da ke zuwa lokacin da alaƙar da kake da ita ba ta yi daidai da wadda kake so ba.',
    res_relationships_hard_times_p2: 'Abubuwan da ke haddasa su na iya haɗawa da rashin lafiya, ƙarancin kuɗi, zama mu kaɗai, ko kuma yadda muke amfani da fasahar zamani. WHO ta lura cewa idan matsalar ta fi tsanani, gano irin tallafi da ayyukan da ake da su ya cancanci a yi.',
    res_relationships_hard_times_p3: 'Akwai wani gefen kuma: dangantaka da ke cutar da mutane. Halaye masu cutarwa a cikin haɗin gwiwa sun haɗa da cin zarafin tunani da kuma sarrafa halaye, da kuma cutarwa ta jiki ko ta jima\'i.',
    res_relationships_hard_times_p4: 'Idan kana jin tsoron wani da ke kusa da kai, ko kuma kana jin rauni, tuntuɓi lambar gaggawa ta yankinka ko layin taimako na gida ko sabis na tallafi. Lambobin da suka dace sun dogara da ƙasarka, kuma abokin hulɗar Veyl abokin tarayya ne, ba ƙwararren mai ba da shawara ba. Idan abubuwa suka yi nauyi sosai, likita ko mai ba da shawara zai iya taimakawa.',
    res_relationships_who_social_connection_note: 'Na Duniya. Takaitaccen bayani game da rahoton WHO na 2025 game da kaɗaici da haɗin kai a zamantakewa (shafuka 13).',
    res_relationships_harvard_gazette_note: 'Majiya daga Amurka. Tambaya da Amsa tare da darektan Harvard Study of Adult Development kan abin da binciken ya ce game da dangantaka da lafiya, gami da ƙananan matakai na yau da kullun. Hira ce, kuma mahalarta binciken na farko sun fito ne daga wani birni na Amurka.',
    res_relationships_who_violence_note: 'Na Duniya. Yana bayanin abin da cin zarafin abokin tarayya ya ƙunsa da kuma yadda yake ya zama ruwan dare, galibi yana shafar mata. Bayani ne, ba layin taimako ba, kuma yana iya zama da wahalar karantawa.',
  },
};

export default translations;

export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'ha', name: 'Hausa', nativeName: 'Hausa' },
];